<template>
    <div @mouseover.prevent="checkSiteIfCorrect()" @click.prevent="checkIfDocumentTypeIsCorrect()">
        <!-- <img style="display: none;" id='logobarter' :src="imagepath" alt='logobarter' crossorigin="anonymous"> -->
        <div id="logoDiv" style="display: none;"></div>
        <a-spin :tip="spinMessage" :spinning="spinning">
        <base-header type="instore" class="pb-5 pt-5 pt-md-8">
        </base-header>

        <div class="container sticky-top sticky-header pt-3" style="background-color: #f5365c; visibility: hidden; border-radius: 0 0 5px 5px;">
            <div class="row ">
                <div class="col-auto">
                    <!-- <router-link :to="{ name: 'documents'}" >
                        <h6 class="heading-small" style='color: white;'> ⟵   Back to Dashboard </h6>
                    </router-link> -->
                    <router-link :to="backLink" >
                        <h6 class="heading-small" style='color: white;'> ⟵   Back to Dashboard </h6>
                    </router-link>
                </div>
                <div class="col p-0">
                    <div class="float-right">
                        <base-dropdown class="nav-link pr-0 float-right" position="right">
                            <div class="media align-items-center" slot="title">
                            <i class="fa fa-ellipsis-v float-right ml-2 btn-sm" style='color: white; cursor: pointer;'></i>
                            </div>
                            <template>
                                <div class="dropdown-header noti-title">
                                    <h6 class="text-overflow m-0">ACTIONS</h6>
                                </div>
                                <template v-if="relatedDocument.length > 0">
                                    <template v-if="documentRelation == 'parent'">
                                        <div v-for="item in relatedDocument" :key="item.id">
                                            <a class="dropdown-item" @click.prevent='openRelatedDocument(item.id, item.document_type_id)'><i class="fa fa-angle-double-right"></i>{{item.friendly_code}} #{{item.document_no}}</a>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div v-for="item in relatedDocument" :key="item.id">
                                            <a class="dropdown-item" @click.prevent='openRelatedDocument(item.id, item.document_type_id)'><i class="fa fa-angle-double-left"></i>{{item.friendly_code}} #{{item.document_no}}</a>
                                        </div>
                                    </template>
                                    <template v-if="relatedGrandChildrenDocument.length > 0">
                                        <div v-for="item in relatedGrandChildrenDocument" :key="item.id">
                                            <a class="dropdown-item" @click.prevent='openRelatedDocument(item.id, item.document_type_id)'><i class="fa fa-angle-double-left"></i>{{item.friendly_code}} #{{item.document_no}}</a>
                                        </div>
                                    </template>
                                </template>
                                <a class="dropdown-item" @click.prevent="showDrawer('history')"><i class="fas fa-history"></i><span>History</span></a>
                                <a class="dropdown-item" @click.prevent="showDrawer('references')"><i class="fa fa-asterisk"></i><span>References</span></a>
                                <a class="dropdown-item" @click.prevent="showDrawer('extras')"><i class="fa fa-plus"></i><span>Extras</span></a>
                                <a class="dropdown-item" v-if="documentNumber > 0" @click.prevent="showDocumentPayment()"><i class="fa fa-money-bill"></i><span>Document Payments</span></a>
                                <a class="dropdown-item" v-if="documentNumber > 0" @click.prevent="showDrawer('document_image')"><i class="fa fa-file-image"></i><span>Document Image</span></a>
                                <template v-if="currentDocumentTypeCode == 'OTHPWS'">
                                    <a class="dropdown-item" v-if="accessRights.includes('D') && documentNumber>0 && (documentStatus == 'Saved' || documentStatus == 'Confirmed' || documentStatus == 'Upload Error') && postedASMDSM == false && orderSource!='shopee' && orderSource!='lazada' && orderSource!='shopify' && orderSource!='zalora'" @click.prevent="voided()"><i class="fas fa-window-close" style="color: Tomato;" ></i><span>Void Request</span></a>
                                    <a class="dropdown-item" v-if="accessRights.includes('D') && documentNumber>0 && (documentStatus == 'Saved' || documentStatus == 'Confirmed' || documentStatus == 'Upload Error') && postedASMDSM == false && (orderSource == 'shopee' || orderSource == 'lazada' || orderSource == 'shopify' || orderSource == 'zalora') && currentDocumentTypeCode=='RELDDE'" @click.prevent="voidEcomOrder()"><i class="fas fa-window-close" style="color: Tomato;" ></i><span>Void Request</span></a>
                                </template>
                                <template v-else>
                                    <a class="dropdown-item" v-if="accessRights.includes('D') && documentNumber>0 && (documentStatus == 'Saved' || documentStatus == 'Upload Error' || documentStatus == 'Posted') && postedASMDSM == false && orderSource!='shopee' && orderSource!='lazada' && orderSource!='shopify' && orderSource!='zalora'" @click.prevent="voided()"><i class="fas fa-window-close" style="color: Tomato;" ></i><span>Void Request</span></a>
                                    <a class="dropdown-item" v-if="accessRights.includes('D') && documentNumber>0 && (documentStatus == 'Saved' || documentStatus == 'Upload Error') && postedASMDSM == false && (orderSource == 'shopee' || orderSource == 'lazada' || orderSource == 'shopify' || orderSource == 'zalora') && currentDocumentTypeCode=='RELDDE'" @click.prevent="voidEcomOrder()"><i class="fas fa-window-close" style="color: Tomato;" ></i><span>Void Request</span></a>
                                </template>
                                <a class="dropdown-item" v-if="documentNumber > 0 && (documentStatus == 'Saved' || documentStatus == 'Upload Error')" @click.prevent="copyDocument()"><i class="fas fa-clone"></i><span>Duplicate Document</span></a>
                                <a class="dropdown-item" v-if="currentDocumentTypeCode=='OTHTRA' || currentDocumentTypeCode=='OTHPCK'" @click.prevent="showDrawer('view_allocation')"><i class="fas fa-eye"></i><span>View Allocation</span></a>
                                <a class="dropdown-item" v-if="documentId > 0" @click.prevent="showInternalDocumentId"><i class="fa fa-file-alt"></i><span>View Internal ID</span></a>
                            </template>
                        </base-dropdown>
                        <p v-if="accessRights.includes('T') && documentNumber>0  && orderSource!='shopee' && orderSource!='lazada' && orderSource!='zalora' && currentDocumentTypeCode!='ORIPOX' && currentDocumentTypeCode!='OTHTRA' && currentDocumentTypeCode!='OTHPCK' && currentDocumentTypeCode!='OTHBAR' && currentDocumentTypeCode!='OTHSIN' && currentDocumentTypeCode!='RECCSR'" class="fas fa-print float-right ml-2 pt-2 btn-sm" style='color: white; cursor: pointer;' @click="printRequest()"> <b style="font-family: 'Arial', sans-serif;" > PRINT</b> </p>
                        <!-- SI / CM: two print options — WITH withholding (new format) and withtout withholding (old/current format) -->
                        <a-dropdown v-if="accessRights.includes('T') && documentNumber>0 && orderSource!='shopee' && orderSource!='lazada' && orderSource!='zalora' && (currentDocumentTypeCode=='OTHSIN' || currentDocumentTypeCode=='RECCSR')">
                            <p class="fas fa-print float-right ml-2 pt-2 btn-sm" style='color: white; cursor: pointer;'> <b style="font-family: 'Arial', sans-serif;" @click="e => e.preventDefault()"> PRINT</b> </p>
                            <a-menu slot="overlay">
                              <a-menu-item>
                                <a @click="printRequest(undefined, undefined, true)">Print (With WTax)</a>
                              </a-menu-item>
                              <a-menu-item>
                                <a @click="printRequest(undefined, undefined, false)">Print (Without WTax)</a>
                              </a-menu-item>
                            </a-menu>
                        </a-dropdown>
                        <p v-if="accessRights.includes('T') && documentNumber>0 && currentDocumentTypeCode=='OTHBAR' && documentStatus == 'Confirmed'" class="fas fa-print float-right ml-2 pt-2 btn-sm" style='color: white; cursor: pointer;' @click="showBarcodePrintingModal()"> <b style="font-family: 'Arial', sans-serif;" > PRINT</b> </p>
                        <a-dropdown v-if="accessRights.includes('T') && documentNumber>0 && orderSource!='shopee' && orderSource!='lazada' && orderSource!='zalora' && currentDocumentTypeCode=='ORIPOX'">
                            <p class="fas fa-print float-right ml-2 pt-2 btn-sm" style='color: white; cursor: pointer;'> <b style="font-family: 'Arial', sans-serif;" @click="e => e.preventDefault()"> PRINT</b> </p>
                            <a-menu slot="overlay">
                              <a-menu-item>
                                <a @click="exportCSV()">CSV</a>
                              </a-menu-item>
                              <a-menu-item>
                                <a @click="printRequest(true)">PDF</a>
                              </a-menu-item>
                              <a-menu-item>
                                <a @click="printRequest(true, 'dotMatrix')">PDF DOT</a>
                              </a-menu-item>
                              <a-menu-item v-if="orderSource=='shopee'">
                                <a @click="shopeePrintWayBill()">Shopee Waybill</a>
                              </a-menu-item>
                              <a-menu-item v-if="orderSource=='lazada'">
                                <a @click="lazadaPrintWayBill()">Lazada Waybill</a>
                              </a-menu-item>
                            </a-menu>
                        </a-dropdown>
                        <a-dropdown v-if="accessRights.includes('T') && documentNumber>0 && (currentDocumentTypeCode=='OTHTRA' || currentDocumentTypeCode=='OTHPCK')">
                            <p class="fas fa-print float-right ml-2 pt-2 btn-sm" style='color: white; cursor: pointer;'> <b style="font-family: 'Arial', sans-serif;" @click="e => e.preventDefault()"> PRINT</b> </p>
                            <a-menu slot="overlay">
                              <a-menu-item>
                                <a @click="printRequest(true)">Print Standard</a>
                              </a-menu-item>
                              <a-menu-item>
                                <a @click="printRequest(true, 'dotMatrix')">Print Standard DOT</a>
                              </a-menu-item>
                              <a-menu-item>
                                <a @click="printRequest(false)">Print Extended</a>
                              </a-menu-item>
                              <a-menu-item>
                                <a @click="printRequest(false, 'dotMatrix')">Print Extended DOT</a>
                              </a-menu-item>
                            </a-menu>
                        </a-dropdown>
                        <a-dropdown v-if="accessRights.includes('T') && documentNumber>0 && (orderSource=='shopee' || orderSource=='lazada' || orderSource=='zalora' )">
                            <p class="fas fa-print float-right ml-2 pt-2 btn-sm" style='color: white; cursor: pointer;'> <b style="font-family: 'Arial', sans-serif;" @click="e => e.preventDefault()"> PRINT</b> </p>
                            <a-menu slot="overlay">
                              <a-menu-item>
                                <a @click="printRequest(true)">Document</a>
                              </a-menu-item>
                              <a-menu-item v-if="orderSource=='shopee'">
                                <a @click="shopeePrintWayBill()">Shopee Waybill</a>
                              </a-menu-item>
                              <a-menu-item v-if="orderSource=='lazada'">
                                <a @click="lazadaPrintWayBill()">Lazada Waybill</a>
                              </a-menu-item>
                              <a-menu-item v-if="orderSource=='zalora' " :disabled="zaloraPrintWayBillDisabled">
                                <a @click="zaloraPrintWayBill()">Zalora Waybill{{ zaloraPrintWayBillStatus != null ? " - " + zaloraPrintWayBillStatus : ""}}</a>
                              </a-menu-item>
                            </a-menu>
                        </a-dropdown>
                        <i v-if='false' class="fas fa-sync-alt float-right ml-2 pt-2 btn-sm" style='color: white; cursor: pointer;'> <b style="font-family: 'Arial', sans-serif;"> REFRESH</b></i>
                    </div>
                </div>
                <div class='col-auto ml-2'>
                    <fieldset :disabled="actionDocumentButton">
                        <div class="float-right">
                            <button v-if="documentOrderStatus != 'Frozen' && documentNumber>0 && currentDocumentTypeCode=='OTHPCN'" type="button" class="btn btn-light btn-sm" @click.prevent="freeze()">Freeze Inventory</button>
                            <!-- FOR MR. SPEEDY SAMPLE -->
                            <button v-if="documentStatus == 'Posted' && showBookingButton" type="button"  @click.prevent="showBooking()" class="btn btn-primary btn-sm">Book Delivery</button>

                            <button v-if="documentStatus == 'Posted' && showDeliverButton && false" type="button"  @click.prevent="deliver()" class="btn btn-primary btn-sm">Deliver</button>
                            <button v-if="documentStatus == 'Posted' && documentOrderStatus !== 'Fulfilled' && documentOrderStatus !== 'Done' && showCreateChildDocButton && createChildDocButtonLabel != '' && createChildDocButtonLabel != null" type="button" class="btn btn-primary btn-sm" @click='processChildDocument(false)'>{{createChildDocButtonLabel}}</button>
                            <button v-if="documentStatus == 'Posted' && documentOrderStatus !== 'Fulfilled' && documentOrderStatus !== 'Done' && showCreateChildDocButton && currentDocumentTypeCode=='ORIPOX' && asnModule > 0" type="button" class="btn btn-primary btn-sm" @click='processChildDocument(true)'>Create ASN</button>
                            <button v-if="documentStatus == 'Posted' && documentOrderStatus !== 'Fulfilled' && documentOrderStatus !== 'Done' && showCreateChildDocButton && currentDocumentTypeCode=='ORISOX' && (originDocumentNumber > 0 || accountName.toLowerCase().includes('piml'))" type="button" class="btn btn-primary btn-sm" @click='processChildDocument(true)'>Create Sales Invoice</button>
                            <button v-if="accessRights.includes('A') && documentNumber==0" type="button" class="btn btn-primary btn-sm" @click.prevent="save()" :disabled="isSaveDisabled">Create {{currentDocumentTypeName}}</button>
                            <button v-if="accessRights.includes('W') && documentNumber>0 && (documentStatus == 'Saved' || documentStatus == 'Upload Error')" type="button" class="btn btn-primary btn-sm" @click.prevent="update()" :disabled="isUpdateDisabled">Update</button>
                            <a-popconfirm v-if="accessRights.includes('P') && documentNumber!=0 && (documentStatus == 'Saved' || documentStatus == 'Confirmed' || documentStatus == 'Upload Error') && orderSource!='shopee' && orderSource!='lazada' && orderSource!='zalora' && currentDocumentTypeCode!='OTHBAR'" title="Are you sure you want to post this document?" @confirm="post()" okText="Yes" cancelText="No" :disabled="isPostDisabled">
                                <a type="button" class="btn btn-info btn-sm text-white">Post</a>
                            </a-popconfirm>
                            <a-popconfirm v-if="accessRights.includes('P') && documentNumber!=0 && (documentStatus == 'Saved' || documentStatus == 'Confirmed') && (orderSource=='shopee' || orderSource=='lazada'|| orderSource=='zalora') && currentDocumentTypeCode=='RELDDE'" title="Are you sure you want to post this document?" @confirm="postEcomOrder()" okText="Yes" cancelText="No" :disabled="isPostDisabled">
                                <a type="button" class="btn btn-info btn-sm text-white">Post</a>
                            </a-popconfirm>
                            <a-popconfirm v-if="accessRights.includes('P') && documentNumber!=0 && (documentStatus == 'Saved' || documentStatus == 'Confirmed') && (orderSource=='shopee' || orderSource=='lazada'|| orderSource=='zalora') && currentDocumentTypeCode!='RELDDE'" title="Are you sure you want to post this document?" @confirm="post()" okText="Yes" cancelText="No" :disabled="isPostDisabled">
                                <a type="button" class="btn btn-info btn-sm text-white">Post</a>
                            </a-popconfirm>
                            <button v-if="accessRights.includes('C') && documentNumber!=0 && documentOrderStatus !== 'Fulfilled' && documentOrderStatus !== 'Done' && (documentStatus == 'Saved' || documentStatus == 'Upload Error') && showconfirmUnconfirmButton" :disabled="isConfirmDisabled" type="button" class="btn btn-light btn-sm" @click.prevent="confirm()">Confirm</button>
                            <button v-if="documentNumber!=0 && documentOrderStatus !== 'Fulfilled' && documentOrderStatus !== 'Done' && documentStatus == 'Confirmed' && showconfirmUnconfirmButton" type="button" class="btn btn-light btn-sm" :disabled="isUnconfirmDisabled" @click.prevent="unconfirm()">Unconfirm</button>
                        </div>
                    </fieldset>
                </div>
            </div>
        </div>

        <div class="container-fluid mt--7 spin-content">
            <div class="row regular-header">
                <div class="col-auto">
                    <router-link :to="backLink" >
                        <h6 class="heading-small" style='color: white;'> ⟵   Back to Dashboard </h6>
                    </router-link>
                    <!-- <router-link :to="{ name: 'documents'}" >
                        <h6 class="heading-small" style='color: white;'> ⟵   Back to Dashboard </h6>
                    </router-link> -->
                </div>
                <div class="col p-0">
                    <div class="float-right">
                        <base-dropdown class="nav-link pr-0 float-right" position="right">
                            <div class="media align-items-center" slot="title">
                            <i class="fa fa-ellipsis-v float-right ml-2 btn-sm" style='color: white; cursor: pointer;'></i>
                            </div>
                            <!-- <template>
                                <div class="dropdown-header noti-title">
                                    <h6 class="text-overflow m-0">ACTIONS</h6>
                                </div>
                                <a v-if='originDocumentTypeId > 0' class="dropdown-item" @click='openOriginDocument(originDocumentNumber)'><i class="fa fa-angle-double-left"></i><span>{{originDocumentTypeName}} #{{originDocumentNumber}}</span></a>
                                <a class="dropdown-item" @click.prevent="showDrawer('history')"><i class="fas fa-history"></i><span>History</span></a>
                                <a class="dropdown-item" @click.prevent="showDrawer('references')"><i class="fa fa-asterisk"></i><span>References</span></a>
                                <a class="dropdown-item" @click.prevent="showDrawer('extras')"><i class="fa fa-plus"></i><span>Extras</span></a>
                                <a class="dropdown-item" v-if="documentNumber > 0" @click.prevent="showDocumentPayment()"><i class="fa fa-money-bill"></i><span>Document Payments</span></a>
                                <a class="dropdown-item" v-if="documentNumber > 0" @click.prevent="showDrawer('document_image')"><i class="fa fa-file-image"></i><span>Document Image</span></a>
                                <template v-if="currentDocumentTypeCode == 'OTHPWS'">
                                    <a class="dropdown-item" v-if="accessRights.includes('D') && documentNumber>0 && (documentStatus == 'Saved' || documentStatus == 'Confirmed' || documentStatus == 'Upload Error') && postedASMDSM == false && orderSource!='shopee' && orderSource!='lazada' && orderSource!='shopify'" @click.prevent="voided()"><i class="fas fa-window-close" style="color: Tomato;" ></i><span>Void Request</span></a>
                                    <a class="dropdown-item" v-if="accessRights.includes('D') && documentNumber>0 && (documentStatus == 'Saved' || documentStatus == 'Confirmed' || documentStatus == 'Upload Error') && postedASMDSM == false && (orderSource == 'shopee' || orderSource == 'lazada' || orderSource == 'shopify') && currentDocumentTypeCode=='RELDDE'" @click.prevent="voidEcomOrder()"><i class="fas fa-window-close" style="color: Tomato;" ></i><span>Void Request</span></a>
                                </template>
                                <template v-else>
                                    <a class="dropdown-item" v-if="accessRights.includes('D') && documentNumber>0 && (documentStatus == 'Saved' || documentStatus == 'Upload Error' || documentStatus == 'Posted') && postedASMDSM == false && orderSource!='shopee' && orderSource!='lazada' && orderSource!='shopify'" @click.prevent="voided()"><i class="fas fa-window-close" style="color: Tomato;" ></i><span>Void Request</span></a>
                                    <a class="dropdown-item" v-if="accessRights.includes('D') && documentNumber>0 && (documentStatus == 'Saved' || documentStatus == 'Upload Error' || documentStatus == 'Posted') && postedASMDSM == false && (orderSource == 'shopee' || orderSource == 'lazada' || orderSource == 'shopify') && currentDocumentTypeCode=='RELDDE'" @click.prevent="voidEcomOrder()"><i class="fas fa-window-close" style="color: Tomato;" ></i><span>Void Request</span></a>
                                </template>
                                <a class="dropdown-item" v-if="documentNumber > 0 && (documentStatus == 'Saved' || documentStatus == 'Upload Error')" @click.prevent="copyDocument()"><i class="fas fa-clone"></i><span>Duplicate Document</span></a>
                                <a class="dropdown-item" v-if="currentDocumentTypeCode=='OTHTRA' || currentDocumentTypeCode=='OTHPCK'" @click.prevent="showDrawer('view_allocation')"><i class="fas fa-eye"></i><span>View Allocation</span></a>
                            </template> -->
                            <template>
                                <div class="dropdown-header noti-title">
                                    <h6 class="text-overflow m-0">ACTIONS</h6>
                                </div>
                                <template v-if="relatedDocument.length > 0">
                                    <template v-if="documentRelation == 'parent'">
                                        <div v-for="item in relatedDocument" :key="item.id">
                                            <a class="dropdown-item" @click.prevent='openRelatedDocument(item.id, item.document_type_id)'><i class="fa fa-angle-double-right"></i>{{item.friendly_code}} #{{item.document_no}}</a>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div v-for="item in relatedDocument" :key="item.id">
                                            <a class="dropdown-item" @click.prevent='openRelatedDocument(item.id, item.document_type_id)'><i class="fa fa-angle-double-left"></i>{{item.friendly_code}} #{{item.document_no}}</a>
                                        </div>
                                    </template>
                                    <template v-if="relatedGrandChildrenDocument.length > 0">
                                        <div v-for="item in relatedGrandChildrenDocument" :key="item.id">
                                            <a class="dropdown-item" @click.prevent='openRelatedDocument(item.id, item.document_type_id)'><i class="fa fa-angle-double-left"></i>{{item.friendly_code}} #{{item.document_no}}</a>
                                        </div>
                                    </template>
                                </template>
                                <a class="dropdown-item" @click.prevent="showDrawer('history')"><i class="fas fa-history"></i><span>History</span></a>
                                <a class="dropdown-item" @click.prevent="showDrawer('references')"><i class="fa fa-asterisk"></i><span>References</span></a>
                                <a class="dropdown-item" @click.prevent="showDrawer('extras')" v-if="currentDocumentTypeCode !== 'OTHPWS'"><i class="fa fa-plus" ></i><span>Extras</span></a>
                                <a class="dropdown-item" v-if="currentDocumentTypeCode == 'RECDEL' && documentStatus == 'Posted' && purchaseVarianceAccess == 1" @click.prevent="enableAdditionalCharges()"><i class="fa fa-pencil"></i><span>Purchase Variance</span></a>
                                <a class="dropdown-item" v-if="documentNumber > 0 && currentDocumentTypeCode !== 'OTHPWS'" @click.prevent="showDocumentPayment()"><i class="fa fa-money-bill"></i><span>Document Payments</span></a>
                                <a class="dropdown-item" v-if="documentNumber > 0 && currentDocumentTypeCode !== 'OTHPWS'" @click.prevent="showDrawer('document_image')"><i class="fa fa-file-image"></i><span>Document Image</span></a>
                                <!-- <template v-if="currentDocumentTypeCode == 'OTHPWS'">
                                    <a class="dropdown-item" v-if="accessRights.includes('D') && documentNumber>0 && (documentStatus == 'Saved' || documentStatus == 'Confirmed' || documentStatus == 'Upload Error') && postedASMDSM == false && orderSource!='shopee' && orderSource!='lazada' && orderSource!='shopify'" @click.prevent="voided()"><i class="fas fa-window-close" style="color: Tomato;" ></i><span>Void Request</span></a>
                                    <a class="dropdown-item" v-if="accessRights.includes('D') && documentNumber>0 && (documentStatus == 'Saved' || documentStatus == 'Confirmed' || documentStatus == 'Upload Error') && postedASMDSM == false && (orderSource == 'shopee' || orderSource == 'lazada' || orderSource == 'shopify')" @click.prevent="voidEcomOrder()"><i class="fas fa-window-close" style="color: Tomato;" ></i><span>Void Request</span></a>
                                </template> -->
                                <template v-if="currentDocumentTypeCode != 'OTHPWS'">
                                    <a class="dropdown-item" v-if="accessRights.includes('D') && documentNumber>0 && (documentStatus == 'Saved' || documentStatus == 'Upload Error' || documentStatus == 'Posted') && postedASMDSM == false && orderSource!='shopee' && orderSource!='lazada' && orderSource!='shopify' && orderSource!='zalora'" @click.prevent="voided()"><i class="fas fa-window-close" style="color: Tomato;" ></i><span>Void Request</span></a>
                                    <a class="dropdown-item" v-if="accessRights.includes('D') && documentNumber>0 && (documentStatus == 'Saved' || documentStatus == 'Upload Error') && postedASMDSM == false && (orderSource == 'shopee' || orderSource == 'lazada' || orderSource == 'shopify' || orderSource == 'zalora') && currentDocumentTypeCode=='RELDDE'" @click.prevent="voidEcomOrder()"><i class="fas fa-window-close" style="color: Tomato;" ></i><span>Void Request</span></a>
                                </template>
                                <a class="dropdown-item" v-if="documentNumber > 0 && (documentStatus == 'Saved' || documentStatus == 'Upload Error')" @click.prevent="copyDocument()"><i class="fas fa-clone"></i><span>Duplicate Document</span></a>
                                <a class="dropdown-item" v-if="currentDocumentTypeCode=='OTHTRA' || currentDocumentTypeCode=='OTHPCK'" @click.prevent="showDrawer('view_allocation')"><i class="fas fa-eye"></i><span>View Allocation</span></a>
                                <a class="dropdown-item" v-if="documentId > 0" @click.prevent="showInternalDocumentId"><i class="fa fa-file-alt"></i><span>View Internal ID</span></a>
                                <a-popconfirm :title="doneTitle" @confirm="updateOrderStatus('D')" okText="Yes" cancelText="No">
                                    <a class="dropdown-item" v-if="documentId > 0 && (documentOrderStatus === 'Partial' || documentOrderStatus === 'Unfulfilled')" ><i class="fa fa-check"></i><span>Mark Document as Done</span></a>
                                </a-popconfirm>
                            </template>
                        </base-dropdown>
                        <a-dropdown v-if='accessRights.includes("T") && documentNumber>0 && orderSource!="shopee" && orderSource!="lazada"&& orderSource!="zalora" && currentDocumentTypeCode!="ORIPOX" && currentDocumentTypeCode!="OTHTRA" && currentDocumentTypeCode!="OTHPCK" && currentDocumentTypeCode !="OTHBAR"'>
                            <p class="fas fa-print float-right ml-2 pt-2 btn-sm" style='color: white; cursor: pointer;' @click="e => e.preventDefault()"> <b style="font-family: 'Arial', sans-serif;">PRINT</b> </p>
                            <a-menu slot="overlay">
                              <a-menu-item v-if="currentDocumentTypeCode=='OTHPWS'">
                                <a @click="exportCsvPwsDocument()">CSV</a>
                              </a-menu-item>
                              <!-- SI / CM: two print options — WITH withholding (new format) and withtout withholding (old/current format) -->
                              <a-menu-item v-if="currentDocumentTypeCode=='OTHSIN' || currentDocumentTypeCode=='RECCSR'">
                                <a @click="printRequest(true, undefined, true)">PDF (With WTax)</a>
                              </a-menu-item>
                              <a-menu-item v-if="currentDocumentTypeCode=='OTHSIN' || currentDocumentTypeCode=='RECCSR'">
                                <a @click="printRequest(true, undefined, false)">PDF (Without WTax)</a>
                              </a-menu-item>
                              <a-menu-item v-if="currentDocumentTypeCode!='OTHSIN' && currentDocumentTypeCode!='RECCSR'">
                                <a @click="printRequest(true)">PDF</a>
                              </a-menu-item>
                              <a-menu-item>
                                <a @click="printRequest(true, 'dotMatrix')">DOT PDF</a>
                              </a-menu-item>
                              <a-menu-item v-if="orderSource=='shopee'">
                                <a @click="shopeePrintWayBill()">Shopee Waybill</a>
                              </a-menu-item>
                              <a-menu-item v-if="orderSource=='lazada'">
                                <a @click="lazadaPrintWayBill()">Lazada Waybill</a>
                              </a-menu-item>
                            </a-menu>
                        </a-dropdown>
                        <a-dropdown v-if="accessRights.includes('T') && documentNumber>0 && orderSource!='shopee' && orderSource!='lazada' && orderSource!='zalora' && currentDocumentTypeCode=='ORIPOX'">
                            <p class="fas fa-print float-right ml-2 pt-2 btn-sm" style='color: white; cursor: pointer;'> <b style="font-family: 'Arial', sans-serif;" @click="e => e.preventDefault()"> PRINT</b> </p>
                            <a-menu slot="overlay">
                              <a-menu-item>
                                <a @click="exportCSV()">CSV</a>
                              </a-menu-item>
                              <a-menu-item>
                                <a @click="printRequest(true)">PDF</a>
                              </a-menu-item>
                              <a-menu-item>
                                <a @click="printRequest(true, 'dotMatrix')">DOT PDF</a>
                              </a-menu-item>
                              <a-menu-item v-if="orderSource=='shopee'">
                                <a @click="shopeePrintWayBill()">Shopee Waybill</a>
                              </a-menu-item>
                              <a-menu-item v-if="orderSource=='lazada'">
                                <a @click="lazadaPrintWayBill()">Lazada Waybill</a>
                              </a-menu-item>
                            </a-menu>
                        </a-dropdown>
                        <a-dropdown v-if="accessRights.includes('T') && documentNumber>0 && (currentDocumentTypeCode=='OTHTRA' || currentDocumentTypeCode=='OTHPCK')">
                            <p class="fas fa-print float-right ml-2 pt-2 btn-sm" style='color: white; cursor: pointer;'> <b style="font-family: 'Arial', sans-serif;" @click="e => e.preventDefault()"> PRINT</b> </p>
                            <a-menu slot="overlay">
                              <a-menu-item>
                                <a @click="printRequest(true)">Print Standard</a>
                              </a-menu-item>
                              <a-menu-item>
                                <a @click="printRequest(true, 'dotMatrix')">Print Standard DOT</a>
                              </a-menu-item>
                              <a-menu-item>
                                <a @click="printRequest(false)">Print Extended</a>
                              </a-menu-item>
                              <a-menu-item>
                                <a @click="printRequest(false, 'dotMatrix')">Print Extended DOT</a>
                              </a-menu-item>
                            </a-menu>
                        </a-dropdown>
                        <a-dropdown v-if='accessRights.includes("T") && documentNumber>0 && (orderSource=="shopee" || orderSource=="lazada" || orderSource=="zalora")'>
                            <p class="fas fa-print float-right ml-2 pt-2 btn-sm" style='color: white; cursor: pointer;'> <b style="font-family: 'Arial', sans-serif;" @click="e => e.preventDefault()"> PRINT</b> </p>
                            <a-menu slot="overlay">
                              <a-menu-item>
                                <a @click="printRequest(true)">Document</a>
                              </a-menu-item>
                              <a-menu-item v-if="orderSource=='shopee'">
                                <a @click="shopeePrintWayBill()">Shopee Waybill</a>
                              </a-menu-item>
                              <a-menu-item v-if="orderSource=='lazada'">
                                <a @click="lazadaPrintWayBill()">Lazada Waybill</a>
                              </a-menu-item>
                              <a-menu-item v-if="orderSource=='zalora' " :disabled="zaloraPrintWayBillDisabled">
                                <a @click="zaloraPrintWayBill()">Zalora Waybill{{ zaloraPrintWayBillStatus != null ? " - " + zaloraPrintWayBillStatus : ""}}</a>
                              </a-menu-item>
                            </a-menu>
                        </a-dropdown>
                        <p v-if="accessRights.includes('T') && documentNumber>0 && currentDocumentTypeCode=='OTHBAR' && documentStatus == 'Confirmed'" class="fas fa-print float-right ml-2 pt-2 btn-sm" style='color: white; cursor: pointer;' @click="showBarcodePrintingModal()"> <b style="font-family: 'Arial', sans-serif;" > PRINT</b> </p>
                        <i v-if='false' class="fas fa-sync-alt float-right ml-2 pt-2 btn-sm" style='color: white; cursor: pointer;' @click.prevent=""> <b style="font-family: 'Arial', sans-serif;"> REFRESH</b></i>
                    </div>
                </div>
                <div class='col-auto ml-2'>
                    <fieldset :disabled="actionDocumentButton">
                        <div class="float-right">
                            <button v-if="documentOrderStatus != 'Frozen' && documentNumber>0 && currentDocumentTypeCode=='OTHPCN'" type="button" class="btn btn-light btn-sm" @click.prevent="freeze()">Freeze Inventory</button>
                            <button v-if="documentStatus == 'Posted' && showDeliverButton && false" type="button"  @click.prevent="deliver()" class="btn btn-primary btn-sm">Deliver</button>

                            <!-- FOR MR. SPEEDY SAMPLE -->
                            <button v-if="documentStatus == 'Posted' && showBookingButton" type="button"  @click.prevent="showBooking()" class="btn btn-primary btn-sm">Booking Details</button>
                            <button v-if="documentStatus == 'Posted' && showCreateChildDocButton && documentOrderStatus !== 'Fulfilled' && documentOrderStatus !== 'Done'" type="button" class="btn btn-primary btn-sm" @click='processChildDocument(false)'>{{createChildDocButtonLabel}}</button>
                            <button v-if="documentStatus == 'Posted' && showCreateChildDocButton && documentOrderStatus !== 'Fulfilled' && documentOrderStatus !== 'Done' && currentDocumentTypeCode=='ORIPOX' && asnModule > 0" type="button" class="btn btn-primary btn-sm" @click='processChildDocument(true)'>Create ASN</button>
                            <button v-if="documentStatus == 'Posted' && showCreateChildDocButton && documentOrderStatus !== 'Fulfilled' && documentOrderStatus !== 'Done' && currentDocumentTypeCode=='ORISOX' && (originDocumentNumber > 0 || accountName.toLowerCase().includes('piml'))" type="button" class="btn btn-primary btn-sm" @click='processChildDocument(true)'>Create Sales Invoice</button>
                            <button v-if="accessRights.includes('A') && documentNumber==0 " type="button" class="btn btn-primary btn-sm" @click.prevent="save()" :disabled="isSaveDisabled">Create {{currentDocumentTypeName}}</button>
                            <button v-if="accessRights.includes('W') && documentNumber>0 && (documentStatus == 'Saved' || documentStatus == 'Upload Error')" type="button" class="btn btn-primary btn-sm" @click.prevent="update()" :disabled="isUpdateDisabled">Update </button>
                            <a-popconfirm v-if="accessRights.includes('P') && documentNumber!=0 && (documentStatus == 'Saved' || documentStatus == 'Confirmed' || documentStatus == 'Upload Error') && orderSource!='shopee' && orderSource!='lazada'&& orderSource!='zalora' && currentDocumentTypeCode!='OTHBAR'" title="Are you sure you want to post this document?" @confirm="post()" okText="Yes" cancelText="No" :disabled="isPostDisabled">
                                <a type="button" class="btn btn-info btn-sm text-white">Post</a>
                            </a-popconfirm>
                            <a-popconfirm v-if="accessRights.includes('P') && documentNumber!=0 && (documentStatus == 'Saved' || documentStatus == 'Confirmed') && (orderSource=='shopee' || orderSource=='lazada'|| orderSource=='zalora') && currentDocumentTypeCode=='RELDDE'" title="Are you sure you want to post this document?" @confirm="postEcomOrder()" okText="Yes" cancelText="No" :disabled="isPostDisabled">
                                <a type="button" class="btn btn-info btn-sm text-white" >Post</a>
                            </a-popconfirm>
                            <a-popconfirm v-if="accessRights.includes('P') && documentNumber!=0 && (documentStatus == 'Saved' || documentStatus == 'Confirmed') && (orderSource=='shopee' || orderSource=='lazada'|| orderSource=='zalora') && currentDocumentTypeCode!='RELDDE'" title="Are you sure you want to post this document?" @confirm="post()" okText="Yes" cancelText="No" :disabled="isPostDisabled">
                                <a type="button" class="btn btn-info btn-sm text-white">Post</a>
                            </a-popconfirm>
                            <button v-if="accessRights.includes('C') && documentNumber!=0 && documentOrderStatus !== 'Fulfilled' && documentOrderStatus !== 'Done' && (documentStatus == 'Saved' || documentStatus == 'Upload Error') && showconfirmUnconfirmButton" :disabled="isConfirmDisabled" type="button" class="btn btn-light btn-sm" @click.prevent="confirm()">Confirm</button>
                            <button v-if="documentNumber!=0 && documentOrderStatus !== 'Fulfilled' && documentOrderStatus !== 'Done' && documentStatus == 'Confirmed' && showconfirmUnconfirmButton" type="button" class="btn btn-light btn-sm" :disabled="isUnconfirmDisabled" @click.prevent="unconfirm()">Unconfirm</button>
                        </div>
                    </fieldset>
                </div>
            </div>

            <!-- View Internal ID Modal -->
            <a-modal title="Internal Document ID" :visible="modalInternalDocumentId" :maskClosable="false"
                    @cancel="handleCancel">
                <template slot="footer">
                    <a-button key="back" @click="handleCancel">Close</a-button>
                </template>
                <b>Document Id: </b> {{this.documentId}}
            </a-modal>

            <!-- Additional Charges Modal -->
            <!-- Arvin -->
            <a-modal title="Additional Charges" :visible="modalAdditionalCharges" :maskClosable = "false"
                    @cancel="modalAdditionalCharges = false; showChargesTable = false;" width='70%' wrap-class-name="full-modal">
                <template slot="footer">
                    <a-popconfirm v-if="additionalChargeData.length > 0" placement="top" @confirm="saveAdditionalCharges()" okText="Yes" cancelText="No">
                        <template #title>
                        <p class="text-small">This will recompute the received cost of all
                        <br>remaining inventory quantity from this document.
                        <br>Do you want to continue?</p>
                        </template>
                            <a type="button" class="btn btn-danger btn-sm text-white" :disabled="disableSaveCharges">Apply Charges</a>
                    </a-popconfirm>
                    <a-button key="back" @click="modalAdditionalCharges = false; showChargesTable = false;">Cancel</a-button>
                </template>
                <a-spin :tip="spinMessage" :spinning="spinning2">
                <div class="row pb-2">
                    <div class="col ">
                        <h6 class="heading-small text-muted">Charges</h6>
                    </div>
                    <div class="col-2 d-flex align-items-end" v-if="additionalChargeSelectedRowKeys && additionalChargeSelectedRowKeys.length > 0">
                        <button type="button" class="btn btn-danger btn-sm btn-block align-bottom" @click="mass_delete_charge()">Delete Charge</button>
                    </div>
                    <div class="col-2 d-flex align-items-end">
                        <button type="button" class="btn btn-primary btn-sm btn-block align-bottom" @click="showDrawer('charges')">Add Charge</button>
                    </div>
                </div>
                <a-table :rowSelection="additionalChargeRowSelection" rowKey='line_no' :columns="additionalChargeColumns" :dataSource="additionalChargeData" :pagination="true" size="small">
                <span slot="amount" slot-scope="text, record">
                    {{formatMyNumber(Number(record.amount), 2)}}
                </span> 
                <template #footer>Total Additional Charges: {{formatMyNumber(Number(totalPurchaseVariance), 2)}}</template>
                </a-table>
                <hr/>
                <base-input label="Charge Distribution Quantity"><br>
                    <a-radio-group name="chargeDistributionQuantity" v-model="chargeDistributionQuantity">
                      <a-radio :value="1">
                        Document Quantity
                      </a-radio>
                      <a-radio :value="2">
                        Inventory Quantity
                      </a-radio>
                    </a-radio-group>
                    <button type="button" v-if="additionalChargeData.length > 0" class="btn btn-success btn-sm align-bottom" @click="applyAdditionalCharges()">View Charges</button>
                </base-input>
                <hr/>
                <a-table rowKey='line_no' :columns="itemsAdditionalChargeColumns" :dataSource="itemCostLayerData" :pagination="true" size="small">
                    <span slot="new_cost" slot-scope="text, record">
                        {{formatMyNumber(Number(record.new_cost), 2)}}
                    </span> 
                    <span slot="charge_share" slot-scope="text, record">
                        {{formatMyNumber(Number(record.charge_share), 2)}}
                    </span> 
                    <span slot="rr_quantity" slot-scope="text, record">
                        {{formatMyNumber(Number(record.rr_quantity), 0)}}
                    </span> 
                    <span slot="quantity" slot-scope="text, record">
                        {{formatMyNumber(Number(record.quantity), 0)}}
                    </span> 
                    <span slot="cost" slot-scope="text, record">
                        {{formatMyNumber(Number(record.cost), 2)}}
                    </span>      
                </a-table>
                </a-spin>
            </a-modal>

            <!-- Min/Max products modal -->
            <a-modal title="Auto-Rep (Min/Max)" :visible="modalMinMaxProducts" :maskClosable = "false"
                    @cancel="modalMinMaxProducts = false;">
                <template slot="footer">
                    <a-button key="submit" type="primary" @click="populateMinMaxProducts()">Yes</a-button>
                    <a-button key="back" @click="modalMinMaxProducts = false;">No</a-button>
                </template>
                This will list all items that need to be replenished based on re-order level. {{overrideMinMaxProducts}} Do you want to continue?
            </a-modal>

            <!-- Offtake products modal -->
            <a-modal title="Auto-Rep (By Offtake)" :visible="modalOffTakeProducts" :maskClosable = "false"
                    @cancel="modalOffTakeProducts = false;">
                <template slot="footer">
                    <a-button key="submit" type="primary" @click="populateOffTakeProducts()">Yes</a-button>
                    <a-button key="back" @click="modalOffTakeProducts = false;">No</a-button>
                </template>
                This will list all items that need to be replenished based on offtake for the last {{offtakeDays}} days. {{overrideOfftakeProducts}} Do you want to continue?
            </a-modal>
            
            <!-- Header -->
            <div class="row mt-2">
                <div class="col">
                    <div class="card shadow">
                        <!-- doc type with id and document status -->
                        <div class="card-header px-4 py-3 bg-transparent">
                            <div class="row px-3">
                                <h6 v-if='documentNumber!=undefined && documentNumber!=0' class="heading-small p-0 m-0"> {{ casNo }} <br> {{ friendlyCodeAndDocumentNo }} <br> {{ friendlyOriginDocumentNo }}</h6>
                                <h6 v-else class="heading-small"> Create {{currentDocumentTypeName}} </h6>
                                <div class="col d-flex justify-content-end">
                                    <h6 class="heading-small p-0 m-0 mr-2"> {{documentOrderStatus}} </h6><i :class="headerOrderStatusIcon"></i>
                                    <h6 class="heading-small p-0 m-0 mr-2"> {{documentStatus}} </h6> <i :class="headerStatusIcon"></i>
                                </div>
                            </div>
                            <template v-if='documentNumber!=undefined && documentNumber!=0 && relatedDocument.length > 0'>
                                 <div v-if="documentRelation == 'parent'" >
                                    <div class="row px-3">
                                        <span v-for="item in relatedDocument" :key="item.id" class="heading-small">
                                            <a @click.prevent='openRelatedDocument(item.id, item.document_type_id)'>Parent Document No: {{item.friendly_code}}#{{item.document_no}}</a>
                                        </span>
                                        <span v-if="relatedDocumentOrigin.length > 0 && (currentDocumentTypeCode === 'ORIASN' || currentDocumentTypeCode === 'RECDEL' || currentDocumentTypeCode === 'OTHPCV' || currentDocumentTypeCode === 'OTHTOV')">
                                            <span v-for="originItem in relatedDocumentOrigin" :key="originItem.id" class="heading-small">
                                                <a @click.prevent='openRelatedDocument(originItem.id, originItem.document_type_id)'>, {{ originItem.friendly_code }}#{{ originItem.document_no }}</a>
                                            </span>
                                        </span>
                                    </div>
                                 </div>
                                 <div v-else class="row px-3">
                                    <span class="heading-small">Child Document No:</span>
                                    <span v-for="item in relatedDocument" :key="item.id" class="heading-small">
                                        <a @click.prevent='openRelatedDocument(item.id, item.document_type_id)'> {{item.friendly_code}}#{{item.document_no}}</a>,&nbsp;
                                    </span>
                                 </div>
                                 <div v-if="relatedGrandChildrenDocument.length > 0" class="row px-3">
                                    <span class="heading-small">Child Document No:</span>
                                    <span v-for="originItem in relatedGrandChildrenDocument" :key="originItem.id" class="heading-small">
                                        <a @click.prevent='openRelatedDocument(originItem.id, originItem.document_type_id)'>, {{ originItem.friendly_code }}#{{ originItem.document_no }}</a>
                                    </span>
                                 </div>
                            </template>
                        </div>

                        <!-- document name and fields -->
                        <div class="card-body mx-4">
                            <!-- header label -->
                            <div class="row">
                                <div class="col p-0"><h3 class='font-weight-bold'>{{currentDocumentTypeName}} Header</h3></div>
                                <div lass="col-auto p-0 mr-2 float-right"  v-if="(accountName.toLowerCase().includes('piml') || accountName.toLowerCase().includes('ph')) && (currentDocumentTypeCode == 'OTHSRQ' || currentDocumentTypeCode == 'ORISOX')" >
                                    <base-dropdown v-model="productPriceChoice" >
                                        <base-button slot="title" type="link" class="dropdown-toggle pt-0 pr-2">{{_.startCase(productPriceChoice)}}</base-button>
                                        <a class="dropdown-item" v-if="accountName.toLowerCase().includes('piml')" @click.prevent="changePimlPriceChoice('piml_price1')">PIML Price 1</a>
                                        <a class="dropdown-item" v-if="accountName.toLowerCase().includes('piml')" @click.prevent="changePimlPriceChoice('piml_price2')">PIML Price 2</a>
                                        <a class="dropdown-item" v-if="accountName.toLowerCase().includes('piml')" @click.prevent="changePimlPriceChoice('piml_price3')">PIML Price 3</a>
                                        <a class="dropdown-item"  v-if="accountName.toLowerCase().includes('ph')" @click.prevent="changePimlPriceChoice('wholesale_price')">Wholesale Price</a>
                                        <a class="dropdown-item" v-if="accountName.toLowerCase().includes('piml') || accountName.toLowerCase().includes('ph')" @click.prevent="changePimlPriceChoice('retail_price')">Retail Price</a>
                                    </base-dropdown>
                                </div>
                                <div class="col-auto p-0 mr-2 float-right" v-if="!docTypesForP2P.includes(currentDocumentTypeCode)">
                                    <a-tooltip placement="top" :title="currencyRateLabel" v-if="currentDocumentTypeCode !== 'OTHPWS'">
                                        <a-select 
                                            size="small"
                                            labelInValue
                                            :value="currency"
                                            class="currency-select"
                                            :filterOption="false"
                                            @dropdownVisibleChange="fetchCurrencies"
                                            @change="selectCurrency"
                                            :disabled="(documentStatus == 'Posted' || docTypesForIM.includes(currentDocumentTypeCode) || currentDocumentTypeCode == 'OTHSBI') ? true : false"
                                            :notFoundContent="fetching ? undefined : null"
                                        >
                                            <a-spin v-if="fetching" slot="notFoundContent" size="small"/>
                                            <a-select-option v-for="c in currencies" :key="'currencies'+c.id.toString()">{{c.name}}</a-select-option>
                                        </a-select>
                                    </a-tooltip>
                                </div>
                                <div v-if='header.showDocumentHeader && showTradeToggle' class="col-auto p-0 float-right">
                                    <a-popconfirm title="This action will clear all document lines?"
                                        ok-text="Continue"
                                        cancel-text="Cancel"
                                        @confirm="toggleDocumentTrade"
                                        :disabled="isTradeToggleDisabled"
                                    >
                                        <a-switch :checked='isDocumentTrade' checked-children="Trade Items" un-checked-children="Non-Trade Items" :disabled="isTradeToggleDisabled"/>
                                    </a-popconfirm>
                                </div>
                                <div class="col-auto p-0 float-right">
                                  <a v-if="!isEditing"
                                     class="refresh-document"
                                     href="#"
                                     @click.prevent="refreshDocument">
                                    <label><a-icon type="reload" /></label>
                                  </a>
                                  <a-popconfirm
                                    v-else
                                    class="refresh-document"
                                    title="This action will reload the current Document. Any unsaved changes will be removed. Do you want to continue?"
                                    ok-text="Yes"
                                    cancel-text="Cancel"
                                    @confirm="refreshDocument">
                                    <label><a-icon type="reload" /></label>
                                  </a-popconfirm>
                                </div>
                            </div>

                            <!-- header fields -->
                            <div class="row mt-2">

                                <!-- Supplying Branch -->
                                <div v-if='header.showSupplyingSite' class="col mr-1">
                                    <div class="row"><h4 class="btn-blockheading-small font-weight-normal">Supplying Branch</h4></div>
                                    <div class="row mt-2">
                                        <a-select
                                        labelInValue
                                        showSearch
                                        :value="supplyingSite"
                                        placeholder="Select a supplying site"
                                        style="width: 100%"
                                        :filterOption="filterOption"
                                        @dropdownVisibleChange="fetchSites"
                                        @change="selectSupplyingSite"
                                        :notFoundContent="fetching ? undefined : null"
                                        :disabled="isSupplyingSiteDisabled || (this.currentDocumentTypeCode == 'RELTRX' && (this.brand.key <=0 || this.brand.key == undefined || this.brand.key == null))"
                                        >
                                            <a-spin v-if="fetching" slot="notFoundContent" size="small"/>
                                            <a-select-option v-for="s in sites" :key="'sites'+s.id.toString()">{{ s.name }}
                                                <!-- <a-tooltip :title="s.name">
                                                    <span>{{ s.name }}</span>
                                                </a-tooltip> -->
                                            </a-select-option>
                                        </a-select>
                                    </div>
                                </div>

                                <!-- Brand-->
                                <div v-if='header.showBrand && currentDocumentTypeCode != "ORISOX" && currentDocumentTypeCode != "OTHSRQ" && currentDocumentTypeCode != "RECCSR" && currentDocumentTypeCode != "OTHSIN" && currentDocumentTypeCode != "RELDDE"' class="col mr-1">
                                    <div class="row"><h4 class="btn-blockheading-small font-weight-normal">Brand</h4></div>
                                    <div class="row mt-2">
                                        <a-auto-complete
                                            style="width: 100%"
                                            placeholder="Select a Brand"
                                            :filter-option="filterOption"
                                            @select="selectBrand"
                                            :value="brand.label"
                                            @search="fetchBrands"
                                            @focus="fetchBrands"
                                            :disabled='isBrandDisabled'
                                            >
                                            <template slot="dataSource">
                                                <a-select-option v-for="b in brands" :key="'brands'+b.id.toString()" :text="b.name">{{b.name}}</a-select-option>
                                            </template>
                                        </a-auto-complete>
                                    </div>
                                </div>

                                <!-- Supplier -->
                                <div v-if='header.showSupplier' class="col mr-1">
                                    <div class="row">
                                        <div v-if='header.showRecevingReport' class="col p-0 mr-1"><h4 class="btn-blockheading-small font-weight-normal">Receiving Report No</h4></div>
                                        <div class="col p-0 mr-1"><h4 class="btn-blockheading-small font-weight-normal">Supplier</h4></div>
                                    </div>
                                    <div class="row mt-2">
                                        <template>
                                            <a-modal
                                                title="Changing Supplier"
                                                :visible="showChangeSupplierModal"
                                                :maskClosable="false"
                                                :confirm-loading="confirmLoadingonSuppModal"
                                                @ok="changeCostBySupplier"
                                                @cancel="showChangeSupplierModal = false"
                                                >
                                                <p>Changing supplier will automatically change cost of all items below. Do you want to change the supplier</p>
                                                </a-modal>
                                        </template>
                                          <!-- /barter-11/bxi-backend/-/issues/2252 -->
                                          <!-- Created a pop-up modal for clearing document line -->
                                        <template>
                                            <a-modal
                                                :title="popUpModal.message"
                                                :visible="popUpModal.isVisible"
                                                :maskClosable="false"
                                                @ok="popUpModal.initializeProcess"
                                                @cancel="popUpModal.isVisible = false"
                                                :cancelButtonProps="{ style: { display: popUpModal.isAutoPopulate ? 'none': null }}"
                                                :closable="false"
                                                >
                                                <p>{{popUpModal.text}}</p>
                                                </a-modal>
                                            <a-modal
                                                title="Adding Item(s)"
                                                :visible="showAddingProgress.isVisible"
                                                :closable="false"
                                                :maskClosable="false"
                                                :footer="null"
                                                >
                                                <p>{{`${showAddingProgress.productAdded} out of ${showAddingProgress.productCount}`}}</p>
                                                
                                                <a-progress :percent="showAddingProgress.productCount?Math.floor((100 / showAddingProgress.productCount ) * showAddingProgress.productAdded): 0" size="small" />
                                                <!-- <p>{{`${showAddingProgress.productCount?Math.floor((100 / showAddingProgress.productCount ) * showAddingProgress.productAdded): 0}% Completed`}}</p> -->
                                                <!-- <button @click.prevent="showAddingProgress.isVisible = false"  class="btn btn-sm btn-dark"> Stop</button> -->
                                                </a-modal>
                                        </template>

                                       <div v-if='header.showRecevingReport' class="col p-0 mr-1">
                                            <a-input style="width: 100%" v-model='receivingReport' placeholder="Receiving Report Number" :disabled='isRecevingReportDisabled'/>
                                        </div>
                                        <div class="col p-0 pr-2">
                                            <a-auto-complete ref="supplierAutoCompleteInput"
                                                style="width: 100%"
                                                placeholder="Search supplier"
                                                @select="selectSupplier"
                                                :value="supplier.label"
                                                @search="fetchSuppliers"
                                                @focus="fetchSuppliers"
                                                @blur="showSupplierModal"
                                                :disabled='isSupplierDisabled'
                                                :allowClear='true'
                                            >
                                                <template slot="dataSource">
                                                    <a-select-option v-for="s in suppliers" :key="'selectSupplier'+s.id.toString()" :text="s.name">
                                                        <a-tooltip :title="s.name">
                                                            <span>{{ s.name }}</span>
                                                        </a-tooltip>
                                                    </a-select-option>
                                                </template>
                                            </a-auto-complete>

                                        </div>
                                        <div class="col-auto p-0" v-if="showSupplierOptions && supplier.key > 0 || currentDocumentTypeCode =='ORIPOX' || currentDocumentTypeCode =='OTHPWS' ">
                                            <a-dropdown>
                                                <a class="ant-dropdown-link" @click="e => e.preventDefault()">
                                                <i class="fa fa-ellipsis-v btn-sm"> </i>
                                                </a>
                                                <a-menu slot="overlay">
                                                <a-menu-item key="1">
                                                    <!-- <a class="btn btn-success btn-sm text-white">Open</a> -->
                                                    <a v-if="supplier.key > 0 || currentDocumentTypeCode=='ORIPOX' || currentDocumentTypeCode=='OTHPWS'" type="button" class="float-right btn btn-light btn-sm" @click.prevent="checkDocumentLine">Auto Populate Products By Supplier</a>
                                                </a-menu-item>
                                                </a-menu>
                                            </a-dropdown>
                                        </div>
                                    </div>
                                </div>

                                <!-- For this Site -->
                                <div v-if='header.showForThisSite' class="col ml-1">
                                    <div class="row">
                                        <h4 class="btn-blockheading-small font-weight-normal">For This Site </h4>
                                        <div v-if="showApplyDocumentToOtherSitesButton()"
                                             class="float-right"
                                             style="flex-grow: 1">
                                            <button type="primary"
                                                      class="btn float-right ml-1 btn-primary btn-sm"
                                                      @click.prevent="toggleApplyDocumentToOtherSitesDrawer(true)">
                                                Apply Document to Other Sites
                                            </button>
                                        </div>
                                    </div>
                                    <div class="row mt-2">
                                        <a-select
                                            labelInValue
                                            :value="forThisSite"
                                            placeholder="Select a site"
                                            style="width: 100%"
                                            :filterOption="false"
                                            @dropdownVisibleChange="fetchForThisSites"
                                            @change="selectForThisSite"
                                            :disabled="isForThisSiteDisabled"
                                            :notFoundContent="fetching ? undefined : null"
                                            >
                                            <a-spin v-if="fetching" slot="notFoundContent" size="small"/>
                                            <a-select-option v-for="s in forThisSites" :key="'forThisSites'+s.id.toString()">{{s.name}}</a-select-option>
                                        </a-select>
                                    </div>
                                </div>

                                <!-- Revenue Branch -->
                                <div v-if='header.showRevenue' class="col ml-1">
                                    <div class="row"><h4 class="btn-blockheading-small font-weight-normal">Revenue Crediting</h4></div>
                                    <div class="row mt-2">
                                        <a-select
                                            v-model="revenue"
                                            placeholder="Select a Revenue site"
                                            style="width: 100%"
                                            @change="selectRevenue"
                                            :filterOption="filterOption"
                                            :notFoundContent="fetching ? undefined : null"
                                            :disabled="isRevenueDisabled"
                                        >
                                            <a-spin v-if="fetching" slot="notFoundContent" size="small"/>
                                            <a-select-option v-for="s in revenueOption" :key="s.key">{{s.value}}</a-select-option>
                                        </a-select>
                                    </div>
                                </div>

                                <!-- Requesting Branch -->
                                <div v-if='header.showRequestingSite' class="col ml-1">
                                    <div class="row"><h4 class="btn-blockheading-small font-weight-normal">{{RequestingLabel}} Branch</h4></div>
                                    <div class="row mt-2">
                                        <a-select
                                            showSearch
                                            labelInValue
                                            :value="requestingSite"
                                            :placeholder="'Select a '+RequestingLabel+' site'"
                                            style="width: 100%"
                                            :filterOption="filterOption"
                                            @dropdownVisibleChange="fetchSites"
                                            @change="selectRequestingSite"
                                            :notFoundContent="fetching ? undefined : null"
                                            :disabled="isRequestingSiteDisabled || (this.currentDocumentTypeCode == 'RELTRX' && (this.brand.key <=0 || this.brand.key == undefined || this.brand.key == null ))"
                                        >
                                            <a-spin v-if="fetching" slot="notFoundContent" size="small"/>
                                            <a-select-option v-for="s in sites" :key="'selectRequestingSite'+s.id.toString()">{{ s.name }}
                                                <!-- <a-tooltip :title="s.name">
                                                    <span>{{ s.name }}</span>
                                                </a-tooltip> -->
                                            </a-select-option>
                                        </a-select>
                                    </div>
                                </div>
                                <!-- Party -->
                                <div v-if='header.showParty' class="col">
                                    <div class="row"><h4 class="btn-blockheading-small font-weight-normal">Party</h4></div>
                                    <div class="row mt-2"> 
                                        <a-input style="width: 100%" v-model='party' placeholder="Party" :disabled='isPartyDisabled'/>
                                    </div>
                                </div>

                                <!-- Sublocation -->
                                <div v-if='header.showSublocation' class="col">
                                    <div class="row"><h4 class="btn-blockheading-small font-weight-normal">Sublocation</h4></div>
                                    <div class="row mt-2">

                                        <a-select
                                        labelInValue
                                        :value="siteSublocation"
                                        placeholder="Select a sublocation"
                                        style="width: 100%"
                                        :filterOption="false"
                                        @dropdownVisibleChange="fetchPcountSublocations"
                                        @change="selectSiteSublocation"
                                        :notFoundContent="fetching ? undefined : null"
                                        :disabled='isSiteSublocationDisabled'
                                        >
                                            <a-spin v-if="fetching" slot="notFoundContent" size="small"/>
                                            <a-select-option v-for="s in sublocations" :key="'sublocations'+s.id.toString()">{{s.name}}</a-select-option>
                                        </a-select>


                                    </div>
                                </div>

                                <!-- SO DD SI -->
                                <div v-if='header.showSublocationHeader' class="col mr-1">

                                    <!-- Label and Input, Site -->
                                    <div v-if='header.showSublocationSite' class="row">
                                        <div v-if='header.showBrand && (currentDocumentTypeCode == "RELDDE" || currentDocumentTypeCode == "OTHSIN")' class="col p-0 mr-1"><h4 class="btn-blockheading-small font-weight-normal">Brand</h4></div>
                                        <div v-if='header.showSalesOrder' class="col p-0 mr-1"><h4 class="btn-blockheading-small font-weight-normal">Sales Order No</h4></div>
                                        <div v-if="header.showDeliveryDocument && currentDocumentTypeCode == 'RECCSI'" class="col p-0 mr-1"><h4 class="btn-blockheading-small font-weight-normal">Concession Sales Document No</h4></div>
                                        <div v-if="header.showDeliveryDocument && currentDocumentTypeCode != 'RECCSI'" class="col p-0 mr-1"><h4 class="btn-blockheading-small font-weight-normal">Delivery Document No</h4></div>
                                        <div v-if='header.showSublocationSite' class="col p-0 mr-1"><h4 class="btn-blockheading-small font-weight-normal">Site Name</h4></div>
                                        <div v-if='header.showCompanyDetails' class="col p-0 mr-1"><h4 class="btn-blockheading-small font-weight-normal">Company Owner</h4></div>
                                    </div>
                                    <div class="row mt-2">
                                        <!-- Brand-->
                                        <div v-if='header.showBrand && (currentDocumentTypeCode == "RELDDE" || currentDocumentTypeCode == "OTHSIN")' class="col p-0 mr-1">
                                            <a-auto-complete
                                                style="width: 100%"
                                                placeholder="Select a Brand"
                                                :filter-option="filterOption"
                                                @select="selectBrand"
                                                :value="brand.label"
                                                @search="fetchBrands"
                                                @focus="fetchBrands"
                                                :disabled='isBrandDisabled || documentLen > 0'
                                                >
                                                <template slot="dataSource">
                                                    <a-select-option v-for="b in brands" :key="'brands'+b.id.toString()" :text="b.name">{{b.name}}</a-select-option>
                                                </template>
                                            </a-auto-complete>
                                        </div>
                                        <div v-if='header.showSalesOrder' class="col p-0 mr-1">
                                            <a-input style="width: 100%" v-model='salesOrder' placeholder="Sales Order Number" :disabled='isSalesOrderDisabled'/>
                                        </div>
                                        <div v-if='header.showDeliveryDocument' class="col p-0 mr-1">
                                            <a-input style="width: 100%" v-model='deliveryDocument' placeholder="Delivery Document Number" :disabled='isDeliveryDocumentDisabled'/>
                                        </div>
                                        <div v-if='header.showSublocationSite' class="col p-0 mr-1">
                                            <a-auto-complete
                                                style="width: 100%"
                                                placeholder="Search site"
                                                :filter-option="autocompleteFilterOption"
                                                @select="selectDistributionSite"
                                                :value="distributionSite.label"
                                                @search="fetchDistributionSites"
                                                @focus="fetchDistributionSites"
                                                :disabled='isDistributionSiteDisabled'
                                                :allowClear='true'
                                            >
                                                <template slot="dataSource">
                                                    <a-select-option v-for="s in sites" :key="'sites1'+s.id.toString()" :text="s.name" :content="s.company_id">{{ s.name }}
                                                        <!-- <a-tooltip :title="s.name">
                                                            <span>{{ s.name }}</span>
                                                        </a-tooltip> -->
                                                    </a-select-option>
                                                </template>
                                            </a-auto-complete>
                                        </div>
                                        <div v-if='header.showCompanyDetails' class="col p-0 mr-1">
                                            <a-input style="width: 100%" disabled v-model="companyOwnerName" placeholder="Company Owner"/>
                                        </div>
                                    </div>
                                    
                                    <!-- Label and Input, Site -->
                                    <div class="row mt-2">
                                        <div v-if='header.showBrand && (currentDocumentTypeCode == "RECCSR")' class="col p-0 mr-1"><h4 class="btn-blockheading-small font-weight-normal">Brand</h4></div>
                                        <div v-if='header.showOrderSource' class="col p-0 mr-1"><h4 class="btn-blockheading-small font-weight-normal">Order Source</h4></div>
                                        <div v-if='header.showSublocationOrigin' class="col p-0 mr-1"><h4 class="btn-blockheading-small font-weight-normal">{{sublocationOriginLabel}}</h4></div>
                                        <div v-if='header.showSublocationDestination' class="col p-0 mr-1"><h4 class="btn-blockheading-small font-weight-normal">{{sublocationDestinationLabel}}</h4></div>
                                        <div v-if='header.showCustomer' class="col p-0"><h4 class="btn-blockheading-small font-weight-normal">Customer Name</h4></div>
                                        <div v-if='header.showSalesman' class="col p-0"><h4 class="btn-blockheading-small font-weight-normal">Salesman Name</h4></div>
                                    </div>
                                    
                                    <div class="row mt-2">
                                        <!-- Brand-->
                                        <div v-if='header.showBrand && (currentDocumentTypeCode == "RECCSR")' class="col p-0 mr-1">
                                            <a-auto-complete 
                                                style="width: 100%"
                                                placeholder="Select a Brand"
                                                :filter-option="filterOption"
                                                @select="selectBrand"
                                                :value="brand.label"
                                                @search="fetchBrands"
                                                @focus="fetchBrands"
                                                :disabled='isBrandDisabled || documentLen > 0'
                                                >
                                                <template slot="dataSource">
                                                    <a-select-option v-for="b in brands" :key="'brands'+b.id.toString()" :text="b.name">{{b.name}}</a-select-option>
                                                </template>
                                            </a-auto-complete>
                                        </div>
                                        <!-- Order Source -->
                                        <div v-if='header.showOrderSource' class="col p-0 mr-1">
                                            <a-select v-model='orderSource' @select="selectOrderSource" placeholder='Order Source' style="width: 100%;" input-classes="form-control" :disabled="isOrderSourceDisabled">
                                                <a-select-option v-for="s in orderSources" :key="s.toString()">{{s}}</a-select-option>
                                            </a-select>
                                        </div>
                                        <!-- Sublocation Origin -->
                                        <div v-if='header.showSublocationOrigin' class="col p-0 mr-1">
                                            <a-select
                                            labelInValue
                                            :value="originSublocation"
                                            placeholder="Select a sublocation"
                                            style="width: 100%"
                                            :filterOption="false"
                                            @dropdownVisibleChange="fetchSublocations"
                                            @change="selectOriginSublocation"
                                            :notFoundContent="fetching ? undefined : null"
                                            :disabled='isOriginSublocationDisabled'
                                            >
                                                <a-spin v-if="fetching" slot="notFoundContent" size="small"/>
                                                <a-select-option v-for="s in sublocations" :key="'sublocations1'+s.id.toString()">{{s.name}}</a-select-option>
                                            </a-select>
                                        </div>
                                        <!-- Sublocation Destination -->
                                        <div v-if='header.showSublocationDestination && currentDocumentTypeCode != "ORIOSO"' class="col p-0 mr-1">
                                            <a-select
                                            labelInValue
                                            :value="destinationSublocation"
                                            placeholder="Select a sublocation"
                                            style="width: 100%"
                                            :filterOption="false"
                                            @dropdownVisibleChange="fetchSublocations"
                                            @change="selectDestinationSublocation"
                                            :notFoundContent="fetching ? undefined : null"
                                            :disabled='isDestinationSublocationDisabled'
                                            >
                                                <a-spin v-if="fetching" slot="notFoundContent" size="small"/>
                                                <a-select-option v-for="s in sublocations" :key="'sublocations2'+s.id.toString()">{{s.name}}</a-select-option>
                                            </a-select>
                                        </div>
                                        <div v-else-if='currentDocumentTypeCode != "ORISOX" && currentDocumentTypeCode != "OTHSRQ"' class="col p-0 mr-1">
                                            <a-select v-model='orderSource' @select="selectOrderSource" placeholder='Order Source' style="width: 100%;" input-classes="form-control" :disabled="isOrderSourceDisabled">
                                                <a-select-option v-for="s in orderSources" :key="s.toString()">{{s}}</a-select-option>
                                            </a-select>
                                        </div>
                                        <!-- Customer -->
                                        <div v-if='header.showCustomer' class="col p-0 mr-1">
                                          <a-input-group compact class="si_customer_name">
                                              <a-auto-complete 
                                              placeholder="Search customer"
                                              class="si_customer_name_input" 
                                              @select="selectCustomer"
                                              @search="fetchCustomers" 
                                              @focus="fetchCustomers" 
                                              :value="customer.label" 
                                              :filter-option="autocompleteFilterOption" 
                                              :disabled='isCustomerDisabled'>
                                                <template slot="dataSource">
                                                  <a-select-option v-for="c in customers" :key="'customers'+c.id.toString()" :text="c.name">{{c.name}}
                                                  </a-select-option>
                                                </template>
                                              </a-auto-complete>
                                        
                                              <a-button v-if="currentDocumentTypeCode != 'RECCSR' && currentDocumentTypeCode != 'ORIOCR'" class="si_customer_name_btn" @click.prevent="createCustomer()" :disabled="isCustomerCreateDisabled">
                                                <a-icon style="margin-bottom: 3px" type="plus-circle" />
                                              </a-button>
                                          </a-input-group>
                                        </div>
                                        <!-- Salesman -->
                                        <div v-if='header.showSalesman' class="col p-0 mr-1">
                                            <a-input-group compact>
                                                <a-auto-complete
                                                    style="width: 100%"
                                                    placeholder="Search salesman"
                                                    :filter-option="autocompleteFilterOption"
                                                    @select="selectSalesman"
                                                    :value="salesman.label"
                                                    @search="fetchSalesmen"
                                                    @focus="fetchSalesmen"
                                                    :disabled='isSalesmanDisabled'
                                                >
                                                    <template slot="dataSource">
                                                        <a-select-option v-for="s in salesmen" :key="'salesman'+s.id.toString()" :text="s.name">{{s.name}}</a-select-option>
                                                    </template>
                                                </a-auto-complete>
                                            </a-input-group>
                                        </div>
                                    </div>

                                    <!-- Customer Type pills (Regular/B2b) -->
                                    <div v-if='header.showCustomerType && !(orderSource === "Online Customer" && currentDocumentTypeCode === "ORIOSO")'>
                                        <div class="row mt-2" v-if="!docTypesForOM.includes(currentDocumentTypeCode) && currentDocumentTypeCode !='ORIOCR' && currentDocumentTypeCode !='RELCSI' && currentDocumentTypeCode !='RECCSI'">
                                            <div class="customer-type-selector">
                                                <h4 class="btn-blockheading-small font-weight-normal">Customer Type</h4>
                                                <span class="pill" @click="selectCustomerType('customer')" :class="{ 'selected': selectedCustomerType === 'customer' }">Customer</span>
                                                <span class="pill" @click="selectCustomerType('b2b')" :class="{ 'selected': selectedCustomerType === 'b2b' }">B2B Customer</span>
                                            </div>
                                        </div>
                                        <div class="row mt-3">
                                            <div class="col p-0 mr-1" v-if="selectedCustomerType === 'customer' && !docTypesForOM.includes(currentDocumentTypeCode) && (currentDocumentTypeCode !='RELCSI' || currentDocumentTypeCode !='RECCSI')">
                                                <h6 class="heading-small text-muted">Customer Name</h6>
                                                <a-input-group compact class="si_customer_name" v-model="selectedCustomer">
                                                    <a-auto-complete
                                                    allowClear
                                                    placeholder="Search customer"
                                                    class="si_customer_name_input"
                                                    @select="selectCustomer"
                                                    @search="fetchCustomers" 
                                                    @focus="fetchCustomers" 
                                                    :value="customer.label" 
                                                    :filter-option="autocompleteFilterOption" 
                                                    :disabled='isCustomerDisabled'>
                                                        <template slot="dataSource">
                                                            <a-select-option v-for="customer in customers" :key="'customers'+customer.id.toString()" :text="customer.name">
                                                                {{customer.name}}
                                                            </a-select-option>
                                                        </template>
                                                    </a-auto-complete>

                                                    <a-button v-if="currentDocumentTypeCode != 'RECCSR' && currentDocumentTypeCode != 'ORIOCR'" class="si_customer_name_btn" @click.prevent="createCustomer()" :disabled="isCustomerCreateDisabled">
                                                        <a-icon style="margin-bottom: 3px" type="plus-circle" />
                                                    </a-button>
                                                </a-input-group>
                                            </div>

                                            <div class="col p-0 mr-1" v-if="selectedCustomerType === 'b2b' || docTypesForOM.includes(currentDocumentTypeCode) || currentDocumentTypeCode =='RECCSR' || currentDocumentTypeCode =='OTHLIQ'">
                                                <h6 class="heading-small text-muted">Customer Name</h6>
                                                <a-input-group compact class="si_customer_name" v-model="selectedB2bCustomer">
                                                    <a-select class="si_customer_name_input" @select="selectB2bCustomer" :disabled="isCustomerDisabled" :filterOption="filterOption" showSearch v-model="b2bCustomer" style="width: 100%" @change="handleInputChange" placeholder="Select b2b customer" allowClear>
                                                        <a-select-option v-for="b2bOption in b2bCustomerOptions" :key="b2bOption.id" :value="b2bOption.id">
                                                            {{b2bOption.name}}
                                                        </a-select-option>
                                                    </a-select>
                                                </a-input-group>
                                            </div>
                                        </div>
                                    </div>

                                     <!-- Label and Input, Customer Address -->
                                    <div class="row mt-2">
                                        <div v-if='header.showCustomer' class="col p-0"><h4 class="btn-blockheading-small font-weight-normal">Customer Address</h4></div>
                                        <div v-if='header.showCustomer' class="col p-0"><h4 class="btn-blockheading-small font-weight-normal">Customer Contact</h4></div>
                                    </div>
                                    <div class="row mt-2">
                                        <div v-if='header.showCustomer' class="col p-0 mr-1">
                                            <a-input style="width: 100%" v-model='customerAddress' placeholder="Customer Address" :disabled='true'/>
                                        </div>

                                        <div v-if='header.showCustomer' class="col p-0 mr-1">
                                            <a-input-group compact>
                                                <a-select v-model="selectedCustomerContact" @select="selectCustomerContact" :disabled='isCustomerDisabled' style="width: 30%">
                                                    <a-select-option value="Telephone">Telephone</a-select-option>
                                                    <a-select-option value="Mobile">Mobile</a-select-option>
                                                    <a-select-option value="Fax">Fax</a-select-option>
                                                    <a-select-option value="Email">Email</a-select-option>
                                                </a-select>
                                                <a-input style="width: 70%" v-model='activeCustomerContact' placeholder="Customer Contact" :disabled='true'/>
                                            </a-input-group>

                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Additional Options, when header with record is Posted -->
                            <div v-if='documentStatus=="Posted" || currentDocumentTypeCode == "RECDEL"' class="row mt-2">
                                <div class="col p-0">
                                    <h6 v-if='currentDocumentTypeCode == "ORIOSO"' class="heading-small text-muted">Online Sales Order Date</h6>
                                    <h6 v-else class="heading-small text-muted">{{currentDocumentTypeFriendlyCode}} Date</h6>
                                    <a-date-picker v-model='documentDate' @change="disabledDate" placeholder="Document Date" style="width: 100%" :disabled='true'/>
                                </div>
                                <div v-if="showTargetDate" class="col p-0 mx-2">
                                    <h6 v-if='currentDocumentTypeCode == "OTHPWS"' class="heading-small text-muted">Effectivity Date</h6>
                                    <h6 v-else class="heading-small text-muted">Target Date</h6>
                                    <a-date-picker v-model='targetDate' :disabled-date="disabledDateForOtherDate" placeholder="Target Date" style="width: 100%" :disabled='true'/>
                                </div>
                                <div v-if="showCancellationDate && currentDocumentTypeCode != 'ORISOX' && currentDocumentTypeCode != 'OTHSRQ'" class="col p-0">
                                    <h6 class="heading-small text-muted">Cancellation Date</h6>
                                    <a-date-picker v-model='cancellationDate' :disabled-date="disabledDateForOtherDate" placeholder="Cancellation Date" style="width: 100%" :disabled='true'/>
                                </div>
                            </div>

                            <div v-if="currentDocumentTypeCode == 'ORIOSO'" class="row mt-3">
                                <div class="col filter_separator">
                                    <div class="row"><h4 class="btn-blockheading-small font-weight-normal">Country of Origin</h4></div>
                                    <div class="row mt-2" @mouseenter="clearCountry" @mouseleave="clearCountry">
                                        <a-auto-complete
                                            style="width: 100%"
                                            placeholder="Country of Origin"
                                            :filter-option="filterOption"
                                            @select="onChangeCountry"
                                            v-model="countryOfOrigin.label"
                                            :disabled='isCountryOfOriginDisabled'
                                            allowClear
                                        >
                                            <template slot="dataSource">
                                                <a-select-option v-for="s in countryOfOriginOptions" :key="'country'+s.id.toString()" :text="s.name">{{s.name}}</a-select-option>
                                            </template>
                                        </a-auto-complete>
                                    </div>
                                </div>
                            </div>

                            <!-- Additional Fields in the Document -->
                            <div v-if="docTypesForP2P.includes(currentDocumentTypeCode) || (docTypesForOMGT.includes(currentDocumentTypeCode) && currentDocumentTypeCode !== 'ORIOSO')">
                                <div class="row mt-3">
                                    <div class="col filter_separator">
                                        <h6 class="heading-small text-muted">Order Type</h6>
                                        <a-select :disabled='isOrderTypeDisabled' style="width: 100%" @change="handleInputChange" v-model="orderType" placeholder="Order Type">
                                            <a-select-option v-for="option in orderTypeOptions" v-bind:key="option.key">{{option.value}}</a-select-option>
                                        </a-select>
                                    </div>
                                    <div class="col filter_separator" @mouseenter="clearCountry" @mouseleave="clearCountry">
                                        <h6 class="heading-small text-muted">Country Of Origin</h6>
                                        <a-auto-complete
                                            style="width: 100%"
                                            placeholder="Country of Origin"
                                            :filter-option="filterOption"
                                            @select="onChangeCountry"
                                            v-model="countryOfOrigin.label"
                                            :disabled='isCountryOfOriginDisabled'
                                            allowClear
                                        >
                                            <template slot="dataSource">
                                                <a-select-option v-for="s in countryOfOriginOptions" :key="'country'+s.id.toString()" :text="s.name" :code="s.code">{{s.name}}</a-select-option>
                                            </template>
                                        </a-auto-complete>
                                    </div>
                                    <div class="col filter_separator">
                                        <h6 class="heading-small text-muted">Fiscal Year</h6>
                                        <a-select :disabled='isFiscalYearDisabled' style="width: 100%" @change="handleInputChange" v-model="fiscalYear" placeholder="Fiscal Year">
                                            <a-select-option v-for="option in fiscalYearOptions" v-bind:key="option.key">{{option.value}}</a-select-option>
                                        </a-select>
                                    </div>
                                    <div class="col filter_separator">
                                        <h6 class="heading-small text-muted">Year Season</h6>
                                        <div class="input-group mb-3">
                                            <a-input style="width: 100%" :disabled='isYearSeasonDisabled' @change="handleInputChange" v-model="yearSeason" placeholder="Year Season"/>
                                        </div>
                                    </div>
                                    <div class="col filter_separator">
                                        <h6 class="heading-small text-muted">No. of Cartons</h6>
                                        <div class="input-group mb-3">
                                            <a-input style="width: 100%" :disabled='isNoOfCartonsDisabled' @change="handleInputChange" v-model="noOfCartons" placeholder="No. of Cartons"/>
                                        </div>
                                    </div>
                                    <div class="col filter_separator" v-if="this.currentDocumentTypeCode=='ORISOX' || this.currentDocumentTypeCode=='OTHSRQ' || this.currentDocumentTypeCode=='OTHSIN'">
                                        <h6 class="heading-small text-muted">Purpose</h6>
                                        <a-select
                                            labelInValue
                                            :value="purpose"
                                            placeholder="Select purpose"
                                            style="width: 100%"
                                            :filterOption="false"
                                            @dropdownVisibleChange="fetchPurposes"
                                            @change="selectPurpose"
                                            :disabled="isPurposeDisabled"
                                            :dataSource="fetchPurposes"
                                        >
                                            <a-select-option v-for="s in purposes" :key="'purposes' + s.id.toString()">
                                                {{ s.name }}
                                            </a-select-option>
                                        </a-select>
                                    </div>
                                </div>
                            </div>
                            <div v-if="this.currentDocumentTypeCode=='RECADJ' || this.currentDocumentTypeCode=='RELADJ'">
                                <div class="row mt-3">
                                    <div class="col filter_separator p-1">
                                        <h6 class="heading-small text-muted">Purpose</h6>
                                        <a-select
                                            labelInValue
                                            :value="purpose"
                                            placeholder="Select purpose"
                                            style="width: 100%"
                                            :filterOption="false"
                                            @dropdownVisibleChange="fetchPurposes"
                                            @change="selectPurpose"
                                            :disabled="isPurposeDisabled"
                                            :dataSource="fetchPurposes"
                                        >
                                            <a-select-option v-for="s in purposes" :key="'purposes' + s.id.toString()">
                                                {{ s.name }}
                                            </a-select-option>
                                        </a-select>
                                    </div>
                                </div>
                            </div>
                            <div v-if="docTypesForTransDoc.includes(currentDocumentTypeCode)" class="row mt-3">
                                <div v-if='header.showSublocationOrigin && !header.showSublocationHeader' class="col">
                                    <div class="row">
                                        <div class="col pl-1 pr-1"><h4 class="btn-blockheading-small font-weight-normal">{{sublocationOriginLabel}}</h4></div>
                                    </div>
                                    <div class="row">
                                        <div class="col mt-2 pl-1 pr-0">
                                            <a-select
                                            labelInValue
                                            :value="originSublocation"
                                            placeholder="Select a sublocation"
                                            style="width: 100%"
                                            :filterOption="false"
                                            @dropdownVisibleChange="fetchSublocations"
                                            @change="selectOriginSublocation"
                                            :notFoundContent="fetching ? undefined : null"
                                            :disabled='isOriginSublocationDisabled'
                                            >
                                                <a-spin v-if="fetching" slot="notFoundContent" size="small"/>
                                                <a-select-option v-for="s in sublocations" :key="'sublocations1'+s.id.toString()">{{s.name}}</a-select-option>
                                            </a-select>
                                        </div>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="row"><h4 class="btn-blockheading-small font-weight-normal">Company</h4></div>
                                    <div class="row mt-2 pr-1">
                                        <a-select :disabled='true' v-model="company" optionFilterProp="children" class="col pl-1 pr-0" @change="fetchCompanyBasedOnSupplyingSite" placeholder="Company">
                                            <a-select-option v-if="site && site.company" :value="site.company.id">{{ site.company.id }}</a-select-option>
                                        </a-select>
                                    </div>
                                </div>
                                <div class="col" v-if="['OTHLIQ'].includes(currentDocumentTypeCode)">
                                    <div class="row"><h4 class="btn-blockheading-small font-weight-normal">Liquidation Period [Month/Year]</h4></div>
                                    <div class="row mt-2 pr-1">
                                        <a-input style="width: 100%" :disabled='true' v-model="liqPeriod" placeholder="Liquidation Period"/>
                                    </div>
                                </div>
                            </div>

                            <div class="row" v-if="this.currentDocumentTypeCode == 'OTHLIQ'">
                                <div class="col filter_separator">
                                    <h6 class="heading-small text-muted">Customer Name</h6>
                                    <div class="input-group mb-3">
                                        <a-input-group compact class="si_customer_name" v-model="selectedB2bCustomer">
                                            <a-select class="si_customer_name_input" @select="selectB2bCustomer" disabled :filterOption="filterOption" showSearch v-model="b2bCustomer" style="width: 100%" @change="handleInputChange" placeholder="Select b2b customer" allowClear>
                                                <a-select-option v-for="b2bOption in b2bCustomerOptions" :key="b2bOption.id" :value="b2bOption.id">
                                                    {{b2bOption.name}}
                                                </a-select-option>
                                            </a-select>
                                        </a-input-group>
                                    </div>
                                </div>
                                <div class="col filter_separator">
                                    <h6 class="heading-small text-muted">Customer Address</h6>
                                    <div class="input-group mb-3">
                                        <a-input style="width: 100%" v-model='customerAddress' placeholder="Customer Address" :disabled='true'/>
                                    </div>
                                </div>
                                <div class="col filter_separator">
                                    <h6 class="heading-small text-muted">Customer Contact</h6>
                                    <div class="input-group mb-3">
                                        <a-input style="width: 100%" v-model='activeCustomerContact' placeholder="Customer Contact" :disabled='true'/>
                                    </div>
                                </div>
                            </div>            
                            <div class="row" v-if="docTypesForOM.includes(currentDocumentTypeCode) || docTypesForIM.includes(currentDocumentTypeCode) || this.currentDocumentTypeCode == 'OTHSBI'">
                                <div class="col filter_separator" v-if="docTypesForIM.includes(currentDocumentTypeCode) || this.currentDocumentTypeCode == 'OTHSBI'">
                                    <h6 class="heading-small text-muted">Supplier Vat Type</h6>
                                    <div class="input-group mb-3">
                                        <a-input style="width: 100%" disabled :value="supplierVatType" placeholder="Supplier Vat Type"/>
                                    </div>
                                </div>
                                <div class="col filter_separator" v-if="docTypesForIM.includes(currentDocumentTypeCode) || this.currentDocumentTypeCode == 'OTHSBI'">
                                    <h6 class="heading-small text-muted">Supplier Currency</h6>
                                    <div class="input-group mb-3">
                                        <a-input style="width: 100%" disabled :value="supplierCurrencyName" placeholder="Supplier Currency"/>
                                    </div>
                                </div>
                                <div class="col filter_separator" v-if="docTypesForOM.includes(currentDocumentTypeCode)">
                                    <h6 class="heading-small text-muted">Customer Vat Type</h6>
                                    <div class="input-group mb-3">
                                        <a-input style="width: 100%" disabled :value="customerVatType" placeholder="Customer Vat Type"/>
                                    </div>
                                </div>
                                <div class="col filter_separator">
                                    <h6 class="heading-small text-muted">Payment Terms</h6>
                                    <a-select
                                            labelInValue
                                            :value="paymentTerm"
                                            placeholder="Select a payment term"
                                            style="width: 100%"
                                            :filterOption="false"
                                            @dropdownVisibleChange="fetchPaymentTerms"
                                            @change="selectPaymentTerm"
                                            :notFoundContent="fetching ? undefined : null"
                                            :disabled='isPaymentTermDisabled'
                                            :allowClear='true'
                                        >
                                        <a-spin v-if="fetching" slot="notFoundContent" size="small"/>
                                        <a-select-option v-for="s in paymentTerms" :key="'paymentTerms'+s.id.toString()">{{s.name}}</a-select-option>
                                    </a-select>
                                </div>
                                <div class="col filter_separator">
                                    <h6 class="heading-small text-muted">WTax Code</h6>
                                    <a-select
                                            labelInValue
                                            :value="wTax"
                                            placeholder="Select a wtax code"
                                            style="width: 100%"
                                            :filterOption="false"
                                            @dropdownVisibleChange="fetchWtaxes"
                                            @change="selectWtax"
                                            :notFoundContent="fetching ? undefined : null"
                                            :disabled='isWTaxDisabled'
                                            :allowClear='true'
                                        >
                                        <a-spin v-if="fetching" slot="notFoundContent" size="small"/>
                                        <a-select-option v-for="option in wtaxCodes" :key="option.w_tax_code">{{option.w_tax_code}} - {{parseFloat(option.percentage * 100).toFixed(2)}}%</a-select-option>
                                    </a-select>
                                </div>
                            </div>
                            <div v-if="docTypesForP2P.includes(currentDocumentTypeCode) || currentDocumentTypeCode == 'ORISOX' || currentDocumentTypeCode == 'OTHSRQ'">
                                <div class="row">
                                    <div class="col filter_separator">
                                        <h4 class="btn-blockheading-small font-weight-normal">Ship To Address</h4>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col filter_separator input-group mt-2 mb-2">
                                        <h4 class="heading-small text-muted">Address</h4>
                                        <a-input style="width: 100%" :disabled='true' @change="handleInputChange" v-model="address" placeholder="Address"/>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col filter_separator input-group mb-3">
                                        <h6 class="heading-small text-muted">Country</h6>
                                        <a-input style="width: 100%" :disabled='true' @change="handleInputChange" v-model="country" placeholder="Country"/>
                                    </div>
                                    <div class="col filter_separator input-group mb-3">
                                        <h6 class="heading-small text-muted">Province</h6>
                                        <a-input style="width: 100%" :disabled='true' @change="handleInputChange" v-model="province" placeholder="Province"/>
                                    </div>
                                    <div class="col filter_separator input-group mb-3">
                                        <h6 class="heading-small text-muted">City</h6>
                                        <a-input style="width: 100%" :disabled='true' @change="handleInputChange" v-model="city" placeholder="City"/>
                                    </div>
                                    <div class="col filter_separator input-group mb-3">
                                        <h6 class="heading-small text-muted">Barangay</h6>
                                        <a-input style="width: 100%" :disabled='true' @change="handleInputChange" v-model="barangay" placeholder="Barangay"/>
                                    </div>
                                    <div class="col filter_separator input-group mb-3">
                                        <h6 class="heading-small text-muted">Zip Code</h6>
                                        <a-input style="width: 100%" :disabled='true' @change="handleInputChange" v-model="zipCode" placeholder="Zip Code"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Body -->
            <div v-if='isHeaderOnly == false'>
                <div v-if='showDocumentBodyHeader'>
                    <div v-if="documentStatus=='Saved' || documentStatus=='Upload Error'" class='mt-4'>
                        <base-dropdown class='' hidden>
                            <base-button slot="title" type="danger" class="dropdown-toggle btn-sm">
                                {{productFormMode}} Product
                            </base-button>
                            <a v-for="productFormMode in productFormModeOptions" :key="'productFormModeOptions'+productFormMode.value" :value="productFormMode.value" class="dropdown-item" href="#" @click.prevent="changeProductFormMode(productFormMode.value)">{{productFormMode.label}}</a>
                        </base-dropdown>
                    </div>
                    <div v-else>
                            <h3 class='font-weight-bold mt-4'>{{productFormMode}} Products</h3>
                    </div>
                </div>
                <div v-else>
                    <h3 v-if="currentDocumentTypeCode=='OTHCNS'" class='font-weight-bold mt-4'>Physical Documents </h3>
                    <h3 v-else class='font-weight-bold mt-4'>Products </h3>
                </div>

                <div class="row mt-2">
                    <div class="col">
                        <div class="card shadow">
                            <div v-if='showDocumentBodyHeader'>
                                <div v-if='productFormMode=="Add" && !HideDeleteAndAddProductButton' class="card-body" style="background: #FAFAFA; border: 1px solid #E0E0E0;">
                                    <div class="row mb-2">
                                        <div class="col-auto">
                                            <base-dropdown  v-model="formattedsearchFilter" >
                                                <base-button slot="title" type="primary" class="dropdown-toggle">{{_.startCase(formattedsearchFilter)}}</base-button>
                                                <a class="dropdown-item" @click.prevent="changeSearchFilter('barcode')">Barcode</a>
                                                <a class="dropdown-item" @click.prevent="changeSearchFilter('name')">Name</a>
                                                <a class="dropdown-item" @click.prevent="changeSearchFilter('stock_no')">Stock</a>
                                                <!-- <a class="dropdown-item" @click.prevent="changeSearchFilter('code')">Code</a> -->
                                                <a class="dropdown-item" @click.prevent="changeSearchFilter('reference_code')">Reference Code</a>
                                            </base-dropdown>
                                        </div>
                                        <div class="col-5">
                                            <!-- <form v-on:submit.prevent="onEnterScanner"> -->
                                              <!-- bryan -->
                                                <autocomplete
                                                    ref="autocomplete"
                                                    :placeholder="placeholder"
                                                    :source="productEndpoint"
                                                    input-class="form-control"
                                                    :resultsFormatter='filterExistingProducts'
                                                    results-property="data"
                                                    :results-display="formattedDisplay"
                                                    :request-headers="authHeaders"
                                                    @selected="getProduct"
                                                    @clear="clearProduct"
                                                    :disableInput='isProductSearchDisabled'
                                                    v-on:keyup.native.enter="onEnterScanner">
                                                </autocomplete>
                                            <!-- </form> -->
                                        </div>

                                        <div class="col">
                                            <a-input addonBefore="Product Name" size="large" v-model="productName" :disabled='isProductNameDisabled' :maxLength="Number(100)" />
                                        </div>
                                        <div v-if='showFilteredBySupplier' class="col-auto pt-2 float-right">
                                            <a-checkbox :v-model='filteredBySupplier' @change='filteredBySupplierChange'>Filtered by supplier</a-checkbox>
                                        </div>
                                    </div>
                                    <div class="row pt-2">
                                        <div v-if='showQuantity' class="col">
                                            <h6 class="heading-small text-muted text-nowrap">Quantity</h6>
                                            <a-input v-model='quantity' :maxLength="Number(8)" onkeypress='return event.charCode >= 46 && event.charCode <= 57' @change="calculateSelectedProduct" input-classes="form-control" :disabled="isDocumentLineFormDisabled"/>
                                        </div>
                                        <div v-if='showActualYield' class="col">
                                            <a-tooltip>
                                                <template slot="title">
                                                    Tolerance Quantity: {{tolerance_quantity}}
                                                </template>
                                                <h6 class="heading-small text-muted text-nowrap">Actual Yield Quantity</h6>
                                                <a-input v-model='actual_yield' :maxLength="Number(8)" onkeypress='return event.charCode >= 46 && event.charCode <= 57' input-classes="form-control" :disabled="isDocumentLineFormDisabled"/>
                                            </a-tooltip>
                                        </div>
                                        <div class="col">
                                            <h6 class="heading-small text-muted text-nowrap">Unit</h6>
                                            <a-select
                                                labelInValue
                                                :value="productComposition"
                                                style="width: 100%;"
                                                :filterOption="false"
                                                @dropdownVisibleChange="fetchProductCompositions"
                                                @change="selectProductComposition"
                                                :notFoundContent="fetching ? undefined : null"
                                                :disabled="isDocumentLineFormDisabled"
                                            >
                                                <a-spin v-if="fetching" slot="notFoundContent" size="small"/>
                                                <a-select-option v-for="s in productCompositions" :key="'productCompositions'+s.key.toString()">{{s.label}}</a-select-option>
                                            </a-select>
                                        </div>

                                        <template v-if='showPwsCosts'>
                                            <div class="col">
                                                <h6 class="heading-small text-muted text-nowrap">Old Ordering</h6>
                                                <a-input min='0' v-model='oldOrdering' :maxLength="Number(8)" :type="costInputTypeAccessRights()" onkeypress='return event.charCode >= 46 && event.charCode <= 57' input-classes="form-control" :disabled="true"/>
                                            </div>
                                            <div class="col">
                                                <h6 class="heading-small text-muted text-nowrap">Old Landed</h6>
                                                <a-input min='0' v-model='oldLanded' :maxLength="Number(8)" :type="costInputTypeAccessRights()" onkeypress='return event.charCode >= 46 && event.charCode <= 57' input-classes="form-control" :disabled="true"/>
                                            </div>
                                            <div class="col">
                                                <h6 class="heading-small text-muted text-nowrap">Old Price</h6>
                                                <a-input min='0' v-model='oldRetailPrice' :maxLength="Number(8)" :type="priceInputTypeAccessRights()" onkeypress='return event.charCode >= 46 && event.charCode <= 57' input-classes="form-control" :disabled="true"/>
                                            </div>
                                            <div class="col">
                                                <h6 class="heading-small text-muted text-nowrap">Old Special Price</h6>
                                                <a-input min='0' v-model='oldSpecialPrice' :maxLength="Number(8)" :type="priceInputTypeAccessRights()" onkeypress='return event.charCode >= 46 && event.charCode <= 57' input-classes="form-control" :disabled="true"/>
                                            </div>
                                            <div class="col">
                                                <h6 class="heading-small text-muted text-nowrap">Old Wholesale Price</h6>
                                                <a-input min='0' v-model='oldWholesalePrice' :maxLength="Number(8)" :type="priceInputTypeAccessRights()" onkeypress='return event.charCode >= 46 && event.charCode <= 57' input-classes="form-control" :disabled="true"/>
                                            </div>
                                            <div class="col">
                                                <h6 class="heading-small text-muted text-nowrap">New Ordering</h6>
                                                <a-input min='0' v-model='newOrdering' :maxLength="Number(8)" :type="costInputTypeAccessRights()" onkeypress='return event.charCode >= 46 && event.charCode <= 57' input-classes="form-control" :disabled="isDocumentLineFormDisabled || isPriceCostDisabled"/>
                                            </div>
                                            <div class="col">
                                                <h6 class="heading-small text-muted text-nowrap">New Landed</h6>
                                                <a-input min='0' v-model='newLanded' :maxLength="Number(8)" :type="costInputTypeAccessRights()" onkeypress='return event.charCode >= 46 && event.charCode <= 57' input-classes="form-control" @change="calculatePwsCosts('newLanded')" :disabled="isDocumentLineFormDisabled  || disableCostAccessRightsValidation() || isPriceCostDisabled || !accessPWSCost || oldLanded != 0 || withRR"/>
                                            </div>
                                            <div class="col">
                                                <h6 class="heading-small text-muted text-nowrap">New Price</h6>
                                                <a-input min='0' v-model='newRetailPrice' :maxLength="Number(8)" :type="priceInputTypeAccessRights()" onkeypress='return event.charCode >= 46 && event.charCode <= 57' input-classes="form-control" @change="calculatePwsCosts('newPrice')" :disabled="isDocumentLineFormDisabled  || disablePriceAccessRightsValidation() || isPriceCostDisabled || !accessPWSPrice"/>
                                            </div>
                                            <div class="col">
                                                <h6 class="heading-small text-muted text-nowrap">New Special Price</h6>
                                                <a-input min='0' v-model='newSpecialPrice' :maxLength="Number(8)" :type="priceInputTypeAccessRights()" onkeypress='return event.charCode >= 46 && event.charCode <= 57' input-classes="form-control" :disabled="isDocumentLineFormDisabled  || disablePriceAccessRightsValidation() || isPriceCostDisabled || !accessPWSPrice"/>
                                            </div>
                                            <div class="col">
                                                <h6 class="heading-small text-muted text-nowrap">New Wholesale Price</h6>
                                                <a-input min='0' v-model='newWholesalePrice' :maxLength="Number(8)" :type="priceInputTypeAccessRights()" onkeypress='return event.charCode >= 46 && event.charCode <= 57' input-classes="form-control" :disabled="isDocumentLineFormDisabled  || disablePriceAccessRightsValidation() || isPriceCostDisabled || !accessPWSPrice"/>
                                            </div>
                                            <div class="col">
                                                <h6 class="heading-small text-muted text-nowrap">Mark Up %</h6>
                                                <a-input min='0' v-model='markUp' :maxLength="Number(8)" onkeypress='return event.charCode >= 46 && event.charCode <= 57' input-classes="form-control" @change="calculatePwsCosts('markUp')" :disabled="isDocumentLineFormDisabled || isPriceCostDisabled"/>
                                            </div>
                                        </template>
                                        
                                        <template v-if="accountName.toLowerCase().includes('piml') && showPwsCosts">
                                        <div class="row" style="margin-left:1px;">
                                            <div class="col">
                                                <h6 class="heading-small text-muted text-nowrap">Old PIML Price1</h6>
                                                <a-input min='0' v-model='oldPimlPrice1' :maxLength="Number(8)" :type="costInputTypeAccessRights()" onkeypress='return event.charCode >= 46 && event.charCode <= 57' input-classes="form-control" :disabled="true"/>
                                            </div>
                                            <div class="col">
                                                <h6 class="heading-small text-muted text-nowrap">Old PIML Price2</h6>
                                                <a-input min='0' v-model='oldPimlPrice2' :maxLength="Number(8)" :type="priceInputTypeAccessRights()" onkeypress='return event.charCode >= 46 && event.charCode <= 57' input-classes="form-control" :disabled="true"/>
                                            </div>
                                            <div class="col">
                                                <h6 class="heading-small text-muted text-nowrap">Old PIML Price3</h6>
                                                <a-input min='0' v-model='oldPimlPrice3' :maxLength="Number(8)" :type="priceInputTypeAccessRights()" onkeypress='return event.charCode >= 46 && event.charCode <= 57' input-classes="form-control" :disabled="true"/>
                                            </div>
                                            <div class="col">
                                                <h6 class="heading-small text-muted text-nowrap">New PIML Price1</h6>
                                                <a-input min='0' v-model='newPimlPrice1' :maxLength="Number(8)" :type="priceInputTypeAccessRights()" onkeypress='return event.charCode >= 46 && event.charCode <= 57' input-classes="form-control" :disabled="isDocumentLineFormDisabled  || disablePriceAccessRightsValidation() || isPriceCostDisabled || !accessPWSPrice"/>
                                            </div>
                                            <div class="col">
                                                <h6 class="heading-small text-muted text-nowrap">New PIML Price2</h6>
                                                <a-input min='0' v-model='newPimlPrice2' :maxLength="Number(8)" :type="priceInputTypeAccessRights()" onkeypress='return event.charCode >= 46 && event.charCode <= 57' input-classes="form-control" :disabled="isDocumentLineFormDisabled  || disablePriceAccessRightsValidation() || isPriceCostDisabled || !accessPWSPrice"/>
                                            </div>
                                            <div class="col">
                                                <h6 class="heading-small text-muted text-nowrap">New PIML Price3</h6>
                                                <a-input min='0' v-model='newPimlPrice3' :maxLength="Number(8)" :type="priceInputTypeAccessRights()" onkeypress='return event.charCode >= 46 && event.charCode <= 57' input-classes="form-control" :disabled="isDocumentLineFormDisabled  || disablePriceAccessRightsValidation() || isPriceCostDisabled || !accessPWSPrice"/>
                                            </div>
                                        </div>
                                        </template>

                                        <div v-if='showUnitCost' class="col">
                                            <h6 v-if="productPriceChoice.includes('piml')" class="heading-small text-muted text-nowrap">{{((productPriceChoice.split('_').toString()).replace(",", " ")).replace(",", " ")}}</h6>
                                            <h6 v-else class="heading-small text-muted text-nowrap">{{productPriceChoice.split('_').pop()}}</h6>
                                            <a-input min='0' v-model='unitCost' :maxLength="Number(8)" onkeypress='return event.charCode >= 46 && event.charCode <= 57' input-classes="form-control" @change="calculateCost" :disabled="isUnitCostDisabled() || accessRightsDisableValidation() || isPriceCostDisabled" :type="accessRightsInputTypeValidation()"/>
                                        </div>
                                        <div v-if='showDiscount' class="col">
                                            <h6 class="heading-small text-muted text-nowrap">Discount</h6>
                                            <a-select mode="tags" :maxTagCount='2'  maxTagPlaceholder='...' v-model='discountText' style="width: 100%;" @change="calculateSelectedProduct" input-classes="form-control" :disabled="isDocumentLineFormDisabled || currentDocumentTypeCode == 'RELTRX'"></a-select>
                                        </div>
                                        <div v-if='showUnitNetCost' class="col">
                                            <h6 class="heading-small text-muted text-nowrap">Unit Net Cost</h6>
                                            <a-input v-model='unitNetCost' :type="accessRightsInputTypeValidation()" input-classes="form-control" disabled/>
                                        </div>
                                        <div v-if='showSubtotal' class="col d-flex align-items-end" style="border-left: 1px solid #E0E0E0;">
                                            <span class="mr-auto font-weight-bold h3 ">Subtotal: {{this.accessRightsMaskValidation(subTotal)}}</span>
                                        </div>

                                        <div class="col d-flex align-items-end" v-if="selectedDocumentLines && selectedDocumentLines.length > 0 && productName == ''">
                                            <base-dropdown v-if="selectedDocumentLines.length == 1" class="nav-link pr-2 float-right" position="right">
                                                <div class="media align-items-center" slot="title">
                                                    <i class="fa fa-ellipsis-v float-right ml-2 btn-sm" style='color: black;'></i>
                                                </div>
                                                <template>
                                                    <div class="dropdown-header noti-title">
                                                        <h6 class="text-overflow m-0">ACTIONS</h6>
                                                    </div>
                                                    <div class="dropdown-item" @click.prevent="showStockCard(selectedDocumentLines)">
                                                         <i class="fas fa-layer-group"></i>
                                                        <span>View Stock Card</span>
                                                    </div>
                                                    <div v-if="selectedDocumentLines[0].product_type == 'S'" class="dropdown-item" @click.prevent="showSerialization(selectedDocumentLines)">
                                                        <i class="fas fa-layer-group"></i>
                                                        <span>Enter/View Serial Number</span>
                                                    </div>
                                                    <div v-if='allowSublocationAllocation' class="dropdown-item" @click.prevent="showSublocationAllocation(selectedDocumentLines)">
                                                        <i class="fas fa-stream"></i>
                                                        <span>Sublocation Allocation</span>
                                                    </div>
                                                    <div v-if='allowSiteAllocation' class="dropdown-item" @click.prevent="showSiteAllocation(selectedDocumentLines)">
                                                        <i class="fas fa-stream"></i>
                                                        <span>Site Allocation</span>
                                                    </div>
                                                    <div v-if="selectedDocumentLines.length > 0 && selectedDocumentLines[0].is_require_lotcode" class="dropdown-item" @click.prevent="showLotCodeExpiry(selectedDocumentLines)">
                                                        <i class="fas fa-hourglass-end"></i>
                                                        <span>Lot Code and Expiry</span>
                                                    </div>
                                                    <div class="dropdown-item" @click.prevent="duplicateDocumentLines" v-if="documentStatus!='Confirmed' && documentStatus!='Posted' &&  documentStatus!='Voided'">
                                                        <i class="fas fa-regular fa-copy"></i>
                                                       <span>Duplicate Line</span>
                                                   </div>
                                                </template>
                                            </base-dropdown>
                                            <button type="button" v-if="this.currentDocumentTypeCode!='RECTRX'" class="btn btn-danger btn-block align-bottom" @click="mass_delete_line()" >Delete</button>
                                        </div>
                                        <div class="col d-flex align-items-end" v-else>
                                            <a-popconfirm
                                                title="Input quantity is more than the available quantity, do you want to proceed?"
                                                :visible="addProductConfirmationVisible"
                                                ok-text="Yes"
                                                cancel-text="Cancel"
                                                @visibleChange="handleAddProductVisibleChange"
                                                @confirm="addProduct(0)"
                                                @cancel="addProductCancel"
                                                :disabled="isDocumentLineFormDisabled"
                                            >
                                                <a type="button" class="btn btn-primary btn-block align-bottom text-white mt-2">+ Add Products</a>
                                            </a-popconfirm>
                                        </div>
                                    </div>

                                    <div v-if="rewardCode != null" class="row mt-3">
                                        <div class="col-auto float-right">
                                            <small><span class="fa fa-info-circle text-blue"/> &nbsp; Promo Applied - {{promoName}} ({{rewardCode}})</small>
                                        </div>
                                    </div>

                                </div>
                                <div v-else class="card-body" style="background: #FAFAFA; border: 1px solid #E0E0E0;">
                                    <div class="row">
                                        <div class="col">
                                            <a-input-search size='large' v-on:keyup="searchProducts" @search="searchProducts" :placeholder="placeholder" v-model='productSearchInput'>
                                                <a-select slot="addonBefore" defaultValue="Barcode" @select="changeSearchFilter">
                                                    <a-select-option value='barcode'>Barcode</a-select-option>
                                                    <a-select-option value='product_name'>Name</a-select-option>
                                                    <a-select-option value='stock_no'>Stock No</a-select-option>
                                                    <a-select-option value='ref_code'>Ref Code</a-select-option>
                                                    <!-- <a-select-option value='product_id'>Code</a-select-option> -->
                                                </a-select>
                                            </a-input-search>
                                        </div>

                                        <div class="col-auto d-flex align-items-end justify-content-end p-0" >
                                            <base-dropdown  class="nav-link pr-2 float-right" position="right">
                                                <div class="media align-items-center" slot="title">
                                                <i class="fa fa-ellipsis-v float-right btn-sm" style='color: black;'></i>
                                                </div>
                                                <template>
                                                    <div class="dropdown-header noti-title">
                                                        <h6 class="text-overflow m-0">ACTIONS</h6>
                                                    </div>
                                                    <a v-if="selectedDocumentLines.length == 1" class="dropdown-item" @click.prevent="showStockCard(selectedDocumentLines)">
                                                        <i class="fas fa-layer-group"></i>
                                                        <span>View Stock Card</span>
                                                    </a>
                                                    <a v-if="selectedDocumentLines.length == 1 && selectedDocumentLines[0].product_type == 'S'" class="dropdown-item" @click.prevent="showSerialization(selectedDocumentLines)">
                                                        <i class="fas fa-layer-group"></i>
                                                        <span>Enter/View Serial Number</span>
                                                    </a>
                                                    <a v-if='allowSublocationAllocation && selectedDocumentLines.length == 1' class="dropdown-item" @click.prevent="showSublocationAllocation(selectedDocumentLines)">
                                                        <i class="fas fa-stream"></i>
                                                        <span>Sublocation Allocation</span>
                                                    </a>
                                                    <div v-if='allowSiteAllocation && selectedDocumentLines.length == 1' class="dropdown-item" @click.prevent="showSiteAllocation(selectedDocumentLines)">
                                                        <i class="fas fa-stream"></i>
                                                        <span>Site Allocation</span>
                                                    </div>
                                                    <a v-if="(((documentStatus=='Saved' || documentStatus=='Upload Error' || documentStatus=='Upload terminated') && productFormMode == 'Add') || documentStatus == null) && (currentDocumentTypeCode=='OTHTRA' || currentDocumentTypeCode=='OTHPCK')" class="dropdown-item" @click.prevent="showDrawer('massAddWithAllocation')">
                                                        <i class="fa fa-upload"></i>
                                                        <span>Import With Allocation</span>
                                                    </a>
                                                    <a class="dropdown-item d-none" @click="exportCsvDocument()">
                                                        <i class="fas fa-file-csv"></i>
                                                        <span>Export CSV</span>
                                                    </a>
                                                    <a class="dropdown-item" @click="exportExcelDocument()">
                                                        <i class="fas fa-file-excel"></i>
                                                        <span>Export Excel Sheet</span>
                                                    </a>
                                                    <a class="dropdown-item" v-if="this.currentDocumentTypeCode=='RELCSI' || this.currentDocumentTypeCode=='ORIPOX' || this.currentDocumentTypeCode=='OTHPUR' || this.currentDocumentTypeCode=='ORISOX'" @click="exportCsvWithHeaderDocument()">
                                                        <i class="fas fa-file-csv"></i>
                                                        <span>Export CSV With Header Details</span>
                                                    </a>
                                                    <a class="dropdown-item" @click="exportWithAllocationDocument()">
                                                        <i class="fas fa-file-excel"></i>
                                                        <span>Export With Allocation</span>
                                                    </a>
                                                    <a class="dropdown-item" @click="showCustomizeListDrawer()">
                                                        <i class="fas fa-bars"></i>
                                                        <span>Customize List</span>
                                                    </a>
                                                    <a class="dropdown-item" @click="showSortDrawer()">
                                                        <i class="fas fa-sort"></i>
                                                        <span>Sort</span>
                                                    </a>
                                                    <a v-if="documentStatus!='Fulfilled' || documentStatus!='Voided'" class="dropdown-item" @click="refreshInventory()">
                                                        <i class="fas fa-sync-alt"></i>
                                                        <span>Refresh Inventory</span>
                                                    </a>
                                                    <a v-if="selectedDocumentLines.length > 0 && selectedDocumentLines[0].is_require_lotcode" class="dropdown-item" @click.prevent="showLotCodeExpiry(selectedDocumentLines)">
                                                        <i class="fas fa-hourglass-end"></i>
                                                        <span>Lot Code and Expiry</span>
                                                    </a>
                                                    <div class="dropdown-item" @click.prevent="duplicateDocumentLines" v-if="documentStatus!='Confirmed' && documentStatus!='Posted' &&  documentStatus!='Voided'">
                                                        <i class="fas fa-regular fa-copy"></i>
                                                       <span>Duplicate Line</span>
                                                   </div>
                                                </template>
                                            </base-dropdown>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="currentDocumentTypeCode=='OTHCNS' && documentStatus!='Posted' &&  documentStatus!='Voided'" class="card-body" style="background: #FAFAFA; border: 1px solid #E0E0E0;">
                                <div class="row mb-2">
                                    <div class="col-auto">
                                        <base-dropdown  v-model="formattedsearchFilter" >
                                            <base-button slot="title" type="primary" class="dropdown-toggle">{{_.startCase(formattedsearchFilter)}}</base-button>
                                            <a class="dropdown-item" @click.prevent="changeSearchFilter('document_no')">Document No</a>
                                            <a class="dropdown-item" @click.prevent="changeSearchFilter('document_id')">Document ID</a>
                                        </base-dropdown>
                                    </div>
                                    <div class="col-4">
                                        <autocomplete
                                            ref="autocomplete"
                                            :placeholder="placeholder"
                                            :source="documentEndpoint"
                                            input-class="form-control"
                                            :resultsFormatter='filterExistingDocuments'
                                            results-property="data"
                                            :results-display="formattedDocumentDisplay"
                                            :request-headers="authHeaders"
                                            @selected="getDocument"
                                            @clear="clearDocument">
                                        </autocomplete>
                                    </div>
                                    <div class="col">
                                        <a-input addonBefore="Document ID" size="large" v-model="documentID" :disabled='isProductNameDisabled' :maxLength="Number(100)" />
                                    </div>
                                    <div class="col-auto" v-if="selectedDocumentLines && selectedDocumentLines.length > 0 && this.currentDocumentTypeCode!='RECTRX'">
                                        <button type="button" class="btn btn-danger btn-block align-bottom" @click="mass_delete_document_line()" >Delete</button>
                                    </div>
                                    <div class="col-auto" v-else>
                                        <a-popconfirm
                                            title="are you sure?"
                                            :visible="addPCountDocumentConfirmationVisible"
                                            ok-text="Yes"
                                            cancel-text="Cancel"
                                            @visibleChange="handleAddDocumentVisibleChange"
                                            @confirm="addPCount"
                                            @cancel="addPCountCancel"
                                        >
                                            <a type="button" class="btn btn-primary btn-block align-bottom text-white">+ Add Physical Documents</a>
                                        </a-popconfirm>
                                    </div>
                                    <div class="col-auto pt-2 float-right px-0">
                                        <base-dropdown class="nav-link float-right" position="right">
                                            <div class="media align-items-center" slot="title">
                                            <i class="fa fa-ellipsis-v float-right btn-sm" style='color: black;'></i>
                                            </div>
                                            <template>
                                                <div class="dropdown-header noti-title">
                                                    <h6 class="text-overflow m-0">ACTIONS</h6>
                                                </div>
                                                <a class="dropdown-item" @click="exportCsvDocument()">
                                                    <i class="fas fa-file-csv"></i>
                                                    <span>Export CSV2</span>
                                                </a>
                                                <a class="dropdown-item" @click="exportExcelDocument()">
                                                    <i class="fas fa-file-excel"></i>
                                                    <span>Export Excel Sheet</span>
                                                </a>
                                                <a class="dropdown-item" v-if="this.currentDocumentTypeCode=='RELCSI' || this.currentDocumentTypeCode=='ORIPOX' || this.currentDocumentTypeCode=='OTHPUR' || this.currentDocumentTypeCode=='ORISOX'" @click="exportCsvWithHeaderDocument()">
                                                    <i class="fas fa-file-csv"></i>
                                                    <span>Export CSV With Header Details</span>
                                                </a>
                                                <div class="dropdown-item" v-if="selectedDocumentLines.length == 1 && selectedDocumentLines && selectedDocumentLines.length > 0" @click.prevent="showStockCard(selectedDocumentLines)">
                                                        <i class="fas fa-layer-group"></i>
                                                    <span>View Document Lines</span>
                                                </div>
                                                <a v-if="documentStatus!='Fulfilled' || documentStatus!='Voided'" class="dropdown-item" @click="refreshInventory()">
                                                    <i class="fas fa-sync-alt"></i>
                                                    <span>Refresh Inventory</span>
                                                </a>
                                            </template>
                                        </base-dropdown>
                                    </div>
                                </div>
                            </div>

                            <div v-if='productFormMode=="Add" && !HideDeleteAndAddProductButton' class="row mt-4 ml-2 mr-2">
                                <div class="col-auto">
                                    <base-dropdown v-model="formattedsearchFilterAddedProduct" >
                                        <base-button slot="title" type="primary" class="dropdown-toggle">{{_.startCase(formattedsearchFilterAddedProduct)}}</base-button>
                                        <a class="dropdown-item" @click.prevent="changesearchFilterAddedProduct('barcode')">Barcode</a>
                                        <a class="dropdown-item" @click.prevent="changesearchFilterAddedProduct('name')">Name</a>
                                        <a class="dropdown-item" @click.prevent="changesearchFilterAddedProduct('stock_no')">Stock</a>
                                        <!-- <a class="dropdown-item" @click.prevent="changesearchFilterAddedProduct('code')">Code</a> -->
                                        <a class="dropdown-item" @click.prevent="changesearchFilterAddedProduct('ref_code')">Reference Code</a>
                                    </base-dropdown>
                                </div>
                                <div class="col">
                                    <a-input-search size="large" v-on:keyup="searchAddedProducts" @search="searchAddedProducts" :placeholder="addedProductPlaceholder" v-model='addedProductSearchInput' :disable='isProductSearchDisabled'/>
                                </div>
                                <div class="col-auto d-flex align-items-end justify-content-end p-0" >
                                    <base-dropdown  class="nav-link pr-2 float-right" position="right">
                                        <div class="media align-items-center" slot="title">
                                        <i class="fa fa-ellipsis-v float-right btn-sm" style='color: black;'></i>
                                        </div>
                                        <template>
                                            <div class="dropdown-header noti-title">
                                                <h6 class="text-overflow m-0">ACTIONS</h6>
                                            </div>
                                            <a v-if="((documentStatus=='Saved' || documentStatus=='Upload Error' || documentStatus=='Upload terminated') && productFormMode == 'Add') || documentStatus == null" class="dropdown-item" @click.prevent="showDrawer('massAdd')">
                                                <i class="fa fa-upload"></i>
                                                <span>Import</span>
                                            </a>
                                            <a v-if="(((documentStatus=='Saved' || documentStatus=='Upload Error' || documentStatus=='Upload terminated') && productFormMode == 'Add') || documentStatus == null) && (currentDocumentTypeCode=='OTHTRA' || currentDocumentTypeCode=='OTHPCK')" class="dropdown-item" @click.prevent="showDrawer('massAddWithAllocation')">
                                                <i class="fa fa-upload"></i>
                                                <span>Import With Allocation</span>
                                            </a>
                                            <a v-if="(((documentStatus=='Saved' || documentStatus=='Upload Error' || documentStatus=='Upload terminated') && productFormMode == 'Add') || documentStatus == null) && (currentDocumentTypeCode=='OTHSRQ' || currentDocumentTypeCode=='ORISOX' || currentDocumentTypeCode=='ORIPOX')" class="dropdown-item" @click.prevent="showDrawer('massAddWithHeader')">
                                                <i class="fa fa-upload"></i>
                                                <span>Import With Header</span>
                                            </a>
                                            <a class="dropdown-item" @click="exportCsvDocument()">
                                                <i class="fas fa-file-csv"></i>
                                                <span>Export CSV</span>
                                            </a>
                                            <a class="dropdown-item" @click="exportExcelDocument()">
                                                <i class="fas fa-file-excel"></i>
                                                <span>Export Excel Sheet</span>
                                            </a>
                                            <a class="dropdown-item" v-if="this.currentDocumentTypeCode=='RELCSI' || this.currentDocumentTypeCode=='ORIPOX' || this.currentDocumentTypeCode=='OTHPUR' || this.currentDocumentTypeCode=='ORISOX'" @click="exportCsvWithHeaderDocument()">
                                                <i class="fas fa-file-csv"></i>
                                                <span>Export CSV With Header Details</span>
                                            </a>
                                            <a class="dropdown-item" @click="exportWithAllocationDocument()">
                                                <i class="fas fa-file-excel"></i>
                                                <span>Export With Allocation</span>
                                            </a>
                                            <a class="dropdown-item" @click="showCustomizeListDrawer()">
                                                <i class="fas fa-bars"></i>
                                                <span>Customize List</span>
                                            </a>
                                            <a class="dropdown-item" v-if="['ORIPOX', 'ORITRQ'].includes(currentDocumentTypeCode) && autoRepMinMaxAccess == 1" @click="getMinMaxProducts()">
                                                <i class="fas fa-gears"></i>
                                                <span>Auto-Rep by Min/Max</span>
                                            </a>

                                            <a class="dropdown-item" v-if="['ORIPOX', 'ORITRQ'].includes(currentDocumentTypeCode) && autoRepOfftakeAccess == 1" @click="getOffTakeProducts()">
                                                <i class="fas fa-shopping-cart"></i>
                                                <span>Auto-Rep by Offtake</span>
                                            </a>

                                            <a class="dropdown-item" @click="showSortDrawer('sort')">
                                                <i class="fas fa-sort"></i>
                                                <span>Sort</span>
                                            </a>
                                            <a v-if="documentStatus!='Fulfilled' || documentStatus!='Voided'" hidden class="dropdown-item" @click="refreshInventory()">
                                                <i class="fas fa-sync-alt"></i>
                                                <span>Refresh Inventory</span>
                                            </a>
                                            <a v-if="selectedDocumentLines.length > 0 && selectedDocumentLines[0].is_require_lotcode" class="dropdown-item" @click.prevent="showLotCodeExpiry(selectedDocumentLines)">
                                                <i class="fas fa-hourglass-end"></i>
                                                <span>Lot Code and Expiry</span>
                                            </a>
                                        </template>
                                    </base-dropdown>
                                </div>
                            </div>

                            <div class="card-body" style="background: #FFFFFF; min-height: 40vh;">
                                <div class="table-responsive pt-2">
                                    <VueTabulator ref="tabulator"
                                        v-model="data"
                                        :options="options"
                                        @cell-edited="tabulatorCellEdit"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Summary -->
            <h3 class='font-weight-bold mt-4'>Summary</h3>
            <div class="row mt-2">
                <div class="col">
                    <div class="card shadow">
                        <div class="card-body">
                            <div v-if='showTotalQuantity' class="row">
                                <div class="col">
                                    <span class="mr-auto h2 font-weight-bold">Total Quantity: {{formatMyNumber(totalQuantity,0)}}</span>
                                </div>
                                <div v-if="showVatExclusiveCheckbox && showVatExclusiveCheckboxConfig && !['OTHLIQ','ORIASN'].includes(currentDocumentTypeCode)" class="col d-flex align-items-end" style="border-left: 1px solid #E0E0E0;">
                                    <a-checkbox :checked="vatExclusiveCheckbox" @change="toggleVatExclusive">Show price and discount exclusive of VAT</a-checkbox>
                                </div>
                            </div>

                            <hr v-if='showTotalQuantity' class='my-3'>

                            <div v-if='showSummaryCalculation && ((document_config!=null && !document_config.document_type_settings.additionalEditorBehaviorCheckboxes.termsAndDiscount) || docTypesForOM.includes(currentDocumentTypeCode) || docTypesForIM.includes(currentDocumentTypeCode)) || currentDocumentTypeCode == "OTHSBI"' class="row pb-1">
                                <div class="col" v-if="showHeaderDiscount">
                                    <h6 class="heading-small text-muted">Header Discount</h6>
                                    <a-select mode="tags" :maxTagCount='5'  maxTagPlaceholder='...' v-model='headerDiscount' placeholder='Discount' style="width: 100%;" @change="onHeaderDiscountChange" input-classes="form-control" v-bind="{ disabled: isHeaderDiscountDisabled }"></a-select>
                                </div>
                                <div class="col" v-if="showSupportDiscount">
                                    <h6 class="heading-small text-muted">Supports Discount</h6>
                                    <a-select mode="tags" :maxTagCount='5'  maxTagPlaceholder='...' v-model='supportDiscount'  @change="onSupportDiscountChange" placeholder='Discount' style="width: 100%;" input-classes="form-control" :disabled="isSupportsDiscountDisabled"></a-select>
                                </div>
                            </div>

                            <div v-if='showSummaryCalculation' class="row pb-4">
                                <div class="col">
                                    <h6 class="heading-small text-muted">Gross Amount
                                    <small v-if="currencyRate > 0 && showConversionRate"> {{currencyDetails.code}} {{ (grossAmountDisplay / currencyRate).toFixed(decimalPlaces) }}</small> </h6>
                                    <small v-if="currencyRate <= 0 && showConversionRate && isCurrencyToPhp"> {{currencyDetails.code || 'PHP'}} {{ (grossAmountDisplay * (documentDetails.currency_rate == null || documentDetails.currency_rate == undefined || documentDetails.currency_rate == 0 ? supplierDetails.currency_rate : documentDetails.currency_rate)).toFixed(decimalPlaces) }}</small> </h6>
                                    <a-input placeholder="0.00" v-model='grossAmountDisplay' style="width: 100%; display:none;" :disabled='true'/>
                                    <h3>{{formatMyNumber(grossAmountDisplay, decimalPlaces)}}</h3>
                                </div>
                                <div class="col">
                                    <h6 class="heading-small text-muted">Item Discount
                                    <small v-if="currencyRate > 0 && showConversionRate"> {{currencyDetails.code}} {{ (itemDiscount / currencyRate).toFixed(decimalPlaces) }}</small> </h6>
                                    <small v-if="currencyRate <= 0 && showConversionRate && isCurrencyToPhp"> {{currencyDetails.code || 'PHP'}} {{ (itemDiscount * (documentDetails.currency_rate == null || documentDetails.currency_rate == undefined || documentDetails.currency_rate == 0 ? supplierDetails.currency_rate : documentDetails.currency_rate)).toFixed(decimalPlaces) }}</small> </h6>
                                    <a-input placeholder="0.00" v-model='itemDiscount' style="width: 100%; display:none;" :disabled='true'/>
                                    <h3>{{formatMyNumber(itemDiscount, decimalPlaces)}}</h3>
                                </div>
                                <div class="col" v-if="docTypesForOM.includes(currentDocumentTypeCode) || (docTypesForIM.includes(currentDocumentTypeCode) && document_config!=null && !document_config.document_type_settings.additionalEditorBehaviorCheckboxes.termsAndDiscount) || currentDocumentTypeCode == 'OTHSBI' || currentDocumentTypeCode == 'RELRSR'">
                                    <h6 class="heading-small text-muted">Overall Discount</h6>
                                    <a-input placeholder="0.00" v-model='overallDiscount' style="width: 100%; display:none;" @change="onChangeOverallDiscount" :disabled='true'/>
                                    <h3>{{formatMyNumber(overallDiscount, decimalPlaces)}}</h3>
                                </div>
                                <div class="col" v-if="currentDocumentTypeCode == 'OTHSIN' || currentDocumentTypeCode == 'OTHSBI' || currentDocumentTypeCode == 'OTHLIQ' || currentDocumentTypeCode == 'RECCSR' || (currentDocumentTypeCode == 'RELADJ' && documentDetails && documentDetails.order_source == 'LIQUIDATION') || currentDocumentTypeCode == 'RELRSR'">
                                    <h6 class="heading-small text-muted">Total Trade Discount</h6>
                                     <!-- <a-input placeholder="0.00" v-model='totalTradeDiscount' style="width: 100%; display:none;" :disabled='true'/> -->
                                    <h3>{{formatMyNumber(Number(documentDetails.trade_discount), decimalPlaces)}}</h3>
                                </div>
                                <div class="col">
                                    <h6 class="heading-small text-muted">Net Amount
                                    <small v-if="currencyRate > 0 && showConversionRate"> {{currencyDetails.code}} {{ (netAmountDisplay / currencyRate).toFixed(decimalPlaces) }}</small> </h6>
                                    <small v-if="currencyRate <= 0 && showConversionRate  && isCurrencyToPhp"> {{currencyDetails.code || 'PHP'}} {{ (netAmountDisplay * (documentDetails.currency_rate == null || documentDetails.currency_rate == undefined || documentDetails.currency_rate == 0 ? supplierDetails.currency_rate : documentDetails.currency_rate)).toFixed(decimalPlaces) }}</small> </h6>
                                    <a-input placeholder="0.00" v-model='netAmountDisplay' style="width: 100%; display:none;" :disabled='true'/>
                                    <h3>{{formatMyNumber(netAmountDisplay, decimalPlaces)}}</h3>
                                </div>
                                <div class="col" v-if="displayNetAmountWOVat">
                                    <h6 class="heading-small text-muted">{{displayNetAmountWOVatLabel}}
                                    <small v-if="currencyRate > 0 && showConversionRate"> {{currencyDetails.code}} {{ (netAmountWithoutTax / currencyRate).toFixed(decimalPlaces) }}</small> </h6>
                                    <small v-if="currencyRate <= 0 && showConversionRate  && isCurrencyToPhp"> {{currencyDetails.code || 'PHP'}} {{ (netAmountWithoutTax * (documentDetails.currency_rate == null || documentDetails.currency_rate == undefined || documentDetails.currency_rate == 0 ? supplierDetails.currency_rate : documentDetails.currency_rate)).toFixed(decimalPlaces) }}</small> </h6>
                                    <a-input placeholder="0.00" v-model='netAmountWithoutTax' style="width: 100%; display:none;" :disabled='true'/>
                                    <h3>{{formatMyNumber(netAmountWithoutTax, decimalPlaces)}}</h3>
                                </div>
                                <div class="col" v-if='vatExclusiveCheckbox || displayVatAmount'>
                                    <h6 class="heading-small text-muted">VAT Amount
                                    <small v-if="currencyRate > 0 && showConversionRate"> {{currencyDetails.code}} {{ (vatAmount / currencyRate).toFixed(decimalPlaces) }}</small></h6>
                                    <small v-if="currencyRate <= 0 && showConversionRate && isCurrencyToPhp"> {{currencyDetails.code || 'PHP'}} {{ (vatAmount * (documentDetails.currency_rate == null || documentDetails.currency_rate == undefined || documentDetails.currency_rate == 0 ? supplierDetails.currency_rate : documentDetails.currency_rate)).toFixed(decimalPlaces) }}</small></h6>
                                    <a-input placeholder="0.00" v-model='vatAmount' style="width: 100%; display:none;" :disabled='true'/>
                                    <h3>{{formatMyNumber(vatAmount, decimalPlaces)}}</h3>
                                </div>
                                <div class="col" v-if='vatExclusiveCheckbox'>
                                    <h6 class="heading-small text-muted">Total with VAT
                                    <small v-if="currencyRate > 0 && showConversionRate"> {{currencyDetails.code}} {{ (totalWithVat / currencyRate).toFixed(decimalPlaces) }}</small></h6>
                                    <small v-if="currencyRate <= 0 && showConversionRate && isCurrencyToPhp"> {{currencyDetails.code || 'PHP'}} {{ (totalWithVat * (documentDetails.currency_rate == null || documentDetails.currency_rate == undefined || documentDetails.currency_rate == 0 ? supplierDetails.currency_rate : documentDetails.currency_rate)).toFixed(decimalPlaces) }}</small></h6>
                                    <a-input placeholder="0.00" v-model='totalWithVat' style="width: 100%; display:none;" :disabled='true'/>
                                    <h3>{{formatMyNumber(totalWithVat, decimalPlaces)}}</h3>
                                </div>
                            </div>
                            <div class="row pb-4" v-if="docTypesForOM.includes(currentDocumentTypeCode) || docTypesForIM.includes(currentDocumentTypeCode) || this.currentDocumentTypeCode == 'OTHSBI'"> 
                                <div class="col">
                                    <h6 class="heading-small text-muted">VATable{{(currentDocumentTypeCode == "OTHSBI" || currentDocumentTypeCode == "RECDEL") ? '' : 's Sales'}}</h6>
                                    <a-input placeholder="0.00" v-model='vatableSalesAmount' style="width: 100%; display:none;" :disabled='true'/>
                                    <h3>{{formatMyNumber(vatableSalesAmount, decimalPlaces)}}</h3>
                                </div>
                                <div class="col">
                                    <h6 class="heading-small text-muted">VAT-Exempt {{(currentDocumentTypeCode == "OTHSBI" || currentDocumentTypeCode == "RECDEL") ? '' : 'Sales'}}</h6>
                                    <a-input placeholder="0.00" v-model='vatExemptSalesAmount' style="width: 100%; display:none;" :disabled='true'/>
                                    <h3>{{formatMyNumber(vatExemptSalesAmount, decimalPlaces)}}</h3>
                                </div>
                                <div class="col">
                                    <h6 class="heading-small text-muted">Zero Rated {{(currentDocumentTypeCode == "OTHSBI" || currentDocumentTypeCode == "RECDEL") ? '' : 'Sales'}}</h6>
                                    <a-input placeholder="0.00" v-model='zeroRatedSalesAmount' style="width: 100%; display:none;" :disabled='true'/>
                                    <h3>{{formatMyNumber(zeroRatedSalesAmount, decimalPlaces)}}</h3>
                                </div>
                                <div class="col">
                                    <h6 class="heading-small text-muted">VAT Amount</h6>
                                    <a-input placeholder="0.00" v-model='vatAmount' style="width: 100%; display:none;" :disabled='true'/>
                                    <h3>{{formatMyNumber(vatAmount, decimalPlaces)}}</h3>
                                </div>
                            </div>
                            <span v-if='documentStatus!="Posted" && currentDocumentTypeCode != "RECDEL"' class="h4 font-weight-bold">Document Date</span>
                            <div v-if='documentStatus!="Posted" && currentDocumentTypeCode != "RECDEL"' class="row pt-1">
                                <div class="col">
                                    <h6 v-if='currentDocumentTypeCode == "ORIOSO"' class="heading-small text-muted">Online Sales Order Date</h6>
                                    <h6 v-else class="heading-small text-muted">{{currentDocumentTypeFriendlyCode}} Date</h6>
                                    <a-date-picker v-model='documentDate' @change="changeDate" placeholder="Document Date" style="width: 100%" :disabled='isDocumentDateDisabled'/>
                                </div>
                                <div v-if="showTargetDate" class="col">
                                    <h6 v-if='currentDocumentTypeCode == "OTHPWS"' class="heading-small text-muted">Effectivity Date</h6>
                                    <h6 v-else class="heading-small text-muted">Target Date</h6>
                                    <a-date-picker v-if='currentDocumentTypeCode == "OTHPWS"' v-model='targetDate' @change="()=>{isEditing = true}" :disabled-date="disabledEffectiveDate" placeholder="Target Date" style="width: 100%" :disabled='isTargetDateDisabled'/>
                                    <a-date-picker v-else v-model='targetDate' :disabled-date="disabledDateForOtherDate" @change="()=>{isEditing = true}" placeholder="Target Date" style="width: 100%" :disabled='isTargetDateDisabled'/>

                                </div>
                                <div v-if="showCancellationDate" class="col">
                                    <h6 class="heading-small text-muted">Cancellation Date</h6>
                                    <a-date-picker v-model='cancellationDate' :disabled-date="disabledDateForOtherDate" @change="()=>{isEditing = true}" placeholder="Cancellation Date" style="width: 100%" :disabled='isCancellationDateDisabled'/>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <div class="d-flex justify-content-center mt-4">
                <button type="button" class="btn btn-sm btn-outline-secondary" @click='showAdvancedInfoDiv' >
                    Advanced Information {{showAdvancedInfo? '↟' : '↡'}}
                </button>
            </div>

            <h3 v-if='showAdvancedInfo' class='font-weight-bold'>Advanced Info</h3>
            <div v-if='showAdvancedInfo' class="row mt-2 advanced-info">
                <div class="col">
                    <div class="card shadow">
                        <div class="card-body">
                            <div class="row pb-4">
                                <div class="col" v-if="document_config!=null && !document_config.document_type_settings.additionalEditorBehaviorCheckboxes.termsAndDiscount && !['ORIPOX', 'ORIASN', 'RECDEL', 'RELRSR'].includes(currentDocumentTypeCode)">
                                    <h6 class="heading-small text-muted">Terms</h6>
                                    <a-select
                                            labelInValue
                                            :value="paymentTerm"
                                            placeholder="Select a payment term"
                                            style="width: 100%"
                                            :filterOption="false"
                                            @dropdownVisibleChange="fetchPaymentTerms"
                                            @change="selectPaymentTerm"
                                            :notFoundContent="fetching ? undefined : null"
                                            :disabled='isPaymentTermDisabled'
                                            :allowClear='true'
                                        >
                                        <a-spin v-if="fetching" slot="notFoundContent" size="small"/>
                                        <a-select-option v-for="s in paymentTerms" :key="'paymentTerms'+s.id.toString()">{{s.name}}</a-select-option>
                                    </a-select>
                                </div>

                                <div class="col" v-if="showShippingMethod">
                                    <h6 class="heading-small text-muted">Shipping Method</h6>
                                    <a-select
                                            labelInValue
                                            :value="shippingMethod"
                                            placeholder="Select a shipping method"
                                            style="width: 100%"
                                            :filterOption="false"
                                            @dropdownVisibleChange="fetchShippingMethods"
                                            @change="selectShippingMethod"
                                            :notFoundContent="fetching ? undefined : null"
                                            :disabled='isShippingMethodDisabled'
                                        >
                                        <a-spin v-if="fetching" slot="notFoundContent" size="small"/>
                                        <a-select-option v-for="s in shippingMethods" :key="'shippingMethods'+s.id.toString()">{{s.name}}</a-select-option>
                                    </a-select>
                                </div>
                                <div class="col" v-if="this.currentDocumentTypeCode!='ORISOX' && this.currentDocumentTypeCode!='OTHSRQ' && this.currentDocumentTypeCode!='OTHSIN' && this.currentDocumentTypeCode!='RECADJ' && this.currentDocumentTypeCode!='RELADJ'">
                                    <h6 class="heading-small text-muted">Purpose</h6>
                                    <a-select
                                        labelInValue
                                        :value="purpose"
                                        placeholder="Select purpose"
                                        style="width: 100%"
                                        :filterOption="false"
                                        @dropdownVisibleChange="fetchPurposes"
                                        @change="selectPurpose"
                                        :disabled="isPurposeDisabled"
                                        :dataSource="fetchPurposes"
                                    >
                                        <a-select-option v-for="s in purposes" :key="'purposes' + s.id.toString()">
                                            {{ s.name }}
                                        </a-select-option>
                                    </a-select>
                                </div>
                                <div class="col">
                                    <h6 class="heading-small text-muted">{{referenceLabel}}</h6>
                                    <a-input style="width: 100%" @change="handleInputChange" @focus="focusedLengthField = 'reference'" @blur="onLengthFieldBlur('reference')" v-model='reference' placeholder="Reference" :disabled='isReferenceDisabled'/>
                                    <small class="text-muted">{{ referenceLength }}/{{ fieldMaxLength }} characters</small>
                                </div>
                            </div>
                            <div class="row pt-1">
                                <div class="col">
                                    <h6 class="heading-small text-muted">{{remarkLabel}}</h6>
                                    <a-input style="width: 100%" v-model='remark' @change="handleInputChange" @focus="focusedLengthField = 'remark'" @blur="onLengthFieldBlur('remark')" placeholder="Remark">
                                        <a v-if='documentNumber > 0' slot="addonAfter" @click='saveRemark()' class="heading-small text-muted">Save</a>
                                    </a-input>
                                    <small class="text-muted">{{ remarkLength }}/{{ fieldMaxLength }} characters</small>
                                </div>
                            </div> <br>
                            <div class="row pt-1 mb-3" v-if="showImageRefLink.includes(currentDocumentTypeCode)">
                                <div class="col">
                                    <h6 class="heading-small text-muted">Image Reference Link</h6>
                                    <a-input
                                        style="width: 100%"
                                        @change="handleInputChange"
                                        v-model="imageReferenceLink"
                                        placeholder="Image Reference Link"
                                    >
                                        <a v-if="documentNumber > 0" slot="addonAfter" @click="saveImageRefLink()" class="heading-small text-muted">Save</a>
                                    </a-input>
                                </div>
                            </div>
                            <div v-if="docTypesForP2P.includes(currentDocumentTypeCode) || docTypesForOMGT.includes(currentDocumentTypeCode)" class="row pt-1">
                                <div class="col filter_separator">
                                    <h6 class="heading-small text-muted">OC Reference No.</h6>
                                    <a-input style="width: 100%" @change="handleInputChange" @focus="focusedLengthField = 'ocReferenceNo'" @blur="onLengthFieldBlur('ocReferenceNo')" v-model="ocReferenceNo" placeholder="OC Reference No.">
                                    <a v-if="documentNumber > 0" slot="addonAfter" @click="saveOcRefNo()" class="heading-small text-muted">Save</a>
                                    </a-input>
                                    <small class="text-muted">{{ ocReferenceNoLength }}/{{ fieldMaxLength }} characters</small>
                                </div>
                                <div class="col filter_separator">
                                    <h6 class="heading-small text-muted">Shipment Reference No.</h6>
                                    <a-input style="width: 100%" @change="handleInputChange" @focus="focusedLengthField = 'shipmentReferenceNo'" @blur="onLengthFieldBlur('shipmentReferenceNo')" v-model="shipmentReferenceNo" placeholder="Shipment Reference No.">
                                    <a v-if="documentNumber > 0" slot="addonAfter" @click="saveShipmentRefNo()" class="heading-small text-muted">Save</a>
                                    </a-input>
                                    <small class="text-muted">{{ shipmentReferenceNoLength }}/{{ fieldMaxLength }} characters</small>
                                </div>
                            </div>
                        </div>

                        <div class="card-body pt-0" v-if="currentDocumentTypeCode === 'ORIOSO' || currentDocumentTypeCode === 'ORIOCR'">
                            <div class="row pb-2">
                                <div class="col ">
                                    <h6 class="heading-small text-muted">Shipment Details</h6>
                                </div>
                            </div>
                            <a-table :columns="shipmentDetailColumns" :dataSource="shipmentDetailData" :pagination="false" size="small">
                            <span slot="amount" slot-scope="text, record">
                                {{record.amount}}
                            </span>
                            </a-table>
                        </div>

                        <div class="card-body pt-0" v-if='showChargesTable'>
                            <div class="row pb-2">
                                <div class="col ">
                                    <h6 class="heading-small text-muted">Charges</h6>
                                </div>
                                <!-- <div class="col-2 d-flex align-items-end" v-if="chargeSelectedRowKeys && chargeSelectedRowKeys.length > 0">
                                    <button type="button" class="btn btn-danger btn-sm btn-block align-bottom" @click="mass_delete_charge()" :disabled="documentStatus == 'Voided' || isAddChargeDisabled">Delete Charge</button>
                                </div> -->
                                <!-- <div class="col-2 d-flex align-items-end">
                                    <button type="button" class="btn btn-primary btn-sm btn-block align-bottom" @click="showDrawer('charges')" :disabled='isAddChargeDisabled'>Add Charge</button>
                                </div> -->
                            </div>
                            <a-table :rowSelection="chargeRowSelection" rowKey='line_no' :columns="chargeColumns" :dataSource="chargeData" :pagination="true" size="small">
                            <span slot="charge_type" slot-scope="text, record">
                                <a-tag v-if="record.charge_type == 'I'" color="green">Initial Charge</a-tag>
                                <a-tag v-if="record.charge_type == 'A-RR'" color="blue">Additional Charge - RR Quantity</a-tag>
                                <a-tag v-if="record.charge_type == 'A-CL'" color="red">Additional Charge - Cost Layer Quantity</a-tag>
                                <a-tag v-else color="green">Add On Charge</a-tag>
                            </span>
                            <span slot="amount" slot-scope="text, record">
                                {{formatMyNumber(Number(record.amount), 2)}}
                            </span>
                            <span slot="vat_amount" slot-scope="text, record">
                                {{formatMyNumber(Number(record.vat_amount), 2)}}
                            </span>
                            <span slot="charge_date" slot-scope="text, record">
                                {{moment(record.charge_date).format('MM/DD/YYYY HH:mm')}}
                            </span>
                            <template #footer>Total Amount: {{formatMyNumber(Number(totalCharges), 2)}} <br> Total VAT Amount: {{formatMyNumber(Number(totalVatCharges), 2)}}</template>
                            </a-table>

                            <a-drawer
                                :width="480"
                                placement="right"
                                @close="closeDrawer('charges')"
                                :visible="chargeDrawerVisible"
                                style="z-index: 999999!important;"
                            >
                                <h6 class="heading-small text-muted mb-4 text-truncate">Add Charge</h6>
                                <form>
                                <base-input label="Description" placeholder="" v-model="chargeDescription" input-classes="form-control" />
                                <base-input label="Charge Type">
                                    <select class="form-control" v-model="chargeType" @change='selectChargeType'>
                                        <option v-for="option in chargeTypeOptions" v-bind:key="'chargeTypeOptions'+option.key" v-bind:value="option.key">
                                            {{option.value}}
                                        </option>
                                    </select>
                                </base-input>
                                <base-input label="Weight (kg)" placeholder="" v-model="chargeWeight" input-classes="form-control" :disabled='isChargeWeightDisabled' @input='calculateChargeAmount'/>
                                <base-input label="Rate /kg" placeholder="" v-model="chargeRate" input-classes="form-control" :disabled='isChargeRateDisabled' @input='calculateChargeAmount'/>
                                <base-input label="Amount" placeholder="" v-model="chargeAmount" input-classes="form-control" :disabled='isChargeAmountDisabled' />
                                <div style="position: absolute; bottom: 0px;right: 0px; width: -webkit-fill-available; background-color: #f2f2f2 ;padding: 10px;">
                                    <button type="button" class="btn btn-primary float-right" @click='addCharge()' >Add</button>
                                    <button type="button" class="btn btn-danger float-right mr-2" @click="closeDrawer('charges')">Close</button>
                                </div>
                                </form>
                            </a-drawer>
                        </div>
                    </div>
                </div>
            </div>
            <hr>

            <!-- Drawer for Payments -->
            <a-drawer :width="480" placement="right"  @close="closeDrawer('payments')" :visible="paymentDrawerVisible">
                <h6 class="heading-small text-muted mb-4 text-truncate">Choose Payment Method</h6>
                <form>
                    <a-spin :spinning="spinning">
                        <base-alert v-if="paymentErrors.length" type="danger">
                            <b>You have the following error(s):</b>
                            <li v-for="error in paymentErrors" :key="error">{{ error }}</li>
                        </base-alert>

                        <base-input label="Payment Mode">
                            <base-radio name="paymaya" class="mb-3" v-model="paymentMode" value="paymaya">
                                Paymaya
                            </base-radio>
                            <base-radio name="dragonpay" class="mb-3" v-model="paymentMode" value="dragonpay">
                                Dragonpay
                            </base-radio>

                            <base-input v-if="paymentMode == 'dragonpay'" label="Payment Method">
                                <br/>
                                <a-select showSearch style="width: 100%" placeholder="Please select payment method" optionFilterProp="children"  v-model="paymentMethod">
                                    <a-select-option v-for="option in paymentMethods" :key="'paymentMethods'+option.procId" :value="option.procId">{{option.shortName}}</a-select-option>
                                </a-select>
                            </base-input>


                            <base-radio name="bank" class="mb-3" v-model="paymentMode" value="bank">
                                Bank Transfer
                            </base-radio>

                            <base-input v-if="paymentMode == 'bank'" label="Reference Number">
                                <br/>
                                <a-input style="width: 100%" v-model='bankTransferReference' placeholder="Reference Number" />
                            </base-input>
                        </base-input>
                    </a-spin>
                    <div style="position: absolute; bottom: 0px;right: 0px; width: -webkit-fill-available; background-color: #f2f2f2 ;padding: 10px;">
                        <button type="button" class="btn btn-primary float-right" @click='pay(documentNumber)' >
                            <span v-if="paymentMode == 'bank'">Confirm</span>
                            <span v-else>Send Link</span>
                        </button>
                        <!-- @click="closeDrawer('payments')" -->
                        <button v-if="currentDocumentTypeCode != 'OTHSIN'" type="button" class="btn btn-danger float-right mr-2" @click="payLater()">Proceed Without Payment</button>
                    </div>
                </form>

            </a-drawer>

            <!-- Drawer for Initail Deposit -->
            <a-drawer :width="480" placement="right"  @close="closeDrawer('initialDeposit')" :visible="initialDepositDrawerVisible">
                <h6 class="heading-small text-muted mb-4 text-truncate">Initial Deposit</h6>
                <form>
                    <a-spin :spinning="spinning">
                        <base-alert v-if="initialDepositErrors.length" type="danger">
                            <b>You have the following error(s):</b>
                            <li v-for="error in initialDepositErrors" :key="error">{{ error }}</li>
                        </base-alert>
                        <base-input label="Amount">
                            <a-input-number v-model="initialDeposit.amount" :min="1" step=".01" :max="Number(grossAmountDisplay)" style="width: 100%" input-classes="form-control" />
                        </base-input>
                        <base-input label="Reference" placeholder="" v-model="initialDeposit.reference" input-classes="form-control"/>
                    </a-spin>
                    <div style="position: absolute; bottom: 0px;right: 0px; width: -webkit-fill-available; background-color: #f2f2f2 ;padding: 10px;">
                        <button type="button" class="btn btn-primary float-right" @click='payInitialDeposit(documentNumber)' >
                            <span>Confirm</span>
                        </button>
                        <!-- @click="closeDrawer('payments')" -->
                    </div>
                </form>
            </a-drawer>

            <!-- Drawer for Applying Document to Other Sites -->
            <DocumentApplyToOtherSitesDrawer
              :documentNumber="this.documentNumber"
              :currentDocumentSite="this.forThisSite"
              :showDrawer="applyDocumentToOtherSitesDrawer"
              @closeDrawer="toggleApplyDocumentToOtherSitesDrawer"
              @notification="(args) => $notification[args.type]({ message: args.msg.message, description: args.msg.description, style: getNotificationStyle(args.type) })"/>

            <!-- Drawer for Booking -->
            <a-modal
               title="Recompute Needed"
               :visible="recomputeModal"
               :maskClosable="false"
               okText="Yes"
               cancelText="Recompute"
               @ok="bookingProper"
               @cancel="recomputeBooking"
             >
                There was a change on the destination point. Do you want to proceed with the original destination point?
            </a-modal>

            <!-- Drawer for TOV-SI -->
            <a-modal
               title="Please select B2B Customer for SI Resolution"
               :visible="tovsiModal"
               :maskClosable="false"
               okText="Proceed"
               cancelText="Cancel"
               @ok="proceedPosting"
               @cancel="handleCancel"
             >
                <div v-if="si_source">
                    <p v-if="currentDocumentTypeCode == 'OTHTOV'">Source Customer:</p>
                    <p v-else>Charge Customer:</p>
                    <a-input-group compact class="si_customer_name" v-model="selectedB2bCustomer">
                        <a-select class="si_customer_name_input" @select="selectB2bCustomerSource" :filterOption="filterOption" showSearch v-model="b2bCustomerSource" style="width: 100%" placeholder="Select B2B Customer" allowClear>
                            <a-select-option v-for="b2bOption in b2bCustomerOptions" :key="b2bOption.id" :value="b2bOption.id">
                                {{b2bOption.name}}
                            </a-select-option>
                        </a-select>
                    </a-input-group>
                </div>
            </br></hr>
                <div v-if="si_destination">
                    <p v-if="currentDocumentTypeCode == 'OTHTOV'">Destination Customer:</p>
                    <p v-else>Charge Customer:</p>
                    <a-input-group compact class="si_customer_name" v-model="selectedB2bCustomer">
                        <a-select class="si_customer_name_input" @select="selectB2bCustomerDestination" :filterOption="filterOption" showSearch v-model="b2bCustomerDestination" style="width: 100%" placeholder="Select B2B Customer" allowClear>
                            <a-select-option v-for="b2bOption in b2bCustomerOptions" :key="b2bOption.id" :value="b2bOption.id">
                                {{b2bOption.name}}
                            </a-select-option>
                        </a-select>
                    </a-input-group>
                </div>
                <!-- <template slot="footer">
                    <a-button key="back" @click="handleCancel">Close</a-button>
                </template> -->
            </a-modal>

            <a-drawer  v-if="bookingDrawerVisible" :width="1000" placement="right"  @close="closeDrawer('booking')" :visible="bookingDrawerVisible">
                <h6 class="heading-small text-muted mb-4 text-truncate">Booking Details</h6>


                <div v-if="activeBooking">
                    <a-card v-if="bookingDetails.order != undefined" title="Booking Details">
                        <a-card-grid style="width:50%;text-align:center">
                          <small>Amount</small>
                          <h3>PHP {{bookingDetails.order.delivery_fee_amount}}</h3>
                        </a-card-grid>
                        <a-card-grid style="width:50%;text-align:center" :hoverable="false">
                         <small>Status</small>
                         <h3>{{bookingDetails.order.status_description}}</h3>
                        </a-card-grid>
                    </a-card>
                </div>
                <div v-else>
                    <a-card v-if="bookingDetails.order != undefined" title="Booking Amount">
                        <h3>PHP {{bookingDetails.order.delivery_fee_amount}}</h3>
                    </a-card>
                </div>
                <!-- <a v-if="addressEditMode == false" href="#" @click.prevent="addressEditMode = true"><small>Edit</small></a>
                <a v-else href="#" @click.prevent="addressEditMode = false"><small>Save</small></a> -->

                <form class="row mt-3" style="overflow: scroll;">

                <div class="col-md-4">
                    <a-steps progress-dot :current="2" direction="vertical">
                      <a-step title="Pickup Address" :description="siteAddress"/>
                      <a-step title="Destination Address" :description="customerAddress" />
                    </a-steps>
                </div>

                <!-- <GmapMarker ref="myMarker" :position="google && new google.maps.LatLng(1.38, 103.8)" /> -->
                <div v-if="activeBooking" class="col-md-8">
                    <google-map :center="center" :zoom="13" style="width: 100%; height: 500px" :key="mapKey">
                      <!-- <google-marker v-for="m in markers" :position="m.position" :clickable="true" :draggable="true" @click="center=m.position" :key="m.id"></google-marker> -->
                      <google-marker :position="markers[0].position" :draggable="false"></google-marker>
                      <google-marker :position="markers[1].position" :draggable="false"></google-marker>
                    </google-map>
                    <small><span class="fa fa-exclamation-circle mr-2 text-info"/>You can move the pinned location on the map if necessary.</small>
                </div>
                <div v-else class="col-md-8">
                    <google-map :center="center" :zoom="13" style="width: 100%; height: 500px" :key="mapKey">
                      <!-- <google-marker v-for="m in markers" :position="m.position" :clickable="true" :draggable="true" @click="center=m.position" :key="m.id"></google-marker> -->
                      <google-marker :position="markers[0].position" :draggable="false"></google-marker>
                      <google-marker :position="markers[1].position" :draggable="true" @dragend="handleDestinationChange" :key="mapKey"></google-marker>
                    </google-map>
                    <small><span class="fa fa-exclamation-circle mr-2 text-info"/>You can move the pinned location on the map if necessary.</small>
                </div>

                <div class="mt-3 col-md-6">
                    <h5 class="navbar-heading text-muted">PICKUP CONTACT DETAILS</h5>
                    <!-- <base-input alternative="" label="Pickup Address" v-model="siteAddress" type="text" /> -->
                    <base-input :disabled="activeBooking" alternative="" label="Pickup Contact Name" v-model="siteContactPerson" type="text"/>
                    <base-input :disabled="activeBooking" alternative="" label="Pickup Contact Number" v-model="siteContactNumber" type="text"/>
                </div>

                <div class="mt-3 col-md-6">
                    <h5 class="navbar-heading text-muted">DESTINATION CONTACT DETAILS</h5>
                    <!-- <base-input alternative="" label="Destination Address" v-model="customerAddress" type="text" /> -->
                    <base-input :disabled="activeBooking" alternative="" label="Destination Contact Name" type="text" v-model="customer.label"/>
                    <base-input :disabled="activeBooking" alternative="" label="Destination Contact Number" type="text" v-model="customerContactMobile"/>
                </div>

                <br/>

                <div class="mt-3 col-md-12">
                    <base-input label="Vehicle Type">
                        <base-radio name="8" class="mb-3" v-model="deliveryMode" value="8" :disabled="activeBooking">
                            Motor Bike
                        </base-radio>
                        <base-radio name="7" class="mb-3" v-model="deliveryMode" value="7" :disabled="activeBooking">
                            Car
                        </base-radio>
                    </base-input>
                    <br/> <br/><br/>
                </div>



                <div style="position: absolute; bottom: 0px;right: 0px; width: -webkit-fill-available; background-color: #f2f2f2 ;padding: 10px;">
                    <button v-if="activeBooking == true && bookingDetails.order.status == 'new'" type="button" class="btn btn-warning float-right" @click.prevent="cancelBooking()">Cancel Booking</button>
                    <button v-if="activeBooking == false" type="button" class="btn btn-success float-right" @click.prevent="proceedBooking()">Book</button>
                    <button v-if="activeBooking == false" type="button" class="btn btn-primary float-right" @click.prevent="recomputeBooking()">Recompute</button>
                    <button type="button" class="btn btn-danger float-right mr-2" @click="closeDrawer('booking')">Close</button>
                </div>
                </form>
            </a-drawer>

            <!-- Drawer for Document Action History -->
            <a-drawer :width="800" placement="right" @close="closeDrawer('history')" :visible="historyDrawerVisible">
                <h6 class="heading-small text-muted mb-4 text-truncate">Document Action History</h6>
                <a-table :columns="historyColumns" :dataSource="historyData" size="small"/>
                <div style="position: absolute; bottom: 0px;right: 0px; width: -webkit-fill-available; background-color: #f2f2f2 ;padding: 10px;">
                    <button type="button" class="btn btn-danger float-right mr-2" @click="closeDrawer('history')">Close</button>
                </div>
            </a-drawer>

            <!-- Drawer for Stock Card -->
            <stock-card v-if="selectedStockCardProduct != null" :product="selectedStockCardProduct" :key="'stockCard'+stockCardKey" :visible="stockCardVisible"></stock-card>

            <!-- Drawer for Customer Form -->
            <a-drawer title="" :width="1000" placement="right" @close="onClose" :visible="customerDrawerVisible">
                <customer-form :key="'CustomerForm'+customerDrawerKey" v-on:refreshPage="refreshPage" @closeDrawer="closeDrawer"></customer-form>
            </a-drawer>

            <!-- Drawer for Document Line Mass Add -->
            <a-drawer :width="480" placement="right" :key="'documentLineMassAdd'+massAddDrawerKey" @close="closeDrawer('massAdd')" :visible="massAddDrawerVisible">
                <h6 class="heading-small text-muted mb-4">Mass Add Products in Document Lines</h6>
                <base-alert v-if="massAddProductErrors.length" type="danger">
                    <b>You have the following error(s):</b>
                    <li v-for="error in massAddProductErrors" :key="error">{{ error }}</li>
                </base-alert>
                <base-alert v-if="massAddProductErrorsDL.length" type="info">
                    <b>Download list:</b>
                    <li v-if="dlDUplicateSkus == 1"><a href="#" @click="printDupSKUs">Duplicate Barcode/s</a></li>
                    <li v-if="dlSkusNotFound == 1"><a href="#" @click="printSKUsNotFound">Barcode/s not found</a></li>

                </base-alert>
                <div>
                    <a-spin tip="Validating CSV file" :spinning="spinning">
                        <label v-if="header.showSaveProductVia">
                            Save each product via:
                            <a-select
                                v-model="saveMassUploadProductVia"
                                style="width: 120px">
                                <a-select-option value="barcode">
                                    Barcode
                                </a-select-option>
                                <a-select-option value="stock_no">
                                    Stock No
                                </a-select-option>
                            </a-select>
                        </label>

                        <br><br>

                        <a-upload-dragger :before-upload="beforeUpload"
                            :remove="handleRemove"
                            :fileList="fileList"
                            :multiple="false" accept=".csv, .CSV">
                            <span class="fa fa-file-import" style="font: 20pt;" />
                            <p class="ant-upload-text">Click or drag file to this area to upload</p>
                            <p class="ant-upload-hint">
                                 Upload your product list in a CSV file following the specified format.
                                 Please upload maximum of {{ maxLines }} lines per batch.
                                 You can download template below.
                            </p>
                        </a-upload-dragger>

                        <br><br>

                        <a-collapse>
                            <a-collapse-panel header="Templates" key="1">
                            <a-list bordered>
                                <a-list-item>
                                <a-list-item-meta description="Contains required data to create a document">
                                    <a @click.prevent="downloadTemplate('1')" slot="title">Download Basic Document Template</a>
                                </a-list-item-meta>
                                <div><a @click.prevent="downloadTemplate('1')"><span class="fa fa-file-download"/></a></div>
                                </a-list-item>
                                <a-list-item v-if="['ORISOX'].includes(currentDocumentTypeCode)">
                                    <a-list-item-meta description="Contains required data to create a document with Discount. Note: Discount Format: 10%,100,L100">
                                        <a @click.prevent="downloadTemplate('3')" slot="title">Download with Discount Document Template</a>
                                    </a-list-item-meta>
                                    <div><a @click.prevent="downloadTemplate('3')"><span class="fa fa-file-download"/></a></div>
                                </a-list-item>
                                <a-list-item v-if="['RELCSI', 'RECCSI'].includes(currentDocumentTypeCode)">
                                    <a-list-item-meta description="Contains required data to create a document with Discount. Note: Discount Format: 10%,100,L100">
                                        <a @click.prevent="downloadTemplate('4')" slot="title">Download with Discount & Salesman Document Template</a>
                                    </a-list-item-meta>
                                    <div><a @click.prevent="downloadTemplate('4')"><span class="fa fa-file-download"/></a></div>
                                </a-list-item>
                                <a-list-item v-if="['RECDEL','RELTRX','RECTRX','RELSLO','RECSLI','OTHPCN','RECADJ','RELADJ'].includes(currentDocumentTypeCode)">
                                <a-list-item-meta description="Contains required data to create a document with lotcode and expiry. Note: Expiry Date format: YYYY-MM-DD Sample: 2014-12-21">
                                    <a @click.prevent="downloadTemplate('2')" slot="title">Download Lot Code & Expiry Document Template</a>
                                </a-list-item-meta>
                                <div><a @click.prevent="downloadTemplate('2')"><span class="fa fa-file-download"/></a></div>
                                </a-list-item>
                            </a-list>
                            </a-collapse-panel>
                        </a-collapse>

                        <br><br>

                        <div class="row">
                            <div class="col-md-12">
                                <base-input :label="import_mode_label">
                                    <base-radio v-if="import_mode_label != 'Import Count Mode'" name="0" class="mb-3" v-model="importMode" value="O">
                                        Add-In
                                    </base-radio>
                                    <base-radio v-if="import_mode_label != 'Import Count Mode'" name="1" class="mb-3" v-model="importMode" value="1">
                                        Override
                                    </base-radio>
                                    <base-radio v-if="import_mode_label == 'Import Count Mode'" name="1" class="mb-3" v-model="importMode" value="1">
                                        Import Count
                                    </base-radio>
                                </base-input>
                            </div>
                        </div>

                    </a-spin>
                </div>
                <div style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                    <button type="button" v-if="massAddProductErrors.length < 1 && csvData != '' && spinning == false" class="btn btn-primary float-right" @click.prevent="importFile">Import</button>
                </div>
            </a-drawer>

            <!-- Drawer for Document header with lines Mass Add -->
            <a-drawer :width="480" placement="right" :key="'importDocumentHeaderWithLine'+massAddDrawerKey" @close="closeDrawer('massAddWithHeader')" :visible="massAddWithHeaderDrawerVisible">
                <h6 class="heading-small text-muted mb-4">Import document header with lines</h6>
                <base-alert v-if="importDocumentHeaderWithLineErrors.length" type="danger">
                    <b>You have the following error(s):</b>
                    <li v-for="error in importDocumentHeaderWithLineErrors" :key="error">{{ error }}</li>
                </base-alert>
               
                <div>
                    <a-spin tip="Validating CSV file" :spinning="spinning">
                        <a-upload-dragger :before-upload="beforeUploadWithHeader"
                            :remove="handleRemove"
                            :fileList="fileList"
                            :multiple="false" accept=".csv, .CSV">
                            <span class="fa fa-file-import" style="font: 20pt;" />
                            <p class="ant-upload-text">Click or drag file to this area to upload</p>
                            <p class="ant-upload-hint">
                                 Upload your product list in a CSV file following the specified format.
                                 Please upload maximum of {{ maxLines }} lines per batch.
                                 You can download template below.
                            </p>
                        </a-upload-dragger>

                    </a-spin>
                </div>
                <div style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                    <button type="button" v-if="importDocumentHeaderWithLineErrors.length < 1 && csvData!='' && spinning == false" class="btn btn-primary float-right" @click.prevent="importFileWithHeader" :disabled="spinning">Import</button>
                </div>
            </a-drawer>

            <!-- Drawer for Document Line Mass Add with Allocation -->
            <a-drawer :width="480" placement="right" @close="closeDrawer('massAddWithAllocation')" :visible="massAddWithAllocationDrawerVisible">
                <h6 class="heading-small text-muted mb-4">Mass Add Products with Allocation in Document Lines</h6>
                <base-alert v-if="massAddWithAllocationProductErrors.length" type="danger">
                    <b>You have the following error(s):</b>
                    <li v-for="error in massAddWithAllocationProductErrors" :key="error">{{ error }}</li>
                </base-alert>
                <div>
                    <a-spin tip="Validating CSV file" :spinning="spinning">
                        <a-upload-dragger :before-upload="beforeUploadWithAllocation"
                            :remove="handleRemove"
                            :fileList="fileWithAllocationList"
                            :multiple="false" accept=".xlsx, .xls">
                            <span class="fa fa-file-import" style="font: 20pt;" />
                            <p class="ant-upload-text">Click or drag file to this area to upload</p>
                            <p class="ant-upload-hint">
                                 Upload your product list in a CSV file following the specified format.
                                 Please upload maximum of {{ maxLines }} lines per batch.
                                 You can download template below.
                            </p>
                        </a-upload-dragger>
                    </a-spin>
                </div>
                <div style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                    <button type="button" v-if="massAddWithAllocationProductErrors.length < 1 && spinning == false" class="btn btn-primary float-right" @click.prevent="importWithAllocationFile">Import</button>
                </div>
            </a-drawer>

            <!-- Drawer for Sublocation Allocation -->
            <a-drawer :width="520" placement="right" :key="'sublocationAllocation'+sublocationAllocationKey" @close="closeDrawer('sublocationAllocation')" :body-style="{ paddingBottom: '80px' }" :visible="sublocationAllocationVisible">
                <h6 class="heading-small text-muted mb-4">{{selectedSublocationAllocationProduct.product_name}}</h6>
                <div>
                    <base-alert v-if="sublocationAllocationErrors.length" type="danger">
                        <b>You have the following error(s):</b>
                        <li v-for="error in sublocationAllocationErrors" :key="error">{{ error }}</li>
                    </base-alert>

                    <div class="row">
                        <div class="col"><h4><b>Quantity: </b>{{selectedSublocationAllocationProduct.quantity}}</h4></div>
                        <div class="col"><h4><b>Remaining Quantity: </b> {{selectedSublocationAllocationProduct.quantity - drawerCurrentSublocationAllocation.reduce((a, {quantity}) => a + parseInt(quantity), 0) }}</h4></div>
                    </div>

                    <hr class="mt-1 mb-2">

                    <div class="row">
                        <div class="col">Sublocation</div>
                        <div class="col">Sublocation Quantity</div>
                    </div>

                    <div class="row">
                        <div class="col">
                            <a-select
                                labelInValue
                                :value="drawerSublocation"
                                placeholder="Select a sublocation"
                                style="width: 100%"
                                :filterOption="false"
                                @dropdownVisibleChange="fetchDrawerSublocations"
                                @change="selectDrawerSublocations"
                                :notFoundContent="fetching ? undefined : null"
                            >
                                <a-spin v-if="fetching" slot="notFoundContent" size="small"/>
                                <a-select-option v-for="s in drawerSublocations" :key="'drawerSublocations'+s.id.toString()">{{s.name}}</a-select-option>
                            </a-select>
                        </div>
                        <div class="col">
                            <a-input v-model='drawerSublocationQuantity' placeholder="Sublocation Quantity" />
                        </div>
                    </div>

                    <div class="row mt-2 mx-1 mb-3">
                        <a-button @click='addDrawerSublocationQuantity' block>Add Sublocation Quantity</a-button>
                    </div>

                    <div class="table-responsive">
                        <table class="table table-bordered table-sm">
                            <thead>
                                <tr>
                                    <th scope="col">Sublocation</th>
                                    <th scope="col">Quantity</th>
                                    <th class="text-center" scope="col">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(data, index) in drawerCurrentSublocationAllocation" v-bind:key="'drawerCurrentSublocationAllocation'+index">
                                    <td class="align-middle">{{ (drawerSublocations.find(x => x.id === parseInt(data.sublocation_id))) ? drawerSublocations.find(x => x.id === parseInt(data.sublocation_id)).name : "Invalid Data. Please Remove" }}</td>
                                    <td class="align-middle">{{data.quantity}}</td>
                                    <td class="text-center"><a-button size="small" @click="removeSublocationAllocation(index)">Remove</a-button></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div v-if="documentStatus!='Posted'"
                        :style="{
                        position: 'absolute',
                        right: 0,
                        bottom: 0,
                        width: '100%',
                        borderTop: '1px solid #e9e9e9',
                        padding: '10px 16px',
                        background: '#fff',
                        textAlign: 'right',
                        zIndex: 1,
                        }"
                    >
                        <a-button @click='saveDrawerSublocationAllocation' type="primary" block>Save</a-button>
                    </div>
                </div>
            </a-drawer>

            <!-- Drawer for Site Allocation -->
            <a-drawer :width="750" placement="right" :key="'siteAllocation'+siteAllocationKey" @close="closeDrawer('siteAllocation')" :body-style="{ paddingBottom: '80px' }" :visible="siteAllocationVisible">
                <h6 class="heading-small text-muted mb-4">{{selectedSiteAllocationProduct.product_name}}</h6>
                <div>
                    <base-alert v-if="siteAllocationErrors.length" type="danger">
                        <b>You have the following error(s):</b>
                        <li v-for="error in siteAllocationErrors" :key="error">{{ error }}</li>
                    </base-alert>

                    <div class="row">
                        <div class="col"><h4><b>Total Quantity: </b>{{selectedSiteAllocationProduct.quantity}}</h4></div>
                    </div>

                    <div class="row" v-if="currentDocumentTypeCode != 'OTHPCK'">
                        <div class="col">
                            <h4>
                                <b>Remaining Quantity: </b>
                                <span v-if="(siteAllocationRemainingQuantity!=null && siteAllocationRemainingQuantity!='') || siteAllocationRemainingQuantity==0">{{siteAllocationRemainingQuantity}}</span>
                                <span v-else>{{selectedSiteAllocationProduct.quantity}}</span>
                            </h4>
                        </div>
                    </div>

                    <hr class="mt-1 mb-2">

                    <div class="row">
                        <div class="col">Site</div>
                        <div class="col">Site Quantity</div>
                    </div>

                    <div class="row">
                        <div class="col">
                            <a-select
                                labelInValue
                                show-search
                                :value="drawerSite"
                                placeholder="Select a site"
                                style="width: 100%"
                                :filterOption="false"
                                @dropdownVisibleChange="fetchDrawerSites"
                                @change="selectDrawerSites"
                                @search="handleSearchDrawerSites"
                                :notFoundContent="fetching ? undefined : null"
                            >
                                <a-spin v-if="fetching" slot="notFoundContent" size="small"/>
                                <a-select-option v-for="s in drawerSites" :key="'drawerSites'+s.id.toString()">{{s.name}}</a-select-option>
                            </a-select>
                        </div>
                        <div class="col">
                            <a-input v-model='drawerSiteQuantity' placeholder="Site Quantity" />
                        </div>
                    </div>

                    <div class="row mt-2 mx-1 mb-3">
                        <a-button @click='addDrawerSiteQuantity' block>Add Site Quantity</a-button>
                    </div>

                    <div class="table-responsive">
                        <table class="table table-bordered table-sm">
                            <thead>
                                <tr>
                                    <th scope="col">Site</th>
                                    <th scope="col">QTY Assigned</th>
                                    <th scope="col">QTY Available</th>
                                    <th scope="col">On-Hand QTY</th>
                                    <th scope="col">Balance</th>
                                    <th v-if="currentDocumentTypeCode != 'OTHPCK'" class="text-center" scope="col">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(data, index) in drawerCurrentSiteAllocation" v-bind:key="'drawerCurrentSiteAllocation'+index">
                                    <td class="align-middle">{{ (drawerSites.find(x => x.id === parseInt(data.site_id))) ? drawerSites.find(x => x.id === parseInt(data.site_id)).name : "Invalid Data. Please Remove" }}</td>
                                    <td class="align-middle">
                                        <a-input v-if="isEditAllocation && isEditAllocationIndex == index" v-model='data.temp_quantity' min="1" type="number" />
                                        <span v-else >{{data.quantity}}</span>
                                    </td>
                                    <td class="align-middle">{{data.available_quantity}}</td>
                                    <td class="align-middle">{{selectedSiteAllocationProduct.on_hand_quantity}}</td>
                                    
                                    <td class="align-middle">{{(parseInt(selectedSiteAllocationProduct.on_hand_quantity) - data.quantity) > 0 ? (parseInt(selectedSiteAllocationProduct.on_hand_quantity) - data.quantity) : 0}}</td>
                                    <td v-if="currentDocumentTypeCode != 'OTHPCK'" class="text-center">
                                        <a-button type="success" size="small" v-if="isEditAllocation && isEditAllocationIndex == index" @click="saveAllocation(index)">Save</a-button>
                                        <a-button type="primary" size="small" v-else @click="editAllocation(index)">Edit</a-button>
                                        <a-button type="danger" size="small" @click="removeSiteAllocation(index)">Remove</a-button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div v-if="documentStatus!='Posted'"
                        :style="{
                        position: 'absolute',
                        right: 0,
                        bottom: 0,
                        width: '100%',
                        borderTop: '1px solid #e9e9e9',
                        padding: '10px 16px',
                        background: '#fff',
                        textAlign: 'right',
                        zIndex: 1,
                        }"
                    >
                        <a-button @click='saveDrawerSiteAllocation' type="primary" block>Save</a-button>
                    </div>
                </div>
            </a-drawer>

            <!-- Drawer for Document Image -->
            <a-drawer :width="960" placement="right" :key="'documentImage'+documentImageKey" @close="closeDrawer('document_image')" :body-style="{ paddingBottom: '80px' }" :visible="documentImageDrawerVisible">

                <h6 class="heading-small text-muted mb-4 text-truncate">Document Image Upload</h6>

                <div class="container">
                    <a-spin tip="Processing Image Upload" :spinning="spinning">
                        <div class="row">
                            <div class='col'>
                                <div class="custom-file">
                                    <input type="file" class="custom-file-input" id="file" ref="file" v-on:change="handleFileUpload()">
                                    <label class="custom-file-label" for="file">Choose file</label>
                                </div>
                            </div>
                            <div class='auto-col'>
                                <a-button class='float-right' size="large" v-on:click="submitFile()">Submit</a-button>
                            </div>
                        </div>
                        <div class="row pt-2 ml-2">
                            <div class='auto-col'>
                                {{ file.name }}
                            </div>
                        </div>

                        <div class='row'>
                            <img style="max-width: 100%; max-height: 100%;" :src="imageFileUrl">
                        </div>
                    </a-spin>
                </div>

            </a-drawer>

            <!-- Drawer for Serialization -->

            <a-drawer :width="520" placement="right" :key="'SerializationKey'+serializationKey" :maskClosable = "false" @close="closeDrawer('serialization')" :body-style="{ paddingBottom: '80px' }" :visible="serializationVisible">
                <h6 class="heading-small text-muted mb-4 text-truncate">Serial Number -  {{ selectedSerialProduct.product_name }}</h6>
                <p>{{`${currentSerialCount} out of ${ previousSerialCount } Serial Number(s) ${ serialMessage }`}}</p>
                <a-progress :percent="Math.floor((currentSerialCount / previousSerialCount ) * 100)" size="small" :format="() => `${currentSerialCount} / ${previousSerialCount}`" v-if="documentStatus !=='Posted'"/>
                <div>
                    <base-alert v-if="serializationErrors.length" type="danger">
                        <b>You have the following error(s):</b>
                        <li v-for="error in serializationErrors" :key="error">{{ error }}</li>
                    </base-alert>

                    <div class="row">
                        <div class="col">
                            <a-input addon-before="Serial Number" style="width: 100%" v-model='inputSerialNumber' @keyup.enter="submitDrawerSerials" v-if="!documentIsRel" />
                            <p v-else-if="documentIsRel  && documentStatus !=='Posted'" >Select from the following serials below:</p>
                        </div>
                        <div class='col-auto'>
                            <a-button type="primary" v-if="documentStatus !== 'Posted' && !documentIsRel" @click='submitDrawerSerials' :disabled='inputSerialNumber==""' >Submit</a-button>
                        </div>
                    </div>

                    <hr>
                    <div class="table-responsive">
                        <table class="table table-bordered table-sm">
                            <thead>
                                <tr>
                                    <th class="text-center" scope="col"></th>
                                    <th scope="col">Serial Number</th>
                                    <th class="text-center" scope="col">{{documentStatus !== 'Posted'? "Action": ""}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(data, index) in currentDrawerSerials" v-bind:key="'currentDrawerSerials'+index">
                                    <!-- <td class="align-middle"><a-checkbox :checked="data.status == 'A'" disabled /></td> -->
                                    <td class="align-middle"><a-checkbox @change="selectSerial" :checked="data.checked" :id="data.serial_no" :disabled="!currentDocumentTypeCode.includes('REL')"  v-if="documentStatus!='Posted'"/></td>
                                    <td class="align-middle">{{data.serial_no}}</td>
                                    <td class="text-center"><a-button size="small" @click="removeSerialNumber(index)" v-if="documentStatus !== 'Posted'" >Remove</a-button></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div v-if="documentStatus!='Posted'"
                        :style="{
                        position: 'absolute',
                        right: 0,
                        bottom: 0,
                        width: '100%',
                        borderTop: '1px solid #e9e9e9',
                        padding: '10px 16px',
                        background: '#fff',
                        textAlign: 'right',
                        zIndex: 1,
                        }"
                    >
                        <a-button @click='saveDrawerSerialization' type="primary" block>Save</a-button>
                    </div>

                </div>
            </a-drawer>

            <!-- Drawer For Refences -->
            <a-drawer
                :width="520"
                placement="right"
                @close="closeDrawer('references')"
                :visible="referenceDrawerVisible"
                v-if="this.document_config != null"
            >
                <h6 class="heading-small text-muted mb-4 text-truncate">Document References</h6>
                <!-- {{this.document_config.document_type_settings.references}} -->

              <div class="row">
                <div class="col text-left">
                  <small>Reference Name</small>
                </div>
                <div class="col text-left">
                  <small>Value</small>
                </div>
              </div>

              <div v-for="reference in document_config.document_type_settings.references" :key="reference.name" class="row pt-2">
                <div class="col">{{reference.name}}</div>
                <div class="col text-left" v-if="documentStatus != 'Posted'">
                    <a-input v-if="_.isEmpty(reference.value)" placeholder="Enter value here" @change="changeReference" v-model="reference.input" :disabled="(reference.name === 'Customer PO#' || reference.name === 'reference') && accountName.toLowerCase().includes('piml')"/>
                    <a-select v-else-if="!_.isEmpty(reference.value)" style="width: 100%" placeholder="Choose value" @change="changeReference" v-model="reference.input">
                        <a-select-option v-for="value in reference.value.split(',')" :key="value" :value="value">{{value}}</a-select-option>
                    </a-select>
                </div>
                <div v-else class="col text-left">
                    <div v-if="_.isUndefined(reference.input)"> - </div>
                    <div v-else>
                        <!-- {{reference.input.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g)}} -->
                        <div v-if="reference.input.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g) !== null">
                            <!-- <a-avatar :src="reference.input" :size="200"/> -->
                            <!-- {{reference.input}} -->
                            <a :href="reference.input"><a-avatar :size="250" :src="reference.input" /></a>
                        </div>
                        <div v-else>{{reference.input}}</div>
                    </div>
                </div>
              </div>
            </a-drawer>

            <!-- Drawer For Extras -->
            <a-drawer
                :width="520"
                placement="right"
                @close="closeDrawer('extras')"
                :visible="extrasDrawerVisible"
            >
                <h6 class="heading-small text-muted mb-4 text-truncate">Document Extras</h6>
                <!-- {{this.document_config.document_type_settings.references}} -->

              <div class="row">
                <div class="col text-left">
                  <small>Extra Atrribute</small>
                </div>
                <div class="col text-left">
                  <small>Value</small>
                </div>
              </div>

              <div v-for="(attribute, value) in documentExtras" :key="attribute" class="row pt-2">
                <div class="col">{{value}}</div>
                <div class="col text-left">
                    {{attribute}}
                </div>
              </div>
            </a-drawer>

            <!-- Drawer For View Allocation -->
            <a-drawer
                :width="1500"
                placement="right"
                @close="closeDrawer('view_allocation')"
                :visible="viewAllocation"
            >
                <h6 class="heading-small text-muted mb-4 text-truncate">Site Allocation</h6>
                <!-- {{this.document_config.document_type_settings.references}} -->
                <div class="table-responsive pt-2">
                    <VueTabulator ref="tabulator1" v-model="documentLines" :options="optionsViewAllocation"/>
                </div>
                <div class="row">
                    <div class="col">
                        <span class="mr-auto font-weight-bold">Total Allocated Quantity: {{totalAllocatedQty}}</span>
                    </div>
                    <div class="col"></div>
                </div>
            </a-drawer>

            <!-- Drawer for Document Payment -->
            <a-drawer :width="960" placement="right" :key="'documentPayment'+documentPaymentsKey" @close="closeDrawer('document_payments')" :body-style="{ paddingBottom: '80px' }" :visible="documentPaymentsDrawerVisible">
                <h6 class="heading-small text-muted mb-4 text-truncate">Document Payments</h6>
                <table style="width:100%">
                    <tr>
                        <th>Payment Mode</th>
                        <th>Amount</th>
                        <th>Reference</th>
                        <th>Payment Date</th>
                    </tr>
                    <tr v-for="p in documentPaymentsList" v-bind:key="'documentPaymentsList'+p.id">
                        <td>{{ p.payment_mode }}</td>
                        <td>{{ p.amount }}</td>
                        <td>{{ p.reference }}</td>
                        <td>{{ moment(p.payment_date).format('MM/DD/YYYY HH:mm') }}</td>
                    </tr>
                </table>
            </a-drawer>

            <!-- Drawer for Ecom Document -->
            <a-drawer title="" :width="600" placement="right" @close="closeDrawer('ecomForm')" :visible="documentEcomDrawerVisible" v-if="documentEcomDrawerVisible">
                <div>
                    <document-ecom-form @closeDrawer="ecomCloseDrawer" v-on:refreshPage="refreshPage" @postOrder="ecomPost" @deleteRow="deleteRow" :ecomAction="ecomAction" :documentDetails="documentDetails"> </document-ecom-form>
                </div>
            </a-drawer>
            <!-- Drawer for lot code and expiry Allocation -->
            <a-drawer :width="520" placement="right" @close="closeDrawer('lotCodeExpiry')" :body-style="{ paddingBottom: '80px' }" :visible="lotCodeExpiryVisible">
                <h3 class="heading-large text-muted mb-4">ITEM: {{ selectedLotCodeExpiryProduct.product_name }} <br> QTY: {{ selectedLotCodeExpiryProduct.quantity }} </h3>
                <div>
                    <hr class="mt-1 mb-2">
                    <div class="row">
                        <div class="col text-left">
                            <h5>Lot Code</h5>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <a-input v-if="!isLotCodeExpiryDisabled" v-model='inputLotCode' placeholder="Lot Code" />
                            <a-select v-else v-model='inputLotCode' @select='selectlotcodeSource' placeholder='Select Lot Code' style="width: 100%;" input-classes="form-control">
                                <a-select-option v-for="s in lotcodeSources" :key="s['id']"> {{ s['lotcode'] }} | {{ moment(String(s['expired_at'])).format('YYYY-MM-DD') }}</a-select-option>
                            </a-select>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col text-left">
                            <h5>Expiry</h5>
                        </div>
                        <div class="col text-left">
                            <h5 v-if="!isLotCodeExpiryDisabled">Quantity</h5>
                            <h5 v-else>Available Quantity: {{ lotcodeAvailableQty }}</h5>
                        </div>
                        <div class="col-auto">
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <a-date-picker v-model='inputExpiryAt' :disabled="isLotCodeExpiryDisabled" :disabled-date="disabledDate" placeholder="Expiry" format="YYYY-MM-DD" />
                        </div>
                        <div class="col">
                            <a-input min="0" type="number" v-model='inputLotCodeQuantity' placeholder="Quantity" />
                        </div>
                        <div class='col-auto'>
                            <a-button type="primary" v-if="documentStatus!='Posted'" @click='submitDrawerLotCodeExpiry' :disabled='inputLotCode=="" || inputExpiryAt == ""' >Add</a-button>
                        </div>
                    </div>
                    <hr>
                    <div class="table-responsive">
                        <table class="table table-bordered table-sm">
                            <thead>
                                <tr>
                                    <th scope="col">Lot Codes</th>
                                    <th scope="col">Expiry Dates</th>
                                    <th scope="col">Quantity</th>
                                    <th class="text-center" scope="col">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(data, index) in currentDrawerLotCodeExpiry" v-bind:key="'lotCodeExpiryKey'+index">
                                    <td class="align-middle">{{data.lot_code}}</td>
                                    <td class="align-middle">{{new Date(data.expiry_at).toLocaleString('en-US', {year: 'numeric', month: 'long', day: 'numeric'})}}</td>
                                    <td class="align-middle" v-if="selectedLotCodeExpiryProduct.product_type == 'P' && currentDocumentTypeCode.includes('REL')">{{data.actual_quantity}}</td>
                                    <td class="align-middle" v-else>{{data.quantity}}</td>
                                    <td class="text-center"><a-button size="small" type="danger"  v-if="documentStatus!='Posted'" @click="removeLotCodeExpiry(index)">Remove</a-button></td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td colspan="2" align="right">
                                        <h3 v-if="selectedLotCodeExpiryProduct.product_type == 'P' && currentDocumentTypeCode.includes('REL')">Lot Code Total Content Quantity</h3>
                                        <h3 v-else>Lot Code Total Quantity</h3>
                                    </td>
                                    <td colspan="2" align="left"><h3>{{ lotcodeTotalQty }}</h3></td>
                                </tr>
                                <tr>
                                    <td colspan="2" align="right">
                                        <h3 v-if="selectedLotCodeExpiryProduct.product_type == 'P' && currentDocumentTypeCode.includes('REL')">Line Content Quantity</h3>
                                        <h3 v-else>Line Quantity</h3>
                                    </td>
                                    <td colspan="2" align="left">
                                        <h3 v-if="selectedLotCodeExpiryProduct.product_type == 'P' && currentDocumentTypeCode.includes('REL')">{{ selectedLotCodeExpiryProduct.quantity * selectedLotCodeExpiryProduct.content_quantity }}</h3>
                                        <h3 v-else>{{ selectedLotCodeExpiryProduct.quantity }}</h3>
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>

                    <div v-if="documentStatus!='Posted'"
                        :style="{
                        position: 'absolute',
                        right: 0,
                        bottom: 0,
                        width: '100%',
                        borderTop: '1px solid #e9e9e9',
                        padding: '10px 16px',
                        background: '#fff',
                        textAlign: 'right',
                        zIndex: 1,
                        }"
                    >
                        <a-button @click='saveDrawerLotCodeExpiry' type="primary" block>Save Lot Code Expiry</a-button>
                    </div>
                </div>
            </a-drawer>

            <!-- drawer for customizeList -->
            <a-drawer title="" width="480" placement="right" @close="()=>{isDrawerVisible = false}" :visible="isDrawerVisible" >
                    <b>Customize Fields</b>
                    <br/>
                    <small>Check the fields that you want to see on the list.</small>
                    <br/>
                    <h3 class="heading-small text-muted list-group-item">Available Fields</h3>
                    <li v-for="field in filteredColumnFields" :key="field.name" class="list-group-item">
                      <a-checkbox :checked="field.value"  @change="onCheck" :id="field.name">
                        {{_.startCase(field.name)}}
                      </a-checkbox>
                    </li>
                    <div class="float-right" style="position: absolute; bottom: 20px; right: 20px">
                      <button class="btn btn-primary float-right" @click.prevent="closeCustomizeListDrawer" > Update List </button>
                    </div>
            </a-drawer>
            <!-- drawer for sort -->
            <a-drawer
                title=""
                :width="800"
                placement="right"
                @close="onCloseSortDrawer"
                :visible="sortDrawerVisibility"
                >
                    <h6 class="heading-small text-muted mb-4">Sort</h6>
                        <sort-drawer :documentTypeCode="currentDocumentTypeCode" @saveSort="saveSort"></sort-drawer>
            </a-drawer>

            <a-modal v-model:open="showPrintingModal" title="Print Details" :maskClosable="false" ok-text="Print" cancel-text="Cancel" :confirm-loading="printBarcodeLoading" @ok="printBarcode()">
                <div class="row">
                    <div class="col-md-12">
                        <base-alert v-if="barcodeTemplateErrors.length" type="danger">
                            <b>You have the following error(s):</b>
                            <li v-for="error in barcodeTemplateErrors" :key="error">{{ error }}</li>
                        </base-alert>
                        <base-input alternative="" label="Select Printer Device" inputClasses="w-100">
                            <a-select
                            ref="select"
                            style="width: 100%"
                            placeholder="Select a Printer"
                            :notFoundContent="fetchingPrinterList ? undefined : null"
                            v-model="selectedPrinter">
                                <a-spin v-if="fetchingPrinterList" slot="notFoundContent" size="small"/>
                                <a-select-option v-for="p in printerList" :value="p">{{p}}</a-select-option>
                            </a-select>
                        </base-input>
                        <base-input alternative="" label="Select Format" inputClasses="w-100">
                            <a-select
                            ref="select"
                            style="width: 100%"
                            placeholder="Select a Template"
                            :notFoundContent="fetchingPrinterFormatList ? undefined : null"
                            @change="changePrinterFormat"
                            v-model="selectedPrinterFormat">
                                <a-spin v-if="fetchingPrinterFormatList" slot="notFoundContent" size="small"/>
                                <a-select-option v-for="p in printerFormatList" :value="p.id">{{p.name}}</a-select-option>
                            </a-select>
                        </base-input>
                        <base-input v-if="selectedPrinterFormat" alternative="" label="Description">
                            <ul>
                            <li v-for="d in selectedBarcodeFormat.descriptionList" :key="`${d + Math.random()}`">
                                {{d}}</li>
                            </ul>
                        </base-input>
                    </div>
                </div> 
                
            </a-modal>
        </div>
        </a-spin>
    </div>
</template>

<script>

    // import VueGoogleAutocomplete from 'vue-google-autocomplete';

    // import VueGoogleAutocomplete from 'vue-google-autocomplete';
    // import {gmapApi} from 'vue2-google-maps';
    import Pusher from 'pusher-js' // import Pusher
    import StockCard from '../Products/StockCard.vue';
    import { mapState, mapActions } from "vuex";
    import HTTPRequest from '../../controllers/httpRequest.js';
    import secureStorage from '../../controllers/secureStorage.js';
    import Autocomplete from "vuejs-auto-complete";
    import ValidateField from '../../components/validateFormUtils.js';
    import { decrypt } from "../../utilities.js"
    import moment from 'moment';
    import axios from "axios";
    import CustomerForm from '../Customer Profiles/CustomerForm.vue';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import DocumentEcomForm from '../Documents/DocumentEcomForm.vue'
    import DocumentApplyToOtherSitesDrawer from './Drawers/DocumentApplyToOtherSitesDrawer.vue';
    import * as XLSX from 'xlsx';
    // import XLSX from 'xlsx';
    import {Epsonfont} from '@/assets/fonts/Epson1-normal'
    import {Epsonfontbold} from '@/assets/fonts/Epson1-bold'
    import SortDrawer from './Drawers/SortDrawer.vue';
    import qz from '../../directives/qz-tray.js';
    import printOthsin from './Mixins/printOthsin';
    import printOthsinWithholding from './Mixins/printOthsinWithholding';
    import printReldde from './Mixins/printReldde';
    import printOripox from './Mixins/printOripox';
    import printOrisox from './Mixins/printOrisox';
    import printReccsr from './Mixins/printReccsr';
    import printReccsrWithholding from './Mixins/printReccsrWithholding';
    import printReltrx from './Mixins/printReltrx';
    import printOthsinPiml from './Mixins/printOthsinPiml';
    import printOthsinPimlHq from './Mixins/printOthsinPimlHq';
    import printOthsinPimpl from './Mixins/printOthsinPimpl';
    import printOrisoxPiml from './Mixins/printOrisoxPiml';
    import printOrisoxPimlHq from './Mixins/printOrisoxPimlHq';
    import printOrisoxPimpl from './Mixins/printOrisoxPimpl';
    import printTov from './Mixins/printTov';
    import printPcv from './Mixins/printPcv';

    import fallbackLogo from '../../assets/report_logo.png';
    var component_x;
    //START OF HISTORY TABLE
    const historyColumns = [
        {
        title: 'Action',
        dataIndex: 'action',
        },
        {
        title: 'Action By',
        dataIndex: 'action_by',
        },
        {
        title: 'Action At',
        dataIndex: 'action_at',
        },
    ];
    const historyData = [];

    const columns = []

    const getNotificationStyle = type => {
        return {
            success: {
                color: 'rgba(0, 0, 0, 0.65)',
                border: '1px solid #b7eb8f',
                backgroundColor: '#f6ffed'
            },
            warning: {
                color: 'rgba(0, 0, 0, 0.65)',
                border: '1px solid #ffe58f',
                backgroundColor: '#fffbe6'
            },
            error: {
                color: 'rgba(0, 0, 0, 0.65)',
                border: '1px solid #ffa39e',
                backgroundColor: '#fff1f0'
            },
            info: {
                color: 'rgba(0, 0, 0, 0.65)',
                border: '1px solid #91d5ff',
                backgroundColor: '#e6f7ff'
            }
        }[type]
    }

    //Start of Charge Table
    const chargeColumns = [
        {   
            title: 'Add On Charge Id',
            dataIndex: 'add_on_charge_id',
        },
        {
            title: 'Description',
            dataIndex: 'name',
        },
        {
            title: 'GL Code',
            dataIndex: 'gl_code',
        },
        {
            title: 'Amount',
            dataIndex: 'amount',
            scopedSlots: { customRender: 'amount' },
            align: 'right'
        },
        {
            title: 'VAT Amount',
            dataIndex: 'vat_amount',
            scopedSlots: { customRender: 'vat_amount' },
            align: 'right'
        },
        {
            title: 'Date',
            dataIndex: 'created_at',
            scopedSlots: { customRender: 'charge_date' },
        },
        {
            title: 'Charge Type',
            dataIndex: 'charge_type',
            scopedSlots: { customRender: 'charge_type' }, 
        },
    ];
    //End of Charge Table

    //Start of Shipment Details Table
    const shipmentDetailColumns = [
        {
            title: 'Description',
            dataIndex: 'name',
        },
        {
            title: 'Amount',
            dataIndex: 'amount',
            scopedSlots: { customRender: 'amount' },
            align: 'right'
        }
    ];
    //End of Shipment Details Table

    //Start of Additional Charge Table
    const additionalChargeColumns = [
        {
            title: 'Description',
            dataIndex: 'name',
        },
        {
            title: 'Weight',
            dataIndex: 'weight',
        },
        {
            title: 'Rate',
            dataIndex: 'rate',
        },
        {
            title: 'Amount',
            dataIndex: 'amount',
            scopedSlots: { customRender: 'amount' },
            align: 'right'
        }
    ];
    //End of Additional Charge Table
    
    //Start of Items for Additional Charge Table
    const itemsAdditionalChargeColumns = [
        {
            title: 'Line #',
            dataIndex: 'line_no',
            align: 'center'
        },
        {
            title: 'Barcode',
            dataIndex: 'barcode',
        },
        {
            title: 'Description',
            dataIndex: 'product_name',
        },
        {
            title: 'RR Quantity',
            dataIndex: 'rr_quantity',
            scopedSlots: { customRender: 'rr_quantity' },
            align: 'right'
        },
        {
            title: 'Inventory Quantity',
            dataIndex: 'quantity',
            scopedSlots: { customRender: 'quantity' },
            align: 'right'
        },
        {
            title: 'Price',
            dataIndex: 'cost',
            scopedSlots: { customRender: 'cost' },
            align: 'right'
        },
        {
            title: 'New Cost',
            dataIndex: 'new_cost',
            scopedSlots: { customRender: 'new_cost' },
            align: 'right'
        },
        {
            title: 'Charge Share',
            dataIndex: 'charge_share',
            scopedSlots: { customRender: 'charge_share' },
            align: 'right'
        },
    ];
    //End of Charge Table

    //DocumentSettings
    const DistributionDocuments = {
        header: {
            showSublocationHeader: true,
            showDocumentHeader: true,
            showSublocationSite: true,
            showSublocationOrigin: true,
            showSublocationDestination: true,
            showPurpose: true,
        },
        headerOriSox: {
            showSublocationHeader: true,
            showDocumentHeader: true,
            showCustomer: false,
            showCustomerType: true,
            showSalesman: true,
            showSublocationSite: true,
            showSublocationDestination: true,
            showOrderSource: false,
        },
        headerRelCsi: {
            showSublocationHeader: true,
            showDocumentHeader: true,
            showCustomer: false,
            showCustomerType: true,
            showSalesman: true,
            showSublocationSite: true,
            showSublocationDestination: true,
            showOrderSource: false,
        },
        headerRelDde: {
            showSublocationHeader: true,
            showDocumentHeader: true,
            showCustomer: true,
            showCustomerType: false,
            showSalesOrder: true,
            showSublocationOrigin: true,
            showSublocationDestination: true,
            showSublocationSite: true,
            showOrderSource: false,
        },
        headerOthSin: {
            showSublocationHeader: true,
            showDocumentHeader: true,
            showCustomer: true,
            showSalesOrder: true,
            showSublocationOrigin: true,
            showSublocationDestination: true,
            showSublocationSite: true,
            showDeliveryDocument: true,
            showOrderSource: true,
        },
        headerRecCsr: {
            showSublocationHeader: true,
            showDocumentHeader: true,
            showCustomer: false,
            showCustomerType: true,
            showDeliveryDocument: true,
            showSublocationDestination: true,
            showSublocationSite: true,
            showOrderSource: false,
        },
        headerOroRso: {
            showDocumentHeader: true,
            showRevenue:false,
            showRequestingSite: true,
        }
    }
    const InterbranchDocuments = {
        //Header
        header: {
            showDocumentHeader: true,
            showSupplier: false,
            showSupplyingSite: true,
            showRequestingSite: true,
            showPurpose: false,
            showParty: false,
        }
    }
    const PurchaseDocuments = {
        //Header
        header: {
            showDocumentHeader: true,
            showSupplier: true,
            showSupplyingSite: false,
            showRequestingSite: false,
            showPurpose: false,
            showParty: false,
        },
        headerOriPox: {
            showDocumentHeader: true,
            showSupplier: true,
            showSupplyingSite: false,
            showRequestingSite: true,
            showPurpose: false,
            showParty: false,
        },
        headerOthSbi: {
            showDocumentHeader: true,
            showSupplier: true,
            showSupplyingSite: false,
            showRequestingSite: false,
            showPurpose: false,
            showParty: false,
            showRecevingReport: true,
            showDocumentBodyHeader:true,
        },
        headerOthLiq: {
            showDocumentHeader: true,
            showSupplier: false,
            showSupplyingSite: false,
            showRequestingSite: true,
            showPurpose: true,
            showParty: true,
            showRecevingReport: false,
            showCompanyDetails: true,
            showCustomerType: true,
            showCustomer: true,
        },
    }
    const LocalDocuments = {
        headerAdjustments: {
            showDocumentHeader: true,
            showSupplyingSite: false,
            showRequestingSite: false,
            showPurpose: true,
            showParty: true,
        }
    }
    const PCount = {
        header: {
            showDocumentHeader: true,
            showSupplyingSite: false,
            showRequestingSit: false,
            showPurpose: false,
            showParty: false,
            showSublocation: true

        }
    }
    const PriceWorkSheet = {
        header: {
            showDocumentHeader: true,
            showSupplier: false,
            showParty: false,
            showForThisSite: true,
            showApplyDocumentToOtherSitesButton: true,
            showSaveProductVia: true,
            showBrand: true,
        }
    }
    const BarcodePrinting = {
        header: {
            showDocumentHeader: true,
            showSupplier: false,
            showParty: false,
            showForThisSite: false,
        }
    }
    const TransferAllocationDocumentPicking = {
        header: {
            showDocumentHeader: true,
            showSupplyingSite: true,
        }
    }
    const CountSet = {
        header: {
            showDocumentHeader: false,
            showSupplyingSite: false,
            showRequestingSit: false,
            showPurpose: false,
            showParty: false,
        }
    }

    export default {
        mixins: [
            printOrisox,
            printReldde,
            printOthsin,
            printOthsinWithholding,
            printOripox,
            printReccsr,
            printReccsrWithholding,
            printReltrx,
            printOthsinPiml,
            printOthsinPimlHq,
            printOthsinPimpl,
            printOrisoxPiml,
            printOrisoxPimlHq,
            printOrisoxPimpl,
            printTov,
            printPcv,
        ],
        components: {
            Autocomplete,
            StockCard,
            CustomerForm,
            DocumentEcomForm,
            DocumentApplyToOtherSitesDrawer,
            SortDrawer
            // VueGoogleAutocomplete
        },
        data: function() {
            return {
                is_updated: 0,
                tovsiModal: false,
                si_source: false,
                si_destination: false,
                selectedCustomerType: 'b2b',
                selectedCustomer: null,
                selectedB2bCustomer: null,
                b2bCustomerOptions: [],
                b2bCustomer: [],
                docTypesForOM:['ORISOX', 'RELDDE', 'OTHSIN','RECCSR','OTHLIQ','OTHSRQ'],
                docTypesForIM:['ORIPOX','ORIASN','OTHPUR','RELRSR','RECDEL'],
                docTypesForP2P: ['ORIPOX', 'ORIASN', 'OTHSBI', 'OTHPUR', 'RELRSR', 'RECDEL'],
                docTypesForOMGT: ['ORISOX', 'RELDDE', 'OTHSIN', 'RECCSR', 'ORORSO', 'ORIOSO', 'ORIOCR', 'RECCSI', 'OTHSRQ'],
                docTypesForTransDoc: ['RECTRX', 'RELTRX', 'RELCSX', 'RECCSX', 'OTHLIQ'],
                showImageRefLink: ['RECTRX', 'RELTRX', 'OTHPCN', 'OTHPCV', 'OTHTOV'],
                countryOfOriginOptions: [],
                site: {},
                company: null,
                company_id: null,
                imageReferenceLink: '',
                ocReferenceNo: '',
                shipmentReferenceNo: '',
                orderType: '',
                countryOfOrigin: {},
                fiscalYear: '',
                yearSeason: '',
                noOfCartons: '',
                liqPeriod: '',
                country: '',
                address: '',
                province: '',
                city: '',
                barangay: '',
                zipCode: '',
                b2bCustomerSource: '',
                b2bCustomerDestination: '',
                province_destination:'',
                city_destination:'',
                barangay_destination:'',
                zipCode_destination:'',
                party_tax_type_destination:'',
                paymentTerm_destination:'',
                wTax_destination:'',
                province_source:'',
                city_source:'',
                barangay_source:'',
                zipCode_source:'',
                party_tax_type_source:'',
                paymentTerm_source:'',
                wTax_source:'',
                proceed_ir_to: 0,
                proceed_resolution: 0,
                proceed_voiding: 0,
                allowZeroCost: 0,
                autoRepMinMaxAccess: 0,
                autoRepOfftakeAccess: 0,
                purchaseVarianceAccess: 0,
                overrideMinMaxProducts: '',
                minMaxProducts: [],
                interval: null,
                overrideOfftakeProducts: '',
                offtakeProducts: [],
                backLink: "/documents?type=" + secureStorage.getItem("documentTypeInternalCode"),
                isRefreshInventory: false,
                friendlyCodeAndDocumentNo: '',
                friendlyOriginDocumentNo: '',
                documentId: '',
                documentNo: 0,
                casNo: '',
                importMode: 0,
                importLotCode: 0,
                confirmLoadingonSuppModal: false,
                confirmLoadingonMinMaxModal: false,
                showChangeSupplierModal: false,
                modalInternalDocumentId: false,
                modalMinMaxProducts: false,
                modalAdditionalCharges: false,
                chargeDistributionQuantity: 1,
                itemCostLayerData: [],
                totalCharges: 0,
                totalVatCharges: 0,
                totalPurchaseVariance: 0,
                modalMinMaxProducts: false,
                modalOffTakeProducts: false,
                offtakeDays: 60,
                // for product_icon
                icon_code: JSON.parse(localStorage.getItem("businessTypeCode")),

                // for customizing column fields per document type
                documentTableFilteredList: secureStorage.getItem("documentTableFilteredList"),
                defaultColumnFields : [
                  { name: "line_no", value: true },
                  { name: "product_icon", value: true },
                  { name: "stock_no", value: true },
                  { name: "product_name", value: true },
                  { name: "barcode", value: true },
                  { name: "unit_id", value: true },
                  { name: "quantity", value: true },
                  { name: "price", value: true },
                  { name: "cost", value: true },
                  { name: "subtotal", value: true },
                  { name: "discount_text", value: true },
                  { name: "discount", value: true },
                  { name: "on_hand_quantity", value: true },
                  { name: "remarks", value: true },
                  { name: "available_quantity", value: false },
                ],
                filteredColumnFields : [],
                isDrawerVisible: false,

                popUpModal:{
                  isVisible: false,
                  toClear:false,
                  isAutoPopulate:false,
                  initializeProcess:"",
                  message:"",
                  text:""
                },
                showAddingProgress:{
                  isVisible: false,
                  productCount:0,
                  productAdded:0
                },
                
                //1935
                overallDiscountWithoutSupportDiscount: 0,
                import_mode_label: 'Import Mode',

                // BOOKING DATA
                bookingId: null,
                activeBooking: false,
                recomputeModal: false,
                recompute: false,
                applyDocumentToOtherSitesDrawer: false,
                saveMassUploadProductVia: "barcode",
                originalGeoLocation: {},
                bookingDetails: {},
                printFontSizeIncrease: 0,
                printValueHeaderPos: 0,
                printValueFooterPos: 0,
                // printPaperSize: 'a4',
                mapKey: 0,
                center: {
                  lat: 10.0,
                  lng: 10.0
                },
                markers: [{
                  id: 1,
                  position: {
                    lat: 10.0,
                    lng: 10.0
                  }
                }, {
                  id: 2,
                  position: {
                    lat: 11.0,
                    lng: 11.0
                  }
                }],
                from_address: {},

                suppDetails: {},

                options: {
                    height:"100%",
                    pagination:"local",
                    paginationSize:10,
                    // http://tabulator.info/docs/4.2/page#element
                    paginationSizeSelector: [10,20,30,40,50],
                    selectable:true,
                    rowSelectionChanged: this.rowSelectionChanged,
                    //downloadDataFormatter: this.downloadDataFormatter,
                    downloadConfig:{
                        columnCalcs:false,
                    },
                    addRowPos:"bottom",
                    movableColumns:true,
                    index: "line_no",
                    columns: [
                        {
                            frozen: true,
                            formatter:"rowSelection",
                            titleFormatter:"rowSelection",
                            download: false,
                            headerSort:false,
                        },
                        {
                            title: '#',
                            field: 'line_no',
                            sorter: 'number',
                            frozen: true,
                            visible: false,
                        },
                        {
                            field: 'product_icon',
                            frozen: true,
                            visible: false,
                            download: false,
                            formatter: this.iconFormatter
                        },
                        {
                            title: 'Brand',
                            field: 'brand_id',
                            sorter: 'string',
                            download: true,
                            visible: true,
                            frozen: true,
                            formatter: this.brandFormatter,
                            cellClick: function(e, cell) { e.stopPropagation(); }
                        },
                        {
                            title: 'Stock No',
                            field: 'stock_no',
                            sorter: 'number',
                            frozen: true,
                            visible: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Description',
                            field: 'product_name',
                            editor: 'input',
                            sorter: 'string',
                            frozen: false,
                            editable: this.isCellEditable,
                            visible: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Style Name',
                            field: 'style_name',
                            editor: 'input',
                            sorter: 'string',
                            frozen: true,
                            visible: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Supplier Stock No.',
                            field: 'supplier_stock_no',
                            sorter: 'number',
                            formatter: this.supplierStockNumber,
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Design',
                            field: 'design',
                            sorter: 'string',
                            formatter: this.designFormatter,
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Size',
                            field: 'size',
                            sorter: 'number',
                            // formatter: this.sizeFormatter,
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Color',
                            field: 'color',
                            sorter: 'string',
                            formatter: this.colorFormatter,
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        // {
                        //     title: 'Code',
                        //     field: 'product_id',
                        //     sorter: 'number',
                        //     visible: false,
                        //     download: false,
                        // },
                        {
                            title: 'Ref Code',
                            field: 'ref_code',
                            sorter: 'number',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Site',
                            field: 'site_liquidation',
                            sorter: 'string',
                            download: false,
                            visible: false,
                        },
                        {
                            title: 'Barcode',
                            field: 'barcode',
                            sorter: 'number',
                            visible: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Alternate Barcode',
                            field: 'alternate_barcode',
                            sorter: 'string',
                            visible: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Unit',
                            field: 'unit_id',
                            visible: false,
                            sorter: 'string',
                            editor: "select",
                            formatter: this.unitFormatter,
                            editorParams: this.unitLookup,
                            editable: this.isCellEditable,
                            accessorDownload: this.unitAccessor,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Item Source',
                            field: 'item_source',
                            sorter: 'string',
                            visible: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Quantity',
                            field: 'quantity',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            editorParams:{
                                min:0,
                                max:10000000,
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: this.isCellEditable,
                            validator: this.validateQuantity,
                            visible: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Ordered Quantity',
                            field: 'ordered_quantity',
                            sorter: 'number',
                            align: 'right',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Requested Quantity',
                            field: 'requested_quantity',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            editorParams:{
                                min:0,
                                max:10000000,
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: this.isCellEditable,
                            validator: this.validateQuantity,
                            visible: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Quantity',
                            field: 'quantity',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            editorParams:{
                                min:0,
                                max:10000000,
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: this.isCellEditable,
                            validator: this.validateQuantity,
                            visible: false,
                            tooltip: this.quantityTooltip,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Reason',
                            field: 'reason_id',
                            visible: false,
                            sorter: 'string',
                            editor: "select",
                            download: false,
                            formatter: this.reasonFormatter,
                            editorParams: this.reasonLookup,
                            //editable: this.isCellEditable,
                            //accessorDownload: this.unitAccessor,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Sub Location',
                            field: 'sublocation',
                            visible: false,
                            sorter: 'string',
                            editor: "select",
                            download: false,
                            formatter: (cell) => this.sublocationFormatter(cell),
                            editorParams: this.sublocationLookup,
                            editable: this.isCellEditable,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Actual Yield Quantity',
                            field: 'actual_yield',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            editorParams:{
                                min:0,
                                max:10000000,
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: this.isCellEditable,
                            validator: this.validateQuantity,
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Delivery Quantity',
                            field: 'delivery_quantity',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            download: false,
                            editorParams:{
                                min:0,
                                max:10000000,
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: this.isCellEditable,
                            validator: this.validateQuantity,
                            visible: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Goods Issue Quantity',
                            field: 'goods_issue_quantity',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            editorParams:{
                                min:0,
                                max:10000000,
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: this.isCellEditable,
                            validator: this.validateQuantity,
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Frozen Quantity',
                            field: 'frozen_quantity',
                            sorter: 'number',
                            align: 'right',
                            visible: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Balance Quantity',
                            field: 'content_quantity',
                            sorter: 'number',
                            align: 'right',
                            download: false,
                            visible: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Delivered Quantity',
                            field: 'content_quantity',
                            sorter: 'number',
                            align: 'right',
                            download: false,
                            visible: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Actual Quantity',
                            field: 'actual_quantity',
                            sorter: 'number',
                            align: 'right',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Remaining Qty',
                            field: 'remaining_qty',
                            sorter: 'number',
                            align: 'right',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'On-Hand Quantity',
                            field: 'on_hand_quantity',
                            sorter: 'number',
                            align: 'right',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'POS Sales Quantity',
                            field: 'pos_sales_quantity',
                            sorter: 'number',
                            align: 'right',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'POS Return Quantity',
                            field: 'pos_return_quantity',
                            sorter: 'number',
                            align: 'right',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Avail Qty to Transact',
                            field: 'avail_qty_to_transact',
                            sorter: 'number',
                            align: 'right',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'STO Quantity',
                            field: 'sto_qty',
                            sorter: 'number',
                            align: 'right',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'STI Quantity',
                            field: 'sti_qty',
                            sorter: 'number',
                            align: 'right',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Variance Quantity',
                            field: 'variance_quantity',
                            sorter: 'number',
                            align: 'right',
                            visible: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Unit Cost',
                            field: 'price',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            formatter: 'money',
                            bottomCalc:"sum",
                            download: true,
                            editorParams:{
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: this.isCellEditable,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Currency',
                            field: 'currency',
                            sorter: 'string',
                            align: 'right',
                            download: false,
                            editable: false,
                            visible: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Unit Cost (PHP)',
                            field: 'price_php',
                            sorter: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            visible: false,
                            download: false,
                            formatter: this.phpFormatter,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },

                        {
                            title: 'PI Price',
                            field: 'price_pi',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            download: false,
                            editorParams:{
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: this.isCellEditable,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Net Cost (PHP)',
                            field: 'cost_php',
                            sorter: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            visible: false,
                            download: false,
                            formatter: this.phpFormatter,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Discount Text',
                            field: 'discount_text',
                            sorter: 'string',
                            editor: 'input',
                            align: 'right',
                            download: false,
                            validator: this.validateTableDiscount,
                            editorParams:{
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: this.isCellEditable,
                            visible: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Net Amount',
                            field: 'net_amount',
                            sorter: 'number',
                            align: 'right',
                            visible: false,
                            download: false,
                            formatter: 'money',
                            editable: this.isCellEditable,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Unit Net Cost',
                            field: 'cost',
                            sorter: 'number',
                            align: 'right',
                            visible: false,
                            download: false,
                            formatter: 'money',
                            editable: this.isCellEditable,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Unit Net Cost',
                            field: 'net_cost',
                            sorter: 'number',
                            align: 'right',
                            visible: false,
                            download: false,
                            formatter: 'money',
                            editable: this.isCellEditable,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Gross Amount',
                            field: 'gross_amount',
                            sorter: 'number',
                            align: 'right',
                            download: false,
                            bottomCalc:"sum",
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Subtotal',
                            field: 'subtotal',
                            sorter: 'number',
                            align: 'right',
                            download: true,
                            bottomCalc:"sum",
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Subtotal (PHP)',
                            field: 'subtotal_php',
                            sorter: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            download: false,
                            visible: false,
                            formatter: this.phpFormatter,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Total Gross',
                            field: 'total_gross',
                            sorter: 'number',
                            align: 'right',
                            mutator: this.totalGrossMutator,
                            bottomCalc:"sum",
                            download: false,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Total Gross (PHP)',
                            field: 'total_gross_php',
                            sorter: 'number',
                            align: 'right',
                            download: false,
                            bottomCalc:"sum",
                            visible: false,
                            formatter: this.phpFormatter,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Discount Amount',
                            field: 'discount',
                            sorter: 'number',
                            bottomCalc:"sum",
                            visible: false,
                            download: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Discount Text',
                            field: 'discount_text',
                            sorter: 'string',
                            editor: 'input',
                            align: 'right',
                            download: false,
                            validator: this.validateTableDiscount,
                            editorParams:{
                                elementAttributes:{
                                    maxlength:"18",
                                }
                            },
                            editable: this.isCellEditable,
                            visible: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Ordering Cost',
                            field: 'prod_ordering_cost',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            download: false,
                            editorParams:{
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: this.isCellEditable,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Currency',
                            field: 'pur_currency',
                            sorter: 'string',
                            align: 'right',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Total Ordering Cost',
                            field: 'total_ordering_cost',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            visible: false,
                            download: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Barcode UPC',
                            field: 'barcode_upc',
                            sorter: 'number',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Barcode EAN',
                            field: 'barcode_ean',
                            sorter: 'number',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Factory Name',
                            field: 'factory_name',
                            sorter: 'string',
                            visible: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Subtotal(ORD)',
                            field: 'prod_ordering_cost_subtotal',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            download: false,
                            editorParams:{
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: false,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Old Retail Price',
                            field: 'old_retail_price',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            download: false,
                            editorParams:{
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: false,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'New Retail Price',
                            field: 'retail_price',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            download: false,
                            editorParams:{
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: this.isCellEditable,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Markup %',
                            field: 'markup_percent',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            download: false,
                            editorParams:{
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: this.isCellEditable,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Old Original',
                            field: 'old_original_cost',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            download: false,
                            editorParams:{
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: false,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'New Original',
                            field: 'original_cost',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            download: false,
                            editorParams:{
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: this.isCellEditable,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Standby Cost',
                            field: 'standby_landed_cost',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            download: false,
                            editorParams:{
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: false,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Old Landed',
                            field: 'old_landed_cost',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            download: false,
                            editorParams:{
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: false,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'New Landed',
                            field: 'landed_cost',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            download: false,
                            editorParams:{
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: this.isCellEditable,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Old Ordering',
                            field: 'old_ordering_cost',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            download: false,
                            editorParams:{
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: false,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'New Ordering',
                            field: 'ordering_cost',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            download: false,
                            editorParams:{
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: this.isCellEditable,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Old Special Price',
                            field: 'old_special_price',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            download: false,
                            editorParams:{
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: false,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'New Special Price',
                            field: 'special_price',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            download: false,
                            editorParams:{
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: this.isCellEditable,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Old Whosale Price',
                            field: 'old_wholesale_price',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            download: false,
                            editorParams:{
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: false,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'New Whosale Price',
                            field: 'wholesale_price',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            download: false,
                            editorParams:{
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: this.isCellEditable,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Old Least Price',
                            field: 'old_least_price',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            download: false,
                            editorParams:{
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: false,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'New Least Price',
                            field: 'least_price',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            download: false,
                            editorParams:{
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: this.isCellEditable,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'New PIML Price1',
                            field: 'piml_price1',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            download: false,
                            editorParams:{
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: this.isCellEditable,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'New PIML Price2',
                            field: 'piml_price2',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            download: false,
                            editorParams:{
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: this.isCellEditable,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'New PIML Price3',
                            field: 'piml_price3',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            download: false,
                            editorParams:{
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: this.isCellEditable,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Invoice Amount',
                            field: 'invoice_amount',
                            sorter: 'number',
                            align: 'right',
                            visible: false,
                            download: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Invoice Discount',
                            field: 'invoice_discount',
                            sorter: 'number',
                            align: 'right',
                            visible: false,
                            download: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Unit Price (v)',
                            field: 'unit_price_vat',
                            sorter: 'number',
                            align: 'right',
                            visible: false,
                            download: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Net Price (v)',
                            field: 'net_price_vat',
                            sorter: 'number',
                            align: 'right',
                            download: false,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Subtotal (v)',
                            field: 'subtotal_vat',
                            sorter: 'number',
                            align: 'right',
                            download: false,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Unit Price (nv)',
                            field: 'unit_price_no_vat',
                            sorter: 'number',
                            align: 'right',
                            visible: false,
                            download: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Net Price (nv)',
                            field: 'price_without_vat',
                            sorter: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Subtotal (nv)',
                            field: 'subtotal_without_vat',
                            sorter: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            visible: false,
                            download: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Effective Discount',
                            field: 'effective_discount',
                            sorter: 'number',
                            align: 'right',
                            download: false,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Incoming Quantity',
                            field: 'incoming_quantity',
                            sorter: 'number',
                            align: 'right',
                            download: false,
                            visible: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: '#',
                            width: '10%',
                            field: 'code_and_document_no',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Document ID',
                            width: '10%',
                            field: 'id',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Reference',
                            width: '10%',
                            field: 'reference_1',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Document Date',
                            width: '10%',
                            field: 'document_date',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Total Quantity',
                            width: '10%',
                            field: 'total_quantity',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Discount Total Amount',
                            field: 'discount_total_amount',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            visible: false,
                            download: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Invoice Total',
                            field: 'invoice_total',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            visible: false,
                            download: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Ordering Cost',
                            field: 'ordering_cost',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            visible: false,
                            download: false,
                            formatter: 'money',
                            editable: this.isCellEditable,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Margin',
                            field: 'margin',
                            align: 'right',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Trade Commission Rate',
                            field: 'trade_commission_rate',
                            align: 'right',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Trade Discount',
                            field: 'trade_discount',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            editable: false,
                            bottomCalc:"sum",
                            visible: false,
                            download: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Interco Payable',
                            field: 'interco_payable',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            visible: false,
                            download: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Net Receivable',
                            field: 'net_receivable',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            visible: false,
                            download: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'CS Quantity',
                            field: 'cs_quantity',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            visible: false,
                            download: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'CS Amount',
                            field: 'cs_amount',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            visible: false,
                            download: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Variance Quantity',
                            field: 'cs_variance_quantity',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            visible: false,
                            download: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Variance Amount',
                            field: 'cs_variance_amount',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            visible: false,
                            download: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        
                        {
                            title: 'Status',
                            width: '10%',
                            field: 'status',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Order Status',
                            width: '15%',
                            field: 'order_status',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Created By',
                            width: '15%',
                            field: 'created_by',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Updated By',
                            width: '15%',
                            field: 'updated_by',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Remark',
                            field: 'remarks',
                            editor: 'input',
                            sorter: 'string',
                            visible: false,
                            download: false,
                            editable: this.isCellEditable,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Salesman',
                            field: 'salesman_name',
                            editor: 'input',
                            sorter: 'string',
                            visible: false,
                            download: false,
                            editable: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Sublocation Alloation',
                            field: 'sublocation_allocation',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Product Type',
                            field: 'product_type',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Serial No',
                            field: 'document_line_serials_text',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Lot Code',
                            field: 'document_line_lot_code',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Expiry',
                            field: 'document_line_expiry',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Available Quantity',
                            field: 'available_quantity',
                            sorter: 'number',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Vendor Item No.',
                            field: 'vendor_item_no',
                            sorter: 'string',
                            download: false,
                            visible: true,
                        },
                        {
                            title: 'Extras',
                            field: 'line_extras',
                            editor: 'textarea',
                            visible: false,
                            download: false,
                            editable: true,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                    ],
                },
                historyData,
                historyColumns,

                processingCsvUpload: false,
                CsvUploadParams: {},

                //Global
                spinning: false,
                spinning2: false,
                spinMessage: 'Loading..',
                documentNumber: -1,
                originDocumentNumber: -1,
                originDocumentTypeId: 0,
                originDocumentTypeName: null,
                originDocumentCodeAndNumber:"",
                documentStatus: null,
                documentOrderStatus: null,

                notifMessage: [],
                document_config: null,
                currentDocumentTypeId: null,
                currentDocumentTypeName: null,
                currentDocumentTypeCode: null,
                currentDocumentTypeFriendlyCode: null,
                currentDocumentTypeFriendlyCodeWithId: "",
                headerStatusIcon: '',
                headerOrderStatusIcon: '',

                //Configuration
                maximumDocumentLineNumber: 200,
                decimalPlaces: 2,

                //Document Header
                    header: {
                        showDocumentHeader: false,
                        showSupplier: false,
                        showSupplyingSite: false,
                        showRequestingSite: false,
                        showPurpose: false,
                        showParty: false,
                    },

                    orderTypeOptions: [
                        {key: "Main Buy", value: "Main Buy"},
                        {key: "2nd Buy", value: "2nd Buy"},
                        {key: "3rd Buy", value: "3rd Buy"},
                        {key: "4th Buy", value: "4th Buy"},
                        {key: "5th Buy", value: "5th Buy"},
                        {key: "6th Buy", value: "6th Buy"},
                        {key: "Additional Order", value: "Additional Order"},
                        {key: "ATS/Chase Buy", value: "ATS/Chase Buy"},
                        {key: "Collab", value: "Collab"},
                        {key: "Custom Order", value: "Custom Order"},
                        {key: "NT", value: "Non Trade"},
                        {key: "SMU", value: "SMU"},
                        {key: "JANDRP", value: "Jan Drop"},
                        {key: "FEBDRP", value: "Feb Drop"},
                        {key: "MARDRP", value: "Mar Drop"},
                        {key: "APRDRP", value: "Apr Drop"},
                        {key: "MAYDRP", value: "May Drop"},
                        {key: "JUNDRP", value: "Jun Drop"},
                        {key: "JULDRP", value: "Jul Drop"},
                        {key: "AUGDRP", value: "Aug Drop"},
                        {key: "SEPDRP", value: "Sep Drop"},
                        {key: "OCTDRP", value: "Oct Drop"},
                        {key: "NOVDRP", value: "Nov Drop"},
                        {key: "DECDRP", value: "Dec Drop"}
                    ],
                    fiscalYearOptions: [],

                    //For all
                    fetching: false,
                    sites: [],

                    // Brand
                    brand: [],
                    brands: [],
                    isBrandDisabled: false,

                    //Suppliers
                    supplier: [],
                    suppliers: [],
                    isSupplierDisabled: false,
                    showSupplierOptions: false,
                    isTradeToggleDisabled: false,
                    showTradeToggle: false,

                    //Supplying Site
                    supplyingSite: [],
                    isSupplyingSiteDisabled: false,

                    //PWS Access Rights
                    accessPWSCost: false,
                    accessPWSPrice: false,
                    withRR: false,

                    //Requesting Site
                    requestingSite: [],
                    isRequestingSiteDisabled: false,

                    //Revenue Site
                    revenue:'',
                    isRevenueDisabled: false,

                    //Distributon
                    sublocations: [],
                    distributionSite: [],
                    isDistributionSiteDisabled: false,
                    originSublocation: [],
                    isOriginSublocationDisabled: false,
                    destinationSublocation: [],
                    isDestinationSublocationDisabled: false,
                    sublocationOriginLabel: 'Sublocation Origin',
                    sublocationDestinationLabel: 'Sublocation Destination',
                    showHeaderDiscount: false,

                    customer: [],
                    customers: [],
                    isCustomerDisabled: false,
                    isCustomerCreateDisabled: false,

                    salesman: {},
                    salesmen: [],
                    isSalesmanDisabled: false,

                    salesOrder: 0,
                    isSalesOrderDisabled: true,

                    deliveryDocument: 0,
                    isDeliveryDocumentDisabled: true,

                    isRecevingReportDisabled: true,
                    receivingReport: 0,

                    // Purpose and Party
                    purpose: [],
                    purposes: [],
                    party: '',

                    isPurposeDisabled: false,
                    isPartyDisabled: false,

                    //Add Product / Search Product
                    showDocumentBodyHeader: true,
                    productFormMode: "Add",
                    productFormModeOptions: [
                        { label: 'Add Products to this Document', value: 'Add' },
                        { label: 'Search within this Document', value: 'Search' },
                    ],
                    productSearchInput: '',
                    addedProductSearchInput: '',

                    selectedParentProduct: [],
                    selectedProduct: [],

                    //Search Filter
                    placeholder: "Search product by barcode",
                    addedProductPlaceholder: "Search added product by barcode",
                    searchFilter: "barcode",
                    searchFilterAddedProduct: "barcode",

                    //Product Search
                    authHeaders: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress") },
                    isProductSearchDisabled: false,

                    //Product Name
                    isProductNameEditConfigDisabled: false,
                    isPriceCostEditConfigDisabled: false,
                    isProductNameDisabled: true,
                    isPriceCostDisabled: true,
                    productName: '',
                    inputProduct: '',
                    productPriceChoice: 'landed_cost', //Default from config is landed_cost

                    //Document Line Form
                    isDocumentLineFormDisabled: true,
                    quantity: '',
                    actual_yield: '',
                    tolerance_quantity: '',
                    unit: [],
                    units: [],
                    productComposition: [],
                    productCompositions: [],
                    unitQuantity: 1,
                    unitCost: '',
                    discountText: [],
                    unitNetCost: '',
                    subTotal: '0.00',
                    retailPrice: 0,

                    promoName: null,
                    rewardCode: null,
                    rewardDiscountAmount: 0,

                    discountTotal: 0,

                    showPwsCosts: false,
                    showQuantity: true,
                    showActualYield: false,
                    showUnitCost: true,
                    showDiscount: true,
                    showUnitNetCost: true,
                    showSubtotal: true,
                    actionDocumentButton:false,

                    //isDirtyData
                    isEditing: false, // track unsaved changes
                    isChangeAction: false,

                    //Document Form Table

                    selectedDocumentLines: [],
                    origData: [],
                    data: [],
                    columns,

                //Summary
                totalQuantity: 0,
                grossAmountDisplay: 0.00,
                netAmountDisplay: 0.00,
                grossAmount: 0.00,
                itemDiscount: 0.00,
                overallDiscount: 0.00,
                netAmount: 0.00,
                vatAmount: 0.00,
                totalWithVat: 0.00,
                taxRate: 0,
                grossAmountwithoutTax: 0.00,
                netAmountWithoutTax: 0.00,

                documentDate: moment(new Date()),
                targetDate:  moment(new Date()).add('1', 'days'),
                cancellationDate: moment(new Date()).add('30', 'days'),
                showTargetDate: true,
                showCancellationDate: true,

                headerDiscount: [],

                supportDiscount: [],
                showSupportDiscount: false,
                isSupportDiscountValid: true,

                isHeaderDiscountDisabled: false,
                isDocumentDateDisabled: false,
                isTargetDateDisabled: false,
                isCancellationDateDisabled: false,

                vatExclusiveCheckbox: false,
                showVatExclusiveCheckboxConfig: true,
                showVatExclusiveCheckbox: false,
                showSummaryCalculation: true,
                showTotalQuantity: true,

                party_tax_type: null,
                supplierVatType: null,
                customerVatType: null,
                

                //Advanced Info
                paymentTerm: [],
                paymentTerms: [],

                shippingMethod: [],
                shippingMethods: [],
                showShippingMethod: false,

                showAdvancedInfo: false,
                isReferenceDisabled: false,
                isPaymentTermDisabled: false,
                isShippingMethodDisabled: false,
                isSupportsDiscountDisabled: false,

                reference : '',
                reference1 : '',
                remark: '',
                remarkLabel: 'Remark',
                fieldMaxLength: 255,
                focusedLengthField: null,
                isIntegrated: 0,

                //Charge Table and Drawer
                disableSaveCharges: false,
                chargeData: [],
                additionalChargeData: [],
                additionalChargeSelectedRowKeys: [],
                chargeSelectedRowKeys: [],
                chargeColumns,
                additionalChargeColumns,
                itemsAdditionalChargeColumns,
                chargeDrawerVisible: false,
                chargeType: 'R',
                chargeTypeOptions: [
                    {key: "R", value: "Regular Charge"},
                    {key: "W", value: "Weighted Charge"}
                ],
                isAddChargeDisabled: false,

                shipmentDetailColumns,
                shipmentDetailData: [],

                chargeDescription: null,
                chargeWeight: 0,
                chargeRate: 0,
                chargeAmount: 0,
                isChargeWeightDisabled: true,
                isChargeRateDisabled: true,
                isChargeAmountDisabled: false,
                showChargesTable: false,

                //Booking Integration
                showBookingButton: false,
                bookingDrawerVisible: false,
                siteAddress: null,
                siteContactPerson: null,
                siteContactNumber: null,
                addressEditMode: false,
                deliveryMode: "8",
                orderParemeters: {},

                // payments
                paymentDrawerVisible: false,
                initialDepositDrawerVisible:false,
                paymentMode: "paymaya",
                paymentMethod: null,
                paymentMethods: [],
                bankTransferReference: '',
                baseUrl: "https://test.dragonpay.ph/api/collect/v2",

                // Document Footer Actions
                isSaveDisabled: false,
                isUpdateDisabled: false,
                isPostDisabled: false,
                showconfirmUnconfirmButton: false,
                showCreateChildDocButton: false,
                createChildDocButtonLabel: '',
                showDeliverButton: false,
                showPayButton: false,

                currentSystemModule: [],
                accessRights: [],
                accessCostPriceRights: [],

                //Document Action History
                historyDrawerVisible: false,
                tabulator: null,
                tabulator1:null,

                stockCardVisible: false,
                selectedStockCardProduct: null,
                stockCardKey: 0,


                sublocationAllocationVisible: false,
                selectedSublocationAllocationProduct: {},
                sublocationAllocationKey: 0,

                siteAllocationVisible: false,
                selectedSiteAllocationProduct: {},
                siteAllocationKey: 0,

                massAddDrawerVisible: false,
                massAddDrawerKey: 0,

                onHandQuantity: 0,
                availableQuantity: 0,

                orderSource: [],
                isOrderSourceDisabled: false,
                orderSources: [],
                isOrderSourceMode: false,
                isOrderTypeDisabled: false,
                isCountryOfOriginDisabled: false,
                isFiscalYearDisabled: false,
                isYearSeasonDisabled: false,
                isNoOfCartonsDisabled: false,
                isProvinceDisabled: false,
                isCityDisabled: false,
                isBarangayDisabled: false,
                isZipCodeDisabled: false,

                customerDrawerVisible: false,
                customerDrawerKey: 0,
                customerAddress: "",
                customerContactMobile: "",
                customerContactTelephone: "",
                customerContactFax: "",
                customerContactEmail: "",
                selectedCustomerContact: "",
                activeCustomerContact: '',

                map: undefined,
                forPaymentIsPosting: false,
                continueAutoCreatePoExceedRr: false,
                continueWithPriceDiscrepancy: true,
                forPaymentIsProcessed: false,
                paymentErrors: [],
                initialDepositErrors:[],
                massAddProductErrors:[],
                massAddProductErrorsDL: [],
                dlDUplicateSkus: 0,
                dlDUplicateSkusItems: [],
                dlSkusNotFound: 0,
                dlSkusNotFoundItems: [],
                showPrint: false,
                postDate: null,

                isHeaderOnly: false,
                isDocumentTrade: true,

                addProductConfirmationVisible: false,

                forThisSite: {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")},
                forThisSites: [],

                //PWS
                oldOrdering: null,
                oldLanded: null,
                oldRetailPrice: null,
                oldSpecialPrice: null,
                oldWholesalePrice: null,
                newOrdering: null,
                newLanded: null,
                newRetailPrice: null,
                newSpecialPrice: null,
                newWholesalePrice: null,
                markUp: null,
                showFilteredBySupplier: false,
                filteredBySupplier: false,
                isForThisSiteDisabled: false,

                //PIML Prices
                oldPimlPrice1: null,
                oldPimlPrice2: null,
                oldPimlPrice3: null,
                newPimlPrice1: null,
                newPimlPrice2: null,
                newPimlPrice3: null,

                //Currency
                currency: [],
                currencies: [],
                currencyRate: 0,
                defaultCurrencyRate:0,
                hasDefaultCurrency:false,
                currencyDetails:{},
                showConversionRate:false,

                // References
                referenceDrawerVisible: false,

                drawerSublocation: {key: 0, label: "Please select a sublocation"},
                drawerSublocations: [],
                drawerSublocationSiteId: null,
                drawerSublocationQuantity: '',
                drawerCurrentSublocationAllocation: [],
                sublocationAllocationErrors: [],
                allowSublocationAllocation: false,

                //Transfer Allocation
                drawerSite: {key: 0, label: "Please select a site"},
                drawerSites: [],
                drawerSiteId: null,
                drawerSiteQuantity: '',
                drawerCurrentSiteAllocation: [],
                allowSiteAllocation: false,
                siteAllocationErrors: [],

                createdBy: '',
                postedBy: '',


                // serialization
                serializationKey: 0,
                serializationVisible: false,
                serializationErrors: [],
                selectedSerialProduct: {},
                currentDrawerSerials: [],
                currentDrawerSerialsInstance: [],
                previousSerialCount:0,
                currentSerialCount:0,
                defaultCountValue:0,
                inputSerialNumber: '',
                serialMessage: "inputted",
                documentIsRel:false,

                file: '',
                documentImageKey: 0,
                documentImageDrawerVisible: false,
                imageFileUrl: '',

                documentPaymentsKey: 0,
                documentPaymentsDrawerVisible: false,
                documentPaymentsList: [],

                siteSublocation: [],
                isSiteSublocationDisabled: false,
                document_origin:[],
                postedASMDSM: false,
                documentEcomDrawerVisible:false,
                ecomAction:null,
                documentDetails:[],
                imagepath: secureStorage.getItem("account_logo"),
                documentID:null,
                isPCountDocumentSearchDisabled:false,
                addPCountDocumentConfirmationVisible: false,
                selectedDocumentID:null,
                selectedDocumentLineRows:null,
                continuePostCountSetDocument:false,
                isSetOtherItemInventoryToZero:false,
                initialDeposit:{
                    amount:0,
                    reference:null,
                    payment_mode:"Initial Deposit",
                    status:"A",
                    payment_date: moment(new Date())
                },
                default_sublocation_code: 0,
                asnModule: 0,
                maxLines: 0,
                autoCreateAlterSupp: false,
                filterBySupp: false,
                fileList: [],
                suppItems: [],
                csvData: '',
                documentExtras: {},
                extrasDrawerVisible: false,
                autoPostDD: false,
                autoPostDDAndSI:false,
                openCSR: false,
                openOCR: false,
                configuredExtras: {},
                validationdocutypes : ["OTHPUR", "ORIPOX", "ORIASN", "RECDEL", "RECPOS"],
                HideDeleteAndAddProductButton:false,
                supplierDetails:{},
                forceFetchCurrency:false,
                isCurrencyToPhp:false,
                filterExistingProductData:[],
                isRunDefaultCurrency:false,
                defaultCurrencyDetails:{},
                isEditAllocation:false,
                isEditAllocationIndex:0,
                siteAllocationRemainingQuantity:null,
                massAddWithAllocationProductErrors:[],
                fileWithAllocationList:[],
                massAddWithAllocationDrawerVisible:false,
                massAddWithHeaderDrawerVisible:false,
                processingXlsxUpload: false,
                xlsxUploadFormData: {},
                viewAllocation:false,
                documentLines:[],
                continueWithPrintPdf:true,
                printDefault:true,
                costUpdated:false,
                optionsViewAllocation: {
                    height:"100%",
                    pagination:"local",
                    paginationSize:20,
                    columns: [
                        {
                            title: 'Line No',
                            field: 'line_no',
                            sorter: 'number',
                            frozen: true,
                        },
                        {
                            title: 'Stock No',
                            field: 'stock_no',
                            sorter: 'number',
                            frozen: true,
                        },
                        {
                            title: 'Description',
                            field: 'product_name',
                            editor: 'input',
                            sorter: 'string',
                            frozen: true,
                        },
                        {
                            title: 'Barcode',
                            field: 'barcode',
                            sorter: 'number',
                        },
                        {
                            title: 'Quantity',
                            field: 'quantity',
                            sorter: 'number',
                        },
                        {
                            title: 'Price',
                            field: 'price',
                            formatter: 'money',
                        },
                        {
                            title: 'Subtotal',
                            field: 'subtotal',
                            sorter: 'number',
                            formatter: 'money',
                        },
                    ]
                },
                totalAllocatedQty:0,
                referenceLabel:"Reference",
                displayNetAmountWOVat:false,
                displayVatAmount:false,
                displayNetAmountWOVatLabel:"Net Amount w/o VAT",
                lotCodeExpiryVisible: false,
                inputLotCode: "",
                inputLotCodeQuantity: 0,
                inputExpiryAt: undefined,
                lotCodeExpiryKey: 0,
                selectedLotCodeExpiryProduct: {},
                currentDrawerLotCodeExpiry: [],
                revenueCreditingMode:'',
                RequestingLabel:'Requesting',
                revenueOption:[
                    {key: "R", value: "Requesting"},
                    {key: "T", value: "Target"}
                ],
                revenueSiteId:0,
                continueAutoCreateTr:false,
                isConfirmDisabled:false,
                isUnconfirmDisabled:false,
                currencyId:-1,
                supplierCurrencyName:"PHP",
                currencyRateLabel:null,
                sortOrder: [],
                sortDrawerVisibility: false,
                sortInput: {},
                isLotCodeExpiryDisabled: false,
                lotcodeSources: [],
                lotcodeSource: [],
                lotcodeTotalQty: 0,
                lotcodeAvailableQty: 0,
                relatedDocument: [],
                relatedDocumentOrigin: [],
                relatedGrandChildrenDocument: [],
                documentRelation: '',
                //zalora
                zaloraPrintWayBillStatus: null,
                zaloraPrintWayBillDisabled: true,
                zaloraPrintWayBillDLink: null,
                zaloraPrintWayBillId:null,
                //flag for documents with upload
                isUploaded: false,
                isPrinted: false,
                defaultSite: secureStorage.getItem("defaultSiteId"),
                documentCurrentSite:secureStorage.getItem("defaultSiteId"),
                documentCurrentSiteCode:secureStorage.getItem("defaultSiteCode"),
                documentCurrentSiteSBU:secureStorage.getItem("defaultSiteSBU"),
                existingDocumentTypeId:-1,
                existingDocumentTypeDetails:[],
                showPrintingModal:false,
                printerList:[],
                selectedPrinter:null,
                fetchingPrinterList:true,
                selectedPrinterFormat:null,
                printerFormatList:[],
                fetchingPrinterFormatList:false,
                printBarcodeLoading:false,
                selectedBarcodeFormat:{},
                barcodeTemplateErrors:[],
                disableAddingProducts: false,
                companyOwnerId:null,
                companyOwnerCode:null,
                companyOwnerName:null,
                documentLen: 0,
                wtaxCodes:[],
                wTax:{},
                isWTaxDisabled:false,
                vatableSalesAmount:0.00,
                vatExemptSalesAmount:0.00,
                zeroRatedSalesAmount:0.00,
                totalTradeDiscount:0.00,
                overallDiscountPercentage:0.00,
                documentCostingMethod:null,
                accountName: secureStorage.getItem("accountName"),
                importDocumentHeaderWithLineErrors:[],
                lineWithHeader:[],
                copyLatestPriceOrCost:false,
                reCalculateHeaderDiscount:false,
                doneTitle: "Are you sure you want to mark this document 'DONE'?",
                tabulator_site_sublocations: [],
            }
        },
        // Track Unsaved Changes on Document
        // beforeMount() {

        // },

        // async beforeRouteLeave(to, from, next) {
        //     var data = this.tabulator.getData();
        //     if (data.length > 0) {
        //         this.isEditing = !(component_x.origData === JSON.stringify(data))
        //     }
        //     if (this.isEditing && !this.isChangeAction) {
        //         if (!window.confirm("Leave without saving?")) {
        //             return;
        //         }
        //     }
        //     next();
        // },

        async beforeRouteLeave(to, from, next) {
            if (this.isDirty && !this.isChangeAction || this.documentStatus === 'Saved') {
                this.$confirm({
                    title:"Document line has been modified",
                    content: "There are unsaved changes in the document.\n Clicking 'Ok' will discard changes. Do you want to proceed?",
                    onOk(){
                    next()
                    }
                })
            }else{
                next();
            }    
        },

        destroyed () {
            window.removeEventListener('scroll', this.handleScroll);
        },
        beforeMount: async function() {
            window.addEventListener("beforeunload", this.preventNav)
            this.$once("hook:beforeDestroy", () => {
                this.isEditing = false
                window.removeEventListener("beforeunload", this.preventNav);
            })
            
            var start_year = new Date().getFullYear();
            for (var i = start_year; i > start_year - 5; i--) {
                var year_from = (i).toString().substring(2, 4);
                var year_to = (i+1).toString().substring(2, 4);
                this.fiscalYearOptions.push({key: "FY"+year_from+"-"+year_to, value: "FY"+year_from+"-"+year_to}, {key: "CY"+year_from+"-"+year_to, value: "CY"+year_from+"-"+year_to})
            }

            //[ERK] Turn off ASN button
            if (secureStorage.getItem("documentTypeInternalCode") == "ORIASN" || secureStorage.getItem("documentTypeInternalCode") == "ORIPOX"){
                let qryasnModule = await HTTPRequest.getRequest(this.endPoint + "system_module_categories?code=PTP-006", null, null)
                this.asnModule = qryasnModule.length
            }
            //Fix: S3 image CORS error in jsPDF
            const corsImageModified = new Image();
            // corsImageModified.crossOrigin = "Anonymous";
            // corsImageModified.id = "logobarter";
            // corsImageModified.src = secureStorage.getItem("account_logo") + "?not-from-cache-please";
            // document.getElementById("logoDiv").appendChild(corsImageModified);
            // //Fix: S3 image CORS error in jsPDF

            function loadImage(url, onSuccess, onError) {
                const img = new Image();
                img.onload = () => onSuccess(img);
                img.onerror = () => onError();
                img.src = url;
            }

            // URL from secureStorage
            const imageUrl = secureStorage.getItem("account_logo") + "?not-from-cache-please";

            // Attempt to load the primary image
            loadImage(imageUrl, (img) => {
                // If the primary image loads successfully, set it as the src
                corsImageModified.crossOrigin = "Anonymous";
                corsImageModified.id = "logobarter";
                corsImageModified.src = imageUrl;
                document.getElementById("logoDiv").appendChild(corsImageModified);
            }, () => {
                // If the primary image fails to load, use the fallback image
                corsImageModified.crossOrigin = "Anonymous";
                corsImageModified.id = "logobarter";
                corsImageModified.src = fallbackLogo;
                document.getElementById("logoDiv").appendChild(corsImageModified);
            });

            if (secureStorage.getItem("documentTypeInternalCode") == 'OTHPWS'){
                this.backLink = "/products_v2?type=OTHPWS"
            }else if (secureStorage.getItem("documentTypeInternalCode") == 'OTHBAR'){
                this.backLink = "/products_v2?type=OTHBAR"
            } else {
                if (this.$route.params.document_typex != undefined && this.$route.params.document_typex != null && this.$route.params.document_typex != ""){
                    this.backLink = "/documents?type=" + this.$route.params.document_typex
                    this.existingDocumentTypeDetails.type = this.$route.params.document_typex
                } else {
                    this.backLink = "/documents?type=" + secureStorage.getItem("documentTypeInternalCode")
                }
            }

            if (this.$route.params.id != undefined){
                if (this.$route.params.id > 0){
                    if(this.$route.params.id) secureStorage.setItem("temp_document_id", this.$route.params.id);
                } else {
                    secureStorage.setItem("temp_document_id", 0);
                }
            }
            if (this.$route.params.document_type_id != undefined){
                if (this.$route.params.document_type_id > 0){
                    this.existingDocumentTypeId = this.$route.params.document_type_id 
                    this.currentDocumentTypeId = this.$route.params.document_type_id 
                    this.existingDocumentTypeDetails.existingDocumentTypeId = this.$route.params.document_type_id 
                }else {
                    this.currentDocumentTypeId = secureStorage.getItem('documentTypeId') 
                }
            }else {
                this.currentDocumentTypeId = secureStorage.getItem('documentTypeId') 
            }
            if (this.$route.params.documentTypeName != undefined){
                this.currentDocumentTypeName = this.$route.params.documentTypeName 
                this.existingDocumentTypeDetails.currentDocumentTypeName = this.currentDocumentTypeName
            }else {
                this.currentDocumentTypeName = secureStorage.getItem('documentTypeName')
            }
            if (this.$route.params.documentTypeCode != undefined){
                this.currentDocumentTypeCode = this.$route.params.documentTypeCode
                this.existingDocumentTypeDetails.currentDocumentTypeCode = this.currentDocumentTypeCode

            }else {
                this.currentDocumentTypeCode = secureStorage.getItem('documentTypeCode')
            }
            if (this.$route.params.documentSiteId !=undefined){
                this.documentCurrentSite = this.$route.params.documentSiteId
            }else {
                this.documentCurrentSite = secureStorage.getItem("defaultSiteId")
            }
            if (this.$route.params.documentSiteCode !=undefined){
                this.documentCurrentSiteCode = this.$route.params.documentSiteCode
            }else {
                this.documentCurrentSiteCode = secureStorage.getItem("defaultSiteCode")
            }
            if (this.$route.params.documentSiteSBU !=undefined){
                this.documentCurrentSiteSBU = this.$route.params.documentSiteSBU
            }else {
                this.documentCurrentSiteSBU = secureStorage.getItem("defaultSiteSBU")
            }
            if (this.$route.params.documentTypeFriendlyCode != undefined){
                this.currentDocumentTypeFriendlyCode = this.$route.params.documentTypeFriendlyCode 
                this.existingDocumentTypeDetails.currentDocumentTypeFriendlyCode = this.currentDocumentTypeFriendlyCode
            }else {
                this.currentDocumentTypeFriendlyCode = secureStorage.getItem('documentTypeFriendlyCode')
            }

            if (this.$route.params.brandId != undefined){
                this.brand.key = this.$route.params.brandId
            }

            if (this.$route.params.companyId != undefined){
                this.company_id = this.$route.params.companyId
            }

            if (this.$route.params.orderSource != undefined){
                this.orderSource = this.$route.params.orderSource
            }

            // check if the trigger is from stockCard hyperlink
            let fromStockCard = secureStorage.getItem('fromStockCard')
            console.log(fromStockCard)
            if(fromStockCard){
              this.backLink = "/products_v2"
            }

            this.documentNumber = secureStorage.getItem('temp_document_id');
            this.currentDocumentTypeFriendlyCodeWithId = this.currentDocumentTypeFriendlyCode+"#"+this.documentNumber

            var credentials = await HTTPRequest.getRequest(this.endPoint + 'settings/accountSettings?field_name=code' , null)
            try {
                this.documentCostingMethod = JSON.parse(credentials.value).documentCostingMethod
            } catch (error) {
                
            }
            await this.initializeDocument();
            await this.getSettings();
            this.mountedAlreadyRendered = true
            this.checkHeaderDiscountState();
           
        },
        computed: {
            ...mapState(['endPoint', 'parentId', 'parameters', 'serverType', 'publicUrl', 'checkCurrentSite']), 
            isDirty(){return this.isEditing},
            // Character counters for the 255-limited advanced-info fields
            referenceLength(){ return (this.reference || '').length },
            remarkLength(){ return (this.remark || '').length },
            ocReferenceNoLength(){ return (this.ocReferenceNo || '').length },
            shipmentReferenceNoLength(){ return (this.shipmentReferenceNo || '').length },
            // Country Of Origin is only rendered for these document types (see template
            // v-if conditions). Use this to avoid fetching countries/get_valid_countries
            // for document types that never display the field.
            showCountryOfOrigin(){
                return this.docTypesForP2P.includes(this.currentDocumentTypeCode)
                    || this.docTypesForOMGT.includes(this.currentDocumentTypeCode)
            },
            // google: gmapApi,
            chargeRowSelection() {
                // eslint-disable-next-line
                const { chargeSelectedRowKeys } = this;
                return {
                    onChange: (chargeSelectedRowKeys) => {
                        var charges = [];
                        this.chargeData.forEach(function(x){
                            charges.push(x.line_no)
                        });
                        // eslint-disable-next-line
                        this.chargeSelectedRowKeys = _.intersection(chargeSelectedRowKeys, charges)
                    }
                }
            },
            additionalChargeRowSelection() {
                const { additionalChargeSelectedRowKeys } = this;

                return {
                    onChange: (additionalChargeSelectedRowKeys) => {
                        var additionalcharges = [];
                        this.additionalChargeData.forEach(function(x){
                            additionalcharges.push(x.line_no)
                        });
                        // eslint-disable-next-line
                        this.additionalChargeSelectedRowKeys = _.intersection(additionalChargeSelectedRowKeys, additionalcharges)
                    }
                }
            },
            formattedsearchFilter(){
                return (this.searchFilter == 'product_id') ? 'code' : this.searchFilter
            },
            formattedsearchFilterAddedProduct(){
                return (this.searchFilterAddedProduct == 'product_id') ? 'code' : this.searchFilterAddedProduct
            },
        },
        created() {
            this.subscribe()
        },
        mounted: async function () {
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            const document_id = urlParams.get('id')
            const document_type_id = urlParams.get('type')
            if(document_id > 0)
                this.openRelatedDocument(document_id, document_type_id)
            await this.getCountryOptions();
            this.isEditing = false;
        },
        methods:{
            ...mapActions(['updateCheckCurrentSite']),
          // Memoized fetch of the current document (GET documents/{documentNumber}).
          // Many code paths independently re-fetch the same document during a single
          // page load/action, producing duplicate GET api/v2/documents/{id} calls.
          // This helper caches the in-flight promise so the same id is only fetched
          // once per load. Call invalidateCurrentDocumentCache() whenever the document
          // is mutated (open/update/post/confirm/unconfirm/void) so the next read is fresh.
          async getCurrentDocument(forceReload = false) {
              if (!(this.documentNumber > 0)) return null
              if (
                  !forceReload &&
                  this._currentDocumentCache &&
                  this._currentDocumentCache.id === this.documentNumber &&
                  this._currentDocumentCache.promise
              ) {
                  return this._currentDocumentCache.promise
              }
              const promise = HTTPRequest.getRequest(this.endPoint + "documents/" + this.documentNumber, null)
              this._currentDocumentCache = { id: this.documentNumber, promise }
              return promise
          },
          invalidateCurrentDocumentCache() {
              this._currentDocumentCache = null
          },
          // Memoized fetch of user access rights for a system module. The user id is constant
          // per session, so the same users/<id>/access_rights?system_module_id=<id> request is
          // often issued multiple times during a single document load. Cache the in-flight
          // promise per system_module_id so it's only fetched once.
          async getUserAccessRights(systemModuleId) {
              if (!this._userAccessRightsCache) this._userAccessRightsCache = {}
              var cacheKey = String(systemModuleId)
              if (this._userAccessRightsCache[cacheKey]) {
                  return this._userAccessRightsCache[cacheKey]
              }
              var promise = HTTPRequest.getRequest(this.endPoint + 'users/' + secureStorage.getItem("userId") + "/access_rights?system_module_id=" + systemModuleId, null)
              // Don't keep a rejected promise cached, so a later call can retry.
              promise.catch(() => { delete this._userAccessRightsCache[cacheKey] })
              this._userAccessRightsCache[cacheKey] = promise
              return promise
          },
          // Memoized fetch of a single site by id (GET sites/<id>). Site records are stable
          // within a session and the same site is often fetched by multiple methods during a
          // document load. Cache the in-flight promise per site id. Returns null for invalid
          // ids (<= 0) so callers never hit sites/-1.
          async getSiteById(siteId) {
              var parsedId = parseInt(siteId)
              if (!(parsedId > 0)) return null
              if (!this._siteByIdCache) this._siteByIdCache = {}
              var cacheKey = String(parsedId)
              if (this._siteByIdCache[cacheKey]) {
                  return this._siteByIdCache[cacheKey]
              }
              var promise = HTTPRequest.getRequest(this.endPoint + 'sites/' + parsedId, null)
              // Don't keep a rejected promise cached, so a later call can retry.
              promise.catch(() => { delete this._siteByIdCache[cacheKey] })
              this._siteByIdCache[cacheKey] = promise
              return promise
          },
          showCustomizeListDrawer() {
            this.isDrawerVisible = true
          },
          checkCustomizedFields(docTypeCode) {
            const currentSettings = this.documentTableFilteredList.filter(({ docType }) => docType === docTypeCode)
            if (currentSettings.length > 0) {
              const { customFields } = currentSettings[0]
              if (customFields.length !== 0) {
                this.filteredColumnFields = customFields
              } 
            } 
          },

          disabledEffectiveDate(current) {
                return current && current < moment().startOf('day');
          },
          onCheck(e) {
            const { checked, id } = e.target
            const tempValue = this.filteredColumnFields.map((field) => {
              if (field.name === id) {
                return { ...field, value: checked }
              }
              return field
            })
            this.filteredColumnFields = tempValue
          },
          closeCustomizeListDrawer() {
            const listIsZero = this.filteredColumnFields.filter(({ value }) => value === true)
            let data = listIsZero.length === 0 ? this.defaultColumnFields : this.filteredColumnFields
            if (listIsZero.length === 0) this.filteredColumnFields = data
            if (this.documentTableFilteredList !== null) {
              const isExisting = this.documentTableFilteredList.filter(({ docType }) => docType === this.currentDocumentTypeCode)
              if (isExisting.length === 0) {
                secureStorage.setItem("documentTableFilteredList", [...this.documentTableFilteredList, { docType: this.currentDocumentTypeCode, customFields: data }])
              } else {
                const newState = this.documentTableFilteredList.map((prevState) => {
                  if (prevState.docType === this.currentDocumentTypeCode) {
                    return { ...prevState, customFields: data }
                  }
                  return prevState
                })
                secureStorage.setItem("documentTableFilteredList", newState)
              }
            } else {
              secureStorage.setItem("documentTableFilteredList", [{ docType: this.currentDocumentTypeCode, customFields: data }])
            }
            // this.renderColumnFields()
            this.isDrawerVisible = false
          },
            checkHeaderDiscountState() {
                var disabledDocumentStatus = ["Posted", "Voided", "Confirmed"];
                var allowedDocTypesForEditingDiscount = ["RELDDE", "OTHSIN"];
                if (allowedDocTypesForEditingDiscount.includes(this.currentDocumentTypeCode) &&
                    !disabledDocumentStatus.includes(this.documentStatus)) {
                    this.isHeaderDiscountDisabled = false;
                    // console.log("header discount enabled for DD and SI");
                }
            },
            disabledDate(current) {
                return current < moment(this.documentDate, "YYYY-MM-DD").add(1, 'days');
            },
            selectlotcodeSource(value) {
                this.lotcodeSources.map(item => {
                  if(item['id'] == value){
                    this.inputExpiryAt = item['expired_at']
                    this.inputLotCodeQuantity = 0
                    this.lotcodeAvailableQty = item['available_quantity']
                  }
                })
            },
            showInternalDocumentId(){
                this.modalInternalDocumentId = true;
            },
            handleCancel(e){
                this.modalInternalDocumentId = false;
                this.tovsiModal = false;
                this.proceed_resolution = 0;
                this.spinning = false;
            },
            showSortDrawer(){
                this.sortDrawerVisibility = true;
            },
            async saveSort(value) {
                if(value != null && value != '' && value != '[]' ){
                    let storeName = "documentTypeSort" + this.currentDocumentTypeCode
                    localStorage.setItem(storeName, JSON.stringify(value));
                    await this.sortDocument(value)
                }else{
                    let storeName = "documentTypeSort" + this.currentDocumentTypeCode
                    localStorage.removeItem(storeName); 
                    this.tabulator.setSort([{column: 'line_no', dir: 'asc'}])
                }
                this.onCloseSortDrawer();
            },
            onCloseSortDrawer(){
                this.sortDrawerVisibility = false
            },
            async sortDocument(val){
                let newVal = []
                val.forEach((val) => {
                    newVal.push({column: val.field_name, dir: val.order_by})
                })
                await this.tabulator.setSort(newVal);
                // console.log(me, this.tabulator.getSorters())
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                );
            },
            isUnitCostDisabled(){
                if(this.currentDocumentTypeCode === 'ORISOX' || this.currentDocumentTypeCode === 'OTHSRQ' || this.currentDocumentTypeCode === 'ORIOSO'){
                     if(this.isDocumentLineFormDisabled || this.isOrderSourceMode){
                        return true
                    }else {
                        return false
                    }
                }else{
                    if(this.isDocumentLineFormDisabled){
                        return true
                    }else{
                        return false
                    }
                }
            },
            printDupSKUs() {
                let csv = 'Barcode\n' + this.dlDUplicateSkusItems.toString().replace(/,/g, '\n');
                const anchor = document.createElement('a');
                anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
                anchor.target = '_blank';
                anchor.download = 'Duplicate Barcodes.csv';
                anchor.click();

            },
            printSKUsNotFound() {
                let csv = 'Barcode\n' + this.dlSkusNotFoundItems.toString().replace(/,/g, '\n');
                const anchor = document.createElement('a');
                anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
                anchor.target = '_blank';
                anchor.download = 'Barcodes Not Found.csv';
                anchor.click();

            },
            async selectSiteSublocation (siteSublocation) {
                var arr = {
                    key:siteSublocation.key.replace('sublocations',''),
                    label:siteSublocation.label
                }
                siteSublocation = arr
                Object.assign(this, {
                    siteSublocation,
                    sublocations: [],
                    fetching: false,
                })
            },
            async submitFile(){
                this.spinning = true;
                let data = new FormData();
                data.append('file', this.file);

                //Get S3 uploader endpoint
                var uploader_endpoint = await HTTPRequest.getRequest(this.endPoint + 'settings/api_s3_uploader', null, null)
                var config = {
                    method: 'post',
                    url: uploader_endpoint['endpoint'] + '?profile=' + secureStorage.getItem('documentTypeName') + '&account_name=' + secureStorage.getItem("accountName"),
                    headers: {'Authorization': 'Bearer ' + secureStorage.getItem("accessToken")},
                    data : data
                };
                var response_data;
                await axios(config)
                    .then(function (response) {
                        response_data = response.data
                    })
                    .catch(function (error) {
                        //console.log(error)
                });
                this.imageFileUrl = response_data.path || ''
                this.spinning = false;

                var documentPayload = {document_id: this.documentNumber, image_url: this.imageFileUrl}
                var post_request = await HTTPRequest.postRequest(this.endPoint + 'documents/save_image_url', null, documentPayload)

            },
            handleFileUpload(){
                this.file = this.$refs.file.files[0];
            },
            async saveDrawerSublocationAllocation(){
                await this.tabulator.updateData([{line_no: this.selectedSublocationAllocationProduct.line_no, sublocation_allocation: this.drawerCurrentSublocationAllocation}])
                this.closeDrawer('sublocationAllocation');
            },
            async saveDrawerSiteAllocation(){
                await this.tabulator.updateData([{line_no: this.selectedSiteAllocationProduct.line_no, site_allocation: this.drawerCurrentSiteAllocation}])
                this.closeDrawer('siteAllocation');
            },
            async saveDrawerLotCodeExpiry(){
                var data = this.tabulator.getData();
                var line_no = data.find(item => this.selectedLotCodeExpiryProduct.product_id === item.product_id).line_no
                var lineqty = (this.currentDrawerLotCodeExpiry.length > 0) ? this.currentDrawerLotCodeExpiry.map(row => row.quantity).reduce((sumqty, qty) => Number(qty) + Number(sumqty)) : 0;
                var contentqty = ((this.selectedDocumentLines[0].product_type == 'P' && this.currentDocumentTypeCode.includes('REL')) ? this.selectedDocumentLines[0].content_quantity : 1)
                if(lineqty != (this.selectedDocumentLines[0].quantity) && lineqty > 0 && this.currentDocumentTypeCode.includes("REC")){
                    this.$confirm({
                        title: 'Proceed?',
                        content: h => <div>Quantity is not equal, do you want to override?</div>,
                        onOk: () => {
                            this.applyLotCodes(lineqty, line_no)
                        },
                        onCancel() {}
                    });
                    return
                } else if(lineqty != (this.selectedDocumentLines[0].quantity) && lineqty > 0 && this.currentDocumentTypeCode.includes("REL")){
                    this.$notification['error']({
                        message: 'Lot Code Expiry',
                        description: "Line Quantity and Lot Code Total Quantity should be equal!",
                        style: getNotificationStyle('error')
                    });
                    return
                } else if(lineqty == 0){
                    this.$notification['error']({
                        message: 'Lot Code Expiry',
                        description: "Lot Code & Expiry date is required for this item!",
                        style: getNotificationStyle('error')
                    });
                    return
                } else {
                    await this.tabulator.updateData([{line_no: line_no, product_id: this.selectedLotCodeExpiryProduct.product_id, quantity: (lineqty), document_line_locations: this.currentDrawerLotCodeExpiry}])
                    //Recalculate
                    await this.recalculateLine(this.selectedLotCodeExpiryProduct.product_id)
                    this.calculateSummary();
                    this.closeDrawer('lotCodeExpiry')
                }
            },
            async applyLotCodes(lineqty, line_no) {
                 await this.tabulator.updateData([{line_no: line_no, product_id: this.selectedLotCodeExpiryProduct.product_id, quantity: lineqty, document_line_locations: this.currentDrawerLotCodeExpiry}])
                 //Recalculate
                 await this.recalculateLine(this.selectedLotCodeExpiryProduct.product_id)
                 this.calculateSummary();
                 this.closeDrawer('lotCodeExpiry')
            },
            async submitDrawerLotCodeExpiry() {
                if(this.inputExpiryAt == undefined || this.inputExpiryAt == ''){
                    this.$notification['error']({
                        message: 'Lot Code Expiry',
                        description: "Cannot add Lot Code. Expiry date is required",
                        style: getNotificationStyle('error')
                    });
                    return
                }
                if(this.inputLotCode == undefined || this.inputLotCode == ''){
                    this.$notification['error']({
                        message: 'Lot Code Expiry',
                        description: "Cannot add Lot Code. Lot Code is required"
                    });
                    return
                }

                let selectedLotCode = 0
                this.lotcodeSources.map(item => {
                    if(item['id'] == this.inputLotCode)
                        selectedLotCode = item['lotcode']
                })

                let lotCodeError = 0
                this.currentDrawerLotCodeExpiry.map(item => {
                    if((item['lot_code'] == selectedLotCode && this.isLotCodeExpiryDisabled) || (item['lot_code'] == this.inputLotCode && moment(String(item['expiry_at'])).format('YYYY-MM-DD') == moment(String(this.inputExpiryAt)).format('YYYY-MM-DD') && !this.isLotCodeExpiryDisabled))
                        lotCodeError++
                })

                if(this.isLotCodeExpiryDisabled && Number(this.inputLotCodeQuantity) > Number(this.lotcodeAvailableQty)) {
                    this.$notification['error']({
                        message: 'Lot Code Expiry',
                        description: "Lot code quantity is greater than available quantity!",
                        style: getNotificationStyle('error')
                    });
                    return
                }

                if(lotCodeError > 0) {
                    this.$notification['error']({
                        message: 'Lot Code Expiry',
                        description: "Lot code selected or encoded is already on the list!",
                        style: getNotificationStyle('error')
                    });
                    return
                } else {
                    var contentqty = ((this.selectedDocumentLines[0].product_type == 'P' && this.currentDocumentTypeCode.includes('REL')) ? this.selectedDocumentLines[0].content_quantity : 1)
                    
                    this.currentDrawerLotCodeExpiry.push(
                        {
                            line_no: this.selectedLotCodeExpiryProduct.line_no,
                            lot_code: (this.currentDocumentTypeCode.includes("REL")) ? selectedLotCode : this.inputLotCode,
                            //expiry_at: (this.currentDocumentTypeCode.includes("REL")) ? this.inputExpiryAt : (new Date(this.inputExpiryAt)).toISOString(),
                            expiry_at: (this.currentDocumentTypeCode.includes("REL")) ? this.inputExpiryAt : moment(this.inputExpiryAt, "YYYY-MM-DD"),
                            status: "A",
                            quantity: Number(this.inputLotCodeQuantity / contentqty),
                            actual_quantity: Number(this.inputLotCodeQuantity),
                            content_quantity: this.selectedLotCodeExpiryProduct.content_quantity.toString()
                        }
                    )
                    this.inputLotCode = ''
                    this.inputLotCodeQuantity = 0
                    this.inputExpiryAt = ''
                    this.lotcodeTotalQty = 0
                    this.lotcodeAvailableQty = 0
                    this.currentDrawerLotCodeExpiry.map(item => {
                        if (contentqty == 1)
                            this.lotcodeTotalQty += Number(item['quantity'])
                        else 
                            this.lotcodeTotalQty += Number(item['actual_quantity'])
                    })
                }
            },
            updateSerialLineStatus(index){
                if(this.currentDrawerSerials[index].status == "D"){
                    this.currentDrawerSerials[index].status = "A"
                }else{
                    this.currentDrawerSerials[index].status = "D"
                }
            },
            removeSerialNumber(index){
                this.currentDrawerSerials.splice(index, 1);
            },
            removeSublocationAllocation(index){
                this.drawerCurrentSublocationAllocation.splice(index, 1);
            },
            removeSiteAllocation(index){
                this.drawerCurrentSiteAllocation.splice(index, 1);
                var total_site_quantity = this.drawerCurrentSiteAllocation.reduce((a, {quantity}) => a + parseInt(quantity), 0);
                this.siteAllocationRemainingQuantity = Number(this.selectedSiteAllocationProduct.quantity) - Number(total_site_quantity)
            },
            removeLotCodeExpiry(index){
                this.currentDrawerLotCodeExpiry.splice(index, 1);
                this.lotcodeTotalQty = 0
                this.currentDrawerLotCodeExpiry.map(item => {
                    if(this.selectedDocumentLines[0].product_type == 'P' && this.currentDocumentTypeCode.includes('REL'))
                        this.lotcodeTotalQty += Number(item['actual_quantity'])
                    else
                        this.lotcodeTotalQty += Number(item['quantity'])
                })
            },
            addDrawerSublocationQuantity: function () {
                this.sublocationAllocationErrors = [];
                if (this.drawerSublocation.key > 0 && this.drawerSublocationQuantity > 0) {
                    var is_sublocation_existing = this.drawerCurrentSublocationAllocation.find(x => x.sublocation_id === this.drawerSublocation.key);
                    if (is_sublocation_existing == undefined) {
                        this.drawerCurrentSublocationAllocation.push(
                            {'sublocation_id': this.drawerSublocation.key,
                            "quantity": this.drawerSublocationQuantity}
                        )

                        var total_sublocation_quantity = this.drawerCurrentSublocationAllocation.reduce((a, {quantity}) => a + parseInt(quantity), 0);
                        if (total_sublocation_quantity > this.selectedSublocationAllocationProduct.quantity) {
                            this.sublocationAllocationErrors.push('You have exceeded the maximum allowed quantity: '+ this.selectedSublocationAllocationProduct.quantity)
                            this.drawerCurrentSublocationAllocation.pop();
                        }

                        this.drawerSublocationQuantity = ''
                        this.drawerSublocation = {key: 0, label: "Please select a sublocation"}
                    } else {
                        this.sublocationAllocationErrors.push('Sublocation already exists')
                    }
                } else {
                    this.sublocationAllocationErrors.push('Sublocation and Quantity must have values')
                }
            },
            addDrawerSiteQuantityValidation(){
                this.siteAllocationErrors = [];
                this.siteAllocationErrors.push(ValidateField.greaterThanZero('Quantity', this.drawerSiteQuantity));
                this.siteAllocationErrors.push(ValidateField.required('Quantity', this.drawerSiteQuantity));
                this.siteAllocationErrors.push(ValidateField.required('Site', this.drawerSite.key));
                this.siteAllocationErrors = this._.compact(this.siteAllocationErrors);
                return this.siteAllocationErrors.length;
            },
            addDrawerSiteQuantity: function () {
                if(!this.addDrawerSiteQuantityValidation()){
                    var is_site_existing = this.drawerCurrentSiteAllocation.find(x => x.site_id === this.drawerSite.key);
                    if (this.currentDocumentTypeCode == 'OTHPCK') {
                        if (is_site_existing == undefined) {
                            this.siteAllocationErrors.push('Site selected is not available below')
                        } else {
                            if (is_site_existing.quantity < this.drawerSiteQuantity){
                                this.siteAllocationErrors.push('You have exceeded the site maximum allowed quantity: ' +is_site_existing.quantity)
                            }else{
                                is_site_existing.available_quantity = this.drawerSiteQuantity
                            }
                        }
                    } else {
                        if (is_site_existing == undefined) {
                            var code = (this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.AllocationDefaultValue == 'SC') ? this.drawerSite.code : this.drawerSite.reference_code;
                            this.drawerCurrentSiteAllocation.push(
                                {'site_id': this.drawerSite.key,
                                "quantity": this.drawerSiteQuantity,
                                "code": code}
                            )
                            var total_site_quantity = this.drawerCurrentSiteAllocation.reduce((a, {quantity}) => a + parseInt(quantity), 0);
                            this.siteAllocationRemainingQuantity = Number(this.selectedSiteAllocationProduct.quantity) - Number(total_site_quantity)
                            if (total_site_quantity > this.selectedSiteAllocationProduct.quantity) {
                                this.siteAllocationErrors.push('You have exceeded the maximum allowed quantity: '+ this.selectedSiteAllocationProduct.quantity)
                                this.drawerCurrentSiteAllocation.pop();
                            }else {
                                this.siteAllocationRemainingQuantity = Number(this.selectedSiteAllocationProduct.quantity) - Number(total_site_quantity)
                            }
                            this.drawerSiteQuantity = ''
                            this.drawerSite = {key: 0, label: "Please select a site"}
                        } else {
                            this.siteAllocationErrors.push('Site already exists')
                        }
                    }
                }
            },
            selectDrawerSublocations (drawerSublocation) {
                var arr = {
                    key:drawerSublocation.key.replace('drawerSublocations',''),
                    label:drawerSublocation.label
                }
                drawerSublocation = arr
                Object.assign(this, {
                    drawerSublocation,
                    drawerSublocations: [],
                    fetching: false,
                })
            },
            selectDrawerSites (drawerSite) {
                var currencyDetails = this.drawerSites.find(c => parseInt(c.id) == parseInt(drawerSite.key.replace('drawerSites','')))
                var arr = {
                    key:drawerSite.key.replace('drawerSites',''),
                    label:drawerSite.label,
                    code:currencyDetails.code,
                    reference_code:currencyDetails.refcode,
                }
                drawerSite = arr
                Object.assign(this, {
                    drawerSite,
                    drawerSites: [],
                    fetching: false,
                })
            },

            async fetchDrawerSublocations(){
                if (this.drawerSublocationSiteId) {
                    this.fetching = true
                    this.drawerSublocations = await HTTPRequest.getRequest(this.endPoint + 'sublocations/get_site_sublocations?site_id='+this.drawerSublocationSiteId, null)
                    this.fetching = false
                }
            },

            async fetchDrawerSites(){
                this.fetching = true
                this.drawerSites = await HTTPRequest.getRequest(this.endPoint + 'sites/get_all_document_sites', null)
                this.fetching = false
            },
            isUrl(string) {
                var res = string.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);
                return (res !== null)
            },
            async fetchCurrencies() {
                this.fetching = true
                if(this.currencies.length <= 0 || this.forceFetchCurrency){
                    var params = '?default_currency='+this.hasDefaultCurrency
                    this.hasDefaultCurrency == true ? params+='&default_currency_id='+this.defaultCurrencyDetails.id : ""
                    try{
                        params += this.supplierDetails.currency_id!=undefined && this.supplierDetails.currency_id!=null ? '&currency_id='+this.supplierDetails.currency_id : ''
                    }catch (e){
                        console.log(e)
                    }
                    this.currencies = await HTTPRequest.getRequest(this.endPoint + 'currencies/get_document_currencies' + params, null)
                    this.forceFetchCurrency = false
                }
                this.fetching = false
            },
            async selectCurrency (currency) {
                var arr = {
                    key:currency.key.replace('currencies',''),
                    label:currency.label
                }
                currency = arr
                var currencyDetails = this.currencies.find(c => parseInt(c.id) == parseInt(currency.key))
                var currency_histories = await this.getSupplierCurrencyByDocDate(this.currencyId)
                if (currency_histories.length > 0) {
                    this.currencyRate = currency_histories[0].conversion_rate || currencyDetails.conversion || 1
                } else {
                    this.currencyRate = currencyDetails.conversion || 1
                }
                Object.assign(this, {
                    currency,
                    fetching: false,
                    currencyDetails:currencyDetails,
                })
                await this.showConversionCurrencyRate()
                this.calculateSummary();
            },

            // Safety clamp then show proper error or info message
            clampFieldValue(fieldKey, fieldLabel) {
                if ((this[fieldKey] || '').length > this.fieldMaxLength) {
                    this[fieldKey] = this[fieldKey].slice(0, this.fieldMaxLength);
                    this.$notification.info({
                        message: 'Character Limit Reached',
                        description: `The ${fieldLabel} field is limited to ${this.fieldMaxLength} characters. Your input was trimmed to fit.`,
                    });
                }
            },
            async saveRemark(){
                this.isEditing = true
                this.clampFieldValue('remark', this.remarkLabel);
                var documentPayload = {document_id: this.documentNumber, remark: this.remark}
                var post_request = await HTTPRequest.postRequest(this.endPoint + 'documents/edit_remark', null, documentPayload)
                if(post_request.id > 0){
                    this.documentActionNotification('Save', 'success')
                }else{
                    this.documentActionNotification('Save', 'error')
                }
            },
            async saveImageRefLink() {
                await this.saveField('image_ref_link', this.imageReferenceLink);
            },
            async saveOcRefNo() {
                this.clampFieldValue('ocReferenceNo', 'OC Reference No.');
                await this.saveField('oc_ref_no', this.ocReferenceNo);
            },
            async saveShipmentRefNo() {
                this.clampFieldValue('shipmentReferenceNo', 'Shipment Reference No.');
                await this.saveField('shipment_ref_no', this.shipmentReferenceNo);
            },
            async saveField(fieldName, fieldValue) {
                var documentPayload = { document_id: this.documentNumber };
                documentPayload[fieldName] = fieldValue;

                var request = await HTTPRequest.postRequest(this.endPoint + 'documents/edit_' + fieldName, null, documentPayload);

                if (request.id > 0) {
                    this.documentActionNotification('Save', 'success');
                } else {
                    this.documentActionNotification('Save', 'error');
                }
            },
            async getCountryOptions() {
                // Only fetch country options for document types that actually render the
                // Country Of Origin field in the UI (see template v-if conditions).
                // Other types (e.g. RELTRX) never display the field, so skip the call.
                var showsCountryOfOrigin = this.docTypesForP2P.includes(this.currentDocumentTypeCode)
                    || this.docTypesForOMGT.includes(this.currentDocumentTypeCode)
                if (!showsCountryOfOrigin) {
                    return;
                }

                let documentStatus = null;

                try {
                    const specificDocumentResponse = await this.getCurrentDocument();
                    documentStatus = specificDocumentResponse ? specificDocumentResponse.status : null;
                } catch (err) {
                    console.error('Failed to fetch document status:', err);
                }

                var countries = await HTTPRequest.getRequest(`${this.endPoint}/countries/get_valid_countries?document_status=${documentStatus}`, null, null);
                this.countryOfOriginOptions = countries.map(country => ({ id: country.id, name: country.name, code: country.code }));
            },
            async getB2bCustomerOptions(b2b_customer_id){
                let documentStatus = null;
                let b2b_customers = [];

                try {
                    const specificDocumentResponse = await this.getCurrentDocument();
                    documentStatus = specificDocumentResponse ? specificDocumentResponse.status : null;
                } catch (err) {
                    console.error('Failed to fetch document status:', err);
                }

                if(['ORISOX', 'RECCSR'].includes(secureStorage.getItem('documentTypeCode')) && Number(b2b_customer_id) == 0){
                    b2b_customers = await HTTPRequest.getRequest(`${this.endPoint}/b2b_customers/get_valid_b2b_customers?business_type=trade&document_status=${documentStatus}`, null, null);
                } else if(Number(b2b_customer_id) > 0){
                    b2b_customers = await HTTPRequest.getRequest(`${this.endPoint}/b2b_customers/get_valid_b2b_customers?id=${b2b_customer_id}&document_status=${documentStatus}`, null, null);
                } else {
                    if(['OTHPCV', 'OTHTOV'].includes(secureStorage.getItem('documentTypeCode'))){
                        b2b_customers = await HTTPRequest.getRequest(`${this.endPoint}/b2b_customers/get_valid_b2b_customers?business_type=trade&document_status=S`, null, null);
                    } else {
                        b2b_customers = await HTTPRequest.getRequest(`${this.endPoint}/b2b_customers/get_valid_b2b_customers?document_status=${documentStatus}`, null, null);
                    }
                }
                this.b2bCustomerOptions = b2b_customers.map(b2b_customer => ({ id: b2b_customer.id, name: decrypt(b2b_customer.custom_name_view), wtax_code: b2b_customer.wtax_code, payment_term: b2b_customer.payment_term, is_on_hold:b2b_customer.is_on_hold, vat_type: b2b_customer.vat_type, extras: {address: b2b_customer.address,province_name: b2b_customer.province_name, city_name:b2b_customer.city_name, barangay_name:b2b_customer.barangay_name, zip_code:b2b_customer.zip_code,country_name: b2b_customer.country_name} }));
            },
            async selectCustomerType(customerType) {
                try {
                    var document = await this.getCurrentDocument();

                    if (!this.isCustomerDisabled) {
                        this.selectedCustomerType = customerType;
                        if (document) {
                            // handle switching between customer types
                            if (this.selectedCustomerType == "customer" && document["b2b_customer_id"] > 0) {
                                this.customer = [];
                            } else if (this.selectedCustomerType == "b2b" && document["customer_id"] > 0) {
                                this.b2bCustomer = [];
                            }
                        }
                    }
                } catch (error) {
                    console.error("Error occurred while selecting customer type:", error);
                }
            },
            async fetchAndProcessCustomerDetails() {
                if (this.customer) {
                    var customer = null;
                    var document = null;

                    // fetch document based on document type
                    if (this.currentDocumentTypeCode === 'RELDDE') {
                        document = await HTTPRequest.getRequest(this.endPoint + "documents/" + this.$route.params.sales_order_id, null);
                    } else if (this.currentDocumentTypeCode === 'OTHSIN') {
                        document = await HTTPRequest.getRequest(this.endPoint + "documents/" + this.$route.params.delivery_document_id, null);
                    }

                    // consider customer type in populating customer details
                    if (document && document["customer_type"] === "customer") {
                        customer = await HTTPRequest.getRequest(this.endPoint + "customers/" + this.customer.key, null);
                    } else if (document && document["customer_type"] === "b2b") {
                        customer = await HTTPRequest.getRequest(this.endPoint + '/b2b_customers/' + this.b2bCustomer, null);

                        if (customer) {
                            const address = `${customer.address || ''} ${customer.barangay_name || ''} ${customer.city_name || ''} ${customer.province_name || ''}`;
                            customer.address = address; // update address field for b2b customer
                        }
                    }

                    if (customer) {
                        this.customerAddress = customer.address || "No Customer Address";
                        this.customerContactMobile = decrypt(customer.mobile) || "No Customer Mobile";
                        this.customerContactTelephone = decrypt(customer.telephone) || "No Customer Telephone";
                        this.customerContactFax = customer.fax || "No Customer Fax";
                        this.customerContactEmail = decrypt(customer.email) || "No Customer Email";
                        this.selectedCustomerContact = customer.mobile ? 'Mobile' : customer.telephone ? 'Telephone' : customer.fax ? 'Fax' : customer.email ? 'Email' : 'Telephone';
                        this.activeCustomerContact = decrypt(customer.mobile) || decrypt(customer.telephone) || customer.fax || decrypt(customer.email) || decrypt(this.customerContactTelephone);
                    }
                }
            },
            // Enforces the max length on the advanced-info fields (reference, remark, OC Reference No., Shipment Reference No.)
            // Trims it to the limit, and tells the user why it was cut
            trimToMaxLength(fieldKey, fieldLabel, value, max) {
                this.isEditing = true;
                value = value || '';
                max = max || this.fieldMaxLength;

                if (value.length <= max) {
                    return;
                }

                // Trim to the limit characters
                this.$nextTick(() => {
                    this[fieldKey] = value.slice(0, max);
                });

                if (this.focusedLengthField === fieldKey) {
                    this.$notification.info({
                        message: 'Character Limit Reached',
                        description: `The ${fieldLabel} field is limited to ${max} characters. Your input was trimmed to fit.`,
                    });
                }
            },
            onLengthFieldBlur(fieldKey) {
                if (this.focusedLengthField === fieldKey) {
                    this.focusedLengthField = null;
                }
            },
            handleInputChange() {
                this.isEditing = true;
            },
            // Resolve the b2b_customer_id to send on save/update/post. The b2bCustomer select
            // (v-model) can end up empty due to allowClear or an options reset, which would null
            // out a customer the document actually has. For b2b documents, fall back to the
            // selected customer object (this.customer.key, which the serializer fills with the
            // b2b customer id) so we never persist b2b_customer_id = null when one is set.
            resolveB2bCustomerId() {
                var selected = parseInt(this.b2bCustomer, 10);
                if (!isNaN(selected) && selected > 0) {
                    return selected;
                }
                if (this.selectedCustomerType === 'b2b' && this.customer && this.customer.key != undefined) {
                    var fallback = parseInt(this.customer.key, 10);
                    if (!isNaN(fallback) && fallback > 0) {
                        return fallback;
                    }
                }
                return null;
            },
            async fetchCompanyBasedOnSupplyingSite() {
                //this.isEditing = true;
                try {
                    if (!this.supplyingSite || !this.supplyingSite.key) {
                        console.error('Supplying site not selected.');
                        return;
                    }

                    const supplyingSiteId = String(this.supplyingSite.key).replace('sites', '');
                    // Trap invalid id: don't call sites/<id> when it resolves to -1 / not positive.
                    if (!(parseInt(supplyingSiteId) > 0)) {
                        return;
                    }

                    //Get default sublocation of origin site
                    if (this.documentStatus != 'Posted' && this.documentStatus != 'Voided' && this.documentStatus != 'Confirmed'){
                        var origin_subloc = await HTTPRequest.getRequest(this.endPoint + 'sublocations/get_site_sublocations?site_id='+supplyingSiteId+'&is_default=true', null)
                        if (this.originSublocation.key == undefined || this.originSublocation.key == 0 || this.originSublocation.key == '0'){
                            this.originSublocation.key = origin_subloc[0].id
                            this.originSublocation.label = origin_subloc[0].name

                            var arr = {
                                key:origin_subloc[0].id,
                                label:origin_subloc[0].name
                            }
                            var originSublocation = arr
                            Object.assign(this, {
                                originSublocation,
                                sublocations: [],
                                fetching: false,
                            })
                        }
                    }

                    //const siteResponse = await HTTPRequest.getRequest(this.endPoint + 'sites/get_all_document_sites?id=' + supplyingSiteId, null);
                    //Optimization: Get site details
                    const siteResponse = await this.getSiteById(supplyingSiteId);
                    if (siteResponse) {
                            this.company = siteResponse.company_name;
                            this.company_id = siteResponse.company_id;
                        // const site = siteResponse.find(site => parseInt(site.id) === parseInt(supplyingSiteId));

                        // if (site && site.company_id) {
                        //     const companyResponse = await HTTPRequest.getRequest(this.endPoint + '/companies/get_valid_companies?id=' + site.company_id, null);

                        //     const company = companyResponse.find(company => company.id === site.company_id);
                        //     if (company) {
                        //         this.company = company.name;
                        //         this.company_id = company.id;
                        //     } else {
                        //         console.error('Company not found for the selected supplying site.');
                        //     }
                        // }
                    } else {
                        console.error('No valid site found with the provided ID:', supplyingSiteId);
                    }

                } catch (error) {
                    console.error('Error fetching site and company:', error);
                }  
            },
            async populateAddress(siteType, siteKey, party_id, party) {
                // Trap invalid ids: never call sites/<id> when the id resolves to -1 (or is
                // empty/undefined), which happens when no site/party is selected.
                var parsedSiteKey = parseInt(String(siteKey != undefined ? siteKey : '').replace('sites', ''));
                var parsedPartyId = parseInt(party_id);
                if (this.docTypesForP2P.includes(this.currentDocumentTypeCode)) {
                    if (!(parsedSiteKey > 0)) {
                        return;
                    }
                    //let siteDetails;

                    // if (siteType === 'requestingSite') {
                    //     siteDetails = await HTTPRequest.getRequest(this.endPoint + 'sites/' + siteKey, null);
                    // } else if (siteType === 'supplyingSite') {
                    //     siteDetails = await HTTPRequest.getRequest(this.endPoint + 'sites/' + siteKey, null);
                    // } 
                    //siteDetails = await HTTPRequest.getRequest(this.endPoint + 'sites/' + siteKey, null); arvs

                    const siteDetails = await this.getSiteById(siteKey);

                    //Dont allow HO to create PO
                    if(this.currentDocumentTypeCode == 'ORIPOX' && siteDetails.site_type == 'ho'){
                        component_x.$notification['error']({
                            message: 'Error',
                            description: "The requesting branch must not be HO.",
                            style: getNotificationStyle('error')
                        });
                        this.requestingSite = []
                        return
                    }

                    const checkBoxMeLocationLength = siteDetails.boxme_location || 0
                    if(checkBoxMeLocationLength.length > 0){
                        this.address = siteDetails.address_1 || 'No Address';
                        this.zipCode = siteDetails.zip_code || 'No Zip Code';
                        try {
                        // if (siteType === 'requestingSite') {
                        //     siteDetails = await HTTPRequest.getRequest(this.endPoint + 'sites/' + siteKey, null);
                        // } else if (siteType === 'supplyingSite') {
                        //     siteDetails = await HTTPRequest.getRequest(this.endPoint + 'sites/' + siteKey, null);
                        // } 
                        //siteDetails = await HTTPRequest.getRequest(this.endPoint + 'sites/' + siteKey, null); arvs
                        const siteDetails = await this.getSiteById(siteKey);
                
                            if(siteDetails.boxme_location.length > 0){
                                this.zipCode = siteDetails.zip_code || 'No Zip Code';
                                this.province = siteDetails.boxme_location[0]['province_name'] || 'No Province';
                                this.country = siteDetails.boxme_location[0]['country'] || 'No Country';
                                this.city = siteDetails.boxme_location[0]['district_name'] || 'No City';
                                this.barangay = siteDetails.boxme_location[0]['subdistrict_name'] || 'No Barangay';
                            } 
                        } catch (error) {
                            this.province = 'No Province';
                            this.country = 'No Country';
                            this.city = 'No City';
                            this.barangay = 'No Barangay';
                        }
                    } else {
                        this.address = siteDetails.address_1 || 'No Address';
                        this.zipCode = siteDetails.zip_code || 'No Zip Code';
                        this.country = siteDetails.countries_name || 'No Country';
                        this.province = siteDetails.province_name || 'No Province';
                        this.city = siteDetails.city_name || 'No City';
                        this.barangay = siteDetails.barangay_name || 'No Barangay';
                    }
                } else if (this.docTypesForP2P.includes(this.currentDocumentTypeCode) && party == 'site') {
                    if (!(parsedPartyId > 0)) {
                        return;
                    }
                    const siteDetails = await this.getSiteById(parsedPartyId);
                    const checkBoxMeLocationLength = siteDetails.boxme_location || 0
                    if(checkBoxMeLocationLength.length > 0){
                        this.address = siteDetails.address_1 || 'No Address';
                        this.zipCode = siteDetails.zip_code || 'No Zip Code';
                        try {
                            this.province = siteDetails.boxme_location[0]['province_name'] || 'No Province';
                            this.country = siteDetails.boxme_location[0]['countries_name'] || siteDetails.boxme_location[0]['country_name'] || 'No Country';
                            this.city = siteDetails.boxme_location[0]['district_name'] || 'No City';
                            this.barangay = siteDetails.boxme_location[0]['subdistrict_name'] || 'No Barangay';
                        } catch (error) {
                            this.province = 'No Province';
                            this.country = 'No Country';
                            this.city = 'No City';
                            this.barangay = 'No Barangay';
                        }
                    } else {
                        this.zipCode = siteDetails.zip_code || 'No Zip Code';
                        this.country = siteDetails.countries_name || siteDetails.country_name || 'No Country';
                        this.address = siteDetails.address_1 || 'No Address';
                        this.province = siteDetails.province_name || 'No Province';
                        this.city = siteDetails.city_name || 'No City';
                        this.barangay = siteDetails.barangay_name || 'No Barangay';
                    }
                }
            },
            async exportExcelDocument(){

                this.spinning = true;
                this.spinMessage = 'Exporting to EXCEL...';
                
                //Implement exporting based on customized list
                const today = new Date();
                const date = today.getFullYear() + '0' + (today.getMonth()+1) + '0' + today.getDate();
                const time = today.getHours() + '0' + today.getMinutes() + '0' + today.getSeconds();
                const timestamp = date + '0' + time;
                var cols = []
                var doc_cols = []
                var cl = this.filteredColumnFields.filter(f => f.value !== false)
                var data = this.tabulator.getData()
                var data_cols = Object.keys(data[0])
                var isBarter = 0

                if (component_x.documentNumber > 0) {
                    var document = await component_x.getCurrentDocument();
                    isBarter = document.reference_7
                }

                cl.forEach(function (col) {
                    if(col.value == false)
                        cols.push(col.name)
                    doc_cols.push(col.name)
                });

                // For customizing col headers position in export excel sheet
                if (this.currentDocumentTypeCode === "ORIPOX") {
                    doc_cols = ['line_no', 'product_icon', 'brand_name', 'stock_no', 'product_name', 'unit_name', 'quantity', 'remaining_qty', 'on_hand_quantity','avail_qty_to_transact', 'price', 'total_gross', 'cost', 'subtotal', 'discount', 'discount_text', 'barcode', 'vendor_item_no'];
                }else if(this.currentDocumentTypeCode === "OTHPUR"){
                    doc_cols = ['line_no', 'product_icon', 'brand_name', 'stock_no', 'product_name', 'unit_name', 'quantity', 'remaining_qty', 'on_hand_quantity','avail_qty_to_transact', 'price', 'subtotal', 'barcode', 'vendor_item_no'];
                }else if(this.currentDocumentTypeCode === "RECDEL"){
                    doc_cols = ['line_no', 'product_icon', 'brand_name', 'stock_no', 'product_name', 'unit_name','reason', 'quantity', 'remaining_qty', 'on_hand_quantity','avail_qty_to_transact', 'price', 'total_gross', 'cost', 'subtotal', 'discount', 'discount_text','invoice_amount','invoice_discount','remarks','ref_code', 'barcode', 'vendor_item_no'];
                }else if(this.currentDocumentTypeCode === "ORIASN"){
                    doc_cols = ['line_no', 'product_icon', 'brand_name', 'stock_no', 'product_name', 'unit_name','quantity', 'remaining_qty', 'on_hand_quantity','avail_qty_to_transact', 'price', 'total_gross', 'cost', 'subtotal', 'discount', 'discount_text','remarks', 'barcode', 'vendor_item_no'];
                }else if(this.currentDocumentTypeCode === "OTHPWS"){
                    doc_cols = ['line_no', 'product_icon', 'brand_name', 'stock_no', 'product_name', 'onhand_quantity','old_retail_price', 'retail_price', 'markup_percent','old_original_cost', 'original_cost', 'old_landed_cost', 'landed_cost', 'old_ordering_cost', 'ordering_cost', 'old_special_price','special_price', 'old_wholesale_price', 'wholesale_price', 'old_least_price', 'least_price', 'barcode', 'vendor_item_no'];
                } else if (this.currentDocumentTypeCode === "RELRSR" && isBarter == 'Interco Tool'){
                    doc_cols = ['line_no', 'brand_id', 'stock_no', 'product_name', 'ref_code', 'barcode', 'unit_name', 'quantity', 'actual_quantity', 'remaining_qty', 'on_hand_quantity', 'avail_qty_to_transact', 'price', 'cost', 'subtotal', 'discount', 'discount_text', 'invoice_total', 'margin','trade_commission_rate','trade_discount','interco_payable', 'remarks', 'vendor_item_no'];
                } else if (this.currentDocumentTypeCode === "ORIOSO"){
                    doc_cols = ['line_no', 'product_icon', 'brand_name', 'stock_no', 'product_name', 'ref_code', 'barcode', 'unit_name', 'item_source', 'quantity', 'actual_quantity', 'on_hand_quantity', 'price', 'subtotal', 'discount', 'discount_text', 'remarks', 'salesman_name', 'vendor_item_no', 'line_extras'];
                // }else if(['OTHSIN'].includes(this.currentDocumentTypeCode) && this.accountName.toLowerCase().includes('piml')){
                //     doc_cols = ['line_no','brand_name', 'barcode', 'vendor_item_no', 'style_name', 'size', 'color', 'unit_name', 'quantity', 'actual_quantity', 'price', 'currency', 'total_gross', 'discount', 'net_amount'];
                }

                let difference = data_cols.filter(x => !doc_cols.includes(x));
            if(!['OTHLIQ'].includes(this.currentDocumentTypeCode)){
                data.forEach(function (data) {
                    data["unit_id"] = data["unit_name"]
                    data["brand_id"] = data["brand_name"]
                    data["reason_id"] = data["reason"]
                    const moneyFormat = [
                        'amount_net',
                        'amount_gross',
                        'gross_amount',
                        'subtotal',
                        'price',
                        'total_gross',
                        'discount',
                        'discount_text',
                        'discount_total_amount',
                        'net_amount',
                        'net_receivable',
                        'ordering_cost',
                        'cost',
                        'old_retail_price',
                        'retail_price',
                        'markup_percent',
                        'old_original_cost',
                        'original_cost',
                        'old_landed_cost',
                        'landed_cost',
                        'old_ordering_cost',
                        'old_special_price',
                        'special_price',
                        'old_wholesale_price',
                        'wholesale_price',
                        'old_least_price',
                        'least_price',
                        'quantity',
                        'actual_quantity',
                        'content_quantity', 
                        'cancelled_quantity',
                        'on_hand_quantity',
                        'ordered_quantity',
                        'goods_issue_quantity',
                        'detail_quantity',
                        'delivery_quantity',
                        'allocated_quantity',
                        'requested_quantity',
                        'pos_return_quantity',
                        'pos_sales_quantity',
                        'variance_quantity',
                        'variance_amount',
                        'cs_amount',
                        'cs_quantity',
                        'discount_amount',
                        'trade_commission_rate',
                        'trade_discount',
                        'quantity',
                        'avail_qty_to_transact',
                        'available_quantity',
                    ];

                    moneyFormat.forEach(key => {
                        if (key in data) {
                            data[key] = data[key] ? parseFloat(data[key]) : 0.0
                        }
                    });

                    cols.forEach(function (col) {
                        delete data[col]; 
                    });

                    difference.forEach(function (diff) {
                        delete data[diff]; 
                        if (diff !== 'product_icon') {
                            delete data[diff]; 
                        }
                    });
                });
            } else if(['OTHLIQ'].includes(this.currentDocumentTypeCode)){
                data.forEach(function (data) {
                    data["unit_id"] = data["unit_name"]
                    data["brand_id"] = data["brand_name"]
                    data["reason_id"] = data["reason"]
                });
            }
                // For customizing col headers in export excel sheet
                const formatColumnName = (name) => {
                    return name.replace('_id', '').replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
                };
                const sequenceData = data.map(item => {
                    const sequenceItem = {};
                    const isPiml = this.accountName.toLowerCase().includes('piml')
                    doc_cols.forEach(col => {
                        const formattedName = formatColumnName(col);
                        if (formattedName === 'Price' && ['RECADJ', 'RELADJ'].includes(this.currentDocumentTypeCode)) {
                            sequenceItem['SRP'] = item[col];
                        } else if (formattedName === 'Trade Discount') {
                            sequenceItem['Trade Discount'] = parseFloat(item[col]);
                        } else if (formattedName === 'Cs Quantity') {
                            sequenceItem['Cs Quantity'] = parseFloat(item[col]);
                        } else if (formattedName === 'Cs Amount') {
                            sequenceItem['Cs Amount'] = parseFloat(item[col]);
                        } else if (formattedName === 'Product Name' && (this.currentDocumentTypeCode != 'OTHTOV' && this.currentDocumentTypeCode != 'OTHPCV')) {
                            if (this.currentDocumentTypeCode == 'ORIOCR'){
                                sequenceItem['Item Description'] = item[col];
                            } else {
                                sequenceItem['Description'] = item[col];
                            }
                        } else if (formattedName === 'Brand Name') {
                            sequenceItem['Brand'] = item[col];
                        } else if (formattedName === 'Cs Variance Amount') {
                            sequenceItem['Variance Amount'] = parseFloat(item[col]);
                        } else if (formattedName === 'Cs Variance Quantity') {
                            sequenceItem['Variance Quantity'] = parseFloat(item[col]);
                        } else if (formattedName === 'Net Amount' && ['OTHLIQ'].includes(this.currentDocumentTypeCode)) {
                            sequenceItem['Net Sales'] = parseFloat(item[col]);
                        } else if (formattedName === 'Cost' && ['OTHLIQ'].includes(this.currentDocumentTypeCode)) {
                            sequenceItem['Price'] = parseFloat(item[col]);
                        } else if (formattedName === 'Subtotal' && ['OTHSIN'].includes(this.currentDocumentTypeCode)) {
                            sequenceItem['Total Gross'] = parseFloat(item[col]);
                        } else if (formattedName === 'Total Gross' && ['ORISOX','RELDDE'].includes(this.currentDocumentTypeCode)) {
                            if (['ORISOX','RELDDE'].includes(this.currentDocumentTypeCode) && !isPiml){
                                if (this.accountName.toLowerCase().includes('primerph'))
                                sequenceItem['Gross Amount'] = parseFloat(item[col]);
                            } else {
                                if (!isPiml){
                                    sequenceItem['Subtotal'] = parseFloat(item[col]);
                                } else {
                                    sequenceItem['Total Gross Sales Amount'] = parseFloat(item[col]);
                                }
                            }
                        } else if (formattedName === 'Site Liquidation' && ['OTHLIQ'].includes(this.currentDocumentTypeCode)) {
                            sequenceItem['Site'] = item[col];
                        } else if (formattedName === 'Unit Name' && ['ORIPOX', 'OTHPUR', 'RECDEL','ORIASN', 'RELRSR', 'ORIOSO'].includes(this.currentDocumentTypeCode)) {
                            sequenceItem['Unit'] = item[col];
                        } else if (formattedName === 'Price' && ['ORIPOX','OTHPUR','RECDEL','ORIASN'].includes(this.currentDocumentTypeCode)) {
                            sequenceItem['Ordering Cost'] = item[col];
                        } else if (formattedName === 'Cost' && ['OTHPUR','RELRSR','RELTRX'].includes(this.currentDocumentTypeCode)) {
                            sequenceItem['Unit Net Cost'] = item[col];
                        } else if (formattedName === 'Actual Quantity' && ['OTHSIN','OTHSRQ','ORISOX'].includes(this.currentDocumentTypeCode) && isPiml) {
                            sequenceItem['Actual Qty'] = parseFloat(item[col]);
                        } else if (formattedName === 'Discount' && ['OTHSIN'].includes(this.currentDocumentTypeCode) && this.accountName.toLowerCase().includes('piml')) {
                            sequenceItem['Sales Discount Amount'] = parseFloat(item[col]);
                        } else if (formattedName === 'Net Amount' && ['OTHSIN','OTHSRQ', 'ORISOX'].includes(this.currentDocumentTypeCode) && isPiml) {
                            sequenceItem['Total Net Sales Amount    '] = parseFloat(item[col]);
                        } else if (formattedName === 'Pur Currency' && ['OTHSIN','OTHSRQ', 'ORISOX'].includes(this.currentDocumentTypeCode) && isPiml) {
                            sequenceItem['Purchase Amount Currency'] = item[col];
                        } else if (formattedName === 'Currency' && ['OTHSIN','OTHSRQ', 'ORISOX'].includes(this.currentDocumentTypeCode) && isPiml) {
                            sequenceItem['Sales Amount Currency'] = item[col];
                        } else if (formattedName === 'Unit Name' && ['OTHSIN','OTHSRQ', 'ORISOX'].includes(this.currentDocumentTypeCode) && isPiml) {
                            sequenceItem['Unit'] = item[col];
                       } else if (formattedName === 'Price' && ['ORIOCR'].includes(this.currentDocumentTypeCode)) {
                            sequenceItem['Original Price'] = item[col];
                        } else if (formattedName === 'Quantity' && ['ORIOCR'].includes(this.currentDocumentTypeCode)) {
                            sequenceItem['Order Quantity'] = parseFloat(item[col]);
                            sequenceItem["Quantity"] = parseFloat(item[col]);
                        }
                        // else if (formattedName === 'Price' && ['RELRSR'].includes(this.currentDocumentTypeCode)) {
                        //     sequenceItem['Cost'] = item[col];
                        // }
                        else if (formattedName === 'Cost' && ['RECDEL','ORIASN'].includes(this.currentDocumentTypeCode)) {
                            sequenceItem['Unit Net Ordering Cost'] = item[col];
                        } else if (formattedName === 'Net Cost' && ['ORIPOX'].includes(this.currentDocumentTypeCode)) {
                            sequenceItem['Unit Net Ordering Cost'] = item[col];
                        } else if (formattedName === 'Line No' && ['OTHPUR','OTHSIN','RELRSR','RELTRX','RECTRX','ORISOX','RELDDE'].includes(this.currentDocumentTypeCode) && !isPiml) {
                            if (['ORISOX','RELDDE','RELTRX','RECTRX'].includes(this.currentDocumentTypeCode)){
                                sequenceItem['No.'] = item[col];
                            } else {
                                sequenceItem['#'] = item[col];
                            }
                        } else if (['OTHPWS'].includes(this.currentDocumentTypeCode)) {
                            const pws_col_header_mapping = {
                                'Line No': '#',
                                'Onhand Quantity': 'On Hand Quantity',
                                'Markup Percent': 'Markup %',
                                'Old Original Cost': 'Old Original',
                                'Original Cost': 'New Original',
                                'Old Landed Cost': 'Old Landed',
                                'Landed Cost': 'New Landed',
                                'Ordering Cost': 'New Ordering Cost',
                                'Special Price': 'New Special Price',
                                'Wholesale Price': 'New Wholesale Price',
                                'Least Price': 'New Least Price',
                                'Retail Price': 'New Retail Price',
                            };

                            if (formattedName in pws_col_header_mapping) {
                                sequenceItem[pws_col_header_mapping[formattedName]] = item[col];
                            } else if (!['Product Icon', 'Brand Name', 'Product Name'].includes(formattedName)) {
                                sequenceItem[formattedName] = item[col];
                            }
                        } else if (formattedName === 'Quantity' && ['ORIPOX', 'OTHPUR', 'RECDEL','ORIASN','ORISOX','RELDDE','OTHSBI', 'RELRSR', 'OTHSRQ', 'RELTRX'].includes(this.currentDocumentTypeCode)) {
                            if (isPiml && ['OTHSRQ','ORISOX'].includes(this.currentDocumentTypeCode)){
                                sequenceItem[this.currentDocumentTypeCode == 'OTHSRQ' ? 'SR Qty' : 'SO Qty'] = parseFloat(item[col]);
                            }else{
                                sequenceItem['Doc Qty'] = parseFloat(item[col]);
                            }
                            sequenceItem["Quantity"] = parseFloat(item[col]);

                        } else if (formattedName === 'Quantity' && ['OTHPCN','OTHPCV'].includes(this.currentDocumentTypeCode)) {
                            sequenceItem['Count Quantity'] = parseFloat(item[col]);
                            sequenceItem["Quantity"] = parseFloat(item[col]);
                        } else if (formattedName === 'Salesman Name' && ['ORIOSO'].includes(this.currentDocumentTypeCode)) {
                            sequenceItem['Salesman'] = item[col];
                        } else if (formattedName === 'Line Extras' && ['ORIOSO'].includes(this.currentDocumentTypeCode)) {
                            sequenceItem['Extras'] = item[col];
                        } else if (formattedName === 'Actual Quantity' && ['OTHPCN','OTHPCV'].includes(this.currentDocumentTypeCode)) {
                            sequenceItem['Freeze Quantity'] = parseFloat(item[col]);
                        } else if (formattedName === 'Discount' && ['ORIPOX', 'OTHPUR', 'RECDEL','ORIASN','RELCSI','OTHLIQ','RELTRX','ORISOX','RELDDE','RELRSR','OTHSBI', 'ORIOSO', 'RECTRX'].includes(this.currentDocumentTypeCode)) {
                            if (isPiml && this.currentDocumentTypeCode == 'ORISOX') {
                                sequenceItem['Sales Discount Amount'] = parseFloat(item[col]);
                            } else {
                                sequenceItem['Discount Amount'] = parseFloat(item[col]);
                            }
                        } else if (formattedName === 'Gross Amount' && this.currentDocumentTypeCode === "RELCSI") {
                            sequenceItem['Subtotal'] = item[col];
                        } else if (formattedName === 'Line No' && this.currentDocumentTypeCode === "RELCSI") {
                            sequenceItem['#'] = item[col];
                        } else if (formattedName === 'Reason' && this.currentDocumentTypeCode === "OTHTOV") {
                            sequenceItem['Resolution'] = item[col];
                        } else if (formattedName === 'Sti Qty' && this.currentDocumentTypeCode === "OTHTOV") {
                            sequenceItem['STI Quantity'] = parseFloat(item[col]);
                        } else if (formattedName === 'Sto Qty' && this.currentDocumentTypeCode === "OTHTOV") {
                            sequenceItem['STO Quantity'] = parseFloat(item[col]);
                        } else if (formattedName === 'Remaining Qty' && this.currentDocumentTypeCode === "RELTRX") {
                            sequenceItem['Rem Qty'] = item[col];
                        } else if (formattedName === '#' && ['OTHTOV'].includes(this.currentDocumentTypeCode)) {
                            sequenceItem['Line No.'] = item[col];
                        } else if (formattedName === 'Line No' && ['OTHSBI','RECCSR', 'ORIOSO'].includes(this.currentDocumentTypeCode)) {
                            sequenceItem['#'] = item[col];
                        } else if (formattedName === 'Product Name' && ['OTHTOV','OTHPCV'].includes(this.currentDocumentTypeCode)) {
                            sequenceItem['Item Description'] = item[col];
                        } else if (formattedName === 'Remarks' && ['ORISOX','REDDE','OTHPCN','OTHPCV', 'ORIOSO'].includes(this.currentDocumentTypeCode)) {
                            sequenceItem['Remark'] = item[col];
                        } else if (formattedName === 'On Hand Quantity' && ['ORISOX','RELDDE'].includes(this.currentDocumentTypeCode)) {
                            sequenceItem['On Hand Qty'] = parseFloat(item[col]);
                        } else if (formattedName === 'Actual Quantity' && ['ORISOX','RELDDE'].includes(this.currentDocumentTypeCode)) {
                            sequenceItem['Actual Qty'] = parseFloat(item[col]);
                        } else if (formattedName === 'Reason' && ['OTHPCV'].includes(this.currentDocumentTypeCode)) {
                            sequenceItem['Resolution'] = item[col];
                        } else if (formattedName === 'Target Date' && ['OTHPWS'].includes(this.currentDocumentTypeCode)) {
                            sequenceItem['Effectivity Date'] = item[col];
                        } else if (formattedName === 'Line No' && ['ORISOX','OTHSRQ', 'OTHSIN'].includes(this.currentDocumentTypeCode) && isPiml) {
                            sequenceItem['#'] = item[col];
                        } else if (formattedName === 'Price' && ['ORISOX','OTHSRQ', 'OTHSIN'].includes(this.currentDocumentTypeCode) && isPiml) {
                            sequenceItem['Sales Price'] = item[col];
                        } else if (formattedName === 'Remaining Qty' && ['ORISOX','OTHSRQ'].includes(this.currentDocumentTypeCode) && isPiml) {
                            sequenceItem['Balance Qty'] = parseFloat(item[col]);
                        } else if (formattedName === 'Ordering Cost' && ['ORISOX','OTHSRQ', 'OTHSIN'].includes(this.currentDocumentTypeCode) && isPiml) {
                            sequenceItem['Purchasing Cost'] = item[col];
                        } else if (formattedName === 'Total Ordering Cost' && ['ORISOX','OTHSRQ', 'OTHSIN'].includes(this.currentDocumentTypeCode) && isPiml) {
                            sequenceItem['Total Purchasing Amount'] = item[col];
                        } else if (formattedName === 'Quantity' && ['OTHSIN'].includes(this.currentDocumentTypeCode) && isPiml) {
                            sequenceItem["SI Qty"] = parseFloat(item[col]);
                            sequenceItem["Quantity"] = parseFloat(item[col]);
                        } else if (formattedName === 'Remaining Qty' && ['ORISOX', 'OTHSIN', 'OTHSRQ'].includes(this.currentDocumentTypeCode) && isPiml) {
                            sequenceItem["Balance Qty"] = parseFloat(item[col]);
                        } else if (formattedName === 'Discount' && ['ORISOX', 'OTHSIN', 'OTHSRQ'].includes(this.currentDocumentTypeCode) && isPiml) {
                            sequenceItem["Sales Discount Amount"] = parseFloat(item[col]);
                        } else if (formattedName === 'Total Gross' && ['ORISOX', 'OTHSIN', 'OTHSRQ'].includes(this.currentDocumentTypeCode) && isPiml) {
                            sequenceItem["Total Gross Sales Amount"] = item[col];
                        } else if (formattedName !== 'Product Icon') { 
                            sequenceItem[formattedName] = item[col]; 
                        } else if (formattedName === 'Doc Qty') {
                            sequenceItem['Doc Qty'] = parseFloat(item[col]);
                        } else if (formattedName === 'Actual Qty') {
                            sequenceItem['Actual Qty'] = parseFloat(item[col]);
                        } else if (formattedName === 'Available Quantity') {
                            sequenceItem['Available Quantity'] = parseFloat(item[col]);
                        } else if (formattedName === 'Avail Qty To Transact') {
                            sequenceItem['Avail Qty To Transact'] = parseFloat(item[col]);
                        }
                        if (formattedName === 'Quantity') {
                            sequenceItem["Quantity"] = parseFloat(item[col]);
                        }
                        if (formattedName === 'Available Quantity') {
                            sequenceItem["Available Quantity"] = parseFloat(item[col]);
                        }
                    }); 
                    return sequenceItem;
                });
                await HTTPRequest.postRequest(component_x.endPoint + 'users/create_user_act', null, {controller:"/document_form",category:this.currentDocumentTypeCode,system_module:this.currentDocumentTypeName,actions:"Export Excel"})
                
                console.log(sequenceData)
                var dataWS = XLSX.utils.json_to_sheet(sequenceData)
                var wb = XLSX.utils.book_new()
                XLSX.utils.book_append_sheet(wb, dataWS, this.currentDocumentTypeFriendlyCodeWithId)
                XLSX.writeFile(wb, this.friendlyCodeAndDocumentNo+".xlsx")

                this.spinning = false;
                this.spinMessage = 'Loading ...';

                // let tabulatorInstance = this.$refs.tabulator.getInstance();
                // tabulatorInstance.download("xlsx", this.friendlyCodeAndDocumentNo+".xlsx", {sheetName:"Document"});
            },
            async exportCsvDocument(){
                //Arvin 3489
                this.spinning = true;
                this.spinMessage = 'Exporting to CSV...';
                
                //Implement exporting based on customized list
                const today = new Date();
                const date = today.getFullYear() + '0' + (today.getMonth()+1) + '0' + today.getDate();
                const time = today.getHours() + '0' + today.getMinutes() + '0' + today.getSeconds();
                const timestamp = date + '0' + time;
                var cols = []
                var doc_cols = []
                var cl = this.filteredColumnFields.filter(f => f.value !== false);
                var data = this.tabulator.getData()
                var data_cols = Object.keys(data[0])
                var isBarter = 0
                var isPiml = this.accountName.toLowerCase().includes('piml')

                if (component_x.documentNumber > 0) {
                    var document = await component_x.getCurrentDocument();
                    isBarter = document.reference_7
                }

                cl.forEach(function (col) {
                    if(col.value == false)
                        cols.push(col.name)
                    doc_cols.push(col.name)
                });
                if(this.currentDocumentTypeCode === "OTHSBI"){
                    doc_cols = ['line_no', 'brand_id', 'barcode', 'product_name', 'unit_id', 'quantity', 'remaining_qty', 'on_hand_quantity','avail_qty_to_transact', 'cost', 'total_gross', 'discount', 'discount_text', 'subtotal','invoice_amount','invoice_discount','discount_total_amount','invoice_total','ordering_cost','margin','trade_commission_rate','trade_discount','interco_payable','remark', 'vendor_item_no'];
                } else if (this.currentDocumentTypeCode === "RELRSR" && isBarter == 'Interco Tool'){
                    doc_cols = ['line_no', 'brand_id', 'stock_no', 'product_name', 'ref_code', 'barcode', 'unit_name', 'quantity', 'actual_quantity', 'remaining_qty', 'on_hand_quantity', 'avail_qty_to_transact', 'price', 'cost', 'subtotal', 'discount', 'discount_text', 'invoice_total', 'margin','trade_commission_rate','trade_discount','interco_payable', 'remarks', 'vendor_item_no'];
                }else if(['OTHSIN', 'ORISOX'].includes(this.currentDocumentTypeCode) && this.accountName.toLowerCase().includes('piml')){
                    doc_cols = ['line_no','brand_name', 'barcode', 'vendor_item_no', 'style_name', 'size', 'color', 'unit_name', 'quantity', 'actual_quantity', 'price', 'currency', 'total_gross', 'discount', 'net_amount'];
                }

                //SR/SO/SI: Add Vendor Item Code, Ex-Factory in the export document.
                // if(['OTHSIN'].includes(this.currentDocumentTypeCode)){
                //     cols.push('vendor_item_code', 'ex_factory')
                //     doc_cols.push('vendor_item_code', 'ex_factory')
                // }
                let difference = data_cols.filter(x => !doc_cols.includes(x));
                data.forEach(function (data) {
                    data["unit_id"] = data["unit_name"]
                    data["brand_id"] = data["brand_name"]
                    data["reason_id"] = data["reason"]
                    cols.forEach(function (col) {   
                        delete data[col]; 
                    });
                    difference.forEach(function (diff) {
                        delete data[diff]; 
                    });
                });
                var fields = doc_cols.filter(x => x !== 'product_icon');
                var sentence_case_fields = fields.map(f => {
                    // For customizing col headers in CSV export
                    var header =  f.replace(/(^\w|[-_]\w)/g, g => g.replace(/[-_]/, ' ').toUpperCase()).replace("Id.label", "Name");
                    if (header === "Cost" && this.currentDocumentTypeCode != "OTHSBI") {
                        header = "Unit Net Cost";
                    }
                    if (header === "Product Name") {
                        header = "Description";
                    }if (header === "Unit Id") {
                        header = "Unit";
                    }
                    if (header === "Brand Id") {
                        header = "Brand";
                    }
                    if(['RECTRX', 'RELTRX'].includes(this.currentDocumentTypeCode)){
                        if (header === "Line No")
                            header = "No";
                    }
                    if (this.currentDocumentTypeCode === "OTHTOV"){
                        if (header === "Reason Id") {
                            header = "Resolution";
                        }
                        if (header === "Sti Qty") {
                            header = "STI Quantity";
                        }
                        if (header === "Sto Qty") {
                            header = "STO Quantity";
                        }
                    }

                    if(this.currentDocumentTypeCode === 'OTHSBI'){
                        if (header === "Subotal") {
                            header = "Gross Amount";
                        }
                        if (header === "Quantity"){
                            header = "Doc Qty";
                        }
                        if (header === "Barcode"){
                            header = "Barcode No";
                        }
                        if (header === "Discount"){
                            header = "Discount Amount";
                        }
                    }

                    if((this.currentDocumentTypeCode === 'ORISOX' && !isPiml) || this.currentDocumentTypeCode === 'RELDDE'){
                        if (header === "Line No"){
                            header = "No.";
                        }
                        if (header === "Quantity"){
                            header = "Doc Qty";
                        }
                        if (this.accountName.toLowerCase().includes('primerph') && header === "Total Gross"){
                            header = "Gross Amount";
                        }
                        if (header === "Discount"){
                            header = "Discount Amount";
                        }
                        if (header === "Remarks"){
                            header = "Remark";
                        }
                        if (header === "On Hand Quantity"){
                            header = "On Hand Qty";
                        }
                        if (header === "Actual Quantity"){
                            header = "Actual Qty";
                        }
                    }
                    if(this.currentDocumentTypeCode === 'OTHPCN' || this.currentDocumentTypeCode === 'OTHPCV'){
                        if (header === "Actual Quantity"){
                            header = "Freeze Quantity";
                        }
                        if (header === "Quantity"){
                            header = "Count Quantity";
                        }
                        if (header === "Remarks"){
                            header = "Remark";
                        }
                        if (header === "Reason Id"){
                            header = "Resolution";
                        }
                        if (header === "Description"  && this.currentDocumentTypeCode === 'OTHPCV'){
                            header = "Item Description";
                        }
                    }

                    if(this.currentDocumentTypeCode === 'OTHSIN'){
                        if (header === "Line No") {
                            header = "#";
                        }
                        if (header === "Brand Name"){
                            header = "Brand";
                        }
                        if (header === "Barcode" && this.accountName.toLowerCase().includes('primerph')){
                            header = "Barcode No";
                        }
                        if (header === "Discount"){
                            header = this.accountName.toLowerCase().includes('primerph') ? "Discount Amount" : "Sales Discount Amount";
                        }
                    }

                    if(this.currentDocumentTypeCode === 'RECCSR'){
                        if (header === "Line No") {
                            header = "#";
                        }
                    }

                    if(this.currentDocumentTypeCode === 'RELRSR'){
                        if (header === "Line No") {
                            header = "#";
                        }
                        if (header === "Remarks"){
                            header = "Remark";
                        }
                        if (header === "Discount"){
                            header = "Discount Amount";
                        }
                        if (header === "Quantity"){
                            header = "Doc Qty";
                        }
                    }

                    if (this.currentDocumentTypeCode === 'OTHPWS') {
                        const pws_csv_header_mapping = {
                            'Line No': '#',
                            'Markup Percent': 'Markup %',
                            'Old Original Cost': 'Old Original',
                            'Original Cost': 'New Original',
                            'Old Landed Cost': 'Old Landed',
                            'Landed Cost': 'New Landed',
                            'Ordering Cost': 'New Ordering Cost',
                            'Special Price': 'New Special Price',
                            'Wholesale Price': 'New Wholesale Price',
                            'Least Price': 'New Least Price'
                        };

                        if (header in pws_csv_header_mapping) {
                            header = pws_csv_header_mapping[header];
                        } else {
                            header = header;
                        }
                    }

                    if( isPiml && ['OTHSRQ', 'ORISOX', 'OTHSIN'].includes(this.currentDocumentTypeCode)){
                        if (header === "Line No"){
                            header = "#";
                        }
                        if (header === "Quantity"){
                            header = this.currentDocumentTypeCode === 'OTHSRQ' ? "SR Qty" : this.currentDocumentTypeCode === 'OTHSIN' ? "SI Qty" : "SO Qty";
                        }
                        if (header === "Currency"){
                            header = "Sales Amount Currency";
                        }
                        if (header === "Pur Currency"){
                            header = "Purchase Amount Currency";
                        }
                        if (header === "Remaining Qty"){
                            header = "Balance Qty";
                        }
                        if (header === "Price"){
                            header = "Sales Price";
                        }
                        if (header === "Total Gross"){
                            header = "Total Gross Sales Amount";
                        }
                        if (header === "Discount"){
                            header = "Sales Discount Amount";
                        }
                        if (header === "Net Amount"){
                            header = "Total Net Sales Amount";
                        }
                        if (header === "Ordering Cost"){
                            header = "Purchase Amount";
                        }
                        if (header === "Total Ordering Cost"){
                            header = "Total Purchasing Amount";
                        }
                        if (header === "Actual Quantity"){
                            header = "Actual Qty";
                        }
                        if (header === "Unit Name"){
                            header = "Unit";
                        }
                    }

                    if( isPiml && ['ORISOX','OTHSRQ', 'OTHSIN'].includes(this.currentDocumentTypeCode)){
                        if (header === "Net Amount"){
                            header = "Total Net";
                        }
                    }
                    if( isPiml && ['OTHSRQ', 'ORISOX', 'OTHSIN'].includes(this.currentDocumentTypeCode)){
                        if (header === "Line No"){
                            header = "#";
                        }
                        if (header === "Quantity"){
                            header = "Total SR Qty";
                        }
                        if (header === "Currency"){
                            header = "Selling Cur";
                        }
                        if (header === "Pur Currency"){
                            header = "Purchasing Cur";
                        }
                        if (header === "Remaining Qty"){
                            header = "Balance Qty";
                        }
                        if (header === "Price"){
                            header = "PIML Price";
                        }
                    }

                    // if( header === "Subtotal" && ['OTHSBI'].includes(this.currentDocumentTypeCode)){
                    //     header = "Gross Amount";
                    // }

                    return header
                });

                let myData
                await HTTPRequest.postRequest(component_x.endPoint + 'users/create_user_act', null, {controller:"/document_form",category:this.currentDocumentTypeCode,system_module:this.currentDocumentTypeName,actions:"Export CSV"})
                if (['ORIPOX','OTHPUR','RECDEL','ORIASN'].includes(this.currentDocumentTypeCode)){
                     myData = this.p2pArrayToCsv(data);
                } else {
                     myData = this.arrayToCsv(data,fields,sentence_case_fields);
                }
                this.downloadBlob(myData, timestamp + '_' + this.friendlyCodeAndDocumentNo + '.csv', 'text/csv;charset=utf-8;');
                this.spinning = false;
                this.spinMessage = 'Loading ...';
                // let tabulatorInstance = this.$refs.tabulator.getInstance();
                // tabulatorInstance.download("csv", this.friendlyCodeAndDocumentNo+".csv", {delimiter:","});
                
            },
            async exportCsvPwsDocument() {
                this.spinning = true;
                this.spinMessage = 'Exporting to CSV...';
                var userCode = secureStorage.getItem("userCode") || '';
                var printDate = moment().format('lll') || '';
                await HTTPRequest.postRequest(component_x.endPoint + 'users/create_user_act', null, {controller:"/document_form",category:this.currentDocumentTypeCode,system_module:this.currentDocumentTypeName,actions:"Export PWS CSV"})
                // Header information
                const headerData = [
                    ['PRIMER HQ', '', '', 'Price Work Sheet'],
                    ['', '', '', '# ' + this.documentNumber],
                    [],
                    ['', '', '', 'PWS Date:', this.documentDate.format('D-MMM-YYYY') || ''],
                    ['', '', '', 'Effectivity Date:', this.targetDate.format('D-MMM-YYYY') || ''],
                    ['', '', '', 'Reference:', this.reference],
                    ['', '', '', 'Status:', 'Active'],
                    [],
                    ['Purpose: ', this.purpose],
                    ['Remark: ', this.remark],
                    []  // Empty row for spacing
                ];

                const columnHeaders = [
                    '#', 'Stock No', 'Description', 'Barcode', 'Old Landed', 'Markup %', 
                    'Old Original', 'New Original', 'Old ORD', 'New ORD', 'Old WHS Price', 
                    'New WHS Price', 'Old LS Price', 'New LS Price', 'Old SP Price', 'New SP Price'
                ];

                const columnHeaderMap = {
                    '#': 'line_no',
                    'Stock No': 'stock_no',
                    'Description': 'product_name',
                    'Barcode': 'barcode',
                    'Old Landed': 'old_landed_cost',
                    'Markup %': 'markup_percent',
                    'Old Original': 'old_original_cost',
                    'New Original': 'original_cost',
                    'Old ORD': 'old_ordering_cost',
                    'New ORD': 'ordering_cost',
                    'Old WHS Price': 'old_wholesale_price',
                    'New WHS Price': 'wholesale_price',
                    'Old LS Price': 'old_least_price',
                    'New LS Price': 'least_price',
                    'Old SP Price': 'old_special_price',
                    'New SP Price': 'special_price',
                    'Old PIML Price1': 'old_piml_price1',
                    'New PIML Price1': 'piml_price1',
                    'Old PIML Price2': 'old_piml_price2',
                    'New PIML Price2': 'piml_price2',
                    'Old PIML Price3': 'old_piml_price3',
                    'New PIML Price3': 'piml_price3'
                };

                const transformTableData = (tableData, columnHeaders) => {
                    return tableData.map(row => {
                        let transformedRow = {};
                        columnHeaders.forEach(header => {
                            if (columnHeaderMap[header]) {
                                transformedRow[header] = row[columnHeaderMap[header]] || '';
                            }
                        });
                        return transformedRow;
                    });
                };

                // Get table data
                let tableData = this.tabulator.getData();
                tableData = transformTableData(tableData, columnHeaders);
                // Footer information
                const footerData = [
                    [],
                    ['','','Noted By:'],
                    ['','','Verified By:'],
                    ['','','Approved By:'],
                    [],  // Empty row for spacing
                    ['Printed By:', userCode || '','', 'Created By:', this.createdBy, 'Posted By:', this.postedBy || ''],
                    ['Print Date:', printDate || ''],
                    ['Post Date:', this.postDate || '']
                ];

                // Combine all data without adding headers in tableData
                let allData = [...headerData, columnHeaders, ...tableData.map(row => columnHeaders.map(header => row[header] || '')), ...footerData];
                // Convert to CSV
                const csvContent = this.arrayToCsvPws(allData);

                // Generate filename
                const timestamp = new Date().toISOString().replace(/[-:]/g, '').split('.')[0];
                const filename = `${timestamp}_${this.friendlyCodeAndDocumentNo}.csv`;

                // Download CSV
                this.downloadBlob(csvContent, filename, 'text/csv;charset=utf-8;');

                this.spinning = false;
                this.spinMessage = 'Loading ...';
            },
            async exportCsvWithHeaderDocument(){
                //Arvin 3489
                this.spinning = true;
                this.spinMessage = 'Exporting to CSV...';
                
                //Implement exporting based on customized list
                const today = new Date();
                const date = today.getFullYear() + '0' + (today.getMonth()+1) + '0' + today.getDate();
                const time = today.getHours() + '0' + today.getMinutes() + '0' + today.getSeconds();
                const timestamp = date + '0' + time;
                var data = this.tabulator.getData()
                var new_data = []

                switch (this.currentDocumentTypeCode) {
                    case 'OTHPUR':
                        var header_columns = ["customer_code","cas_no","code_and_document_no","brand_code","order_type","country_of_origin","fiscal_year","year_season","target_date","oc_reference"]
                        var header_columns_view = ["customer_code","cas_no","code_and_document_no","brand_code","order_type","country_of_origin","fiscal_year","year_season","target_date","oc_reference"]
                        var line_columns = ["barcode","quantity","price"]
                        var brand_details = await HTTPRequest.getRequest(this.endPoint + '/brands/'+this.brand.key, null);
                    break;
                    case 'ORISOX':
                        var header_columns = ["site_code","customer_code","document_date","target_date","country_of_origin","reference","amount_net"]
                        var header_columns_view = ["Site Code","Customer Code","Document Date","Target Date","Country Code","Reference","Total Amount"]
                        var line_columns = ["line_no","stock_no","product_name","ref_code","barcode","quantity","price","discount","subtotal","remarks"]
                    
                    break;
                    case 'ORIPOX':
                        var header_columns = ["site_code","supplier_code","document_date","target_date","country_of_origin","reference","amount_net"]
                        var header_columns_view = ["Site Code","Vendor Code","Document Date","Target Date","Country Code","Reference","Total Amount"]
                        var line_columns = ["line_no","stock_no","product_name","ref_code","barcode","quantity","price","discount","subtotal","remarks"]
                    break;           
                    default:
                    
                    break;
                }
                data.forEach(function (row) {
                    new_data.push(component_x.deleteExcessBodyData(row,line_columns))
                });
                new_data = new_data.map(row => _.at(row, line_columns))
                this.documentDetails.customer_address = this.customerAddress
                this.documentDetails.customer_contact = this.activeCustomerContact
                var b2b_details = await HTTPRequest.getRequest(this.endPoint + '/b2b_customers/'+this.customer.key, null);
                this.documentDetails.customer_code = b2b_details['code']
                if (this.currentDocumentTypeCode == "OTHPUR") this.documentDetails.brand_code = brand_details['code'];
                var site_details = await this.getSiteById(this.documentDetails["site_id"]["key"]);
                this.documentDetails.site_code = site_details ? site_details['nav_store_code'] : null
                var supplier_details = await HTTPRequest.getRequest(this.endPoint + '/suppliers/'+this.supplier.key, null);
                this.documentDetails.supplier_code = supplier_details['code']
                var country_details = {}
                if (parseInt(this.countryOfOrigin.key) > 0){
                    country_details = await HTTPRequest.getRequest(this.endPoint + '/countries/'+this.countryOfOrigin.key, null);
                }
                this.documentDetails.country_of_origin = country_details["code"] || "PH"
                this.documentDetails.oc_reference = this.ocReferenceNo
                this.documentDetails.fiscal_year = this.fiscalYear
                this.documentDetails.year_season = this.yearSeason
                this.documentDetails.target_date = this.targetDate.format('YYYY-MM-DD')
                var doc_header_details = this.deleteExcessHeaderData(this.documentDetails,header_columns);
                doc_header_details = this.formatAllColumnWIthObjectValue(doc_header_details);
                var header_data = [doc_header_details].map(row => _.at(row, header_columns))
                var header = header_columns.join(',')
                var header_values = Object.values(header_data).join(',')
                var header1 = line_columns.join(',')
                // const myData = this.arrayToCsv(data);
                var arrayAllValues = new_data.map((row) => {
                    var values = Object.values(row).join(',')
                    return values
                })
                var stringAllValues = arrayAllValues.reduce((growingString, elem) => {
                    return (growingString + '\n'+ elem)
                })
                await HTTPRequest.postRequest(component_x.endPoint + 'users/create_user_act', null, {controller:"/document_form",category:this.currentDocumentTypeCode,system_module:this.currentDocumentTypeName,actions:"Export CSV With Header"})
	            stringAllValues = header_columns_view + '\n' + header_values + '\n\n' + header1 + '\n' + stringAllValues
                this.downloadBlob(stringAllValues, timestamp + '_' + this.friendlyCodeAndDocumentNo + '.csv', 'text/csv;charset=utf-8;');
                this.spinning = false;
                this.spinMessage = 'Loading ...';
                // let tabulatorInstance = this.$refs.tabulator.getInstance();
                // tabulatorInstance.download("csv", this.friendlyCodeAndDocumentNo+".csv", {delimiter:","});
            },
            formatAllColumnWIthObjectValue(data){
                data.country_id = data.country_id ? data.country_id.label : this.countryOfOrigin.label || null
                if (this.currentDocumentTypeCode=='ORIPOX'){
                    data.customer_id = data.customer_id ? data.customer_id.key : this.customer.key || null
                }else{
                    data.customer_id = data.customer_id ? data.customer_id.label : this.customer.label || null
                }
                data.sublocation_id = data.sublocation_id ? (data.sublocation_id.key == 0) ? "Default Site" : data.sublocation_id.label : null
                return data
            },
            deleteExcessBodyData(data,cols){
                var header = Object.keys(data)
                header.forEach(function (col) {
                    if (!cols.includes(col)){
                        delete data[col]; 
                    }
                })
                return data;
            },
            deleteExcessHeaderData(data,cols){
                var header = Object.keys(data)
                header.forEach(function (col) {
                    if (!cols.includes(col)){
                        delete data[col]; 
                    }
                })
                return data;
            },
            // arrayToCsv(data) {
            //     const array = [Object.keys(data[0])].concat(data)
            //     return array.map(it => {
            //         return Object.values(it).toString()
            //     }).join('\n');
            // },
            arrayToCsv(data, fields, sentence_case_fields) {
                // Normalize fields to handle nested properties
                const normalizedFields = fields.map(field => field.split('.')[0]);
                // Filter out excluded fields
                const excluded_fields = Object.keys(data[0]).filter(x => !normalizedFields.includes(x));
                data.forEach(f => {
                    excluded_fields.forEach(e => delete f[e]);
                });

                // Prepare the CSV data
                //const new_data = [sentence_case_fields];
                const new_data = [sentence_case_fields.map(header => `"${header}"`)];

                for (const item of data) {
                    const row = fields.map(field => {
                        const [mainField, subField] = field.split('.');
                        let value = item[mainField];

                        if (subField) {
                            value = value && value[subField] !== null ? value[subField] : '';
                        }

                        if (['amount_net', 'amount_gross', 'subtotal', 'price', 'total_gross', 'discount_total_amount', 'net_amount', 'trade_discount', 'net_receivable','cost', 'discount'].includes(field)) {
                            value = value ? parseFloat(value).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '0.00';
                        } 
                        if (field === 'line_extras') {
                            value = value ? value.toString().replace(/\n/g, ' ') : '';                         
                        }
                        value =  value !== undefined && value !== null ? value.toString().replace(/, /g, ' ').replace(/"/g, '')  : '-';
                        return value = `"${value}"`
                    });
                    new_data.push(row);
                }

                return new_data.map(row => row.join(',')).join('\n');
            },

            p2pArrayToCsv(data) {
                const columnOrder = [
                    'line_no',
                    'brand_name',
                    'stock_no',
                    'product_name',
                    'unit_name',
                    'document_quantity',
                    'remaining_qty',
                    'on_hand_quantity',
                    'avail_qty_to_transact',
                    'unit_cost',
                    'unit_net_cost',
                    'subtotal',
                    'discount',
                ];
                const columnHeaderMap = {
                    'line_no': '#',
                    'brand_name': 'Brand',
                    'stock_no': 'Stock No',
                    'product_name': 'Description',
                    'unit_name': 'Unit',
                    'reason': 'Reason',
                    'document_quantity': 'Doc Qty',
                    'remaining_qty': 'Remaining Qty',
                    'on_hand_quantity': 'On-Hand Quantity',
                    'avail_qty_to_transact': 'Avail Qty to Transact',
                    'unit_cost': 'Ordering Cost',
                    'total_gross': 'Total Gross',
                    'unit_net_cost': 'Unit Net Ordering Cost',
                    'subtotal': 'Subtotal',
                    'discount': 'Discount Amount',
                    'discount_text':'Discount Text',
                    'invoice_amount': 'Invoice Amount',
                    'invoice_discount': 'Invoice Discount',
                    'remarks': 'Remark',
                    'ref_code': 'Ref Code',
                    'barcode': 'Barcode',
                    'vendor_item_no': 'Vendor Item No.',
                };

                const costIndex = columnOrder.indexOf('unit_cost');
                const unitIndex = columnOrder.indexOf('unit_name');

                if (this.currentDocumentTypeCode == 'RECDEL' || this.currentDocumentTypeCode == 'ORIASN' || this.currentDocumentTypeCode == 'ORIPOX'){
                    columnOrder.splice(costIndex + 1, 0, 'total_gross');
                } 
                if (this.currentDocumentTypeCode == 'RECDEL') {
                    columnOrder.splice(unitIndex + 1, 0, 'reason'); 
                }
                if (this.currentDocumentTypeCode == 'ORIPOX') {
                    columnOrder.push('discount_text');
                }
                // if (this.currentDocumentTypeCode === 'OTHPUR') {
                //     columnOrder[costIndex] = 'cost';
                //     columnOrder.filter(column => column !== 'discount_text');
                // }
                if (this.currentDocumentTypeCode !== 'OTHPUR') {
                    columnOrder.filter(column => column !== 'reason');
                }
                if (this.currentDocumentTypeCode === 'ORIASN') {
                    columnOrder.push('discount_text');
                    columnOrder.push('remarks');
                    // const docQtyIndex = columnOrder.indexOf('document_quantity');
                    // if (docQtyIndex !== -1) {
                    //     columnOrder[docQtyIndex] = 'actual_quantity';
                    // }
                }
                if (this.currentDocumentTypeCode === 'RECDEL') {
                    columnOrder.push(
                        'discount_text',
                        'invoice_amount',
                        'invoice_discount',
                        'remarks',
                        'ref_code',
                    );
                }
                columnOrder.push('barcode', 'vendor_item_no');
                const newColumnFormatted = []
                const reorderedData = data.map(item => {
                    let transformedRow = {};
                    const newItem = columnOrder.reduce((acc, key) => {
                        if (key === 'unit_name') {
                            acc['unit_name'] = item['unit_name'] !== undefined ? item['unit_name'] :
                                               item['unit_id'] !== undefined ? item['unit_id'] : '';
                        } else if (key === 'cost') {
                            acc['cost'] = item['price'] !== undefined ? item['price'] : '';
                        } else if (key === 'unit_cost') {
                            acc['unit_cost'] = item['price'] !== undefined ? item['price'] : '';
                        } else if (key === 'unit_net_cost') {
                            acc['unit_net_cost'] = item['cost'] !== undefined ? item['cost'] : '';
                        } else if (key === 'reason') {
                            acc['reason'] = item['reason_id'] !== null ? item['reason_id'] : 'No Reason';
                        } else if (key === 'document_quantity') {
                            acc['document_quantity'] = item['quantity'] !== null ? item['quantity'] : '';
                        } else {
                            acc[key] = item[key] !== undefined ? item[key] : '';
                        }
                        return acc;
                    }, {});
                    columnOrder.forEach(header => {
                        if (columnHeaderMap[header]) {
                            if (header == "unit_cost" && (this.currentDocumentTypeCode == 'ORIPOX' || this.currentDocumentTypeCode == 'RECDEL' || this.currentDocumentTypeCode === 'ORIASN')){
                                newColumnFormatted.push("Unit Cost")
                                transformedRow["Unit Cost"] = newItem[header] || '';
                            }else{
                                newColumnFormatted.push(columnHeaderMap[header])
                                transformedRow[columnHeaderMap[header]] = newItem[header] || '';
                            }
                        }
                    });
                    return transformedRow;
                });
                const headers = newColumnFormatted;
                const csv = [
                    headers.join(','),
                    ...reorderedData.map(row => headers.map(header => row[header]).join(','))
                ].join('\n');

                return csv;
            },

            arrayToCsvPws(data) {
                return data.map(row => {
                    if (Array.isArray(row)) {
                        return row.map(item => `"${item}"`).join(',');
                    } else if (typeof row === 'object') {
                        return Object.values(row).map(item => `"${item}"`).join(',');
                    }
                    return `"${row}"`;
                }).join('\n');
            },
            downloadBlob(content, filename, contentType) {
                // Create a blob
                var blob = new Blob([content], { type: contentType });
                var url = URL.createObjectURL(blob);

                // Create a link to download it
                var pom = document.createElement('a');
                pom.href = url;
                pom.setAttribute('download', filename);
                pom.click();
            },
            handleRemove(file) {
                const index = this.fileList.indexOf(file);
                const newFileList = this.fileList.slice();
                newFileList.splice(index, 1);
                this.fileList = newFileList;
            },
            pwsErrorMessages(errors) {
              if (this.currentDocumentTypeCode != "OTHPWS") return;

              if (!errors.validUniqueCodeHeader) {
                const currentSaveVia = this.saveMassUploadProductVia == 'stock_no' ? 'stock no' : 'barcode';
                const invalidSaveVia = this.saveMassUploadProductVia == 'stock_no' ? 'barcode' : 'stock no';
                this.massAddProductErrors.push(`Invalid ${invalidSaveVia} column. CSV first column must be ${currentSaveVia}`);
              }

              if (errors.invalidOrdering.length > 0)
                this.massAddProductErrors.push(`Invalid New Ordering in ${errors.uniqueCodeText}: ${errors.invalidOrdering.join(", ")}`);
                if (errors.invalidLanded.length > 0)
                this.massAddProductErrors.push(`Invalid New Landed in ${errors.uniqueCodeText}: ${errors.invalidLanded.join(", ")}`);

              if (errors.invalidPrice.length > 0)
                this.massAddProductErrors.push(`Invalid New Price in ${errors.uniqueCodeText}: ${errors.invalidPrice.join(", ")}`);
                
               if (errors.invalidPriceCost.length > 0)
                 this.massAddProductErrors.push(`Atleast one Price/Cost field is required in ${errors.uniqueCodeText}: ${errors.invalidPriceCost.join(", ")}`);

              if (errors.negativeOrdering.length > 0)
                this.massAddProductErrors.push(`Negative New Ordering in ${errors.uniqueCodeText}: ${errors.negativeOrdering.join(", ")}`);

              if (errors.negativePrice.length > 0)
                this.massAddProductErrors.push(`Negative New Price in ${errors.uniqueCodeText}: ${errors.negativePrice.join(", ")}`);

              if (errors.negativeLanded.length > 0)
                this.massAddProductErrors.push(`Negative New Landed in ${errors.uniqueCodeText}: ${errors.negativeLanded.join(", ")}`);
            },
            pwsMassProductUploadValidation(lines, linePointer) {
              let validUniqueCodeHeader = true;
              let blankUniqueCodeCount = 0;
              let invalidOrdering = '';
              let invalidPrice = '';
              let negativeOrdering = '';
              let negativePrice = '';
              let negativeLanded = '';
              let invalidLanded = '';
              let invalidSpecial = '';
              let negativeSpecial = '';
              let invalidWholesale = '';
              let negativeWholesale = '';
              let invalidPriceCost = '';
              let negativePimlPrice1 = '';
              let invalidPimlPrice1 = '';
              let negativePimlPrice2 = '';
              let invalidPimlPrice2 = '';
              let negativePimlPrice3 = '';
              let invalidPimlPrice3 = '';


              if (linePointer == 0) {
                const csvHeaders = lines[0].split(',');
                const currentSaveVia = this.saveMassUploadProductVia == 'stock_no' ? 'stock no' : 'barcode';

                if (csvHeaders[0].toString().toLowerCase() != currentSaveVia) validUniqueCodeHeader = false;

                return { validUniqueCodeHeader,
                         blankUniqueCodeCount, negativeLanded,
                         invalidOrdering, invalidPrice, invalidLanded, invalidPriceCost,
                         negativeOrdering, negativePrice, invalidSpecial, negativeSpecial, invalidWholesale, negativeWholesale, negativePimlPrice1, invalidPimlPrice1, negativePimlPrice2, invalidPimlPrice2, negativePimlPrice3, invalidPimlPrice3};
              }


              const productLine = lines[linePointer].split(',');
              // Check if barcode/stock no is blank
              if (lines[linePointer].length > 0 && productLine[0].length == 0)
                blankUniqueCodeCount += 1

              if (blankUniqueCodeCount == 0) {
                const parsedOrdering = parseFloat(productLine[1])
                if (isNaN(parsedOrdering)) {
                  // Check if New Ordering is present
                  invalidOrdering = `${productLine[0]}`;
                } else if (parsedOrdering < 0) {
                  // Check if New Ordering is negative
                  negativeOrdering = `${productLine[0]}`;
                }

                const parsedLanded = parseFloat(productLine[2])
                if (!isNaN(parsedLanded) && parsedLanded < 0) {
                  // Check if New Landed is negative
                  negativeLanded = `${productLine[0]}`;
                } else if(isNaN(parsedLanded)) {
                  invalidLanded = `${productLine[0]}`
                }


                const parsedPrice = parseFloat(productLine[3])
                if (isNaN(parsedPrice)) {
                  // Check if New Price is blank
                  invalidPrice = `${productLine[0]}`;
                } else if (parsedPrice < 0) {
                  // Check if New Price is negative
                  negativePrice = `${productLine[0]}`;
                }

                const parsedSpecialPrice = parseFloat(productLine[4])
                if (isNaN(parsedSpecialPrice)) {
                  // Check if New Price is blank
                  invalidSpecial = `${productLine[0]}`;
                } else if (parsedSpecialPrice < 0) {
                  // Check if New Price is negative
                  negativeSpecial = `${productLine[0]}`;
                }

                const parsedWholesale = parseFloat(productLine[5])
                if (isNaN(parsedWholesale)) {
                  // Check if New Price is blank
                  invalidWholesale = `${productLine[0]}`;
                } else if (parsedWholesale < 0) {
                  // Check if New Price is negative
                  negativeWholesale = `${productLine[0]}`;
                }

                if(this.accountName.toLowerCase().includes('piml')){
                    const parsedPimlPrice1 = parseFloat(productLine[6])
                    if (isNaN(parsedPimlPrice1)) {
                    // Check if New Price is blank
                    invalidPimlPrice1 = `${productLine[0]}`;
                    } else if (parsedPimlPrice1 < 0) {
                    // Check if New Price is negative
                    negativePimlPrice1 = `${productLine[0]}`;
                    }

                    const parsedPimlPrice2 = parseFloat(productLine[7])
                    if (isNaN(parsedPimlPrice2)) {
                    // Check if New Price is blank
                    invalidPimlPrice2 = `${productLine[0]}`;
                    } else if (parsedPimlPrice2 < 0) {
                    // Check if New Price is negative
                    negativePimlPrice2 = `${productLine[0]}`;
                    }

                    const parsedPimlPrice3 = parseFloat(productLine[8])
                    if (isNaN(parsedPimlPrice3)) {
                    // Check if New Price is blank
                    invalidPimlPrice3 = `${productLine[0]}`;
                    } else if (parsedPimlPrice3 < 0) {
                    // Check if New Price is negative
                    negativePimlPrice3 = `${productLine[0]}`;
                    }
                }

                // Check if all three invalid values are present
                if(invalidLanded && invalidPrice && invalidOrdering && invalidSpecial && invalidWholesale) {
                    invalidPriceCost = `${productLine[0]}`;
                }

                if(this.accountName.toLowerCase().includes('piml')){
                    invalidPriceCost = '';
                    if(invalidPimlPrice1 && invalidPimlPrice2 && invalidPimlPrice3){
                        invalidPriceCost = `${productLine[0]}`;
                    }
                }

              }
              return { validUniqueCodeHeader,
                       blankUniqueCodeCount, negativeLanded,
                       invalidOrdering, invalidPrice, invalidLanded, invalidPriceCost,
                       negativeOrdering, negativePrice, invalidSpecial, negativeSpecial, invalidWholesale, negativeWholesale, negativePimlPrice1, invalidPimlPrice1, negativePimlPrice2, invalidPimlPrice2, negativePimlPrice3, invalidPimlPrice3 };
            },
            dateIsValid(dateStr){
                const regex = /^\d{4}-\d{2}-\d{2}$/;

                if (dateStr.match(regex) === null) {
                    return false;
                }

                const date = new Date(dateStr);

                const timestamp = date.getTime();

                if (typeof timestamp !== 'number' || Number.isNaN(timestamp)) {
                    return false;
                }

                return date.toISOString().startsWith(dateStr);
            },
            beforeUpload(file) {
                this.fileList = [];
                const reader = new FileReader();
                reader.onload = async e => {
                    //     this.processCsvMassAdd(e.target.result);
                    this.massAddProductErrors = [];
                    this.massAddProductErrorsDL = [];
                    this.csvData = '';

                    var text = e.target.result;
                    var skulist = [];
                    var qtylist = [];
                    var orderingCost = [];
                    var lines = text.split(/[\r\n]+/g); // tolerate both Windows and Unix linebreaks
                    let productCount = 0;
                    let blankUniqueCodeCount = 0;
                    let pwsErrors = { validUniqueCodeHeader: true, uniqueCodeText: '', invalidOrdering: [], invalidPrice: [], invalidLanded: [], invalidPriceCost: [],
                                      negativeOrdering: [], negativePrice: [], negativeLanded: [] }

                    const exemptedDocTypes = !["OTHPWS"].includes(this.currentDocumentTypeCode)

                    pwsErrors.uniqueCodeText = lines[0].split(',')[0];

                    if(lines.length - 1 > this.maxLines)
                        this.massAddProductErrors.push('Total lines exceeded.  Please only upload up to ' + this.maxLines + ' lines.');

                    for(var i = 0; i < lines.length; i++) {
                        //PWS price & cost access validation
                        if(this.currentDocumentTypeCode == 'OTHPWS' && i > 0){
                            if((Number(lines[i].split(',')[2]) > 0) && !this.accessPWSCost){
                                this.massAddProductErrors.push('No access to update landed cost.');
                            }
                            if((Number(lines[i].split(',')[3]) > 0 || Number(lines[i].split(',')[4]) > 0 || Number(lines[i].split(',')[5]) > 0) && !this.accessPWSPrice){
                                this.massAddProductErrors.push('No access to update price.');
                            }
                        }
                        if( i == 0 && (lines[i].split(',')[0] != 'barcode' || lines[i].split(',')[1] != 'qty' || (lines[i].split(',')[2] && lines[i].split(',')[2] != 'ordering_cost')) && exemptedDocTypes && !['RECDEL','RELTRX','RECTRX','RELSLO','RECSLI','OTHPCN','RECADJ','RELADJ','ORISOX','RECCSI','RELCSI'].includes(this.currentDocumentTypeCode))   
                              this.massAddProductErrors.push('Column names are incorrect and invalid.');

                        if( i == 0 && (lines[i].split(',')[0] != 'barcode' || lines[i].split(',')[1] != 'qty' || (lines[i].split(',')[2] && lines[i].split(',')[2] != 'discount_text')) && this.currentDocumentTypeCode === "ORISOX" ){
                            this.massAddProductErrors.push('Column names are incorrect and invalid.');
                        } 

                        if( i == 0 && (lines[i].split(',')[0] != 'barcode' || lines[i].split(',')[1] != 'qty' || (lines[i].split(',')[2] && lines[i].split(',')[2] != 'discount_text') || (lines[i].split(',')[3] && lines[i].split(',')[3] != 'salesman')) && ['RECCSI','RELCSI'].includes(this.currentDocumentTypeCode)){
                            this.massAddProductErrors.push('Column names are incorrect and invalid.');
                        }

                        //Check salesman if exist [RECCSI, RELCSI]
                        if(['RECCSI','RELCSI'].includes(this.currentDocumentTypeCode) && i == 1 && lines[i].split(',')[3] && this.salesman.key === undefined){
                            var salesman_details = await HTTPRequest.getRequest(this.endPoint + 'salesmen?code='+lines[i].split(',')[3], null)
                            if(salesman_details['data'].length > 0){
                                this.salesman.key = salesman_details['data'][0]['id']
                                this.salesman.label = salesman_details['data'][0]['name']
                            }else{
                                this.massAddProductErrors.push('Unable to find salesman with code '+lines[i].split(',')[3]+'.');
                            }
                        }
                        
                        if( i == 0 && (lines[i].split(',')[0] != 'barcode' || lines[i].split(',')[1] != 'qty' || lines[i].split(',')[2] != 'lot_code' || lines[i].split(',')[3] != 'expiry_date') && ['RECDEL','RELTRX','RECTRX','RELSLO','RECSLI','OTHPCN','RECADJ','RELADJ'].includes(this.currentDocumentTypeCode) && lines[i].split(',').length == 4)  
                            this.massAddProductErrors.push('Column names are incorrect and invalid for lotcode and expiry. Kindly follow this format barcode,qty,lot_code,expiry_date');

                        if(i > 0 && ['RECDEL','RELTRX','RECTRX','RELSLO','RECSLI','OTHPCN','RECADJ','RELADJ'].includes(this.currentDocumentTypeCode) && lines[i].split(',').length == 4 && !this.dateIsValid(lines[i].split(',')[3].toString()) && lines[i].split(',')[3] != '')
                            this.massAddProductErrors.push('Invalid expiry date format on line: '+i+'. Value: ' + lines[i].split(',')[3].toString());
                        
                        if(i > 0 && ['RECDEL','RELTRX','RECTRX','RELSLO','RECSLI','OTHPCN','RECADJ','RELADJ'].includes(this.currentDocumentTypeCode) && lines[i].split(',').length == 4 && (lines[i].split(',')[2] == '' || lines[i].split(',')[3] == ''))
                            this.massAddProductErrors.push('Lotcode or Expiry Date must not be empty');

                        if(i > 0 && lines[i].includes(',') && exemptedDocTypes) {

                            if(typeof lines[i].split(',')[1] === 'string')
                                qtylist.push(parseInt(lines[i].split(',')[1]));
                            else
                                qtylist.push(parseInt(lines[i].split(',')[1]) || 0);

                            skulist.push(lines[i].split(',')[0]);
                            orderingCost.push(lines[i].split(',')[2])
                            
                            if((['RECDEL','RELTRX','RECTRX','RELSLO','RECSLI','OTHPCN','RECADJ','RELADJ','RELCSI'].includes(this.currentDocumentTypeCode) || (['OTHSIN'].includes(this.currentDocumentTypeCode) && this.accountName.toLowerCase().includes('piml'))) && lines[i].split(',').length == 4){
                                this.csvData += lines[i].split(',')[0] +','+ parseInt(lines[i].split(',')[1])+ ',' + lines[i].split(',')[2].toString() + ',' + lines[i].split(',')[3].toString();
                                this.importLotCode = (['OTHSIN', 'RELCSI'].includes(this.currentDocumentTypeCode)) ? 0 : 1;
                            }else{
                                var line_2 = ''
                                if (this.currentDocumentTypeCode == "ORISOX") {
                                    line_2 = lines[i].split('"')[1] || lines[i].split(',')[2]
                                    line_2 = '"'+line_2+'"'
                                }  else {
                                    line_2 = lines[i].split(',')[2] || 0
                                }
                                this.csvData += lines[i].split(',')[0] +','+ parseInt(lines[i].split(',')[1])+ ',' + line_2;
                                this.importLotCode = 0;
                            }
                                
                            if(i < lines.length)
                                this.csvData += '\n'
                        }
                        if (i > 0 && productCount == 0) {
                          // Check if there's any product present
                          productCount = lines[i].replace(",","").length;
                        }

                        if (this.currentDocumentTypeCode == "OTHPWS" && pwsErrors.validUniqueCodeHeader) {
                          const pwsValidation = this.pwsMassProductUploadValidation(lines, i);

                          if (!pwsValidation.validUniqueCodeHeader) {
                            pwsErrors.validUniqueCodeHeader = false;
                            break;
                          }

                          blankUniqueCodeCount += pwsValidation.blankUniqueCodeCount;
                        //   if (pwsValidation.invalidOrdering) pwsErrors.invalidOrdering.push(pwsValidation.invalidOrdering);
                        //   if (pwsValidation.invalidPrice) pwsErrors.invalidPrice.push(pwsValidation.invalidPrice);
                          if (pwsValidation.negativeOrdering) pwsErrors.negativeOrdering.push(pwsValidation.negativeOrdering);
                          if (pwsValidation.negativePrice) pwsErrors.negativePrice.push(pwsValidation.negativePrice);
                          if (pwsValidation.negativeLanded) pwsErrors.negativeLanded.push(pwsValidation.negativeLanded);
                          if (pwsValidation.invalidPriceCost) pwsErrors.invalidPriceCost.push(pwsValidation.invalidPriceCost);
                        }

                        if (!exemptedDocTypes) {
                            this.csvData += lines[i] + '\n'
                        }
                    }
                    // console.log(this.csvData)
                    // Get duplicate sku's/barcode
                    if (this.importLotCode == 0){
                        const findDuplicates = (skulist) => {
                            let sorted_arr = skulist.slice().sort();
                            let results = [];
                            for (let i = 0; i < sorted_arr.length - 1; i++) {
                                if (sorted_arr[i + 1] == sorted_arr[i]) {
                                    results.push(sorted_arr[i]);
                                }
                            }
                            return results;
                        }

                        // Result duplicate sku's/barcode -> download list
                        if(findDuplicates(skulist).length > 0) {
                            this.massAddProductErrors.push('With duplicate Barcodes');
                            this.dlDUplicateSkus = 1
                            this.dlDUplicateSkusItems = findDuplicates(skulist)
                            this.massAddProductErrorsDL.push('With duplicate Barcodes');
                        } else {
                            this.dlDUplicateSkus = 0
                        }
                    }

                    // Get 0 / - quantity
                    const zQty = qtylist.filter(qty => {
                        if(isNaN(qty))
                            return true
                        else if(qty == 0 && this.currentDocumentTypeCode == 'OTHPCN')
                            return false
                        else
                            return qty < 1
                    });

                    // Result 0 / - quantity

                    // 2021-08-23 - https://tools.iripple.com/barter-11/bxi-backend/-/issues/1686
                    // Allow 0 quantity for PCOUNT document [OTHPCN]
                    if(zQty.length > 0 && exemptedDocTypes){
                      this.massAddProductErrors.push('All quantities must be POSITIVE integers and no blanks/characters.');
                    }

                    // Get blank skus
                    const bSku = skulist.filter(sku => sku.length < 1);
                    // const bOrderingCost = orderingCost.filter(ordercost => ordercost === "");

                    // Result blank skus & blank ordering_cost
                    if(bSku.length > 0 && exemptedDocTypes)
                        this.massAddProductErrors.push('File has blank lines that generate rows with no data but with a comma.');

                    //this will make the field ordering_cost required not to be empty
                    // if(bOrderingCost.length > 0 && exemptedDocTypes )
                    //     this.massAddProductErrors.push('File has blank lines that generate rows with no data but with a comma.');

                    // Check if PWS Uploaded file has no product indicated
                    if (productCount == 0)
                        this.massAddProductErrors.push('File has no data');

                    // Check if PWS Uploaded file has some lines without barcode/stock no
                    if (blankUniqueCodeCount > 0)
                        this.massAddProductErrors.push(`${blankUniqueCodeCount} blank ${lines[0].split(',')[0]}`);

                    // Render PWS Error messages if there's any
                    this.pwsErrorMessages(pwsErrors);

                    // Check if CSV has no error
                    // Proceed validating if barcodes are valid

                    if(this.massAddProductErrors.length < 1){
                      this.spinning = true;

                      // Hot Fix - https://tools.iripple.com/barter-11/bxi-backend/-/issues/1639
                      // Check supplier in header if exist for product mass update
                      if(this.validationdocutypes.includes(this.currentDocumentTypeCode) && this.filterBySupp) {
                        await this.getSuppItems(skulist)
                      } else {
                        this.spinning = false;
                      }

                      if (this.massAddProductErrors.length == 0 && this.massAddProductErrorsDL.length == 0) {
                        this.fileList = [...this.fileList, file];
                      }
                    }
                    this.massAddProductErrors = this._.compact(this.massAddProductErrors);

                };
                reader.readAsText(file);
                this.spinning = false;
                return false;
            },
            async getSuppItems(skulist){
                const supplier_param = (this.supplier.key != null && this.supplier.key != "") ? "supplier_ids="+this.supplier.key+"&" : ""
                // var suppItems = await HTTPRequest.getRequest(component_x.endPoint + "products?"+supplier_param+"per_page=500&type=document", null);
                let suppItems = await HTTPRequest.getRequest(component_x.endPoint + "products/check_supplier_products?"+supplier_param+"per_page=500", null);
                let supplierProducts = suppItems.products || [];
                var pageCount = suppItems.total_pages
                this.suppItems = [];

                supplierProducts.map(product => {
                  this.suppItems.push(product.barcode)
                })

                // Get succeeding records
                if(pageCount > 1) {
                  for (var i = 2; i <= pageCount; i++) {
                    // suppItems = await HTTPRequest.getRequest(component_x.endPoint + "products?"+supplier_param+"per_page=500&page="+i+"&type=document");
                    suppItems = await HTTPRequest.getRequest(`${component_x.endPoint}products/check_supplier_products?${supplier_param}per_page=500&page=${i}`, null);
                    supplierProducts = suppItems.products || [];
                    supplierProducts.map(product => {
                      this.suppItems.push(product.barcode)
                    })
                  }
                }

                let errorBarcodes = []
                this.spinning = false;
                skulist.map(item => {
                  if (!this.suppItems.includes(item)) {
                    errorBarcodes.push(item);
                  }
                })

                const arrNF = skulist.filter(i => !this.suppItems.includes(i))
                if(arrNF.length > 0) {
                    this.massAddProductErrors.push(`The following barcodes are not under the selected supplier or does not exist: ${arrNF.join(', ')}`);
                    this.massAddProductErrorsDL.push('With duplicate Barcodes');
                    this.dlSkusNotFound = 1
                    this.dlSkusNotFoundItems = arrNF
                }

                return true;
            },
            importFileWithHeader(){
                this.spinning = true;
                const reader = new FileReader();
                reader.onload = e => {
                    // this.processCsvMassAdd(e.target.result);
                    this.processCsvMassAdd(this.csvData);
                };
                reader.readAsText(this.fileList[0]);
                this.spinning = false;
                this.documentStatus = 'Uploading';
                return false;
            },
            importFile(){
                this.spinning = true;
                const reader = new FileReader();
                reader.onload = e => {
                    // this.processCsvMassAdd(e.target.result);
                    this.processCsvMassAdd(this.csvData);
                };
                reader.readAsText(this.fileList[0]);
                this.spinning = false;
                this.documentStatus = 'Uploading';
                return false;
            },
            async processCsvMassAdd(csvtext){
                this.spinning = true;
                this.CsvUploadParams = {'csv_lines': csvtext, 'import_mode': this.importMode, 'is_lotcode': this.importLotCode}
                this.processingCsvUpload = true
                if (this.documentNumber > 1) {
                    this.update();
                } else {
                    this.save();
                }

                this.spinning = false;
                this.closeDrawer('massAddWithHeaderDrawerVisible');
                this.closeDrawer('massAdd');
            },
            subscribe(){
                var pusher = new Pusher('b74fa07f1048125271b8', {
                  cluster: 'ap1'
                });
                pusher.subscribe('my-channel')
                pusher.bind('my-event', data => {
                    // Delivery Document # "+ data.message.order.points[0].client_order_id + "
                    this.bookingDetails = data.message
                    // this.$notification['info']({
                    //   message: 'Status Change',
                    //   description: "Your booking status has changed."
                    // });
                })
            },
            haversineDistance(coords1, coords2, isMiles) {
                function toRad(x) {
                  return x * Math.PI / 180;
                }

                var lon1 = coords1[0];
                var lat1 = coords1[1];

                var lon2 = coords2[0];
                var lat2 = coords2[1];

                var R = 6371; // km

                var x1 = lat2 - lat1;
                var dLat = toRad(x1);
                var x2 = lon2 - lon1;
                var dLon = toRad(x2)
                var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                  Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
                  Math.sin(dLon / 2) * Math.sin(dLon / 2);
                var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
                var d = R * c;

                if(isMiles) d /= 1.60934;

                return d;
            },
            handleDestinationChange(location){
                var newPosition = {
                    lat: location.latLng.lat(),
                    lng: location.latLng.lng()
                }
                var distance = this.haversineDistance([newPosition.lng, newPosition.lat], [this.originalGeoLocation[1].position.lng, this.originalGeoLocation[1].position.lat], false)
                if(distance < 1){
                    this.markers[1].position = newPosition;
                } else {
                    this.markers[1].position = this.originalGeoLocation[1].position;
                    this.mapKey++;
                    this.$notification['error']({
                      message: 'Invalid Location',
                      description: "Cannot pin to new location. Distance from original should be within 1 km radius."
                    })
                }

                this.recompute = true;
            },
            getFromAddress(from_address, placeResultData, id) {
                this.from_address = from_address;
            },
            getToAddress(to_address, placeResultData, id){
                this.to_address = to_address;
            },
            handleError(error){
                alert(error)
            },
            filteredBySupplierChange(e){
                this.filteredBySupplier = e.target.checked
            },
            selectCustomerContact(value){
                switch(value) {
                    case 'Telephone':
                        this.activeCustomerContact = decrypt(this.customerContactTelephone)
                        break;
                    case 'Mobile':
                        this.activeCustomerContact = decrypt(this.customerContactMobile)
                        break;
                    case 'Fax':
                        this.activeCustomerContact = decrypt(this.customerContactFax)
                        break;
                    case 'Email':
                        this.activeCustomerContact = decrypt(this.customerContactEmail)
                        break;
                }
            },
            createCustomer(){
                this.customerDrawerVisible = true
                this.customerDrawerKey++
            },
            onClose() {
                this.errors = [];
                this.customerDrawerVisible = false
                this.customerDrawerKey++
            },
            // closeDrawer(){
            //     this.onClose()
            // },
            async refreshPage(event) {
                var new_customer_data = JSON.parse(event.target.response)
                if (new_customer_data.id > 0 && new_customer_data.name != undefined) {
                    this.customer = {key: new_customer_data.id, label: new_customer_data.name}
                    if (new_customer_data.id){
                        var customer = await HTTPRequest.getRequest(component_x.endPoint + "customers/"+new_customer_data.id, null);
                        this.customerAddress = (customer["address"]) ? decrypt(customer["address"]) : "No Customer Address";
                        this.customerContactMobile = (customer["mobile"]) ? decrypt(customer["mobile"]) : "No Customer Mobile";
                        this.customerContactTelephone = (customer["telephone"]) ? decrypt(customer["telephone"]) : "No Customer Telephone";
                        this.customerContactFax = (customer["fax"]) ? customer["fax"] : "No Customer Fax";
                        this.customerContactEmail = (customer["email"]) ? decrypt(customer["email"]) : "No Customer Email";
                        this.selectedCustomerContact = (customer["mobile"]) ? 'Mobile' : (customer["telephone"]) ? 'Telephone' : (customer["fax"]) ? 'Fax' : (customer["email"]) ? 'Email' : 'Telephone'
                        this.activeCustomerContact = (customer["mobile"]) ? decrypt(this.customerContactMobile) : (customer["telephone"]) ? decrypt(this.customerContactTelephone) : (customer["fax"]) ? this.customerContactFax : (customer["email"]) ? decrypt(this.customerContactEmail) : decrypt(this.customerContactTelephone)
                        this.isProductSearchDisabled = false;
                    }
                }

                this.onClose()
                this.documentActionNotification('Create customer', 'success')
            },
            moment,
            selectForThisSite (forThisSite) {
              let arr = {
                key:forThisSite.key.replace('forThisSites',''),
                label:forThisSite.label
              }

              forThisSite = arr
              Object.assign(this, {
                forThisSite,
                forThisSites: [],
                fetching: false,
              })
            },
            showApplyDocumentToOtherSitesButton() {
              if (this.header.showApplyDocumentToOtherSitesButton &&
                  this.documentStatus == "Confirmed") {
                return true;
              }
              return false;
            },
            toggleApplyDocumentToOtherSitesDrawer(open) {
              this.applyDocumentToOtherSitesDrawer = open;
            },
            showStockCard(product){
                this.stockCardVisible = true
                this.selectedStockCardProduct = product[0].product_id;
                this.stockCardKey++;
            },
            async recalculateLine(product_id){
                console.log("recalculate line")
                var data = this.tabulator.getData();
                var line_no = data.find(item => product_id === item.product_id).line_no
                if(data.find(item => line_no === item.line_no)){
                    //Quantity Change
                    var cost = data.find(item => line_no === item.line_no).cost
                    if(this.currentDocumentTypeCode=="OTHPCV"){
                        var quantity = Math.abs(data.find(item => line_no === item.line_no).variance_quantity)
                    } else {
                        var quantity = data.find(item => line_no === item.line_no).quantity
                    }
                    
                    var subtotal = Number(quantity) * Number(cost)
                    await this.tabulator.updateData([{line_no: line_no,product_id: product_id, subtotal: subtotal}])

                    //Discount Change and Unit Cost Change
                    var discount_text = ''
                    if(data.find(item => line_no === item.line_no).discount_text != null)
                        discount_text = _.compact((data.find(item => line_no === item.line_no).discount_text).split(','));

                    var discountTotal = 0;
                    var unitNetCost = data.find(item => line_no === item.line_no).price
                    var decimalPlaces = this.decimalPlaces
                    if (discount_text.length > 0) {
                        var lessDiscount = /^L[0-9]+(\.[0-9][0-9]?)?$/;
                        var numberRegex = /^[0-9]+(\.[0-9][0-9]?)?$/;
                        // eslint-disable-next-line
                        var percentDiscount = /^[0-9]+(\.[0-9][0-9]?)?\%$/;
                        discount_text.forEach(function(row) {
                            var discount;
                            var discountAmount = 0;
                            if (numberRegex.test(row)) {
                                discount = row
                                discountAmount = Number(discount)
                            } else if (lessDiscountDecimal.test(row)) {
                                discount = row
                                discountAmount = Number(discount)
                            } else if (lessDiscount.test(row)) {
                                discount = row.slice(1);
                                discountAmount = (Number(discount) * quantity)
                            } else if (percentDiscount.test(row)) {
                                discount = row.slice(0,-1)
                                discountAmount = ((unitNetCost * quantity) - discountTotal) * (discount / 100)
                            }
                            discountTotal += discountAmount
                        });
                    }

                    if (this.currentDocumentTypeCode =='RELDDE') {
                        if (unitNetCost < 0) unitNetCost = 0
                        subtotal = ((quantity * unitNetCost) - discountTotal).toFixed(this.decimalPlaces)
                        discountTotal = (quantity * unitNetCost) - subtotal
                        await this.tabulator.updateData([{line_no: line_no,product_id: product_id, subtotal: subtotal, discount: discountTotal.toFixed(this.decimalPlaces)}])
                    } else {
                        if (unitNetCost < 0) unitNetCost = 0
                        var totalGross = data.find(item => line_no === item.line_no).total_gross
                        if (discountTotal >= totalGross) discountTotal = totalGross
                        subtotal = ((quantity * unitNetCost) - discountTotal).toFixed(this.decimalPlaces)
                        discountTotal = (quantity * unitNetCost) - subtotal
                        await this.tabulator.updateData([{line_no: line_no,product_id: product_id, subtotal: subtotal, discount: discountTotal.toFixed(this.decimalPlaces), total_gross: totalGross}])
                    }
                }
            },
            async saveDrawerSerialization() {
              this.currentDrawerSerials = this.currentDrawerSerials.filter(item => item.status == "A")
              var data = this.tabulator.getData();
              var line_no = data.find(item => this.selectedSerialProduct.product_id === item.product_id).line_no
              if(this.currentDocumentTypeCode.includes('REL')) { this.currentDrawerSerials = this.currentDrawerSerials.filter(item => item.checked)}
              await this.tabulator.updateData([{line_no: line_no,product_id: this.selectedSerialProduct.product_id, quantity: this.currentDrawerSerials.length, document_line_serials: this.currentDrawerSerials }])
              //Recalculate
              await this.recalculateLine(this.selectedSerialProduct.product_id)
              this.calculateSummary();
              this.serializationVisible = false
                // this.closeDrawer('serialization');
            },
            async submitDrawerSerials() {
                //  ------CHECKING IF SERIAL EXIST IN A PRODUCT
                // console.log("---PRODUCT")
                // console.log(this.selectedSerialProduct)

                var ctr_chk = 0
                var releasing_documents = ["RELTRX", "RELADJ", "RELCSI", "ORISOX", "RELSLO", "RELDDE", "ORIOSO"]
                if( !releasing_documents.includes(this.currentDocumentTypeCode) ){
                    var inventory_serials = await HTTPRequest.getRequest(component_x.endPoint + `inventory_serials?product_id=${this.selectedSerialProduct.product_id}&serial_no=${this.inputSerialNumber}&status=A`, null);
                    ctr_chk = inventory_serials.data.length
                }

                if( ctr_chk > 0){
                    this.$notification['error']({
                                message: 'Serial Manager',
                                description: "Cannot add serial. Serial Number exists",
                                style: getNotificationStyle('error')
                            });
                    // alert("Cannot add serial. Serial already exist.")
                } else {
                    if (this.currentDocumentTypeCode.includes("REL")) {
                       var exists = this.currentDrawerSerials.find(x => x.serial_no == this.inputSerialNumber)
                        if (exists) {
                            exists.status = "A"
                            this.inputSerialNumber = ''
                        } else {
                            this.inputSerialNumber = ''
                        }
                    } else {
                        var exists = this.currentDrawerSerials.find(x => x.serial_no == this.inputSerialNumber)
                        if (exists) {
                            this.$notification['error']({
                                message: 'Serial Manager',
                                description: "Serial Number exists",
                                style: getNotificationStyle('error')
                            });
                        } else {
                            this.currentDrawerSerials.push({line_no: this.selectedSerialProduct.line_no, serial_no: this.inputSerialNumber, status: "A"})
                        }
                        this.inputSerialNumber = ''
                    }
                }
                this.currentSerialCount = this.currentDrawerSerials.length
            },
            selectSerial(e){
              const { id, checked } = e.target
              this.currentDrawerSerials = this.currentDrawerSerials.map((item) => {
                if(item.serial_no === id){
                  item = {...item, checked}
                }
                return item
              })
              this.currentSerialCount = this.currentDrawerSerials.filter(({checked}) => checked).length
              this.previousSerialCount = this.currentSerialCount > this.previousSerialCount ?  this.currentSerialCount : this.defaultCountValue;
            },
            async showSerialization(product){
                var site_id = secureStorage.getItem("defaultSiteId");
                this.selectedSerialProduct = product[0];
                if (this.currentDocumentTypeCode.includes("REL")) {
                  if (product[0].document_line_serials) {
                    var inventory_serials = await HTTPRequest.getRequest(component_x.endPoint + "inventory_serials/get_serials_for_release_document?product_id="+product[0].product_id+"&site_id="+site_id+"&line_no="+product[0].line_no, null);

                    // var selected = product[0].document_line_serials.map(x => x.serial_no)
                        // var not_selected = inventory_serials.filter(item => !selected.includes(item.serial_no))
                        // var merged = product[0].document_line_serials.concat(not_selected)

                        var selected = product[0].document_line_serials.map(x => x.serial_no)
                        var merged = inventory_serials.map((item) =>  {
                          return {...item, checked: selected.includes(item.serial_no) }
                        } )

                        this.currentDrawerSerials = this.documentStatus === "Posted"? merged.filter(({checked}) => checked ) : merged ;
                      } else {
                        var inventory_serials = await HTTPRequest.getRequest(component_x.endPoint + "inventory_serials/get_serials_for_release_document?product_id="+product[0].product_id+"&site_id="+site_id+"&line_no="+product[0].line_no, null);
                        this.currentDrawerSerials = inventory_serials.map((item) => {
                          item = {...item, checked:false}
                          return item
                        });
                      }
                      this.serialMessage = "selected"
                      this.documentIsRel = true
                      this.defaultCountValue = Number(product[0].quantity) > this.currentDrawerSerials.length? this.currentDrawerSerials.length : Number(product[0].quantity);
                } else {
                    if (this.documentStatus == null) {
                        this.currentDrawerSerials = product[0].document_line_serials || [];
                    } else {
                        if (product[0].document_line_serials) {
                            this.currentDrawerSerials = product[0].document_line_serials || [];
                          } else {
                            var document_line_serials = await HTTPRequest.getRequest(component_x.endPoint + "document_line_serials/?document_line_id="+product[0].id, null);
                            this.currentDrawerSerials = document_line_serials.data;
                          }
                        }
                      }
                      
               
                this.currentSerialCount = this.documentIsRel? this.currentDrawerSerials.filter(({checked}) => checked).length : this.currentDrawerSerials.length
                // this.previousSerialCount = this.currentDocumentTypeCode.includes("REL")? this.currentDrawerSerials.length : Number(product[0].quantity);
                this.previousSerialCount = this.documentIsRel ? this.defaultCountValue : Number(product[0].quantity);
                this.currentDrawerSerialsInstance = [...this.currentDrawerSerials]
                this.serializationVisible = true
                this.serializationKey++;
            },
            async showDocumentPayment(status){
                var document_payments = await HTTPRequest.getRequest(component_x.endPoint + "document_payments?document_id="+this.documentNumber, null);
                this.documentPaymentsList = document_payments["data"]
                if(status==undefined){
                  this.documentPaymentsDrawerVisible = true
                    this.documentPaymentsKey++;
                }
            },
            async showSublocationAllocation(product){
                this.sublocationAllocationVisible = true
                this.selectedSublocationAllocationProduct = product[0];
                this.sublocationAllocationKey++;

                var document_type_code = '';
                var document_trans_code = '';
                var document_type_trans_code = await HTTPRequest.getRequest(component_x.endPoint + "document_types?table_prefix=inventory&id="+this.currentDocumentTypeId, null);
                if (document_type_trans_code.find(x => x.id === this.currentDocumentTypeId)) {
                    document_type_code = document_type_trans_code.find(x => x.id === this.currentDocumentTypeId).type_code
                    document_trans_code = document_type_trans_code.find(x => x.id === this.currentDocumentTypeId).trans_code
                }

                var site_id = secureStorage.getItem("defaultSiteId");
                if ((document_trans_code == 'REC' && document_type_code == 'SLI')  || (document_trans_code == 'REL' && document_type_code == 'SLO') || (document_trans_code == 'ORI' && document_type_code == 'SOX') || (document_trans_code == 'ORI' && document_type_code == 'OSO') || (document_trans_code == 'REL' && document_type_code == 'DDE' || (document_trans_code == 'OTH' && document_type_code == 'SIN') || (document_trans_code == 'REC' && document_type_code == 'CSR') || (document_trans_code == 'REC' && document_type_code == 'OCR'))){
                    site_id = this.distributionSite.key
                }
                if ((document_trans_code == 'REL' && document_type_code == 'TRX') || (document_trans_code == 'REL' && document_type_code == 'CSX') || (document_trans_code == 'ORO' && document_type_code == 'TRQ' ) || (document_trans_code == 'ORO' && document_type_code == 'CSQ' )){
                    site_id = this.supplyingSite.key
                }
                if ((document_trans_code == 'REC' && document_type_code == 'TRX') || (document_trans_code == 'REC' && document_type_code == 'CSX') || (document_trans_code == 'ORI' && document_type_code == 'TRQ' ) || (document_trans_code == 'ORI' && document_type_code == 'CSQ' ) || (document_trans_code == 'ORI' && document_type_code == 'POX' )){
                    site_id = this.requestingSite.key
                }
                if ((document_trans_code == 'OTH' && document_type_code == 'PWS')){
                    site_id = this.forThisSite.key
                }

                this.drawerSublocationSiteId = (this.drawerSublocationSiteId > 0) ? this.drawerSublocationSiteId : site_id

                this.drawerSublocations = await HTTPRequest.getRequest(this.endPoint + 'sublocations/get_site_sublocations?site_id='+this.drawerSublocationSiteId, null)
                if (product[0].sublocation_allocation != undefined) this.drawerCurrentSublocationAllocation = product[0].sublocation_allocation
            },
            async showSiteAllocation(product){
                this.siteAllocationVisible = true
                this.selectedSiteAllocationProduct = product[0];
                this.siteAllocationKey++;

                this.drawerSites = await HTTPRequest.getRequest(this.endPoint + 'sites/get_all_document_sites', null)
                if (product[0].site_allocation != undefined) this.drawerCurrentSiteAllocation = product[0].site_allocation
                var total_site_quantity = this.drawerCurrentSiteAllocation.reduce((a, {quantity}) => a + parseInt(quantity), 0);
                this.siteAllocationRemainingQuantity = Number(this.selectedSiteAllocationProduct.quantity) - Number(total_site_quantity)
            },
            async showLotCodeExpiry(product){
                this.selectedLotCodeExpiryProduct = product[0];
                if (this.documentStatus == null) {
                    this.currentDrawerLotCodeExpiry = product[0].document_line_locations || [];
                } else {
                    if (product[0].document_line_locations) {
                        this.currentDrawerLotCodeExpiry = product[0].document_line_locations || [];
                    } else {
                        var document_line_locations = await HTTPRequest.getRequest(component_x.endPoint + "document_line_locations/?document_line_id="+product[0].id, null);
                        this.currentDrawerLotCodeExpiry = document_line_locations.data;
                    }
                }

                //If REL documents  - retrieve lotcode per site per item
                if(this.isLotCodeExpiryDisabled) {
                    var lotCodes = await HTTPRequest.getRequest(component_x.endPoint + "inventories/site_product_inventory_with_lotcode_expiry?product_id="+ product[0].product_id +"&product_type=" + product[0].product_type +"&site_id=" + secureStorage.getItem("defaultSiteId"), null);
                    this.lotcodeSources = lotCodes;
                }

                this.lotcodeTotalQty = 0
                this.currentDrawerLotCodeExpiry.map(item => {
                    if(this.selectedDocumentLines[0].product_type == 'P' && this.currentDocumentTypeCode.includes('REL'))
                        this.lotcodeTotalQty += Number(item['actual_quantity'])
                    else
                        this.lotcodeTotalQty += Number(item['quantity'])
                })

                this.lotCodeExpiryVisible = true
                //if (product[0].document_line_lotcode != undefined) this.drawerLotCode = product[0].document_line_lotcode;
                //if (product[0].document_line_expiry != undefined) this.drawerExpiryAt = product[0].document_line_expiry;
                //if (product[0].document_line_locations != undefined && product[0].document_line_locations.length > 0){
                //    this.drawerLotCode = product[0].document_line_locations[0].lot_code
                //    this.drawerExpiryAt = product[0].document_line_locations[0].expiry_at
                //}
                this.lotCodeExpiryKey++;
            },
            handleScroll () {
                var regular = document.getElementsByClassName("regular-header");
                var sticky = document.getElementsByClassName("sticky-header");
                if(window.scrollY>=160){
                    regular[0].style.visibility = 'hidden';
                    sticky[0].style.visibility = 'visible';
                } else {
                    regular[0].style.visibility = 'visible';
                    sticky[0].style.visibility = 'hidden';
                }
            },
            rowSelectionChanged(data, rows){
                this.selectedDocumentLines = data
                this.selectedDocumentLineRows = rows
            },
            totalGrossMutator(value, data){
                if(['BARTER TOOL', 'BARTER TOOL 3P'].includes((this.documentDetails || {}).order_source)){
                    var total_gross = Number(data.invoice_total) + Number(data.discount)
                } else {
                    var total_gross = data.quantity * data.price
                }
                
                return total_gross;
            },
            searchProducts(){
                if (this.productSearchInput){
                    this.tabulator.clearFilter();
                    this.searchFilter
                    this.tabulator.addFilter(this.searchFilter, "like", this.productSearchInput);
                } else {
                    this.tabulator.clearFilter();
                }
            },
            searchAddedProducts(){
                if (this.addedProductSearchInput){
                    this.tabulator.clearFilter();
                    this.searchFilterAddedProduct
                    this.tabulator.addFilter(this.searchFilterAddedProduct, "like", this.addedProductSearchInput);
                } else {
                    this.tabulator.clearFilter();
                }
            },
            validateTableDiscount(cell, value){
                var discount_text = value.split(',');
                var isValid = true
                // eslint-disable-next-line
                //var discountRegex = /(^L[0-9]+(\.[0-9][0-9]?)?$|^[0-9]+(\.[0-9][0-9]?)?$|^[0-9]+(\.[0-9][0-9]?)?\%$)/;
                var discountRegex = /(^\d{0,10}(\.\d{1,4})? *%?$)/;
                //var lessDiscount = /^L[0-9]+$/;
                var lessDiscount = /^L[0-9]+(\.[0-9]{1,2})?$/;
                //var lessDiscount = /^L[0-9]+$/;
                var lessDiscount = /^L[0-9]+(\.[0-9]{1,2})?$/;
                if (discount_text != '') {
                    discount_text.forEach(function(row) {
                        if (!discountRegex.test(row)) isValid = false;
                        if (lessDiscount.test(row)) isValid = true;
                    });
                }
                return isValid;
            },
            isCellEditable(cell){
                var column = cell.getColumn().getField();
                if ((this.documentStatus == 'Posted' ) || (this.documentStatus == 'Voided' ) || (this.documentStatus == 'Confirmed')){
                    return false
                } else {
                    if (!this.accessRights.includes('W')){
                        return false
                    } else if ((this.isPriceCostDisabled && this.isPriceCostEditConfigDisabled) && column.includes("price", "price_php", "price_pi", "cost_php", "cost", "old_landed_cost", "landed_cost", "old_retail_price", "retail_price", "old_original_cost", "original_cost", "old_ordering_cost", "ordering_cost", "old_wholesale_price", "wholesale_price", "old_least_price", "least_price", "old_special_price", "special_price", "piml_price1", "old_piml_price1", "piml_price2", "old_piml_price2", "piml_price3", "old_piml_price3")) {
                        return false
                    } else {
                        if (this.currentDocumentTypeCode=="RELDDE") {
                            if (this.documentNumber > 0) {
                                if (column == 'goods_issue_quantity' || column == 'remarks') {
                                    return true
                                } else {
                                    return false
                                }
                            } else {
                                if (column == 'delivery_quantity' || column == 'remarks') {
                                    return true
                                } else {
                                    return false
                                }
                            }
                        }
                        
                        else if (["OTHSRQ", "OTHSIN", "ORIOSO"].includes(this.currentDocumentTypeCode)) {
                            if ((column === 'price' || column === 'quantity') && this.accountName.toLowerCase().includes('piml')) {
                                return true
                            } else {
                                return false
                            }
                        }
                        else if (["ORISOX"].includes(this.currentDocumentTypeCode)) {
                            // allow discount_text editing if user has Edit accessRights and for PIML account only
                            if ((column === 'discount_text') && (this.accessRights.includes('W')) && this.accountName.toLowerCase().includes('piml')) {
                                return true;
                            }

                            // allow price/quantity editing for PIML account only
                            if ((column === 'price' || column === 'quantity') && this.accountName.toLowerCase().includes('piml')) {
                                return true;
                            }

                            return false;
                        }

                        else if(this.currentDocumentTypeCode=="OTHSBI"){
                            if ((column == 'price_pi' || column == 'cost' || column == 'price' || column == 'discount_text') && this.accessRights.includes('S')) {
                                return true
                            } else {
                                return false
                            }
                        }
                        else if(this.currentDocumentTypeCode=="RELTRX"){
                            if (column == 'discount_text') {
                                return false
                            } 
                            if (column == 'quantity') {
                                return true
                            }
                        }
                        else if(this.currentDocumentTypeCode=="RECCSR" || this.currentDocumentTypeCode=="ORIOCR"){
                            if (column == 'remarks' || column == 'quantity') {
                                return true
                            } else {
                                return false
                            }
                        }
                        else if(this.currentDocumentTypeCode=="OTHPCK" || this.currentDocumentTypeCode=="OTHTOV"){
                            if (column == 'quantity') {
                                if (this.originDocumentNumber > 0){
                                    return false
                                }else{
                                    return true
                                }
                            }else{
                                return true
                            }
                        }else if(this.currentDocumentTypeCode=="OTHPCV" && column == 'quantity'){
                            return false
                        }else if(this.currentDocumentTypeCode=="ORORSO"){
                            if (column == 'requested_quantity') {
                                if (secureStorage.getItem("defaultSiteId").toString() == this.requestingSite.key && this.forThisSite.key != secureStorage.getItem("defaultSiteId").toString()){
                                    return false
                                }else{
                                    return true
                                }
                            }else{
                                return true
                            }
                        }else if(this.currentDocumentTypeCode=="RECTRX"){
                            if (column == 'product_name') {
                                return false
                            }
                            if (column == 'quantity') {
                                return true
                            }
                            if (column == 'sublocation') {
                                return true
                            }
                        }else if(this.currentDocumentTypeCode=="OTHPWS"){
                            //accessPWSCost only for landed cost
                            if (['landed_cost'].includes(column) && !this.accessPWSCost) {
                                return false
                            } else {
                                return true
                            }
                            if (['retail_price','special_price','wholesale_price','least_price'].includes(column) && !this.accessPWSPrice) {
                                return false
                            } else {
                                return true
                            }

                            // if (column == 'ordering_cost' && !this.accessPWSCost) {
                            //     return false
                            // } else {
                            //     return true
                            // }
                        }else {
                            return true
                        }
                    }
                }
            },
            quantityTooltip(cell){
                if(!cell._cell.row.data.is_weighted){
                    return 'Decimal Quantity is not allowed for this item'
                }else{
                    return 'Decimal Quantity is allowed for this item.Maximum number of decimal digit is 4'
                }
            },
            validateQuantity(cell, value){
                if (value < 0){
                    return false;
                }else {
                    var field = cell._cell.column.field;
                    var ordered_quantity = 0;
                    var actual_quantity = 0;
                    var quantity = 0;
                    var isValid = true;
                    if (this.currentDocumentTypeCode=="RELDDE"){
                        if (value > 0){
                            if (field == 'delivery_quantity'){
                                if (this.isOrderSourceMode) {
                                    ordered_quantity = cell._cell.row.data.ordered_quantity
                                    if (value > ordered_quantity) isValid = false
                                    if (value < 1) isValid = false
                                    return isValid;
                                } else {
                                    ordered_quantity = cell._cell.row.data.ordered_quantity
                                    actual_quantity = cell._cell.row.data.actual_quantity
                                    if (value > ordered_quantity) isValid = false
                                    if (value > actual_quantity) isValid = false
                                    if (value < 1) isValid = false
                                    return isValid;
                                }
                            } else if (field == 'goods_issue_quantity') {
                                ordered_quantity = cell._cell.row.data.ordered_quantity
                                if (value > Number(ordered_quantity)) isValid = false
                                if (value < 1) isValid = false
                                return isValid;
                            } else{
                                return true;
                            }
                        }else {
                            return true;
                        }
                    } else {
                        if (field == 'quantity') {
                            if (value < 0){
                                isValid = false
                            }
                            
                            if(!cell._cell.row.data.is_weighted){
                                if(Number.isInteger(Number(value)) == false){
                                    isValid=false
                                }
                            }else{
                                if (Number.isInteger(Number(value)) == false){
                                    if(value.toString().split('.')[1].length > 4){
                                        isValid = false
                                    }
                                }
                            }
                            
                            return isValid;
                        }else {
                            return true;
                        }
                    }
                }
            },
            //event when document line table has been edited
            async tabulatorCellEdit(e){
                this.isEditing = true;
                console.log("tabulatorCellEdit")
                const { field } = e._cell.column
                if(field === "quantity"){
                  const { product_type } = e._cell.row.data
                  const { value: quantity, oldValue:oldQuantity} = e._cell
                  if (product_type === "S") {
                    this.showSerialization([{...e._cell.row.data, quantity, oldQuantity}])
                  }
                }
               
                var product_id = e._cell.row.data.product_id
                var line_no = e._cell.row.data.line_no
                const rowData = e._cell.row.data;

                if(this.currentDocumentTypeCode=="OTHPWS" && field === "landed_cost" && (rowData.with_rr || rowData.old_landed_cost > 0)){
                    this.notifMessage = []
                    this.notifMessage.push('No updating of landed cost, already had a receiving report or with landed cost.')
                    this.documentActionNotification('Information', 'info')
                    e.restoreOldValue();
                    return;
                }
                
                console.log("field edited: ", field);
                console.log("row data: ", rowData);

                if (field === "discount_text") {
                    const discountText = rowData.discount_text || "";
                    let netAmount = Number(rowData.net_amount || 0);

                    // store the original net amount if not already stored
                    if (!rowData.original_net_amount && rowData.net_amount) {
                        rowData.original_net_amount = netAmount;
                    }

                    let updatedNetAmount;

                    if (discountText.trim() === "") {
                        // if discount text is cleared, reset to original net amount
                        updatedNetAmount = rowData.original_net_amount || netAmount;
                    } else if (discountText.includes("%")) {
                        // handle percentage discount
                        const discountPercentage = parseFloat(discountText.replace("%", "").trim());
                        if (!isNaN(discountPercentage)) {
                            const discount = (discountPercentage / 100) * rowData.original_net_amount;
                            updatedNetAmount = rowData.original_net_amount - discount;
                        } else {
                            console.error("invalid discount percentage format:", discountText);
                            return;
                        }
                    }  else if (discountText.includes("L")){
                        var lessdiscount = discountText.slice(1)
                        if (!isNaN(lessdiscount)) {
                            var discount = lessdiscount * rowData.quantity
                                updatedNetAmount = rowData.original_net_amount - discount;
                        } else {
                            console.error("invalid less discount format:", discountText);
                            return;
                        }
                    }  else if (discountText.includes("L")){
                        var lessdiscount = discountText.slice(1)
                        if (!isNaN(lessdiscount)) {
                            var discount = lessdiscount * rowData.quantity
                                updatedNetAmount = rowData.original_net_amount - discount;
                        } else {
                            console.error("invalid less discount format:", discountText);
                            return;
                        }
                    } else {
                        // handle fixed amount discount
                        const discount = Number(discountText);
                        if (!isNaN(discount)) {
                            updatedNetAmount = rowData.original_net_amount - discount;
                        } else {
                            console.error("invalid fixed discount format:", discountText);
                            return;
                        }
                    }

                    await this.tabulator.updateData([
                        {
                            line_no: line_no,
                            product_id: product_id,
                            net_amount: updatedNetAmount,
                        },
                    ]);

                    console.log(`updated net_amount for line_no ${line_no}: ${updatedNetAmount}`);
                }

                if (e._cell.column.field == 'delivery_quantity'){
                    await this.tabulator.updateData([{line_no: line_no,product_id: product_id, quantity: Number(e._cell.value)}])
                }
                if (e._cell.column.field == 'goods_issue_quantity'){
                    await this.tabulator.updateData([{line_no: line_no,product_id: product_id, quantity: Number(e._cell.value)}])
                }
                if (e._cell.column.field == 'quantity' && ["ORISOX","RELTRX","RECTRX"].includes(this.currentDocumentTypeCode)){
                    await this.tabulator.updateData([{line_no: line_no,product_id: product_id, requested_quantity: Number(e._cell.value)}])
                }
                if (this.orderSource=="shopify" || this.orderSource=="lazada" || this.orderSource=="shopee"|| this.orderSource=='zalora'){
                  // Insert code here
                }else{
                    if (e._cell.column.field == 'unit_id'){
                        var productCompositions = await HTTPRequest.getRequest(this.endPoint + 'products/'+e._cell.row.data.product_id+'/get_product_unit_compositions', null)
                        var selectedUnit = Number(e._cell.value)
                        var selectedProductId = productCompositions.find(x => x.unit_id == selectedUnit).key
                        var selectedProduct = await HTTPRequest.getRequest(this.endPoint + '/products/'+ selectedProductId);

                        var unitCost = eval('selectedProduct.'+this.productPriceChoice)
                        var unitNetCost = eval('selectedProduct.'+this.productPriceChoice)
                        // if (['BLENDED'].includes(this.documentCostingMethod) && ['RELTRX','RECTRX'].includes(this.currentDocumentTypeCode)){
                        //     unitCost = eval('selectedProduct.blended_cost')
                        //     unitNetCost = eval('selectedProduct.blended_cost')
                        // }
                        if (unitCost <= 0) unitCost = eval('selectedProduct.landed_cost')
                        if (unitNetCost <= 0) unitNetCost = eval('selectedProduct.landed_cost')

                        // var site_id = secureStorage.getItem("defaultSiteId");
                        // var isRel = this.currentDocumentTypeCode.includes("REL");
                        // var isRec = this.currentDocumentTypeCode.includes("REC");
                        // if (isRel || isRec) {
                        //     var inventory_cost = await HTTPRequest.getRequest(this.endPoint + 'inventory_costs/get_latest_inventory_cost?product_id='+selectedProductId+'&site_id='+site_id, null)
                        //     if (inventory_cost.cost && Number(inventory_cost.cost) != 0){
                        //         unitCost = inventory_cost.cost
                        //         unitNetCost = inventory_cost.cost
                        //     } else {
                        //         unitCost = unitCost
                        //         unitNetCost = unitNetCost
                        //     }
                        // }else {
                        //     unitCost = unitCost
                        //     unitNetCost = unitNetCost
                        // }

                        if (selectedProduct){
                            this.notifMessage = []
                            if (this.currentDocumentTypeCode=="RELTRX" || this.currentDocumentTypeCode=="RELCSX" || this.currentDocumentTypeCode=="RELSLO"){
                                if(this.currentDocumentTypeCode=="RELSLO"){
                                    var inventory = await HTTPRequest.getRequest(this.endPoint + 'inventories/site_product_inventory?product_id='+group.selectedObject.id+'&site_id='+this.distributionSite.key+'&sublocation_id='+this.originSublocation.key, null)
                                } else {
                                    var inventory = await HTTPRequest.getRequest(this.endPoint + 'inventories/site_product_inventory?product_id='+selectedProduct.id+'&site_id='+this.supplyingSite.key, null)
                                }
                                
                                if (inventory.error) {
                                    this.notifMessage.push(inventory.error)
                                    this.documentActionNotification('Add document line', 'error')
                                    e.restoreOldValue();
                                    return
                                } else{
                                    this.delete_line(e._cell.row.data.line_no)
                                    var onHandQuantity = inventory.quantity
                                    var availableQuantity = inventory.available_quantity
                                    var productName = selectedProduct.name
                                    var quantity = 1
                                    unitCost = Number(unitCost).toFixed(this.decimalPlaces)
                                    var discountText = []
                                    unitNetCost = Number(unitNetCost).toFixed(this.decimalPlaces)
                                    var discountTotal = 0
                                    var subTotal =  (quantity * unitCost).toFixed(this.decimalPlaces)

                                    this.addRegularProduct(selectedProduct, productName, quantity, 0, unitCost, subTotal, unitNetCost, discountTotal, discountText, onHandQuantity, availableQuantity, '', '', 0);
                                }
                            }
                        }
                    }

                    if (e._cell.column.field == 'markup_percent'){
                    let landedCost = e._cell.row.data.landed_cost;
                    let markUpPercent = e._cell.value;
                    let newRetailPrice = (Number(landedCost) + Number(landedCost) * markUpPercent / 100);
                    if (newRetailPrice < 0) newRetailPrice = 0;
                    await this.tabulator.updateData([{line_no: line_no,product_id: product_id, retail_price: newRetailPrice}]);
                    }

                    if (e._cell.column.field == 'landed_cost'){
                    let landedCost = e._cell.value;
                    let retailPrice = e._cell.row.data.retail_price;
                    let markUpPercent = '';
                    if (retailPrice && landedCost && !isNaN(retailPrice) && !isNaN(landedCost)) {
                        markUpPercent = 0;
                        if (landedCost > 0) markUpPercent = ((retailPrice - landedCost) / landedCost) * 100;
                    }
                    if (markUpPercent < 0) markUpPercent = 0;
                    await this.tabulator.updateData([{line_no: line_no,product_id: product_id, markup_percent: markUpPercent}]);
                    }

                    if (e._cell.column.field == 'retail_price'){
                    let landedCost = e._cell.row.data.landed_cost;
                    let retailPrice = e._cell.value;
                    let markUpPercent = '';
                    if (retailPrice && landedCost && !isNaN(retailPrice) && !isNaN(landedCost)) {
                        markUpPercent = 0;
                        if (landedCost > 0) markUpPercent = ((retailPrice - landedCost) / landedCost) * 100;
                    }
                    if (markUpPercent < 0) markUpPercent = 0;
                    await this.tabulator.updateData([{line_no: line_no,product_id: product_id, markup_percent: markUpPercent}]);
                    }

                    var data = this.tabulator.getData();

                    if(data.find(item => line_no === item.line_no)){
                        //Quantity Change
                        var cost = data.find(item => line_no === item.line_no).cost
                        if(this.currentDocumentTypeCode=="OTHPCV"){
                            quantity = Math.abs(data.find(item => line_no === item.line_no).variance_quantity)
                        } else {
                            quantity = data.find(item => line_no === item.line_no).quantity
                        }
                        
                        var subtotal = Number(quantity) * Number(cost)

                        // Recalculate subtotal_without_vat, price_without_vat, tax_amount
                        // var subtotal_without_vat = data.find(item => line_no ===item.line_no).subtotal_without_vat * quantity
                        // var price_without_vat = data.find(item => line_no ===item.line_no).price_without_vat * quantity
                        // var tax_amount =  data.find(item => line_no ===item.line_no).tax_amount * quantity

                        // await this.tabulator.updateData([{product_id: product_id, subtotal: subtotal,subtotal_without_vat:subtotal_without_vat, price_without_vat:price_without_vat, tax_amount:tax_amount}])

                        //Discount Change and Unit Cost Change
                        var discount_text = ""
                        var line_discount_text = data.find(item => line_no === item.line_no).discount_text
                        if (line_discount_text != null) {
                            discount_text = line_discount_text.split(',')
                        }
                        
                        
                        //discount_text = _.compact(discount_text);
                        discountTotal = 0;
                        unitNetCost = data.find(item => line_no === item.line_no).price
                        var decimalPlaces = this.decimalPlaces
                        var notifMessage = []
                        //var lessDiscount = /^L[0-9]+$/;
                        var lessDiscount = /^L[0-9]+(\.[0-9]{1,2})?$/;
                        //var lessDiscount = /^L[0-9]+$/;
                        var lessDiscount = /^L[0-9]+(\.[0-9]{1,2})?$/;
                        var discountRegex = /(^\d{0,10}(\.\d{1,4})? *%?$)/;
                        if (discount_text.length > 0) {
                            discount_text.forEach(function(row) {
                                var validation = false;
                                if (!discountRegex.test(row)) validation = true;
                                if (lessDiscount.test(row)) validation = false;
                                if (validation) notifMessage.push(row + ' discount input is invalid \n \r');
                            });

                            if (notifMessage.length == 0) {
                                // var lessDiscount = /^L[0-9]+(\.[0-9][0-9]?)?$/;
                                var lessDiscountDecimal = /^\d{0,10}(\.\d{1,10})?$/;
                                var numberRegex = /^[0-9]+$/;
                                // eslint-disable-next-line
                                // var percentDiscount = /^[0-9]+(\.[0-9][0-9]?)?\%$/;
                                var percentDiscount = /^[1][0][0]\.[0]{2}\%|[0-9]+\%|[1-9]?[0-9]\.[0-9]{1,4}\%$/;
                                discount_text.forEach(function(row) {
                                    var discount;
                                    var discountAmount = 0;
                                    if (numberRegex.test(row)) {
                                        discount = row
                                        discountAmount =  Number(discount)
                                    } else if (lessDiscountDecimal.test(row)) {
                                        discount = row
                                        discountAmount = Number(discount)
                                    } else if (lessDiscount.test(row)) {
                                        discount = row.slice(1);
                                        discountAmount = (Number(discount) * quantity)
                                    } else if (percentDiscount.test(row)) {
                                        discount = row.slice(0,-1)
                                        discountAmount = ((unitNetCost * quantity)-discountTotal) * (discount / 100)
                                    }
                                    discountTotal += discountAmount
                                });
                            } else {
                                discount_text.pop();
                                this.notifMessage = notifMessage
                                this.documentActionNotification('Document line discount', 'error')
                            }
                        }
                        if (this.currentDocumentTypeCode =='RELDDE') {
                            if (unitNetCost < 0) unitNetCost = 0
                            subtotal = ((quantity * unitNetCost) - discountTotal).toFixed(this.decimalPlaces)
                            discountTotal = (quantity * unitNetCost) - subtotal
                            await this.tabulator.updateData([{line_no: line_no,product_id: product_id, subtotal: subtotal, discount: discountTotal.toFixed(this.decimalPlaces)}])
                        } else {
                            if (unitNetCost < 0) unitNetCost = 0
                            var totalGross = data.find(item => line_no === item.line_no).total_gross
                            if (discountTotal >= totalGross) discountTotal = totalGross
                            subtotal = ((quantity * unitNetCost) - discountTotal).toFixed(this.decimalPlaces)
                            discountTotal = (quantity * unitNetCost) - subtotal
                            await this.tabulator.updateData([{line_no: line_no,product_id: product_id, subtotal: subtotal, discount: discountTotal.toFixed(this.decimalPlaces), total_gross: totalGross}])
                        }
                    }

                    // Recalculate subtotal_without_vat, price_without_vat, tax_amount 
                    // Apply line discount
                    // Consider party tax
                    if(this.party_tax_type == "V"){
                        var subtotal = quantity * Number(cost).toFixed(this.decimalPlaces)
                        var subtotal_without_vat = (Number(subtotal)/ (1+Number(this.taxRate))).toFixed(this.decimalPlaces)
                        var price_without_vat = (Number(unitNetCost)/ (1+Number(this.taxRate))).toFixed(this.decimalPlaces)
                        var tax_amount = Number(subtotal).toFixed(this.decimalPlaces) * (1+Number(this.taxRate))
                    }else{
                        var subtotal = quantity * Number(cost).toFixed(this.decimalPlaces)
                        var subtotal_without_vat = (Number(subtotal)).toFixed(this.decimalPlaces)
                        var price_without_vat = (Number(unitNetCost)).toFixed(this.decimalPlaces)
                        var tax_amount = 0
                    }

                    await this.tabulator.updateData([{line_no: line_no,product_id: product_id, subtotal_without_vat: subtotal_without_vat, price_without_vat:price_without_vat, tax_amount:tax_amount}])

                    this.calculateSummary();
                }
            },
            async populateMatrixItems(selectedProduct, productName, quantity, paramDiscountText) {
                window.scrollTo(0,0);
                this.spinning = true;
                this.spinMessage = 'Loading matrix items from ' + productName;
                // let unit_supplier_ordering_cost;
                // let site_product_cost;

                // if(this.currentDocumentTypeCode == 'OTHPUR' || this.currentDocumentTypeCode == 'ORIPOX'){
                //     // console.log(this.unitCost, isRel, isRec, this.productPriceChoice,eval('group.selectedObject.'+this.productPriceChoice))
                //     // if docType check alternate_sup of this product
                //     var site_id = secureStorage.getItem("defaultSiteId");
                //     var site_product = await HTTPRequest.getRequest(this.endPoint + '/site_products/get_site_product?product_id=' + selectedProduct.id + '&site_id=' + site_id);

                //     if(site_product != null){
                //         var siteProductCost = eval('site_product.'+this.productPriceChoice)
                //         site_product_cost = Number(siteProductCost).toFixed(this.decimalPlaces)
                //     }

                //     if(this.supplier.key != null && selectedProduct.id != null && this.productPriceChoice == 'ordering_cost'){
                //         var supp_id = Number(this.supplier.key)
                //         var alternate_supplier = await HTTPRequest.getRequest(this.endPoint + 'supplier_products/get_alternate_supplier?product_id=' + selectedProduct.id + '&supplier_id=' + supp_id)
                //         if(alternate_supplier != null && alternate_supplier.ordering_cost > 0){
                //             // this.unitCost = alternate_supplier.ordering_cost
                //             // this.unitNetCost = alternate_supplier.ordering_cost
                //             unit_supplier_ordering_cost = Number(alternate_supplier.ordering_cost).toFixed(this.decimalPlaces)
                //         }
                //         // if alternate_sup exist use this ordering_cost if productPriceChoice is Ordering Cost
                //     }
                // }

                var params = '/products/get_matrix_items?matrix_parent_id='+selectedProduct.id+'&matrix_item=1';
                var selectedProducts = await HTTPRequest.getRequest(this.endPoint + params);
                if (selectedProducts.length > 0){
                    for (let i = 0; i < selectedProducts.length; i++) {
                        var productName = selectedProducts[i].name
                        // unitcost equals to retail price note
                        var unitCost = eval('selectedProducts[i].'+`${this.productPriceChoice}`)
                        var discountText = []
                        var unitNetCost = eval('selectedProducts[i].'+`${this.productPriceChoice}`)

                        // for alternate supplier costing
                        if(this.currentDocumentTypeCode == 'OTHPUR' || this.currentDocumentTypeCode=="ORIPOX"){
                            let site_product_cost;
                            let site_product = await HTTPRequest.getRequest(this.endPoint + '/site_products/get_site_product?product_id=' + selectedProducts[i].matrix_parent_id + '&site_id=' + this.requestingSite.key);
                                    
                            if(site_product != null){
                                let siteProductCost = eval('site_product.'+this.productPriceChoice)
                                // if (['BLENDED'].includes(this.documentCostingMethod) && ['RELTRX','RECTRX'].includes(this.currentDocumentTypeCode)){
                                //     siteProductCost = eval('site_product.blended_cost')
                                // }
                                if(siteProductCost <=0) siteProductCost = eval('site_product.landed_cost')
                                site_product_cost = Number(siteProductCost).toFixed(this.decimalPlaces)
                            }

                            if(site_product_cost && site_product_cost > 0){
                                unitCost = site_product_cost
                                unitNetCost = site_product_cost
                            }

                            if(this.supplier != null && this.supplier != undefined && this.supplier != ""){
                                if(Number(this.supplier.key) != Number(selectedProducts[i].supplier_id)){
                                    // if not main supplier get cost based on supplier products table
                                    let findSupplierProduct = await HTTPRequest.getRequest(this.endPoint + '/supplier_products?product_id='+ selectedProducts[i].matrix_parent_id+ '&supplier_id=' + this.supplier.key);
                                    if(findSupplierProduct != null){
                                        if(findSupplierProduct.data.length > 0){
                                            let supplierProduct = findSupplierProduct.data[0]
                                            unitCost = supplierProduct.ordering_cost
                                            unitNetCost = supplierProduct.ordering_cost
                                        }
                                    }
                                }
                            }
                        }

                        unitCost = Number(unitCost).toFixed(this.decimalPlaces)
                        unitNetCost = Number(unitNetCost).toFixed(this.decimalPlaces)

                        if(this.costUpdated){
                            unitCost = this.unitCost
                            unitNetCost = this.unitCost
                        }

                        // if(site_product_cost && site_product_cost > 0){
                        //     unitCost = site_product_cost
                        //     unitNetCost = site_product_cost
                        // }

                        // if(unit_supplier_ordering_cost && unit_supplier_ordering_cost > 0){
                        //     unitCost = unit_supplier_ordering_cost
                        //     unitNetCost = unit_supplier_ordering_cost
                        // }
                        var notifMessage = []
                        if (paramDiscountText.length > 0) {
                            // eslint-disable-next-line
                            //var discountRegex = /(^L[0-9]+$|^[0-9]+$|^[0-9]+\%$)/;
                            var discountRegex = /(^\d{0,10}(\.\d{1,4})? *%?$)/;
                            //var lessDiscount = /^L[0-9]+$/;
                            var lessDiscount = /^L[0-9]+(\.[0-9]{1,2})?$/;
                            //var lessDiscount = /^L[0-9]+$/;
                            var lessDiscount = /^L[0-9]+(\.[0-9]{1,2})?$/;
                            var discountText = paramDiscountText.join();
                            discountText = discountText.split(',');

                            discountText.forEach(function(row) {
                                var validation = false;
                                if (!discountRegex.test(row)) validation = true;
                                if (lessDiscount.test(row)) validation = false;
                                if (validation) notifMessage.push(row + ' discount input is invalid \n \r');
                            });

                            if (notifMessage.length == 0) {
                                var lessDiscountDecimal = /^\d{0,10}(\.\d{1,10})?$/;
                                var numberRegex = /^[0-9]+$/;
                                // eslint-disable-next-line
                                //var percentDiscount = /^[0-9]+\%$/;
                                var percentDiscount = /^[1][0][0]\.[0]{2}\%|[0-9]+\%|[1-9]?[0-9]\.[0-9]{1,4}\%$/;

                                var unitNetCost = unitCost
                                var quantity = quantity
                                var discountTotal = 0;
                                var decimalPlaces = this.decimalPlaces

                                discountText.forEach(function(row) {
                                    var discount;
                                    var discountAmount;
                                    if (numberRegex.test(row)) {
                                        discount = row
                                        discountAmount =  Number(discount)
                                    } else if (lessDiscountDecimal.test(row)) {
                                        discount = row
                                        discountAmount = discount
                                    } else if (lessDiscount.test(row)) {
                                        discount = row.slice(1);
                                        discountAmount = (discount * quantity)
                                    } else if (percentDiscount.test(row)) {
                                        discount = row.slice(0,-1)
                                        discountAmount = ((unitNetCost * quantity)-discountTotal) * (discount / 100)
                                    }
                                    discountTotal += discountAmount
                                });
                                if (unitNetCost < 0) unitNetCost = 0
                                this.unitNetCost = Number(unitNetCost).toFixed(this.decimalPlaces)
                                var subTotal = ((this.quantity * this.unitNetCost) - discountTotal).toFixed(this.decimalPlaces) 
                                discountTotal = (this.quantity * this.unitNetCost) - subTotal
                            } else {
                                paramDiscountText.pop();
                                this.notifMessage = notifMessage
                                this.documentActionNotification('Document line discount', 'error')
                            }
                        }else {
                            var subTotal = (this.quantity * unitCost).toFixed(this.decimalPlaces)
                        }
                        // this.unitCost gets whats in price
                        this.addRegularProduct(selectedProducts[i], productName, quantity, 0, unitCost, subTotal, unitNetCost, discountTotal, discountText, 0, 0, "", "", 1);
                    }

                    this.calculateSummary();
                    this.$refs.autocomplete.clear();
                    this.clearProduct();
                }
                this.spinning = false;
                this.costUpdated = false;
                this.spinMessage = 'Loading...';
            },

            // function to clear current document line upon clicking "OK" on modal
            clearDocumentLine(){
              this.popUpModal.isVisible = false
              this.spinning = true;
              this.spinMessage = 'Clearing document lines'
              const data = this.tabulator.getRows()
              setTimeout(()=>{
                data.forEach((item, idx)=>{
                  let line_no = idx + 1
                  this.delete_line(line_no)
                  })  
              this.spinning = false;  
              this.spinMessage = 'Loading...'
              this.calculateSummary()
              this.populateBySupplier(this.supplier)
              },500)  
            },

            checkDocumentLine(){
              // validate if document line is currently filled
                if(this.tabulator.getRows().length > 0){
                 this.popUpModal.isVisible = true 
                 this.popUpModal.initializeProcess = this.clearDocumentLine
                 this.popUpModal.message = "Do you want to overwrite existing item(s)?"
                 this.popUpModal.text = "Click 'OK' to overwrite , 'Cancel' to retain current list and add item(s) below"
                 this.popUpModal.toClear = true
                }
               if(this.tabulator.getRows().length === 0){
                this.popUpModal.isVisible = true 
                this.popUpModal.initializeProcess = ()=>{this.populateBySupplier(this.supplier) } 
                this.popUpModal.message = "Auto Populate By Supplier"
                this.popUpModal.text = "Are you sure you want to populate the products from this supplier?"
               }

            },
            async populateMinMaxProducts(){
                this.spinning = true;

                const data = this.tabulator.getRows()
                data.forEach((item, idx)=>{
                  let line_no = idx + 1
                  this.delete_line(line_no)
                })

                for (let i = 0; i < this.minMaxProducts.length; i++) {
                        var productName = this.minMaxProducts[i].name
                        var quantity = this.minMaxProducts[i].order_quantity
                        var unitCost = eval('this.minMaxProducts[i].'+this.productPriceChoice)
                        var unitNetCost = eval('this.minMaxProducts[i].'+this.productPriceChoice)
                        // if (['BLENDED'].includes(this.documentCostingMethod) && ['RELTRX','RECTRX'].includes(this.currentDocumentTypeCode)){
                        //     unitCost = eval('this.minMaxProducts[i].blended_cost')
                        //     unitNetCost = eval('this.minMaxProducts[i].blended_cost')
                        // }
                        var discountText = []
                        if(unitCost<=0) unitCost = eval('this.minMaxProducts[i].landed_cost')
                        if(unitNetCost<=0) unitNetCost = eval('this.minMaxProducts[i].landed_cost')
                
                        unitCost = Number(unitCost).toFixed(this.decimalPlaces)
                        unitNetCost = Number(unitNetCost).toFixed(this.decimalPlaces)
                        var discountTotal = 0

                        var subTotal = unitCost * quantity
                        if(this.minMaxProducts.length == (i+1))
                            var triggerCompute = 0
                        else
                            var triggerCompute = 1
                        this.addRegularProduct(this.minMaxProducts[i], productName, quantity, 0, unitCost, subTotal, unitNetCost, discountTotal, discountText, 0, 0, "", "", triggerCompute);
                    }
                this.modalMinMaxProducts = false;
                this.spinning = false;
            },
            async populateOffTakeProducts(){
                this.spinning = true;
                const data = this.tabulator.getRows()
                data.forEach((item, idx)=>{
                  let line_no = idx + 1
                  this.delete_line(line_no)
                })

                for (let i = 0; i < this.offtakeProducts.length; i++) {
                        var productName = this.offtakeProducts[i].name
                        var quantity = this.offtakeProducts[i].order_quantity
                        var unitCost = eval('this.offtakeProducts[i].'+this.productPriceChoice)
                        var unitNetCost = eval('this.offtakeProducts[i].'+this.productPriceChoice)
                        // if (['BLENDED'].includes(this.documentCostingMethod) && ['RELTRX','RECTRX'].includes(this.currentDocumentTypeCode)){
                        //     unitCost = eval('this.offtakeProducts[i].blended_cost')
                        //     unitNetCost = eval('this.offtakeProducts[i].blended_cost')
                        // }
                        var discountText = []
                        if(unitCost <=0) unitCost = eval('this.offtakeProducts[i].landed_cost')
                        if(unitNetCost <=0) unitNetCost = eval('this.offtakeProducts[i].landed_cost')
                
                        unitCost = Number(unitCost).toFixed(this.decimalPlaces)
                        unitNetCost = Number(unitNetCost).toFixed(this.decimalPlaces)
                        var discountTotal = 0

                        var subTotal = unitCost * quantity
                        if(this.offtakeProducts.length == (i+1))
                            var triggerCompute = 0
                        else
                            var triggerCompute = 1
                        this.addRegularProduct(this.offtakeProducts[i], productName, quantity, 0, unitCost, subTotal, unitNetCost, discountTotal, discountText, 0, 0, "", "", triggerCompute);
                    }
                this.modalOffTakeProducts = false;
                this.spinning = false;
            },
            async populateBySupplier(supplier){
               this.popUpModal.isVisible = false
               this.showAddingProgress.isVisible = true
                // window.scrollTo(0,0);
                // this.spinning = true;
                // this.spinMessage = 'Loading products from ' + supplier.label;
                var params = '/products/?per_page=200&supplier_id='+supplier.key+'&all=1';
                if (this.currentDocumentTypeCode == 'ORIPOX'){
                    params += '&is_non_trade=' + !this.isDocumentTrade;
                }
                var selectedProducts = await HTTPRequest.getRequest(this.endPoint + params);
                this.showAddingProgress.productCount = selectedProducts.data.length
                if (selectedProducts.data.length > 0){
                  for (let i = 0; i < selectedProducts.data.length; i++) {
                        this.showAddingProgress.productAdded = (i + 1)
                        var productName = selectedProducts.data[i].name
                        var quantity = 1.0
                        var unitCost = eval('selectedProducts.data[i].'+this.productPriceChoice)
                        var unitNetCost = eval('selectedProducts.data[i].'+this.productPriceChoice)
                        // if (['BLENDED'].includes(this.documentCostingMethod) && ['RELTRX','RECTRX'].includes(this.currentDocumentTypeCode)){
                        //     unitCost = eval('selectedProducts.data[i].blended_cost')
                        //     unitNetCost = eval('selectedProducts.data[i].blended_cost')
                        // }
                        var discountText = []
                        if(unitCost <= 0) unitCost = eval('selectedProducts.data[i].landed_cost')
                        if(unitNetCost <= 0) unitNetCost = eval('selectedProducts.data[i].landed_cost')
                        // unitNetCost = Number(unitNetCost).toFixed(this.decimalPlaces)
                        // var discountTotal = 0

                        // // https://tools.iripple.com/barter-11/bxi-backend/-/issues/1927
                        // // https://tools.iripple.com/barter-11/bxi-backend/-/issues/1871#note_82568
                        // //In PO Document, if the selected supplier is the main supplier:
                        // if(this.currentDocumentTypeCode == 'OTHPUR' || this.currentDocumentTypeCode == 'ORIPOX'){
                        //     // Check first if the current site have site price/cost, if none, use the product (main).
                        //     // Check first if the current site have site price/cost, if none, use the product (main).
                        //     // If the selected supplier is not main supplier or not alternate supplier:
                        //     var site_id = secureStorage.getItem("defaultSiteId");
                        //     var site_product = await HTTPRequest.getRequest(this.endPoint + '/site_products/get_site_product?product_id=' + selectedProducts.data[i].id + '&site_id=' + site_id);

                        //     if(site_product != null){
                        //         var siteUnitCost = eval('site_product.'+this.productPriceChoice)
                        //         var siteUnitNetCost = eval('site_product.'+this.productPriceChoice)
                        //         if(siteUnitCost > 0 || siteUnitNetCost > 0){
                        //             unitCost = Number(siteUnitCost).toFixed(this.decimalPlaces)
                        //             unitNetCost = Number(siteUnitNetCost).toFixed(this.decimalPlaces)
                        //         }
                        //     }
                        //     // If the selected supplier is alternate supplier (with record in product_suppliers), get the ordering cost in the product_suppliers table
                        //     if(this.productPriceChoice == 'ordering_cost' && selectedProducts.data[i].supplier_product_ordering_cost != null){
                        //         if(selectedProducts.data[i].supplier_product_ordering_cost > 0){
                        //             unitCost = Number(selectedProducts.data[i].supplier_product_ordering_cost).toFixed(this.decimalPlaces)
                        //             unitNetCost = Number(selectedProducts.data[i].supplier_product_ordering_cost).toFixed(this.decimalPlaces)
                        //         }
                        //     }
                        // }
                        
                        // for alternate supplier costing
                        if(this.currentDocumentTypeCode == 'OTHPUR' || this.currentDocumentTypeCode=="ORIPOX"){
                            let site_product_cost;
                            let site_product = await HTTPRequest.getRequest(this.endPoint + '/site_products/get_site_product?product_id=' + selectedProducts.data[i].id + '&site_id=' + this.requestingSite.key);
                                    
                            if(site_product != null){
                                let siteProductCost = eval('site_product.'+this.productPriceChoice)
                                // if (['BLENDED'].includes(this.documentCostingMethod) && ['RELTRX','RECTRX'].includes(this.currentDocumentTypeCode)){
                                //     siteProductCost = eval('site_product.blended_cost')
                                // }
                                if(siteProductCost <= 0) siteProductCost = eval('site_product.landed_cost')
                                site_product_cost = Number(siteProductCost).toFixed(this.decimalPlaces)
                            }

                            if(site_product_cost && site_product_cost > 0){
                                unitCost = site_product_cost
                                unitNetCost = site_product_cost
                            }

                            if(supplier != null && supplier != undefined && supplier != ""){
                                if(Number(supplier.key) != Number(selectedProducts.data[i].supplier_id)){
                                    // if not main supplier get cost based on supplier products table
                                    let findSupplierProduct = await HTTPRequest.getRequest(this.endPoint + '/supplier_products?product_id='+ selectedProducts.data[i].id+ '&supplier_id=' + supplier.key);
                                    if(findSupplierProduct != null){
                                        if(findSupplierProduct.data.length > 0){
                                            let supplierProduct = findSupplierProduct.data[0]
                                            unitCost = supplierProduct.ordering_cost
                                            unitNetCost = supplierProduct.ordering_cost
                                        }
                                    }
                                }
                            }
                        }

                        unitCost = Number(unitCost).toFixed(this.decimalPlaces)
                        unitNetCost = Number(unitNetCost).toFixed(this.decimalPlaces)
                        var discountTotal = 0

                        var subTotal = unitCost * quantity
                        if(selectedProducts.data.length == (i+1))
                            var triggerCompute = 0
                        else
                            var triggerCompute = 1
                        this.addRegularProduct(selectedProducts.data[i], productName, quantity, 0, unitCost, subTotal, unitNetCost, discountTotal, discountText, 0, 0, "", "", triggerCompute);
                    }
                }
                this.spinning = false;
                this.spinMessage = 'Loading...';
                this.showAddingProgress.isVisible = false
                this.showAddingProgress.productAdded = 0
                this.showAddingProgress.productCount = 0

               setTimeout(()=>{ 
                // Prompt how many product/s are successfully populated.
                 this.popUpModal.isVisible = true 
                 this.popUpModal.isAutoPopulate = true 
                 this.popUpModal.initializeProcess = () => {
                  this.popUpModal.isVisible = false
                  this.popUpModal.isAutoPopulate = false
                }
                 this.popUpModal.message = `Auto-populate Successful`
                 this.popUpModal.text = `${selectedProducts.data.length} Item(s) added to list`
                // alert(`${selectedProducts.data.length} Product(s) has been added to list.`)
                }
                ,1000)

            },
            reasonLookup(){
                var response = '';
                var request = new XMLHttpRequest();
                if(this.currentDocumentTypeCode == 'OTHTOV')
                    request.open('GET', this.endPoint + 'reasons/get_tabulator_reasons?reason_type_code=TOV', false);
                else if(this.currentDocumentTypeCode == 'OTHPCV')
                    request.open('GET', this.endPoint + 'reasons/get_tabulator_reasons?reason_type_code=PCV', false);
                else
                    request.open('GET', this.endPoint + 'reasons/get_tabulator_reasons?reason_type_code='+this.currentDocumentTypeCode, false);
                request.setRequestHeader('Authorization', 'Bearer ' + secureStorage.getItem("accessToken"));
                request.setRequestHeader('Request-Source',"BXI-Web");
                request.setRequestHeader('ip',secureStorage.getItem("ipAddress"));
                request.send(null);
                if (request.status === 200) {
                    response = request.responseText;
                }
                var json_response = JSON.parse(response)
                return {values:json_response}
            },
            reasonFormatter(cell){
                if(['OTHTOV', 'OTHPCV'].includes(this.currentDocumentTypeCode))
                    var label = 'No Resolution'
                else
                    var label = 'No Reason'

                if (cell._cell.row.data.reason_id != undefined){
                    var response = '';
                    var request = new XMLHttpRequest();
                    if(this.currentDocumentTypeCode == 'OTHTOV')
                        request.open('GET', this.endPoint + 'reasons/get_tabulator_reasons?reason_type_code=TOV', false);
                    else if(this.currentDocumentTypeCode == 'OTHPCV')
                        request.open('GET', this.endPoint + 'reasons/get_tabulator_reasons?reason_type_code=PCV', false);
                    else
                        request.open('GET', this.endPoint + 'reasons/get_tabulator_reasons', false);
                    request.setRequestHeader('Authorization', 'Bearer ' + secureStorage.getItem("accessToken"));
                    request.setRequestHeader('Request-Source',"BXI-Web");
                    request.setRequestHeader('ip',secureStorage.getItem("ipAddress"));
                    request.send(null);
                    if (request.status === 200) {
                        response = request.responseText;
                    }
                    var json_response = JSON.parse(response)
                    if (json_response[0]!=undefined){
                        if (json_response[0].value != undefined) {
                            try {
                                label = json_response.find(element => element.value == cell._cell.row.data.reason_id.toString()).label;
                            } catch (error) {}
                        }
                    }

                }
                return label;
            },
            sublocationLookup(){
                if(this.tabulator_site_sublocations.length > 0){
                    return {values: this.tabulator_site_sublocations}
                } else {
                    return "No Sublocation"
                }
                // var response = '';
                // var sl_site = (this.currentDocumentTypeCode == 'RECTRX') ? this.distributionSite.key : this.requestingSite.key;
                // if (sl_site>0){
                //     var request = new XMLHttpRequest();
                //     request.open('GET', this.endPoint + 'sublocations/get_tabulator_site_sublocations?site_id='+sl_site, false);
                //     request.setRequestHeader('Authorization', 'Bearer ' + secureStorage.getItem("accessToken"));
                //     request.setRequestHeader('Request-Source',"BXI-Web");
                //     request.setRequestHeader('ip',secureStorage.getItem("ipAddress"));
                //     request.send(null);
                //     if (request.status === 200) {
                //         response = request.responseText;
                //     }
                //     var json_response = JSON.parse(response)
                //     return {values:json_response}
                // }else{
                //     return "No Sublocation"
                // }
            },
            // True only for document types whose item table actually shows the Sub Location
            // column (driven by filteredColumnFields -> renderColumnFields). Tabulator runs
            // a column's formatter even when the column is hidden, so the formatter must
            // check this too, otherwise get_tabulator_site_sublocations fires for types like
            // ORIPOX that never display the column.
            documentShowsSublocationColumn(){
                try {
                    var sublocationField = (this.filteredColumnFields || []).find(f => f.name === 'sublocation');
                    if (sublocationField && sublocationField.value === true) return true;
                    if (this.tabulator && this.tabulator.getColumn) {
                        var slCol = this.tabulator.getColumn('sublocation');
                        if (slCol && typeof slCol.isVisible === 'function') return slCol.isVisible();
                    }
                } catch (e) { /* fall through */ }
                return false;
            },
            sublocationFormatter(cell){
                var label = 'No Sublocation'
                if (cell._cell.row.data.sublocation != undefined && this.documentShowsSublocationColumn()){
                    if(this.tabulator_site_sublocations.length == 0){
                        var response = '';
                        var request = new XMLHttpRequest();
                        var sl_site = (this.currentDocumentTypeCode == 'RECTRX') ? this.distributionSite.key : this.requestingSite.key;
                        if (sl_site > 0){
                            request.open('GET', this.endPoint + 'sublocations/get_tabulator_site_sublocations?site_id='+sl_site, false);
                            request.setRequestHeader('Authorization', 'Bearer ' + secureStorage.getItem("accessToken"));
                            request.setRequestHeader('Request-Source',"BXI-Web");
                            request.setRequestHeader('ip',secureStorage.getItem("ipAddress"));
                            request.send(null);
                            if (request.status === 200) {
                                response = request.responseText;
                                this.tabulator_site_sublocations = JSON.parse(response)
                            }
                        }
                    } 
                    
                    var json_response = this.tabulator_site_sublocations
                    if (json_response[0]!=undefined){
                        if (json_response[0].value != undefined) {
                            try {
                                label = json_response.find(element => element.value == cell._cell.row.data.sublocation.toString()).label;
                            } catch (error) {}
                        }
                    }

                    // var response = '';
                    // var request = new XMLHttpRequest();
                    // var sl_site = (this.currentDocumentTypeCode == 'RECTRX') ? this.distributionSite.key : this.requestingSite.key;
                    // if (sl_site > 0){
                    //     request.open('GET', this.endPoint + 'sublocations/get_tabulator_site_sublocations?site_id='+sl_site, false);
                    //     request.setRequestHeader('Authorization', 'Bearer ' + secureStorage.getItem("accessToken"));
                    //     request.setRequestHeader('Request-Source',"BXI-Web");
                    //     request.setRequestHeader('ip',secureStorage.getItem("ipAddress"));
                    //     request.send(null);
                    //     if (request.status === 200) {
                    //         response = request.responseText;
                    //     }
                    //     var json_response = JSON.parse(response)
                    //         console.log('^^^^')
                    //          console.log(json_response)
                    //          console.log(this.tabulator_site_sublocations)
                    //          console.log('^^^^')
                    //     if (json_response[0]!=undefined){
                    //         if (json_response[0].value != undefined) {
                    //             try {
                    //                 label = json_response.find(element => element.value == cell._cell.row.data.sublocation.toString()).label;
                    //             } catch (error) {}
                    //         }
                    //     }
                    // }
                }
                return label;
            },
            unitLookup(cell) {
                if(this.currentDocumentTypeCode == 'OTHPWS'){
                    return '';
                } else {
                    var response = '';
                    var request = new XMLHttpRequest();
                    request.open('GET', this.endPoint + 'products/' + cell._cell.row.data.product_id + '/get_product_unit_compositions', false);
                    request.setRequestHeader('Authorization', 'Bearer ' + secureStorage.getItem("accessToken"));
                    request.setRequestHeader('Request-Source', "BXI-Web");
                    request.setRequestHeader('ip', secureStorage.getItem("ipAddress"));
                    request.send(null);
                    if (request.status === 200) {
                        response = request.responseText;
                    }
                    var json_response = JSON.parse(response);
                    var options = json_response.map(element => {
                        return {
                            label: element.label,
                            value: element.unit_id
                        };
                    });
                    return { values: options };
                }
            },

            brandFormatter(cell) {
                try {
                    return cell._cell.row.data.brand_name || '';
                } catch (error) {
                    return '';
                }
            },
            phpFormatter(cell){
                var field = (cell._cell.column.field).replace('_php','');
                var value = eval('cell._cell.row.data.'+field);
                var value_php
                if (this.isCurrencyToPhp){
                    if (Number(this.currencyRate) > 0 && (this.documentStatus == 'Posted' || this.documentStatus == 'Voided')){
                        value_php = Number(value * this.currencyRate) || 0;
                    }else if (this.supplierDetails.currency_rate!=undefined && this.supplierDetails.currency_rate !=null && this.supplierDetails.currency_rate != 0 && this.supplierDetails.currency_rate != '0.0'){
                        value_php = Number(value * this.currencyRate) || Number(value * this.supplierDetails.currency_rate) || 0;
                    }else if (this.documentDetails.currency_rate !=undefined && this.documentDetails.currency_rate !=null && this.documentDetails.currency_rate != 0 && this.documentDetails.currency_rate != '0.0'){
                        value_php = Number(value * this.documentDetails.currency_rate) || 0;
                    }else if (this.hasDefaultCurrency && this.defaultCurrencyRate!=0){
                        value_php = Number(value * this.defaultCurrencyRate) || 0;
                    }else {
                        value_php = Number(value * 1);
                    }
                }else{
                    value_php = Number(value / this.currencyRate) || 0;
                }
                value_php =  Math.round(value_php * 100) / 100
                var values = {}
                values[cell._cell.column.field] = value_php
                cell.getRow().update(values)
                return value_php;
            },
            unitFormatter(cell){
                if (cell._cell.row.data.product_unit_composition!=null && cell._cell.row.data.product_unit_composition!=""){
                    return cell._cell.row.data.product_unit_composition;
                } else {
                    var response = '';
                    var request = new XMLHttpRequest();
                    request.open('GET', this.endPoint + 'products/' + cell._cell.row.data.product_id + '/get_product_unit_compositions', false);
                    request.setRequestHeader('Authorization', 'Bearer ' + secureStorage.getItem("accessToken"));
                    request.setRequestHeader('Request-Source', "BXI-Web");
                    request.setRequestHeader('ip', secureStorage.getItem("ipAddress"));
                    request.send(null);
                    if (request.status === 200) {
                        response = request.responseText;
                    }
                    try {
                        var uData = JSON.parse(response);

                        if (Array.isArray(uData)) {
                            var u = uData.find(element => element.unit_id == cell._cell.row.data.unit_id);
                            return u ? u.label : '';
                        } else {
                            return u.label || '';
                        }
                    } catch (error) {
                        console.error("Error parsing JSON:", error);
                        return '';
                    }
                }
            },
            // Document Header
            async fetchSites() {
                this.fetching = true
                var params = "";
                (this.currentDocumentTypeCode == 'RELTRX') ? params=`?not_included_id=${this.supplyingSite.key}` : null;
                (this.currentDocumentTypeCode == 'ORITRQ') ? params=`?not_included_id=${this.requestingSite.key}` : null;
                
                if (this.currentDocumentTypeCode == 'RELTRX' || this.currentDocumentTypeCode == 'RECTRX' || this.currentDocumentTypeCode == 'OTHTRA'){
                    this.sites = await HTTPRequest.getRequest(this.endPoint + 'sites/get_all_document_sites'+params, null)
                } else {
                    this.sites = await HTTPRequest.getRequest(this.endPoint + 'sites/get_valid_document_sites'+params, null)
                }
                this.fetching = false
            },
            async fetchBrands(value){
                this.brand = {key: '', label: value}
                this.fetching = true
                if (value == undefined) value = ''
                var document_site_id = this.distributionSite.key || this.supplyingSite.key
                // this.brands = await HTTPRequest.getRequest(this.endPoint + 'brands/get_valid_brands?name='+value+'&site_id='+document_site_id, null)
                this.brands = await HTTPRequest.getRequest(this.endPoint + '/brands/get_valid_brands?mode=all', null, null);
                this.fetching = false
            },
            async fetchForThisSites() {
                this.fetching = true
                this.forThisSites = await HTTPRequest.getRequest(this.endPoint + 'sites/get_valid_document_sites', null)
                this.forThisSites.unshift({id: 0, code: 'All', name: 'All'})
                this.forThisSites.unshift({id: -1, code: 'Master', name: 'Master'})
                this.fetching = false
            },
            async fetchDistributionSites(value) {
                this.distributionSite = {key: '', label: value}
                this.originSublocation = []
                this.destinationSublocation = []
                this.sublocations = []
                if (value == undefined) value = ''
                this.sites = await HTTPRequest.getRequest(this.endPoint + 'sites/get_valid_document_sites?name='+value, null)
                // await this.tabulator.clearData();

                if (this.distributionSite.key > 0) {
                    this.isProductSearchDisabled = false
                    this.isDestinationSublocationDisabled = false
                } else {
                    this.isProductSearchDisabled = true
                    this.isDestinationSublocationDisabled = true
                }
            },
            async fetchPcountSublocations(){
                this.fetching = true
                this.sublocations = await HTTPRequest.getRequest(this.endPoint + 'sublocations/get_site_sublocations?site_id='+secureStorage.getItem("defaultSiteId"), null)
                this.fetching = false
            },
            async fetchSublocations(){
                this.fetching = true
                if (this.distributionSite.key) {
                    this.sublocations = await HTTPRequest.getRequest(this.endPoint + 'sublocations/get_site_sublocations?site_id='+this.distributionSite.key, null)
                }else if (this.currentDocumentTypeCode == 'RELTRX' && this.supplyingSite.key){
                    this.sublocations = await HTTPRequest.getRequest(this.endPoint + 'sublocations/get_site_sublocations?site_id='+this.supplyingSite.key, null)
                }else {
                    site_id = this.distributionSite.key || this.supplyingSite.key || this.requestingSite.key
                    this.sublocations = await HTTPRequest.getRequest(this.endPoint + 'sublocations/get_site_sublocations?site_id='+site_id, null)
                }
                this.fetching = false
            },
            async fetchCustomers(value){
                this.customer = {key: '', label: value}
                if (value == undefined) {
                    if(this.currentDocumentTypeCode == 'RECCSR'){
                        value = ''
                        this.customers = await HTTPRequest.getRequest(this.endPoint + '/b2b_customers/get_valid_b2b_customers?business_type=trade', null, null);
                    }else{
                        value = ''
                        this.customers = await HTTPRequest.getRequest(this.endPoint + 'customers/get_valid_customers?name='+value, null)
                    }
                }
            },
            async selectCustomer (customer, option) {
                this.b2bCustomer = [];
                // Selecting from the regular customer autocomplete means this is a 'customer'
                // (non-b2b) document; keep customer_type consistent with the chosen customer.
                // RECCSR/ORIOCR reuse this autocomplete to pick a b2b customer, so leave their
                // customer_type untouched.
                if (this.currentDocumentTypeCode != 'RECCSR' && this.currentDocumentTypeCode != 'ORIOCR') {
                    this.selectedCustomerType = 'customer'
                }
                customer = customer.replace('customers','')
                this.customer = {key: customer, label: decrypt(option.data.attrs.text)}
                if (customer) {
                    try {
                        if(this.currentDocumentTypeCode == 'RECCSR' || this.currentDocumentTypeCode == 'ORIOCR'){
                            var customerData = await HTTPRequest.getRequest(this.endPoint + "b2b_customers/"+customer, null);
                        }else{
                            var customerData = await HTTPRequest.getRequest(this.endPoint + "customers/"+customer, null);
                            if(this.b2bCustomerOptions.length <= 0){
                                this.b2bCustomerOptions = [{id:customerData.id, name:decrypt(customerData.name)}]
                            }
                        }
                        this.customerAddress = customerData.address ? customerData.address : "No Customer Address";
                        this.customerContactMobile = customerData.mobile ? decrypt(customerData.mobile) : "No Customer Mobile";
                        this.customerContactTelephone = customerData.telephone ? decrypt(customerData.telephone) : "No Customer Telephone";
                        this.customerContactFax = customerData.fax ? customerData.fax : "No Customer Fax";
                        this.customerContactEmail = customerData.email ? decrypt(customerData.email) : "No Customer Email";
                        this.selectedCustomerContact = customerData.mobile ? 'Mobile' : customerData.telephone ? 'Telephone' : customerData.fax ? 'Fax' : customerData.email ? 'Email' : 'Telephone';
                        this.activeCustomerContact = customerData.mobile ? decrypt(this.customerContactMobile) : customerData.telephone ? decrypt(this.customerContactTelephone) : customerData.fax ? this.customerContactFax : customerData.email ? decrypt(this.customerContactEmail) : decrypt(this.customerContactTelephone);

                        // auto populate province, city, barangay, zip_code  based on the customer selection
                        this.province = customerData.province_name ? customerData.province_name : "";
                        this.address = customerData.address || "";
                        this.city = customerData.city_name ? customerData.city_name : "";
                        this.barangay = customerData.barangay_name ? customerData.barangay_name : "";
                        this.zipCode = customerData.zip_code ? customerData.zip_code : "";
                    } catch (error) {
                        console.error('Error fetching customer details:', error);
                    }
                }

                if (this.currentDocumentTypeCode == 'ORISOX' || this.currentDocumentTypeCode == 'OTHSRQ' || this.currentDocumentTypeCode == 'ORIOSO'){
                  // bryan
                    if (this.distributionSite.key > 0 && this.customer.key > 0) {
                        this.isProductSearchDisabled = false
                    } else {
                        this.isProductSearchDisabled = true
                    }
                }
            },
            async selectB2bCustomerSource(att, options) {
                this.customer = []
                if (this.b2bCustomerSource > 0) {
                    try{
                        var b2b_details_index = this.b2bCustomerOptions.findIndex(x=> x.id == att)
                        var b2b_details = this.b2bCustomerOptions[b2b_details_index]
                            var extras = b2b_details.extras
                            this.province_source = extras.province_name
                            this.city_source = extras.city_name
                            this.barangay_source = extras.barangay_name
                            this.zipCode_source = extras.zip_code
                            this.party_tax_type_source = b2b_details.vat_type
                            if(b2b_details.payment_term!=null && b2b_details.payment_term > 0){
                                await this.fetchPaymentTerms()
                                var payment_term_index = this.paymentTerms.findIndex(x=> x.id == b2b_details.payment_term)
                                var payment_terms = this.paymentTerms[payment_term_index]
                                this.paymentTerm_source =  {
                                    key:b2b_details.payment_term,
                                    label:payment_terms.name
                                }
                            }else{
                                this.paymentTerm_source = {}
                            }
                            if(b2b_details.wtax_code!=null){
                                this.wTax_source = {
                                    key:b2b_details.wtax_code,
                                    label:b2b_details.wtax_code
                                }
                            }else{
                                this.wTax_source = {}
                            }
                    }catch(e){}
                }
            },
            async selectB2bCustomerDestination(att, options) {
                this.customer = []
                if (this.b2bCustomerDestination > 0) {
                    try{
                        var b2b_details_index = this.b2bCustomerOptions.findIndex(x=> x.id == att)
                        var b2b_details = this.b2bCustomerOptions[b2b_details_index]
                            var extras = b2b_details.extras
                            this.province_destination = extras.province_name
                            this.city_destination = extras.city_name
                            this.barangay_destination = extras.barangay_name
                            this.zipCode_destination = extras.zip_code
                            this.party_tax_type_destination = b2b_details.vat_type
                            if(b2b_details.payment_term!=null && b2b_details.payment_term > 0){
                                await this.fetchPaymentTerms()
                                var payment_term_index = this.paymentTerms.findIndex(x=> x.id == b2b_details.payment_term)
                                var payment_terms = this.paymentTerms[payment_term_index]
                                this.paymentTerm_destination =  {
                                    key:b2b_details.payment_term,
                                    label:payment_terms.name
                                }
                            }else{
                                this.paymentTerm_destination = {}
                            }
                            if(b2b_details.wtax_code!=null){
                                this.wTax_destination = {
                                    key:b2b_details.wtax_code,
                                    label:b2b_details.wtax_code
                                }
                            }else{
                                this.wTax_destination = {}
                            }
                    }catch(e){}
                }
            },
            async selectB2bCustomer(att, options) {
                // Explicitly set the selected b2b customer id from the @select argument.
                if (att != undefined && att !== '') {
                    this.b2bCustomer = att
                }
                // Selecting from the b2b customer dropdown means this is a b2b customer document.
                // Force customer_type to 'b2b' so the backend persists b2b_customer_id instead of
                // treating it as a regular customer (which would drop b2b_customer_id to null).
                this.selectedCustomerType = 'b2b'
                this.customer = []
                if (this.currentDocumentTypeCode == 'ORISOX' || this.currentDocumentTypeCode == 'OTHSRQ' || this.currentDocumentTypeCode == 'ORIOSO'){
                    if (this.distributionSite.key > 0 && this.b2bCustomer > 0) {
                        try{
                            var b2b_details_index = this.b2bCustomerOptions.findIndex(x=> x.id == att)
                            var b2b_details = this.b2bCustomerOptions[b2b_details_index]
                            if(b2b_details.is_on_hold == 1){
                                this.b2bCustomer = []
                                component_x.$notification['error']({
                                    message: 'Customer is On Hold',
                                    description: "Customer " + b2b_details.name + " is on hold and cannot be selected."
                                });
                            }else {
                                var extras = b2b_details.extras
                                this.country = extras.countries_name || extras.country_name 
                                this.address = b2b_details.address || extras.address || ""
                                this.province = extras.province_name
                                this.city = extras.city_name
                                this.barangay = extras.barangay_name
                                this.zipCode = extras.zip_code
                                this.party_tax_type = b2b_details.vat_type
                                if(b2b_details.payment_term!=null && b2b_details.payment_term > 0){
                                    await this.fetchPaymentTerms()
                                    var payment_term_index = this.paymentTerms.findIndex(x=> x.id == b2b_details.payment_term)
                                    var payment_terms = this.paymentTerms[payment_term_index]
                                    this.paymentTerm =  {
                                        key:b2b_details.payment_term,
                                        label:payment_terms.name
                                    }
                                }else{
                                    this.paymentTerm = {}
                                }
                                if(b2b_details.wtax_code!=null){
                                    this.wTax = {
                                        key:b2b_details.wtax_code,
                                        label:b2b_details.wtax_code
                                    }
                                }else{
                                    this.wTax = {}
                                }
                            }
                        }catch(e){}
                        this.isProductSearchDisabled = false
                    } else {
                        this.isProductSearchDisabled = true
                    }
                }
            },
            async selectOrderSource() {
                if (this.currentDocumentTypeCode === 'ORIOSO'){
                    if (this.distributionSite.key > 0 && this.orderSource === "Online Customer") {
                        this.isProductSearchDisabled = false;
                    } else {
                        this.isProductSearchDisabled = true;
                    }
                }
                this.isEditing = true
            },
            async fetchSalesmen(value){
                this.salesman = {key: '', label: value}
                if (value == undefined) value = ''
                this.salesmen = await HTTPRequest.getRequest(this.endPoint + 'salesmen/get_valid_salesmen?name='+value, null)
            },
            async selectSalesman (salesman, option) {
                salesman = salesman.replace('salesman','')
                this.salesman = {key: salesman, label: option.data.attrs.text}
                this.isEditing = true
            },
            async onChangeCountry(country, option){
                country = country.replace('country','')
                this.countryOfOrigin = {key: country, label: option.data.attrs.text, code: option.data.attrs.code}
                this.isEditing = true
            },
            clearCountry(){
                if (this.countryOfOrigin != undefined && (this.countryOfOrigin.label == null || this.countryOfOrigin.label == "" || this.countryOfOrigin.label == undefined)){
                    this.countryOfOrigin = {key:"-1",label:null}
                }
            },
            async selectDistributionSite (distributionSite, option) {
                this.isEditing = true
                distributionSite = distributionSite.replace('sites1','')
                Object.assign(this, {
                    originSublocation: [],
                    destinationSublocation: [],
                })
                this.distributionSite = {key: distributionSite, label: option.data.attrs.text}
                this.companyOwnerId = option.data.attrs.content
                await this.tabulator.clearData();
                //Get default sublocation of origin site
                var origin_subloc = await HTTPRequest.getRequest(this.endPoint + 'sublocations/get_site_sublocations?site_id='+distributionSite+'&is_default=true', null)
                var arr = {
                    key:origin_subloc[0].id,
                    label:origin_subloc[0].name
                }

                var destinationSublocation = arr
                Object.assign(this, {
                    destinationSublocation,
                    sublocations: [],
                    fetching: false,
                })

                if(this.currentDocumentTypeCode != 'RECCSI'){
                    let site_lessor = this.sites.find(x => x.id == distributionSite)
                    this.b2bCustomer = (Number(site_lessor.lessor) > 0) ? Number(site_lessor.lessor) : ''
                    this.selectedCustomerType = 'b2b'
                }

                if (this.currentDocumentTypeCode == 'ORISOX' || this.currentDocumentTypeCode == 'OTHSRQ' || this.currentDocumentTypeCode == 'ORIOSO'){
                  // bryan
                    if (this.distributionSite.key > 0 && this.customer.key > 0) {
                        this.isProductSearchDisabled = false
                    } else {
                        this.isProductSearchDisabled = true
                    }
                } else {
                    if (this.distributionSite.key > 0) {
                        this.isProductSearchDisabled = false
                    } else {
                        this.isProductSearchDisabled = true
                    }
                }

                if (this.distributionSite.key > 0) {
                    this.isDestinationSublocationDisabled = false
                } else {
                    this.isDestinationSublocationDisabled = true
                }
            },
            async selectOriginSublocation (originSublocation) {
                this.isEditing = true
                var arr = {
                    key:originSublocation.key.replace('sublocations1',''),
                    label:originSublocation.label
                }
                originSublocation = arr
                Object.assign(this, {
                    originSublocation,
                    sublocations: [],
                    fetching: false,
                })

                //RELOAD Document Lines to retrieve actual quantity of sublocation on RELDDE
                window.scrollTo(0,0);
                this.spinning = true;
                var sales_order_id = this.$route.params.sales_order_id
                let document_lines = []
                document_lines = await HTTPRequest.getRequest(this.endPoint+'document_lines/'+sales_order_id+'?field_name=document_id&origin_sublocation='+originSublocation.key, null)
                if(document_lines != undefined && document_lines != null && document_lines != []){
                    document_lines.forEach( row => {
                        row.quantity = 0
                    });
                    await this.tabulator.clearData();
                    await this.tabulator.addData(document_lines, true);
                }
                this.tabulator.addFilter("line_no", ">", 0);
                if(document_lines != undefined && document_lines != null && document_lines != []){
                    component_x.origData = JSON.stringify(document_lines.reverse()) //For isDirty Data on Document lines
                } 
                this.spinning = false;
            },
            selectDestinationSublocation (destinationSublocation) {
                this.isEditing = true
                var arr = {
                    key:destinationSublocation.key.replace('sublocations2',''),
                    label:destinationSublocation.label
                }
                destinationSublocation = arr
                Object.assign(this, {
                    destinationSublocation,
                    sublocations: [],
                    fetching: false,
                })
            },
            async selectSupplyingSite (supplyingSite) {
                this.isEditing = true
                var arr = {
                    key:supplyingSite.key.replace('sites',''),
                    label:supplyingSite.label
                }
                supplyingSite = arr
                Object.assign(this, {
                    supplyingSite,
                    sites: [],
                    fetching: false,
                })

                // populate address based on the supplying branch value
                this.populateAddress('supplyingSite', supplyingSite.key);

                if (['RELTRX'].includes(this.currentDocumentTypeCode)) {
                    var checkBrandAss = await HTTPRequest.getRequest(this.endPoint + "sites/check_brand_assortment_for_site?brand_id=" + this.brand.key + "&site_id=" + supplyingSite.key, null)
                    if (checkBrandAss["error"] != undefined && checkBrandAss["error"] != null && checkBrandAss["error"] != ""){
                        component_x.$notification['error']({
                            message: 'Brand Assortment Error',
                            description: "No Site Brand Access. Select valid Supplying Site for " + this.brand.label || 'document.',
                            style: getNotificationStyle('error')
                        });
                        this.supplyingSite = {}
                        this.populateAddress('supplyingSite', null)
                        return;
                    }

                    component_x.$notification.success({
                        message: 'Supplying Site Selected',
                        description: `You have successfully selected supplying site: ${supplyingSite.label}.`,
                        style: getNotificationStyle('success')
                    })
                }
            },
            async selectBrand(brandKey, option) {
                this.isEditing = true
                const numericBrandKey = brandKey.toString().replace('brands','')
                const selectedBrand = this.brands.find(b => b.id == numericBrandKey)
                var arr = {
                    key: selectedBrand.id, 
                    label: selectedBrand.name
                }

                if (this.currentDocumentTypeCode === 'RELTRX') {
                    const checkBrandAssortment = await HTTPRequest.getRequest(this.endPoint + `brands/check_user_brand_access?brand_id=${arr.key}`, null)

                    if (checkBrandAssortment && checkBrandAssortment.error) {
                        component_x.$notification.error({
                            message: 'Brand Access Error',
                            description: `You do not have access to brand ${arr.label}`,
                            style: getNotificationStyle('error')
                        })
                        this.brand = {}
                        return
                    }
                }
                Object.assign(this, {
                    brand: arr,
                    brands: [],
                    fetching: false,
                })
                if (this.brand.key > 0) {
                    this.isProductSearchDisabled = false
                } else {
                    this.isProductSearchDisabled = true
                }

                component_x.$notification.success({
                    message: 'Brand Selected',
                    description: `You have access to ${arr.label}! Brand selected successfully.`,
                    style: getNotificationStyle('success')
                })

                await this.fetchSites()
            },

            async selectRequestingSite (requestingSite) {
                var arr = {
                    key:requestingSite.key.replace('selectRequestingSite',''),
                    label:requestingSite.label
                }
                requestingSite = arr
                Object.assign(this, {
                    requestingSite,
                    sites: [],
                    fetching: false,
                })
                this.isEditing = true
                if(this.party == null || this.party == undefined || this.party == ''){
                    this.party = this.requestingSite.label
                }

                // populate address based on the requesting branch value
                this.populateAddress('requestingSite', requestingSite.key);
                if(this.currentDocumentTypeCode == 'RELTRX'){
                    //Get Default Site Sublocation [Requesting Site]
                    var default_sublocation = await this.getSiteById(requestingSite.key.replace('selectRequestingSite',''))
                    this.notifMessage = []
                    if(default_sublocation['sublocation_id'] != null){
                        //Get Sublocation Code
                        var sublocation = await HTTPRequest.getRequest(this.endPoint + 'sublocations/'+default_sublocation['sublocation_id'], null)
                        this.default_sublocation_code = sublocation['code']
                    } else {
                        this.requestingSite = ''
                        this.documentActionNotification('No default sublocation for the selected requesting site.', 'error')
                    }
                }

                if (['RELTRX'].includes(this.currentDocumentTypeCode)) {
                    var checkBrandAss = await HTTPRequest.getRequest(this.endPoint + "sites/check_brand_assortment_for_site?brand_id=" + this.brand.key + "&site_id=" + requestingSite.key, null)
                    if (checkBrandAss["error"] != undefined && checkBrandAss["error"] != null && checkBrandAss["error"] != ""){
                        component_x.$notification['error']({
                            message: 'Brand Assortment Error',
                            description: "No Site Brand Access. Select valid Requesting Site for " + this.brand.label,
                            style: getNotificationStyle('error')
                        });
                        this.requestingSite = {}
                        this.isRequestingSiteDisabled = false
                        this.populateAddress('requestingSite', null)
                        return;
                    }

                    component_x.$notification.success({
                        message: 'Requesting Site Selected',
                        description: `You have successfully selected requesting site: ${requestingSite.label}.`,
                        style: getNotificationStyle('success')
                    })
                }
            },
            selectRevenue (revenue) {
                this.revenue = revenue.replace('selectRevenue','')
                this.fetching=false
            },
            async fetchSuppliers(value) {
                this.supplier = {key: '', label: value}
                if (value == undefined) value = ''
                this.suppliers = await HTTPRequest.getRequest(this.endPoint + 'suppliers/get_valid_suppliers?name='+value, null)
                this.supplierDetails = {}
                if (this.supplier.key !=undefined && this.supplier.key!=''){
                    this.forceFetchCurrency = true
                    this.showConversionRate = false
                    this.showConversionCurrencyRate()
                }
            },
            async fetchDefaultCurrency() {
                var default_currency = await HTTPRequest.getRequest(this.endPoint + 'currencies/get_default_currency', null)
                if(default_currency["error"] == undefined){
                    try{
                        if(this.currency.key==undefined){
                            this.currency = {key: default_currency.id, label: default_currency.currency}
                        }
                    }catch(e){
                        this.currency = {key: default_currency.id, label: default_currency.currency}
                    }
                    this.hasDefaultCurrency = default_currency.has_default_currency
                    this.defaultCurrencyDetails = default_currency
                    var currency_histories = await this.getSupplierCurrencyByDocDate(default_currency.id)
                    if (currency_histories.length > 0) {
                        this.defaultCurrencyRate = currency_histories[0].conversion_rate || default_currency.currency_rate || 1
                    } else {
                        this.defaultCurrencyRate = default_currency.currency_rate || 1
                    }
                    this.isRunDefaultCurrency = true
                }else{
                    this.notifMessage = default_currency["error"].split(",");
                }
            },

            // Start
            // https://tools.iripple.com/barter-11/bxi-backend/-/issues/1724
            // Target Date & Cancellation Date for PO is not getting the assigned date from supplier template

            changeDate () {
                    this.isEditing = true
                if( ['ORIPOX', 'OTHPUR', 'RELRSR', 'RECDEL'].includes(this.currentDocumentTypeCode) ) {
                    this.targetDate = moment(this.documentDate, "YYYY-MM-DD").add(this.suppDetails.delivery_lead_time, 'days');
                    this.cancellationDate = moment(this.documentDate, "YYYY-MM-DD").add(this.suppDetails.delivery_lead_time + this.suppDetails.days_to_cancel, 'days');
                }
            },


            // https://tools.iripple.com/barter-11/bxi-backend/-/issues/1724
            // Target Date & Cancellation Date for PO is not getting the assigned date from supplier template
            // End

            async selectSupplier (supplier, option) {
                this.isEditing = true
                supplier = supplier.replace('selectSupplier','')

                // Start
                // https://tools.iripple.com/barter-11/bxi-backend/-/issues/1724
                // Target Date & Cancellation Date for PO is not getting the assigned date from supplier template

                if( ['OROTRQ', 'OROCSQ', 'ORITRQ', 'ORICSQ', 'RECTRX', 'RELTRX', 'OTHPUR', 'ORIPOX', 'RECDEL', 'RELRSR', 'ORITRQ', 'OROTRQ', 'RECTRX', 'ORIASN'].includes(this.currentDocumentTypeCode) ) {
                    var response = await HTTPRequest.getRequest(this.endPoint + 'suppliers/' + supplier, null)
                    this.suppDetails = response
                    var lead_time = (parseInt(this.suppDetails.delivery_lead_time) == 0) ? 1 : parseInt(this.suppDetails.delivery_lead_time)
                    this.targetDate = moment(this.documentDate, "YYYY-MM-DD").add(lead_time, 'days').utc().startOf('day');
                    this.cancellationDate = moment(this.documentDate, "YYYY-MM-DD").add(lead_time + this.suppDetails.days_to_cancel, 'days').utc().startOf('day');

                    //1935 - Populate supplier header and support discount
                    if(this.suppDetails.support_discount_text!=null && this.suppDetails.support_discount_text.length > 0 )
                        this.supportDiscount = this.suppDetails.support_discount_text.toString().split(",")
                    else
                        this.supportDiscount = []
                    if(this.suppDetails.discount_text!=null && this.suppDetails.discount_text.length > 0 ){
                        this.headerDiscount = this.suppDetails.discount_text.toString().split(",")
                    }else{
                        this.headerDiscount = []
                    }

                    //2370
                    if(this.suppDetails.payment_term_id!=null && this.suppDetails.payment_term_id > 0){
                        this.paymentTerm =  {
                            key:this.suppDetails.payment_term_id,
                            label:this.suppDetails.payment_term_name
                        }
                    }else{
                        this.paymentTerm = {}
                    }
                    if(this.suppDetails.wtax_code!=null){
                        this.wTax = {
                            key:this.suppDetails.wtax_code,
                            label:this.suppDetails.wtax_code
                        }
                    }else{
                        this.wTax = {}
                    }
                    this.party_tax_type = response.vat_type
                }

                // https://tools.iripple.com/barter-11/bxi-backend/-/issues/1724
                // Target Date & Cancellation Date for PO is not getting the assigned date from supplier template
                // End

                this.forceFetchCurrency = true
                let check_supplier = this.suppliers.findIndex(x=> x.id == supplier)
                let currency_id =null
                if (check_supplier>=0){
                    let supplier_details = this.suppliers[check_supplier]
                    this.supplierDetails = supplier_details
                    if (supplier_details.currency_id>0){
                        this.currencyId = supplier_details.currency_id
                        var currency_histories = await this.getSupplierCurrencyByDocDate(this.currencyId)
                        if (currency_histories.length > 0) {
                            this.currencyRate = currency_histories[0].conversion_rate || supplier_details.currency_rate
                        } else {
                            this.currencyRate = supplier_details.currency_rate
                        }
                        currency_id = supplier_details.currency_id
                        if(this.currencies.length <= 0 || this.hasDefaultCurrency){
                            this.forceFetchCurrency = true
                            await this.fetchCurrencies()
                        }
                        let currency_details = this.currencies.find(c => parseInt(c.id) == parseInt(this.suppliers[check_supplier].currency_id))
                        if (currency_details!=undefined){
                            let currency = {
                                key:this.suppliers[check_supplier].currency_id,
                                label:currency_details.code,
                            }
                            var currency_histories = await this.getSupplierCurrencyByDocDate(this.currencyId)
                            if (currency_histories.length > 0) {
                                this.currencyRate = currency_histories[0].conversion_rate || currency_details.conversion || 1
                            } else {
                                this.currencyRate = currency_details.conversion || 1
                            }
                            this.supplierCurrencyName = currency_details.name + "("+Number(this.currencyRate).toFixed(4)+")"
                            Object.assign(this, {
                                currency,
                                fetching: false,
                                currencyDetails:currency_details,
                            })
                            this.forceFetchCurrency = true
                            await this.fetchCurrencies()
                            await this.showConversionCurrencyRate()
                        }
                        this.calculateSummary();    
                    }else{
                        this.currencyId = -1
                        this.supplierCurrencyName = "PHP"
                        this.supplierDetails = {}
                        await this.fetchCurrencies()
                    }
                    this.party_tax_type = supplier_details.vat_type
                }else{
                    this.currencyId = -1
                    this.supplierCurrencyName = "PHP"
                    this.supplierDetails = {}
                    await this.fetchCurrencies()
                }
                Object.assign(this, {
                    suppliers: [],
                })
                this.supplier = {key: supplier, label: option.data.attrs.text,currency_id:currency_id}
                this.$refs.supplierAutoCompleteInput.blur()
                this.$refs.autocomplete.clear()
            },

            showSupplierModal(){
                if(this.currentDocumentTypeCode == 'OTHPUR' || this.currentDocumentTypeCode == 'ORIPOX'){
                    let _data = this.tabulator.getData();
                    if(_data.length > 0){
                        this.showChangeSupplierModal = true
                    }
                }
            },
            async getSupplierCurrencyByDocDate(currency_id){
                // Memoize by currency_id + business_date. Several methods (fetchDefaultCurrency,
                // the mount block, updateValueOfSupplierCurrency, the documentDate watcher, etc.)
                // request the same currency/date during a single load, producing duplicate
                // GET currencies/get_currency_by_document_date calls. Cache the in-flight promise
                // per key so the same request is only sent once.
                var businessDate = this.documentDate.format('YYYY-MM-DD')
                var currencyCacheKey = currency_id + '|' + businessDate
                if (!this._currencyByDocDateCache) this._currencyByDocDateCache = {}
                if (this._currencyByDocDateCache[currencyCacheKey]) {
                    return this._currencyByDocDateCache[currencyCacheKey]
                }
                var currencyPromise = HTTPRequest.getRequest(this.endPoint + 'currencies/get_currency_by_document_date?currency_id='+currency_id+'&business_date='+businessDate, null)
                // Don't keep a rejected promise cached, so a later call can retry.
                currencyPromise.catch(() => { delete this._currencyByDocDateCache[currencyCacheKey] })
                this._currencyByDocDateCache[currencyCacheKey] = currencyPromise
                return currencyPromise
            },
            //Add Product / Search Product
            changeProductFormMode(val) {
                this.productFormMode = val
                if (val == "Add") {
                    this.tabulator.clearFilter();
                    this.productSearchInput = ''
                }
            },
            changeSearchFilter(searchFilter){
                this.productSearchInput = ''
                var search_text = searchFilter.split('_');
                if (this.currentDocumentTypeCode=='OTHCNS'){
                    this.placeholder = "Search by " + search_text.join(' ')
                }else{
                    this.placeholder = "Search product by " + search_text.join(' ')
                }
                // if (searchFilter == 'code') {
                //     searchFilter = 'product_id'
                // }
                if (searchFilter == 'document_id') {
                    searchFilter = 'id'
                }
                this.searchFilter = searchFilter
            },

            changesearchFilterAddedProduct(searchFilter){
                this.addedProductSearchInput = ''
                if(this.addedProductSearchInput == ''){
                    this.searchAddedProducts()
                }
                var search_text = searchFilter.split('_');
                if (this.currentDocumentTypeCode=='OTHCNS'){
                    this.addedProductPlaceholder = "Search by " + search_text.join(' ')
                }else{
                    this.addedProductPlaceholder = "Search added product by " + search_text.join(' ')
                }
                if (searchFilter == 'code') {
                    searchFilter = 'product_id'
                }
                if (searchFilter == 'name') {
                    searchFilter = 'product_name'
                }
                this.searchFilterAddedProduct = searchFilter
            },

            productEndpoint (input) {
                var params = '/products?&type=document&'
                if (this.currentDocumentTypeCfode == 'OTHASM' || this.currentDocumentTypeCode == 'OTHDSM'){
                    params = '/products?&type=ASMDSMDOC&'
                }
                if (this.currentDocumentTypeCode == 'ORISOX' || this.currentDocumentTypeCode == 'OTHSRQ' || this.currentDocumentTypeCode == 'ORIOSO'){
                    params = '/products?site_id='+this.distributionSite.key+'&type=ORISOXDOC&'
                }

                // if (this.supplier.key > 0) params = '/products?type=document&supplier_id=' + this.supplier.key + '&'
                if (this.filterBySupp && this.supplier.key > 0){
                    params = '/products?type=document&supplier_id=' + this.supplier.key + '&'
                }
                else if (this.filterBySupp && this.supplier.key == undefined) {
                    if (this.document_config.document_type_settings.incomingOrder.requireSupplierInPo){
                        component_x.$notification['error']({
                            message: 'Supplier is required',
                            description: "Filter product by supplier is enabled.",
                            style: getNotificationStyle('error')
                        });
                    }
                    params = '/products?type=document&supplier_id=0&'
                }
                else {
                    params = '/products?type=document&'
                }

                if (this.currentDocumentTypeCode == 'OTHPWS') {
                    if (this.filteredBySupplier == false) {
                        params = '/products?type=document&'
                    } else {
                        params = '/products?type=document&supplier_id=' + this.supplier.key + '&'
                    }
                }
                if (this.currentDocumentTypeCode == 'RECCSR' && component_x.openCSR != undefined && !(component_x.openCSR)){
                    var document_id = this.$route.params.sales_order_id
                    params = `/products?type=RECCSRDOC&origin_document_id=${component_x.documentNumber > 0 ?  component_x.documentNumber : this.$route.params.sales_order_id }&`
                }
                if (this.currentDocumentTypeCode == 'ORIOCR' && component_x.openOCR != undefined && !(component_x.openOCR)){
                    var document_id = this.$route.params.sales_order_id
                    params = `/products?type=RECCSRDOC&origin_document_id=${component_x.documentNumber > 0 ?  component_x.documentNumber : this.$route.params.sales_order_id }&`
                }
                if (this.currentDocumentTypeCode == 'ORIPOX'){
                    params += 'is_non_trade=' + !this.isDocumentTrade + '&' + 'documenttype=ORIPOX&';
                }
                //2114
                if(['OTHPUR', 'OTHASM', 'OTHDSM'].includes(this.currentDocumentTypeCode)) {
                    params += 'documenttype=' + this.currentDocumentTypeCode + '&';
                } 
                // console.log(this.endPoint + params + this.searchFilter + '=' + input + '&sort=alphabetical', this.currentDocumentTypeCode);
                let userBrandLevel = secureStorage.getItem("userBrandLevel");
                let brand_id = this.brand.key
                if(brand_id != null && brand_id != "" && brand_id != []){
                    //WAF ISSUE
                    params += 'userBrands=' + brand_id + '&'
                    // comment for document brand filter issue
                    //params += 'userBrands=' + true + '&'
                }else if(userBrandLevel){
                    let site_brands =  secureStorage.getItem("siteBrands")
                    let doc_user_brand_ids =  secureStorage.getItem("docUserSiteBrand")
                    let user_brand_ids
                    if (doc_user_brand_ids.length > 0){
                        user_brand_ids = doc_user_brand_ids
                    } else {
                        user_brand_ids = site_brands
                    }
                    //WAF ISSUE
                    //params += 'userBrands=' + user_brand_ids + '&';
                    params += 'userBrands=' + true + '&';
                }

                return this.endPoint + params + this.searchFilter + '=' + input + '&sort=alphabetical';
            },
            formattedDisplay (result) {
                if (this.searchFilter == 'name'){
                    let namePrefix = result[this.document_config.document_type_settings.editorBehavior.prefixSearch]
                    let resultPrefix = (namePrefix) ? `[ ${namePrefix} ] ` : '';
                    return resultPrefix + eval('result.'+this.searchFilter);
                } else{
                    return eval('result.'+this.searchFilter) + ' ['+result.name+']';
                }
            },
            async getProduct (group) {
                 // On initial loading of document the value of on-hand quantity/available quantity in the UI is (*).
                // if(this.isRefreshInventory == false && (this.documentStatus == 'Saved' || this.documentStatus == null)) {
                //     this.onHandQuantity = '*'
                //     this.availableQuantity = '*'
                // } else {    
                    var lastinv = await HTTPRequest.getRequest(this.endPoint + 'inventories/site_product_inventory?product_id='+group.selectedObject.id+'&site_id='+secureStorage.getItem("defaultSiteId"), null)
                    if (lastinv.onhand_quantity != undefined){
                        this.onHandQuantity = lastinv.onhand_quantity
                        this.availableQuantity = lastinv.available_quantity
                    } else {
                        this.onHandQuantity = 0
                        this.availableQuantity = 0
                    }
                // }

                this.notifMessage = []
                if (this.currentDocumentTypeCode == 'OTHASM' && group.selectedObject.product_type == "R"){
                    this.actual_yield = group.selectedObject.yield_quantity || 0;
                    this.tolerance_quantity = group.selectedObject.tolerance_quantity || 0;
                    this.showActualYield = true;
                }

                if (this.currentDocumentTypeCode=="RELTRX" || this.currentDocumentTypeCode=="RELCSX" || this.currentDocumentTypeCode=="RELSLO"){
                    var inventory = await HTTPRequest.getRequest(this.endPoint + 'inventories/site_product_inventory?product_id='+group.selectedObject.id+'&site_id='+((this.currentDocumentTypeCode=="RELSLO") ? this.distributionSite.key : this.supplyingSite.key)+'&sublocation_id='+this.originSublocation.key, null)
                    if (inventory.error) {
                        this.notifMessage.push(inventory.error)
                        this.documentActionNotification('Add document line', 'error')
                        return
                    } else{
                        this.onHandQuantity = inventory.onhand_quantity / group.selectedObject.content_quantity
                        this.availableQuantity = inventory.available_quantity / group.selectedObject.content_quantity
                    }
                }

                if (this.currentDocumentTypeCode=="RELRSR" || this.currentDocumentTypeCode=="RELADJ"){
                    var req_site = this.requestingSite.key;
                    if(this.currentDocumentTypeCode=="RELRSR" && secureStorage.getItem("currentSiteSiteType") != 'ho'){
                        req_site = secureStorage.getItem("defaultSiteId");
                    }
                    var inventory = await HTTPRequest.getRequest(this.endPoint + 'inventories/site_product_inventory?product_id='+group.selectedObject.id+'&site_id='+req_site+'&document_type_id='+this.currentDocumentTypeId, null)
                    if (inventory.error) {
                        this.notifMessage.push(inventory.error)
                        this.documentActionNotification('Add document line', 'error')
                        return
                    } else{
                        this.onHandQuantity = inventory.onhand_quantity / group.selectedObject.content_quantity
                        this.availableQuantity = inventory.available_quantity / group.selectedObject.content_quantity
                    }
                }

                if (this.currentDocumentTypeCode=="ORISOX" || this.currentDocumentTypeCode=="OTHSRQ" || this.currentDocumentTypeCode=="ORIOSO"){
                    var inventory = await HTTPRequest.getRequest(this.endPoint + 'inventories/site_product_inventory?product_id='+group.selectedObject.id+'&site_id='+this.distributionSite.key+'&document_type_id='+this.currentDocumentTypeId, null)
                    if (inventory.error) {
                        this.notifMessage.push(inventory.error)
                        this.documentActionNotification('Add document line', 'error')
                        return
                    } else{
                        this.onHandQuantity = inventory.onhand_quantity  / group.selectedObject.content_quantity
                        this.availableQuantity = inventory.available_quantity  / group.selectedObject.content_quantity
                    }
                }

                if (this.currentDocumentTypeCode=="OTHTRA"){
                    var inventory = await HTTPRequest.getRequest(this.endPoint + 'inventories/site_product_inventory?product_id='+group.selectedObject.id+'&site_id='+this.supplyingSite.key, null)
                    if (inventory.error) {
                        this.notifMessage.push(inventory.error)
                        this.documentActionNotification('Add document line', 'error')
                        return
                    } else{
                        this.onHandQuantity = inventory.onhand_quantity  / group.selectedObject.content_quantity
                        this.availableQuantity = inventory.available_quantity  / group.selectedObject.content_quantity
                    }
                }
                
                if(this.productPriceChoice.includes('piml')){
                    let t = 0
                    let tt = 0
                    var unitCost = eval('group.selectedObject.'+this.productPriceChoice.replace(/_/g, match => ++t === 2 ? '' : match))
                    var unitNetCost = eval('group.selectedObject.'+this.productPriceChoice.replace(/_/g, match => ++tt === 2 ? '' : match))
                }else{
                    var unitCost = eval('group.selectedObject.'+this.productPriceChoice)
                    var unitNetCost = eval('group.selectedObject.'+this.productPriceChoice)
                }
                
                // if (['BLENDED'].includes(this.documentCostingMethod) && ['RELTRX','RECTRX'].includes(this.currentDocumentTypeCode)){
                //     unitCost = eval('group.selectedObject.blended_cost')
                //     unitNetCost = eval('group.selectedObject.blended_cost')
                // }
                //Remove logic for 0 price
                // if (unitCost <= 0) unitCost = eval('group.selectedObject.landed_cost')
                // if (unitNetCost <= 0) unitNetCost = eval('group.selectedObject.landed_cost')
                var site_id = secureStorage.getItem("defaultSiteId");
                var isRel = this.currentDocumentTypeCode.includes("REL");
                var isRec = this.currentDocumentTypeCode.includes("REC");
                if (isRel || isRec) {
                    let currency_params = ""
                    if (this.supplier.currency_id!=null && this.currencyRate!=null){
                        currency_params = '&currency_id='+this.supplier.currency_id+'&currency_rate='+this.currencyRate
                    }
                    // var inventory_cost = await HTTPRequest.getRequest(this.endPoint + 'inventory_costs/get_latest_inventory_cost?product_id='+group.selectedObject.id+'&site_id='+site_id+' ' +currency_params, null)
                    // if (inventory_cost.cost){
                    //     this.unitCost = inventory_cost.cost
                    //     this.unitNetCost= inventory_cost.cost
                    // } else {
                        this.unitCost = unitCost
                        this.unitNetCost= unitNetCost
                    //}
                }else {
                    this.unitCost = unitCost
                    this.unitNetCost= unitNetCost

                    // for alternate supplier costing
                    if(this.currentDocumentTypeCode == 'OTHPUR' || this.currentDocumentTypeCode=="ORIPOX"){
                        let site_product_cost;
                        let site_product = await HTTPRequest.getRequest(this.endPoint + '/site_products/get_site_product?product_id=' + group.selectedObject.id + '&site_id=' + this.requestingSite.key);
                                
                        if(site_product != null){
                            let siteProductCost = eval('site_product.'+this.productPriceChoice)
                            // if (['BLENDED'].includes(this.documentCostingMethod) && ['RELTRX','RECTRX'].includes(this.currentDocumentTypeCode)){
                            //     siteProductCost = eval('site_product.blended_cost')
                            // }
                            if (siteProductCost <= 0) siteProductCost = eval('site_product.landed_cost')
                            site_product_cost = Number(siteProductCost).toFixed(this.decimalPlaces)
                        }

                        if(site_product_cost && site_product_cost > 0){
                            this.unitCost = site_product_cost
                            this.unitNetCost = site_product_cost
                        }

                        if(this.supplier != null && this.supplier != undefined && this.supplier != ""){
                            if(Number(this.supplier.key) != Number(group.selectedObject.supplier_id)){
                                // if not main supplier get cost based on supplier products table
                                let findSupplierProduct = await HTTPRequest.getRequest(this.endPoint + '/supplier_products?product_id='+ group.selectedObject.id+ '&supplier_id=' + this.supplier.key);
                                if(findSupplierProduct != null){
                                    if(findSupplierProduct.data.length > 0){
                                        let supplierProduct = findSupplierProduct.data[0]
                                        this.unitCost = supplierProduct.ordering_cost
                                        this.unitNetCost = supplierProduct.ordering_cost
                                    }
                                }
                            }
                        }
                    }
                }

                                
                // // TODO: https://tools.iripple.com/barter-11/bxi-backend/-/issues/1927
                // // ------ [Internal] - Incorrect ordering cost of product when using alternate supplier
                // // Check if docType is Purchase Order or Purchase Request
                // // what if matrix item matrix item product dont have alternate supplier
                // if(this.currentDocumentTypeCode == 'OTHPUR' || this.currentDocumentTypeCode == 'ORIPOX'){
                //     // console.log(this.unitCost, isRel, isRec, this.productPriceChoice,eval('group.selectedObject.'+this.productPriceChoice))
                //     // if docType check alternate_sup of this product
                //     let product_id
                //     if(group.selectedObject.matrix_parent_id == null){
                //         product_id = group.selectedObject.id
                //     }else{
                //         product_id = group.selectedObject.matrix_parent_id
                //     }

                //     var site_product = await HTTPRequest.getRequest(this.endPoint + '/site_products/get_site_product?product_id=' + product_id + '&site_id=' + site_id);
                //     if(site_product != null){
                //         var siteUnitCost = eval('site_product.'+this.productPriceChoice)
                //         var siteUnitNetCost = eval('site_product.'+this.productPriceChoice)
                //         if(siteUnitCost != null && siteUnitNetCost != null && siteUnitCost > 0 && siteUnitNetCost > 0){
                //             this.unitCost = Number(siteUnitCost).toFixed(this.decimalPlaces)
                //             this.unitNetCost = Number(siteUnitNetCost).toFixed(this.decimalPlaces)
                //         }
                //     }

                //     if(this.supplier.key != null && group.selectedObject.id != null && this.productPriceChoice == 'ordering_cost'){
                //         var supp_id = Number(this.supplier.key)
                //         var alternate_supplier = await HTTPRequest.getRequest(this.endPoint + 'supplier_products/get_alternate_supplier?product_id=' + product_id + '&supplier_id=' + supp_id)
                //         if(alternate_supplier != null && alternate_supplier.ordering_cost > 0){
                //             this.unitCost = alternate_supplier.ordering_cost
                //             this.unitNetCost = alternate_supplier.ordering_cost
                //         }
                //         // if alternate_sup exist use this ordering_cost if productPriceChoice is Ordering Cost
                //     }
                // }
                // // ------ END [Internal] - Incorrect ordering cost of product when using alternate supplier

                this.selectedParentProduct = group.selectedObject
                this.selectedProduct = group.selectedObject
                if (group.selectedObject.product_type == "R") {
                    this.productName = group.selectedObject.name + ' : ' + group.selectedObject.finished_product_name
                } else {
                    this.productName = group.selectedObject.name
                }

                this.inputProduct = group.selectedObject.name
                this.quantity = 1
                this.productComposition = group.selectedObject.product_unit_content
                if ((['X','Z'].includes(this.party_tax_type) && this.docTypesForOM.includes(this.currentDocumentTypeCode))){
                    if (group.selectedObject.tax_type == "V"){
                        this.unitCost = (Number(this.unitCost) / (1+Number(this.taxRate)))
                        this.unitNetCost = (Number(this.unitNetCost) / (1+Number(this.taxRate)))
                    }
                }
                this.unitCost = Number(this.unitCost).toFixed(this.decimalPlaces)
                this.unitNetCost = Number(this.unitNetCost).toFixed(this.decimalPlaces)
                this.isDocumentLineFormDisabled = false
                this.isProductNameDisabled = this.isProductNameEditConfigDisabled
                this.isPriceCostDisabled = this.isPriceCostEditConfigDisabled
                this.discountText = []
                this.subTotal = (this.quantity * this.unitCost).toFixed(this.decimalPlaces)

                if ((this.currentDocumentTypeCode=="ORISOX" || this.currentDocumentTypeCode=="OTHSRQ" || this.currentDocumentTypeCode=="ORIOSO") && this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.allowPromotionComputation) {
                    var request_body = {
                        document_date: this.documentDate.format(),
                        site_id: this.distributionSite.key,
                        unit_cost: this.unitCost,
                        product_id: group.selectedObject.id,
                        customer_id: this.customer.key
                    }
                    var promotion = await HTTPRequest.postRequest(this.endPoint + 'promotions/is_applicable', null, request_body)

                    if (promotion.applied_promo_reward_code != null) {
                        //this.unitCost = promotion.new_unit_cost
                        this.unitNetCost = promotion.new_unit_cost.toFixed(this.decimalPlaces)
                        this.promoName = promotion.applied_promo_name
                        this.rewardCode = promotion.applied_promo_reward_code
                        this.rewardDiscountAmount = promotion.discounted_amount
                        this.discountText.push(promotion.discounted_amount)
                        this.subTotal = (this.subTotal - promotion.discounted_amount).toFixed(this.decimalPlaces)
                    }
                }
                // price work sheet
                if (this.currentDocumentTypeCode=="OTHPWS"){
                    this.oldOrdering = group.selectedObject.ordering_cost
                    this.oldLanded = group.selectedObject.landed_cost
                    this.oldRetailPrice = group.selectedObject.retail_price
                    this.oldSpecialPrice = group.selectedObject.special_price
                    this.oldWholesalePrice = group.selectedObject.wholesale_price
                    this.oldPimlPrice1 = group.selectedObject.piml_price1
                    this.oldPimlPrice2 = group.selectedObject.piml_price2
                    this.oldPimlPrice3 = group.selectedObject.piml_price3

                    if(group.selectedObject.last_received_date != null && group.selectedObject.last_received_date != ""){
                        this.withRR = true;
                        this.notifMessage.push('Landed cost is disabled, already had a receiving report last '+moment(group.selectedObject.last_received_date).format('YYYY-MM-DD')+'.')
                        this.documentActionNotification('Information', 'info')
                    } else {
                        this.withRR = false;
                    }
                }
            },
            clearProduct (){
                this.selectedParentProduct = ''
                this.selectedProduct = ''
                this.productName = '';
                this.inputProduct = ''
                this.quantity = 0
                this.productComposition = ''
                this.unitCost = 0
                this.discountTotal = 0
                this.discountText = []
                this.unitNetCost = 0
                this.subTotal =  0
                this.isDocumentLineFormDisabled = true
                this.isProductNameDisabled = true
                this.rewardCode = null
                this.rewardDiscountAmount = 0
                this.showActualYield = false;
                this.actual_yield = 0;
                this.tolerance_quantity = 0;
                this.oldOrdering = ''
                this.newOrdering = ''
                this.oldLanded = ''
                this.newLanded = ''
                this.oldRetailPrice = ''
                this.newRetailPrice = ''
                this.oldSpecialPrice = ''
                this.newSpecialPrice = ''
                this.oldLeastPrice = ''
                this.newWholesalePrice = ''
                this.oldWholesalePrice = ''
                this.oldSpecialPrice = ''
                this.oldOriginal = ''
                this.markUp = ''
                this.oldPimlPrice1 = ''
                this.oldPimlPrice2 = ''
                this.oldPimlPrice3 = ''
                this.newPimlPrice1 = ''
                this.newPimlPrice2 = ''
                this.newPimlPrice3 = ''
            },
                calculatePwsCosts(field) {
                  if (field == 'markUp') {
                    let landedCost = (this.newLanded == null || this.newLanded == "") ? this.oldLanded : this.newLanded;
                    let markUpPercent = this.markUp;
                    let newRetailPrice = (Number(landedCost) + Number(landedCost) * markUpPercent / 100);

                    if(this.accessPWSPrice){
                        this.newRetailPrice = newRetailPrice > 0 ? newRetailPrice.toFixed(this.decimalPlaces) : 0;
                    }
                        //this.newRetailPrice = newRetailPrice > 0 ? newRetailPrice.toFixed(this.decimalPlaces) : 0;
                  }

                  if (field == 'newLanded') {
                    //let landedCost = this.newLanded;
                    //let retailPrice = this.newRetailPrice;
                    let landedCost = (this.newLanded == null || this.newLanded == "") ? this.oldLanded : this.newLanded;
                    let retailPrice = (this.newRetailPrice == null || this.newRetailPrice == "") ? this.oldRetailPrice : this.newRetailPrice;
                    if (landedCost && retailPrice &&
                        !isNaN(landedCost) && !isNaN(retailPrice)) {
                      let markUpPercent = 0;
                      if (landedCost != 0) markUpPercent = ((retailPrice - landedCost) / landedCost) * 100;
                      this.markUp = markUpPercent.toFixed(this.decimalPlaces);
                      //this.markUp = markUpPercent > 0 ? markUpPercent.toFixed(this.decimalPlaces) : 0;
                    } else { this.markUp = ''; }
                  }

                  if (field == 'newPrice') {
                    //let landedCost = this.newLanded;
                    //let retailPrice = this.newRetailPrice;
                    let landedCost = (this.newLanded == null || this.newLanded == "") ? this.oldLanded : this.newLanded;
                    let retailPrice = (this.newRetailPrice == null || this.newRetailPrice == "") ? this.oldRetailPrice : this.newRetailPrice;
                    if (landedCost && retailPrice &&
                        !isNaN(landedCost) && !isNaN(retailPrice)) {
                      let markUpPercent = 0;
                      if (landedCost != 0) markUpPercent = ((retailPrice - landedCost) / landedCost) * 100;
                      this.markUp = markUpPercent.toFixed(this.decimalPlaces);
                      //this.markUp = markUpPercent > 0 ? markUpPercent.toFixed(this.decimalPlaces) : 0;
                    } else { this.markUp = ''; }
                  }
                },
                calculateCost(){
                  this.calculateSelectedProduct()
                  this.costUpdated = true
                },
                calculateSelectedProduct () {
                    var notifMessage = []
                    if (this.discountText.length > 0) {
                        // eslint-disable-next-line
                        //var discountRegex = /(^L[0-9]+$|^[0-9]+$|^[0-9]+\%$)/;
                        var discountRegex = /(^\d{0,10}(\.\d{1,4})? *%?$)/;
                        //var lessDiscount = /^L[0-9]+$/;
                        var lessDiscount = /^L[0-9]+(\.[0-9]{1,2})?$/;
                        //var lessDiscount = /^L[0-9]+$/;
                        var lessDiscount = /^L[0-9]+(\.[0-9]{1,2})?$/;
                        var discountText = this.discountText.join();
                        discountText = discountText.split(',');

                        discountText.forEach(function(row) {
                            var validation = false;
                            if (!discountRegex.test(row)) validation = true;
                            if (lessDiscount.test(row)) validation = false;
                            if (validation) notifMessage.push(row + ' discount input is invalid \n \r');
                        });

                        if (notifMessage.length == 0) {
                            var lessDiscountDecimal = /^\d{0,10}(\.\d{1,10})?$/;
                            var numberRegex = /^[0-9]+$/;
                            // eslint-disable-next-line 
                            //var percentDiscount = /^[0-9]+\%$/;
                            var percentDiscount = /^[1][0][0]\.[0]{2}\%|[0-9]+\%|[1-9]?[0-9]\.[0-9]{1,4}\%$/;

                            var unitNetCost = this.unitCost
                            var quantity = this.quantity
                            var discountTotal = 0;
                            var decimalPlaces = this.decimalPlaces

                            discountText.forEach(function(row) {
                                var discount;
                                var discountAmount;
                                if (numberRegex.test(row)) {
                                    discount = row
                                    discountAmount = Number(discount)
                                } else if (lessDiscountDecimal.test(row)) {
                                    discount = row
                                    discountAmount = (discount)
                                } else if (lessDiscount.test(row)) {
                                    discount = row.slice(1)
                                    discountAmount = (discount * quantity)
                                } else if (percentDiscount.test(row)) {
                                    discount = row.slice(0,-1)
                                    discountAmount = ((unitNetCost * quantity)-discountTotal) * (discount / 100)
                                }
                                discountTotal += discountAmount 
                            });
                            if (unitNetCost < 0) unitNetCost = 0
                            this.unitNetCost = Number(unitNetCost).toFixed(this.decimalPlaces)
                            this.subTotal = ((this.quantity * this.unitNetCost) - discountTotal).toFixed(this.decimalPlaces)
                            this.discountTotal = (this.quantity * this.unitNetCost) - this.subTotal
                        } else {
                            this.discountText.pop();
                            this.notifMessage = notifMessage
                            this.documentActionNotification('Document line discount', 'error')
                        }
                    }else {
                        this.unitNetCost = Number(this.unitCost).toFixed(this.decimalPlaces)
                        this.subTotal = (this.quantity * this.unitCost).toFixed(this.decimalPlaces)
                    }
                },
                //Document Line Form
                documentLineErrorNotif(type) {
                    this.$notification[type]({
                        message: 'Document Line Notification',
                        // eslint-disable-next-line
                        description: h => {
                            return <ul class='m-0 p-0'>
                                {this.notifMessage.map((value, index) => {
                                    return <li key={index}>{value}</li>
                                })}
                            </ul>
                        },
                        style: getNotificationStyle(type)
                    });
                },
                async fetchProductCompositions() {
                    this.fetching = true
                    this.productCompositions = await HTTPRequest.getRequest(this.endPoint + 'products/'+this.selectedParentProduct.id+'/get_product_unit_compositions', null)
                    this.fetching = false
                },
                async selectProductComposition(productComposition) {
                    var arr = {
                        key:productComposition.key.replace('productCompositions',''),
                        label:productComposition.label
                    }
                    productComposition = arr
                    var unitId = this.productCompositions.find(x => x.key == productComposition.key).unit_id
                    Object.assign(this, {
                        productComposition,
                        productCompositions: [],
                        fetching: false,
                    })
                    this.productComposition.unit_id = unitId
                    var product = await HTTPRequest.getRequest(this.endPoint + '/products/'+ this.productComposition.key);

                    if (product){
                         this.notifMessage = []
                        if (this.currentDocumentTypeCode=="RELTRX" || this.currentDocumentTypeCode=="RELCSX"){
                            var inventory = await HTTPRequest.getRequest(this.endPoint + 'inventories/site_product_inventory?product_id='+product.id+'&site_id='+this.supplyingSite.key, null)
                            if (inventory.error) {
                                this.notifMessage.push(inventory.error)
                                this.documentActionNotification('Add document line', 'error')
                                return
                            } else{
                               this.onHandQuantity = inventory.quantity
                               this.availableQuantity = inventory.available_quantity
                            }
                        }


                        var unitCost = eval('product.'+this.productPriceChoice)
                        var unitNetCost = eval('product.'+this.productPriceChoice) //VAT EXCLUDE PRICE
                        // if (['BLENDED'].includes(this.documentCostingMethod) && ['RELTRX','RECTRX'].includes(this.currentDocumentTypeCode)){
                        //     unitCost = eval('product.blended_cost')
                        //     unitNetCost = eval('product.blended_cost')
                        // }
                        if (unitCost <= 0) unitCost = eval('product.landed_cost')
                        if (unitNetCost <= 0) unitNetCost = eval('product.landed_cost')

                        var site_id = secureStorage.getItem("defaultSiteId");
                        var isRel = this.currentDocumentTypeCode.includes("REL");
                        var isRec = this.currentDocumentTypeCode.includes("REC");
                        if (isRel || isRec) {
                            var inventory_cost = await HTTPRequest.getRequest(this.endPoint + 'inventory_costs/get_latest_inventory_cost?product_id='+product.id+'&site_id='+site_id, null)
                            if (inventory_cost.cost && Number(inventory_cost.cost) != 0){
                                this.unitCost = inventory_cost.cost
                                this.unitNetCost= inventory_cost.cost
                            } else {
                                this.unitCost = unitCost
                                this.unitNetCost= unitNetCost
                            }
                        }else {
                            this.unitCost = unitCost
                            this.unitNetCost= unitNetCost
                        }

                        this.selectedProduct = product
                        this.productName = product.name
                        this.inputProduct = product.name
                        this.quantity = 1
                        this.unitCost = Number(this.unitCost).toFixed(this.decimalPlaces)
                        this.discountText = [] //Not Hardcoded
                        this.unitNetCost = Number(this.unitNetCost).toFixed(this.decimalPlaces)
                        this.subTotal =  (this.quantity * this.unitCost).toFixed(this.decimalPlaces)
                    }
                },

                //isDirtyData
                preventNav(event) {
                    if (!this.isDirty) return
                    event.preventDefault()
                    event.returnValue = ""
                },
                filterExistingProducts(e){
                    if (this.document_config.document_type_settings.editorBehavior.radio == 'P'){
                        this.filterExistingProductData = e.data
                        return e.data
                    }else{
                        var data = this.tabulator.getData();
                        var product_ids = data.map(({product_id}) => product_id)
                        return e.data.filter(item => !product_ids.includes(item.id))
                    }
                },

                //Document Lines
                validateAddLine(quantity, productName, unitCost, selectedProduct){
                    this.notifMessage = [];
                    var data = this.tabulator.getData();
                    if (this.document_config.document_type_settings.editorBehavior.radio != 'P'){
                        var product = data.find(element => element.product_id == selectedProduct.id)
                        if (product != undefined) this.notifMessage.push("Matrix Item Exists");
                    }
                    this.notifMessage.push(ValidateField.positiveNumber('Quantity', quantity));
                    this.notifMessage.push(ValidateField.charMinAndMax("Product Name", productName, 0, 100));
                    this.notifMessage.push(ValidateField.positiveNumber('Cost', unitCost));

                    if(!selectedProduct.is_weighted){
                        this.notifMessage.push(ValidateField.isWholeNumber('Quantity', quantity, 'Decimal Quantity is not allowed for this item. Please enter a whole number.'));
                    }else{
                        this.notifMessage.push(ValidateField.decimalDigitsLessThan('Quantity', quantity, 4));
                    }
                    
                    this.notifMessage = this._.compact(this.notifMessage);
                    return this.notifMessage.length;
                },
                validateAddPwsLine(productName, newOrdering, newLanded, newRetailPrice, markUp, newSpecialPrice, newWholesalePrice, newPimlPrice1, newPimlPrice2, newPimlPrice3){
                    this.notifMessage = [];
                    this.notifMessage.push(ValidateField.charMinAndMax("Product Name", productName, 0, 100));
                    if (newOrdering) {
                        this.notifMessage.push(ValidateField.positiveNumber('New Ordering', newOrdering));
                    }
                    if (newLanded) {
                        this.notifMessage.push(ValidateField.positiveNumber('New Landed', newLanded));
                    }
                    if (newRetailPrice){
                        this.notifMessage.push(ValidateField.positiveNumber('New Retail Price', newRetailPrice));
                    }
                    if (markUp) {
                        this.notifMessage.push(ValidateField.positiveNumber('Mark Up %', markUp));
                    }
                    if (newSpecialPrice) {
                        this.notifMessage.push(ValidateField.positiveNumber('New Special Price', newSpecialPrice));
                    }
                    if (newWholesalePrice) {
                        this.notifMessage.push(ValidateField.positiveNumber('New Wholesale Price', newWholesalePrice));
                    }
                    if (newPimlPrice1) {
                        this.notifMessage.push(ValidateField.positiveNumber('New PIML Price1', newPimlPrice1));
                    }
                    if (newPimlPrice2) {
                        this.notifMessage.push(ValidateField.positiveNumber('New PIML Price2', newPimlPrice2));
                    }
                    if (newPimlPrice3) {
                        this.notifMessage.push(ValidateField.positiveNumber('New PIML Price3', newPimlPrice3));
                    }
                    if ((newOrdering == "" || newOrdering == null) && (newLanded == "" || newLanded == null) && (newRetailPrice == "" || newRetailPrice == null) && (newSpecialPrice == "" || newSpecialPrice == null) && (newWholesalePrice == "" || newWholesalePrice == null) && (newPimlPrice1 == "" || newPimlPrice1 == null) && (newPimlPrice2 == "" || newPimlPrice2 == null) && (newPimlPrice3 == "" || newPimlPrice3 == null)) {
                        this.notifMessage.push("Atleast one price/cost field is required.")
                    }
                    this.notifMessage = this._.compact(this.notifMessage);
                    return this.notifMessage.length;
                },
                async refreshInventory() {
                    // this.isRefreshInventory = true
                    var items = this.tabulator.getData();
                    let refreshProducts = [];

                        for (const product of items) {
                            var site_id = secureStorage.getItem("defaultSiteId")
                            var sublocation_id = (this.originSublocation.key != undefined) ? this.originSublocation.key : 0;
                            var refreshInventory = 0
                            if(sublocation_id > 0)
                                var lastinv = await HTTPRequest.getRequest(this.endPoint + 'inventories/site_product_inventory?product_id='+product.product_id+'&site_id='+site_id+'&sublocation_id='+this.originSublocation.key, null)
                            else
                                var lastinv = await HTTPRequest.getRequest(this.endPoint + 'inventories/site_product_inventory?product_id='+product.product_id+'&site_id='+site_id, null)

                            if (lastinv.onhand_quantity != undefined)
                                refreshInventory = lastinv.onhand_quantity
                            //Get Available QTY 
                                //https://tools.iripple.com/barter-11/bxi-backend/-/issues/3113
                                var available_qty = await HTTPRequest.getRequest(this.endPoint + 'inventories/site_product_movement_quantity?product_id='+product.product_id+'&site_id='+site_id, null);
                                
                                const intransit_quantity = (available_qty.find(({ label }) => label  === "intransit_quantity") != undefined) ? (available_qty.find(({ label }) => label  === "intransit_quantity")['quantity']) : 0;
                                const incoming_quantity = (available_qty.find(({ label }) => label  === "incoming_quantity") != undefined) ? (available_qty.find(({ label }) => label  === "incoming_quantity")['quantity']) : 0;
                                const outgoing_quantity = (available_qty.find(({ label }) => label  === "outgoing_quantity") != undefined) ? (available_qty.find(({ label }) => label  === "outgoing_quantity")['quantity']) : 0;

                                //var available_quantity = (Number(lastinv.onhand_quantity) + Number(intransit_quantity) + Number(incoming_quantity)) - Number(outgoing_quantity);

                                var available_quantity = Number(lastinv.available_quantity);
                                
                                var data = {
                                    "line_no": product.line_no,
                                    "stock_no": product.stock_no,
                                    "product_name": product.product_name,
                                    "supplier_stock_no": product.supplier_stock_no,
                                    "design": product.design,
                                    "size": product.size,
                                    "product_id": product.product_id,
                                    "ref_code": product.ref_code,
                                    "barcode": product.barcode,
                                    "unit_id": product.unit_id,
                                    "ordered_quantity": product.ordered_quantity,
                                    "actual_quantity": product.actual_quantity,
                                    "quantity": product.quantity,
                                    "reason_id": product.reason_id,
                                    "actual_yield": product.actual_yield,
                                    "delivery_quantity": product.delivery_quantity,
                                    "goods_issue_quantity": product.goods_issue_quantity,
                                    "frozen_quantity": product.frozen_quantity,
                                    "content_quantity": product.content_quantity,
                                    "price": product.price,
                                    "price_php": product.price_php,
                                    "price_pi": product.price_pi,
                                    "cost": product.cost,
                                    "cost_php": product.cost_php,
                                    "total_gross": product.total_gross,
                                    "total_gross_php": product.total_gross_php,
                                    "subtotal": product.subtotal,
                                    "subtotal_php": product.subtotal_php,
                                    "discount": product.discount,
                                    "discount_text": product.discount_text,
                                    "old_landed_cost": product.old_landed_cost,
                                    "landed_cost": product.landed_cost,
                                    "old_retail_price": product.old_retail_price,
                                    "retail_price": product.retail_price,
                                    "markup_percent": product.markup_percent,
                                    "old_original_cost": product.old_original_cost,
                                    "original_cost": product.original_cost,
                                    "old_ordering_cost": product.old_ordering_cost,
                                    "ordering_cost": product.ordering_cost,
                                    "old_wholesale_price": product.old_wholesale_price,
                                    "wholesale_price": product.wholesale_price,
                                    "old_piml_price1": product.old_piml_price1,
                                    "piml_price1": product.piml_price1,
                                    "old_piml_price2": product.old_piml_price2,
                                    "piml_price2": product.piml_price2,
                                    "old_piml_price3": product.old_piml_price3,
                                    "piml_price3": product.piml_price3,
                                    "old_least_price": product.old_least_price,
                                    "least_price": product.least_price,
                                    "old_special_price": product.old_special_price,
                                    "special_price": product.special_price,
                                    "on_hand_quantity": refreshInventory,
                                    "invoice_amount": product.invoice_amount,
                                    "invoice_discount": product.invoice_discount,
                                    "unit_price_vat": product.unit_price_vat,
                                    "net_price_vat": product.net_price_vat,
                                    "subtotal_vat": product.subtotal_vat,
                                    "unit_price_no_vat": product.unit_price_no_vat,
                                    "price_without_vat": product.price_without_vat,
                                    "subtotal_without_vat": product.subtotal_without_vat,
                                    "effective_discount": product.effective_discount,
                                    "incoming_quantity": product.incoming_quantity,
                                    "code_and_document_no": product.code_and_document_no,
                                    "id": product.id,
                                    "reference_1": product.reference_1,
                                    "document_date": product.document_date,
                                    "total_quantity": product.total_quantity,
                                    "status": product.status,
                                    "order_status": product.order_status,
                                    "created_by": product.created_by,
                                    "updated_by": product.updated_by,
                                    "remarks": product.remarks,
                                    "salesman_name": product.salesman_name,
                                    "line_extras": product.line_extras,
                                    "sublocation_allocation": product.sublocation_allocation,
                                    "product_type": product.product_type,
                                    "document_line_serials_text": product.document_line_serials_text,
                                    // "size": product.size_name,
                                    "color": product.color,
                                    "available_quantity": available_quantity
                                }
                                refreshProducts.push(data)
                        }
                    await this.tabulator.clearData();
                    await this.tabulator.addData(refreshProducts);
                },
                addProduct(is_enough) {
                    this.notifMessage = []
                    //All REL check AQT/OH if enough []
                    if(is_enough == 0 && this.document_config.document_type_settings.releasingDocument['restrictAddingItemNotEnoughQuantity']){
                           this.documentActionNotification('Add product ', 'error')
                           this.notifMessage.push('Not enough available quantity.')
                           this.notifMessage.push('Current AQT: ' + this.availableQuantity + '.')
                           return
                    } 
                    // else if(is_enough == 0 && !this.document_config.document_type_settings.releasingDocument['restrictAddingItemNotEnoughQuantity']){
                    //        this.documentActionNotification('Add product ', 'error')
                    //        this.notifMessage.push('Not enough onhand quantity.')
                    //        this.notifMessage.push('Current OH: ' + this.onHandQuantity + '.')
                    //        return
                    // }

                    var data = this.tabulator.getData();

                    if (this.inputProduct) {
                        if (!(data.length == this.maximumDocumentLineNumber)) {
                            if (this.currentDocumentTypeCode == 'OTHPWS'){
                                this.addPwsProduct(this.selectedProduct, this.onHandQuantity, this.newOrdering, this.newLanded, this.newRetailPrice, this.markUp, this.newSpecialPrice, this.newWholesalePrice, this.newPimlPrice1, this.newPimlPrice2, this.newPimlPrice3);
                            } else {
                                if (this.selectedProduct.product_type == "M") {
                                    this.populateMatrixItems(this.selectedProduct, this.productName, this.quantity, this.discountText)
                                } else {
                                    this.addRegularProduct(this.selectedProduct, this.productName, this.quantity, this.actual_yield, this.unitCost, this.subTotal, this.unitNetCost, this.discountTotal, this.discountText, this.onHandQuantity, this.availableQuantity, this.rewardCode, this.rewardDiscountAmount, 0);
                                    if(this.currentDocumentTypeCode == 'RECCSR' || this.currentDocumentTypeCode == 'ORIOCR' || this.currentDocumentTypeCode == 'RECCSI'){
                                        this.limitCsrProduct(this.tabulator.getData().at(-1));
                                    }
                                }
                            }
                        } else {
                            this.documentActionNotification('Add Product', 'error')
                        }
                    }
                    this.showActualYield = false;
                    this.actual_yield = 0;
                    this.tolerance_quantity = 0;
                    this.addProductConfirmationVisible = false;
                },
                async limitCsrProduct(selectedProduct){
                    // change good issued quantity here
                    var returnable_product = component_x.returnable_qtys.data.find(line => line.product_id == selectedProduct.product_id)
                    var updatedProduct = {product_id: selectedProduct.product_id}
                    updatedProduct.goods_issue_quantity = returnable_product == undefined ? 0 : (returnable_product.returnable_qty)
                    updatedProduct.delivery_quantity = updatedProduct.goods_issue_quantity
                    updatedProduct.discount_text = (returnable_product == undefined) ? '' : returnable_product.discount_text
                    this.tabulator.updateData([updatedProduct])
                    await this.recalculateLine(updatedProduct.product_id)
                    this.calculateSummary();
                },

                async addPwsProduct(selectedProduct, onhandQuantity, newOrdering, newLanded, newRetailPrice, markUp, newSpecialPrice, newWholesalePrice, newPimlPrice1, newPimlPrice2, newPimlPrice3){
                    if(!this.validateAddPwsLine(selectedProduct, newOrdering, newLanded, newRetailPrice, markUp, newSpecialPrice, newWholesalePrice, newPimlPrice1, newPimlPrice2, newPimlPrice3)) {
                        let _products = []
                        if(selectedProduct.product_type == 'M'){
                            var prodMatrix = await HTTPRequest.getRequest(this.endPoint + 'products/get_matrix_items?document_form=true&matrix_parent_id='+selectedProduct.id, null )
                            if(prodMatrix != null){
                                _products = prodMatrix
                            }
                        }
                        _products.push(selectedProduct)

                        let newProducts = [];
                        _products.forEach((product) => {
                            // var oldLeastPrice = (Number(product.least_price) > 0) ? product.least_price : product.retail_price
                            // var oldWholesalePrice = (Number(product.wholesale_price) > 0) ? product.wholesale_price : product.retail_price
                            // var oldSpecialPrice = (Number(product.special_price) > 0) ? product.special_price : product.retail_price
                            // var oldOriginal = (Number(product.original_cost)>0) ? product.original_cost : product.ordering_cost
                            var oldLeastPrice = Number(product.least_price)
                            var oldWholesalePrice = Number(product.wholesale_price)
                            var oldSpecialPrice = Number(product.special_price)
                            var oldOriginal = Number(product.original_cost)
                            var oldPimlPrice1 = Number(product.piml_price1)
                            var oldPimlPrice2 = Number(product.piml_price2)
                            var oldPimlPrice3 = Number(product.piml_price3)

                           var data = {
                                "parent_line_no": 0,
                                "product_id": product.id,
                                "barcode": product.barcode,
                                // "original_cost": oldOriginal,
                                "on_hand_quantity": onhandQuantity,
                                "original_cost": "",
                                "ordering_cost": newOrdering,
                                "landed_cost": newLanded,
                                "retail_price": newRetailPrice,
                                // "wholesale_price": oldWholesalePrice,
                                // "least_price": oldLeastPrice,
                                "special_price": newSpecialPrice,
                                "wholesale_price": newWholesalePrice,
                                "piml_price1": newPimlPrice1,
                                "piml_price2": newPimlPrice2,
                                "piml_price3": newPimlPrice3,
                                "old_piml_price1": oldPimlPrice1,
                                "old_piml_price2": oldPimlPrice2,
                                "old_piml_price3": oldPimlPrice3,
                                "least_price": "",
                                "markup_percent": markUp,
                                "old_original_cost": oldOriginal,
                                "old_ordering_cost": product.ordering_cost,
                                "old_landed_cost": product.landed_cost,
                                "old_retail_price": product.retail_price,
                                "old_wholesale_price": oldWholesalePrice,
                                "old_least_price": oldLeastPrice,
                                "old_special_price": oldSpecialPrice,
                                "unit_id": product.unit_id,
                                "product_name": product.name,
                                "stock_no": product.stock_no,
                                "ref_code": product.reference_code,
                                "size": product.size,
                                "color": product.color,
                                "is_weighted": product.is_weighted,
                                "brand_id": product.brand_id,
                                "brand_name": product.brand_name,
                                "is_require_lotcode": product.is_require_lotcode,
                                "product_icon": product.product_type,
                                "with_rr": this.withRR
                            };
                            newProducts.push(data)
                        })
                            this.tabulator.addData(newProducts);
                            this.recountLineNo();
                            this.calculateSummary();
                            this.$refs.autocomplete.clear();
                            this.clearProduct();

                    } else {
                        if (this.notifMessage.length) this.documentLineErrorNotif('error');
                    }

                },
                async addRegularProduct(selectedProduct, productName, quantity, actualYield, unitCost, subTotal, unitNetCost, discountTotal, discountText, on_hand_quantity, available_quantity, rewardCode, rewardDiscountAmount, autoPopulate){
                     if(!this.validateAddLine(quantity, productName, unitCost, selectedProduct)) {
                        var subtotal = Number(subTotal).toFixed(this.decimalPlaces)
                        if(this.party_tax_type == "V"){
                            var subtotal_without_vat = (Number(subTotal)/ (1+Number(this.taxRate))).toFixed(this.decimalPlaces)
                            var price_without_vat = (Number(unitNetCost)/ (1+Number(this.taxRate))).toFixed(this.decimalPlaces)
                            var tax_amount = Number(subTotal).toFixed(this.decimalPlaces) * (1+Number(this.taxRate))
                        }else{
                            var subtotal_without_vat = (Number(subTotal)).toFixed(this.decimalPlaces)
                            var price_without_vat = (Number(unitNetCost)).toFixed(this.decimalPlaces)
                            var tax_amount = 0
                        }
                        var check_existing_data = []
                        if (this.document_config.document_type_settings.editorBehavior.radio == 'P'){
                            check_existing_data = await this.tabulator.searchData("product_id","=",selectedProduct.id);
                            if (check_existing_data != undefined && check_existing_data.length > 0){
                                check_existing_data[0].quantity = Number(check_existing_data[0].quantity) + Number(quantity)
                            }
                        }

                        //If RELCSI/RECCSI get alternate barcode
                        var alternate_barcode = '-'
                        if(["RELCSI", "RECCSI"].includes(this.currentDocumentTypeCode)){
                            let document_site = this.sites.find(x => x.id == this.distributionSite.key)
                            var alternate_product = await HTTPRequest.getRequest(this.endPoint + 'product_barcodes?product_id=' + selectedProduct.id + '&mall_group_id=' + Number(document_site.mall_group_id))
                            if(alternate_product['data'].length > 0){
                                alternate_barcode = alternate_product['data'][0]['barcode']
                            }
                        }
                        
                        var data = {
                            "parent_line_no": 0,
                            "product_type": selectedProduct.product_type,
                            "product_id": selectedProduct.id,
                            "barcode": selectedProduct.barcode,
                            "actual_quantity": 0, // :TODO: if physical count document must have actual quantity value
                            "on_hand_quantity": on_hand_quantity,
                            "unit_id": selectedProduct.unit_id,
                            "content_quantity": selectedProduct.content_quantity,
                            "product_name": productName,
                            "tax_type": selectedProduct.tax_type,
                            "quantity": quantity,
                            "requested_quantity": quantity,
                            "price": Number(unitCost),
                            "subtotal": subtotal,
                            "subtotal_without_vat": subtotal_without_vat,
                            "price_without_vat": price_without_vat,
                            "discount": discountTotal,
                            "discount_text": discountText.join(),
                            "stock_no": selectedProduct.stock_no,
                            "cost": Number(unitNetCost).toFixed(this.decimalPlaces),
                            "remarks": "",
                            "retail_price": selectedProduct.retail_price,
                            "tax_rate": this.taxRate,
                            "tax_amount": subtotal - subtotal_without_vat,
                            // "tax_amount": tax_amount,
                            "reward_code": rewardCode,
                            "reward_discount_amount": rewardDiscountAmount,
                            "actual_yield": actualYield,
                            "extras":selectedProduct.extras,
                            "ref_code": selectedProduct.reference_code,
                            "matrix_parent_id": selectedProduct.matrix_parent_id,
                            "size": selectedProduct.size,
                            "color": selectedProduct.color,
                            "is_weighted": selectedProduct.is_weighted,
                            "brand_id": selectedProduct.brand_id,
                            "is_require_lotcode": selectedProduct.is_require_lotcode,
                            "product_icon": selectedProduct.product_type,
                            "sublocation": this.default_sublocation_code,
                            "brand_id":selectedProduct.brand_id,
                            "brand_name":selectedProduct.brand_name,
                            "ordering_cost":selectedProduct.ordering_cost,
                            "prod_ordering_cost":selectedProduct.ordering_cost,
                            "net_amount":subtotal,
                            "gross_amount":Number(unitCost) * Number(quantity),
                            "alternate_barcode": alternate_barcode,
                        };
                    
                        if(this.currentDocumentTypeCode == 'RELDDE'){
                            data["ordered_quantity"] = quantity
                            data["delivery_quantity"] = quantity
                        }
                        if (this.document_config.document_type_settings.editorBehavior.radio == 'P'){
                            if (check_existing_data != undefined && check_existing_data.length > 0){
                                await this.tabulator.updateData(check_existing_data);
                            }else{
                                await this.tabulator.addRow(data);
                            }
                        }else{
                            await this.tabulator.addRow(data);
                        }

                        this.isEditing = true;
                        this.recountLineNo();

                        if(autoPopulate == 0){
                            this.calculateSummary();
                            if(selectedProduct.product_type == 'S'){
                                await this.showSerialization([{...this.tabulator.getRowFromPosition(this.tabulator.getRows().length-1).getData(), quantity}])
                            }
                            if(selectedProduct.is_require_lotcode && /^RE(C|L)/.test(this.currentDocumentTypeCode)){
                                await this.tabulator.updateData([{product_id: selectedProduct.id, is_require_lotcode: selectedProduct.is_require_lotcode}])
                                this.rowSelectionChanged([this.tabulator.getData().at(-1)], [this.tabulator.getRowFromPosition(this.tabulator.getRows().length-1)])
                                this.showLotCodeExpiry([this.tabulator.getData().at(-1)])
                            }
                            this.$refs.autocomplete.clear();
                            this.clearProduct();
                        }
                    } else {
                        if (this.notifMessage.length) this.documentLineErrorNotif('error');
                    }
                    this.calculateSummary();
                },

                //START OF Document Line TABLE
                mass_delete_line() {
                    var ids = this.selectedDocumentLines.map(({line_no}) => line_no)
                    console.log(ids)
                    ids.forEach(
                       line_no => this.delete_line(line_no)
                    );
                    this.calculateSummary();
                },
                async delete_line(line_no) {
                    // var data = this.tabulator.getData();
                    // var product_id = data.find(item => item.line_no == line_no).line_no
                    await this.tabulator.deleteRow(line_no);
                    this.recountLineNo();
                },
                recountLineNo(){
                    var data = this.tabulator.getData();
                    var lineCounter = 1
                    data.forEach( row => {
                        if (row.line_no == undefined){
                            row.line_no = lineCounter
                            lineCounter = lineCounter + 1
                        } else if (row.line_no != undefined && row.line_no > 0) {
                            if (row.parent_line_no === -1){
                                if (data.find(x => x.parent_line_no === row.line_no)) {
                                    data.find(x => x.parent_line_no === row.line_no).parent_line_no = lineCounter
                                }
                                row.line_no = lineCounter
                            }else{
                                row.line_no = lineCounter
                            }
                            lineCounter = lineCounter + 1
                        }
                    });
                    var negativeLineCounter = -1
                    data.forEach(function(row) {
                        if (row.line_no != undefined && row.line_no < 0) {
                            row.line_no = negativeLineCounter
                            negativeLineCounter = negativeLineCounter - 1
                        }
                    });
                    this.documentLen = data.length
                    this.tabulator.replaceData(data)
                },
                //END OF VUE ANT TABLE`

                async initializeFooterCalculation() {
                    var tQuantity = 0;
                    var itemsProcessed = 0;
                    var data = this.tabulator.getData();
                    data.forEach(function(element) {
                        //Total Quantity
                        if (element.line_no > 0){
                            if(component_x.currentDocumentTypeCode != 'OTHPCV'){
                                if(element.quantity) tQuantity = Number(tQuantity) + Number(element.quantity)
                            } else {
                                if(element.quantity) tQuantity = Number(tQuantity) + Number(Math.abs(element.variance_quantity))
                            }
                        }
                        itemsProcessed++;
                        if(itemsProcessed === data.length) {
                            setTimeout(() => {
                                component_x.calculateSummary();
                            }, 1000);
                        }
                    })
                    component_x.totalQuantity = tQuantity
                },
                calculateSummary(){
                    //Calculate Overall Discount
                    //this.calculateOverallDiscount();

                    var summaryResults = this.tabulator.getCalcResults();
                    //Calculates Quantity
                    if(component_x.currentDocumentTypeCode != 'OTHPCV'){
                        component_x.totalQuantity = summaryResults.bottom.quantity
                    }
                    component_x.grossAmount = summaryResults.bottom.total_gross
                   
                    if(!['BARTER TOOL', 'BARTER TOOL 3P', 'LIQUIDATION'].includes((this.documentDetails || {}).order_source)){
                        component_x.itemDiscount = this.toFixedNotRounded(Number(summaryResults.bottom.discount),this.decimalPlaces)
                    }
                    this.calculateOverallDiscount();

                    //Calcualates discount_amount
                    if(this.currentDocumentTypeCode == 'OTHLIQ_'){
                        var netAmount = (Number(summaryResults.bottom.total_gross) - Number(summaryResults.bottom.discount) - Number(summaryResults.bottom.trade_discount))
                    } else {
                        var netAmount = (Number(summaryResults.bottom.total_gross) - Number(summaryResults.bottom.discount) - Number(component_x.overallDiscount) - Number(summaryResults.bottom.trade_discount))
                    }
                   
                    if((!['BARTER TOOL', 'BARTER TOOL 3P', 'LIQUIDATION'].includes((this.documentDetails || {}).order_source) && !['OTHSIN', 'RECCSR'].includes(this.currentDocumentTypeCode)) || (['OTHSIN', 'RECCSR'].includes(this.currentDocumentTypeCode) && ['Saved'].includes(this.documentStatus)) || (['OTHSIN', 'RECCSR'].includes(this.currentDocumentTypeCode) && component_x.netAmount == 0)){
                            //if (netAmount <= 0) netAmount = 0
                            component_x.netAmount = netAmount.toFixed(this.decimalPlaces)

                            //Calculate Trade discount total amount
                            component_x.totalTradeDiscount = Number(summaryResults.bottom.trade_discount)

                            //Calculate Gross Amount Without Tax
                            component_x.grossAmountwithoutTax = Number(summaryResults.bottom.total_gross) / (1+Number(this.taxRate))

                            //Calculate Net Amount Without Tax
                            component_x.netAmountWithoutTax = component_x.netAmount / (1+Number(this.taxRate))
                            //Update grossAmount UI Display Data when Vat Exempt is Toggled on PO / RR
                            component_x.grossAmountDisplay = component_x.vatExclusiveCheckbox ? (Number(component_x.grossAmountwithoutTax)).toFixed(component_x.decimalPlaces) : Number(component_x.grossAmount).toFixed(component_x.decimalPlaces)
                            component_x.netAmountDisplay = component_x.vatExclusiveCheckbox ? Number(component_x.netAmountWithoutTax).toFixed(component_x.decimalPlaces) : Number(component_x.netAmount).toFixed(component_x.decimalPlaces)

                            //Calculate Vat Amount
                            component_x.vatAmount = (Number(component_x.netAmount) - Number(component_x.netAmountWithoutTax)).toFixed(component_x.decimalPlaces)
                            
                            //Set Total With Vat
                            component_x.totalWithVat = component_x.grossAmount.toFixed(this.decimalPlaces)
                        }
                    if (this.party_tax_type != "V" && this.party_tax_type != null && (this.docTypesForIM.includes(this.currentDocumentTypeCode) || this.docTypesForOM.includes(this.currentDocumentTypeCode) || this.currentDocumentTypeCode == 'OTHSBI')){
                        component_x.vatAmount = 0
                        component_x.grossAmountwithoutTax = Number(summaryResults.bottom.total_gross)
                        component_x.netAmountWithoutTax = Number(component_x.netAmount).toFixed(component_x.decimalPlaces)
                    } else if(this.party_tax_type == "V"){
                        component_x.netAmountWithoutTax = (Number(component_x.netAmount) - Number(component_x.vatAmount)).toFixed(component_x.decimalPlaces)
                    }

                    if (this.docTypesForIM.includes(this.currentDocumentTypeCode) || this.docTypesForOM.includes(this.currentDocumentTypeCode) || this.currentDocumentTypeCode == 'OTHSBI'){
                        var vat_type = (this.docTypesForIM.includes(this.currentDocumentTypeCode) ||  this.docTypesForOM.includes(this.currentDocumentTypeCode) || this.currentDocumentTypeCode == 'OTHSBI') ? this.party_tax_type : null
                        switch (vat_type) {
                        case "V":
                            this.vatableSalesAmount = this.netAmountWithoutTax || 0.00
                            this.vatExemptSalesAmount = 0.00
                            this.zeroRatedSalesAmount = 0.00
                        break;
                        case "X":
                            this.vatableSalesAmount = 0.00
                            this.vatExemptSalesAmount = this.netAmountWithoutTax || 0.00
                            this.zeroRatedSalesAmount = 0.00
                        break;
                        case "Z":
                            this.vatableSalesAmount = 0.00
                            this.vatExemptSalesAmount = 0.00
                            this.zeroRatedSalesAmount = this.netAmountWithoutTax || 0.00
                        break;
                        default:
                        break;
                    }
                }
            },

            //SUMARRY
            calculateOverallDiscount(){
                var notifMessage = [];
                // eslint-disable-next-line
                //var discountRegex = /(^[0-9]+$|^[0-9]+\%$)/;
                var discountRegex = /(^\d{0,10}(\.\d{1,4})? *%?$)/;
                //var lessDiscount = /^L[0-9]+$/;
                var lessDiscount = /^L[0-9]+(\.[0-9]{1,2})?$/;
                //var lessDiscount = /^L[0-9]+$/;
                var lessDiscount = /^L[0-9]+(\.[0-9]{1,2})?$/;
                
                if(this.headerDiscount.length > 0 && (!component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.termsAndDiscount || this.currentDocumentTypeCode == "ORISOX" || this.currentDocumentTypeCode == "OTHSIN" || this.currentDocumentTypeCode == "OTHSRQ" || this.currentDocumentTypeCode == "ORIOSO" || this.currentDocumentTypeCode == "OTHLIQ" || this.currentDocumentTypeCode == 'OTHSBI' || this.currentDocumentTypeCode == 'RECCSR')){
                    this.headerDiscount.forEach(function(row) {
                        var validation = false;
                        if (!discountRegex.test(row)) validation = true;
                        if (lessDiscount.test(row)) validation = false;
                        if (validation) notifMessage.push(row + ' discount input is invalid \n \r');
                    });

                    if (notifMessage.length == 0) {

                        var numberRegex = /^[0-9]+$/;
                        //var percentDiscount = /^[0-9]+\%$/;
                        var percentDiscount = /^[1][0][0]\.[0]{2}\%|[0-9]+\%|[1-9]?[0-9]\.[0-9]{1,4}\%$/;
                        var lessDiscountDecimal = /^\d{0,10}(\.\d{1,10})?$/;
                        
                        var beforeDiscount = Number(component_x.grossAmount) - Number(component_x.itemDiscount)
                        var overallDiscount = 0;
                        if (this.currentDocumentTypeCode == "ORISOX"){
                            component_x.reCalculateHeaderDiscount = true
                        }

                        if (this.currentDocumentTypeCode == "RECCSR" && this.documentStatus == 'Saved'){
                            component_x.reCalculateHeaderDiscount = false
                        }

                        if (component_x.originDocumentNumber > 0 && component_x.headerDiscount.length > 0 && !component_x.reCalculateHeaderDiscount) {
                            //Get origin amount header discount
                            if (this.currentDocumentTypeCode == "RECCSR"){
                                // Sample CM document: CM-UTCI-000000150
                                // Carry the ORIGIN (parent SI) invoice-discount RATE and
                                // recompute it on the CM's remaining line net, so a partial
                                // return recalculates the discount against what is actually
                                // left (e.g. 1,791.00 x 25% = 447.75) and reflects the
                                // parent's clean percentage instead of a drifted rate

                                // OLD (pro-rated the parent's PESO amount by gross ratio,
                                // var document_share_percent = Number(component_x.grossAmount) / Number(component_x.document_origin['amount_gross'])
                                // overallDiscount = Number(Number(component_x.document_origin['amount_header_discount']) * Number(document_share_percent)).toFixed(2)
                                
                                // NEW (recompute the parent's discount rate against the remaining line net)
                                var originDiscountPercentage = Number(component_x.document_origin['overall_discount_percentage']) || 0
                                overallDiscount = Number(Number(beforeDiscount) * originDiscountPercentage).toFixed(2)
                                if(Number(component_x.overallDiscount).toFixed(4) != Number(overallDiscount).toFixed(4)){
                                    this.isEditing = true
                                }
                                this.isHeaderDiscountDisabled = true
                            } else {
                                overallDiscount = beforeDiscount * Number(component_x.overallDiscountPercentage)
                            }
                            component_x.reCalculateHeaderDiscount = true
                        } else {
                            if (Number(component_x.overallDiscount) > 0 && this.currentDocumentTypeCode == "RECCSR" && (this.documentStatus == 'Posted' || this.documentStatus == 'Voided' || this.documentStatus == 'Confirmed')) {
                                overallDiscount = overallDiscount + Number(component_x.overallDiscount)
                            } else {
                                component_x.headerDiscount.forEach(function(row) {
                                    var discount;
                                    if (numberRegex.test(row)) {
                                        discount = row;
                                        beforeDiscount = (beforeDiscount - discount)
                                    } else if (lessDiscount.test(row)) {
                                        discount = row.slice(1)
                                        beforeDiscount = (beforeDiscount - discount)
                                    } else if (lessDiscountDecimal.test(row)) {
                                        discount = row
                                        beforeDiscount = (beforeDiscount - discount)
                                    } else if (percentDiscount.test(row)) {
                                        discount = row.slice(0,-1)
                                        discount = (beforeDiscount) * (discount / 100)
                                        beforeDiscount = (beforeDiscount - discount)
                                    }
                                    overallDiscount = overallDiscount + Number(discount)
                                });
                            }
                            
                        }
                        
                        if (overallDiscount <= 0) overallDiscount = 0
                        var totalDiscount = Number(overallDiscount) + Number(component_x.itemDiscount)
                        if (totalDiscount <= Number(component_x.grossAmount) || Number(component_x.grossAmount) == 0) {
                            if (this.accountName.toLowerCase().includes('piml')){
                                overallDiscount = overallDiscount.toFixed(2)
                            }
                            component_x.overallDiscount = this.toFixedNotRounded(overallDiscount,this.decimalPlaces)
                            component_x.overallDiscountWithoutSupportDiscount = Number(overallDiscount)
                        } else {
                            this.notifMessage = ['Discount total must not be greater than gross amount']
                            this.documentActionNotification('Overall discount', 'error')
                        }
                    } else {
                        this.notifMessage = notifMessage
                        this.documentActionNotification('Document line discount', 'error')
                    }
                }

                if(this.supportDiscount.length > 0 && !component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.termsAndDiscount){
                    this.supportDiscount.forEach(function(row) {
                        var validation = false;
                        if (!discountRegex.test(row)) validation = true;
                        if (lessDiscount.test(row)) validation = false;
                        if (validation) notifMessage.push(row + ' discount input is invalid \n \r');
                    });

                    if (notifMessage.length == 0) {

                        var numberRegex = /^[0-9]+$/;
                        //var percentDiscount = /^[0-9]+\%$/;
                        var percentDiscount = /^[1][0][0]\.[0]{2}\%|[0-9]+\%|[1-9]?[0-9]\.[0-9]{1,4}\%$/;
                        var lessDiscountDecimal = /^\d{0,10}(\.\d{1,10})?$/;

                        var beforeDiscount = Number(component_x.grossAmount) - Number(component_x.itemDiscount) - ((Number(component_x.overallDiscount) > 0) ? Number(component_x.overallDiscount) : 0)
                        var overallDiscount = (Number(component_x.overallDiscount) > 0) ? Number(component_x.overallDiscount) : 0;

                        component_x.supportDiscount.forEach(function(row) {
                            var discount;
                            if (numberRegex.test(row)) {
                                discount = row;
                                beforeDiscount = (beforeDiscount - discount)
                            } else if (lessDiscount.test(row)) {
                                discount = row.slice(1)
                                beforeDiscount = (beforeDiscount - discount)
                            } else if (lessDiscountDecimal.test(row)) {
                                discount = row
                                beforeDiscount = (beforeDiscount - discount)
                            } else if (percentDiscount.test(row)) {
                                discount = row.slice(0,-1)
                                discount = (beforeDiscount) * (discount / 100)
                                beforeDiscount = (beforeDiscount - discount)
                            }
                            overallDiscount = overallDiscount + Number(discount)
                        });

                        if (overallDiscount <= 0) overallDiscount = 0

                        var totalDiscount = Number(overallDiscount) + Number(component_x.itemDiscount)
                        if (totalDiscount <= Number(component_x.grossAmount) || Number(component_x.grossAmount) == 0) {
                            component_x.overallDiscount = this.toFixedNotRounded(overallDiscount,this.decimalPlaces)
                        } else {
                            this.notifMessage = ['Discount total must not be greater than gross amount']
                            this.documentActionNotification('Overall discount', 'error')
                        }
                    } else {
                        this.notifMessage = notifMessage
                        this.documentActionNotification('Document line discount', 'error')
                    }
                }
            },
            validateHeaderDiscountInput() {
                this.notifMessage = [];
                // validate headerDiscount, restrict user in inputting invalid discount
                this.headerDiscount = this.headerDiscount.filter(discount => {
                    discount = discount.replace('%', '');
                    if (isNaN(discount)) {
                        this.notifMessage.push(`Invalid header discount: "${discount}". Must be a numeric value.`);
                        this.documentActionNotification('Invalid discount', 'error');
                        return false; // filter out invalid discounts, display error message for each invalid discount
                    }
                    return true;
                });
            },
            onHeaderDiscountChange() {
                this.validateHeaderDiscountInput();
                this.isEditing = true
                var netAmount;
                var netAmountWithoutTax;
                if (component_x.headerDiscount.length != 0){
                    this.calculateOverallDiscount();
                    //Calcualates Net Amount
                    if(this.currentDocumentTypeCode == 'OTHLIQ'){
                        netAmount = (Number(component_x.grossAmount) - Number(component_x.itemDiscount))
                    } else {
                        netAmount = (Number(component_x.grossAmount) - Number(component_x.itemDiscount) - Number(component_x.overallDiscount))
                    }
                    if (netAmount <= 0) netAmount = 0
                    component_x.netAmount = netAmount.toFixed(this.decimalPlaces)
                    netAmountWithoutTax = (Number(component_x.netAmount) / (1+Number(this.taxRate)))
                    component_x.netAmountWithoutTax = netAmountWithoutTax.toFixed(this.decimalPlaces)
                    component_x.netAmountDisplay = component_x.netAmount
                    component_x.vatAmount = (Number(component_x.netAmount) - Number(component_x.netAmountWithoutTax)).toFixed(component_x.decimalPlaces)
                    this.onChangeOverallDiscount();
                } else {
                    component_x.overallDiscount = Number(0).toFixed(this.decimalPlaces)
                    this.calculateOverallDiscount();

                    //Calcualates Net Amount
                    if(this.currentDocumentTypeCode == 'OTHLIQ'){
                        netAmount = (Number(component_x.grossAmount) - Number(component_x.itemDiscount))
                    } else {
                        netAmount = (Number(component_x.grossAmount) - Number(component_x.itemDiscount) - Number(component_x.overallDiscount))
                    }
                    if (netAmount <= 0) netAmount = 0
                    component_x.netAmount = netAmount.toFixed(this.decimalPlaces)
                    netAmountWithoutTax = (Number(component_x.netAmount) / (1+Number(this.taxRate)))
                    component_x.netAmountWithoutTax = netAmountWithoutTax.toFixed(this.decimalPlaces)
                    component_x.netAmountDisplay = component_x.netAmount
                    component_x.vatAmount = (Number(component_x.netAmount) - Number(component_x.netAmountWithoutTax)).toFixed(component_x.decimalPlaces)
                }
                if (this.party_tax_type != "V" && this.party_tax_type != null && (this.docTypesForIM.includes(this.currentDocumentTypeCode) || this.docTypesForOM.includes(this.currentDocumentTypeCode) || this.currentDocumentTypeCode == 'OTHSBI')){
                    component_x.vatAmount = 0
                    component_x.netAmountWithoutTax = Number(netAmount).toFixed(component_x.decimalPlaces)
                }
                if (this.docTypesForIM.includes(this.currentDocumentTypeCode) || this.docTypesForOM.includes(this.currentDocumentTypeCode) || this.currentDocumentTypeCode == 'OTHSBI'){
                        var vat_type = (this.docTypesForIM.includes(this.currentDocumentTypeCode) ||  this.docTypesForOM.includes(this.currentDocumentTypeCode) || this.currentDocumentTypeCode == 'OTHSBI') ? this.party_tax_type : null
                        switch (vat_type) {
                        case "V":
                            this.vatableSalesAmount = this.netAmountWithoutTax || 0.00
                            this.vatExemptSalesAmount = 0.00
                            this.zeroRatedSalesAmount = 0.00
                        break;
                        case "X":
                            this.vatableSalesAmount = 0.00
                            this.vatExemptSalesAmount = this.netAmountWithoutTax || 0.00
                            this.zeroRatedSalesAmount = 0.00
                        break;
                        case "Z":
                            this.vatableSalesAmount = 0.00
                            this.vatExemptSalesAmount = 0.00
                            this.zeroRatedSalesAmount = this.netAmountWithoutTax || 0.00
                        break;
                        default:
                        break;
                    }
                }
                
            },
            onSupportDiscountChange () {
                this.isEditing = true
                if(['ORIPOX', 'OTHPUR', 'RELRSR', 'RECDEL'].includes(this.currentDocumentTypeCode)) {
                    
                    var netAmount;
                    var netAmountWithoutTax;
                    if (component_x.supportDiscount.length != 0){
                        this.calculateOverallDiscount();

                        //Calculates Net Amount
                        netAmount = (Number(component_x.grossAmount) - Number(component_x.itemDiscount) - Number(component_x.overallDiscount))
                        if (netAmount <= 0) netAmount = 0
                        component_x.netAmount = netAmount.toFixed(this.decimalPlaces)
                        netAmountWithoutTax = (Number(component_x.netAmount) / (1+Number(this.taxRate)))
                        component_x.netAmountWithoutTax = netAmountWithoutTax.toFixed(this.decimalPlaces)
                        component_x.netAmountDisplay = component_x.netAmount
                        component_x.vatAmount = (Number(component_x.netAmount) - Number(component_x.netAmountWithoutTax)).toFixed(component_x.decimalPlaces)
                    } else {
                        component_x.overallDiscount = Number(0).toFixed(this.decimalPlaces)
                        this.calculateOverallDiscount();

                        //Calculates Net Amount
                        netAmount = (Number(component_x.grossAmount) - Number(component_x.itemDiscount) - Number(component_x.overallDiscount))
                        if (netAmount <= 0) netAmount = 0
                        component_x.netAmount = netAmount.toFixed(this.decimalPlaces)
                        netAmountWithoutTax = (Number(component_x.netAmount) / (1+Number(this.taxRate)))
                        component_x.netAmountWithoutTax = netAmountWithoutTax.toFixed(this.decimalPlaces)
                        component_x.netAmountDisplay = component_x.netAmount
                        component_x.vatAmount = (Number(component_x.netAmount) - Number(component_x.netAmountWithoutTax)).toFixed(component_x.decimalPlaces)
                    }

                } else {
                    this.isSupportDiscountValid = false
                    var notifMessage = []
                    // eslint-disable-next-line
                    //var discountRegex = /(^L[0-9]+$|^[0-9]+$|^[0-9]+\%$)/;
                    var discountRegex = /(^\d{0,10}(\.\d{1,4})? *%?$)/;
                    //var lessDiscount = /^L[0-9]+$/;
                    var lessDiscount = /^L[0-9]+(\.[0-9]{1,2})?$/;
                    //var lessDiscount = /^L[0-9]+$/;
                    var lessDiscount = /^L[0-9]+(\.[0-9]{1,2})?$/;

                    this.supportDiscount.forEach(function(row) {
                        var validation = false;
                        if (!discountRegex.test(row)) validation = true;
                        if (lessDiscount.test(row)) validation = false;
                        if (validation) notifMessage.push(row + ' discount input is invalid \n \r');
                    });

                    if (notifMessage.length == 0) {
                        this.isSupportDiscountValid = true
                    } else {
                        this.notifMessage = notifMessage
                        this.documentActionNotification('Document line discount', 'error')
                    }
                }
            },
            toggleVatExclusive(e) {
                this.vatExclusiveCheckbox = e.target.checked
                this.calculateSummary();
                if (this.vatExclusiveCheckbox) {
                    if (this.unitCost) this.unitCost = (Number(this.unitCost) / (1+Number(this.taxRate))).toFixed(this.decimalPlaces)
                    if (this.unitNetCost) this.unitNetCost = (Number(this.unitNetCost) / (1+Number(this.taxRate))).toFixed(this.decimalPlaces)
                    if (this.subTotal) this.subTotal = (Number(this.subTotal) / (1+Number(this.taxRate))).toFixed(this.decimalPlaces)
                    this.grossAmountDisplay = Number(this.grossAmountwithoutTax).toFixed(this.decimalPlaces)
                    this.netAmountDisplay = Number(this.netAmountWithoutTax).toFixed(this.decimalPlaces)
                } else {
                    if (this.unitCost) this.unitCost = (Number(this.unitCost) * (1+Number(this.taxRate))).toFixed(this.decimalPlaces)
                    if (this.unitNetCost) this.unitNetCost = (Number(this.unitNetCost) * (1+Number(this.taxRate))).toFixed(this.decimalPlaces)
                    if (this.subTotal) this.subTotal = (Number(this.subTotal) * (1+Number(this.taxRate))).toFixed(this.decimalPlaces)
                    this.grossAmountDisplay = Number(this.grossAmount).toFixed(this.decimalPlaces)
                    this.netAmountDisplay = Number(this.netAmount).toFixed(this.decimalPlaces)
                }
            },
            // Advanced Info
            showAdvancedInfoDiv(){
                this.showAdvancedInfo ? this.showAdvancedInfo = false : this.showAdvancedInfo = true
            },
            async fetchWtaxes() {
                this.fetching = true
                this.wtaxCodes = await HTTPRequest.getRequest(this.endPoint + "accounts/wtax_codes" , null)
                this.fetching = false
            },
            async fetchPaymentTerms() {
                this.fetching = true
                this.paymentTerms = await HTTPRequest.getRequest(this.endPoint + 'payment_terms/get_valid_payment_terms', null)
                this.fetching = false
            },
            selectPaymentTerm (paymentTerm) {
                this.isEditing = true
                var arr = {
                    key:'',
                    label:''
                }
                if(paymentTerm != undefined){
                    arr = {
                        key:paymentTerm.key.replace('paymentTerms',''),
                        label:paymentTerm.label
                    }
                }
                paymentTerm = arr
                Object.assign(this, {
                    paymentTerm,
                    paymentTerms: [],
                    fetching: false,
                })
            },
            selectWtax (wTax) {
                this.isEditing = true
                var arr = {
                    key:'',
                    label:''
                }
                if(wTax != undefined){
                    var arr = {
                        key:wTax.key,
                        label:wTax.key
                    }
                }
                wTax = arr
                Object.assign(this, {
                    wTax,
                    wTaxes: [],
                    fetching: false,
                })
            },
            async fetchShippingMethods() {
                this.fetching = true
                let methods = await HTTPRequest.getRequest(this.endPoint + 'shipping_methods/get_valid_shipping_methods', null)

                //Apply only in PHRETAIL
                if (this.currentDocumentTypeCode === 'ORISOX' && !this.accountName.toLowerCase().includes('piml')) {
                    methods = methods.filter(m => 
                        (m.code === 'BOXMEEXPRESS' || m.name === 'BOXME EXPRESS') ||
                        (m.code === 'NOTVIABOXME' || m.name === 'NOT VIA BOXME')
                    )
                }

                this.shippingMethods = methods
                this.fetching = false
            },
            formatMyNumber(number, decimal) {
                if(isNaN(number)){
                    return '0.00'
                }
                var sign = (Math.sign(number) == -1) ? '-' : ''
                //var sign = ''
                var splitNum;
                number = Math.abs(number);
                number = number.toFixed(decimal);
                splitNum = number.split('.');
                splitNum[0] = splitNum[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                return sign+''+splitNum.join(".");
            },
            async enableAdditionalCharges(){
                // Arvin
                this.modalAdditionalCharges = true
                this.totalPurchaseVariance = 0
            },
            async applyAdditionalCharges(){
                this.spinMessage = 'Calculating Additional Charges for Viewing'
                this.spinning2 = true;
                //Get lines cost layer
                //Allocate Charges
                this.itemCostLayerData = []
                this.itemCostLayerData = await HTTPRequest.getRequest(this.endPoint + 'documents/get_document_cost_layer?document_id='+this.documentNumber + '&additionalCharges=' + this.totalPurchaseVariance + '&chargeDistributionQuantity=' + this.chargeDistributionQuantity,null)
                this.spinning2 = false;
            },
            async saveAdditionalCharges(){
                //Apply Charges
                this.applyAdditionalCharges();
                this.spinMessage = 'Saving Additional Charges'
                this.spinning2 = true;
                //Save Charges
                var additionalChargeDataPayLoad = {"additionalChargeData": this.additionalChargeData}
                var saveAdditionalCharges = await HTTPRequest.postRequest(this.endPoint + 'documents/save_additional_charges?document_id='+ this.documentNumber + '&chargeDistributionQuantity=' + this.chargeDistributionQuantity, null, additionalChargeDataPayLoad)

                if(saveAdditionalCharges["error"] == undefined){
                   //Update Cost Layer
                   var itemCostLayerData = {"itemCostLayerData" : this.itemCostLayerData}
                   var applyAdditionalChargesToCostLayer = await HTTPRequest.postRequest(this.endPoint + 'documents/apply_additional_charges_to_cost_layer?document_id='+ this.documentNumber, null, itemCostLayerData)
                   if(applyAdditionalChargesToCostLayer["error"] == undefined){
                        this.$emit('refreshPage', event)
                        this.openDocument(this.documentNumber,this.existingDocumentTypeDetails)
                        this.documentActionNotification('Applying Additional Charges', 'success')
                        this.create_action_history('Apply Additional Charges')
                        this.modalAdditionalCharges = false
                        this.itemCostLayerData = []
                        this.additionalChargeData = []
                   } else {
                        this.documentActionNotification(applyAdditionalChargesToCostLayer["error"], 'error')
                   }
                }
                this.spinning2 = false;
                this.disableSaveCharges = false;
            },
            selectShippingMethod (shippingMethod) {
                this.isEditing = true
                var arr = {
                    key:'',
                    label:''
                }
                if(shippingMethod != undefined){
                    arr = {
                        key:shippingMethod.key.replace('shippingMethods',''),
                        label:shippingMethod.label
                    }
                }
                shippingMethod = arr
                Object.assign(this, {
                    shippingMethod,
                    shippingMethods: [],
                    fetching: false,
                })
            },
            async fetchPurposes() {
                this.fetching = true
                if (this.documentStatus == 'Posted' || this.documentStatus == 'Voided' || this.documentStatus == 'Confirmed'){
                    this.purposes = await HTTPRequest.getRequest(this.endPoint + 'purposes/get_valid_purposes', null)
                } else {
                    this.purposes = await HTTPRequest.getRequest(this.endPoint + 'purposes/get_valid_purposes?document_type_id='+this.currentDocumentTypeId, null)
                }
                this.fetching = false
            },
            selectPurpose (purpose) {
              this.isEditing = true
              var arr = {
                    key:'',
                    label:''
                }
                if(purpose != undefined){
                    arr = {
                        key:purpose.key.replace('purposes',''),
                        label:purpose.label
                    }
                }
                purpose = arr
                Object.assign(this, {
                    purpose,
                    purposes: [],
                    fetching: false,
                })
            },
            closeChargeDrawer() {
            },
            showDrawer(action) {

                if (action == 'charges') {
                    this.chargeDrawerVisible = true;
                } else if (action == 'history') {
                    this.historyDrawerVisible = true;
                }
                // Validation for PURCHASE TO PAYMENT documents -> SUPPLIER is required
                   else if (action == 'massAdd') {

                    if( this.validationdocutypes.includes(this.currentDocumentTypeCode) && this.supplier.key === undefined  ) {
                        component_x.$notification['error']({
                            message: 'Supplier is required',
                            description: "Please select supplier.",
                            style: getNotificationStyle('error')
                        });
                    }else if(!["ORISOX","RECADJ","RELADJ","OTHPCN","RELCSI","RELSLO","RECCSI","OTHSRQ"].includes(this.currentDocumentTypeCode) && (this.brand.key === undefined || this.brand.key == null || this.brand.key <= 0 || this.brand.key == "")){
                        component_x.$notification['error']({
                            message: 'Brand is required',
                            description: "Please select Brand.",
                            style: getNotificationStyle('error')
                        });
                    }else if(["ORISOX","OTHSRQ"].includes(this.currentDocumentTypeCode) && (this.b2bCustomer == undefined || this.b2bCustomer == null || this.b2bCustomer <= 0 || this.b2bCustomer == "")){
                    }else if(["ORISOX","OTHSRQ"].includes(this.currentDocumentTypeCode) && (this.b2bCustomer == undefined || this.b2bCustomer == null || this.b2bCustomer <= 0 || this.b2bCustomer == "")){
                        component_x.$notification['error']({
                            message: 'Customer is required',
                            description: "Please select Customer.",
                            style: getNotificationStyle('error')
                        });
                    } else {
                        this.massAddDrawerVisible = true;
                        this.massAddDrawerKey++
                    }

                } else if (action == 'references') {
                    this.referenceDrawerVisible = true;
                } else if (action == 'extras') {
                    this.extrasDrawerVisible = true;
                } else if (action == 'document_image') {
                    this.documentImageDrawerVisible = true;
                }else if (action == "massAddWithAllocation"){
                    this.massAddWithAllocationDrawerVisible = true;
                }else if (action == "massAddWithHeader"){
                    this.massAddWithHeaderDrawerVisible = true;
                }else if (action == "view_allocation"){
                    this.viewSiteAllocation()
                }
                this.massAddProductErrors = [];
                this.massAddProductErrorsDL = [];
                this.dlDUplicateSkus = 0;
                this.dlSkusNotFound =  0;
            },
            closeDrawer(action) {
                if (action == 'charges'){
                    this.clearChargeFormDrawer();
                    this.selectChargeType();
                    this.chargeDrawerVisible = false;
                } else if (action == 'history'){
                    this.historyDrawerVisible = false;
                } else if (action == 'payments'){
                    this.paymentDrawerVisible = false;
                } else if (action == 'booking'){
                    this.bookingDrawerVisible = false;
                } else if (action == 'massAdd'){
                    this.massAddDrawerVisible = false;
                } else if (action == 'massAddWithHeader'){
                    this.massAddWithHeaderDrawerVisible = false;
                } else if (action == 'references'){
                    this.referenceDrawerVisible = false;
                } else if (action == 'extras'){
                    this.extrasDrawerVisible = false;
                } else if (action == 'document_image'){
                    this.documentImageDrawerVisible = false;
                } else if (action == 'serialization'){
                  let drawerSnapshot = this.currentDocumentTypeCode.includes("REL") ? this.currentDrawerSerials.filter(({checked}) => checked) : this.currentDrawerSerialsInstance;
                  this.tabulator.updateData([{product_id: this.selectedSerialProduct.product_id, quantity: drawerSnapshot.length, document_line_serials: drawerSnapshot }])
                  this.calculateSummary();
                  this.serializationVisible = false;
                } else if (action == 'document_payments'){
                    this.documentPaymentsDrawerVisible = false;
                } else if (action == 'sublocationAllocation'){
                    this.sublocationAllocationVisible = false;
                    this.drawerCurrentSublocationAllocation = []
                    this.drawerSublocation = {key: 0, label: "Please select a sublocation"}
                    this.drawerSublocationQuantity = ''
                    this.sublocationAllocationErrors = [];
                } else if (action == 'siteAllocation'){
                    this.siteAllocationVisible = false;
                    this.drawerCurrentSiteAllocation = []
                    this.drawerSite = {key: 0, label: "Please select a site"}
                    this.drawerSiteQuantity = ''
                    this.siteAllocationErrors = [];
                    this.isEditAllocation=false
                    this.isEditAllocationIndex=0
                    this.siteAllocationRemainingQuantity = null
                } else if (action == "ecomForm"){
                    this.documentEcomDrawerVisible = false
                } else if(action == "initialDeposit"){
                    this.initialDepositDrawerVisible = false
                }else if (action == "massAddWithAllocation"){
                    this.massAddWithAllocationDrawerVisible = false
                }else if (action == "massAddWithHeader"){
                    this.massAddWithHeaderDrawerVisible = false
                }else if (action == "view_allocation"){
                    this.viewAllocation = false
                }else if (action == "lotCodeExpiry"){
                    this.inputExpiryAt = undefined
                    this.inputLotCode = ''
                    this.lotCodeExpiryVisible = false
                }
            },
            ecomCloseDrawer(){
                this.closeDrawer("ecomForm")
            },
            selectChargeType () {
                this.isChargeWeightDisabled = (this.chargeType == 'W') ?  false : true
                this.isChargeRateDisabled = (this.chargeType == 'W') ? false : true
                this.isChargeAmountDisabled = (this.chargeType == 'W') ? true : false
                this.chargeWeight = 0
                this.chargeRate = 0
                this.chargeAmount = 0
            },
            mass_delete_charge() {
                if (this.documentStatus == 'Posted'){
                    const newData = [...this.additionalChargeData]
                    var ids = this.additionalChargeSelectedRowKeys
                    var afterDelete = _.remove(newData, function(n) {
                        return !ids.includes(n.line_no);
                    });
                    this.additionalChargeData = afterDelete
                    this.chargeSelectedRowKeys = []
                } else {
                    const newData = [...this.chargeData]
                    var ids = this.chargeSelectedRowKeys
                    var afterDelete = _.remove(newData, function(n) {
                        return !ids.includes(n.line_no);
                    });
                    this.chargeData = afterDelete
                    this.chargeSelectedRowKeys = []
                }
                this.totalCharge();
            },
            validateCharge(){
                this.notifMessage = [];
                this.notifMessage.push(ValidateField.required('Description', this.chargeDescription));
                this.notifMessage.push(ValidateField.decimalFormat('Weight', this.chargeWeight));
                this.notifMessage.push(ValidateField.decimalFormat('Rate', this.chargeRate));
                this.notifMessage.push(ValidateField.decimalFormat('Amount', this.chargeAmount));
                this.notifMessage.push(ValidateField.lessThanZero('Weight', this.chargeWeight, 'Weight is required'));
                this.notifMessage.push(ValidateField.lessThanZero('Rate', this.chargeRate, 'Rate is required'));
                this.notifMessage.push(ValidateField.lessThanZero('Amount', this.chargeAmount, 'Amount is Required'));
                this.notifMessage = this._.compact(this.notifMessage);
                return this.notifMessage.length;
            },
            totalCharge() {
                let i = 0;
                this.totalCharges = 0
                this.totalVatCharges = 0
                this.totalPurchaseVariance = 0
                while (i < this.chargeData.length) {
                    this.totalCharges =  Number(this.totalCharges) + Number(this.chargeData[i]['amount']);
                    this.totalVatCharges =  Number(this.totalVatCharges) + Number(this.chargeData[i]['vat_amount']);
                    i++;
                }
                i = 0;
                while (i < this.additionalChargeData.length) {
                        this.totalPurchaseVariance =  Number(this.totalPurchaseVariance) + Number(this.additionalChargeData[i]['amount']);
                    i++;
                }  
            },
            clearChargeFormDrawer() {
                this.chargeDescription = null
                this.chargeType = 'R'
                this.chargeWeight = 0
                this.chargeRate = 0
                this.chargeAmount = 0
            },
            addCharge: async function() {
                if(!this.validateCharge()) {
                    var charges = this.chargeData.map(a => a.line_no);
                    var additional_charges = this.additionalChargeData.map(a => a.line_no);
                    if (charges.length == 0) charges = [0]
                    if (additional_charges.length == 0) additional_charges = [0]
                    if (this.documentStatus == 'Posted'){
                        this.additionalChargeData.push({
                            line_no: Math.max(...additional_charges) + 1,
                            name: this.chargeDescription,
                            remark: this.chargeType,
                            weight: this.chargeWeight,
                            rate: this.chargeRate,
                            amount: this.chargeAmount,
                            charge_type: 'A'
                        })
                    } else {
                        this.chargeData.push({
                            line_no: Math.max(...charges) + 1,
                            name: this.chargeDescription,
                            remark: this.chargeType,
                            weight: this.chargeWeight,
                            rate: this.chargeRate,
                            amount: this.chargeAmount,
                            charge_type: 'I'
                        })
                    }

                    this.totalCharge();
                    this.clearChargeFormDrawer();
                    this.closeDrawer('charges');
                    this.documentActionNotification('add charge', 'success')
                } else {
                    this.documentActionNotification('add charge', 'error')
                }
            },
            calculateChargeAmount () {
                this.notifMessage = [];
                this.notifMessage.push(ValidateField.decimalFormat('Weight', this.chargeWeight));
                this.notifMessage.push(ValidateField.decimalFormat('Rate', this.chargeRate));
                this.notifMessage = this._.compact(this.notifMessage);
                if (this.notifMessage.length == 0) {
                    this.chargeAmount = Number(this.chargeWeight * this.chargeRate * (1+Number(this.taxRate))).toFixed(this.decimalPlaces)
                }
            },

            // Footer Document Actions
            documentActionNotification(action, type) {
                if (type == 'success') {
                    // For document-level actions (save, update, confirm, void, post),
                    // include CAS # (cas_no) and Document Number (document_no) so the
                    // user knows exactly which document the message refers to.
                    var documentActions = ['save', 'update', 'confirm', 'void', 'post'];
                    var successNotification = {
                        message: _.startCase(action) + ' action success',
                        style: getNotificationStyle(type)
                    };
                    if (documentActions.includes(String(action).toLowerCase())) {
                        var casNoText = this.casNo ? this.casNo : (this.documentDetails && this.documentDetails.cas_no ? this.documentDetails.cas_no : '');
                        var documentNoText = this.documentNo ? this.documentNo : (this.friendlyCodeAndDocumentNo ? this.friendlyCodeAndDocumentNo : '');
                        // Only attach the CAS # / Document Number details when there is data to show.
                        // For newly created documents with no data, the message stays as is.
                        if (casNoText || documentNoText) {
                            // eslint-disable-next-line
                            successNotification.description = h => {
                                return <ul class='m-0 p-0'>
                                    {casNoText ? <li>CAS #: {casNoText}</li> : null}
                                    {documentNoText ? <li>Document Number: {documentNoText}</li> : null}
                                </ul>
                            };
                        }
                    }
                    this.$notification[type](successNotification);
                } else if (type == 'error' || type == 'info') {
                    // Snapshot the messages at creation time. The description below is a
                    // render function that Ant re-evaluates; if it referenced the reactive
                    // this.notifMessage directly, later mutations (clear/push on the next
                    // "Add Document Line" attempt) would retro-actively overwrite the text of
                    // toasts that are still on screen, making every toast show the same product.
                    var messages = Array.isArray(this.notifMessage) ? this.notifMessage.slice() : [];
                    this.$notification[type]({
                        // Reuse a single key per type so a new notification replaces the
                        // previous one instead of stacking a tower of identical toasts.
                        key: 'document-action-' + type,
                        message: (type == 'error') ? _.startCase(action) + ' action failed' : _.startCase(action),
                        // eslint-disable-next-line
                        description: h => {
                            return <ul class='m-0 p-0'>
                                {messages.map((value, index) => {
                                    return <li key={index}>{value}</li>
                                })}
                            </ul>
                        },
                        style: getNotificationStyle(type)
                    });
                }
            },
            validateForm(){
                this.notifMessage = [];
                var data = this.tabulator.getData()
                //For Interbranch Documents
                if (['ORITRQ','OROTRQ','RECTRX','RELTRX','ORICSQ','OROCSQ','RECCSX','RELCSX'].includes(this.currentDocumentTypeCode)){
                    this.notifMessage.push(ValidateField.required('Supplying Site', this.supplyingSite.key, 'Please select a valid Supplying Site'));
                    this.notifMessage.push(ValidateField.required('Requesting Site', this.requestingSite.key, 'Please select a valid Requesting Site'));
                    this.notifMessage.push(ValidateField.identicalField('Supplying Site', 'Requesting Site', this.supplyingSite.key, this.requestingSite.key));
                }
                //For Purchase Documents
                if (['OTHPUR','ORIPOX','RECDEL','RELRSR'].includes(this.currentDocumentTypeCode)){
                    this.notifMessage.push(ValidateField.required('Supplier', this.supplier.key));
                }

                //For Local Documents
                if(['RECADJ','RELADJ'].includes(this.currentDocumentTypeCode)){
                    this.notifMessage.push(ValidateField.required('Purpose', this.purpose.key));
                    this.notifMessage.push(ValidateField.required('Party', this.party));
                }

                //For Transfer Allocation
                if(['OTHTRA'].includes(this.currentDocumentTypeCode) && this.processingXlsxUpload != true){
                    this.notifMessage.push(ValidateField.required('Supplying Site', this.supplyingSite.key));
                    data.forEach( line => {
                        if (line.site_allocation == undefined || line.site_allocation == []){
                            this.notifMessage.push(`Product ${line.product_name} has no site allocation`);
                        }
                    })
                }
                //For Distribution Documents
                if(['RECSLI','RELSLO'].includes(this.currentDocumentTypeCode)){
                    if (this.originSublocation.key == undefined){
                        this.notifMessage.push(ValidateField.required('Sublocation Origin', this.originSublocation.key));
                    }
                    if (this.destinationSublocation.key == undefined){
                        this.notifMessage.push(ValidateField.required('Sublocation Destination', this.destinationSublocation.key));
                    }
                    if (this.destinationSublocation.key != undefined && this.originSublocation.key != undefined){
                        this.notifMessage.push(ValidateField.identicalField('Sublocation Origin', 'Sublocation Destination', this.originSublocation.key, this.destinationSublocation.key));
                    }

                }

                //For Orisox Documents
                if (['ORISOX', 'ORIOSO'].includes(this.currentDocumentTypeCode)) {
                    if (!this.isOrderSourceMode) {
                        this.notifMessage.push(ValidateField.required('Sublocation Destination', this.destinationSublocation.key));
                    } else {
                        this.notifMessage.push(ValidateField.required('Order Source', this.orderSource));
                    }

                    var invalid = data.find(row => row.quantity == 0);
                    if (invalid !== undefined) {
                        this.notifMessage.push("Zero quantity is not allowed in the document line");
                    }
                }

                //For RelDde Documents
                if(['RELDDE'].includes(this.currentDocumentTypeCode)){
                    this.notifMessage.push(ValidateField.required('Customer', this.customer.key));

                    if (this.isOrderSourceMode){
                        this.notifMessage.push(ValidateField.required('Order Source', this.orderSource));
                    }else{
                        this.notifMessage.push(ValidateField.required('Sublocation Origin', this.originSublocation.key));
                    }

                    //when goods issue
                    if (this.documentNumber > 0) {
                        var invalid = data.find(row => (row.goods_issue_quantity == 0 && Number(row.ordered_quantity) > 0))
                        if (invalid != undefined){
                            this.notifMessage.push("Zero goods issue quantity is not allowed in the document line");
                        }
                    } else {
                        //when open delivery
                        var any = data.find(row => (row.quantity > 0 && Number(row.ordered_quantity) > 0))
                        if (any == undefined){
                            this.notifMessage.push("Atleast one line of delivery quantity should be filled");
                        }
                    }
                }
                if(['RECCSR', 'ORIOCR'].includes(this.currentDocumentTypeCode)){
                    //Validate each line
                    this.notifMessage.push(ValidateField.required('Customer', this.b2bCustomer));
                    this.notifMessage.push(ValidateField.required('Site', this.distributionSite.key));
                    if(!component_x.openCSR && !component_x.openOCR && this.originDocumentNumber > 0){
                        data.forEach(row => {
                            this.notifMessage.push(ValidateField.isGreaterThan(`${row.product_name}`, parseInt(row.quantity),  parseInt(row.goods_issue_quantity)+1, `${row.product_name} quantity is more than the goods issued quantity.`))
                        });
                    }
                }

                this.notifMessage.push(ValidateField.required('Document Date', this.documentDate));
                this.notifMessage.push(ValidateField.required('Target Date', this.targetDate));
                this.notifMessage.push(ValidateField.required('Cancellation Date', this.cancellationDate));
                if (this.supportDiscount) this.notifMessage.push(ValidateField.validateBoolean('Support Discount', this.isSupportDiscountValid));
                this.notifMessage.push(ValidateField.charMinAndMax("Remark",this.remark,0,this.fieldMaxLength));
                this.notifMessage.push(ValidateField.charMinAndMax(this.referenceLabel,this.reference,0,this.fieldMaxLength));

                if(this.isHeaderOnly != true && this.processingCsvUpload != true && this.processingXlsxUpload != true){
                    this.notifMessage.push(ValidateField.isEmpty('Document Line', data));
                }
                this.notifMessage.push(ValidateField.isDuplicate('Document Line', data))
                // Validate Release and Receive Documents
                if(/^RE(C|L)/.test(this.currentDocumentTypeCode)){
                    //Validate serial numbers matching the quantity
                    let serial_products = []
                    serial_products = data.filter(row => row.product_type === 'S')
                    if(serial_products.length > 0 && this.documentNumber > 0) {
                        serial_products.forEach(row => {
                            this.notifMessage.push(ValidateField.matchData('Quantity', row.quantity, row.document_line_serials.length, `Insufficient Serial Number provided for product in line number: ${row.line_no}. It must match quantity`));
                        })
                    } 
                    var data = this.tabulator.getData()
                    let require_lotcode_products = []
                    require_lotcode_products = data.filter(row => (row.is_require_lotcode != undefined && row.is_require_lotcode === true))
                    if(require_lotcode_products.length > 0) {
                        require_lotcode_products.forEach(row => {
                            if(row.document_line_locations == undefined){
                                row.document_line_locations = []
                            }
                            var contentqty = ((row.product_type == 'P' && this.currentDocumentTypeCode.includes('REL')) ? row.content_quantity : 1)
                            var lineqty = (row.document_line_locations.length > 0) ? row.document_line_locations.map(lineloc => lineloc.quantity).reduce((sumqty, qty) => Number(qty) + Number(sumqty)) : 0;
                            this.notifMessage.push(ValidateField.matchData('Quantity', (row.quantity * contentqty), lineqty, `Insufficient Lot Codes provided for product in line number: ${row.line_no}. It must match quantity`));
                        })
                    }
                }
                this.notifMessage = this._.compact(this.notifMessage);
                return this.notifMessage.length;
            },

            async save(){
                this.notifMessage = [];
                //Validation for 0 quantity documents except PCount
                if(this.currentDocumentTypeCode != 'OTHPCN' && this.currentDocumentTypeCode != 'OTHPWS' && this.totalQuantity == 0 && this.CsvUploadParams['csv_lines'] === undefined){
                    this.notifMessage.push("Unable to SAVE document with zero quantity.")
                    this.documentActionNotification('save', 'error');
                    return false;
                }
                if(["ORISOX","OTHSRQ"].includes(this.currentDocumentTypeCode) && (this.b2bCustomer == undefined || this.b2bCustomer == null || this.b2bCustomer <= 0 || this.b2bCustomer == "")){
                    this.notifMessage.push("Customer is required. Please select Customer.")
                    this.documentActionNotification('save', 'error');
                    return false;
                }

                if (["OTHSRQ"].includes(this.currentDocumentTypeCode) && this.accountName.toLowerCase().includes('piml') && !this.yearSeason) {
                    this.notifMessage.push("Year Season is required!");
                    this.documentActionNotification('save', 'error');
                    return false;
                }

                if (["OTHSRQ"].includes(this.currentDocumentTypeCode) && this.accountName.toLowerCase().includes('piml') && !this.fiscalYear) {
                    this.notifMessage.push("Fiscal Year is required!");
                    this.documentActionNotification('save', 'error');
                    return false;
                }

                // const hasValidationError = await this.validateBrandAssortment();
                // if (hasValidationError) {
                //     this.spinning = false;
                //     return false;
                // }

                if(['OTHSBI'].includes(this.currentDocumentTypeCode) && this.continueWithPriceDiscrepancy == false) {
                    // var data = this.tabulator.getData();
                    // var notEqual = data.find(row => Number(row.price) != Number(row.price_pi))
                    // if (notEqual != undefined){
                    //     this.$confirm({
                    //     title: 'Proceed?',
                    //     content: h => <div>There are lines where Cost and PI Price is not equal</div>,
                    //     onOk: () => {
                    //         this.continueWithPriceDiscrepancy = true
                    //         this.save()
                    //     },
                    //     onCancel() {}
                    //     });
                    // }else {
                        this.continueWithPriceDiscrepancy = true
                        this.save()
                   // }
                } else {
                    this.isChangeAction = true;
                    window.scrollTo(0,0);
                    this.disableActions();
                    if(!this.validateForm()) {
                        // this.calculateSummary();

                        //To get document type and trans code
                        var document_type_code = '';
                        var document_trans_code = '';
                        var document_party_type = '';
                        var document_type_trans_code = await HTTPRequest.getRequest(component_x.endPoint + "document_types?table_prefix=inventory&id="+this.currentDocumentTypeId, null);
                        if (document_type_trans_code.find(x => x.id === this.currentDocumentTypeId)) {
                            document_type_code = document_type_trans_code.find(x => x.id === this.currentDocumentTypeId).type_code
                            document_trans_code = document_type_trans_code.find(x => x.id === this.currentDocumentTypeId).trans_code
                            document_party_type = document_type_trans_code.find(x => x.id === this.currentDocumentTypeId).party_type
                        }

                        if(this.processingCsvUpload || this.isUploaded ){
                            this.isUploaded = true
                        }

                        var party_id = -1
                        if ((document_trans_code == 'REL' && document_type_code == 'TRX') || (document_trans_code == 'REL' && document_type_code == 'CSX') || (document_trans_code == 'REC' && document_type_code == 'ADJ') || (document_trans_code == 'REL' && document_type_code == 'ADJ')){
                             // Save the current_site.id info in party_id
                             party_id = this.requestingSite.key
                        }
                        else if ((document_trans_code == 'ORI' && document_type_code == 'TRQ') || (document_trans_code == 'ORI' && document_type_code == 'CSQ' )){
                            party_id = this.supplyingSite.key
                        }

                        var site_id = secureStorage.getItem("defaultSiteId");
                        if ((document_trans_code == 'REC' && document_type_code == 'SLI')  || (document_trans_code == 'REL' && document_type_code == 'SLO') || (document_trans_code == 'ORI' && document_type_code == 'SOX') || (document_trans_code == 'ORI' && document_type_code == 'OSO') || (document_trans_code == 'REL' && document_type_code == 'DDE' || (document_trans_code == 'OTH' && document_type_code == 'SIN') || (document_trans_code == 'REC' && document_type_code == 'CSR') || (document_trans_code == 'REL' && document_type_code == 'CSI') || (document_trans_code == 'REC' && document_type_code == 'OCR') || (document_trans_code == 'REC' && document_type_code == 'CSI'))){
                            site_id = this.distributionSite.key
                        }
                        if ((document_trans_code == 'REL' && document_type_code == 'TRX') || (document_trans_code == 'REL' && document_type_code == 'CSX') || (document_trans_code == 'ORO' && document_type_code == 'TRQ' ) || (document_trans_code == 'ORO' && document_type_code == 'CSQ' ) || (document_trans_code == 'OTH' && document_type_code == 'TRX' )){
                            site_id = this.supplyingSite.key
                        }

                        if ((document_trans_code == 'REC' && document_type_code == 'TRX') || (document_trans_code == 'REC' && document_type_code == 'CSX') || (document_trans_code == 'ORI' && document_type_code == 'TRQ' ) || (document_trans_code == 'ORI' && document_type_code == 'CSQ' ) || (document_trans_code == 'ORI' && document_type_code == 'POX') || (document_trans_code == 'OTH' && document_type_code == 'PUR') || (document_trans_code == 'REC' && document_type_code == 'ADJ') || (document_trans_code == 'REL' && document_type_code == 'ADJ') || (document_trans_code == 'ORI' && document_type_code == 'ASN') || (document_trans_code == 'REC' && document_type_code == 'DEL') || (document_trans_code == 'REL' && document_type_code == 'RSR')){
                            if(document_party_type == "Supplier"){
                                // Save the supplier info in party_id
                                party_id = this.supplier.key
                            
                                // Save the supplier info in party_name
                                this.party =  this.supplier.label
                            }
                           
                           site_id = this.requestingSite.key
                        }
                        if ((document_trans_code == 'OTH' && document_type_code == 'PWS')){
                            site_id = this.forThisSite.key
                        }

                        if(this.currentDocumentTypeCode=="RELRSR" && secureStorage.getItem("currentSiteSiteType") != 'ho'){
                            site_id = secureStorage.getItem("defaultSiteId");
                        } 
                        // else {
                        //     site_id = this.requestingSite.key;
                        // }

                        var origin_document_id = -1
                        if (this.originDocumentNumber > 0) {
                            origin_document_id = this.originDocumentNumber
                        }

                        var order_status = 'U'
                        if((document_trans_code == 'REL' && document_type_code == 'DDE') || (document_trans_code == 'REC' && document_type_code == 'CSR') || (document_trans_code == 'REC' && document_type_code == 'OCR')){
                            origin_document_id = this.$route.params.sales_order_id || this.originDocumentNumber
                            order_status = 'O'
                        }  else if(document_trans_code == 'REC' && document_type_code == 'CSI'){
                            origin_document_id = this.$route.params.concession_return_order_id || this.originDocumentNumber
                            order_status = 'O'
                        } else if(document_trans_code == 'OTH' && document_type_code == 'SIN'){
                            origin_document_id = this.$route.params.delivery_document_id || this.originDocumentNumber
                            order_status = 'G'
                        } else if(document_trans_code == 'OTH' && document_type_code == 'SBI'){
                            origin_document_id = this.$route.params.receiving_report_id
                        } else if(document_trans_code == 'OTH' && document_type_code == 'TRA'){
                            origin_document_id = this.$route.params.transfer_allocation_id || -1
                        } else if(document_trans_code == 'OTH' && document_type_code == 'BAR'){
                            origin_document_id = this.$route.params.barcode_printing_id
                        }else if(document_trans_code == 'ORO' && document_type_code == 'RSO'){
                            origin_document_id = this.$route.params.sales_order_id
                            if(this.documentExtras!= null){
                                this.documentExtras['revenue'] = this.revenue
                            }else{
                                this.documentExtras = {revenue:this.revenue}
                            }
                        }

                        var data = this.tabulator.getData();
                        if (this.document_config) {
                            if (this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.automaticPostingOnSave == true) {
                                data.forEach(row => {row.goods_issue_quantity = row.delivery_quantity;});
                            }
                        }


                        var line_type = 'document_lines'
                        if ((document_trans_code == 'OTH' && document_type_code == 'PWS')){
                            line_type = 'pricecost_lines'
                        }else if((document_trans_code == 'OTH' && document_type_code == 'CNS')){
                            line_type = 'countset_lines'
                        }
                        //HERE
                        var company = null
                        if (this.currentDocumentTypeCode == 'ORIOSO' || this.currentDocumentTypeCode=='ORISOX' || this.currentDocumentTypeCode=='OTHSRQ' || this.currentDocumentTypeCode=='RELCSI'){
                            company = this.companyOwnerId
                        }else {
                            company = this.company_id
                        }
                        if (company == null || company == undefined || company <=0){
                            var siteDetails = await HTTPRequest.getRequest(this.endPoint + "sites/"+ site_id, null);
                            company = siteDetails.company_id
                        }

                        //Populate B2B customer for OTHPUR
                        if(this.currentDocumentTypeCode == 'OTHPUR'){
                            var siteDetails = await HTTPRequest.getRequest(this.endPoint + "sites/"+site_id, null);
                            company = siteDetails.company_id
                            //Get company details
                            var company_details = await HTTPRequest.getRequest(this.endPoint + '/companies/'+company, null);
                            this.b2bCustomer = company_details['b2b_customer_id']
                            this.selectedCustomerType = 'b2b'
                        }

                        var brand_id = null
                        if(this.brand.key != null && this.brand.key != ""  && this.brand.key != []){
                            brand_id = this.brand.key
                        }
                        if (this.party_tax_type == null || this.party_tax_type == ''){
                            this.party_tax_type = 'V'
                        }
                        //Populate site_concept_id
                        var siteDetails = await HTTPRequest.getRequest(this.endPoint + "sites/"+site_id, null);

                        var documentPayload = {
                            document: {
                                site_id: site_id,
                                site_concept_id: siteDetails.site_concept_id,
                                document_type_id: this.currentDocumentTypeId,
                                document_type_code: document_type_code,
                                document_trans_code: document_trans_code,
                                document_date : this.documentDate,
                                party_id: party_id,
                                target_date : this.targetDate,
                                cancellation_date : this.cancellationDate,
                                discount_text : this.headerDiscount.join(),
                                remark : this.remark,
                                image_ref_link : this.imageReferenceLink,
                                order_type : this.orderType,
                                country_id : this.countryOfOrigin.key,
                                company_id : company,
                                fiscal_year : this.fiscalYear,
                                year_season : this.yearSeason,
                                no_of_cartons : this.noOfCartons,
                                oc_ref_no : this.ocReferenceNo,
                                shipment_ref_no : this.shipmentReferenceNo,
                                source_site_id : this.supplyingSite.key,
                                target_site_id : this.requestingSite.key,
                                reference_1 :  this.reference,
                                reference_2 : this.reference1,
                                payment_term_id : this.paymentTerm.key,
                                document_no: 0, //TEST ONLY,
                                [line_type]: data,
                                document_charges: this.chargeData,
                                shipping_method_id : this.shippingMethod.key,
                                support_discount_text: this.supportDiscount.join(),
                                amount_gross:this.grossAmount,
                                amount_header_discount: this.overallDiscount,
                                overall_discount_percentage:this.overallDiscountPercentage,
                                amount_net: this.netAmount,
                                tax_amount: this.vatAmount,
                                tax_exempt_amount: this.netAmountWithoutTax,
                                tax_rate: this.taxRate,
                                amount_line_discount: this.itemDiscount,
                                gross_amount_without_tax: this.grossAmountwithoutTax,
                                net_amount_without_tax: this.netAmountWithoutTax,
                                party_name: this.party,
                                purpose_id : this.purpose.key,
                                supplier_id: this.supplier.key,
                                origin_sublocation_id: this.originSublocation.key,
                                target_sublocation_id: this.destinationSublocation.key,
                                customer_id: this.customer.key,
                                b2b_customer_id: this.resolveB2bCustomerId(),
                                customer_type: this.selectedCustomerType,
                                salesman_id: this.salesman.key,
                                salesman_name: this.salesman.label,
                                origin_document_id: origin_document_id,
                                order_status: order_status,
                                order_source: this.orderSource,
                                total_quantity: this.totalQuantity,
                                is_header_only: this.isHeaderOnly,
                                is_trade: this.isDocumentTrade,
                                ui_currency_id: this.currency.key,
                                sublocation_id: this.siteSublocation.key,
                                extras:this.documentExtras,
                                revenue_site_id:this.revenueSiteId,
                                currency_id:this.currencyId || this.currency.key,
                                party_tax_type: this.party_tax_type,
                                wtax_code:this.wTax.key,
                                is_uploaded: this.isUploaded,
                                brand_id: brand_id,
                                country: this.country,
                                province: this.province,
                                address: this.address,
                                city: this.city,
                                barangay: this.barangay,
                                price_type: this.productPriceChoice,
                            }
                        }

                        documentPayload.document.customer_id = this.selectedCustomerType === 'customer' ? this.customer.key : null;
                        documentPayload.document.b2b_customer_id = this.selectedCustomerType === 'b2b' ? this.b2bCustomer : null;
                        documentPayload.document.customer_type = this.selectedCustomerType;

                        documentPayload.document.currency_rate = this.currencyRate!=undefined && this.currencyRate!=0 ? this.currencyRate : (this.defaultCurrencyRate!=undefined && this.defaultCurrencyRate!=0) ?this.defaultCurrencyRate : this.currencyRate
                        try {
                            if(this.documentDetails.address_id!=undefined){
                                documentPayload.document.address_id = this.documentDetails.address_id
                            } 
                        } catch (error) {}

                        // Process references
                        var documentReferences = this.document_config.document_type_settings.references;
                        for(var i=0; i < documentReferences.length; i++){
                            var reference = documentReferences[i]
                            if(_.isUndefined(reference.input)){
                                //console.log("skip")
                            }else{
                                documentPayload.document["reference_" + (i + 1).toString()] = reference.input
                            }
                        }

                        //console.log("===============");
                        //console.log(documentPayload);
                        var post_request = await HTTPRequest.postRequest(this.endPoint + 'documents', null, documentPayload)
                        if (post_request == undefined) {
                                if (this.processingCsvUpload == true) {
                                    let url = `${this.endPoint}document_lines/mass_add_products?document_id=${post_request.id}`;
                                    if (document_trans_code == 'OTH' && document_type_code == 'PWS') {
                                        url = `${this.endPoint}pricecost_lines/import_pricecost_lines?document_id=${post_request.id}&save_via=${this.saveMassUploadProductVia}`;
                                    }

                                    //var job = await HTTPRequest.postRequest(url, null, this.CsvUploadParams);
                                    var config = {
                                        method: 'post',
                                        url: url,
                                        headers: {'Authorization': 'Bearer ' + secureStorage.getItem("accessToken"), 'Request-Source':"BXI-File", 'ip':secureStorage.getItem("ipAddress")},
                                        data: this.CsvUploadParams
                                    }
                                    var job;
                                    await axios(config)
                                        .then(function (response) {
                                            job = response.data
                                        })
                                        .catch(function (error) {
                                            console.log(error)
                                    });

                                    if (job.id > 1) {
                                        component_x.$notification['success']({
                                            message: 'Successful Operation',
                                            description: "CSV File has been uploaded. Your importation is ongoing, you can check the ongoing jobs for updates.",
                                            style: getNotificationStyle('success'),
                                            btn: h => {
                                                return h(
                                                'base-button',
                                                {
                                                    props: {
                                                    type: 'primary',
                                                    class: 'btn-sm',
                                                    },
                                                    on: {
                                                    click: () => component_x.$router.push("/jobs"),
                                                    },
                                                },
                                                'View Jobs',
                                                );
                                            },
                                        });
                                        this.$router.replace(this.backLink)
                                    } else {
                                        this.documentActionNotification('CSV Upload', 'error');
                                    }
                                } else if (this.processingXlsxUpload == true){
                                    let url = `${this.endPoint}document_lines/mass_add_products_with_allocation?document_id=${post_request.id}`;
                                    var job = await HTTPRequest.postRequest(url, null, this.xlsxUploadFormData);
                                    if (job.id > 1) {
                                        component_x.$notification['success']({
                                            message: 'Successful Operation',
                                            description: "XLSX File has been uploaded. Your importation is ongoing, you can check the ongoing jobs for updates.",
                                            style: getNotificationStyle('success'),
                                            btn: h => {
                                                return h(
                                                'base-button',
                                                {
                                                    props: {
                                                    type: 'primary',
                                                    class: 'btn-sm',
                                                    },
                                                    on: {
                                                    click: () => component_x.$router.push("/jobs"),
                                                    },
                                                },
                                                'View Jobs',
                                                );
                                            },
                                        });
                                        this.$router.replace(this.backLink)
                                    } else {
                                        this.documentActionNotification('XLSX Upload', 'error');
                                    }
                                } else {
                                    this.documentNumber = post_request.id
                                    // Set CAS # and Document Number from the save response so the
                                    // success message shows the correct values immediately
                                    // (openDocument runs asynchronously and may not have resolved yet).
                                    if (post_request.cas_no != undefined) { this.casNo = post_request.cas_no }
                                    if (post_request.document_no != undefined) { this.documentNo = post_request.document_no }
                                    this.openDocument(post_request.id,component_x.existingDocumentTypeDetails)
                                    this.documentActionNotification('save', 'success')
                                    this.create_action_history('CREATED')
                                }
                        } else {
                            if (post_request["error"] == undefined) {
                                if((['ORISOX','OTHSRQ','RELDDE','OTHSIN','ORIOSO'].includes(this.currentDocumentTypeCode)) && (this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.automaticPostingOnSave == true) && (post_request.id > 0)){
                                    this.documentNumber = post_request.id
                                    this.post();
                                } else {
                                    //this.$router.replace('/documents')
                                    if (this.processingCsvUpload == true) {
                                        let url = `${this.endPoint}document_lines/mass_add_products?document_id=${post_request.id}`;
                                        if (document_trans_code == 'OTH' && document_type_code == 'PWS') {
                                            url = `${this.endPoint}pricecost_lines/import_pricecost_lines?document_id=${post_request.id}&save_via=${this.saveMassUploadProductVia}`;
                                        }

                                        //var job = await HTTPRequest.postRequest(url, null, this.CsvUploadParams);
                                        var config = {
                                        method: 'post',
                                        url: url,
                                        headers: {'Authorization': 'Bearer ' + secureStorage.getItem("accessToken"), 'Request-Source':"BXI-File", 'ip':secureStorage.getItem("ipAddress")},
                                        data: this.CsvUploadParams
                                        }
                                        var job;
                                        await axios(config)
                                            .then(function (response) {
                                                job = response.data
                                            })
                                            .catch(function (error) {
                                                console.log(error)
                                        });

                                        if (job.id > 1) {
                                            component_x.$notification['success']({
                                                message: 'Successful Operation',
                                                description: "CSV File has been uploaded. Your importation is ongoing, you can check the ongoing jobs for updates.",
                                                style: getNotificationStyle('success'),
                                                btn: h => {
                                                    return h(
                                                    'base-button',
                                                    {
                                                        props: {
                                                        type: 'primary',
                                                        class: 'btn-sm',
                                                        },
                                                        on: {
                                                        click: () => component_x.$router.push("/jobs"),
                                                        },
                                                    },
                                                    'View Jobs',
                                                    );
                                                },
                                            });
                                        this.$router.replace(this.backLink)
                                        } else {
                                            this.documentActionNotification('CSV Upload', 'error');
                                        }
                                    } else if (this.processingXlsxUpload == true){
                                        let url = `${this.endPoint}document_lines/mass_add_products_with_allocation?document_id=${post_request.id}`;
                                        var job = await HTTPRequest.postRequest(url, null, this.xlsxUploadFormData);
                                        if (job.id > 1) {
                                            component_x.$notification['success']({
                                                message: 'Successful Operation',
                                                description: "XLSX File has been uploaded. Your importation is ongoing, you can check the ongoing jobs for updates.",
                                                style: getNotificationStyle('success'),
                                                btn: h => {
                                                    return h(
                                                    'base-button',
                                                    {
                                                        props: {
                                                        type: 'primary',
                                                        class: 'btn-sm',
                                                        },
                                                        on: {
                                                        click: () => component_x.$router.push("/jobs"),
                                                        },
                                                    },
                                                    'View Jobs',
                                                    );
                                                },
                                            });
                                            this.$router.replace(this.backLink)
                                        } else {
                                            this.documentActionNotification('XLSX Upload', 'error');
                                        }
                                    } else {
                                        this.documentNumber = post_request.id
                                        // Set CAS # and Document Number from the save response so the
                                        // success message shows the correct values immediately
                                        // (openDocument runs asynchronously and may not have resolved yet).
                                        if (post_request.cas_no != undefined) { this.casNo = post_request.cas_no }
                                        if (post_request.document_no != undefined) { this.documentNo = post_request.document_no }
                                        this.openDocument(post_request.id,component_x.existingDocumentTypeDetails)
                                        this.documentActionNotification('save', 'success')
                                        this.create_action_history('CREATED')
                                    }
                                }
                            } else {
                                this.notifMessage = post_request["error"].split(",")
                                this.documentActionNotification('save', 'error')
                            }
                        }
                    } else {
                        this.documentActionNotification('save', 'error')
                    }
                    this.spinning = false;
                    this.enableActions();
                }
            },
            async validateBrandAssortment() {
                if (!['RELTRX', 'RECTRX'].includes(this.currentDocumentTypeCode)) return false;
                let hasError = false;
                const brandLabel = this.brand && this.brand.label ? this.brand.label : "document";

                if (this.supplyingSite && this.supplyingSite.key) {
                    const checkSupplyingSite = await HTTPRequest.getRequest(`${this.endPoint}sites/check_brand_assortment_for_site?brand_id=${this.brand.key}&site_id=${this.supplyingSite.key}`, null);

                    if (checkSupplyingSite && checkSupplyingSite.error) {
                        component_x.$notification.error({
                            message: 'Brand Assortment Error',
                            description: `No Site Brand Access. Select valid Supplying Site for ${brandLabel}`,
                            style: getNotificationStyle('error')
                        });

                        this.supplyingSite = {};
                        this.originSublocation = {};
                        this.populateAddress('supplyingSite', null);
                        hasError = true;
                    }
                }

                if (this.requestingSite && this.requestingSite.key) {
                    const checkRequestingSite = await HTTPRequest.getRequest(`${this.endPoint}sites/check_brand_assortment_for_site?brand_id=${this.brand.key}&site_id=${this.requestingSite.key}`, null);

                    if (checkRequestingSite && checkRequestingSite.error) {
                        component_x.$notification.error({
                            message: 'Brand Assortment Error',
                            description: `No Site Brand Access. Select valid Requesting Site for ${brandLabel}`,
                            style: getNotificationStyle('error')
                        });

                        this.requestingSite = {};
                        this.isRequestingSiteDisabled = false
                        this.populateAddress('requestingSite', null);
                        hasError = true;
                    }
                }

                return hasError;
            },
            async update() {
                //Validation for 0 quantity documents except PCount
                if(this.currentDocumentTypeCode != 'OTHPCN' && this.currentDocumentTypeCode != 'OTHPWS' && this.currentDocumentTypeCode != 'RECTRX' && this.totalQuantity == 0 && this.CsvUploadParams['csv_lines'] === undefined){
                    this.notifMessage.push("Unable to UPDATE document with zero quantity.")
                    this.documentActionNotification('update', 'error');
                    return false;
                }
                if(["ORISOX","OTHSRQ"].includes(this.currentDocumentTypeCode) && (this.b2bCustomer == undefined || this.b2bCustomer == null || this.b2bCustomer <= 0 || this.b2bCustomer == "")){
                    this.notifMessage.push("Customer is required. Please select Customer.")
                    this.documentActionNotification('update', 'error');
                    return false;
                }

                if (["OTHSRQ"].includes(this.currentDocumentTypeCode) && this.accountName.toLowerCase().includes('piml') && !this.yearSeason) {
                    this.notifMessage.push("Year Season is required!");
                    this.documentActionNotification('update', 'error');
                    return false;
                }

                if (["OTHSRQ"].includes(this.currentDocumentTypeCode) && this.accountName.toLowerCase().includes('piml') && !this.fiscalYear) {
                    this.notifMessage.push("Fiscal Year is required!");
                    this.documentActionNotification('update', 'error');
                    return false;
                }

                // const hasValidationError = await this.validateBrandAssortment();
                // if (hasValidationError) return;

                if(['OTHSBI'].includes(this.currentDocumentTypeCode) && this.continueWithPriceDiscrepancy == false) {
                    var data = this.tabulator.getData();
                    var notEqual = data.find(row => Number(row.price) != Number(row.price_pi))
                    if (notEqual != undefined){
                        this.$confirm({
                        title: 'Proceed?',
                        content: h => <div>There are lines where Cost and PI Price is not equal</div>,
                        onOk: () => {
                            this.continueWithPriceDiscrepancy = true
                            this.update()
                        },
                        onCancel() {}
                        });
                    }else {
                        this.continueWithPriceDiscrepancy = true
                        this.update()
                    }
                } else {
                    this.disableActions();
                    this.isChangeAction = true;
                    window.scrollTo(0,0);
                    this.spinning = true;
                    if(!this.validateForm()) {
                        if (this.orderSource=="shopify" || this.orderSource=="lazada" || this.orderSource=="shopee"|| this.orderSource=="zalora"){
                        }else{
                            this.calculateSummary();
                        }

                        //To get document type and trans code
                        var document_type_code = '';
                        var document_trans_code = '';
                        var document_party_type = '';
                        var document_type_trans_code = await HTTPRequest.getRequest(component_x.endPoint + "document_types?table_prefix=inventory&id="+this.currentDocumentTypeId, null);
                        if (document_type_trans_code.find(x => x.id === this.currentDocumentTypeId)) {
                            document_type_code = document_type_trans_code.find(x => x.id === this.currentDocumentTypeId).type_code
                            document_trans_code = document_type_trans_code.find(x => x.id === this.currentDocumentTypeId).trans_code
                            document_party_type = document_type_trans_code.find(x => x.id === this.currentDocumentTypeId).party_type
                        }

                        if(this.processingCsvUpload){
                          let is_uploaded = this.processingCsvUpload
                        }

                        var party_id = -1
                        if ((document_trans_code == 'REL' && document_type_code == 'TRX') || (document_trans_code == 'REL' && document_type_code == 'CSX')){
                            party_id = this.requestingSite.key
                        }
                        else if ((document_trans_code == 'ORI' && document_type_code == 'TRQ') || (document_trans_code == 'ORI' && document_type_code == 'CSQ' )){
                            party_id = this.supplyingSite.key
                        }
                        var site_id = this.documentCurrentSite || secureStorage.getItem("defaultSiteId");
                        if ((document_trans_code == 'REC' && document_type_code == 'SLI')  || (document_trans_code == 'REL' && document_type_code == 'SLO') || (document_trans_code == 'ORI' && document_type_code == 'SOX') || (document_trans_code == 'ORI' && document_type_code == 'OSO') || (document_trans_code == 'REL' && document_type_code == 'DDE' || (document_trans_code == 'OTH' && document_type_code == 'SIN') || (document_trans_code == 'REC' && document_type_code == 'CSR') || (document_trans_code == 'REL' && document_type_code == 'CSI') || (document_trans_code == 'REC' && document_type_code == 'OCR') || (document_trans_code == 'REC' && document_type_code == 'CSI'))){
                            site_id = this.distributionSite.key
                        }
                        if ((document_trans_code == 'REL' && document_type_code == 'TRX') || (document_trans_code == 'REL' && document_type_code == 'CSX') ||  (document_trans_code == 'ORO' && document_type_code == 'TRQ' ) || (document_trans_code == 'ORO' && document_type_code == 'CSQ' ) || (document_trans_code == 'OTH' && document_type_code == 'TRX' )){
                            site_id = this.supplyingSite.key
                        }

                        if ((document_trans_code == 'REC' && document_type_code == 'TRX') || (document_trans_code == 'REC' && document_type_code == 'CSX') || (document_trans_code == 'ORI' && document_type_code == 'TRQ' ) || (document_trans_code == 'ORI' && document_type_code == 'CSQ' ) || (document_trans_code == 'ORI' && document_type_code == 'POX') || (document_trans_code == 'OTH' && document_type_code == 'PUR') ||(document_trans_code == 'ORI' && document_type_code == 'ASN') || (document_trans_code == 'REL' && document_type_code == 'ADJ') || (document_trans_code == 'REC' && document_type_code == 'ADJ') || (document_trans_code == 'REC' && document_type_code == 'DEL') || (document_trans_code == 'REL' && document_type_code == 'RSR') || (document_trans_code == 'OTH' && document_type_code == 'PCV')){
                           
                            if(document_party_type == "Supplier"){
                                // Save the supplier info in party_id
                                party_id = this.supplier.key
                            
                                // Save the supplier info in party_name
                                this.party =  this.supplier.label
                            }
                           
                           site_id = this.requestingSite.key
                        }
                        
                        if ((document_trans_code == 'OTH' && document_type_code == 'PWS') || (document_trans_code == 'ORO' && document_type_code == 'RSO')){
                            site_id = this.forThisSite.key
                        }

                        if(this.currentDocumentTypeCode=="RELRSR" && secureStorage.getItem("currentSiteSiteType") != 'ho'){
                            site_id = secureStorage.getItem("defaultSiteId");
                        } 
                        // else {
                        //     site_id = this.requestingSite.key;
                        // }

                        var origin_document_id = -1
                        if (this.originDocumentNumber > 0) {
                            origin_document_id =  this.originDocumentNumber
                        }
                        var order_status = 'U'
                        if((document_trans_code == 'REL' && document_type_code == 'DDE') || (document_trans_code == 'OTH' && document_type_code == 'SIN') || (document_trans_code == 'REC' && document_type_code == 'CSR') || (document_trans_code == 'REC' && document_type_code == 'OCR')){
                            origin_document_id = this.$route.params.sales_order_id || this.originDocumentNumber
                            order_status = 'O'
                        } else if(document_trans_code == 'REC' && document_type_code == 'CSI'){
                            origin_document_id = this.$route.params.concession_return_order_id || this.originDocumentNumber
                            order_status = 'O'
                        } else if(document_trans_code == 'OTH' && document_type_code == 'SIN'){
                            origin_document_id = this.$route.params.delivery_document_id || this.originDocumentNumber
                            order_status = 'G'
                        } else if(document_trans_code == 'OTH' && document_type_code == 'SBI'){
                            origin_document_id = this.$route.params.receiving_report_id
                        } else if(document_trans_code == 'OTH' && document_type_code == 'TRA'){
                            origin_document_id = this.$route.params.transfer_allocation_id
                        } else if(document_trans_code == 'ORO' && document_type_code == 'RSO'){
                            origin_document_id = this.$route.params.sales_order_id
                            if(this.documentExtras!= null){
                                this.documentExtras['revenue'] = this.revenue
                            }else{
                                this.documentExtras = {revenue:this.revenue}
                            }
                        } else if(document_trans_code == 'OTH' && document_type_code == 'PCN'){
                            if(component_x.documentOrderStatus == 'Frozen')
                                order_status = 'F'
                        }

                        var line_type = 'document_lines'
                        if ((document_trans_code == 'OTH' && document_type_code == 'PWS')){
                            line_type = 'pricecost_lines'
                        }else if((document_trans_code == 'OTH' && document_type_code == 'CNS')){
                            line_type = 'countset_lines'
                        }
                        this.updateValueOfSupplierCurrency();

                        var data = this.tabulator.getData();
                        var company = null
                        if (this.currentDocumentTypeCode == 'ORIOSO' || this.currentDocumentTypeCode=='ORISOX' || this.currentDocumentTypeCode=='OTHSRQ' || this.currentDocumentTypeCode=='RELCSI' || this.currentDocumentTypeCode=='OTHSBI'){
                            company = this.companyOwnerId
                        }else {
                            company = this.company_id
                        }
                        if (company == null || company == undefined || company <=0){
                            var siteDetails = await HTTPRequest.getRequest(this.endPoint + "sites/"+ site_id, null);
                            company = siteDetails.company_id
                        }

                        //Populate B2B customer for OTHPUR
                        if(this.currentDocumentTypeCode == 'OTHPUR'){
                            var siteDetails = await HTTPRequest.getRequest(this.endPoint + "sites/"+site_id, null);
                            company = siteDetails.company_id
                            //Get company details
                            var company_details = await HTTPRequest.getRequest(this.endPoint + '/companies/'+company, null);
                            this.b2bCustomer = company_details['b2b_customer_id']
                            this.selectedCustomerType = 'b2b'
                        }

                        var brand_id = null
                        if(this.brand.key != null && this.brand.key != ""  && this.brand.key != []){
                            brand_id = this.brand.key
                        }
                        if (this.party_tax_type == null || this.party_tax_type == ''){
                            this.party_tax_type = 'V'
                        }

                        //Populate site_concept_id
                        var siteDetails = await HTTPRequest.getRequest(this.endPoint + "sites/"+site_id, null);

                        var documentPayload = {
                            document: {
                                site_id: site_id,
                                site_concept_id: siteDetails.site_concept_id,
                                document_type_id: this.currentDocumentTypeId,
                                document_type_code: document_type_code,
                                document_trans_code: document_trans_code,
                                document_date : this.documentDate,
                                party_id: party_id,
                                target_date : this.targetDate,
                                cancellation_date : this.cancellationDate,
                                discount_text : this.headerDiscount.join(),
                                remark : this.remark,
                                image_ref_link : this.imageReferenceLink,
                                order_type : this.orderType,
                                country_id : this.countryOfOrigin.key,
                                company_id: company,
                                fiscal_year : this.fiscalYear,
                                year_season : this.yearSeason,
                                no_of_cartons : this.noOfCartons,
                                oc_ref_no : this.ocReferenceNo,
                                shipment_ref_no : this.shipmentReferenceNo,
                                source_site_id : this.supplyingSite.key,
                                target_site_id : this.requestingSite.key,
                                reference_1 :  this.reference,
                                reference_2 : this.reference1,
                                payment_term_id : this.paymentTerm.key,
                                [line_type]: data,
                                document_charges: this.chargeData,
                                shipping_method_id : this.shippingMethod.key,
                                support_discount_text: this.supportDiscount.join(),
                                amount_gross: this.grossAmount,
                                amount_header_discount: this.overallDiscount,
                                overall_discount_percentage:this.overallDiscountPercentage,
                                amount_net: this.netAmount,
                                tax_amount: this.vatAmount,
                                tax_exempt_amount: this.netAmountWithoutTax,
                                tax_rate: this.taxRate,
                                amount_line_discount: this.itemDiscount,
                                gross_amount_without_tax: this.grossAmountwithoutTax,
                                net_amount_without_tax: this.netAmountWithoutTax,
                                party_name: this.party,
                                purpose_id : this.purpose.key,
                                supplier_id: this.supplier.key,
                                origin_sublocation_id: this.originSublocation.key,
                                target_sublocation_id: this.destinationSublocation.key,
                                customer_id: this.customer.key,
                                b2b_customer_id: this.resolveB2bCustomerId(),
                                customer_type: this.selectedCustomerType,
                                salesman_id: this.salesman.key,
                                salesman_name: this.salesman.label,
                                origin_document_id: origin_document_id,
                                order_status: order_status,
                                order_source: this.orderSource,
                                total_quantity: this.totalQuantity,
                                is_header_only: this.isHeaderOnly,
                                is_trade: this.isDocumentTrade,
                                ui_currency_id: this.currency.key,
                                sublocation_id: this.siteSublocation.key,
                                extras:this.documentExtras,
                                revenue_site_id:this.revenueSiteId,
                                currency_id:this.currencyId || this.currency.key,
                                party_tax_type: this.party_tax_type,
                                wtax_code:this.wTax.key,
                                is_uploaded: this.isUploaded,
                                brand_id: brand_id,
                                country: this.country,
                                province: this.province,
                                address: this.address,
                                city: this.city,
                                barangay: this.barangay,
                                price_type: this.productPriceChoice,
                            }
                        }
                        documentPayload.document.customer_id = this.selectedCustomerType === 'customer' ? this.customer.key : null;
                        documentPayload.document.b2b_customer_id = this.selectedCustomerType === 'b2b' ? this.b2bCustomer : null;
                        documentPayload.document.customer_type = this.selectedCustomerType;

                        documentPayload.document.currency_rate = (this.currencyRate!=undefined && this.currencyRate!=0) ? this.currencyRate : (this.defaultCurrencyRate!=undefined && this.defaultCurrencyRate!=0) ? this.defaultCurrencyRate : this.currencyRate

                        // Process references
                        var documentReferences = this.document_config.document_type_settings.references;
                        for(var i=0; i < documentReferences.length; i++){
                            var reference = documentReferences[i]
                            if(_.isUndefined(reference.input)){
                                //console.log("skip")
                            }else{
                                if(this.reference != '' && i == 0){
                                    documentPayload.document["reference_1"] = this.reference
                                } else {
                                    documentPayload.document["reference_" + (i + 1).toString()] = reference.input
                                }
                            }
                        }

                        var put_request = await HTTPRequest.putRequest(this.endPoint + 'documents/'+this.documentNumber, null, documentPayload)
                        if(put_request == undefined){
                                if (this.processingCsvUpload == true) {
                                    let url = `${this.endPoint}document_lines/mass_add_products?document_id=${this.documentNumber}`;
                                    if (document_trans_code == 'OTH' && document_type_code == 'PWS') {
                                        url = `${this.endPoint}pricecost_lines/import_pricecost_lines?document_id=${this.documentNumber}&save_via=${this.saveMassUploadProductVia}`;
                                    }

                                    //var job = await HTTPRequest.postRequest(url, null, this.CsvUploadParams);
                                    var config = {
                                        method: 'post',
                                        url: url,
                                        headers: {'Authorization': 'Bearer ' + secureStorage.getItem("accessToken"), 'Request-Source':"BXI-File", 'ip':secureStorage.getItem("ipAddress")},
                                        data: this.CsvUploadParams
                                    }
                                    var job;
                                    await axios(config)
                                        .then(function (response) {
                                            job = response.data
                                        })
                                        .catch(function (error) {
                                            console.log(error)
                                    });
        
                                    if (job.id > 1) {
                                        component_x.$notification['success']({
                                            message: 'Successful Operation',
                                            description: "CSV File has been uploaded. Your importation is ongoing, you can check the ongoing jobs for updates.",
                                            style: getNotificationStyle('success'),
                                            btn: h => {
                                                return h(
                                                'base-button',
                                                {
                                                    props: {
                                                    type: 'primary',
                                                    class: 'btn-sm',
                                                    },
                                                    on: {
                                                    click: () => component_x.$router.push("/jobs"),
                                                    },
                                                },
                                                'View Jobs',
                                                );
                                            },
                                        });
                                        this.$router.replace(this.backLink)
                                    } else {
                                        this.documentActionNotification('CSV Upload', 'error');
                                    }
                                } else if (this.processingXlsxUpload == true){
                                    let url = `${this.endPoint}document_lines/mass_add_products_with_allocation?document_id=${this.documentNumber}`;
                                    var job = await HTTPRequest.postRequest(url, null, this.xlsxUploadFormData);
                                    if (job.id > 1) {
                                        component_x.$notification['success']({
                                            message: 'Successful Operation',
                                            description: "XLSX File has been uploaded. Your importation is ongoing, you can check the ongoing jobs for updates.",
                                            style: getNotificationStyle('success'),
                                            btn: h => {
                                                return h(
                                                'base-button',
                                                {
                                                    props: {
                                                    type: 'primary',
                                                    class: 'btn-sm',
                                                    },
                                                    on: {
                                                    click: () => component_x.$router.push("/jobs"),
                                                    },
                                                },
                                                'View Jobs',
                                                );
                                            },
                                        });
                                        this.$router.replace(this.backLink)
                                    } else {
                                        this.documentActionNotification('XLSX Upload', 'error');
                                    }
                                } else {
                                    this.$emit('refreshPage', event)
                                    this.documentActionNotification('update', 'success')
                                    this.create_action_history('UPDATED')
                                }
                        } else {
                            if(put_request["error"] == undefined){
                                if (this.processingCsvUpload == true) {
                                    let url = `${this.endPoint}document_lines/mass_add_products?document_id=${this.documentNumber}`;
                                    if (document_trans_code == 'OTH' && document_type_code == 'PWS') {
                                        url = `${this.endPoint}pricecost_lines/import_pricecost_lines?document_id=${this.documentNumber}&save_via=${this.saveMassUploadProductVia}`;
                                    }

                                    //var job = await HTTPRequest.postRequest(url, null, this.CsvUploadParams);
                                    var config = {
                                        method: 'post',
                                        url: url,
                                        headers: {'Authorization': 'Bearer ' + secureStorage.getItem("accessToken"), 'Request-Source':"BXI-File", 'ip':secureStorage.getItem("ipAddress")},
                                        data: this.CsvUploadParams
                                    }
                                    var job;
                                    await axios(config)
                                        .then(function (response) {
                                            job = response.data
                                        })
                                        .catch(function (error) {
                                            console.log(error)
                                    });

                                    if (job.id > 1) {
                                        component_x.$notification['success']({
                                            message: 'Successful Operation',
                                            duration: 0,
                                            description: "CSV File has been uploaded. Your importation is ongoing, you can check the ongoing jobs for updates.",
                                            btn: h => {
                                                return h(
                                                'base-button',
                                                {
                                                    props: {
                                                    type: 'primary',
                                                    class: 'btn-sm',
                                                    },
                                                    on: {
                                                    click: () => component_x.$router.push("/jobs"),
                                                    },
                                                },
                                                'View Jobs',
                                                );
                                            },
                                        });
                                        this.$router.replace(this.backLink)
                                    } else {
                                        this.documentActionNotification('CSV Upload', 'error');
                                    }
                                } else if (this.processingXlsxUpload == true){
                                    let url = `${this.endPoint}document_lines/mass_add_products_with_allocation?document_id=${this.documentNumber}`;
                                    var job = await HTTPRequest.postRequest(url, null, this.xlsxUploadFormData);
                                    if (job.id > 1) {
                                        component_x.$notification['success']({
                                            message: 'Successful Operation',
                                            description: "XLSX File has been uploaded. Your importation is ongoing, you can check the ongoing jobs for updates.",
                                            style: getNotificationStyle('success'),
                                            btn: h => {
                                                return h(
                                                'base-button',
                                                {
                                                    props: {
                                                    type: 'primary',
                                                    class: 'btn-sm',
                                                    },
                                                    on: {
                                                    click: () => component_x.$router.push("/jobs"),
                                                    },
                                                },
                                                'View Jobs',
                                                );
                                            },
                                        });
                                        this.$router.replace(this.backLink)
                                    } else {
                                        this.documentActionNotification('XLSX Upload', 'error');
                                    }
                                } else {
                                    this.openDocument(this.documentNumber,this.existingDocumentTypeDetails)
                                    this.documentActionNotification('update', 'success')
                                    this.create_action_history('UPDATED')
                                }
                            } else {
                                this.notifMessage = put_request["error"].split(",");
                                this.documentActionNotification('update', 'error')
                            }
                        }
                    } else {
                        this.documentActionNotification('update', 'error')
                    }
                    this.spinning = false;
                    this.enableActions();
                }
            },
            async payLater(){
                 window.scrollTo(0,0);
                    this.spinning = true;
                    this.notifMessage = [];
                    var data = this.tabulator.getData();

                    if(["ORISOX","OTHSRQ","ORIOSO"].includes(this.currentDocumentTypeCode)){
                        if(this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.autoCreatePostDD){
                            this.autoPostDD = true;
                        }else if (this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.autoCreatePostDDAndSI){
                            this.autoPostDDAndSI = true;
                        }
                    } 
                    //For RelDde Documents
                    if(['RELDDE'].includes(this.currentDocumentTypeCode)){
                        if (this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.automaticPostingOnSave != true) {
                            //when goods issue
                            if (this.documentNumber > 0) {
                                var invalid = data.find(row => row.goods_issue_quantity == 0 && Number(row.ordered_quantity) > 0)
                                if (invalid != undefined){
                                    this.notifMessage.push("Zero goods issue quantity is not allowed in the document line");
                                    this.documentActionNotification('post', 'error');
                                    this.spinning = false;
                                    return;
                                }
                            }
                        }
                    }

                    if (data.length > 0) {
                        this.isEditing = !(component_x.origData === JSON.stringify(data))
                    }

                    if(this.documentStatus == "Confirmed" && this.isEditing){
                        this.isChangeAction = true;
                    }

                    if (this.isEditing && !this.isChangeAction) {
                        this.notifMessage.push("You have unsaved changes, please save before posting")
                        this.documentActionNotification('post', 'error');
                        this.spinning = false;
                        return;
                    } else {
                        if (component_x.documentNumber > 0) {
                            var params = (this.autoPostDD) ? "&auto_post_dd=true" : (this.autoPostDDAndSI) ? "&auto_post_dd_and_si=true" : ""
                            var post_request = await HTTPRequest.postRequest(this.endPoint + 'documents/post/?document_id='+component_x.documentNumber+''+params, null)
                            if (post_request['success']){
                                this.openDocument(this.documentNumber,this.existingDocumentTypeDetails)
                                this.documentActionNotification('post', 'success')
                                if (this.documentDetails && this.documentDetails.order_source=="shopee" && this.documentDetails.order_source=="shopify" && this.documentDetails.order_source=="lazada" && this.documentDetails.order_source=="zalora" && (this.autoPostDD || this.autoPostDDAndSI)){
                                    var message = (this.autoPostDD) ? "Auto posting of DD failed" : (this.autoPostDDAndSI) ? "Auto posting of DD, creation & posting of SI failed" : ""
                                    if (message !=""){
                                        this.$notification['warning']({
                                            message: message,
                                            description: "the setting is only applicable for manually created SO's."
                                        });
                                    }
                                } 
                            } else if (post_request['error']){
                                this.notifMessage = post_request['error'].split(',');
                                this.documentActionNotification('post', 'error')
                            }
                        }
                    }

                    this.spinning = false;
                    this.paymentDrawerVisible = false;
            },
            proceedPosting(){
                this.tovsiModal = false;
                this.spinMessage = 'Creating Resolution...'
                this.proceed_resolution = 0;
                this.spinning = false;
                this.enableActions();
                this.post();
            },
            async post(){
                this.notifMessage = [];
                if(!this.isPostDisabled && !this.spinning){
                    this.spinning = true;
                    this.disableActions();
                    //Validation for 0 quantity documents except PCount
                    if(this.currentDocumentTypeCode != 'OTHPCN' && this.currentDocumentTypeCode != 'OTHPWS' && this.currentDocumentTypeCode != 'OTHLIQ' && this.currentDocumentTypeCode != 'RECTRX' && this.totalQuantity == 0){
                        this.notifMessage.push("Unable to POST document with zero quantity.")
                        this.documentActionNotification('post', 'error');
                        this.spinning = false;
                        this.enableActions();
                        return false;
                    }
                    if((this.docTypesForIM.includes(this.currentDocumentTypeCode) || this.currentDocumentTypeCode=="OTHSBI") && (this.brand.key <= 0 || this.brand.key == "")){
                        this.notifMessage.push("Unable to POST document without brand.")
                        this.documentActionNotification('post', 'error');
                        this.spinning = false;
                        this.enableActions();
                        return false;
                    }

                    if(['ORISOX'].includes(this.currentDocumentTypeCode) && this.shippingMethod.key === undefined){
                        this.notifMessage.push("Shipping method is required.")
                        this.documentActionNotification('post', 'error');
                        this.spinning = false;
                        this.enableActions();
                        return false;
                    }

                    if (["OTHSRQ"].includes(this.currentDocumentTypeCode) && this.accountName.toLowerCase().includes('piml') && !this.yearSeason) {
                        this.notifMessage.push("Year Season is required!");
                        this.documentActionNotification('post', 'error');
                        return false;
                    }

                    if (["OTHSRQ"].includes(this.currentDocumentTypeCode) && this.accountName.toLowerCase().includes('piml') && !this.fiscalYear) {
                        this.notifMessage.push("Fiscal Year is required!");
                        this.documentActionNotification('post', 'error');
                        return false;
                    }

                    // const hasValidationError = await this.validateBrandAssortment();
                    // if (hasValidationError) {
                    //     this.spinning = false;
                    //     return false;
                    // }

                    if (this.isEditing) {
                        this.notifMessage.push("You have unsaved changes, please save before posting")
                        this.documentActionNotification('post', 'error');
                        this.spinning = false;
                        this.enableActions();
                        return;
                    }
                    
                    //Force check is_dirty 
                    var data = this.tabulator.getData();
                    var is_doc_quantity_dirty = data.filter(({ quantity: id1 }) => !JSON.parse(component_x.origData).some(({ quantity: id2 }) => id2 === id1));
                    var is_doc_cost_dirty = data.filter(({ cost: id1 }) => !JSON.parse(component_x.origData).some(({ cost: id2 }) => id2 === id1));
                    var is_doc_product_name_dirty = data.filter(({ product_name: id1 }) => !JSON.parse(component_x.origData).some(({ product_name: id2 }) => id2 === id1));
                    var is_doc_unit_id_dirty = data.filter(({ unit_id: id1 }) => !JSON.parse(component_x.origData).some(({ unit_id: id2 }) => id2 === id1));
                    var is_doc_price_dirty = data.filter(({ price: id1 }) => !JSON.parse(component_x.origData).some(({ price: id2 }) => id2 === id1));
                    var is_doc_discount_text_dirty = data.filter(({ discount_text: id1 }) => !JSON.parse(component_x.origData).some(({ discount_text: id2 }) => id2 === id1));
                    var is_doc_remarks_dirty = data.filter(({ remarks: id1 }) => !JSON.parse(component_x.origData).some(({ remarks: id2 }) => id2 === id1));
                    if(data.length == 0){
                        this.notifMessage.push('Atleast one Document Line is required.')
                        this.documentActionNotification('post', 'error');
                        this.spinning = false;
                        this.enableActions();
                        return;
                    }
                    //Arvs
                    //is_doc_cost_dirty.length > 0 ||
                    if(is_doc_quantity_dirty.length > 0 || is_doc_product_name_dirty.length > 0 || is_doc_unit_id_dirty.length > 0 || is_doc_price_dirty.length > 0 || is_doc_discount_text_dirty.length > 0 || is_doc_remarks_dirty.length > 0){
                        this.notifMessage.push("You have unsaved changes, please save before posting. [Document Lines]")
                        this.documentActionNotification('post', 'error');
                        this.spinning = false;
                        this.enableActions();
                        return;
                    }
                    //Check Lot codes
                    if(/^RE(C|L)/.test(this.currentDocumentTypeCode)){
                        this.notifMessage = [];
                        var data = this.tabulator.getData()
                        let require_lotcode_products = []
                        require_lotcode_products = data.filter(row => (row.is_require_lotcode != undefined && row.is_require_lotcode === true))
                        if(require_lotcode_products.length > 0) {
                            require_lotcode_products.forEach(row => {
                                if(row.document_line_locations == undefined){
                                    row.document_line_locations = []
                                }
                                var contentqty = ((row.product_type == 'P' && this.currentDocumentTypeCode.includes('REL')) ? row.content_quantity : 1)
                                var lineqty = (row.document_line_locations.length > 0) ? row.document_line_locations.map(lineloc => lineloc.quantity).reduce((sumqty, qty) => Number(qty) + Number(sumqty)) : 0;
                                this.notifMessage.push(ValidateField.matchData('Quantity', (row.quantity * contentqty), lineqty, `Insufficient Lot Codes provided for product in line number: ${row.line_no}. It must match quantity`));
                            })
                        }
                        this.notifMessage = this._.compact(this.notifMessage);
                        if (this.notifMessage.length > 0) {
                            this.spinning = false;
                            this.enableActions();
                            this.documentActionNotification('post', 'error');
                            return;
                        }
                
                        if(/^RE(C)/.test(this.currentDocumentTypeCode)){
                            //Validation for document setting to restrict posting of zero cost - 2895
                            var zeroCost = []
                                data.forEach(row => {
                                    if (Number(row.cost) == 0 || Number(row.cost) < 0)
                                        zeroCost.push(row.line_no)
                                })
                            if(zeroCost.length > 0 && this.document_config.document_type_settings.receivingDocument.strictPostingWithZeroCost){
                                this.notifMessage.push(`Unable to proceed posting this document, line: ${zeroCost} have zero cost.`);
                                this.spinning = false;
                                this.enableActions();
                                this.documentActionNotification('post', 'error');
                                return;
                            } else if(zeroCost.length > 0 && !this.document_config.document_type_settings.receivingDocument.strictPostingWithZeroCost && this.allowZeroCost == 0){
                                this.$confirm({
                                        title: 'Proceed?',
                                        content: h => <div>Line: {zeroCost.toString()} have zero cost, this will affect your cost layer. Do you want to proceed?</div>,
                                        okText: 'Yes',
                                        onOk: () => {
                                            this.allowZeroCost = 1
                                            this.spinning = false;
                                            this.enableActions();
                                            this.post()
                                        },
                                        onCancel: () => {
                                            component_x.spinning = false;
                                            component_x.enableActions();
                                        }
                                    });
                                return;
                            }
                        }
                        //IR for TO
                        //Check if with discrepancy
                        //https://tools.iripple.com/barter-11/bxi-backend/-/issues/3333
                        // this.originDocumentNumber
                        if(this.currentDocumentTypeCode == 'RECTRX' && this.proceed_ir_to == 0 && this.originDocumentNumber > 0){
                            var over_delivery_line = [];
                            var under_delivery_line = [];
                            var off_setting_line = [];
                            var lines = [];
                            var document_lines  = []
                            var data = this.tabulator.getData();
                            var is_doc_quantity_dirty = data.filter(({ quantity: id1 }) => !JSON.parse(component_x.origData).some(({ quantity: id2 }) => id2 === id1));
                            var is_doc_cost_dirty = data.filter(({ cost: id1 }) => !JSON.parse(component_x.origData).some(({ cost: id2 }) => id2 === id1));
                            var is_doc_product_name_dirty = data.filter(({ product_name: id1 }) => !JSON.parse(component_x.origData).some(({ product_name: id2 }) => id2 === id1));
                            var is_doc_unit_id_dirty = data.filter(({ unit_id: id1 }) => !JSON.parse(component_x.origData).some(({ unit_id: id2 }) => id2 === id1));
                            var is_doc_price_dirty = data.filter(({ price: id1 }) => !JSON.parse(component_x.origData).some(({ price: id2 }) => id2 === id1));
                            var is_doc_discount_text_dirty = data.filter(({ discount_text: id1 }) => !JSON.parse(component_x.origData).some(({ discount_text: id2 }) => id2 === id1));
                            var is_doc_remarks_dirty = data.filter(({ remarks: id1 }) => !JSON.parse(component_x.origData).some(({ remarks: id2 }) => id2 === id1));
                            if(data.length == 0){
                                this.notifMessage.push('Atleast one Document Line is required.')
                                this.documentActionNotification('post', 'error');
                                this.spinning = false;
                                this.enableActions();
                                return;
                            }
                            if(is_doc_quantity_dirty.length > 0 || is_doc_cost_dirty.length > 0 || is_doc_product_name_dirty.length > 0 || is_doc_unit_id_dirty.length > 0 || is_doc_price_dirty.length > 0 || is_doc_discount_text_dirty.length > 0 || is_doc_remarks_dirty.length > 0){
                                this.notifMessage.push("You have unsaved changes, please save before posting. [Document Lines]")
                                this.documentActionNotification('post', 'error');
                                this.spinning = false;
                                this.enableActions();
                                return;
                            }
                            const is_qty_dirty = data.filter(({ quantity: id1 }) => !JSON.parse(component_x.origData).some(({ quantity: id2 }) => id2 === id1));
                            if(is_qty_dirty.length > 0){
                                this.notifMessage.push("You have unsaved changes, please save before posting. [Document Lines :Quantity]")
                                this.documentActionNotification('post', 'error');
                                this.spinning = false;
                                this.enableActions();
                                return;
                            }
                            
                            document_lines = await HTTPRequest.getRequest(this.endPoint+'document_lines/'+this.originDocumentNumber+'?field_name=document_id&origin_sublocation=0', null)
                            //var othtov_doc_config = await HTTPRequest.getRequest(this.endPoint+'/document_types?type_code=TOV&trans_code=OTH', null);
                            
                            //Loop Original Line
                            for (let i = 0; i < data.length; i++) {
                                let currentData = document_lines.find(({ product_id }) => product_id === data[i]['product_id']);
                                
                                if(currentData === undefined) {
                                    data[i]['remarks'] = 'Off Setting';
                                    data[i]['actual_quantity'] = 0;
                                    lines.push(data[i]);
                                    off_setting_line.push(data[i]['line_no']);
                                } else {
                                    var discrepancy_qty = Math.abs(Number(data[i]['quantity']) - Number(currentData['quantity']));
                                    var current_qty = currentData['quantity'];
                                    currentData['actual_quantity'] = Number(data[i]['quantity']);
                                    currentData['quantity'] = discrepancy_qty;
                                    currentData['subtotal'] = ((currentData['subtotal'] / Number(currentData['quantity'])) * discrepancy_qty).toFixed(4);
                                    currentData['subtotal_without_vat'] = ((currentData['subtotal_without_vat'] / Number(currentData['quantity'])) * discrepancy_qty).toFixed(4);
                                    currentData['price_without_vat'] = ((currentData['price_without_vat'] / Number(currentData['quantity'])) * discrepancy_qty).toFixed(4);
                                    currentData['tax_amount'] = ((currentData['tax_amount'] / Number(currentData['quantity'])) * discrepancy_qty).toFixed(4);
                                    currentData['total_gross'] = ((currentData['total_gross'] / Number(currentData['quantity'])) * discrepancy_qty).toFixed(4);
                                    if(Number(current_qty) < Number(data[i]['quantity'])){
                                        //over_delivery.push(currentData);
                                        currentData['remarks'] = 'Over Delivery';
                                        over_delivery_line.push(data[i]['line_no']);
                                        lines.push(currentData);
                                    } else if(Number(current_qty) > Number(data[i]['quantity'])){
                                        //under_delivery.push(currentData);
                                        currentData['remarks'] = 'Under Delivery';
                                        under_delivery_line.push(data[i]['line_no']);   
                                        lines.push(currentData);
                                    }
                                }
                            }
                            if(lines.length > 0){
                                this.$confirm({
                                    title: 'Proceed?',
                                    content: h => <div>There are items with discrepancies, this will automatically create Transfer Order Verification for the Incident Report. Do you want to proceed?<li><br/><b>[Over Delivery]</b> Lines: {over_delivery_line.toString()}</li><li><b>[Under Delivery]</b> Lines: {under_delivery_line.toString()}</li><li><b>[Off Setting]</b> Lines: {off_setting_line.toString()}</li></div>,
                                    okText: 'Yes',
                                    onOk: () => {
                                        this.proceed_ir_to = 1;
                                        //Create TOV
                                        this.spinning = true;
                                        this.spinMessage = "Creating Transfer Order Verification..."

                                        // if (othtov_doc_config){
                                        //     //Loop lines
                                        //     //Create TOV per line
                                        //     console.log('Creating Transfer Order Verification...')
                                        //     for (let i = 0; i < lines.length; i++) {
                                        //         setTimeout(async function() {
                                        //             await this.create_document(lines[i], 'Transfer Order Verification', othtov_doc_config, 0)
                                        //         }.bind(this), 2000)

                                        //         if(lines.length == i+1){
                                                    this.spinning = false;
                                                    this.enableActions();
                                                    this.post();
                                                    return;
                                        //         }
                                        //     }
                                        // } else {
                                        //     this.documentActionNotification('post', 'error');
                                        // }
                                    },
                                    onCancel: () => {
                                        component_x.spinning = false;
                                        component_x.enableActions();
                                        return;
                                    }
                                });
                            } else {
                                this.proceed_ir_to = 1;
                                this.spinning = false;
                                this.enableActions();
                                this.post();
                                return;
                            }
                        }
                    }
                    //Create Resolution Documents for TOV
                    //https://tools.iripple.com/barter-11/bxi-backend/-/issues/3333
                    if(['OTHTOV', 'OTHPCV'].includes(this.currentDocumentTypeCode) && this.proceed_resolution == 0){
                        this.notifMessage = [];
                        this.spinMessage = "Validating Resolution Documents..."
                        var data = this.tabulator.getData()

                        //Checking SI source
                        if(this.si_source && this.b2bCustomerSource === undefined){
                            this.notifMessage.push("Customer is required, please select customer for source.")
                            this.documentActionNotification('post', 'error');
                            this.spinning = false;
                            this.enableActions();
                            this.tovsiModal = true;
                            //this.si_source = false;
                            return;
                        }

                        //Checking SI destination
                        if(this.si_destination && this.b2bCustomerDestination === undefined){
                            this.notifMessage.push("Customer is required, please select customer for destination.")
                            this.documentActionNotification('post', 'error');
                            this.spinning = false;
                            this.enableActions();
                            this.tovsiModal = true;
                            //this.si_destination = false;
                            return;
                        }

                        const is_reason_dirty = data.filter(({ reason_id: id1 }) => !JSON.parse(component_x.origData).some(({ reason_id: id2 }) => id2 === id1));
                        if(is_reason_dirty.length > 0){
                            this.notifMessage.push("You have unsaved changes, please save before posting [Document Lines :Resolution]")
                            this.documentActionNotification('post', 'error');
                            this.spinning = false;
                            this.enableActions();
                            return;
                        }

                        //Check if reason exists per line
                        //Map all reasons
                        const reason_ids = [...new Set(data.map(item => item.reason_id))];
                        if(reason_ids.includes(null)){
                            this.notifMessage.push('Resolution is requred!');
                            this.documentActionNotification('Validation', 'error');
                            this.spinning = false;
                            return;
                        }

                        //Check purpose
                        if(component_x.documentDetails.purpose_id['key'] == 0){
                            this.notifMessage.push('Purpose is requred!');
                            this.documentActionNotification('Validation', 'error');
                            this.spinning = false;
                            return;
                        }
                        
                        //Sort lines by reason_id
                        data.sort((a, b) => a.reason_id - b.reason_id);

                        //Get all reasons 
                        var reason_master = await HTTPRequest.getRequest(this.endPoint+'/reasons?per_page=500', null);

                        //Get all document types
                        var document_type_master = await HTTPRequest.getRequest(this.endPoint+'/document_types', null);

                        //Loop all reasons to get resolutions
                        //Then create documents and document lines
                        var trigger_reason = 0
                        var source_document = []
                        var source_document_lines = []
                        var destination_document = []
                        var destination_document_lines = []
                        var line_no_counter = 0
                        var ctr = 0
                        this.spinning = false;
                        this.$confirm({
                            title: 'Proceed?',
                            content: h => <div>This will create, confirm or post documents based on the resolution configured in the reason attributes. Click YES button below to proceed.</div>,
                            okText: 'Yes',
                            onOk: async () => {
                                this.proceed_resolution = 1;
                                //Create TOV
                                this.spinning = true;
                                this.spinMessage = "Creating Resolution Documents..."

                                try {
                                    // TOV documents have exactly 1 line per document,
                                    // so we resolve the single row directly (no forEach grouping,
                                    // no setTimeout race, no re-entrant post() inside a loop).
                                    var row = data[0];

                                    //Get resolution
                                    let resolution = reason_master['data'].find(({ id }) => id === row.reason_id);
                                    if(!resolution){
                                        this.notifMessage.push('Resolution configuration not found for the selected reason.');
                                        this.documentActionNotification('Validation', 'error');
                                        this.spinning = false;
                                        this.enableActions();
                                        return;
                                    }

                                    line_no_counter = 1;
                                    source_document = []
                                    source_document_lines = []
                                    destination_document = []
                                    destination_document_lines = []

                                    //Get Document Type details
                                    //Source
                                    if(resolution['source_resolution_document_type'] != null && resolution['source_resolution_document_type'] != 0){
                                        source_document[0] = document_type_master.find(({ id }) => id === resolution['source_resolution_document_type']);
                                        var source_line = { ...row };
                                        source_line.line_no = line_no_counter;
                                        source_document_lines.push(source_line)
                                    }

                                    //Destination
                                    if(resolution['destination_resolution_document_type'] != null && resolution['destination_resolution_document_type'] != 0){
                                        destination_document[0] = document_type_master.find(({ id }) => id === resolution['destination_resolution_document_type']);
                                        var destination_line = { ...row };
                                        destination_line.line_no = line_no_counter;
                                        destination_document_lines.push(destination_line)
                                    }
                                    //End Get Document Type details

                                    if(source_document.length > 0 && source_document[0]['type_code'] == 'SIN')
                                        this.si_source = true

                                    if(destination_document.length > 0 && destination_document[0]['type_code'] == 'SIN')
                                        this.si_destination = true

                                    //If an SI resolution needs a B2B customer that isn't set yet,
                                    //open the SI modal and stop. proceedPosting() resumes post() afterwards.
                                    if((this.si_source == true && this.b2bCustomerSource == '') || (this.si_destination == true && this.b2bCustomerDestination == '')){
                                        //Pop up SI customer selection
                                        this.tovsiModal = true;
                                        this.spinMessage = 'Waiting for B2B customer...'
                                        this.spinning = false;
                                        return;
                                    }

                                    this.tovsiModal = false;
                                    //Create documents & lines sequentially (awaited).
                                    //The line arrays above are cloned copies of the parent row,
                                    //so child creation no longer depends on the tabulator grid.
                                    //Pass skip_refresh=true so create_document does NOT reload the
                                    //parent document (which would empty this.tabulator.getData()
                                    //and cause "Atleast one Document Line is required" when the
                                    //parent post() re-enters below).
                                    if(source_document_lines.length > 0){
                                        await this.create_document(source_document_lines, 'Source Resolution', source_document, (this.si_source == true) ? 0 : 1, true)
                                    }

                                    if(destination_document_lines.length > 0){
                                        await this.create_document(destination_document_lines, 'Destination Resolution', destination_document, (this.si_destination == true) ? 0 : 1, true)
                                    }
                                } catch (e) {
                                    console.error('Resolution child creation failed', e);
                                    this.notifMessage.push('Failed to create resolution document(s).');
                                    this.documentActionNotification('Create Document', 'error');
                                    this.spinning = false;
                                    this.enableActions();
                                    return;
                                }

                                //Post the parent ONCE, after children are created.
                                //proceed_resolution is now 1, so this re-entry skips the
                                //resolution block and posts the parent.
                                //Safeguard: if child creation/posting side effects emptied the
                                //tabulator grid, restore the parent's captured lines so the
                                //re-entrant post() does not fail with
                                //"Atleast one Document Line is required".
                                try {
                                    if(this.tabulator && this.tabulator.getData().length == 0 && data.length > 0){
                                        await this.tabulator.replaceData(data);
                                    }
                                } catch (restoreErr) {
                                    console.error('Failed to restore parent grid before post', restoreErr);
                                }

                                this.spinning = false;
                                this.enableActions();
                                this.post();
                            },
                            onCancel: () => {
                                component_x.spinning = false;
                                component_x.enableActions();
                                return;
                            }
                        });
                        this.spinning = false;
                        return false;
                    }
                    if (['ORISOX','OTHSRQ','RELDDE','OTHSIN','ORIOSO'].includes(this.currentDocumentTypeCode) && (this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.allowPaymentOnPosting || false == true) && this.forPaymentIsProcessed == false) {
                        this.forPaymentIsPosting = true;
                        this.showPaymentMethods();
                    } else if(['ORIPOX'].includes(this.currentDocumentTypeCode) && (this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.enableRecordingOfInitialDeposit || false == true) && this.forPaymentIsProcessed == false) {
                        this.forPaymentIsPosting = true;
                        this.showInitialDepositMethods();
                    } else if(['RECDEL'].includes(this.currentDocumentTypeCode) && this.continueAutoCreatePoExceedRr == false) {
                        this.notifMessage = [];
                        var data = this.tabulator.getData()
                        let require_lotcode_products = []
                        require_lotcode_products = data.filter(row => (row.is_require_lotcode != undefined && row.is_require_lotcode === true))
                        if(require_lotcode_products.length > 0) {
                            require_lotcode_products.forEach(row => {
                                if(row.document_line_locations == undefined){
                                    row.document_line_locations = []
                                }
                                var contentqty = ((row.product_type == 'P' && this.currentDocumentTypeCode.includes('REL')) ? row.content_quantity : 1)
                                var lineqty = (row.document_line_locations.length > 0) ? row.document_line_locations.map(lineloc => lineloc.quantity).reduce((sumqty, qty) => Number(qty) + Number(sumqty)) : 0;
                                this.notifMessage.push(ValidateField.matchData('Quantity', (row.quantity * contentqty), lineqty, `Insufficient Lot Codes provided for product in line number: ${row.line_no}. It must match quantity`));
                            })
                        }
                        this.notifMessage = this._.compact(this.notifMessage);
                        if (this.notifMessage.length > 0) {
                            this.spinning = false;
                            this.documentActionNotification('post', 'error');
                            this.spinning = false;
                            this.enableActions();
                            return;
                        }

                        if (this.document_config.document_type_settings.receivingDocumentWithOrder.autoCreatePurchaseOrderExceedingQuantity == true && this.notifMessage.length == 0){
                            var result = await HTTPRequest.getRequest(this.endPoint + 'documents/check_has_exceeding_receiving_report/?document_id='+component_x.documentNumber, null)
                            if (result.exceeding == true){
                                this.$confirm({
                                    title: 'Proceed?',
                                    content: h => <div>This action will auto create PO documents from exceeding RR quantity</div>,
                                    onOk: () => {
                                        this.continueAutoCreatePoExceedRr = true
                                        this.spinning = false;
                                        this.enableActions();
                                        this.post()
                                    },
                                    onCancel: () => {
                                        component_x.spinning = false;
                                        component_x.enableActions();
                                    }
                                });
                            } else {
                                this.continueAutoCreatePoExceedRr = true
                                this.spinning = false;
                                this.enableActions();
                                this.post()
                            }
                        } else {
                                this.continueAutoCreatePoExceedRr = true
                                this.spinning = false;
                                this.enableActions();
                                this.post()
                        }
                    } else if(this.currentDocumentTypeCode=='OTHCNS' && this.continuePostCountSetDocument == false){
                        this.$confirm({
                            title: 'Proceed?',
                            content: h => <div>Set not included products to zero (0) inventory ? </div>,
                            okText: 'Yes',
                            cancelText: 'No',
                            onOk: () => {
                                component_x.continuePostCountSetDocument = true
                                component_x.isSetOtherItemInventoryToZero = true
                                this.spinning = false;
                                this.enableActions();
                                component_x.post()
                            },
                            onCancel: () => {
                                component_x.continuePostCountSetDocument = true
                                component_x.isSetOtherItemInventoryToZero = false
                                component_x.spinning = false;
                                component_x.enableActions();
                                component_x.post()
                            }
                        });
                    } else {
                        if(this.currentDocumentTypeCode == 'RECTRX' && this.proceed_ir_to == 0 && this.originDocumentNumber > 0){
                            return false;
                        }
                        window.scrollTo(0,0);
                        this.notifMessage = [];
                        var data = this.tabulator.getData();
                        if(["ORISOX","OTHSRQ","ORIOSO"].includes(this.currentDocumentTypeCode)){
                            if(this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.autoCreatePostDD){
                                this.autoPostDD = true;
                            }else if (this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.autoCreatePostDDAndSI){
                                this.autoPostDDAndSI = true;
                            }
                        } 
                        //For RelDde Documents
                        if(['RELDDE'].includes(this.currentDocumentTypeCode)){
                            if (this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.automaticPostingOnSave != true) {
                                //when goods issue
                                if (this.documentNumber > 0) {
                                    var invalid = data.find(row => row.goods_issue_quantity == 0 && Number(row.ordered_quantity) > 0)
                                    if (invalid != undefined){
                                        this.notifMessage.push("Zero goods issue quantity is not allowed in the document line");
                                        this.documentActionNotification('post', 'error');
                                        this.spinning = false;
                                        this.enableActions();
                                        return;
                                    }
                                }
                            }
                        }
                        if (['ORORSO'].includes(this.currentDocumentTypeCode)){
                            if (this.documentNumber > 0) {
                                var invalidDoc = data.find(row => row.requested_quantity == 0 && row.quantity == 0)
                                if (invalidDoc != undefined){
                                    this.notifMessage.push("Zero quantity is not allowed in the document line");
                                    this.documentActionNotification('post', 'error');
                                    this.spinning = false;
                                    this.enableActions();
                                    return;
                                }
                                var checkQty = data.find(row => row.requested_quantity < row.quantity)
                                if (checkQty != undefined){
                                    this.notifMessage.push("quantity must less than or equal to requested quantity");
                                    this.documentActionNotification('post', 'error');
                                    this.spinning = false;
                                    this.enableActions();
                                    return;
                                }
                                var checkNotAvailableQty = data.find(row => parseFloat(row.quantity) > parseFloat(row.on_hand_quantity))
                                if (checkNotAvailableQty != undefined){
                                    this.notifMessage.push("containing item that cannot be fulfilled because of lack of inventory.");
                                    this.documentActionNotification('post', 'error');
                                    this.spinning = false;
                                    this.enableActions();
                                    return;
                                }
                            }
                        }
                        if (data.length > 0) {
                            this.isEditing = !(component_x.origData === JSON.stringify(data))
                        }
                        if(this.documentStatus == "Confirmed" && this.isEditing){
                            this.isChangeAction = true;
                        }

                        if (this.isEditing && !this.isChangeAction && this.currentDocumentTypeCode!='OTHLIQ') {
                            this.notifMessage.push("You have unsaved changes, please save before posting. [Document Header]")
                            this.documentActionNotification('post', 'error');
                            if(this.currentDocumentTypeCode=='OTHCNS'){
                                this.continuePostCountSetDocument = false
                            }
                            this.spinning = false;
                            this.enableActions();
                            return;
                        } else {
                            if(this.currentDocumentTypeCode=='RECTRX_TRANSFERED'){
                                //Auto Create SubLoc Transfer In
                                //4165
                                console.log('Auto Create SubLoc Transfer In')
                                this.notifMessage = [];
                                this.spinMessage = "Processing Sublocation Transfer In Documents..."
                                var data = this.tabulator.getData()
                                var doc_config = await HTTPRequest.getRequest(this.endPoint+'/document_types?type_code=SLO&trans_code=REL', null);
                                var document_lines = []
                                var trigger_sublocation = ''
                                var line_no_counter = 0
                                var ctr = 0
                                //Sort lines by sublocation
                                data.sort((a, b) => a.sublocation - b.sublocation);

                                var group_result = Object.groupBy(data, ({ sublocation }) => sublocation);
                                Object.keys(group_result).forEach(row => {
                                if(group_result[row].length > 1){
                                    ctr = 0
                                    group_result[row].forEach(row => {
                                    ctr++;
                                    row['line_no'] = ctr;
                                    })
                                }else{
                                    group_result[row][0]['line_no'] = 1
                                }
                                //Create SLI/SLO
                                setTimeout(async function() {
                                            await this.create_document(group_result[row], 'Sub Location Transfer In', doc_config, 1)
                                        }.bind(this), 2000)
                                })
                                this.spinning = false;
                                this.spinMessage = "Posting Documents..."
                                // data.forEach(row => {
                                //     ctr++;
                                //     if (trigger_sublocation != row.sublocation){
                                        
                                //         if(ctr > 0){
                                //             //Create documents & lines
                                //             if(document_lines.length > 0){
                                //                 setTimeout(async function() {
                                //                     await this.create_document(document_lines, 'Sub Location Transfer In', doc_config, 1)
                                //                 }.bind(this), 2000)
                                //                 //setTimeout(this.create_document(document_lines, 'Sub Location Transfer In', doc_config, 1), 5000);
                                //             }
                                //         }
                                //         line_no_counter = 1;
                                //         document_lines = []
                                //         document_lines.push(row)
                                //         trigger_sublocation = row.sublocation;
                        
                                //     } else {
                                //         line_no_counter++;
                                //         row.line_no = line_no_counter
                                //         document_lines.push(row)
                                        
                                //         //Create documents & lines for last record
                                //         if(ctr == data.length){
                                //             //this.create_document(document_lines, 'Sub Location Transfer In', doc_config, 1);
                                //             setTimeout(async function() {
                                //                 await this.create_document(document_lines, 'Sub Location Transfer In', doc_config, 1)
                                //             }.bind(this), 2000)
                                //             this.spinning = false;
                                //             return;
                                //         }
                                //     }

                                //     //Create documents & lines for last record
                                //     if(ctr == data.length){
                                //         //this.create_document(document_lines, 'Sub Location Transfer In', doc_config, 1);
                                //         //setTimeout(this.create_document(document_lines, 'Sub Location Transfer In', doc_config, 1), 5000);
                                //         setTimeout(async function() {
                                //             await this.create_document(document_lines, 'Sub Location Transfer In', doc_config, 1)
                                //         }.bind(this), 2000)
                                //         this.spinning = false;
                                //         return;
                                //     }
                                // });
                            }
                            if (component_x.documentNumber > 0) {
                                var params = (this.isSetOtherItemInventoryToZero) ? "&set_other_item_inventory_to_zero=true" : ""
                                params += (this.autoPostDD) ? "&auto_post_dd=true" : (this.autoPostDDAndSI) ? "&auto_post_dd_and_si=true" : ""
                                var post_request = await HTTPRequest.postRequest(this.endPoint + 'documents/post/?document_id='+component_x.documentNumber+''+params, null)
                                // var linecost_recompute_request = []
                                // 1935 - Line Cost (When posting Document with header discount)
                                // if(this.headerDiscount.length > 0)
                                // linecost_recompute_request = await HTTPRequest.postRequest(this.endPoint + 'documents/recompute_line_cost_with_discount/?document_id='+component_x.documentNumber+'&overallDiscountWithoutSupportDiscount='+component_x.overallDiscountWithoutSupportDiscount+'&grossAmount='+component_x.grossAmountDisplay, null)
                                // 1935 - Line Cost (When posting Document with header discount)

                                if ( (post_request['success'] && this.headerDiscount.length > 0) || (post_request['success'] && this.headerDiscount.length == 0) ){
                                    this.openDocument(component_x.documentNumber,component_x.existingDocumentTypeDetails);
                                    this.documentActionNotification('post', 'success')
                                    this.spinning = false;
                                    this.enableActions();
                                
                                    if(this.currentDocumentTypeCode=='OTHPCN' && data.reduce((n, {variance_quantity}) => n + Number(variance_quantity), 0) > 0){
                                        this.documentActionNotification('Physical Count Verification has been created', 'success');
                                    }

                                } else if (post_request['error']) {
                                    if(this.currentDocumentTypeCode=='OTHCNS'){
                                        this.continuePostCountSetDocument = false
                                    }

                                    this.notifMessage = post_request['error'].split(',');
                                    this.documentActionNotification('post', 'error')
                                    this.spinning = false;
                                    this.enableActions();
                                }
                            }
                        }

                        // if(this.currentDocumentTypeCode=='OTHPCN'){
                        //     this.documentActionNotification('Physical Count Verification has been created', 'success');
                        // }
                    }
                }
            },
            disableActions(){
                this.isPostDisabled = true
                this.isSaveDisabled = true
                this.isUpdateDisabled = true
                this.isUnconfirmDisabled = true
                this.isConfirmDisabled = true
            },
            enableActions(){
                this.isPostDisabled = false
                this.isSaveDisabled = false
                this.isUpdateDisabled = false
                this.isUnconfirmDisabled = false
                this.isConfirmDisabled = false
                this.spinning = false
            },
            async create_document(document_lines, remark, doc_config, auto_post, skip_refresh = false){
                this.spinning = true;
                this.spinMessage = 'Creating Sub Documents...'
                var res_document = [];
                var amount_gross = 0;
                var amount_net = 0;
                var tax_amount = 0;
                var tax_exempt_amount = 0;
                var gross_amount_without_tax = 0;
                var net_amount_without_tax = 0;
                var total_quantity = 0;
                var sublocation = []
                var default_sublocation = []
                var sublocation_id = null
                var tov_line = []
                var document_type_id = (doc_config[0].id == undefined) ? doc_config['id'] : doc_config[0].id;
                var document_type_code = (doc_config[0].type_code == undefined) ? doc_config['type_code'] : doc_config[0].type_code;
                var document_trans_code = (doc_config[0].trans_code == undefined) ? doc_config['trans_code'] : doc_config[0].trans_code;
                var document_type_name = (doc_config[0].type_code == undefined) ? doc_config['name'] : doc_config[0].name;
                
                if(document_lines.length === undefined){
                    amount_gross = parseFloat(document_lines['subtotal']);
                    amount_net = parseFloat(document_lines['subtotal']);
                    tax_amount = parseFloat(document_lines['tax_amount']);
                    tax_exempt_amount = parseFloat(document_lines['subtotal_without_vat']);
                    gross_amount_without_tax = parseFloat(document_lines['subtotal_without_vat']);
                    net_amount_without_tax = parseFloat(document_lines['subtotal_without_vat']);
                    total_quantity = parseFloat(document_lines['quantity']);        
                } else {
                    for (let i = 0; i < document_lines.length; i++) {

                        //Recompute for PCV [quantity less actual]
                        if(['OTHPCV'].includes(this.currentDocumentTypeCode)){
                            // var variance_quantity = Number(document_lines[i]['quantity']) - Number(document_lines[i]['actual_quantity'])
                            document_lines[i]['quantity'] = Math.abs(document_lines[i]['variance_quantity'])
                        }
                        //Compute Header
                        //Apply tax if party and item are vatable arvs
                        if(((this.party_tax_type_destination == 'V' && remark == 'Destination Resolution' && document_type_code == 'SIN') || (this.party_tax_type_source == 'V' && remark == 'Source Resolution' && document_type_code == 'SIN') || (component_x.documentDetails.party_tax_type == 'V' && document_type_code != 'SIN')) && document_lines[i]['tax_type'] == 'V'){
                            //Recompute tax for lines
                            document_lines[i]['subtotal_without_vat'] = (Number(document_lines[i]['subtotal'])/ (1+Number(this.taxRate))).toFixed(this.decimalPlaces)
                            document_lines[i]['price_without_vat'] = (Number(document_lines[i]['cost'])/ (1+Number(this.taxRate))).toFixed(this.decimalPlaces)
                            document_lines[i]['tax_amount'] = Number(document_lines[i]['subtotal']).toFixed(this.decimalPlaces) * (1+Number(this.taxRate))
                        } else {
                            //Recompute without tax for lines
                            document_lines[i]['subtotal_without_vat'] = Number(document_lines[i]['subtotal']).toFixed(this.decimalPlaces)
                            document_lines[i]['price_without_vat'] = Number(document_lines[i]['cost']).toFixed(this.decimalPlaces)
                            document_lines[i]['tax_amount'] = 0
                        }
                            tax_amount = tax_amount + parseFloat(document_lines[i]['tax_amount']);
                            tax_exempt_amount = tax_exempt_amount + parseFloat(document_lines[i]['subtotal_without_vat']);
                            gross_amount_without_tax = gross_amount_without_tax + parseFloat(document_lines[i]['subtotal_without_vat']);
                            net_amount_without_tax = net_amount_without_tax + parseFloat(document_lines[i]['subtotal_without_vat']);
                            amount_gross = amount_gross + parseFloat(document_lines[i]['subtotal']);
                            amount_net = amount_net + parseFloat(document_lines[i]['subtotal']);
                            total_quantity = total_quantity + parseFloat(document_lines[i]['quantity']);   
                    }
                }

                
                //Get Sublocation Details
                if(this.currentDocumentTypeCode == 'RECTRX' && document_type_code != 'TOV'){
                    sublocation = await HTTPRequest.getRequest(this.endPoint + 'sublocations?code='+document_lines[0]['sublocation'], null)
                } else {
                    //remark == 'Source Resolution'
                    if(['OTHPCV'].includes(this.currentDocumentTypeCode)){
                        default_sublocation = await HTTPRequest.getRequest(this.endPoint + 'sites/'+component_x.documentDetails.site_id['key'], null)
                        sublocation_id = default_sublocation['sublocation_id']
                    } else {
                        if(remark == 'Source Resolution'){
                            sublocation = await HTTPRequest.getRequest(this.endPoint + 'sublocations?id='+component_x.originSublocation.key, null)
                            sublocation_id = this.originSublocation.key 
                        }else{
                            sublocation = await HTTPRequest.getRequest(this.endPoint + 'sublocations?code='+document_lines[0]['sublocation'], null)
                            sublocation_id = sublocation['data'][0].id
                        }
                    }
                    tov_line.push(document_lines)
                }

                default_sublocation = await HTTPRequest.getRequest(this.endPoint + 'sites/'+component_x.documentDetails.site_id['key'], null)

                //Do not create SLO/SLI if origin & target subloc is the same #4165
                if(this.currentDocumentTypeCode == 'RECTRX' && document_type_code != 'TOV' && default_sublocation['sublocation_id'] == sublocation['data'][0].id){
                    return;
                }

                //SI arvs
                var doc_address = ''
                var doc_province = ''
                var doc_city = ''
                var doc_barangay = ''
                var doc_party_tax_type = ''
                var doc_payment_term_id = ''
                var doc_wtax_code = ''
                var doc_b2b_customer_id = ''
                var doc_customer_type = ''
                if(document_type_code == 'SIN' && remark == 'Source Resolution'){
                    doc_address = this.address
                    doc_province = this.province_source
                    doc_city = this.city_source
                    doc_barangay = this.barangay_source
                    doc_party_tax_type = this.party_tax_type_source
                    doc_payment_term_id = this.paymentTerm_source.key
                    doc_wtax_code = this.wTax_source.key
                    doc_b2b_customer_id = this.b2bCustomerSource
                    doc_customer_type = 'b2b'
                } else if(document_type_code == 'SIN' && remark == 'Destination Resolution'){
                    doc_province = this.province_destination
                    doc_city = this.city_destination
                    doc_barangay = this.barangay_destination
                    doc_party_tax_type = this.party_tax_type_destination
                    doc_payment_term_id = this.paymentTerm_destination.key
                    doc_wtax_code = this.wTax_destination.key
                    doc_b2b_customer_id = this.b2bCustomerDestination
                    doc_customer_type = 'b2b'
                }else{
                    doc_party_tax_type = component_x.documentDetails.party_tax_type
                    doc_wtax_code = component_x.documentDetails.wtax_code
                }

                var cancel_date = moment().add(1, 'M').format('YYYY-MM-DD');
                var target_date = moment().add(1, 'day').format('YYYY-MM-DD');
                res_document = {
                document: {
                    "source_site_id": (['OTHTOV', 'OTHPCV'].includes(this.currentDocumentTypeCode)) ? -1 : component_x.documentDetails.source_site_id['key'],
                    "sublocation_id":(this.currentDocumentTypeCode == 'RECTRX' && document_type_code != 'TOV') ? sublocation['data'][0].id : sublocation_id,
                    "site_id": (['OTHTOV'].includes(this.currentDocumentTypeCode)) ? ((remark == 'Source Resolution') ? component_x.documentDetails.source_site_id['key'] : component_x.documentDetails.target_site_id['key']) : component_x.documentDetails.site_id['key'],
                    "origin_site_id":(['OTHTOV', 'OTHPCV'].includes(this.currentDocumentTypeCode)) ? ((remark == 'Source Resolution') ? component_x.documentDetails.source_site_id['key'] : component_x.documentDetails.target_site_id['key']) : component_x.documentDetails.origin_site_id,
                    "brand_id":component_x.documentDetails.brand_id,
                    "document_type_id": document_type_id,
                    "document_type_code": document_type_code,
                    "document_trans_code": document_trans_code,
                    "document_date":moment(new Date()),
                    "party_id":(['OTHTOV'].includes(this.currentDocumentTypeCode)) ? component_x.documentDetails.source_site_id['key'] : -1,
                    "party_name":(['OTHTOV'].includes(this.currentDocumentTypeCode)) ? ((remark == 'Source Resolution') ? component_x.documentDetails.source_site_id['label'] : component_x.documentDetails.target_site_id['label']) : component_x.documentDetails.party_name,
                    "origin_sublocation_id":(this.currentDocumentTypeCode == 'RECTRX' && document_type_code != 'TOV') ? default_sublocation['sublocation_id'] : null,
                    "target_sublocation_id":(this.currentDocumentTypeCode == 'RECTRX' && document_type_code != 'TOV') ? sublocation['data'][0].id : null,
                    "target_date":target_date,
                    "cancellation_date":cancel_date,
                    "discount_text":"",
                    //"remark": remark,
                    "remark": component_x.remark,
                    "purpose_id": component_x.documentDetails.purpose_id['key'],
                    "target_site_id":component_x.documentDetails.target_site_id['key'],
                    "reference_1":component_x.documentDetails.reference_1,
                    "document_no":0,
                    "document_lines":(document_type_code != 'TOV') ? document_lines : tov_line,
                    "document_charges":[],
                    "support_discount_text":"",
                    "amount_gross":Number(amount_gross).toFixed(4),
                    "amount_header_discount":0,
                    "amount_net":Number(amount_net).toFixed(4),
                    "tax_amount":Number(tax_amount).toFixed(4),
                    "tax_exempt_amount":Number(tax_exempt_amount).toFixed(4),
                    "tax_rate":component_x.documentDetails.tax_rate,
                    "amount_line_discount":0,
                    "gross_amount_without_tax":Number(gross_amount_without_tax).toFixed(4),
                    "net_amount_without_tax":Number(net_amount_without_tax).toFixed(4),
                    "supplier_id":component_x.documentDetails.supplier_id['key'],
                    "origin_document_id":component_x.documentDetails.id,
                    "order_status":"U",
                    "order_source": (document_trans_code == 'REC' && document_type_code == 'SLI') ? "STI-SUBLOCATION" : ((this.currentDocumentTypeCode == 'OTHPCV') ? "PCN-IR" : "STI-IR"),
                    "total_quantity":Number(total_quantity).toFixed(4),
                    "is_header_only":false,
                    "is_trade":true,
                    "ui_currency_id":component_x.documentDetails.currency_id,
                    "extras":{
                    },
                    "revenue_site_id":0,
                    "party_tax_type":doc_party_tax_type,
                    "wtax_code":doc_wtax_code,
                    "address": doc_address,
                    "province":doc_province,
                    "city":doc_city,
                    "barangay":doc_barangay,
                    "payment_term_id":doc_payment_term_id,
                    "customer_type":doc_customer_type,
                    "company_id":component_x.company_id,
                    "company_code":component_x.companyOwnerCode,
                    "b2b_customer_id":doc_b2b_customer_id,
                    "is_uploaded":false,
                    "price_type": component_x.productPriceChoice,
                  }
                };

                this.spinMessage = 'Creating '+ document_type_name +'...'
                console.log('Creating '+ document_type_name +'...')
                var create_request = await HTTPRequest.postRequest(this.endPoint + '/documents', null, res_document);
                if(create_request['error'] == undefined){
                    // Send Email For TOV
                    var childDocumentTypeCode = (doc_config[0].type_code == undefined) ? doc_config['type_code'] : doc_config[0].type_code;
                    var childDocumentTransCode = (doc_config[0].trans_code == undefined) ? doc_config['trans_code'] : doc_config[0].trans_code;
                    var childDocumentName = (doc_config[0].trans_code == undefined) ? doc_config['name'] : doc_config[0].name;
                    var email_params = {
                        "document_type_code": childDocumentTypeCode,
                        "document_trans_code": childDocumentTransCode,
                        "document": create_request,
                        "site_id": (this.currentDocumentTypeCode == 'OTHTOV') ? component_x.documentDetails.source_site_id['key'] : component_x.documentDetails.site_id['key']
                    }
                    if(['TOV','PCV'].includes(childDocumentTypeCode) && ['OTH'].includes(childDocumentTransCode)){
                        this.spinMessage = 'Sending Email for '+ childDocumentName +'...'
                        console.log('Sending Email for '+ childDocumentName +'...')
                        await HTTPRequest.postRequest(this.endPoint + '/documents/send_email_notification', null, email_params);
                    }
 
                    if(auto_post == 1 || (this.currentDocumentTypeCode == 'OTHTOV' && document_type_code != 'SIN')){
                        this.spinMessage = 'Posting '+ document_type_name +'...'
                        console.log('Posting '+ document_type_name +'...')
                        var post_request = await HTTPRequest.postRequest(this.endPoint + 'documents/post/?document_id='+create_request['id'], null);
                        if(post_request['error'] == undefined){
                            this.notifMessage.push("Document number " + create_request['document_no'] + " has been created.");
                            this.notifMessage.push("Document number " + create_request['document_no'] + " has been posted.");
                            this.documentActionNotification('Post Document', 'success');
                        } else {
                            this.notifMessage.push(post_request['error']);
                            this.documentActionNotification('Post Document', 'error');
                        }
                    } else {
                        this.notifMessage.push("Document number " + create_request['document_no'] + " has been created.");
                        this.documentActionNotification('Create Document', 'success');
                    }
                    this.spinning = false;
                    if(!skip_refresh){
                        this.refreshDocument()
                    }
                    return create_request;
                } else {
                    this.notifMessage.push(create_request['error']);
                    this.documentActionNotification('Create Document', 'error');
                    this.spinning = false;
                    return create_request;
                }
            },
            async voided() {
                window.scrollTo(0,0);
                this.spinning = true;

                //[Internal] - Issue on voiding REL - 2972
                //Prevent voiding REL (STO) if target document (STI) is not yet voided.
                if(this.currentDocumentTypeCode == 'RELTRX'){
                    //Check STI if Voided
                    var sti_doc = await HTTPRequest.getRequest(this.endPoint + "documents/"+ this.documentNumber +"?field_name=origin_document_id", null);
                    this.proceed_voiding = ((sti_doc != null && sti_doc.status == 'Voided') || sti_doc == null) ? 1 : 0;
                } 

                //Prevent voiding REC, if the cost layer has a movement. (For FIFO or LIFO costing method only)
                if(/^RE(C)/.test(this.currentDocumentTypeCode)){
                var credentials = await HTTPRequest.getRequest(this.endPoint + 'settings/accountSettings?field_name=code' , null)
                    //Check Costing Method
                    if (['FIFO','LIFO',''].includes(JSON.parse(credentials.value).documentCostingMethod)){
                        //Check Cost layer if has a movement
                        //Compare document line and cost layer
                        var document_lines = this.tabulator.getData();
                        var cost_layer = await HTTPRequest.getRequest(this.endPoint + 'documents/get_document_cost_layer_details?document_id='+ this.documentNumber,null)

                        var document_lines_qty = 0
                        var cost_layer_qty = 0
                        
                        if (document_lines.length > 0){
                            document_lines.forEach( line => {
                                document_lines_qty += Number(line.quantity)
                            })
                        }

                        if (cost_layer.length > 0){
                            cost_layer.forEach( line => {
                                cost_layer_qty += Number(line.quantity)
                            })
                        }
                        this.proceed_voiding = (document_lines_qty != cost_layer_qty && cost_layer_qty != 0 && this.proceed_voiding == 0) ? 0 : 1;
                    } else if (['BLENDED'].includes(JSON.parse(credentials.value).documentCostingMethod)){
                        this.proceed_voiding = 1
                    }
                }
                
                if(this.proceed_voiding == 0 && this.currentDocumentTypeCode == 'RELTRX'){
                    this.notifMessage = []
                    this.notifMessage.push("Please void the STI first before voiding the STO.")
                    this.documentActionNotification('voiding', 'error');
                } else if(this.proceed_voiding == 0 && (/^RE(C)/.test(this.currentDocumentTypeCode))){
                    var documentCostingMethod = JSON.parse(credentials.value).documentCostingMethod
                    this.$confirm({
                        title: "The cost layer for this document has already moved",
                        content: h => <div>If there is not enough inventory, it will obtain it from the layer using the { documentCostingMethod } costing method; however, if there is no more inventory, it will obtain the cost from the product's last received cost, or "landed cost." Click OK to continue.</div>,
                        onOk: () => {
                                this.proceed_voiding = 1;
                                this.voided();
                            },
                        onCancel() {}
                    });
                } else {
                    var status = -1;
                    var err_msg = [];
                    await axios({
                        method: 'delete',
                        url: this.endPoint + 'documents/' + this.documentNumber,
                        headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress") },
                    })
                    .then(function () {
                        status = 1;
                    })
                    .catch(function (e) {
                        err_msg = JSON.parse(e.request.response).error
                        status = 0;
                    });
                    if (status) {
                        this.openDocument(this.documentNumber,this.existingDocumentTypeDetails)
                        this.documentActionNotification('void', 'success')
                        this.create_action_history('VOIDED')
                    }  else {
                        this.notifMessage = err_msg
                        this.documentActionNotification('void', 'error')
                    }
                }
                this.spinning = false;
            },
            async confirm() {
                this.notifMessage = [];
                //Validation for 0 quantity documents except PCount
                if(this.currentDocumentTypeCode != 'OTHPCN' && this.currentDocumentTypeCode != 'OTHPWS' && this.currentDocumentTypeCode != 'OTHLIQ' && this.currentDocumentTypeCode != 'RECTRX' && this.totalQuantity == 0){
                    this.notifMessage.push("Unable to CONFIRM document with zero quantity.")
                    this.documentActionNotification('confirm', 'error');
                    return false;
                }
                var data = this.tabulator.getData();
                 //Force check is_dirty 
                var is_doc_quantity_dirty = data.filter(({ quantity: id1 }) => !JSON.parse(component_x.origData).some(({ quantity: id2 }) => id2 === id1));
                var is_doc_cost_dirty = data.filter(({ cost: id1 }) => !JSON.parse(component_x.origData).some(({ cost: id2 }) => id2 === id1));
                var is_doc_product_name_dirty = data.filter(({ product_name: id1 }) => !JSON.parse(component_x.origData).some(({ product_name: id2 }) => id2 === id1));
                var is_doc_unit_id_dirty = data.filter(({ unit_id: id1 }) => !JSON.parse(component_x.origData).some(({ unit_id: id2 }) => id2 === id1));
                var is_doc_price_dirty = data.filter(({ price: id1 }) => !JSON.parse(component_x.origData).some(({ price: id2 }) => id2 === id1));
                var is_doc_discount_text_dirty = data.filter(({ discount_text: id1 }) => !JSON.parse(component_x.origData).some(({ discount_text: id2 }) => id2 === id1));
                var is_doc_remarks_dirty = data.filter(({ remarks: id1 }) => !JSON.parse(component_x.origData).some(({ remarks: id2 }) => id2 === id1));
                if(data.length == 0){
                    this.notifMessage.push('Atleast one Document Line is required.')
                    this.documentActionNotification('Confirm', 'error');
                    this.spinning = false;
                    return;
                }

                if (['RELTRX'].includes(this.currentDocumentTypeCode) && (!this.shippingMethod || this.shippingMethod.key === undefined)) {
                    this.notifMessage.push("Shipping method is required.");
                    this.documentActionNotification('confirm', 'error');
                    return false;
                }

                if (["OTHSRQ"].includes(this.currentDocumentTypeCode) && this.accountName.toLowerCase().includes('piml') && !this.yearSeason) {
                    this.notifMessage.push("Year Season is required!");
                    this.documentActionNotification('confirm', 'error');
                    return false;
                }

                if (["OTHSRQ"].includes(this.currentDocumentTypeCode) && this.accountName.toLowerCase().includes('piml') && !this.fiscalYear) {
                    this.notifMessage.push("Fiscal Year is required!");
                    this.documentActionNotification('confirm', 'error');
                    return false;
                }

                // const hasValidationError = await this.validateBrandAssortment();
                // if (hasValidationError) {
                //     this.spinning = false;
                //     return false;
                // }

                if (this.isEditing) {
                    this.notifMessage.push("You have unsaved changes, please save before confirming")
                    this.documentActionNotification('confirm', 'error');
                    this.spinning = false;
                    return;
                }
                //Arvs
                //is_doc_cost_dirty.length > 0 ||
                if(is_doc_quantity_dirty.length > 0 || is_doc_product_name_dirty.length > 0 || is_doc_unit_id_dirty.length > 0 || is_doc_price_dirty.length > 0 || is_doc_discount_text_dirty.length > 0 || is_doc_remarks_dirty.length > 0){
                    this.notifMessage.push("You have unsaved changes, please save before Confirming. [Document Lines]")
                    this.documentActionNotification('Confirm', 'error');
                    this.spinning = false;
                    return;
                }
                this.spinning = true;
                this.spinMessage = 'Confirming...'
                var data = this.tabulator.getData();
                if (['ORORSO'].includes(this.currentDocumentTypeCode)){
                    if (this.documentNumber > 0) {
                        var invalidQty = data.find(row => row.quantity == 0)
                        if (invalidQty != undefined){
                            this.notifMessage.push("Zero quantity is not allowed in the document line");
                            this.documentActionNotification('confirm', 'error');
                            this.spinning = false;
                            return;
                        }
                        var checkQty = data.find(row => row.requested_quantity < row.quantity)
                        if (checkQty != undefined){
                            this.notifMessage.push("quantity must less than or equal to requested quantity");
                            this.documentActionNotification('confirm', 'error');
                            this.spinning = false;
                            return;
                        }
                        var checkNotAvailableQty = data.find(row => row.quantity > row.on_hand_quantity)
                        if (checkNotAvailableQty != undefined){
                            this.continueAutoCreateTr = true
                        }
                    }
                    var put_request = await HTTPRequest.putRequest(this.endPoint + 'documents/'+this.documentNumber+'/confirm?auto_create_tr='+this.continueAutoCreateTr, null, null)
                }else{
                    var put_request = await HTTPRequest.putRequest(this.endPoint + 'documents/'+this.documentNumber+'/confirm', null, null)
                }
                if(put_request == undefined){
                    this.$emit('refreshPage', event)
                    this.openDocument(this.documentNumber,this.existingDocumentTypeDetails)
                    this.documentActionNotification('confirm', 'success')
                    this.create_action_history('CONFIRMED')
                } else {
                    if(put_request["error"] == undefined){
                        this.$emit('refreshPage', event)
                        this.openDocument(this.documentNumber,this.existingDocumentTypeDetails)
                        this.documentActionNotification('confirm', 'success')
                        this.create_action_history('CONFIRMED')
                    } else {
                        this.notifMessage = put_request["error"].split(",");
                        this.documentActionNotification('confirm', 'error')
                        this.spinning = false;
                    }
                }
                this.spinMessage = 'Loading...'
                this.spinning = false;
            },
            deliver(){

            },

            async updateOrderStatus(value){
              this.spinning = !this.spinning
              this.tabulator.clearData()
              await HTTPRequest.putRequest(`${this.endPoint}/documents/${this.documentNumber}/update_order_status`, null, {order_status:value})
              component_x.$notification['success']({
                                            message: 'Successful Operation',
                                            description: "Successfully Updated Order Status",
                                            style: getNotificationStyle('success'),
                                        });
              this.spinning = !this.spinning
              this.initializeDocument()
            },

            downloadTemplate(type){
                let urlDownload = "";
                if(type == 1)
                    urlDownload = this.endPoint + "import_templates/download_file?profile_name=documents&type=basic";
                else if(type == 2)
                    urlDownload = this.endPoint + "import_templates/download_file?profile_name=documents&type=lotcode_expiry";
                else if(type == 3)
                    urlDownload = this.endPoint + "import_templates/download_file?profile_name=documents&type=basic_with_discount";
                else if(type == 4)
                    urlDownload = this.endPoint + "import_templates/download_file?profile_name=documents&type=basic_with_discount_salesman";
                else
                    return;

                if (this.currentDocumentTypeCode == "OTHPWS") {
                    // Import Mass Upload Products for PWS
                    // Selection between Barcode and Stock No field must be visible
                    if(this.accountName.toLowerCase().includes('piml')){
                        urlDownload = `${this.endPoint}import_templates/download_file?profile_name=pws_product&type=basic_piml&save_via=${this.saveMassUploadProductVia}`;
                    }else{
                        urlDownload = `${this.endPoint}import_templates/download_file?profile_name=pws_product&type=basic&save_via=${this.saveMassUploadProductVia}`;
                    }
                        
                }
                if (this.currentDocumentTypeCode == "ORIPOX") {
                    urlDownload = `${this.endPoint}import_templates/download_file?profile_name=documents&type=purchase_order`;
                }

                if (this.currentDocumentTypeCode == "OTHPUR" || this.currentDocumentTypeCode == "RECDEL" || this.currentDocumentTypeCode == "ORIASN") {
                    urlDownload = `${this.endPoint}import_templates/download_file?profile_name=documents&type=p2p`;
                }

                axios({
                    url:  urlDownload,
                    method: 'POST',
                    responseType: 'blob', // important
                    headers: {
                        Authorization: 'Bearer ' + secureStorage.getItem("accessToken"),
                        "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File", 'ip':secureStorage.getItem("ipAddress")
                    }
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'product_import_template.csv');
                    document.body.appendChild(link);
                    link.click();
                    component_x.$notification['success']({
                        message: 'Successful Download',
                        description: "You have succesfully downloaded the template for document upload.",
                        style: getNotificationStyle('success')
                    });
                });
            },

            showPaymentMethods(){
                this.paymentDrawerVisible = true
            },
            showInitialDepositMethods(){
                this.initialDepositDrawerVisible = true
            },
            async showBooking(){
                // https://robotapitest.mrspeedy.ph/api/business/1.1/calculate-order

                var activeBooking = await HTTPRequest.getRequest(this.endPoint + "document_bookings/get_active_booking?document_id="+ this.documentNumber, null);

                var siteId = secureStorage.getItem("defaultSiteId").toString();
                var siteDetails = await HTTPRequest.getRequest(this.endPoint + "sites/"+ siteId, null);

                this.siteAddress = siteDetails.address;

                if(_.isEmpty(this.siteAddress) || _.isEmpty(this.customerAddress)){
                    this.$notification['error']({
                      message: 'Address Missing',
                      description: "Please make sure site and customer address are both configured.",
                      style: getNotificationStyle('error')
                    });
                    return;
                }

                this.bookingDrawerVisible = true
                this.siteContactNumber = siteDetails.telephone;
                this.siteContactPerson = siteDetails.contact_person;
                this.orderParemeters = {
                    matter: "BXI Order",
                    vehicle_type_id: 8,
                    points: [
                        {
                            address: this.siteAddress,
                            contact_person: {
                                phone: this.siteContactNumber,
                                name: this.siteContactPerson
                            },
                            client_order_id: this.documentNumber
                        },
                        {
                            address: this.customerAddress,
                            contact_person: {
                                phone: this.customerContactMobile,
                                name: this.customer.label
                            },
                            client_order_id: this.documentNumber
                        }
                    ]
                }

                var bookingDetails = {}
                var response = {}
                if(activeBooking.length > 0){
                    this.bookingId = activeBooking[0].id
                    bookingDetails = activeBooking[0].booking_details
                    response = activeBooking[0].booking_details.order
                    this.activeBooking = true
                }  else {
                    var recomputeRequest = await HTTPRequest.postRequest(this.endPoint + '/logistics/get_quotation', null, this.orderParemeters)
                    bookingDetails = recomputeRequest
                    response = recomputeRequest.order
                }
                // var recomputeRequest = await HTTPRequest.postRequest(this.endPoint + '/logistics/get_quotation', null, this.orderParemeters)

                this.bookingDetails = bookingDetails;
                var response = response;
                this.recompute = false;
                this.center = {lat: parseFloat(response.points[0].latitude), lng: parseFloat(response.points[0].longitude)}
                this.markers = [{
                  id: 1,
                  position: {
                    lat: parseFloat(response.points[0].latitude),
                    lng: parseFloat(response.points[0].longitude)
                  }
                }, {
                  id: 2,
                  position: {
                    lat: parseFloat(response.points[1].latitude),
                    lng: parseFloat(response.points[1].longitude)
                  }
                }]

                this.originalGeoLocation = [{
                  id: 1,
                  position: {
                    lat: parseFloat(response.points[0].latitude),
                    lng: parseFloat(response.points[0].longitude)
                  }
                }, {
                  id: 2,
                  position: {
                    lat: parseFloat(response.points[1].latitude),
                    lng: parseFloat(response.points[1].longitude)
                  }
                }]

                // this.$notification['success']({
                //   message: 'Completed Recomputation',
                //   description: "Please see updated booking fee."
                // });

                    // await axios({
                    //     method: 'post',
                    //     url: "https://robotapitest.mrspeedy.ph/api/business/1.1/calculate-order",
                    //     data: this.orderParemeters,
                    //     headers: {"X-DV-Auth-Token": "BA98FA54AF033CBE8760BF29AD49581FC3ED95FA"}
                    // })
                    // .then(function (response) {
                    //     component_x.bookingDetails = response.data;
                    //     var response = response.data.order;

                    //     component_x.center = {lat: parseFloat(response.points[0].latitude), lng: parseFloat(response.points[0].longitude)}
                    //     component_x.markers = [{
                    //       id: 1,
                    //       position: {
                    //         lat: parseFloat(response.points[0].latitude),
                    //         lng: parseFloat(response.points[0].longitude)
                    //       }
                    //     }, {
                    //       id: 2,
                    //       position: {
                    //         lat: parseFloat(response.points[1].latitude),
                    //         lng: parseFloat(response.points[1].longitude)
                    //       }
                    //     }]

                    //     component_x.originalGeoLocation = [{
                    //       id: 1,
                    //       position: {
                    //         lat: parseFloat(response.points[0].latitude),
                    //         lng: parseFloat(response.points[0].longitude)
                    //       }
                    //     }, {
                    //       id: 2,
                    //       position: {
                    //         lat: parseFloat(response.points[1].latitude),
                    //         lng: parseFloat(response.points[1].longitude)
                    //       }
                    //     }]
                    //     // component_x.paymentMethods = response.data
                    // })
                    // .catch(async function (error) {
                    // })
            },
            async recomputeBooking(){
                this.orderParemeters = {
                    matter: "BXI Order",
                    vehicle_type_id: 8,
                    points: [
                        {
                            address: this.siteAddress,
                            latitude: this.markers[0].position.lat,
                            longitude: this.markers[0].position.lng,
                            contact_person: {
                                phone: this.siteContactNumber,
                                name: this.siteContactPerson
                            },
                            client_order_id: this.documentNumber
                        },
                        {
                            address: this.customerAddress,
                            latitude: this.markers[1].position.lat,
                            longitude: this.markers[1].position.lng,
                            contact_person: {
                                phone: this.customerContactMobile,
                                name: this.customer.label
                            },
                            client_order_id: this.documentNumber
                        }
                    ]
                }

                var recomputeRequest = await HTTPRequest.postRequest(this.endPoint + '/logistics/get_quotation', null, this.orderParemeters)
                this.bookingDetails = recomputeRequest;
                this.recompute = false;
                this.$notification['success']({
                  message: 'Completed Recomputation',
                  description: "Please see updated booking fee.",
                  style: getNotificationStyle('success')
                });

                // await axios({
                //     method: 'post',
                //     url: "https://robotapitest.mrspeedy.ph/api/business/1.1/calculate-order",
                //     data: this.orderParemeters,
                //     headers: {"X-DV-Auth-Token": "BA98FA54AF033CBE8760BF29AD49581FC3ED95FA"}
                // })
                // .then(function (response) {
                //     component_x.bookingDetails = response.data;
                //     component_x.recompute = false;
                //     // componennt_x.originalGeoLocation = component_x.markers
                // })
                // .catch(async function (error) {
                // })

                this.recomputeModal = false
            },
            async proceedBooking(){
                if(this.recompute == true){
                    this.recomputeModal = true
                }else{
                    this.bookingProper()
                }
            },
            async cancelBooking(){
                var cancelRequest = await HTTPRequest.postRequest(this.endPoint + '/logistics/cancel_booking?booking_id=' + this.bookingId , null, this.orderParemeters)
                this.$notification['success']({
                  message: 'Success',
                  description: "Your booking is successfully cancelled.",
                  style: getNotificationStyle('success')
                });
                this.activeBooking = false
            },
            async bookingProper(){
                this.recomputeModal = false
                this.orderParemeters = {
                    matter: "BXI Order",
                    vehicle_type_id: 8,
                    points: [
                        {
                            address: this.siteAddress,
                            latitude: this.markers[0].position.lat,
                            longitude: this.markers[0].position.lng,
                            contact_person: {
                                phone: this.siteContactNumber,
                                name: this.siteContactPerson
                            },
                            client_order_id: this.documentNumber
                        },
                        {
                            address: this.customerAddress,
                            latitude: this.markers[1].position.lat,
                            longitude: this.markers[1].position.lng,
                            contact_person: {
                                phone: this.customerContactMobile,
                                name: this.customer.label
                            },
                            client_order_id: this.documentNumber
                        }
                    ]
                }

                var bookRequest = await HTTPRequest.postRequest(this.endPoint + '/logistics/book?document_id=' + this.documentNumber , null, this.orderParemeters)

                if(bookRequest.error == undefined){
                    this.bookingDetails = bookRequest;
                    this.recompute = false;
                    this.$notification['success']({
                      message: 'Waiting for driver..',
                      description: "We will notify you once booking has been accepted.",
                      style: getNotificationStyle('success')
                    });
                    this.activeBooking = true
                } else {
                    this.$notification['error']({
                      message: 'Failed to book.',
                      description: bookRequest.error,
                      style: getNotificationStyle('error')
                    });
                }


                // await axios({
                //     method: 'post',
                //     url: "https://robotapitest.mrspeedy.ph/api/business/1.1/create-order",
                //     data: this.orderParemeters,
                //     headers: {"X-DV-Auth-Token": "BA98FA54AF033CBE8760BF29AD49581FC3ED95FA"}
                // })
                // .then(function (response) {
                //     component_x.bookingDetails = response.data;
                //     component_x.$notification['success']({
                //       message: 'Waiting for driver...',
                //       description: "We will notify you once booking has been accepted."
                //     });
                // })
                // .catch(async function (error) {
                // })
            },
            async pay(documentNumber){
                this.spinning = true;
                var curr_document = await HTTPRequest.getRequest(this.endPoint + "documents/"+ documentNumber, null);

                if(this.paymentMode == "paymaya"){
                    var request_body = {
                        type: "paymaya",
                        document: curr_document
                    }
                    var post_request = await HTTPRequest.postRequest(this.endPoint + 'integrations/get_url', null, request_body)

                    if(post_request["error"] == undefined){
                        if (this.forPaymentIsPosting == true) {
                            this.forPaymentIsProcessed = true;
                            this.post();
                        }else{
                        this.openDocument(documentNumber,this.existingDocumentTypeDetails);
                        this.documentActionNotification('pay', 'success')
                    }
                    }
                } else if(this.paymentMode == "dragonpay") {
                    this.paymentErrors = []
                    if (this.paymentMethod == null) {
                        this.paymentErrors.push("Please select a payment method")
                    }else{
                        var request_body = {
                            type: "dragonpay",
                            document: curr_document,
                            procId: this.paymentMethod
                        }
                        var post_request = await HTTPRequest.postRequest(this.endPoint + 'integrations/get_url', null, request_body)

                        if(post_request["error"] == undefined){
                            if (this.forPaymentIsPosting == true) {
                                this.forPaymentIsProcessed = true;
                                this.post();
                            }else{
                                this.openDocument(documentNumber,this.existingDocumentTypeDetails)
                                this.documentActionNotification('pay', 'success')
                            }
                        }
                    }
                } else {
                    this.paymentErrors = []
                    if (this.bankTransferReference == "") {
                        this.paymentErrors.push("Please input a reference number")
                    }else{
                        var request_body = {
                            type: "bank",
                            document: curr_document,
                            reference: this.bankTransferReference
                        }
                        var post_request = await HTTPRequest.postRequest(this.endPoint + 'integrations/get_url', null, request_body)
                        if(post_request["error"] == undefined){
                            if (this.forPaymentIsPosting == true) {
                                this.forPaymentIsProcessed = true;
                                this.post();
                            }else{
                                this.openDocument(documentNumber,this.existingDocumentTypeDetails)
                                this.documentActionNotification('pay', 'success')
                            }
                        }
                    }
                }
                this.spinning = false;
            },
            async unconfirm() {
                this.spinning = true;
                this.spinMessage = 'Unconfirming...'

            // OLD checking using reference 2
            // if (['RELTRX'].includes(this.currentDocumentTypeCode)) {
            //     if (this.documentNumber > 0) {
            //         const document = await HTTPRequest.getRequest(this.endPoint + "documents/" + this.documentNumber, null);
            //         const ref2 = document.reference_2;

            //         if (ref2 && ref2.trim() !== "") {
            //             this.notifMessage = ["Unconfirming is not allowed: This document has already been sent to Boxme (Reference 2 is not blank)."];
            //             this.documentActionNotification('unconfirm', 'error');
            //             this.spinning = false;
            //             return;
            //         }
            //     }
            // }

            // NEW checking using is_exported
            if (['RELTRX', 'ORIASN'].includes(this.currentDocumentTypeCode)) {
                if (this.documentNumber > 0) {
                    const document = await HTTPRequest.getRequest(this.endPoint + "documents/" + this.documentNumber, null);
                    const isExported = document.is_exported;
                    const wmsStatus = document.wms_status;

                    // allow unconfirm if wms_status is in cancel list, regardless of is_exported
                    const allowedWmsStatuses = ["700", "701", "703", "705", "708", "212"];
                    const isAllowedWmsStatus = allowedWmsStatuses.includes(wmsStatus);

                    if (!isAllowedWmsStatus && (isExported === true || isExported === 1)) {
                        this.notifMessage = ["Unconfirming is not allowed: This document has already been exported (is_exported = true)."];
                        this.documentActionNotification('unconfirm', 'error');
                        this.spinning = false;
                        return;
                    }
                }
            }

                var put_request = await HTTPRequest.putRequest(this.endPoint + 'documents/'+this.documentNumber+'/unconfirm', null, null)
                if(put_request == undefined){
                    this.$emit('refreshPage', event)
                    this.openDocument(this.documentNumber,this.existingDocumentTypeDetails)
                    this.documentActionNotification('unconfirm', 'success')
                    this.create_action_history('UNCONFIRMED')
                    this.spinning = false;
                } else {
                    if(put_request["error"] == undefined){
                        this.$emit('refreshPage', event)
                        this.openDocument(this.documentNumber,this.existingDocumentTypeDetails)
                        this.documentActionNotification('unconfirm', 'success')
                        this.create_action_history('UNCONFIRMED')
                        this.spinning = false;
                    } else {
                        this.notifMessage = put_request["error"].split(",");
                        this.documentActionNotification('unconfirm', 'error')
                        this.spinning = false;
                    }
                }
                this.spinMessage = 'Loading...'
                this.spinning = false;
            },
            async create_action_history(action) {
                var actionHistoryPayload = {
                    action: action,
                    action_at: moment(new Date()),
                    action_by: secureStorage.getItem("userName"),
                    document_id: this.documentNumber,
                    status: "A"
                }
                await HTTPRequest.postRequest(this.endPoint + 'document_action_histories/', null, actionHistoryPayload)
            },
            async freeze(){
                window.scrollTo(0,0);
                this.importMode = 1
                this.spinning = true;
                this.notifMessage = [];
                var data = this.tabulator.getData();

                if (data.length > 0) {
                    this.isEditing = !(component_x.origData === JSON.stringify(data))
                }

                if (this.isEditing && !this.isChangeAction) {
                    this.notifMessage.push("You have unsaved changes, please save before freezing inventory")
                    this.documentActionNotification('freeze', 'error');
                    this.spinning = false;
                    return;
                } else {
                    if (component_x.documentNumber > 0) {
                        var post_request = await HTTPRequest.postRequest(this.endPoint + 'documents/freeze/?document_id='+component_x.documentNumber, null)
                        post_request
                        if (post_request['success']){
                            this.openDocument(component_x.documentNumber,this.existingDocumentTypeDetails)
                            this.documentActionNotification('freeze', 'success')
                        } else if (post_request['error']){
                            this.notifMessage = post_request['error'].split(',');
                            this.documentActionNotification('freeze', 'error')
                        }
                    }
                }
                this.spinning = false;
            },
            autocompleteFilterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toUpperCase().indexOf(input.toUpperCase()) >= 0
                );
            },
            async toggleDocumentTrade(){
                this.isDocumentTrade = !this.isDocumentTrade
                await this.tabulator.clearData();
                this.calculateSummary();
            },
            refreshDocument() {
              this.openDocument(this.documentNumber,this.existingDocumentTypeDetails,1);
            },
            async printRequest(isDefaultPrint, customFont, withWithholding = true) {
                // withWithholding: for SI (OTHSIN) and CM (RECCSR), choose between the
                // new format WITH withholding tax (default) and the old/current format
                // WITHOUT (less) withholding. The two print menu options pass this flag.
                var summaryData = {
                        gross_amount: this.grossAmountDisplay,
                        item_discount: this.itemDiscount,
                        net_amount: this.netAmountDisplay,
                        vatables: this.vatableSalesAmount,
                        net_amount_wo_tax: this.netAmountWithoutTax,
                        vat_ex: this.vatExemptSalesAmount,
                        vat_amount: this.vatAmount
                    }

                let currentSiteCode = this.documentCurrentSiteCode;
                const isPIMLAccount = this.accountName.toLowerCase().includes('piml');
                // use siteCode as this value is unique for checking which printout to use (with different bank details)
                const isPIMLHQ = currentSiteCode === '000001'
                const isPIMPL  = currentSiteCode === '000003'

                // console.log("isPIMLAccount", isPIMLAccount);
                // console.log("isPIMLHQ", isPIMLHQ);
                // console.log("isPIMPL", isPIMPL);

                if (this.currentDocumentTypeCode == 'OTHSIN') {
                    if (isPIMLAccount && isPIMLHQ) {
                        // console.log("PRINT OTHSIN PIML HQ");
                        await this.printOTHSINPIMLHQ(isDefaultPrint, customFont);
                    } else if (isPIMLAccount && isPIMPL) {
                        // console.log("PRINT OTHSIN PIMPL");
                        await this.printOTHSINPIMPL(isDefaultPrint, customFont);
                    } else if (withWithholding) {
                        // NEW format WITH withholding tax
                        await this.printOTHSINWithholding(isDefaultPrint, customFont, summaryData, this);
                    } else {
                        // OLD/current format, WITHTOUT withholding tax
                        await this.printOTHSIN(isDefaultPrint, customFont, summaryData, this);
                    }
                } else if (this.currentDocumentTypeCode == 'RELDDE') {
                    // console.log("PRINT RELDDE");
                    await this.printRELDDE(isDefaultPrint, customFont);
                } else if (this.currentDocumentTypeCode == 'ORIPOX') {
                    // console.log("PRINT ORIPOX");
                    await this.printORIPOX(isDefaultPrint, customFont);
                } else if (this.currentDocumentTypeCode == 'ORISOX') {
                    if (isPIMLAccount && isPIMLHQ) {
                        // console.log("PRINT ORISOX PIML HQ");
                        await this.printORISOXPIMLHQ(isDefaultPrint, customFont);
                    } else if (isPIMLAccount && isPIMPL) {
                        // console.log("PRINT ORISOX PIMPL");
                        await this.printORISOXPIMPL(isDefaultPrint, customFont);
                    } else {
                        // console.log("PRINT ORISOX DEFAULT PRINTOUT");
                        await this.printORISOX(isDefaultPrint, customFont);
                    }
                } else if (this.currentDocumentTypeCode == 'RECCSR') {
                    if (withWithholding) {
                        // NEW format WITH withholding tax
                        await this.printRECCSRWithholding(isDefaultPrint, customFont, summaryData);
                    } else {
                        // OLD/current format, WITHOUT withholding tax
                        await this.printRECCSR(isDefaultPrint, customFont, summaryData);
                    }
                } else if (this.currentDocumentTypeCode == 'RELTRX') {
                    // console.log("PRINT RELTRX");
                    await this.printRELTRX(isDefaultPrint, customFont);
                } else if (this.accountName.toLowerCase().includes('piml') && this.currentDocumentTypeCode == 'OTHSRQ') {
                    // console.log("PRINT OTHSRQ");
                    await this.printORISOXPIML(isDefaultPrint, customFont);
                } else if (this.accountName.toLowerCase().includes('primer') && this.currentDocumentTypeCode == 'OTHTOV') {
                    // console.log("PRINT OTHTOV");
                    await this.printTOV(isDefaultPrint, customFont);
                } else if (this.accountName.toLowerCase().includes('primer') && this.currentDocumentTypeCode == 'OTHPCV') {
                    // console.log("PRINT OTHPCV");
                    await this.printPCV(isDefaultPrint, customFont);
                } else {
                    await this.print(isDefaultPrint, customFont);
                }
            },
            async print(isDefaultPrint, customFont){

                let headerCustomPosition = 0
                let xCustomPosition = 0
                if(customFont == 'dotMatrix') {
                    headerCustomPosition = -10
                    xCustomPosition = 10
                }
                this.printDefault = isDefaultPrint;
                this.spinning = true;

                // alert("Font Size: " + this.printFontSizeIncrease)
                var fontSizeIncreaser = this.printFontSizeIncrease || 0
                var valueHeaderPos = this.printValueHeaderPos
                var valueFooterPos = this.printValueFooterPos

                var friendlyOriginDocumentNo = component_x.friendlyOriginDocumentNo || ''
                var currentDocumentTypeCode = this.currentDocumentTypeCode || ''
                var documentType = this.currentDocumentTypeName || ''
                var currentSiteName = secureStorage.getItem("defaultSiteName") || '';
                const currentSiteId = secureStorage.getItem("defaultSiteId") || '';
                let requestingSiteName = this.requestingSite.label;
                let requestingSiteId = this.requestingSite.key;

                var userCode = secureStorage.getItem("userCode") || '';
                var createdBy = this.createdBy || '';
                var postedBy = ['RECADJ', 'RELADJ'].includes(currentDocumentTypeCode) ? (this.documentDetails.posted_by_user_name || '') : (this.postedBy || '');
                var userName = this.documentDetails.posted_by_user_name || '';
                var createdByUserName = this.documentDetails.created_by_user_name || '';

                var siteName = this.distributionSite.label || ''
                var customerName = this.customer.label || ''
                var customerAddress = this.customerAddress.trim() || ''

                var supplier = this.supplier.label || ''
                var supplyingBranch = this.supplyingSite.label || ''
                var requestingBranch = this.requestingSite.label || ''
                var sublocationSite = this.distributionSite.label || ''
                var originSublocation =  this.originSublocation.label || ''
                var destinationSublocation = this.destinationSublocation.label || ''
                var party = this.party || ''
                var documentDate = this.documentDate.format('D-MMM-YYYY') || ''
                var targetDate = this.targetDate.format('D-MMM-YYYY') || ''
                var cancellationDate = this.cancellationDate.format('D-MMM-YYYY') || ''

                var currentDocumentTypeFriendlyCode = this.currentDocumentTypeFriendlyCode || ''
                var documentStatus = this.documentStatus || ''
                var documentNumber = this.documentNo || ''

                var reference = this.reference || ''
                var ocReference = this.documentDetails.oc_ref_no || ''
                var shipmentReference = this.documentDetails.shipment_ref_no || ''
                var referenceLabel = this.referenceLabel || 'Reference'
                var remark = this.remark || ''
                var imageReferenceLink = this.imageReferenceLink || ''
                var purpose = this.purpose.label || ''
                var casNo =  this.documentDetails.cas_no || ''

                var printDate = moment().format('lll') || '';
                var postDate = moment(this.postDate).format('lll') || ''

                var creationDateAdj = moment(this.documentDetails.created_at).format('M/DD/YYYY HH:mm:ss') || '';
                var postDateAdj = this.postDate ? moment(this.postDate).format('M/DD/YYYY HH:mm:ss') : '';

                var doc = new jsPDF();
                let currencyKey = component_x.currency.key;
                let currencyLabel = component_x.currency.label;
                let documentCurrencyLabel = this.documentDetails.currency_id.label;
                let currencyRate = (component_x.documentDetails.currency_rate!=0 && component_x.documentDetails.currency_rate!=null && component_x.documentDetails.currency_rate!=undefined && component_x.documentDetails.currency_rate!='0.0') ? Number(component_x.documentDetails.currency_rate).toFixed(2) : '1';
                var header_position = ['RECADJ', 'RELADJ'].includes(currentDocumentTypeCode) ? 125 + headerCustomPosition : 130 + headerCustomPosition
                var value_position = 170
                var line_position = 195
                var total_plus_width = 0
                var minus_height = 0
                var initial_deposit = 0
                var balance = 0
                var orientation = "portrait"
                var papersize = "a4"
                var x_position = 0
                var showDiscountAmountValue = 0
                var showTotalVatValue = 0

                // console.log("documentDetails: ", this.documentDetails)
                
                if (currentDocumentTypeCode == 'OTHPUR' || currentDocumentTypeCode == 'ORIASN' || currentDocumentTypeCode == 'RECDEL' || currentDocumentTypeCode == 'RELRSR') {
                    var vendor_item_no = this.tabulator.getColumn("vendor_item_no");
                    vendor_item_no.updateDefinition({download: true});
                    this.tabulator.moveColumn("vendor_item_no", "product_name", true);
                }
                if (currentDocumentTypeCode == 'RECADJ' || currentDocumentTypeCode == 'RELADJ') {
                    let adjData = this.tabulator.getData();
                    var adj_gross_amount = this.tabulator.getColumn("gross_amount");
                    adj_gross_amount.updateDefinition({download: false});
                    
                    adjData = adjData.map(item => {
                        return {
                            ...item,
                            brand_id: item.brand_name
                        };
                    });

                    this.tabulator.setData(adjData);
                    var unit = this.tabulator.getColumn("unit_id");
                    unit.updateDefinition({download: false});
                    var brand = this.tabulator.getColumn("brand_id");
                    brand.updateDefinition({download: true});
                    this.tabulator.moveColumn("barcode", "product_name", false);
                    
                } 
                if (currentDocumentTypeCode == 'ORIASN' || currentDocumentTypeCode == 'RELRSR'){
                    var barcode = this.tabulator.getColumn("barcode")
                    barcode.updateDefinition({download:false})
                }

                if (currentDocumentTypeCode == 'RELRSR'){
                    quantity = this.tabulator.getColumn("quantity")
                    quantity.updateDefinition({download:true})
                  // quantity.updateDefinition({title:'Doc Qty'})

                    var refcode = this.tabulator.getColumn("ref_code")
                    refcode.updateDefinition({download: false})

                    var price = this.tabulator.getColumn("price")
                    price.updateDefinition({title:'Ordering Cost'})
                }

                if (currentDocumentTypeCode == 'RECDEL'){
                    let rrData = this.tabulator.getData();
                    rrData = rrData.map(item => {
                        return {
                            ...item,
                            subtotal: Number(item.subtotal) + Number(item.trade_discount)
                        };
                    });
                    var stock_no = this.tabulator.getColumn("stock_no")
                    stock_no.updateDefinition({download:false})
                    this.tabulator.moveColumn("barcode", "product_name", false);
                }
                if (currencyKey>0 && component_x.showConversionRate){
                    var subtotal = this.tabulator.getColumn("subtotal")
                    await subtotal.updateDefinition({download:false})
                    var subtotal_php = this.tabulator.getColumn("subtotal_php")
                    await subtotal_php.updateDefinition({downloadTitle: "Subtotal", download:true})
                    var price = this.tabulator.getColumn("price")
                    await price.updateDefinition({download:false})
                    var cost_php = this.tabulator.getColumn("price_php")
                    await cost_php.updateDefinition({downloadTitle: "Cost", download:true})
                }

                if(currentDocumentTypeCode == 'OTHPWS'){
                    papersize = "a4"
                    orientation = "landscape"
                    header_position = 220 + headerCustomPosition
                    value_position = 300
                    line_position = 280
                    minus_height = 85
                    total_plus_width = 70
                    var old_landed_cost = this.tabulator.getColumn("old_landed_cost")
                    await old_landed_cost.updateDefinition({download:true})
                    var old_original_cost = this.tabulator.getColumn("old_original_cost")
                    await old_original_cost.updateDefinition({download:true})
                    var original_cost = this.tabulator.getColumn("original_cost")
                    await original_cost.updateDefinition({download:true})
                    var old_ordering_cost = this.tabulator.getColumn("old_ordering_cost")
                    await old_ordering_cost.updateDefinition({downloadTitle: "Old ORD", download:true})
                    var ordering_cost = this.tabulator.getColumn("ordering_cost")
                    await ordering_cost.updateDefinition({downloadTitle: "New ORD", download:true})
                    var old_wholesale_price = this.tabulator.getColumn("old_wholesale_price")
                    await old_wholesale_price.updateDefinition({downloadTitle: "Old WHS Price", download:true})
                    var wholesale_price = this.tabulator.getColumn("wholesale_price")
                    await wholesale_price.updateDefinition({downloadTitle: "New WHS Price", download:true})
                    var old_least_price = this.tabulator.getColumn("old_least_price")
                    await old_least_price.updateDefinition({downloadTitle: "Old LS Price", download:true})
                    var least_price = this.tabulator.getColumn("least_price")
                    await least_price.updateDefinition({downloadTitle: "New LS Price", download:true})
                    var old_special_price = this.tabulator.getColumn("old_special_price")
                    await old_special_price.updateDefinition({downloadTitle: "Old SP Price", download:true})
                    var special_price = this.tabulator.getColumn("special_price")
                    await special_price.updateDefinition({downloadTitle: "New SP Price", download:true})
                    var markup_percent = this.tabulator.getColumn("markup_percent")
                    await markup_percent.updateDefinition({downloadTitle: "Markup %", download:true, accessorParams:{}, 
                        accessor:function(value, data, accessorParams){
                            return Number(value).toFixed(2);
                        }})
                    var document_line_serials_text = this.tabulator.getColumn("document_line_serials_text")
                    await document_line_serials_text.updateDefinition({download:false})
                    var price = this.tabulator.getColumn("price")
                    await price.updateDefinition({download:false})
                    var subtotal = this.tabulator.getColumn("subtotal")
                    await subtotal.updateDefinition({download:false})
                    // var stock_no = this.tabulator.getColumn("stock_no")
                    // await stock_no.updateDefinition({width: 5})
                    const columns = ["original_cost", "least_price", "wholesale_price", "special_price", "ordering_cost"];
                    const rowData = this.tabulator.getData();
                    console.log(rowData)
                    rowData.forEach((row) => {
                        columns.forEach((col) => {
                            if (row[col] === null) {
                            row[col] = "";
                            }
                        });
                    });
                     // Update the table with the modified data
                    this.tabulator.setData(rowData);


                }
                const rowData = this.tabulator.getData();
                rowData.forEach((row) => {
                    row["brand_id"] = row["brand_name"]
                });
                this.tabulator.setData(rowData);
                if(currentDocumentTypeCode == 'ORIPOX' || currentDocumentTypeCode == 'OTHTRA' || currentDocumentTypeCode == 'OTHPCK'){
                    var priceInclusion = this.documentDetails.reference_8 || ''
                    var comment1 = this.documentDetails.reference_9 || ''
                    var comment2 = this.documentDetails.reference_10 || ''
                }
                var showRefCode = false,showStockNoInProductList = false
                var printSettingEnabledCount = 0;
                if (this.document_config.document_type_settings.printSettings!= undefined){
                    showRefCode = this.document_config.document_type_settings.printSettings.showRefCode
                    showStockNoInProductList = this.document_config.document_type_settings.printSettings.showStockNoInProductList
                    if(showRefCode != undefined && showRefCode == true &&  currentDocumentTypeCode != 'RELRSR'){
                        printSettingEnabledCount +=1
                        var ref_code = this.tabulator.getColumn("ref_code")
                        ref_code.updateDefinition({download: true})
                    }
                    
                    if(currentDocumentTypeCode == 'ORIPOX' && showStockNoInProductList != undefined && showStockNoInProductList == true){
                        printSettingEnabledCount +=1
                        var supplier_stock_no = this.tabulator.getColumn("supplier_stock_no")
                        supplier_stock_no.updateDefinition({download:true})
                        if (this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.enableShowingSupplierStockNumber!=undefined && this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.enableShowingSupplierStockNumber==true) {
                            this.tabulator.showColumn("supplier_stock_no")
                        }
                    }
                    if(this.document_config.document_type_settings.printSettings.showSerialNoInProductList != undefined && this.document_config.document_type_settings.printSettings.showSerialNoInProductList == true){
                        printSettingEnabledCount +=1
                        var supplier_stock_no = this.tabulator.getColumn("document_line_serials_text")
                        supplier_stock_no.updateDefinition({download:true})
                    }
                    if(this.document_config.document_type_settings.printSettings.showDesignAndSizeInProductList != undefined && this.document_config.document_type_settings.printSettings.showDesignAndSizeInProductList == true){
                        printSettingEnabledCount +=2
                        var design = this.tabulator.getColumn("design")
                        design.updateDefinition({download:true})
                        var size = this.tabulator.getColumn("size")
                        size.updateDefinition({download:true})
                    }
                    if(this.document_config.document_type_settings.printSettings.enableShowingInitialDepositField!=undefined && this.document_config.document_type_settings.printSettings.enableShowingInitialDepositField==true){
                        printSettingEnabledCount +=1
                        this.showDocumentPayment("initialDeposit")
                        initial_deposit = Number(this.documentPaymentsList.reduce(function(prev, cur) { return Number(prev) + Number(cur.amount); }, 0)) || Number(this.documentDetails.reference_7) || 0
                    }
                    if(this.document_config.document_type_settings.printSettings.enableLandscapePrinting != undefined && this.document_config.document_type_settings.printSettings.enableLandscapePrinting == true){
                        orientation = "landscape"
                        header_position = 220 + headerCustomPosition
                        value_position = 260
                        line_position = 280
                        minus_height = 85
                        if (currentDocumentTypeCode == 'ORIPOX' && !this.document_config.document_type_settings.printSettings.showStockNoInProductList){
                            total_plus_width = 58
                        }else {
                            total_plus_width = 66
                        }
                        if(!this.document_config.document_type_settings.printSettings.showSerialNoInProductList){
                            total_plus_width = 78
                        }
                    }         

                    if(this.document_config.document_type_settings.printSettings.showTotalVat != undefined && this.document_config.document_type_settings.printSettings.showTotalVat == true){
                        var showTotalVat = this.document_config.document_type_settings.printSettings.showTotalVat
                        showTotalVatValue = this.documentDetails.tax_amount
                    }
                    if(this.document_config.document_type_settings.printSettings.showNetAmountWithoutVat != undefined && this.document_config.document_type_settings.printSettings.showNetAmountWithoutVat == true){
                        var showNetAmountWithoutVat = this.document_config.document_type_settings.printSettings.showNetAmountWithoutVat
                    }
                    if(this.document_config.document_type_settings.printSettings.showTotalPrice != undefined && this.document_config.document_type_settings.printSettings.showTotalPrice == true){
                        var showTotalPrice = this.document_config.document_type_settings.printSettings.showTotalPrice
                    }
                    if(this.document_config.document_type_settings.printSettings.showDiscountAmount != undefined && this.document_config.document_type_settings.printSettings.showDiscountAmount == true){
                        var showDiscountAmount = this.document_config.document_type_settings.printSettings.showDiscountAmount
                        //showDiscountAmountValue = Number((component_x.discountTotal * 100)/100) ||  Number(this.documentDetails.amount_header_discount)
                        showDiscountAmountValue = Number(this.itemDiscount || 0) + Number(this.overallDiscount || 0) 
                    }
                    if(this.document_config.document_type_settings.printSettings.showOtherCharges != undefined && this.document_config.document_type_settings.printSettings.showOtherCharges == true){
                        var showOtherCharges = this.document_config.document_type_settings.printSettings.showOtherCharges
                    }
                }

                let tempdata = this.tabulator.getData();
            
                var column_names = []
                if(currentDocumentTypeCode =='OTHCNS'){
                    let document_lines = await HTTPRequest.getRequest(component_x.endPoint + "documents/get_count_set_pcount_lines?id="+component_x.documentNumber, null);
                    this.tabulator.replaceData(document_lines)
                    this.tabulator.toggleColumn("line_no")
                    this.tabulator.toggleColumn("product_name")
                    this.tabulator.toggleColumn("stock_no")
                    this.tabulator.toggleColumn("barcode")
                    this.tabulator.toggleColumn("unit_id")
                    this.tabulator.toggleColumn("quantity")
                    this.tabulator.getColumn('actual_quantity').updateDefinition({title:"Frozen Quantity"})
                    this.tabulator.toggleColumn("actual_quantity")
                    this.tabulator.toggleColumn("price")
                    this.tabulator.toggleColumn("cost")
                    this.tabulator.toggleColumn("subtotal")
                    this.tabulator.toggleColumn("on_hand_quantity")
                }else if ((currentDocumentTypeCode == 'OTHTRA' || currentDocumentTypeCode == 'OTHPCK') && isDefaultPrint == false){
                    var lines = this.tabulator.getData();
                    for(var i = 0; i < lines.length; i++) {
                        if (lines[i].site_allocation!=undefined && lines[i].site_allocation!=null){
                            lines[i].site_allocation.forEach(function(obj) {
                                if (currentDocumentTypeCode=='OTHPCK'){
                                    var qty = (obj.available_quantity == 0) ? '' : obj.available_quantity
                                    if(component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.AllocationDefaultValue == 'SC'){
                                        lines[i][`${obj.code}`] = qty
                                    } else {
                                        lines[i][`${obj.refcode}`] = qty
                                    }
                                }else{
                                    var qty = (obj.quantity == 0) ? '' : obj.quantity
                                    if(component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.AllocationDefaultValue == 'SC'){
                                        lines[i][`${obj.code}`] = qty
                                    } else {
                                        lines[i][`${obj.refcode}`] = qty
                                    }
                                }
                                if (!column_names.includes(obj.code) && component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.AllocationDefaultValue == 'SC') {
                                    column_names.push(obj.code);
                                }

                                if (!column_names.includes(obj.refcode) && component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.AllocationDefaultValue == 'RC') {
                                    column_names.push(obj.refcode);
                                }
                            });
                        }
                    }
                    this.tabulator.replaceData(lines)
                    for (var index = 0; index < column_names.length; index++) { this.tabulator.addColumn({title:column_names[index], field:column_names[index], download: true, visible:false, align: 'right'}) }
                    if (column_names.length > 5){
                        this.continueWithPrintPdf = false
                        this.$confirm({
                        title: "Allocation is more than 5 sites, print to pdf is not possible",
                        content: h => <div>Do you want to export this via excel?</div>,
                        onOk: () => {
                            this.downLoadExcelIfMoreThan5Site()
                        },
                        onCancel() {}
                        });
                    }
                }
                
                let siteData = {};
                let supplierData = {};
                let companyData = {};
                let currentSiteData = {};
                if (this.continueWithPrintPdf){
                    if (currentDocumentTypeCode == 'ORIPOX' || currentDocumentTypeCode == 'RELRSR' || currentDocumentTypeCode == 'RECDEL' || currentDocumentTypeCode == 'OTHPUR' || currentDocumentTypeCode == 'OTHSBI' || currentDocumentTypeCode == 'ORIASN') {
                    requestingSiteId = this.documentDetails.site_id.key
                    requestingSiteName = this.documentDetails.site_id.label
                    siteData = await HTTPRequest.getRequest(`${this.endPoint}sites/${requestingSiteId}` , null, null);
                    companyData = await HTTPRequest.getRequest(`${this.endPoint}companies/${siteData.company_id}` , null, null);
                    supplierData = await HTTPRequest.getRequest(`${this.endPoint}suppliers/${this.supplier.key}` , null, null);
                        if(currentDocumentTypeCode == 'ORIPOX' && component_x.document_config.document_type_settings.printSettings.includeImageInPrintout!=undefined && component_x.document_config.document_type_settings.printSettings.includeImageInPrintout == true){
                            var imgLogo = new Image()
                            var arrImgLogos = []
                            var config = {
                                method: 'get',
                                url: `${this.endPoint}documents/get_product_image?stock_no=${this.tabulator.getData()[0].stock_no}`,
                                headers: {'Authorization': 'Bearer ' + secureStorage.getItem("accessToken"), 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress")},
                                // headers: {'Authorization': 'Bearer ' + 'BX-pG09P8sgsNKczX9CtRaxNeH7S_kD6NCuxC3Twzo0'},
                            }
                            var imageResponse;
                            await axios(config)
                                .then(function (response) {
                                    imageResponse = response.data
                                })
                                .catch(function (error) {
                                    console.log(error)
                            });

                            if(imageResponse["error"] == undefined){
                                if (imageResponse.images_url != undefined && imageResponse.images_url.length > 0){
                                    for(let  i = 0; i < imageResponse.images_url.length; i++){
                                        var img = new Image()
                                        img.src = imageResponse.images_url[i]
                                        arrImgLogos.push(img)
                                    }
                                }
                                else if (imageResponse.image != undefined && imageResponse.image != ""){
                                    imgLogo.src = "data:image/"+imageResponse.file_type+";base64,"+imageResponse.image
                                    var stock_no = this.tabulator.getData()[0].stock_no
                                }
                            }
                            console.log(arrImgLogos)
                        }
                    }
                    if (currentDocumentTypeCode == 'RECADJ' || currentDocumentTypeCode == 'RELADJ' ) {
                        siteData = await HTTPRequest.getRequest(`${this.endPoint}sites/${this.documentDetails.site_id.key}` , null, null);
                        companyData = await HTTPRequest.getRequest(`${this.endPoint}companies/${siteData.company_id}` , null, null);
                    }
                    let tabulatorInstance = this.$refs.tabulator.getInstance();
                    var calculation = tabulatorInstance.getCalcResults();
                    var startY = 90 
                    function addTextWithFormatting(doc, label, value, x, y, maxWidth) {
                        doc.setFont(undefined, "bold");
                        doc.setFontSize(8 + fontSizeIncreaser);
                        doc.text(label, x, y);
                        doc.setFont(undefined, "normal");
                        let valueLines = doc.splitTextToSize(value, maxWidth);
                        doc.text(valueLines, 35, y);
                    }    
                    // console.log("instance: ",tabulatorInstance.getColumns());
                    tabulatorInstance.downloadToTab("pdf", "data"+isDefaultPrint+".pdf", {
                        orientation:orientation,
                        jsPDF:{
                            unit:"mm",
                            putOnlyUsedFonts:true,
                            // format: this.printPaperSize,
                            format:papersize
                        },
                        autoTable:function(doc){
                            // tabulatorInstance.getColumns({download: true});
                            //HEADER
                            doc.addFileToVFS('Epson1-normal.ttf', Epsonfont);
                            doc.addFont('Epson1-normal.ttf', 'Epson1', 'normal');
                            doc.addFileToVFS('Epson1-bold.ttf', Epsonfontbold);
                            doc.addFont('Epson1-bold.ttf', 'Epson1', 'bold');
                            if(customFont == 'dotMatrix'){
                                doc.setFont("Epson1");
                            }
                            if (currentDocumentTypeCode == 'ORISOX' || currentDocumentTypeCode == 'OTHSRQ' || currentDocumentTypeCode == 'ORIOSO' || currentDocumentTypeCode == 'OTHSIN' || currentDocumentTypeCode == 'RELDDE' || currentDocumentTypeCode == 'RECCSR' || currentDocumentTypeCode == 'ORIOCR' || currentDocumentTypeCode == 'RECCSI') {
                                doc.setFontSize(10 + fontSizeIncreaser);
                                doc.text("Site:", 15, 50);
                                doc.setFontStyle("bold");
                                doc.text(siteName, 40, 50);
                                doc.setFontStyle("normal");

                                doc.text("Customer:", 15, 60);
                                doc.setFontStyle("bold");
                                doc.text(customerName, 40, 60);
                                doc.setFontStyle("normal");
                                doc.setFontSize(8 + fontSizeIncreaser);

                                if (customerAddress.length > 50){
                                    var cut = customerAddress.length /4;
                                    doc.text(customerAddress.slice(0, cut).trim(), 40, 65);
                                    doc.text(customerAddress.slice(cut, cut*2).trim(), 40, 70);
                                    doc.text(customerAddress.slice(cut*2, cut*3).trim(), 40, 75);
                                    doc.text(customerAddress.slice(cut*3, cut*4).trim(), 40, 80);
                                }else {
                                    doc.text(customerAddress, 40, 65);
                                }
                            }
                            
                            if (currentDocumentTypeCode == 'OTHPUR' || currentDocumentTypeCode == 'OTHSBI' || currentDocumentTypeCode == 'RECDEL' || currentDocumentTypeCode == 'ORIASN' || currentDocumentTypeCode == 'RELRSR') {
                                doc.setFontSize(10 + fontSizeIncreaser);
                                doc.setFontStyle("bold");
                                if (currentDocumentTypeCode == 'RECDEL'){
                                    doc.setFontStyle("normal");
                                    doc.setFontSize(9 + fontSizeIncreaser);

                                }
                                var supplier_address = [
                                    supplierData.billing_address && supplierData.billing_address.length > 0 ? supplierData.billing_address : '',
                                    supplierData.barangay_name && supplierData.barangay_name.length > 0 ? supplierData.barangay_name : '',
                                    supplierData.city_name && supplierData.city_name.length > 0 ? supplierData.city_name : '',
                                    supplierData.province_name && supplierData.province_name.length > 0 ? supplierData.province_name : '',
                                    supplierData.zip_code && supplierData.zip_code.length > 0 ? supplierData.zip_code : '',
                                ].filter(address => address.length > 0).join(', ')
                                //const supplierAddress = supplierData.billing_address || '';
                                doc.setFontStyle("normal");

                                const tin = supplierData.tin || '';
                                let splitTitle = doc.splitTextToSize(`Supplier: ${supplier}\nAddress: ${supplier_address}\nTIN #: ${tin}`, 90);
                                let companyAddressTextWidth = doc.getTextWidth(companyData.address);
                                let supplierNameTextWidth = doc.getTextWidth(supplier);
                                let supplerAddressTextWidth = doc.getTextWidth(supplier_address);
                                let addSpacing = companyAddressTextWidth > 82 ? 5 : 0
                                let addSpacing2 = supplierNameTextWidth > 82 ? 5 : 0
                                let addSpacing3 = supplerAddressTextWidth > (82 * 2) ? 8 : 
                                                  supplerAddressTextWidth > 82 ? 5 : 0
                                let addLineSpace = addSpacing + addSpacing2 + addSpacing3

                                if (currentDocumentTypeCode == 'RECDEL'){
                                    addTextWithFormatting(doc, "Supplier:", supplier, 15, 50 + addSpacing, 75);
                                    addTextWithFormatting(doc, "Address:", supplier_address.toUpperCase(), 15, 55 + (addSpacing+ addSpacing2), 75);
                                    addTextWithFormatting(doc, "TIN #:", tin, 15, 60 + addLineSpace, 75);
                                }else {
                                    doc.text(15, 50 + addSpacing, splitTitle);
                                }

                            }

                            if (currentDocumentTypeCode == 'ORIPOX') {
                                doc.setFontSize(9 + fontSizeIncreaser);
                                if (currentDocumentTypeCode == 'ORIPOX'){
                                    doc.setFontStyle("bold");
                                } 
                                // doc.text(supplier, 40, 50);
                                const supplierName = supplierData.name || '';
                                const supplierAddress = supplierData.billing_address || '';
                                const tin = supplierData.tin || '';
                                let splitTitle = doc.splitTextToSize(`Supplier: ${supplierName}\nAddress: ${supplierAddress}\nTIN #: ${tin}`, 90);
                                doc.text(15, 50, splitTitle);
                                doc.setFontStyle("normal");
                            }

                            if (currentDocumentTypeCode == 'ORITRQ' || currentDocumentTypeCode == 'OROTRQ' || currentDocumentTypeCode == 'RELTRX' || currentDocumentTypeCode == 'RECTRX' || currentDocumentTypeCode == 'ORICSQ' || currentDocumentTypeCode == 'OROCSQ' || currentDocumentTypeCode == 'RELCSX' || currentDocumentTypeCode == 'RECCSX') {
                                doc.setFontSize(10 + fontSizeIncreaser);
                                doc.text("Supplying Branch:", 15, 50);
                                doc.setFontStyle("bold");
                                doc.text(supplyingBranch, 50 + xCustomPosition, 50);
                                doc.setFontStyle("normal");

                                doc.text("Requesting Branch:", 15, 60);
                                doc.setFontStyle("bold");
                                doc.text(requestingBranch, 50 + xCustomPosition, 60);
                                doc.setFontStyle("normal");
                                doc.setFontSize(8 + fontSizeIncreaser);
                            }

                            if (currentDocumentTypeCode == 'RELSLO' || currentDocumentTypeCode == 'RECSLI') {
                                doc.setFontSize(10 + fontSizeIncreaser);
                                doc.text("Site:", 15, 50);
                                doc.setFontStyle("bold");
                                doc.text(sublocationSite, 40, 50);
                                doc.setFontStyle("normal");

                                doc.text("Origin:", 15, 60);
                                doc.setFontStyle("bold");
                                doc.text(originSublocation, 40, 60);
                                doc.setFontStyle("normal");

                                doc.text("Destination:", 15, 70);
                                doc.setFontStyle("bold");
                                doc.text(destinationSublocation, 40, 70);
                                doc.setFontStyle("normal");
                                doc.setFontSize(8 + fontSizeIncreaser);

                            }
                            var text_width
                            const targetBranch = siteData.name
                            const targetBranchSublocation = siteData.sublocation_name
                            if (currentDocumentTypeCode == 'RECADJ' || currentDocumentTypeCode == 'RELADJ') {
                                doc.setFontSize(9 + fontSizeIncreaser);
                                text_width = doc.getTextWidth(requestingSiteName);
                                doc.text("Site", 15, 41);
                                let splitTitle = doc.splitTextToSize(`${targetBranch}`, 75);
                                doc.text(40, 41, splitTitle);                        
                                doc.text("Sublocation", 15, text_width>73 ? 51 : 47);
                                doc.text(40, text_width>73 ? 51 : 47, doc.splitTextToSize(`${targetBranchSublocation}`, 75));
                                doc.text("Reference", 15, text_width>73 ? 61 : 53);
                                doc.text(reference, 40, text_width>73 ? 61 : 53);
                                doc.text("Remark", 15, text_width>120 ? 70 : 65);
                                let splitRemark = doc.splitTextToSize(`${remark}`, 150);
                                doc.text(splitRemark, 40, text_width>120 ? 70 : 65);
                                let linesCount = splitRemark.length;
                                if (linesCount >= 3) {
                                    startY = startY + (5 * (linesCount - 2));
                                }
                            }

                            doc.setFontSize(10 + fontSizeIncreaser);
                            if (currentDocumentTypeCode != 'RECADJ' && currentDocumentTypeCode != 'RELADJ') {
                                if (currentDocumentTypeCode == 'ORIASN'){
                                    header_position = header_position - 5
                                    value_position = value_position -5
                                }
                                if (currentDocumentTypeCode == 'RECDEL' || currentDocumentTypeCode == 'ORIASN' || currentDocumentTypeCode == 'RELRSR'){
                                    doc.setFontSize(9 + fontSizeIncreaser);
                                    if( currentDocumentTypeCode == 'RECDEL'){
                                    doc.setFontSize(8 + fontSizeIncreaser);
                                    doc.setFontStyle("bold");
                                    }
                                }
                                doc.text(currentDocumentTypeFriendlyCode+" Date:", header_position, 50);
                                doc.setFontStyle("normal");
                                doc.text(documentDate, currentDocumentTypeFriendlyCode === 'PWS' ? value_position - 45 : value_position, 50);
                                if (currentDocumentTypeCode != 'RECDEL'){
                                    doc.text(((currentDocumentTypeFriendlyCode === 'PWS') ? "Effectivity Date:" : "Target Date:"), header_position, 55);
                                    doc.text(targetDate, currentDocumentTypeFriendlyCode === 'PWS' ? value_position - 45 : value_position, 55);
                                }
                            } else {
                                doc.setFontSize(9 + fontSizeIncreaser);
                                doc.text("Posting Date", header_position, 47);
                                doc.text(postDateAdj, value_position - 20, 47);
                                doc.text("Purpose", header_position, 53);
                                doc.text(purpose, value_position - 20, 53);
                                doc.text("Status", header_position, 59);
                                doc.text(documentStatus, value_position - 20, 59);
                                
                                startY = startY - (text_width>73 ? 10 : 20)

                                // let splitTitle = doc.splitTextToSize(`ADI Date:     ${documentDate}\nPurpose:     ${purpose}\nStatus #:     ${documentStatus}`, 60);
                                // doc.text(header_position, 50, splitTitle);
                            }
                            if(currentDocumentTypeFriendlyCode != 'PWS') {
                                x_position = 60
                                if (currentDocumentTypeCode == 'RECDEL'){
                                    x_position = x_position - 5
                                    doc.setFontSize(8 + fontSizeIncreaser);
                                }
                                let refWidth = doc.getTextWidth(reference);
                                if (currentDocumentTypeCode != 'RECADJ' && currentDocumentTypeCode != 'RELADJ') {
                                if( currentDocumentTypeCode == 'RECDEL'){
                                    doc.setFontStyle("bold");
                                }
                                doc.text("Cancellation  Date:", header_position, x_position);
                                doc.text(`${referenceLabel}:`, header_position, x_position + 5);
                                doc.setFontStyle("normal");
                                doc.text(cancellationDate, value_position, x_position);
                                let splitRef = doc.splitTextToSize(`${reference}`, 28)
                                doc.text((currentDocumentTypeCode == 'ORIASN' || currentDocumentTypeCode == 'RECDEL' || currentDocumentTypeCode == 'RELRSR') ? splitRef : reference, value_position, x_position + 5);
                                }
                                let splitOCRef = doc.splitTextToSize(`${ocReference}`, 28)
                                let splitShipmentRef = doc.splitTextToSize(`${shipmentReference}`, 28)
                                let ocRefWidth = doc.getTextWidth(reference);
                                let shipmentRefWidth = doc.getTextWidth(reference);
                                if (currentDocumentTypeCode == 'ORIASN' || currentDocumentTypeCode == 'RECDEL' || currentDocumentTypeCode == 'RELRSR') {
                                    let addOcLineSpace = 0
                                    let addShipmentLineSpace = 0
                                    if (refWidth > 28) {
                                        x_position = x_position + 5
                                    }
                                    addOcLineSpace = ocRefWidth > 50 ? 10 :
                                                     ocRefWidth > 28 ? 5 : 0
                                    addShipmentLineSpace = shipmentRefWidth > 48 ? 8 :
                                                     shipmentRefWidth > 28 ? 5 : 0
                                if( currentDocumentTypeCode == 'RECDEL'){
                                    doc.setFontStyle("bold");
                                }
                                doc.text(`Oc Reference:`, header_position, x_position + 10);
                                doc.text(`Shipment Reference:`, header_position, x_position + (15 + addOcLineSpace));
                                doc.text("Currency:", header_position, (x_position + addShipmentLineSpace ) + (20 + addOcLineSpace));
                                doc.text("Currency Rate:", header_position, (x_position + addShipmentLineSpace)+ (25 + addOcLineSpace));
                                doc.text("Status:", header_position, (x_position + addShipmentLineSpace) + (30 + addOcLineSpace));
                                doc.setFontStyle("normal");

                                doc.text( splitOCRef, value_position, x_position + 10);
                                doc.text( splitShipmentRef, value_position, x_position + (15 + addOcLineSpace));
                                doc.text(currencyLabel, value_position, (x_position + addShipmentLineSpace) + (20 + addOcLineSpace));
                                doc.text(currencyRate, value_position, (x_position + addShipmentLineSpace)+ (25 + addOcLineSpace));

                                doc.text(documentStatus, currentDocumentTypeFriendlyCode === 'PWS' ? value_position - 45 : value_position, (x_position + addShipmentLineSpace) + (30 + addOcLineSpace));

                                startY = startY + (2 + addShipmentLineSpace)
                                } else {
                                    if (currentDocumentTypeCode != 'RECADJ' && currentDocumentTypeCode != 'RELADJ') {
                                        doc.text("Currency:", header_position, x_position + 10);
                                        doc.text(documentCurrencyLabel, value_position, x_position + 10);
                                        doc.text("Currency Rate:", header_position, x_position + 15);
                                        doc.text(currencyRate, value_position, x_position + 15);
                                        doc.text("Status:", header_position, x_position + 20);
                                        doc.text(documentStatus, currentDocumentTypeFriendlyCode === 'PWS' ? value_position - 45 : value_position, x_position + 20);
                                    }
                                }
                            } else {
                                x_position = 55
                                doc.text(`${referenceLabel}:`, header_position, x_position + 5);
                                doc.text(reference, currentDocumentTypeFriendlyCode === 'PWS' ? value_position - 45 : value_position, x_position + 5);
                                x_position = 45
                                startY = 80
                            }
                            if (currentDocumentTypeCode != 'RECADJ' && currentDocumentTypeCode != 'RELADJ') {
                                if(currentDocumentTypeCode == 'RECDEL' || currentDocumentTypeCode == 'ORIASN' || currentDocumentTypeCode == 'RELRSR'){
                                    if (currentDocumentTypeCode == 'RECDEL'){
                                    doc.setFontStyle("bold") ;
                                    doc.setFontSize(8 + fontSizeIncreaser);
                                    }
                                    let companyAddressTextWidth = doc.getTextWidth(companyData.address);
                                    let supplierAddressTextWidth = doc.getTextWidth(supplier_address);
                                    let addSpacing = companyAddressTextWidth > 164 ? 4 : 0
                                    let addSpacing2 = supplierAddressTextWidth > 164 ? 4 : 0

                                    x_position = x_position + (addSpacing + addSpacing2)
                                    doc.text("Site:  ", 15, x_position + 25);
                                    doc.setFontStyle("normal");
                                    doc.text(requestingSiteName, 35, x_position + 25);
                                }
                            if (currentDocumentTypeCode == 'RECDEL'){
                            doc.setFontStyle("bold");
                            doc.setFontSize(8 + fontSizeIncreaser);
                            }
                            // if (currentDocumentTypeCode == 'RELRSR'){
                            //     //x_position = x_position-10
                            //     doc.text("Site:  ", 15, x_position + 25);
                            //     doc.text(requestingSiteName, 35, x_position + 25);
                            //     }
                            if (currentDocumentTypeCode == 'OTHSBI'){
                                x_position = x_position - 10
                            }
                            doc.text("Purpose:", 15,  x_position + 30);
                            doc.text("Remark:", 15, x_position + 35);
                            doc.setFontStyle("normal");
                            doc.text(purpose, 35,  x_position + 30);
                            doc.text(remark, 35, x_position + 35);
                            }
                            if (currentDocumentTypeCode == 'ORIASN' || currentDocumentTypeCode == 'RELRSR'){
                                startY = startY + 10
                            }
                            if(currentDocumentTypeCode == 'ORIPOX' || currentDocumentTypeCode == 'RECDEL'){
                                if (component_x.document_config.document_type_settings.printSettings!= undefined){
                                    if(component_x.document_config.document_type_settings.printSettings.enableShowingPriceInclusionField!=undefined && component_x.document_config.document_type_settings.printSettings.enableShowingPriceInclusionField==true){
                                        doc.text("Price Inclusion:", 15, 90);
                                        doc.text(priceInclusion, 40, 90);
                                    }
                                    if(component_x.document_config.document_type_settings.printSettings.enableShowingComment1Field!=undefined && component_x.document_config.document_type_settings.printSettings.enableShowingComment1Field==true){
                                        doc.text("Comment 1:", 15, 95);
                                        doc.text(comment1, 40, 95);
                                    }
                                    if(component_x.document_config.document_type_settings.printSettings.enableShowingComment2Field!=undefined && component_x.document_config.document_type_settings.printSettings.enableShowingComment2Field==true){
                                        doc.text("Comment 2:", 15, 100);
                                        doc.text(comment2, 40, 100);
                                    }
                                    if(component_x.document_config.document_type_settings.printSettings.enableShowingInitialDepositField!=undefined && component_x.document_config.document_type_settings.printSettings.enableShowingInitialDepositField==true){
                                        doc.text("Initial Deposit:", header_position, 90);
                                        doc.text(initial_deposit.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), value_position, 90);
                                    }
                                    if(component_x.document_config.document_type_settings.printSettings.enableShowingBalanceField!=undefined && component_x.document_config.document_type_settings.printSettings.enableShowingBalanceField==true){
                                        balance = (calculation.bottom.subtotal).toFixed(2) - initial_deposit.toFixed(2)
                                        doc.text("Balance:", header_position, 95);
                                        doc.text(balance.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), value_position, 95);
                                    }
                                }
                                startY = 105
                                if (currentDocumentTypeCode != 'RECDEL'){
                                    doc.text("Total:", header_position, 100);
                                    doc.text(calculation.bottom.subtotal.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), value_position, 100);
                                }
                            }

                            let stockNoWidth = 30;

                            if (currentDocumentTypeCode == 'RELRSR' || currentDocumentTypeCode == 'RELDEL') {
                                stockNoWidth = 20;
                            }

                            doc.line(15, startY, line_position, startY);
                            return {
                                didParseCell: function (table) {
                                    //console.log(table)
                                    if (table.section === 'head' && (table.column.index == 8 || table.column.index == 9 || table.column.index == 10 || table.column.index == 11 || table.column.index == 12)) {
                                        table.cell.styles.halign = 'right';
                                    }
                                    if (currentDocumentTypeCode === 'RECADJ' || currentDocumentTypeCode === 'RELADJ') {
                                        if (table.section === 'head') {
                                            table.cell.text = String(table.cell.text).toUpperCase();
                                            table.cell.styles.fillColor = [255, 255, 255]; 
                                            table.cell.styles.textColor = [0, 0, 0]
                                        }
                                        if (["Subtotal", "SRP", 'Quantity'].includes(table.table.head[0].raw[table.column.index])) {
                                            table.cell.styles.halign = 'right'; 
                                        } else {
                                            table.cell.styles.halign = 'left';
                                        }

                                        if (table.section === 'body') {
                                            table.cell.styles.textColor = [0, 0, 0]
                                        }
                                    }
                                    if (currentDocumentTypeCode === 'ORIASN') {
                                        if (table.table.head[0].raw[table.column.index] === "Brand") {
                                            table.cell.styles.halign = 'center'; 
                                        }
                                    }
                                    if(table.section === 'body' && (!component_x.accessCostPriceRights.includes('Z') || !component_x.accessCostPriceRights.includes('Y'))){
                                        var count = (component_x.showConversionRate) ? 6 : 2
                                        for (let i = 0; i < count; i++) {
                                            if (table.column.index == (table.table.columns.length-(i+1))){
                                                table.cell.text = '***';
                                            }
                                        }
                                    } else {
                                        const headerRaw = table.table.head[0].raw
                                        if (headerRaw[table.column.index] === "Quantity" || headerRaw[table.column.index] === "Variance Quantity" || headerRaw[table.column.index] === "Doc Qty") {
                                            let value = parseFloat(table.cell.text);
                                            if (!isNaN(value) && !/^[0-9]{12,}$/.test(table.cell.text)) {
                                                table.cell.text = Math.floor(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                            }
                                        } else if (headerRaw[table.column.index] == "Subtotal" || headerRaw[table.column.index] == "Unit Cost"|| headerRaw[table.column.index] == "SRP" || headerRaw[table.column.index] == "Price" || headerRaw[table.column.index] == "Ordering Cost" ) {
                                            let value = parseFloat(table.cell.text);
                                            if (!isNaN(value) && !/^[0-9]{12,}$/.test(table.cell.text)) {
                                                table.cell.text = value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                            }
                                        }
                                    }
                                },
                                didDrawPage: function (data) {
                                    //Main Header
                                    var logobarter = document.getElementById('logobarter');
                                    //doc.addImage(logobarter, "PNG", 15, 20, 20, 20);
                                    doc.setFontStyle("bold");
                                    doc.setFontSize(14 + fontSizeIncreaser);
                                    if (currentDocumentTypeCode == 'ORIPOX' || currentDocumentTypeCode == 'ORIASN'|| currentDocumentTypeCode == 'RELRSR'|| currentDocumentTypeCode == 'RECDEL') {
                                        if (currentDocumentTypeCode != 'RECDEL' && currentDocumentTypeCode != 'ORIASN' && currentDocumentTypeCode != 'RELRSR' ){
                                            let splitSiteName = doc.splitTextToSize(`${requestingSiteName}`, 75)
                                            doc.text(splitSiteName, 15, 25);
                                        }
                                    } else {
                                        if (currentDocumentTypeCode == 'RECADJ' || currentDocumentTypeCode == 'RELADJ' ) {
                                            doc.text(documentType, 15, 25);
                                            doc.setFontStyle("bold");
                                            doc.setFontSize(9 + fontSizeIncreaser);
                                            doc.text("Company", 15, 35);
                                            doc.text(companyData.name, 40, 35);
                                            doc.setFontStyle("normal");
                                        }else{
                                            doc.text(currentSiteName, 40, 25);
                                        }
                                    }

                                    if (currentDocumentTypeCode == 'ORIPOX' || currentDocumentTypeCode == 'OTHPUR' || currentDocumentTypeCode == 'OTHSBI') {
                                    doc.setFontSize(9 + fontSizeIncreaser);
                                    const companyName = siteData.company_name || '';
                                    const companyAddress = siteData.company_address || '';
                                    const tin = siteData.company_tin || '';
                                    let splitTitle = doc.splitTextToSize(`Company Name: ${companyName}\nAddress: ${companyAddress}\nTIN #: ${tin}`, 75);
                                    doc.text(15, 30, splitTitle);
                                    doc.setFontSize(14 + fontSizeIncreaser);
                                    }
                                    if (currentDocumentTypeCode == 'RECDEL' || currentDocumentTypeCode == 'ORIASN' || currentDocumentTypeCode == 'RELRSR') {
                                        doc.setFontStyle("normal");
                                        doc.setFontSize(10 + fontSizeIncreaser);
                                        const companyName = companyData.name || '';
                                        const companyAddress = companyData.address || '';
                                        const tin = companyData.tin || '';
                                        if(currentDocumentTypeCode == 'RECDEL'){
                                        doc.setFontSize(9 + fontSizeIncreaser);
                                        var nameWidth = doc.getTextWidth(companyName)  
                                        var addressWidth = doc.getTextWidth(companyAddress)
                                        const extendY1 = nameWidth > 82 ? 5 : 0;
                                        const extendY2 = addressWidth > 164 ? 8 : 
                                                         addressWidth > 82 ? 5 : 0;
                                        
                                        addTextWithFormatting(doc, "Company:", companyName, 15, 25, 75);
                                        addTextWithFormatting(doc, "Address:", companyAddress, 15, 30 + extendY1, 75);
                                        addTextWithFormatting(doc, "TIN #:", tin, 15, 35 + (extendY1 + extendY2), 75);
                                        } else {
                                            doc.setFontSize(9 + fontSizeIncreaser);
                                            let splitTitle = doc.splitTextToSize(`Company Name: ${companyName}\nAddress: ${companyAddress}\nTIN #: ${tin}`, 75);
                                            doc.text(15, 25, splitTitle);
                                        }

                                        doc.setFontSize(14 + fontSizeIncreaser);
                                    }

                                    doc.setFontStyle("normal");
                                    if(currentDocumentTypeCode != 'RECADJ' && currentDocumentTypeCode != 'RELADJ'){
                                    if (currentDocumentTypeCode == 'ORIASN' || currentDocumentTypeCode == 'RECDEL' || currentDocumentTypeCode == 'RELRSR'){
                                        doc.setFontStyle("bold");
                                    }
                                    doc.text(documentType, header_position, 25);
                                    doc.setFontStyle("normal");
                                    if (currentDocumentTypeCode == 'ORIASN' || currentDocumentTypeCode == 'RELRSR'){
                                        doc.text("# "+String(casNo), header_position, 35);
                                    }else if (currentDocumentTypeCode != 'RECDEL'){
                                        doc.text("#"+String(documentNumber), header_position, 35);
                                    }   
                                    if(currentDocumentTypeCode == 'RECDEL'){
                                        doc.setFontSize(9 + fontSizeIncreaser);
                                        doc.text("# "+String(casNo), header_position, 35);
                                        doc.setFontStyle("bold");
                                    }else {
                                        doc.setFontSize(9 + fontSizeIncreaser);
                                    }
                                    doc.text("Origin Document No:", header_position, 40);
                                    doc.setFontStyle("normal");
                                    doc.text(String(friendlyOriginDocumentNo), line_position-30, 40);
                                    doc.line(15, 265-minus_height, line_position, 265-minus_height);

                                    doc.text("Printed By:", 15, 270-minus_height);
                                    doc.text(userCode, 35 + xCustomPosition, 270-minus_height);
                                    if(currentDocumentTypeCode != 'RECDEL'){
                                    doc.text("Created By:", 70, 270-minus_height);
                                    doc.text(createdBy, 90 + xCustomPosition, 270-minus_height);
                                    }    
                                    doc.text("Posted By:", 125, 270-minus_height);
                                    doc.text(postedBy, 145 + xCustomPosition, 270-minus_height);

                                    doc.text("Print Date:", 15, 275-minus_height);
                                    doc.text(printDate, 35 + xCustomPosition, 275-minus_height)
                                    doc.text("Post Date:", 15, 280-minus_height);
                                    doc.text(postDate, 35 + xCustomPosition, 280-minus_height)
                                    } else {

                                    doc.setFontSize(10 + fontSizeIncreaser);
                                    if (currentDocumentTypeCode == 'RECADJ' || currentDocumentTypeCode == 'RELADJ' ) {
                                        doc.setFontStyle("bold");
                                        doc.setFontSize(9 + fontSizeIncreaser);
                                    }
                                    doc.text('CAS #', header_position, 35);
                                    doc.text(String(casNo), value_position - 20, 35);
                                    if (currentDocumentTypeCode == 'RECADJ' || currentDocumentTypeCode == 'RELADJ' ) {
                                        doc.setFontStyle("normal");
                                    }
                                    doc.text(`RMS ${currentDocumentTypeFriendlyCode} #`, header_position, 41);

                                    doc.text(String(documentNumber), value_position - 20, 41);
                                    doc.text("Created By:", 15, 270-minus_height);
                                    doc.text(['RECADJ', 'RELADJ'].includes(currentDocumentTypeCode) ? createdByUserName : createdBy, 37 + xCustomPosition, 270-minus_height);
                                    doc.text("Creation Date:", 15, 275-minus_height);
                                    doc.text(creationDateAdj, 37 + xCustomPosition, 275-minus_height);

                                    doc.text("Posted By:", 85, 270-minus_height);
                                    doc.text(['RECADJ', 'RELADJ'].includes(currentDocumentTypeCode) ? userName : postedBy, 107 + xCustomPosition, 270-minus_height);
                                    doc.text("Posting Date:", 85, 275-minus_height);
                                    doc.text(postDateAdj, 107 + xCustomPosition, 275-minus_height);
                                    }
                                },
                                startY: startY,
                                margin: {top: 50, bottom: 58},
                                bodyStyles: {
                                    fontSize: 7 + fontSizeIncreaser
                                },
                                headStyles: {
                                    fontSize: 8 + fontSizeIncreaser,
                                    halign: 'center',
                                    valign: 'middle'
                                    },
                                styles: {
                                 overflow: 'linebreak',
                                 font: (customFont == 'dotMatrix') ? 'Epson1' : null,
                                 ...(['RELADJ', 'RECADJ'].includes(currentDocumentTypeCode) && {
                                        lineWidth: 0.5,
                                        lineColor: [0, 0, 0] 
                                    })
                                },
                                // columnStyles: { text: { cellWidth: 'auto' } },
                                theme:  ['RELADJ','RECADJ'].includes(currentDocumentTypeCode) ? 'grid' : 'plain',
                                columnStyles: {
                                    0: {
                                        halign: 'center',
                                        cellWidth: ['RELADJ','RECADJ'].includes(currentDocumentTypeCode) ? 15 : 'auto'
                                    },
                                    1: {
                                        halign: (currentDocumentTypeCode == 'ORISOX' || currentDocumentTypeCode == 'OTHSRQ' || currentDocumentTypeCode == 'ORIOSO' || currentDocumentTypeCode == 'RELDDE' || currentDocumentTypeCode == 'OTHSIN' || currentDocumentTypeCode == 'RECCSR' || currentDocumentTypeCode == 'ORIOCR' || currentDocumentTypeCode == 'RECCSI' || currentDocumentTypeCode== 'RELTRX') ? 'center' : '',
                                        cellWidth: (['OTHTOV','RECADJ','RELADJ','ORIASN'].includes(currentDocumentTypeCode)) ? 'auto' : 25
                                    },
                                    2: {
                                        cellWidth: (currentDocumentTypeCode == 'ORIPOX' && showStockNoInProductList == true) ? stockNoWidth : currentDocumentTypeCode == 'ORIPOX' ? 25 : 'auto'
                                    },
                                    3: {
                                        halign: (currentDocumentTypeCode == 'ORISOX' || currentDocumentTypeCode == 'OTHSRQ' || currentDocumentTypeCode == 'ORIOSO' || currentDocumentTypeCode == 'RELDDE' || currentDocumentTypeCode == 'OTHSIN' || currentDocumentTypeCode == 'RECCSR' || currentDocumentTypeCode == 'ORIOCR' || currentDocumentTypeCode== 'RELTRX' || currentDocumentTypeCode == 'RECCSI') ? 'center' : '',
                                        cellWidth: currentDocumentTypeCode == 'OTHTOV' ? 15 : (currentDocumentTypeCode == 'ORIASN' || currentDocumentTypeCode == 'RECDEL') ? 40 : 'auto'
                                    },
                                    4: {
                                        cellWidth: (currentDocumentTypeCode == 'ORISOX' || currentDocumentTypeCode == 'OTHSRQ' || currentDocumentTypeCode == 'ORIOSO' || currentDocumentTypeCode == 'RELDDE' || currentDocumentTypeCode == 'OTHSIN' || currentDocumentTypeCode == 'RECCSR' || currentDocumentTypeCode == 'ORIOCR' || currentDocumentTypeCode== 'RELTRX' || currentDocumentTypeCode == 'RECCSI') ? 25 : (currentDocumentTypeCode == 'RELADJ' || currentDocumentTypeCode == 'RECADJ') ? 20 : 15
                                    },
                                    5: {
                                        halign: (currentDocumentTypeCode == 'ORIPOX' &&  showRefCode == true && showStockNoInProductList != true)? 'auto' : (currentDocumentTypeCode == 'RELADJ' || currentDocumentTypeCode == 'RECADJ') ? 'left' : 'right',
                                        cellWidth: (currentDocumentTypeCode == 'ORIPOX' &&  showRefCode == true && showStockNoInProductList != true) ? 20 : 15 
                                    },

                                    6: {
                                        halign: (currentDocumentTypeCode == 'ORIPOX' &&  showRefCode == true && showStockNoInProductList == true) ?  'auto' : 'right',
                                        cellWidth: (currentDocumentTypeCode == 'ORIPOX' &&  showRefCode == true && showStockNoInProductList == true) ? 25 : (currentDocumentTypeCode == 'RELDDE' || currentDocumentTypeCode == 'OTHSIN' || currentDocumentTypeCode == 'ORIASN' || currentDocumentTypeCode == 'RECDEL') ? 15 : 20
                                    },
                                    7: {
                                        halign: 'right',
                                        cellWidth:  (currentDocumentTypeCode == 'RECADJ' || currentDocumentTypeCode == 'RELADJ') ? 17 : (currentDocumentTypeCode == 'RECDEL' || currentDocumentTypeCode == 'ORIASN' || currentDocumentTypeCode == 'RELRSR') ? 20 : 15
                                    },
                                    8: {
                                        halign: 'right',
                                        cellWidth: (currentDocumentTypeCode == 'ORISOX' || currentDocumentTypeCode == 'OTHSRQ' || currentDocumentTypeCode == 'ORIOSO' || currentDocumentTypeCode == 'RECCSR' || currentDocumentTypeCode == 'ORIOCR' || currentDocumentTypeCode== 'RELTRX' || currentDocumentTypeCode == 'RECCSI') ? 17 : (currentDocumentTypeCode == 'ORISOX' || currentDocumentTypeCode == 'RECDEL') ? 'auto' : 15
                                    },
                                    9: {
                                        halign: 'right',
                                        cellWidth: ( currentDocumentTypeCode == 'ORIASN' || currentDocumentTypeCode == 'RECDEL') ? 'auto' : 15
                                    },
                                    10: {
                                        halign: 'right',
                                    },
                                    11: {
                                        halign: 'right',
                                    },
                                    12: {
                                        halign: 'right',
                                    },
                                    13: {
                                        halign: 'right',
                                    },
                                }
                            };
                        },
                        documentProcessing:function(doc){
                            let showRefCodeAdjustXpos = 13;
                            if(showRefCode!=undefined && showRefCode==true){
                                showRefCodeAdjustXpos += 2;
                            }
                            let quantityTotalWidth = 145 + showRefCodeAdjustXpos;
                            let priceTotalWidth = 163 + showRefCodeAdjustXpos;
                            let subTotalWidth = 178 + showRefCodeAdjustXpos;
                            if (currentDocumentTypeCode == 'RELRSR') {
                                priceTotalWidth = 161;
                                subTotalWidth = 181;
                            } else if (currentDocumentTypeCode == 'ORIPOX') {
                                if(showRefCode!=undefined && showRefCode==true){
                                    quantityTotalWidth = 165;
                                    priceTotalWidth = 185;
                                    subTotalWidth = 205;
                                } else {
                                    quantityTotalWidth = 155;
                                    priceTotalWidth = 175;
                                    subTotalWidth = 195;
                                }
                            }else if (currentDocumentTypeCode == 'RECDEL'){
                                if(showRefCode!=undefined && showRefCode==true){
                                    quantityTotalWidth = 168;
                                    priceTotalWidth = 185;
                                    subTotalWidth = 206;
                                } else {
                                    quantityTotalWidth = 168;
                                    priceTotalWidth = 190;
                                    subTotalWidth = 207;
                                }
                            }

                            doc.setFontSize(7 + fontSizeIncreaser);
                            const pageCount = doc.internal.getNumberOfPages();
                            const finalY = doc.lastAutoTable['finalY'];
                            for(var i = 1; i <= pageCount; i++) {
                                doc.setPage(i);
                                doc.text('Page ' + String(i) + ' of ' + String(pageCount),value_position,280 - minus_height);
                            }

                            doc.setFontStyle("bold");
                            var formatMyNumber = function (number, decimal) {
                                var splitNum;
                                number = Math.abs(number);
                                number = number.toFixed(decimal);
                                splitNum = number.split('.');
                                splitNum[0] = splitNum[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                return splitNum.join(".");
                            }
                            // Issue: 1474
                            // Update PO Print-out to include subtotal and total cost
                            doc.line(15, finalY, line_position, finalY, 'F');
                            if (currentDocumentTypeCode == 'ORIPOX'){
                                if(component_x.document_config.document_type_settings.printSettings.includeImageInPrintout!=undefined && component_x.document_config.document_type_settings.printSettings.includeImageInPrintout == true){
                                    if(imageResponse["error"] == undefined){
                                        if (imageResponse.images_url != undefined && imageResponse.images_url.length > 0){
                                            let x = 20
                                            arrImgLogos.forEach(el => {
                                                doc.addImage(el,'JPEG', x,finalY + 3,15,15)
                                                x += 15
                                            })
                                        }
                                        else if (imageResponse.image != undefined && imageResponse.image != ""){
                                            doc.addImage(imgLogo, imageResponse.file_type, 30, 63, 14, 14);
                                        }
                                    }
                                    // doc.text("stock no:"+stock_no, 26, 59);
                                    // doc.setFontStyle("normal");
                                    // doc.setFontSize(5);
                                }
                            }

                            if(currentDocumentTypeCode != 'OTHPWS'){
                                var positionTQ = 255
                                var positionTC = 259
                                var positionS = 263
                                var postionDA = 0
                                var positionNWOV = 0
                                var positionTP = 0
                                var positionTV = 0
                                if(currentDocumentTypeCode == 'RECADJ' || currentDocumentTypeCode == 'RELADJ'){
                                    positionS-=4
                                }
                                if (showDiscountAmount){
                                    positionTQ-=4
                                    positionTC-=4
                                    positionS-=4
                                    postionDA = positionS+4
                                    positionNWOV+=4
                                    positionTP+=4
                                    positionTV+=4
                                }
                                if (showTotalVat){
                                    positionTQ-=4
                                    positionTC-=4
                                    positionS-=4
                                    postionDA-=4
                                    positionTV = positionS+positionTV+4
                                    positionNWOV+= 4
                                    positionTP+=4
                                }
                                if(showNetAmountWithoutVat){
                                    positionTQ-=4
                                    positionTC-=4
                                    positionS-=4
                                    postionDA-=4
                                    positionTV-=4
                                    positionNWOV = positionS+positionNWOV+4
                                    positionTP+=4
                                }
                                if(showTotalPrice){
                                    positionTQ-=4
                                    positionTC-=4
                                    positionS-=4
                                    postionDA-=4
                                    positionTV-=4
                                    positionNWOV-=4
                                    positionTP = positionS+positionTP+4
                                }
                                if(currencyKey>0 && component_x.showConversionRate){
                                    if((currentDocumentTypeCode != 'OTHTRA' && currentDocumentTypeCode != 'OTHPCK') || isDefaultPrint){
                                        doc.text(doc.splitTextToSize((calculation.bottom.quantity).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), 12), quantityTotalWidth+total_plus_width, finalY + 5, 'right')
                                        doc.text((!component_x.accessCostPriceRights.includes('Y') || !component_x.accessCostPriceRights.includes('Z')) ? "***" : doc.splitTextToSize((calculation.bottom.price_php).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), 15), priceTotalWidth+total_plus_width, finalY + 5, 'right')
                                        doc.text((!component_x.accessCostPriceRights.includes('Y') || !component_x.accessCostPriceRights.includes('Z')) ? "***" : doc.splitTextToSize((calculation.bottom.subtotal_php).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), 15), subTotalWidth+total_plus_width, finalY + 5, 'right')
                                    }
                                    // End Issue: 1474
                                    doc.text("Total Quantity:", 15, positionTQ-minus_height)
                                    doc.text((calculation.bottom.quantity).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), 60, positionTQ-minus_height, 'right')
                                    if(currentDocumentTypeCode != 'RECADJ' && currentDocumentTypeCode != 'RELADJ'){
                                        doc.text("Total Cost:", 15, positionTC-minus_height)
                                        doc.text((!component_x.accessCostPriceRights.includes('Z')) ? "***" : (calculation.bottom.price_php).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), 60, positionTC-minus_height, 'right')
                                    }
                                    doc.text("Subtotal:", 15, positionS-minus_height)
                                    doc.text(((!component_x.accessCostPriceRights.includes('Z') && (component_x.productPriceChoice == 'landed_cost' || component_x.productPriceChoice == 'ordering_cost' || component_x.productPriceChoice == 'original_cost')) || (!component_x.accessCostPriceRights.includes('Y') && (component_x.productPriceChoice == 'retail_price' || component_x.productPriceChoice == 'wholesale_price'))) ? "***" : (calculation.bottom.subtotal_php).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), 60, positionS-minus_height, 'right')
                                    if(showDiscountAmount){
                                        doc.text("Disc. Amount:", 15, postionDA-minus_height)
                                        doc.text(formatMyNumber(showDiscountAmountValue, 2), 50, postionDA-minus_height, 'right')
                                    }
                                    if (showTotalVat){
                                        doc.text("Total VAT (" + (component_x.taxRate * 100) + "%):", 15, positionTV-minus_height)
                                        doc.text(formatMyNumber(Math.floor(component_x.netAmountWithoutTax * 100) / 100, 2), 60, positionTV-minus_height, 'right')
                                    }
                                    if(showNetAmountWithoutVat){
                                        doc.text("Net Amount w/o VAT:", 15, positionNWOV-minus_height)
                                        doc.text(formatMyNumber(Math.floor(component_x.netAmountWithoutTax * 100) / 100, 2), 60, positionNWOV-minus_height, 'right')
                                    }
                                    if(showTotalPrice){
                                        doc.text("Total Price:", 15, positionTP-minus_height)
                                        doc.text((!component_x.accessCostPriceRights.includes('Y')) ? "***" : formatMyNumber(Math.floor(component_x.netAmount * 100) / 100, 2), 60, positionTP-minus_height, 'right')
                                    }
                                    if(showOtherCharges){
                                        for (var index = 1; index <= component_x.chargeData.length; index++) { 
                                            var p = (index == 1) ? positionTQ-minus_height : (index == 2) ? positionTC-minus_height : (index == 3) ? positionS-minus_height : (index == 4) ? (positionS+4)-minus_height : (index == 5) ? (positionS+8)-minus_height : (index == 6) ? (positionS+12)-minus_height : (positionS+16)-minus_height
                                            doc.text(component_x.chargeData[index-1].name+':', 155, p)
                                            doc.text(formatMyNumber(component_x.chargeData[index-1].amount, 2), 190, p, 'right')
                                        }
                                    }
                                }else{
                                    if((currentDocumentTypeCode != 'OTHTRA' && currentDocumentTypeCode != 'OTHPCK') || isDefaultPrint){
                                        if(currentDocumentTypeCode != 'RECADJ' && currentDocumentTypeCode != 'RELADJ'){
                                            if (currentDocumentTypeCode == 'RECDEL'){
                                                total_plus_width = total_plus_width - 13
                                                quantityTotalWidth = quantityTotalWidth - 2
                                                priceTotalWidth = priceTotalWidth - 3
                                            } else if (currentDocumentTypeCode == 'ORIASN'){
                                            }

                                            if (currentDocumentTypeCode == 'RELRSR'){
                                                quantityTotalWidth = quantityTotalWidth + 1
                                                priceTotalWidth = priceTotalWidth + 18
                                                subTotalWidth = subTotalWidth + 13
                                            }
                                            doc.text(doc.splitTextToSize((calculation.bottom.quantity).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), 12), quantityTotalWidth+total_plus_width, finalY + 5, 'right')
                                            doc.text((!component_x.accessCostPriceRights.includes('Y') || !component_x.accessCostPriceRights.includes('Z')) ? "***" : doc.splitTextToSize((calculation.bottom.price).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), 15), priceTotalWidth+total_plus_width, finalY + 5, 'right')
                                            doc.text((!component_x.accessCostPriceRights.includes('Y') || !component_x.accessCostPriceRights.includes('Z')) ? "***" : doc.splitTextToSize((calculation.bottom.subtotal).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), 15), subTotalWidth+total_plus_width, finalY + 5, 'right')
                                        }else{
                                            doc.text(doc.splitTextToSize((calculation.bottom.quantity).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), 12), (quantityTotalWidth+total_plus_width) + 1, finalY + 5, 'right')
                                            doc.text((!component_x.accessCostPriceRights.includes('Y') || !component_x.accessCostPriceRights.includes('Z')) ? "***" : doc.splitTextToSize((calculation.bottom.subtotal).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), 15), (subTotalWidth+total_plus_width) + 3, finalY + 5, 'right')
                                        }
                                    }
                                    // End Issue: 1474
                                    if(currentDocumentTypeCode != 'RECADJ' && currentDocumentTypeCode != 'RELADJ'){

                                    doc.text("Total Quantity:", 15, positionTQ-minus_height)
                                    doc.text(formatMyNumber(calculation.bottom.quantity, 0), 60, positionTQ-minus_height, 'right')
                                    doc.text("Total Cost:", 15, positionTC-minus_height)
                                    doc.text((!component_x.accessCostPriceRights.includes('Z')) ? "***" : formatMyNumber(calculation.bottom.price, 2), 60, positionTC-minus_height, 'right')
                                    
                                    doc.text("Subtotal:", 15, positionS-minus_height)
                                    doc.text(((!component_x.accessCostPriceRights.includes('Z') && (component_x.productPriceChoice == 'landed_cost' || component_x.productPriceChoice == 'ordering_cost' || component_x.productPriceChoice == 'original_cost')) || (!component_x.accessCostPriceRights.includes('Y') && (component_x.productPriceChoice == 'retail_price' || component_x.productPriceChoice == 'wholesale_price'))) ? "***" : formatMyNumber(calculation.bottom.subtotal, 2), 60, positionS-minus_height, 'right')
                                    }
                                    if(showDiscountAmount){
                                        doc.text("Disc. Amount:", 15, postionDA-minus_height)
                                        doc.text(formatMyNumber(showDiscountAmountValue, 2), 60, postionDA-minus_height, 'right')
                                    }
                                    if (showTotalVat){
                                        doc.text("Total VAT (" + (component_x.taxRate * 100) + "%):", 15, positionTV-minus_height)
                                        doc.text(formatMyNumber(Math.floor(component_x.vatAmount * 100) / 100, 2), 60, positionTV-minus_height, 'right')
                                    }
                                    if(showNetAmountWithoutVat){
                                        doc.text("Net Amount w/o VAT:", 15, positionNWOV-minus_height)
                                        doc.text(formatMyNumber(Math.floor(component_x.netAmountWithoutTax * 100) / 100, 2), 60, positionNWOV-minus_height, 'right')
                                    }
                                    if(showTotalPrice){
                                        doc.text("Total Price:", 15, positionTP-minus_height)
                                        doc.text((!component_x.accessCostPriceRights.includes('Y')) ? "***" : formatMyNumber(Math.floor(component_x.netAmount * 100) / 100, 2), 60, positionTP-minus_height, 'right')
                                    }
                                    if(showOtherCharges){
                                        for (var index = 1; index <= component_x.chargeData.length; index++) { 
                                            var p = (index == 1) ? positionTQ-minus_height : (index == 2) ? positionTC-minus_height : (index == 3) ? positionS-minus_height : (index == 4) ? (positionS+4)-minus_height : (index == 5) ? (positionS+8)-minus_height : (index == 6) ? (positionS+12)-minus_height : (positionS+16)-minus_height
                                            doc.text(component_x.chargeData[index-1].name+':', 155, p)
                                            doc.text(formatMyNumber(component_x.chargeData[index-1].amount, 2), 190, p, 'right')
                                        }
                                    }
                                }
                            }
                            doc.setFontStyle("normal");
                            doc.setFontSize(6 + fontSizeIncreaser);
                            if(currentDocumentTypeCode != 'RECADJ' && currentDocumentTypeCode != 'RELADJ'){

                            doc.text("Noted By:", 75, 252-minus_height)
                            doc.text("____________________________________", 95, 252-minus_height)
                            doc.text("Verified By:", 75, 256-minus_height)
                            doc.text("____________________________________", 95, 256-minus_height)
                            doc.text("Approved By:", 75, 260-minus_height)
                            doc.text("____________________________________", 95, 260-minus_height)
                            }
                        }
                    });
                    if(currentDocumentTypeCode =='OTHCNS'){
                        this.tabulator.replaceData(tempdata)
                        var line_no = this.tabulator.getColumn("line_no")
                        line_no.updateDefinition({visible:false})
                        var product_name = this.tabulator.getColumn("product_name")
                        product_name.updateDefinition({visible:false})
                        var stock_no = this.tabulator.getColumn("stock_no")
                        stock_no.updateDefinition({visible:false})
                        var ref_code = this.tabulator.getColumn("ref_code")
                        ref_code.updateDefinition({visible:false})
                        var barcode = this.tabulator.getColumn("barcode")
                        barcode.updateDefinition({visible:false})
                        var unit_id = this.tabulator.getColumn("unit_id")
                        unit_id.updateDefinition({visible:false})
                        var quantity = this.tabulator.getColumn("quantity")
                        quantity.updateDefinition({visible:false})
                        var actual_quantity = this.tabulator.getColumn("actual_quantity")
                        actual_quantity.updateDefinition({visible:false})
                        var _price = this.tabulator.getColumn("price")
                        _price.updateDefinition({visible:false})
                        var cost = this.tabulator.getColumn("cost")
                        cost.updateDefinition({visible:false})
                        var _subtotal = this.tabulator.getColumn("subtotal")
                        _subtotal.updateDefinition({visible:false})
                        var on_hand_quantity = this.tabulator.getColumn("on_hand_quantity")
                        on_hand_quantity.updateDefinition({visible:false})
                    }else if (currentDocumentTypeCode == 'OTHTRA' || currentDocumentTypeCode == 'OTHPCK'){
                        for (var index = 0; index < column_names.length; index++) {
                            var customField = this.tabulator.getColumn(column_names[index])
                            customField.updateDefinition({visible:false,download:false})
                        }
                    }
                }
                this.spinning = false;
            },
            addProductCancel() {
                this.addProductConfirmationVisible = false;
            },
            handleAddProductVisibleChange(addProductConfirmationVisible){
                if (!addProductConfirmationVisible) {
                    this.addProductConfirmationVisible = false;
                    return;
                }
                if (this.currentDocumentTypeCode == 'ORISOX' || this.currentDocumentTypeCode == 'OTHSRQ' || this.currentDocumentTypeCode == 'ORIOSO' || this.currentDocumentTypeCode == 'RELTRX' || this.currentDocumentTypeCode == 'RELRSR' || this.currentDocumentTypeCode == 'RELCSX' || this.currentDocumentTypeCode == 'RELADJ' || this.currentDocumentTypeCode == 'RELSLO' || this.currentDocumentTypeCode == 'RELCSI') {
                    //Check config
                    if (this.document_config && this.document_config.document_type_settings.releasingDocument){
                        if(this.document_config.document_type_settings.releasingDocument['warnNotEnoughQuantity'] && (Number(this.quantity) > Number(this.onHandQuantity)) && !this.document_config.document_type_settings.releasingDocument['restrictAddingItemNotEnoughQuantity']){
                           this.addProductConfirmationVisible = true;
                           return
                        } else if(this.document_config.document_type_settings.releasingDocument['warnNotEnoughQuantity'] && (Number(this.quantity) > Number(this.availableQuantity)) && this.document_config.document_type_settings.releasingDocument['restrictAddingItemNotEnoughQuantity']){
                           this.addProductConfirmationVisible = true;
                           return
                        } else if(!this.document_config.document_type_settings.releasingDocument['warnNotEnoughQuantity'] && (Number(this.quantity) > Number(this.availableQuantity)) && this.document_config.document_type_settings.releasingDocument['restrictAddingItemNotEnoughQuantity']){
                            this.addProduct(0);
                        } else if(!this.document_config.document_type_settings.releasingDocument['warnNotEnoughQuantity'] && (Number(this.quantity) > Number(this.onHandQuantity)) && !this.document_config.document_type_settings.releasingDocument['restrictAddingItemNotEnoughQuantity']){
                            this.addProduct(0);
                        } else {
                            this.addProduct(1);
                        }
                    } else {
                        this.addProduct(1);
                    }
                    // if (Number(this.quantity) <= Number(this.onHandQuantity)) {
                    //     this.addProduct(1);
                    // } else {
                    //     this.addProductConfirmationVisible = true;
                    // }
                }else{
                    this.addProduct(1);
                }
            },
            unitAccessor(value, data){
                var response = '';
                var label = 'No Product Unit'
                var unit_label = data.unit_label
                if (unit_label!=undefined){
                    label = unit_label
                }else{
                    var request = new XMLHttpRequest();
                    request.open('GET', this.endPoint + 'products/'+data.product_id+'/get_product_unit_compositions', false);
                    request.setRequestHeader('Authorization', 'Bearer ' + secureStorage.getItem("accessToken"));
                    request.setRequestHeader('Request-Source',"BXI-Web");
                    request.setRequestHeader('ip',secureStorage.getItem("ipAddress"));
                    request.send(null);
                    if (request.status === 200) {
                        response = request.responseText;
                    }
                    var json_response = JSON.parse(response)
                    json_response.forEach(element => {element.value = element.unit_id; delete element.unit_id;});
                    if (json_response[0]!=undefined){
                        if (json_response[0].value != undefined) {
                            try {
                                label = json_response.find(element => element.value == data.unit_id.toString()).label;
                            } catch (error) {}
                        }
                    }
                }
                return label;
            },
            async openDocument(document_id,existingDocumentTypeDetails,is_reload){
                this.spinning = true
                // Fresh open: drop any cached document so we re-fetch for the new id
                this.invalidateCurrentDocumentCache()
                secureStorage.setItem("temp_document_id", document_id);
                secureStorage.setItem('documentTypeCode',this.currentDocumentTypeCode)
                secureStorage.setItem('DataOptions',this.$options.data())
                if (this.currentDocumentTypeCode=='OTHQUO' || this.currentDocumentTypeCode=='OTHBIN' || this.currentDocumentTypeCode=='OTHCPO'){
                    Object.assign(this.$data, this.$options.data());
                }else{
                    await this.tabulator.clearData();
                    Object.assign(this.$data.options, secureStorage.getItem('DataOptions').options)
                }
                this.isEditing = false
                if (existingDocumentTypeDetails.existingDocumentTypeId != undefined){
                    if (existingDocumentTypeDetails.existingDocumentTypeId > 0){
                        this.currentDocumentTypeId = existingDocumentTypeDetails.existingDocumentTypeId
                    }else {
                        this.currentDocumentTypeId = secureStorage.getItem('documentTypeId') 
                    }
                }else {
                    this.currentDocumentTypeId = secureStorage.getItem('documentTypeId') 
                }
                if (existingDocumentTypeDetails.currentDocumentTypeName != undefined){
                    this.currentDocumentTypeName = existingDocumentTypeDetails.currentDocumentTypeName
                }else {
                    this.currentDocumentTypeName = secureStorage.getItem('documentTypeName')
                }
                if (existingDocumentTypeDetails.currentDocumentTypeCode != undefined){
                    this.currentDocumentTypeCode = existingDocumentTypeDetails.currentDocumentTypeCode

                }else {
                    this.currentDocumentTypeCode = secureStorage.getItem('documentTypeCode')
                }
                if (existingDocumentTypeDetails.currentDocumentTypeFriendlyCode != undefined){
                    this.currentDocumentTypeFriendlyCode = existingDocumentTypeDetails.currentDocumentTypeFriendlyCode
                }else {
                    this.currentDocumentTypeFriendlyCode = secureStorage.getItem('documentTypeFriendlyCode')
                }
                this.documentNumber = secureStorage.getItem('temp_document_id');
                this.currentDocumentTypeFriendlyCodeWithId = this.currentDocumentTypeFriendlyCode+"#"+this.documentNumber
                await this.initializeDocument(is_reload);
                if (secureStorage.getItem("documentTypeInternalCode") == 'OTHPWS'){
                    this.backLink = "/products_v2?type=OTHPWS"
                }else if(secureStorage.getItem("documentTypeInternalCode") == 'OTHBAR'){
                    this.backLink = "/products_v2?type=OTHBAR"
                } else {
                    if(existingDocumentTypeDetails.type != undefined && existingDocumentTypeDetails.type != null && existingDocumentTypeDetails.type != ""){
                        this.backLink = "/documents?type=" + existingDocumentTypeDetails.type
                    }else{
                        this.backLink = "/documents?type=" + secureStorage.getItem("documentTypeInternalCode")
                    }
                }
                this.spinning = false
            },
            // change for openOriginDocument to openRelatedDocument
            async openRelatedDocument(doc_id, doc_type_id){
                this.spinning = true;
                try {
                this.invalidateCurrentDocumentCache();
                var documentTypes = await HTTPRequest.getRequest(this.endPoint + '/document_types/get_document_types_on_system_modules' , null, null)
                if (documentTypes){
                    var origin_document_type = documentTypes.find(x => x.id === doc_type_id)
                    if (origin_document_type) {
                        var origin_trans_code = origin_document_type.trans_code
                        var origin_type_code = origin_document_type.type_code
                        var origin_document_type = documentTypes.find(x => x.trans_code === origin_trans_code && x.type_code === origin_type_code)
                        if(origin_document_type == undefined){
                            this.$notification['error']({
                                message: 'Document Action Error',
                                description: origin_trans_code+origin_type_code+" origin document is not available",
                                style: getNotificationStyle('error')
                            });
                            return;
                        }
                        secureStorage.setItem("temp_document_id", doc_id);
                        secureStorage.setItem("documentTypeId", origin_document_type.id);
                        secureStorage.setItem("documentTypeName", origin_document_type.name);
                        secureStorage.setItem("documentTypeCode", origin_document_type.trans_code+origin_document_type.type_code);
                        secureStorage.setItem("documentTypeFriendlyCode", origin_document_type.friendly_code);
                        // The table options include component callbacks such as rowSelectionChanged
                        Object.assign(this.$data, this.$options.data.call(this));
                        await this.$nextTick();
                        this.documentNumber = secureStorage.getItem('temp_document_id');

                        this.currentDocumentTypeId = secureStorage.getItem('documentTypeId')
                        this.currentDocumentTypeName = secureStorage.getItem('documentTypeName')
                        this.currentDocumentTypeCode = secureStorage.getItem('documentTypeCode')
                        this.currentDocumentTypeFriendlyCode = secureStorage.getItem('documentTypeFriendlyCode')
                        this.currentDocumentTypeFriendlyCodeWithId = this.currentDocumentTypeFriendlyCode+"#"+this.documentNumber
                    }
                }
                if (secureStorage.getItem("documentTypeInternalCode") == "ORIASN" || secureStorage.getItem("documentTypeInternalCode") == "ORIPOX"){
                    let qryasnModule = await HTTPRequest.getRequest(this.endPoint + "system_module_categories?code=PTP-006", null, null)
                    this.asnModule = qryasnModule.length
                }
                await this.getSettings();
                await this.initializeDocument();
                // window.location.reload()
                } catch (error) {
                    console.error('Failed to open related document', error);
                    this.$notification['error']({
                        message: 'Document Action Error',
                        description: 'Unable to load the selected related document. Please try again.',
                        style: getNotificationStyle('error')
                    });
                } finally {
                    this.spinning = false;
                }
            },
            async processChildDocument(isASN){
                this.actionDocumentButton = true
                var originDocumentNumber = this.documentNumber
                var originDocumentTypeId = this.currentDocumentTypeId
                var originDocumentTypeName = this.currentDocumentTypeName
                var documentTypes = await HTTPRequest.getRequest(this.endPoint + '/document_types/get_document_types_on_system_modules', null, null)
                if (documentTypes){
                    var origin_document_type = documentTypes.find(x => x.id === this.currentDocumentTypeId)
                    if (origin_document_type) {
                        if (isASN) {
                            var child_trans_code = origin_document_type.child_trans_code2
                            var child_type_code = origin_document_type.child_type_code2
                        } else {
                            var child_trans_code = origin_document_type.child_trans_code
                            var child_type_code = origin_document_type.child_type_code
                        }

                        var child_document_type = documentTypes.find(x => x.trans_code === child_trans_code && x.type_code === child_type_code)
                        if(child_document_type == undefined){
                            this.$notification['error']({
                                message: 'Document Action Error',
                                description: child_trans_code+child_type_code+" child document is not available",
                                style: getNotificationStyle('error')
                            });
                            return;
                        }
                        secureStorage.setItem("temp_document_id", 0);
                        secureStorage.setItem("documentTypeId", child_document_type.id);
                        secureStorage.setItem("documentTypeName", child_document_type.name);
                        secureStorage.setItem("documentTypeCode", child_document_type.trans_code+child_document_type.type_code);
                        secureStorage.setItem("documentTypeFriendlyCode", child_document_type.friendly_code);
                        if (this.currentDocumentTypeCode=='OTHQUO' || this.currentDocumentTypeCode=='OTHBIN' || this.currentDocumentTypeCode=='OTHCPO'){
                            Object.assign(this.$data, this.$options.data());
                        }else{
                            this.tabulator.clearData();
                            Object.assign(this.$data.options,(secureStorage.hasOwnProperty('DataOptions')) ? secureStorage.getItem('DataOptions').options : this.$options.data())
                        }
                        if (child_document_type != undefined){
                            this.documentNumber = 0
                            this.currentDocumentTypeId = child_document_type.id
                            this.currentDocumentTypeName = child_document_type.name
                            this.currentDocumentTypeCode =  child_document_type.trans_code+child_document_type.type_code
                            this.currentDocumentTypeFriendlyCode = child_document_type.friendly_code
                            this.existingDocumentTypeDetails.existingDocumentTypeId = child_document_type.id
                            this.existingDocumentTypeDetails.currentDocumentTypeName = child_document_type.name
                            this.existingDocumentTypeDetails.currentDocumentTypeCode = this.currentDocumentTypeCode
                            this.existingDocumentTypeDetails.currentDocumentTypeFriendlyCode = this.currentDocumentTypeFriendlyCode
                        }else {
                            this.currentDocumentTypeId = secureStorage.getItem('documentTypeId')
                            this.currentDocumentTypeName = secureStorage.getItem('documentTypeName')
                            this.currentDocumentTypeCode = secureStorage.getItem('documentTypeCode')
                            this.currentDocumentTypeFriendlyCode = secureStorage.getItem('documentTypeFriendlyCode')
                        }
                        this.currentDocumentTypeFriendlyCodeWithId = this.currentDocumentTypeFriendlyCode+"#"+this.documentNumber
                        this.originDocumentNumber = originDocumentNumber
                        this.originDocumentTypeId = originDocumentTypeId
                        this.originDocumentTypeName = originDocumentTypeName
                    }
                }
                await this.initializeDocument();
                if(this.accountName.toLowerCase().includes('primerph')){
                    this.targetDate = moment(new Date()).add(1, 'days')
                }
                this.documentDate = moment(new Date());
                if (this.currencyId > 0){
                    var currency_histories = await this.getSupplierCurrencyByDocDate(this.currencyId)
                    if (currency_histories.length > 0) {
                        this.currencyRate = currency_histories[0].conversion_rate || this.currencyDetails.conversion || 1
                    }else {
                        this.currencyRate = this.currencyDetails.conversion || 1
                    }
                }
                await this.save();
                this.actionDocumentButton = false
            },
            async initializeDocument(is_reload) {
                // window.checkAndAttachMapScript(this.initLocationSearch);
                // NOTE: do NOT invalidate the document cache here. beforeMount and mounted
                // run concurrently (both async), so getCountryOptions()/getB2bCustomerOptions()
                // may populate the cache before/while initializeDocument runs. Invalidating
                // here would throw that away and force duplicate GET documents/{id} calls.
                // The cache is invalidated in openDocument (document switch/reload) and after
                // mutations, which is where a fresh fetch is actually needed.
                window.addEventListener('scroll', this.handleScroll);
                this.spinning = true;
                component_x = this
                //Retrieve TaxRate from Global Settings
                var tax_rate_settings = await HTTPRequest.getRequest(this.endPoint + '/system_settings');
                var default_vat_rate = 12
                if (tax_rate_settings.data[0]) {
                    default_vat_rate = JSON.parse(tax_rate_settings.data[0].settings_json).default_vat_rate || 12
                }

                this.taxRate = Number(default_vat_rate) / 100

                //Retrieving and application of Document Access Rights
                var system_module = await HTTPRequest.getRequest(this.endPoint+'/system_modules?status=A&code='+ this.currentDocumentTypeCode, null)
                var accessRightsRequest = await this.getUserAccessRights(system_module[0].id)
                this.currentSystemModule = system_module[0] 

                if (accessRightsRequest.access_rights[system_module[0].id]) {
                    this.accessRights  = accessRightsRequest.access_rights[system_module[0].id];
                } else {
                    this.accessRights = [];
                }

                //3082
                //123 >> PRODUCTS | 125 >> PWS
                var system_module_id = (this.currentDocumentTypeCode == 'OTHPWS') ? 125 : 123;
                var accessCostPriceRightsRequest = await this.getUserAccessRights(system_module_id)
    
                if (_.isEmpty(accessCostPriceRightsRequest.access_rights) == false){
                    this.accessCostPriceRights = accessCostPriceRightsRequest.access_rights[system_module_id]
                }else {
                    this.accessCostPriceRights = []
                }

                if(this.currentDocumentTypeCode == 'OTHPWS'){
                    var product_access_cost_price = await this.getUserAccessRights(123)
                    var product_accessCostPriceRights = product_access_cost_price.access_rights[123]
                    if(product_accessCostPriceRights.includes("Z")){
                        this.accessCostPriceRights.push('ZZ')
                    }
                    if(product_accessCostPriceRights.includes("Y")){
                        this.accessCostPriceRights.push('YY')
                    }
                }
                component_x.isSaveDisabled = (!this.accessRights.includes('W')) ? true : false;
                component_x.isUpdateDisabled = (!this.accessRights.includes('W')) ? true : false;
                component_x.isTableEditable = (!this.accessRights.includes('W')) ? true : false;
                component_x.isSupplyingSiteDisabled = (!this.accessRights.includes('W')) ? true : false;
                component_x.isRequestingSiteDisabled = (!this.accessRights.includes('W')) ? true : false;
                component_x.isHeaderDiscountDisabled = (!this.accessRights.includes('W')) ? true : false;
                component_x.productFormMode = (!this.accessRights.includes('W')) ? "Search" : "Add";
                component_x.isReferenceDisabled = (!this.accessRights.includes('W')) ? true : false;
                component_x.isPaymentTermDisabled = (!this.accessRights.includes('W')) ? true : false;
                component_x.isWTaxDisabled = (!this.accessRights.includes('W')) ? true : false;
                component_x.isShippingMethodDisabled = (!this.accessRights.includes('W')) ? true : false;
                component_x.isSupportsDiscountDisabled = (!this.accessRights.includes('W')) ? true : false;
                component_x.isPurposeDisabled = (!this.accessRights.includes('W')) ? true : false;
                component_x.isDocumentDateDisabled = (!this.accessRights.includes('W')) ? true : false;
                component_x.isTargetDateDisabled = (!this.accessRights.includes('W')) ? true : false;
                component_x.isCancellationDateDisabled = (!this.accessRights.includes('W')) ? true : false;
                component_x.isOriginSublocationDisabled = (!this.accessRights.includes('W')) ? true : false;
                component_x.isDestinationSublocationDisabled = (!this.accessRights.includes('W')) ? true : false;
                component_x.isCustomerDisabled = (!this.accessRights.includes('W')) ? true : false;
                component_x.isSalesmanDisabled = (!this.accessRights.includes('W')) ? true : false;
                component_x.isCustomerCreateDisabled = (!this.accessRights.includes('W')) ? true : false;
                // bryan
                component_x.isForThisSiteDisabled = (!this.accessRights.includes('W') || !secureStorage.getItem("sitePricingEnabled")) ? true : false; 
                this.isLotCodeExpiryDisabled = (this.currentDocumentTypeCode.substring(0,3) == "REC") ? false : true;
               
                //brand_col = this.tabulator.getColumns('brand_id')
                //Get Tabulator Instance
                this.tabulator = this.$refs.tabulator.getInstance();
                this.tabulator.clearData();

                //Optimization - Load only b2b for document types with [customer] party table
                var current_document = await HTTPRequest.getRequest(this.endPoint+'/document_types/'+component_x.currentDocumentTypeId, null);
                if(current_document['party_table'] == 'customer' || ['OTHTOV', 'OTHPCV'].includes(this.currentDocumentTypeCode)){
                    await this.getB2bCustomerOptions(0);
                }

                //Document Configuration Application
                var document_config = await HTTPRequest.getRequest(component_x.endPoint+'/document_types/get_document_type_settings?id='+ component_x.currentDocumentTypeId, null)
                if(document_config) this.document_config = document_config
                if (this.document_config && document_config.document_type_settings.editorBehavior) 
                    this.maxLines = this.document_config.document_type_settings.editorBehavior.maxMassUploadLineRestrictionInput

                if (this.document_config && document_config.document_type_settings.incomingOrder) 
                    this.autoCreateAlterSupp = this.document_config.document_type_settings.incomingOrder.disableAutocreationAlternateSupplierPosting
                
                if (this.document_config && document_config.document_type_settings.additionalEditorBehaviorCheckboxes) 
                    this.filterBySupp = this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.filterProductBySupplier

                //Mount selected Product Price/Cost depending on the configuration
                if (this.document_config && document_config.document_type_settings.priceOrCost) {
                    if (is_reload){
                        this.productPriceChoice = this.productPriceChoice
                    }else{
                        this.productPriceChoice = document_config.document_type_settings.priceOrCost
                        this.productPriceChoice = _.snakeCase(this.productPriceChoice);
                    }
                    var unit_cost_column = this.tabulator.getColumn("price")
                    if (unit_cost_column)
                        await unit_cost_column.updateDefinition({title: _.capitalize(this.productPriceChoice.split('_').pop())})

                    var unit_cost_column_php = this.tabulator.getColumn("price_php")
                    if (unit_cost_column_php)
                        await unit_cost_column_php.updateDefinition({title: _.capitalize(this.productPriceChoice.split('_').pop()) + ' (PHP)' })
                }

                //Disable Editing Depending on Config
                if (component_x.document_config && !component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.itemDescEditForPrinting) {
                    component_x.isProductNameEditConfigDisabled = !component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.itemDescEditForPrinting
                }

                //Allow Editing of Price & Cost Depending on Config
                if (component_x.document_config && !component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.priceCostEditing && this.currentDocumentTypeCode != 'OTHPWS') {
                    component_x.isPriceCostEditConfigDisabled = !component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.priceCostEditing
                }
                
                // Enable Confirm and Unconfirm Document - Config
                if (component_x.document_config && component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.confirmDocumentStatus) {
                    this.showconfirmUnconfirmButton = component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.confirmDocumentStatus
                }

                //Set Maximum Document Line Limit - Config
                if (component_x.document_config && component_x.document_config.document_type_settings.editorBehavior.lineRestrictionInput){
                    this.maximumDocumentLineNumber = component_x.document_config.document_type_settings.editorBehavior.lineRestrictionInput
                }

                //Set Decimal Places Config
                if (component_x.document_config && component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.fourDecimalPlaces){
                    if (component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.fourDecimalPlaces) {
                        this.decimalPlaces = 4
                    }
                }

                //Set Order Source
                var isSourceMode = null
                var user_settings = await HTTPRequest.getRequest(this.endPoint + '/user_settings?user_specific=Y&module_name='+this.currentDocumentTypeCode+'');
                if (user_settings.data[0]) isSourceMode = user_settings.data[0].settings_json.isSourceMode

                if (component_x.document_config && component_x.document_config.document_type_settings.orderSource){
                    if (isSourceMode == null) isSourceMode = component_x.document_config.document_type_settings.orderSource.enableOrderSourceMode
                    this.isOrderSourceMode = isSourceMode
                    this.isOrderSourceDisabled = !this.isOrderSourceMode
                    if (this.isOrderSourceMode && component_x.document_config.document_type_settings.orderSource.orderSources) {
                        this.orderSources = component_x.document_config.document_type_settings.orderSource.orderSources
                    }
                }

                if(component_x.document_config){
                    var enableAddCharges = component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.enableAddCharges
                    if(enableAddCharges) {
                        component_x.showChargesTable = true
                    }
                    component_x.showVatExclusiveCheckboxConfig = component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.showVatExclusiveAmount
                }

                if (['RELTRX', 'RECTRX', 'RELADJ', 'RECADJ', 'RELDDE', 'RECDEL', 'RECCSR', 'ORIOCR', 'RECCSI'].includes(this.currentDocumentTypeCode)) {
                    this.allowSublocationAllocation = true
                }
                if (['OTHTRA', 'OTHPCK'].includes(this.currentDocumentTypeCode)) {
                    this.allowSiteAllocation = true
                }
                if (component_x.documentNumber>0){
                    var hasChild = await HTTPRequest.getRequest(this.endPoint + "documents/?origin_document_id=" + component_x.documentNumber, null)
                }
                //Setting columns on Document Form Table
                switch(this.currentDocumentTypeCode) {
                    case 'ORITRQ':

                        //1935 - Show Header / Supports Discount for ORITRQ
                        component_x.showHeaderDiscount = true

                        this.filteredColumnFields = [
                            ...this.defaultColumnFields,
                            { name: "actual_quantity", value: true },
                        ]

                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.header = InterbranchDocuments.header
                        this.renderColumnFields()

                        // Arvin
                        // Check if account has autorep feature
                        var categoryId = await HTTPRequest.getRequest(this.endPoint + '/system_module_categories?code=PTP-001', null, null)
                        var autoRepModules = await HTTPRequest.getRequest(this.endPoint + '/system_module_categories/' +  categoryId[0].id + '/enabled_modules', null, null)
                        //Disable this feature, this is not applicable anymore
                        // if(autoRepModules.length > 0) {
                        //     for (var key in autoRepModules) {
                        //         //Retrieving and application of User Access Rights
                        //         var system_module = await HTTPRequest.getRequest(this.endPoint+'/system_modules?status=A&code='+ autoRepModules[key].code, null)
                        //         var accessRightsRequest = await this.getUserAccessRights(system_module[0].id)

                        //         if (accessRightsRequest.access_rights[system_module[0].id]) {
                        //             var withaccessRights  = (accessRightsRequest.access_rights[system_module[0].id].includes('V')) ? 1 : 0
                        //             if(autoRepModules[key].code == 'ORIPOX-AM' && withaccessRights == 1)
                        //                 this.autoRepMinMaxAccess = 1;
                                
                        //             if(autoRepModules[key].code == 'ORIPOX-AO' && withaccessRights == 1)
                        //                 this.autoRepOfftakeAccess = 1;
                        //         } 
                        //     }   
                        // }

                        component_x.requestingSite = {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")}
                        component_x.isRequestingSiteDisabled = true
                        component_x.createChildDocButtonLabel = 'Create Transfer Order'

                        if (this.document_config && this.document_config.document_type_settings.incomingOrder) {
                            this.cancellationDate = moment(new Date()).add(this.document_config.document_type_settings.incomingOrder.cancellationDays, 'days')

                            if(this.document_config.document_type_settings.additionalEditorBehavior){
                                this.offtakeDays = this.document_config.document_type_settings.additionalEditorBehavior.offtakeDays
                            }
                        }
                        break;
                    case 'OROTRQ':

                        //1935 - Show Header / Supports Discount for OROTRQ
                        component_x.showHeaderDiscount = true

                        this.filteredColumnFields = [
                            ...this.defaultColumnFields,
                            { name: "actual_quantity", value: true },
                        ]

                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.header = InterbranchDocuments.header
                        this.renderColumnFields()
                        if (secureStorage.getItem("currentSiteSiteType") == "ho"){
                            component_x.supplyingSite = []
                            component_x.isSupplyingSiteDisabled = false
                        }else{
                            component_x.supplyingSite = {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")}
                            component_x.isSupplyingSiteDisabled = true
                        }
                        component_x.showCreateChildDocButton = true
                        component_x.createChildDocButtonLabel = 'Create Transfer Out'

                        if (this.document_config && this.document_config.document_type_settings.outgoingOrder){
                            this.cancellationDate = moment(new Date()).add(this.document_config.document_type_settings.outgoingOrder.cancellationDays, 'days')
                        }

                        if (component_x.documentNumber < 1) {
                            var document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+this.originDocumentNumber, null);
                            if (document != null){
                                component_x.requestingSite = document['target_site_id']
                                component_x.supplyingSite = document['source_site_id']
                                component_x.reference = document['reference']
                                component_x.remark = document['remark']
                                component_x.targetDate = moment(document["target_date"])
                                component_x.cancellationDate = moment(document["cancellation_date"])
                                component_x.party_tax_type = document['party_tax_type']

                                //Populate Footer and Calculation Data
                                component_x.grossAmount =  document['amount_gross'].replace(',','')
                                component_x.grossAmountDisplay = document['amount_gross'].replace(',','')
                                component_x.overallDiscount = document['amount_header_discount']
                                component_x.overallDiscountPercentage = document['overall_discount_percentage']
                                component_x.netAmount = document['amount_net'].replace(',','')
                                component_x.netAmountDisplay = document['amount_net'].replace(',','')
                                component_x.vatAmount = document['tax_amount']
                                component_x.totalWithVat = document['tax_exempt_amount']
                                component_x.itemDiscount = document['amount_line_discount']
                                component_x.taxRate = document['tax_rate']
                                component_x.grossAmountwithoutTax = document['gross_amount_without_tax']
                                component_x.netAmountWithoutTax = document['net_amount_without_tax']
                                component_x.isRequestingSiteDisabled = true
                            }

                            //Load document lines
                            window.scrollTo(0,0);
                            let document_lines = []
                            document_lines = await HTTPRequest.getRequest(this.endPoint+'document_lines/'+this.originDocumentNumber+'?field_name=document_id&origin_sublocation=0', null)
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                await this.tabulator.addData(document_lines, true);
                            } 
                                
                            this.tabulator.addFilter("line_no", ">", 0);
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                component_x.origData = JSON.stringify(document_lines.reverse()) //For isDirty Data on Document lines
                            } 

                            this.initializeFooterCalculation();
                        }

                        break;
                    case 'RECTRX':

                        //1935 - Show Header for RECTRX
                        component_x.showHeaderDiscount = true

                        //Default Sublocation Handling

                        this.sites = await HTTPRequest.getRequest(this.endPoint + 'sites/get_valid_document_sites', null)
                        this.sublocations = await HTTPRequest.getRequest(this.endPoint + 'sublocations/get_site_sublocations?site_id='+secureStorage.getItem("defaultSiteId"), null)

                        if(this.sublocations.length > 0){
                            var default_sublocation_id = this.sites.find(element => element.id == secureStorage.getItem("defaultSiteId")).sublocation_id || 0
                            var default_sublocation_name = this.sublocations.find(element => element.id == default_sublocation_id).name || ""
                            this.siteSublocation = {key: default_sublocation_id, label: default_sublocation_name}
                            this.default_sublocation_code = this.sublocations.find(element => element.id == default_sublocation_id).code || ""
                        } else {
                            this.notifMessage.push("Site has no default sublocation.")
                            this.documentActionNotification('Document', 'error');
                            
                            return;
                        }
                      
                        this.moveColumnNextToFrozen(this.tabulator, "sublocation", "brand_id", true);
                        this.moveColumnNextToFrozen(this.tabulator,"barcode", "sublocation", true);
                        
                        let stiColumns = this.tabulator.getColumnDefinitions();
                        stiColumns[1].title = "No."
                        this.tabulator.setColumns(stiColumns);

                        this.defaultColumnFields = [
                            { name: "line_no", value: true },
                            { name: "product_icon", value: true },
                            { name: "brand_id", value: true },
                            { name: "sublocation", value: true },
                            { name: "barcode", value: true },
                            { name: "product_name", value: true },
                            { name: "size", value: true },
                            { name: "color", value: true },
                            { name: "unit_id", value: true },
                            { name: "quantity", value: true },
                            { name: "on_hand_quantity", value: true },
                            { name: "avail_qty_to_transact", value: true },
                            { name: "price", value: true },
                            { name: "subtotal", value: true },
                            { name: "discount", value: true },
                            { name: "discount_text", value: true },
                            { name: "remarks", value: true },
                            { name: "vendor_item_no", value: true },
                        ]
                        
                        // if (!this.accessRights.includes("Z")){
                        //     this.defaultColumnFields.forEach((item) => {
                        //         if (item.name === 'cost') {
                        //             item.value = false;
                        //         }
                        //     });
                        // }

                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.header = InterbranchDocuments.header
                        this.header.showBrand = true
                        this.renderColumnFields()

                        component_x.requestingSite = {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")}
                        component_x.isRequestingSiteDisabled = true

                        if (component_x.documentNumber < 1) {
                            var document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+this.originDocumentNumber, null);

                            if (document != null) {
                                component_x.requestingSite = document['target_site_id']
                                component_x.supplyingSite = document['source_site_id']
                                component_x.reference = document['reference']
                                component_x.remark = document['remark']
                                component_x.targetDate = moment(document["target_date"])
                                component_x.cancellationDate = moment(document["cancellation_date"])
                                component_x.party_tax_type = document['party_tax_type']
                                component_x.isOriginSublocationDisabled = true

                                //Populate Footer and Calculation Data
                                component_x.grossAmount =  document['amount_gross'].replace(',','')
                                component_x.grossAmountDisplay = document['amount_gross'].replace(',','')
                                component_x.overallDiscount = document['amount_header_discount']
                                component_x.overallDiscountPercentage = document['overall_discount_percentage']
                                component_x.netAmount = document['amount_net'].replace(',','')
                                component_x.netAmountDisplay = document['amount_net'].replace(',','')
                                component_x.vatAmount = document['tax_amount']
                                component_x.totalWithVat = document['tax_exempt_amount']
                                component_x.itemDiscount = document['amount_line_discount']
                                component_x.taxRate = document['tax_rate']
                                component_x.grossAmountwithoutTax = document['gross_amount_without_tax']
                                component_x.netAmountWithoutTax = document['net_amount_without_tax']
                            }
                            //Load document lines
                            window.scrollTo(0,0);
                            let document_lines = []
                            document_lines = await HTTPRequest.getRequest(this.endPoint+'document_lines/'+this.originDocumentNumber+'?field_name=document_id&origin_sublocation=0', null)
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                await this.tabulator.addData(document_lines, true);
                            } 
                            this.tabulator.addFilter("line_no", ">", 0);
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                component_x.origData = JSON.stringify(document_lines.reverse()) //For isDirty Data on Document lines
                            } 
                            
                            this.initializeFooterCalculation();
                        }
                        component_x.isSupplyingSiteDisabled = true
                        break;
                    case 'OTHTOV':
                        this.tabulator.getColumn('product_name').updateDefinition({title:"Item Description"})
                        this.tabulator.getColumn('price').updateDefinition({ title: "Price" })
                        //this.tabulator.getColumn('brand_id').updateDefinition({ download: false})
                        
                        this.tabulator.moveColumn("reason_id", "variance_quantity", true);
                        this.tabulator.moveColumn("remarks", "reason_id", true);
                        this.moveColumnNextToFrozen(this.tabulator, "brand_id", "subtotal", false);
                        this.moveColumnNextToFrozen(this.tabulator, "barcode", "line_no", true);
                        this.tabulator.moveColumn("line_no", "barcode", false); 

                        this.renameLineNo()

                        this.defaultColumnFields = [
                            {name: 'line_no', value: true},
                            {name: 'barcode', value: true},
                            {name: 'product_name', value: true},
                            {name: 'sto_qty', value: true},
                            {name: 'sti_qty', value: true},
                            {name: 'variance_quantity', value: true},
                            {name: 'reason_id', value: true},
                            {name: 'remarks', value: true},
                            {name: 'price', value: true},
                            {name: 'subtotal', value: true},
                            {name: 'brand_id', value: true},
                            {name: 'vendor_item_no', value: false},
                        ]
                        
                        if (!this.accessRights.includes("Z")){
                            this.defaultColumnFields.forEach((item) => {
                                if (item.name === 'cost') {
                                    item.value = false;
                                }
                            });
                        }
                        
                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.header = InterbranchDocuments.header
                        this.renderColumnFields()

                        component_x.requestingSite = {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")}
                        component_x.isRequestingSiteDisabled = true

                        if (component_x.documentNumber < 1) {
                            var document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+this.originDocumentNumber, null);

                            if (document != null) {
                                component_x.requestingSite = document['target_site_id']
                                component_x.supplyingSite = document['source_site_id']
                                component_x.reference = document['reference']
                                component_x.remark = document['remark']
                                component_x.targetDate = moment(document["target_date"])
                                component_x.cancellationDate = moment(document["cancellation_date"])
                                component_x.party_tax_type = document['party_tax_type']

                                //Populate Footer and Calculation Data
                                component_x.grossAmount =  document['amount_gross'].replace(',','')
                                component_x.grossAmountDisplay = document['amount_gross'].replace(',','')
                                component_x.overallDiscount = document['amount_header_discount']
                                component_x.overallDiscountPercentage = document['overall_discount_percentage']
                                component_x.netAmount = document['amount_net'].replace(',','')
                                component_x.netAmountDisplay = document['amount_net'].replace(',','')
                                component_x.vatAmount = document['tax_amount']
                                component_x.totalWithVat = document['tax_exempt_amount']
                                component_x.itemDiscount = document['amount_line_discount']
                                component_x.taxRate = document['tax_rate']
                                component_x.grossAmountwithoutTax = document['gross_amount_without_tax']
                                component_x.netAmountWithoutTax = document['net_amount_without_tax']
                                component_x.companyOwnerId = document['company_id']
                                component_x.companyOwnerCode = document['company_code']
                            }

                            //Load document lines
                            window.scrollTo(0,0);
                            let document_lines = []
                            document_lines = await HTTPRequest.getRequest(this.endPoint+'document_lines/'+this.originDocumentNumber+'?field_name=document_id&origin_sublocation=0', null)
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                await this.tabulator.addData(document_lines, true);
                            } 
                            this.tabulator.addFilter("line_no", ">", 0);
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                component_x.origData = JSON.stringify(document_lines.reverse()) //For isDirty Data on Document lines
                            } 
                            
                            this.initializeFooterCalculation();
                        }
                        component_x.isSupplyingSiteDisabled = true
                        break;
                    case 'OTHPCV':

                        //Default Sublocation Handling
                        this.doneTitle = "Make sure that your resolution has no impact to inventory. Are you sure you want to mark this document 'DONE'?"
                        this.sites = await HTTPRequest.getRequest(this.endPoint + 'sites/get_valid_document_sites', null)
                        this.sublocations = await HTTPRequest.getRequest(this.endPoint + 'sublocations/get_site_sublocations?site_id='+secureStorage.getItem("defaultSiteId"), null)
                        var default_sublocation_id = this.sites.find(element => element.id == secureStorage.getItem("defaultSiteId")).sublocation_id || 0
                        var default_sublocation_name = this.sublocations.find(element => element.id == default_sublocation_id).name || ""
                        this.siteSublocation = {key: default_sublocation_id, label: default_sublocation_name}
                        this.isSiteSublocationDisabled = true;
                        this.showSummaryCalculation = false
                        this.showUnitCost = false
                        this.showDiscount = false
                        this.showUnitNetCost = false
                        this.showSubtotal = false

                        this.tabulator.getColumn('product_name').updateDefinition({title:"Item Description"})
                        this.moveColumnNextToFrozen(this.tabulator, "barcode", "line_no", true);
                        this.moveColumnNextToFrozen(this.tabulator, "brand_id", "remarks", false);
                        this.tabulator.moveColumn("reason_id", "quantity", false);

                        let pcvColumns = this.tabulator.getColumnDefinitions();
                        pcvColumns[1].title = "Line No."
                        this.tabulator.setColumns(pcvColumns);
                        
                        this.defaultColumnFields = [
                            { name: "line_no", value: true },
                            { name: "product_icon", value: true },
                            { name: "barcode", value: true },
                            { name: "product_name", value: true },
                            { name: "unit_id", value: true },
                            { name: "reason_id", value: true },
                            { name: "quantity", value: true },
                            { name: "actual_quantity", value: true },
                            { name: "pos_sales_quantity", value: true },
                            { name: "pos_return_quantity", value: true },
                            { name: "variance_quantity", value: true },
                            { name: "price", value: true },
                            { name: "cost", value: false },
                            { name: "subtotal", value: true },
                            { name: "remarks", value: true },
                            { name: "brand_id", value: true },
                            { name: "vendor_item_no", value: true },
                        ]
                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.header = PCount.header
                        this.renderColumnFields()

                        this.showCreateChildDocButton = false
                        component_x.showCancellationDate = false
                        component_x.showTargetDate = false
                        component_x.header.showRequestingSite = true
                        component_x.isRequestingSiteDisabled = true
                        break;
                    case 'RELTRX':

                        //check if has child

                        //1935 - Show Header / Supports Discount for RELTRX
                        component_x.showHeaderDiscount = true
                        component_x.showShippingMethod = true
                        this.tabulator.moveColumn("sublocation", "unit_id", true);
                        this.tabulator.moveColumn("barcode", "vendor_item_no", true);
                        // this.tabulator.moveColumn("retail_price", "cost", false);
                        //this.tabulator.getColumn('line_no').updateDefinition({title:"No."})
                        let stoColumns = this.tabulator.getColumnDefinitions();
                        stoColumns[1].title = "No."
                        this.tabulator.setColumns(stoColumns);

                        this.defaultColumnFields = [
                            { name: "line_no", value: true },
                            { name: "product_icon", value: true },
                            { name: "brand_id", value: true },
                            { name: "stock_no", value: true },
                            { name: "product_name", value: true },
                            { name: "size", value: true },
                            { name: "color", value: true },
                            { name: "unit_id", value: true },
                            { name: "sublocation", value: true },
                            { name: "quantity", value: true },
                            { name: "actual_quantity", value: true },
                            { name: "remaining_qty", value: true },
                            { name: "on_hand_quantity", value: true },
                            { name: "avail_qty_to_transact", value: true },
                            { name: "price", value: true },
                            { name: "cost", value: true },
                            // { name: "retail_price", value: true },
                            { name: "subtotal", value: true },
                            { name: "discount", value: true },
                            { name: "discount_text", value: true },
                            { name: "remarks", value: true },
                            { name: "vendor_item_no", value: true },
                            { name: "barcode", value: true },
                        ]

                        if (!this.accessRights.includes("Z")){
                            this.defaultColumnFields.forEach((item) => {
                                if (item.name === 'cost') {
                                    item.value = false;
                                }
                            });
                        }

                        component_x.targetDate = moment(new Date()).add('3', 'days');
                        component_x.isTargetDateDisabled = true
                  
                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.header = InterbranchDocuments.header
                        this.header.showSublocationHeader = false
                        this.header.showSublocationOrigin = true
                        this.header.showBrand = true
                        this.renderColumnFields()

                        if (secureStorage.getItem("currentSiteSiteType") == "ho"){
                            component_x.supplyingSite = []
                            component_x.isSupplyingSiteDisabled = false
                        }else{
                            component_x.supplyingSite = {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")}
                            component_x.isSupplyingSiteDisabled = true
                        }
                        component_x.createChildDocButtonLabel = 'Create Transfer In'

                        if (component_x.documentNumber < 1) {
                            var document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+this.originDocumentNumber, null);
                            if (document != null) {
                                component_x.requestingSite = document['target_site_id']
                                component_x.supplyingSite = document['source_site_id']
                                component_x.reference = document['reference']
                                component_x.remark = document['remark']
                                component_x.targetDate = moment(document["target_date"])
                                component_x.cancellationDate = moment(document["cancellation_date"])
                                component_x.party_tax_type = document['party_tax_type']

                                //Populate Footer and Calculation Data
                                component_x.grossAmount =  document['amount_gross'].replace(',','')
                                component_x.grossAmountDisplay = document['amount_gross'].replace(',','')
                                component_x.overallDiscount = document['amount_header_discount']
                                component_x.overallDiscountPercentage = document['overall_discount_percentage']
                                component_x.netAmount = document['amount_net'].replace(',','')
                                component_x.netAmountDisplay = document['amount_net'].replace(',','')
                                component_x.vatAmount = document['tax_amount']
                                component_x.totalWithVat = document['tax_exempt_amount']
                                component_x.itemDiscount = document['amount_line_discount']
                                component_x.taxRate = document['tax_rate']
                                component_x.grossAmountwithoutTax = document['gross_amount_without_tax']
                                component_x.netAmountWithoutTax = document['net_amount_without_tax']
                            }

                            //Load document lines
                            window.scrollTo(0,0);
                            let document_lines = []
                            document_lines = await HTTPRequest.getRequest(this.endPoint+'document_lines/'+this.originDocumentNumber+'?field_name=document_id&origin_sublocation=0', null)
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                await this.tabulator.addData(document_lines, true);
                            } 
                            this.tabulator.addFilter("line_no", ">", 0);
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                component_x.origData = JSON.stringify(document_lines.reverse()) //For isDirty Data on Document lines
                            } 
                                
                            
                            this.initializeFooterCalculation();
                        }
                        break;
                    
                    case 'ORICSQ':

                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.header = InterbranchDocuments.header
                        this.renderColumnFields()

                        component_x.requestingSite = {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")}
                        component_x.isRequestingSiteDisabled = true
                        component_x.showCreateChildDocButton = true
                        component_x.createChildDocButtonLabel = 'Create Transfer Order'

                        if (this.document_config && this.document_config.document_type_settings.incomingOrder) {
                            this.cancellationDate = moment(new Date()).add(this.document_config.document_type_settings.incomingOrder.cancellationDays, 'days')
                        }
                        break;
                    case 'OROCSQ':
                  
                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.header = InterbranchDocuments.header
                        this.renderColumnFields()

                        if (secureStorage.getItem("currentSiteSiteType") == "ho"){
                            component_x.supplyingSite = []
                            component_x.isSupplyingSiteDisabled = false
                        }else{
                            component_x.supplyingSite = {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")}
                            component_x.isSupplyingSiteDisabled = true
                        }
                        component_x.showCreateChildDocButton = true
                        component_x.createChildDocButtonLabel = 'Create Transfer Out'

                        if (this.document_config && this.document_config.document_type_settings.outgoingOrder){
                            this.cancellationDate = moment(new Date()).add(this.document_config.document_type_settings.outgoingOrder.cancellationDays, 'days')
                        }

                        if (component_x.documentNumber < 1) {
                            var document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+this.originDocumentNumber, null);

                            if (document != null){
                                component_x.requestingSite = document['target_site_id']
                                component_x.supplyingSite = document['source_site_id']
                                component_x.reference = document['reference']
                                component_x.remark = document['remark']
                                component_x.targetDate = moment(document["target_date"])
                                component_x.cancellationDate = moment(document["cancellation_date"])
                                component_x.party_tax_type = document['party_tax_type']

                                //Populate Footer and Calculation Data
                                component_x.grossAmount =  document['amount_gross'].replace(',','')
                                component_x.grossAmountDisplay = document['amount_gross'].replace(',','')
                                component_x.overallDiscount = document['amount_header_discount']
                                component_x.overallDiscountPercentage = document['overall_discount_percentage']
                                component_x.netAmount = document['amount_net'].replace(',','')
                                component_x.netAmountDisplay = document['amount_net'].replace(',','')
                                component_x.vatAmount = document['tax_amount']
                                component_x.totalWithVat = document['tax_exempt_amount']
                                component_x.itemDiscount = document['amount_line_discount']
                                component_x.taxRate = document['tax_rate']
                                component_x.grossAmountwithoutTax = document['gross_amount_without_tax']
                                component_x.netAmountWithoutTax = document['net_amount_without_tax']
                                component_x.isRequestingSiteDisabled = true
                            }

                            //Load document lines
                            window.scrollTo(0,0);
                            let document_lines = []
                            document_lines = await HTTPRequest.getRequest(this.endPoint+'document_lines/'+this.originDocumentNumber+'?field_name=document_id&origin_sublocation=0', null)
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                await this.tabulator.addData(document_lines, true);
                            } 
                            this.tabulator.addFilter("line_no", ">", 0);
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                component_x.origData = JSON.stringify(document_lines.reverse()) //For isDirty Data on Document lines
                            } 
                            
                            this.initializeFooterCalculation();
                        }

                        break;
                    case 'RECCSX':
                       
                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.header = InterbranchDocuments.header
                        this.renderColumnFields()

                        component_x.requestingSite = {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")}
                        component_x.isRequestingSiteDisabled = true

                        if (component_x.documentNumber < 1) {
                            var document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+this.originDocumentNumber, null);

                            if (document != null) {
                                component_x.requestingSite = document['target_site_id']
                                component_x.supplyingSite = document['source_site_id']
                                component_x.reference = document['reference']
                                component_x.remark = document['remark']
                                component_x.targetDate = moment(document["target_date"])
                                component_x.cancellationDate = moment(document["cancellation_date"])
                                component_x.party_tax_type = document['party_tax_type']

                                //Populate Footer and Calculation Data
                                component_x.grossAmount =  document['amount_gross'].replace(',','')
                                component_x.grossAmountDisplay = document['amount_gross'].replace(',','')
                                component_x.overallDiscount = document['amount_header_discount']
                                component_x.overallDiscountPercentage = document['overall_discount_percentage']
                                component_x.netAmount = document['amount_net'].replace(',','')
                                component_x.netAmountDisplay = document['amount_net'].replace(',','')
                                component_x.vatAmount = document['tax_amount']
                                component_x.totalWithVat = document['tax_exempt_amount']
                                component_x.itemDiscount = document['amount_line_discount']
                                component_x.taxRate = document['tax_rate']
                                component_x.grossAmountwithoutTax = document['gross_amount_without_tax']
                                component_x.netAmountWithoutTax = document['net_amount_without_tax']
                                if (secureStorage.getItem("currentSiteSiteType") == "ho"){
                                    component_x.isSupplyingSiteDisabled = false
                                }else{
                                    component_x.isSupplyingSiteDisabled = true
                                }
                            }

                            //Load document lines
                            window.scrollTo(0,0);
                            let document_lines = []
                            document_lines = await HTTPRequest.getRequest(this.endPoint+'document_lines/'+this.originDocumentNumber+'?field_name=document_id&origin_sublocation=0', null)
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                await this.tabulator.addData(document_lines, true);
                            } 
                            this.tabulator.addFilter("line_no", ">", 0);
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                component_x.origData = JSON.stringify(document_lines.reverse()) //For isDirty Data on Document lines
                            } 
                            
                            this.initializeFooterCalculation();
                        }

                        break;
                    case 'RELCSX':
                      
                    this.filteredColumnFields = this.defaultColumnFields
                    if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                    this.header = InterbranchDocuments.header
                    this.renderColumnFields()

                        if (secureStorage.getItem("currentSiteSiteType") == "ho"){
                            component_x.supplyingSite = []
                            component_x.isSupplyingSiteDisabled = false
                        }else{
                            component_x.supplyingSite = {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")}
                            component_x.isSupplyingSiteDisabled = true
                        }
                        component_x.showCreateChildDocButton = true
                        component_x.createChildDocButtonLabel = 'Create Transfer In'

                        if (component_x.documentNumber < 1) {
                            var document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+this.originDocumentNumber, null);
                            if (document != null) {
                                component_x.requestingSite = document['target_site_id']
                                component_x.supplyingSite = document['source_site_id']
                                component_x.reference = document['reference']
                                component_x.remark = document['remark']
                                component_x.targetDate = moment(document["target_date"])
                                component_x.cancellationDate = moment(document["cancellation_date"])
                                component_x.party_tax_type = document['party_tax_type']

                                //Populate Footer and Calculation Data
                                component_x.grossAmount =  document['amount_gross'].replace(',','')
                                component_x.grossAmountDisplay = document['amount_gross'].replace(',','')
                                component_x.overallDiscount = document['amount_header_discount']
                                component_x.overallDiscountPercentage = document['overall_discount_percentage']
                                component_x.netAmount = document['amount_net'].replace(',','')
                                component_x.netAmountDisplay = document['amount_net'].replace(',','')
                                component_x.vatAmount = document['tax_amount']
                                component_x.totalWithVat = document['tax_exempt_amount']
                                component_x.itemDiscount = document['amount_line_discount']
                                component_x.taxRate = document['tax_rate']
                                component_x.grossAmountwithoutTax = document['gross_amount_without_tax']
                                component_x.netAmountWithoutTax = document['net_amount_without_tax']
                            }

                            //Load document lines
                            window.scrollTo(0,0);
                            let document_lines = []
                            document_lines = await HTTPRequest.getRequest(this.endPoint+'document_lines/'+this.originDocumentNumber+'?field_name=document_id&origin_sublocation=0', null)
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                await this.tabulator.addData(document_lines, true);
                            } 
                            this.tabulator.addFilter("line_no", ">", 0);
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                component_x.origData = JSON.stringify(document_lines.reverse()) //For isDirty Data on Document lines
                            } 
                            
                            this.initializeFooterCalculation();
                        }

                        break;
                    case 'OTHPUR':

                        //1935 - Show Header / Supports Discount for OTHPUR
                        component_x.showHeaderDiscount = true
                        component_x.showSupportDiscount = true
                        this.tabulator.moveColumn("barcode", "vendor_item_no", false);
                        this.tabulator.getColumn('cost').updateDefinition({ title: "Unit Net Ordering Cost" })

                    this.defaultColumnFields = [
                         ...this.defaultColumnFields.filter(({name}) => name !== "discount_text" ),
                         { name: "actual_quantity", value: false },
                         { name: "vendor_item_no", value: true },
                         { name: "remaining_qty", value: true },
                         { name: "avail_qty_to_transact", value: true },
                    ]

                    this.defaultColumnFields = this.defaultColumnFields.map(field => {
                            if ((field.name === 'remarks'|| field.name === 'discount') && field.value === true) {
                                return { ...field, value: false };
                            }else if(field.name === 'price'){
                                return { ...field, value: true };
                            }
                            return field;
                    });

                    this.filteredColumnFields = this.defaultColumnFields
                    if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                    this.filteredColumnFields.push({ name: "brand_name", value: true })
                    this.header = PurchaseDocuments.header
                    this.header.showBrand = true
                    this.renderColumnFields()

                    if (this.document_config && this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.displayVatAmount){
                        this.displayVatAmount = this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.displayVatAmount || false
                    }
                    if (this.document_config && this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.displayNetAmountWOVat){
                        this.displayNetAmountWOVat = this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.displayNetAmountWOVat || false
                        this.displayNetAmountWOVatLabel = this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.displayNetAmountWOVatLabel || "Net Amount w/o VAT"
                    }

                        component_x.showCreateChildDocButton = true

                        if (secureStorage.getItem("currentSiteSiteType") == "ho"){
                            component_x.isRequestingSiteDisabled = false
                        }else{
                            component_x.isRequestingSiteDisabled = true
                        }

                        component_x.requestingSite = {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")}
                        component_x.header.showRequestingSite = true
                        component_x.createChildDocButtonLabel = 'Create PO'
                        break;
                    case 'ORIPOX':

                        // var subtotal = this.tabulator.getColumn("ref_code");
                        // await subtotal.updateDefinition({ download: true });
                        var unit = this.tabulator.getColumn("unit_id");
                        await unit.updateDefinition({ visible: true });
                       
                        this.tabulator.moveColumn("barcode", "vendor_item_no", false);
                        this.tabulator.moveColumn("total_gross", "price", true);
                        //1935 - Show Header / Supports Discount for ORIPOX
                        component_x.showHeaderDiscount = true
                        component_x.showSupportDiscount = false
                        this.asnModule = 1

                    this.defaultColumnFields = [
                        { name: "line_no", value: true },
                        { name: "supplier_stock_no", value: false },
                        { name: "product_icon", value: true },
                        { name: "stock_no", value: true },
                        { name: "barcode", value: true },
                        { name: "product_name", value: true },
                        { name: "unit_name", value: true },
                        { name: "quantity", value: true },
                        { name: "actual_quantity", value: false },
                        { name: "content_quantity", value: false },
                        { name: "price", value: true },
                        { name: "net_cost", value: true },
                        { name: "total_gross", value: true },
                        { name: "subtotal", value: true },
                        { name: "discount_text", value: true },
                        { name: "discount", value: true },
                        { name: "available_quantity", value: false },
                        { name: "on_hand_quantity", value: true },
                        { name: "vendor_item_no", value: true },
                        { name: "remaining_qty", value: true },
                        { name: "avail_qty_to_transact", value: true },
                    ]

                        
                    // Arvin
                    // Check if account has autorep feature
                    var categoryId = await HTTPRequest.getRequest(this.endPoint + '/system_module_categories?code=PTP-001', null, null)
                    var autoRepModules = await HTTPRequest.getRequest(this.endPoint + '/system_module_categories/' +  categoryId[0].id + '/enabled_modules', null, null)
                        
                    // if(autoRepModules.length > 0) {
                    //     for (var key in autoRepModules) {
                    //         //Retrieving and application of User Access Rights
                    //         var system_module = await HTTPRequest.getRequest(this.endPoint+'/system_modules?status=A&code='+ autoRepModules[key].code, null)
                    //         var accessRightsRequest = await this.getUserAccessRights(system_module[0].id)

                    //         if (accessRightsRequest.access_rights[system_module[0].id]) {
                    //             var withaccessRights  = (accessRightsRequest.access_rights[system_module[0].id].includes('V')) ? 1 : 0;
                    //             if(autoRepModules[key].code == 'ORIPOX-AM' && withaccessRights == 1)
                    //                 this.autoRepMinMaxAccess = 1;
                                
                    //             if(autoRepModules[key].code == 'ORIPOX-AO' && withaccessRights == 1)
                    //                 this.autoRepOfftakeAccess = 1;
                    //         } 
                    //     }   
                    // }

                    this.filteredColumnFields = this.defaultColumnFields
                    if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                    this.filteredColumnFields.push({ name: "brand_name", value: true })
                    this.header = PurchaseDocuments.headerOriPox
                    this.header.showBrand = true
                    this.renderColumnFields()

                    if (secureStorage.getItem("currentSiteSiteType") == "ho"){
                        component_x.isRequestingSiteDisabled = false
                    }else{
                        //EJ
                        component_x.isRequestingSiteDisabled = true
                        component_x.requestingSite = {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")}
                    }
                        if (this.document_config && this.document_config.document_type_settings.incomingOrder) {
                            this.cancellationDate = moment(new Date()).add(this.document_config.document_type_settings.incomingOrder.cancellationDays, 'days')
                        }
                        if (this.document_config && this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.displayVatAmount){
                            this.displayVatAmount = this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.displayVatAmount || false
                        }
                        if (this.document_config && this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.CopyLatestPriceOrCost){
                            this.copyLatestPriceOrCost = this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.CopyLatestPriceOrCost || false
                        }
                        if (this.document_config && this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.displayNetAmountWOVat){
                            this.displayNetAmountWOVat = this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.displayNetAmountWOVat || false
                            this.displayNetAmountWOVatLabel = this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.displayNetAmountWOVatLabel || "Net Amount w/o VAT"
                        }
                        //Show Charges and Vat Exclusive Option
                        component_x.showChargesTable = true
                        if(component_x.document_config){
                            component_x.showVatExclusiveCheckboxConfig = component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.showVatExclusiveAmount
                            
                            if(component_x.document_config.document_type_settings.additionalEditorBehavior){
                                this.offtakeDays = component_x.document_config.document_type_settings.additionalEditorBehavior.offtakeDays
                            }
                        }
                        component_x.showVatExclusiveCheckbox = false
                        component_x.showShippingMethod = true
                        component_x.showCreateChildDocButton = true
                        component_x.createChildDocButtonLabel = 'Create RR'
                        component_x.showSupplierOptions = true
                        component_x.showTradeToggle = true

                        //Document Charges
                        //Use document number if origin document number is not exist (TKT#2764)
                        // Only fetch document charges for OTHSBI documents.
                        if (component_x.currentDocumentTypeCode === 'OTHSBI') {
                            var oripoxChargeDocId = (component_x.originDocumentNumber > 0) ? component_x.originDocumentNumber : component_x.documentNumber
                            if (oripoxChargeDocId > 0) {
                                var document_charges = []
                                document_charges = await HTTPRequest.getRequest(component_x.endPoint + "document_charges/"+oripoxChargeDocId+"?field_name=document_id",null);
                                if(document_charges) component_x.chargeData = document_charges
                            }
                        }

                        //console.log(component_x.documentNumber < 1)
                        if (component_x.documentNumber < 1) {
                            var document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+this.documentNumber, null);
                            if (document != null) {
                                component_x.supplier = document["supplier_id"]
                                component_x.currency = document["ui_currency_id"]
                                component_x.currencyDetails = document["ui_currency_id"]
                                component_x.currencyRate = document["currency_rate"]
                                component_x.reference = document['reference']
                                component_x.remark = document['remark']
                                component_x.targetDate = moment(document["target_date"])
                                component_x.cancellationDate = moment(document["cancellation_date"])

                                //Populate Footer and Calculation Data
                                component_x.grossAmount =  document['amount_gross'].replace(',','')
                                component_x.grossAmountDisplay = document['amount_gross'].replace(',','')
                                component_x.overallDiscount = document['amount_header_discount']
                                component_x.overallDiscountPercentage = document['overall_discount_percentage']
                                component_x.netAmount = document['amount_net'].replace(',','')
                                component_x.netAmountDisplay = document['amount_net'].replace(',','')
                                component_x.vatAmount = document['tax_amount']
                                component_x.totalWithVat = document['tax_exempt_amount']
                                component_x.itemDiscount = document['amount_line_discount']
                                component_x.taxRate = document['tax_rate']
                                component_x.grossAmountwithoutTax = document['gross_amount_without_tax']
                                component_x.netAmountWithoutTax = document['net_amount_without_tax']
                                component_x.currencyId = document['currency_id']['key']
                                component_x.supplierCurrencyName = document['supplier_currency_name']
                                component_x.party = document["party_name"]
                                component_x.party_tax_type =  document['party_tax_type']
                                component_x.requestingSite = document['target_site_id']
                                component_x.fiscalYear  = document["fiscal_year"]
                                component_x.yearSeason = document["year_season"]
                                component_x.noOfCartons  = document["no_of_cartons"]
                                component_x.ocReferenceNo  = document["oc_ref_no"]
                                component_x.shipmentReferenceNo  = document["shipment_ref_no"]
                                component_x.brand = document["brand_filter"]
                                component_x.companyOwnerId = document['company_id']
                                component_x.companyOwnerCode = document['company_code']
                            }

                            //Load document lines
                            window.scrollTo(0,0);
                            let document_lines = []
                            document_lines = await HTTPRequest.getRequest(this.endPoint+'document_lines/'+this.originDocumentNumber+'?field_name=document_id&origin_sublocation=0', null)
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                document_lines = document_lines.map((item) => {
                                    item.quantity = item.quantity - item.actual_quantity
                                    if (item.quantity <= 0) {
                                        item.quantity = 0
                                        item.discount_text = null
                                        item.discount = 0
                                    }
                                    item.actual_quantity = 0
                                    //3058 Recalculate lines 
                                    if(component_x.copyLatestPriceOrCost){
                                        var price = Number(eval('item.price_list.'+component_x.productPriceChoice))
                                        item.price = Number(price || item.price).toFixed(component_x.decimalPlaces)
                                        item.cost = Number(price || item.cost).toFixed(component_x.decimalPlaces)
                                    }
                                    if(this.party_tax_type == "V"){
                                        item.subtotal = ((item.quantity * Number(item.cost).toFixed(this.decimalPlaces)) - Number(item.discount)).toFixed(this.decimalPlaces)
                                        item.subtotal_without_vat = (Number(item.subtotal)/ (1+Number(this.taxRate))).toFixed(this.decimalPlaces)
                                        item.price_without_vat = (Number(item.cost)/ (1+Number(this.taxRate))).toFixed(this.decimalPlaces)
                                        item.tax_amount = item.subtotal - item.subtotal_without_vat
                                    }else{
                                        item.subtotal = ((item.quantity * Number(item.cost).toFixed(this.decimalPlaces)) - Number(item.discount)).toFixed(this.decimalPlaces)
                                        item.subtotal_without_vat = (Number(item.subtotal)).toFixed(this.decimalPlaces)
                                        item.price_without_vat = (Number(item.cost)).toFixed(this.decimalPlaces)
                                        item.tax_amount = 0
                                    }  
                                    return item
                                })
                            }

                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                //Remove 0 quantity
                                let data = []
                                document_lines.forEach((object) => {
                                    if(object.quantity > 0){
                                        data.push(object)
                                    }
                                })
                                //await this.tabulator.addData(document_lines, true);
                                await this.tabulator.addData(data, true);
                            } 

                            this.tabulator.addFilter("line_no", ">", 0);
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                component_x.origData = JSON.stringify(document_lines.reverse()) //For isDirty Data on Document lines
                            } 
                            
                        }
                        this.initializeFooterCalculation();
                        break;
                    case 'ORIASN':

                        this.tabulator.moveColumn("barcode", "vendor_item_no", false);
                        this.tabulator.moveColumn("total_gross", "price", true);
                       
                        this.defaultColumnFields = [
                          ...this.defaultColumnFields,
                          { name: "unit_id", value: true },
                          { name: "total_gross", value: true },
                          { name: "actual_quantity", value: false },
                          { name: "vendor_item_no", value: true },
                          { name: "remaining_qty", value: true },
                          { name: "avail_qty_to_transact", value: true },
                        ]

                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.filteredColumnFields.push({ name: "brand_name", value: true })
                        this.header = PurchaseDocuments.headerOriPox
                        this.header.showBrand = true
                        this.renderColumnFields()

                        component_x.requestingSite = {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")}

                        if (this.document_config && this.document_config.document_type_settings.incomingOrder) {
                            this.cancellationDate = moment(new Date()).add(this.document_config.document_type_settings.incomingOrder.cancellationDays, 'days')
                        }
                        if (this.document_config && this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.displayVatAmount){
                            this.displayVatAmount = this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.displayVatAmount || false
                        }
                        if (this.document_config && this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.displayNetAmountWOVat){
                            this.displayNetAmountWOVat = this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.displayNetAmountWOVat || false
                            this.displayNetAmountWOVatLabel = this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.displayNetAmountWOVatLabel || "Net Amount w/o VAT"
                        }

                        if (this.document_config && this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.disableAddingProducts){
                            this.HideDeleteAndAddProductButton = this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.disableAddingProducts || false
                        }

                        //Show Charges and Vat Exclusive Option
                        component_x.showChargesTable = true
                        if(component_x.document_config){
                            component_x.showVatExclusiveCheckboxConfig = component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.showVatExclusiveAmount
                        }
                        component_x.showHeaderDiscount = true
                        component_x.showSupportDiscount = false
                        component_x.showVatExclusiveCheckbox = true
                        component_x.showShippingMethod = true
                        component_x.showCreateChildDocButton = true
                        component_x.createChildDocButtonLabel = 'Create RR'
                        component_x.showSupplierOptions = true
                        component_x.showTradeToggle = true

                        if (component_x.documentNumber < 1 && this.originDocumentNumber > 0) {
                            var document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+this.originDocumentNumber, null);

                            if (document != null) {
                                component_x.supplier = document["supplier_id"]
                                component_x.reference = document['reference']
                                component_x.remark = document['remark']
                                component_x.targetDate = moment(document["target_date"])
                                component_x.cancellationDate = moment(document["cancellation_date"])

                                //Populate Footer and Calculation Data
                                component_x.grossAmount =  document['amount_gross'].replace(',','')
                                component_x.grossAmountDisplay = document['amount_gross'].replace(',','')
                                component_x.overallDiscount = document['amount_header_discount']
                                component_x.overallDiscountPercentage = document['overall_discount_percentage']
                                component_x.netAmount = document['amount_net'].replace(',','')
                                component_x.netAmountDisplay = document['amount_net'].replace(',','')
                                component_x.vatAmount = document['tax_amount']
                                component_x.totalWithVat = document['tax_exempt_amount']
                                component_x.itemDiscount = document['amount_line_discount']
                                component_x.taxRate = document['tax_rate']
                                component_x.grossAmountwithoutTax = document['gross_amount_without_tax']
                                component_x.netAmountWithoutTax = document['net_amount_without_tax']
                                component_x.currencyId = document['currency_id']['key']
                                component_x.currency = document['ui_currency_id']
                                component_x.supplierCurrencyName = document['supplier_currency_name']
                                component_x.currencyRate =  document['currency_rate']
                                component_x.party_tax_type =  document['party_tax_type']
                                component_x.paymentTerm = document["payment_term_id"]
                                component_x.wTax = {key:document["wtax_code"],label:document["wtax_code"]}
                                component_x.currencyDetails = document["ui_currency_id"]
                                component_x.party = document["party_name"]
                                component_x.requestingSite = document['target_site_id']
                                component_x.fiscalYear  = document["fiscal_year"]
                                component_x.yearSeason = document["year_season"]
                                component_x.noOfCartons  = document["no_of_cartons"]
                                component_x.ocReferenceNo  = document["oc_ref_no"]
                                component_x.shipmentReferenceNo  = document["shipment_ref_no"]
                                component_x.brand = document["brand_filter"]
                                component_x.companyOwnerId = document['company_id']
                                component_x.companyOwnerCode = document['company_code']
                            }

                            //Load document lines
                            window.scrollTo(0,0);
                            let document_lines = []
                            document_lines = await HTTPRequest.getRequest(this.endPoint+'document_lines/'+this.originDocumentNumber+'?field_name=document_id&origin_sublocation=0', null)
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                document_lines = document_lines.map((item) => {
                                  item.quantity = item.quantity - item.actual_quantity
                                  if (item.quantity <= 0) {
                                    item.quantity = 0
                                    item.discount_text = null
                                    item.discount = 0
                                  }
                                  item.actual_quantity = 0
                                  //3058 Recalculate lines
                                    if(this.party_tax_type == "V"){
                                        item.subtotal = ((item.quantity * Number(item.cost).toFixed(this.decimalPlaces)) - Number(item.discount)).toFixed(this.decimalPlaces)
                                        item.subtotal_without_vat = (Number(item.subtotal)/ (1+Number(this.taxRate))).toFixed(this.decimalPlaces)
                                        item.price_without_vat = (Number(item.cost)/ (1+Number(this.taxRate))).toFixed(this.decimalPlaces)
                                        item.tax_amount = item.subtotal - item.subtotal_without_vat
                                    }else{
                                        item.subtotal = ((item.quantity * Number(item.cost).toFixed(this.decimalPlaces)) - Number(item.discount)).toFixed(this.decimalPlaces)
                                        item.subtotal_without_vat = (Number(item.subtotal)).toFixed(this.decimalPlaces)
                                        item.price_without_vat = (Number(item.cost)).toFixed(this.decimalPlaces)
                                        item.tax_amount = 0
                                    }    
                                  return item
                                })
                            }

                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                //Remove 0 quantity
                                let data = []
                                document_lines.forEach((object) => {
                                    if(object.quantity > 0){
                                        data.push(object)
                                    }
                                })
                                //await this.tabulator.addData(document_lines, true);
                                await this.tabulator.addData(data, true);
                            } 

                            this.tabulator.addFilter("line_no", ">", 0);
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                component_x.origData = JSON.stringify(document_lines.reverse()) //For isDirty Data on Document lines
                            } 
                            
                            this.initializeFooterCalculation();
                        }
                        if (secureStorage.getItem("currentSiteSiteType") == "ho"){
                            component_x.isRequestingSiteDisabled = false
                        }else{
                            component_x.isRequestingSiteDisabled = true
                        }
                        break;
                    case 'RECDEL':
                        //1935 - Show Header / Supports Discount for RECDEL
                        component_x.showHeaderDiscount = true
                        component_x.showSupportDiscount = false
                        this.tabulator.moveColumn("barcode", "vendor_item_no", false);
                        this.tabulator.moveColumn("ref_code", "remarks", true);
                        this.tabulator.moveColumn("total_gross", "price", true);
                        this.tabulator.moveColumn("reason_id", "unit_id", true);

                        this.defaultColumnFields = [
                          { name: "line_no", value: true },
                          { name: "brand_id", value: true },
                          { name: "stock_no", value: true },
                          { name: "product_name", value: true },
                          { name: "unit_id", value:true},
                          { name: "reason_id", value:true},
                          { name: "quantity", value: true },
                          { name: "remaining_qty", value: true },
                          { name: "on_hand_quantity", value: true },
                          { name: "avail_qty_to_transact", value: true },
                          { name: "price", value: true },
                          { name: "total_gross", value: true },
                          { name: "cost", value: true },
                          { name: "original_cost", value: true },
                          { name: "prod_ordering_cost", value: true },
                          { name: "price_pi", value: true },
                          { name: "subtotal", value: true },
                          { name: "discount", value: false },
                          { name: "discount_text", value: false },
                          { name: "invoice_amount", value: true },
                          { name: "invoice_discount", value: true },
                          { name: "remarks", value: true },
                          { name: "ref_code", value: true },
                          { name: "barcode", value: true },
                          { name: "vendor_item_no", value: true },
                        ]

                        // Arvin
                        // Check if account has purchase variance feature
                        var categoryId = await HTTPRequest.getRequest(this.endPoint + '/system_module_categories?code=PTP-002', null, null)
                        var purchaseVarianceModules = await HTTPRequest.getRequest(this.endPoint + '/system_module_categories/' +  categoryId[0].id + '/enabled_modules', null, null)
                            
                        if(purchaseVarianceModules.length > 0) {
                            for (var key in purchaseVarianceModules) {
                                //Retrieving and application of User Access Rights
                                var system_module = await HTTPRequest.getRequest(this.endPoint+'/system_modules?status=A&code='+ purchaseVarianceModules[key].code, null)
                                var accessRightsRequest = await this.getUserAccessRights(system_module[0].id)

                                if (accessRightsRequest.access_rights[system_module[0].id]) {
                                    var withaccessRights  = (accessRightsRequest.access_rights[system_module[0].id].includes('V')) ? 1 : 0
                                    if(purchaseVarianceModules[key].code == 'RECDEL-PV' && withaccessRights == 1)
                                        this.purchaseVarianceAccess = 1;
                                } 
                            }   
                        }
                      
                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.filteredColumnFields.push({ name: "brand_name", value: true })
                        this.header = PurchaseDocuments.header
                        this.header.showRequestingSite = true
                        this.header.showBrand = true
                        this.renderColumnFields()
                        if (secureStorage.getItem("currentSiteSiteType") == "ho"){
                            component_x.requestingSite = []
                            component_x.isRequestingSiteDisabled = false
                        }else{
                            component_x.requestingSite = {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")}
                            component_x.isRequestingSiteDisabled = true
                        }

                        //Show Charges and Vat Exclusive Option
                        component_x.showChargesTable = true
                        if(component_x.document_config){
                            component_x.showVatExclusiveCheckboxConfig = component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.showVatExclusiveAmount
                        }
                        if (this.document_config && this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.displayVatAmount){
                            this.displayVatAmount = this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.displayVatAmount || false
                        }
                        if (this.document_config && this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.displayNetAmountWOVat){
                            this.displayNetAmountWOVat = this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.displayNetAmountWOVat || false
                            this.displayNetAmountWOVatLabel = this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.displayNetAmountWOVatLabel || "Net Amount w/o VAT"
                        }

                        component_x.showCancellationDate = false
                        component_x.showTargetDate = false
                        component_x.showVatExclusiveCheckbox = false
                        component_x.showCreateChildDocButton = true
                        component_x.createChildDocButtonLabel = 'Create Purchase Return'

                        //Document Charges
                        //Use document number if origin document number is not exist (TKT#2764)
                        var document_charges = []
                        document_charges = await HTTPRequest.getRequest(component_x.endPoint + "document_charges/"+component_x.documentNumber+"?field_name=document_id",null);
                        if(document_charges) component_x.chargeData = document_charges

                        if (component_x.documentNumber < 1 && this.originDocumentNumber > 0) {
                            var document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+this.originDocumentNumber, null);
                            if (document != null) {
                                component_x.supplier = document["supplier_id"]
                                component_x.currency = document["ui_currency_id"]
                                component_x.currencyDetails = document["ui_currency_id"]
                                component_x.currencyRate = document["currency_rate"]
                                component_x.reference = document['reference']
                                component_x.remark = document['remark']
                                component_x.targetDate = moment(document["target_date"])
                                component_x.cancellationDate = moment(document["cancellation_date"])

                                //Populate Footer and Calculation Data
                                component_x.grossAmount =  document['amount_gross'].replace(',','')
                                component_x.grossAmountDisplay = document['amount_gross'].replace(',','')
                                component_x.overallDiscount = document['amount_header_discount']
                                component_x.overallDiscountPercentage = document['overall_discount_percentage']
                                component_x.netAmount = document['amount_net'].replace(',','')
                                component_x.netAmountDisplay = document['amount_net'].replace(',','')
                                component_x.vatAmount = document['tax_amount']
                                component_x.totalWithVat = document['tax_exempt_amount']
                                component_x.itemDiscount = document['amount_line_discount']
                                component_x.taxRate = document['tax_rate']
                                component_x.grossAmountwithoutTax = document['gross_amount_without_tax']
                                component_x.netAmountWithoutTax = document['net_amount_without_tax']
                                component_x.currencyId = document['currency_id']['key']
                                component_x.supplierCurrencyName = document['supplier_currency_name']
                                component_x.party_tax_type =  document['party_tax_type']
                                component_x.paymentTerm = document["payment_term_id"]
                                component_x.wTax = {key:document["wtax_code"],label:document["wtax_code"]}
                                component_x.party = document["party_name"]
                                component_x.requestingSite = document['target_site_id']
                                component_x.fiscalYear  = document["fiscal_year"]
                                component_x.yearSeason = document["year_season"]
                                component_x.noOfCartons  = document["no_of_cartons"]
                                component_x.ocReferenceNo  = document["oc_ref_no"]
                                component_x.shipmentReferenceNo  = document["shipment_ref_no"]
                                component_x.brand = document["brand_filter"]
                                component_x.companyOwnerId = document['company_id']
                                component_x.companyOwnerCode = document['company_code']
                            }

                            if(component_x.document_config){
                                var notSetRecdelQuantityZero = component_x.document_config.document_type_settings.receivingDocumentWithOrder.populateReceivingReportQuantityBasedOnPurchaseOrder || false
                            }

                            //Load document lines
                            window.scrollTo(0,0);
                            let document_lines = []
                            document_lines = await HTTPRequest.getRequest(this.endPoint+'document_lines/'+this.originDocumentNumber+'?field_name=document_id&origin_sublocation=0', null)
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                document_lines = document_lines.map((item) => {
                                  item.quantity = item.quantity - item.actual_quantity
                                  if (item.quantity <= 0) {
                                    item.quantity = 0
                                    item.discount_text = null
                                    item.discount = 0
                                  }
                                  item.actual_quantity = 0
                                  //3058 Recalculate lines 
                                    if(this.party_tax_type == "V"){
                                        item.subtotal = ((item.quantity * Number(item.cost).toFixed(this.decimalPlaces)) - Number(item.discount)).toFixed(this.decimalPlaces)
                                        item.subtotal_without_vat = (Number(item.subtotal)/ (1+Number(this.taxRate))).toFixed(this.decimalPlaces)
                                        item.price_without_vat = (Number(item.cost)/ (1+Number(this.taxRate))).toFixed(this.decimalPlaces)
                                        item.tax_amount = item.subtotal - item.subtotal_without_vat
                                    }else{
                                        item.subtotal = ((item.quantity * Number(item.cost).toFixed(this.decimalPlaces)) - Number(item.discount)).toFixed(this.decimalPlaces)
                                        item.subtotal_without_vat = (Number(item.subtotal)).toFixed(this.decimalPlaces)
                                        item.price_without_vat = (Number(item.cost)).toFixed(this.decimalPlaces)
                                        item.tax_amount = 0
                                    }  
                                  return item
                                })
                            }
                            if (!notSetRecdelQuantityZero) {
                                document_lines.forEach( row => {
                                    row.quantity = 0
                                });
                            }
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                await this.tabulator.addData(document_lines, true);
                            } 

                            this.tabulator.addFilter("line_no", ">", 0);
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                component_x.origData = JSON.stringify(document_lines.reverse()) //For isDirty Data on Document lines
                            } 
                            
                            
                            this.initializeFooterCalculation();

                            this.isSupplierDisabled = true
                            // this.showCreateChildDocButton = false;
                        }
                        break;
                    case 'OTHSBI':
                        component_x.showHeaderDiscount = true
                        var isBarter = 0
                        if (component_x.documentNumber > 0) {
                            var document = await component_x.getCurrentDocument();
                            isBarter = document.reference_7
                        }
                        this.moveColumnNextToFrozen(this.tabulator, "barcode", "brand_id", true);
                        this.moveColumnNextToFrozen(this.tabulator, "brand_id", "product_icon", true);
                        this.tabulator.moveColumn("ref_code", "remarks", true);
                        this.tabulator.moveColumn("subtotal_php", "discount_text", true);
                        this.tabulator.moveColumn("subtotal", "discount_text", true);

                        let sbiColumns = this.tabulator.getColumnDefinitions();
                        sbiColumns[1].title = "line_no"
                        sbiColumns[4].title = "Barcode No."
                        this.tabulator.setColumns(sbiColumns);


                        if(isBarter == 'Interco Tool'){
                            this.defaultColumnFields = [
                                { name: "product_icon", value: false },
                                { name: "stock_no", value: false },
                                { name: "product_name", value: true },
                                { name: "barcode", value: true },
                                { name: "quantity", value: true },
                                { name: "price", value: false },
                                { name: "subtotal", value: true },
                                { name: "discount", value: true },
                                { name: "invoice_total", value: true },   
                                { name: "cost", value: true },
                                { name: "margin", value: true },
                                { name: "trade_commission_rate", value: true },
                                { name: "trade_discount", value: true },
                                { name: "interco_payable", value: true },
                                { name: "price_pi", value: false },
                                { name: "remaining_qty", value: true },
                                { name: "avail_qty_to_transact", value: true },
                            ]
                        } else {
                            this.defaultColumnFields = [
                                { name: "line_no", value: true },
                                { name: "brand_id", value: true },
                                { name: "barcode", value: true },
                                { name: "product_name", value: true },
                                { name: "unit_id", value: true },
                                { name: "quantity", value: true },
                                { name: "remaining_qty", value: true },
                                { name: "on_hand_quantity", value: true },
                                { name: "avail_qty_to_transact", value: true },
                                { name: "price", value: true },
                                { name: "cost", value: true },
                                { name: "original_cost", value: true },
                                { name: "standby_landed_cost", value: true },
                                { name: "prod_ordering_cost", value: true },
                                { name: "total_gross", value: true },
                                { name: "discount", value: true },
                                { name: "discount_text", value: true },
                                { name: "subtotal", value: true },
                                { name: "invoice_amount", value: true },
                                { name: "invoice_discount", value: true },
                                { name: "discount_total_amount", value: true },
                                { name: "invoice_total", value: true },   
                                { name: "ordering_cost", value: true },
                                { name: "margin", value: true },
                                { name: "trade_commission_rate", value: true },
                                { name: "trade_discount", value: true },
                                { name: "interco_payable", value: true },
                                { name: "remarks", value: true },
                                { name: "vendor_item_no", value: true },
                            ]
                        }
                        
                      
                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.header = PurchaseDocuments.headerOthSbi
                        this.header.showBrand = true
                        this.header.showRequestingSite = true
                        this.renderColumnFields()

                        if (secureStorage.getItem("currentSiteSiteType") == "ho"){
                            component_x.requestingSite = []
                            component_x.isRequestingSiteDisabled = false
                        }else{
                            component_x.requestingSite = {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")}
                            component_x.isRequestingSiteDisabled = true
                        }

                        if(component_x.document_config){
                            component_x.showVatExclusiveCheckboxConfig = component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.showVatExclusiveAmount
                        }
                        component_x.showVatExclusiveCheckbox = true
                        component_x.showDocumentBodyHeader = true
                        component_x.isPurposeDisabled = true
                        component_x.isSupportsDiscountDisabled = true
                        component_x.isSupplierDisabled =  true
                        component_x.isDocumentDateDisabled = true
                        component_x.isTargetDateDisabled = true
                        component_x.isCancellationDateDisabled = true
                        component_x.showChargesTable = true
                        //Document Charges
                        //Use document number if origin document number is not exist (TKT#2764)
                        // Only fetch when there's a valid document/origin id, otherwise this
                        // hits document_charges/0 (or /-1) for a brand new document.
                        var sbiChargeDocId = (component_x.originDocumentNumber > 0) ? component_x.originDocumentNumber : component_x.documentNumber
                        if (sbiChargeDocId > 0) {
                            var document_charges = []
                            document_charges = await HTTPRequest.getRequest(component_x.endPoint + "document_charges/"+sbiChargeDocId+"?field_name=document_id",null);
                            if(document_charges) component_x.chargeData = document_charges
                        }

                        if (component_x.documentNumber < 1) {

                            var receiving_report_id = this.$route.params.receiving_report_id
                            var document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+receiving_report_id, null);

                            component_x.receivingReport = receiving_report_id
                            component_x.supplier = document["supplier_id"]
                            component_x.party_tax_type = document["party_tax_type"]
                            component_x.paymentTerm = document["payment_term_id"]
                            component_x.wTax = {key:document["wtax_code"],label:document["wtax_code"]}
                            component_x.reference = document['reference']
                            component_x.remark = document['remark']
                            component_x.targetDate = moment(document["target_date"])
                            component_x.cancellationDate = moment(document["cancellation_date"])
                            component_x.taxRate = document['tax_rate']
                            component_x.grossAmountwithoutTax = document['gross_amount_without_tax']
                            component_x.netAmountWithoutTax = document['net_amount_without_tax']
                            component_x.currency = document["ui_currency_id"]
                            component_x.currencyDetails = document["ui_currency_id"]
                            component_x.currencyId = document['currency_id']['key']
                            component_x.supplierCurrencyName = document['supplier_currency_name']
                            component_x.currencyRate =  document['currency_rate']
                            component_x.party = document["party_name"]
                            component_x.requestingSite = document['target_site_id']
                            component_x.fiscalYear  = document["fiscal_year"]
                            component_x.yearSeason = document["year_season"]
                            component_x.noOfCartons  = document["no_of_cartons"]
                            component_x.ocReferenceNo  = document["oc_ref_no"]
                            component_x.shipmentReferenceNo  = document["shipment_ref_no"]
                            component_x.brand = document["brand_filter"]
                            component_x.companyOwnerId = document['company_id']
                            component_x.companyOwnerCode = document['company_code']

                            if (document['support_discount_text']) component_x.supportDiscount = document['support_discount_text'].split(',')
                            if (document["discount_text"]!="") {
                                if (document['discount_text'] != null) component_x.headerDiscount = document["discount_text"].split(',')
                            }

                            //Load document lines
                            window.scrollTo(0,0);
                            let document_lines = []
                            document_lines = await HTTPRequest.getRequest(this.endPoint+'document_lines/'+receiving_report_id+'?field_name=document_id', null)
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                document_lines.forEach( row => {
                                    row.goods_issue_quantity = row.quantity
                                });
                                await this.tabulator.addData(document_lines, true);
                            }
                            this.tabulator.addFilter("line_no", ">", 0);
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                component_x.origData = JSON.stringify(document_lines.reverse()) //For isDirty Data on Document lines
                            } 
                            if (parseInt(component_x.brand.key) > 0){
                                component_x.isBrandDisabled = true
                            }
                            this.isPriceCostDisabled = this.isPriceCostEditConfigDisabled
                            

                            //Populate Footer and Calculation Data
                            component_x.grossAmount =  document['amount_gross'].replace(',','')
                            component_x.grossAmountDisplay = document['amount_gross'].replace(',','')
                            component_x.overallDiscount = document['amount_header_discount']
                            component_x.overallDiscountPercentage = document['overall_discount_percentage']
                            component_x.netAmount = document['amount_net'].replace(',','')
                            component_x.netAmountDisplay = document['amount_net'].replace(',','')
                            component_x.vatAmount = document['tax_amount']
                            component_x.totalWithVat = document['tax_exempt_amount']
                            component_x.itemDiscount = document['amount_line_discount']
                            component_x.taxRate = document['tax_rate']
                            component_x.grossAmountwithoutTax = document['gross_amount_without_tax']
                            component_x.netAmountWithoutTax = document['net_amount_without_tax']
                            this.initializeFooterCalculation()
                            if (component_x.totalQuantity == 0) component_x.totalQuantity = document['total_quantity']
                        }
                        break;              
                    case 'OTHLIQ':

                        this.defaultColumnFields = [
                            { name: "line_no", value: true },
                            { name: "product_icon", value: true },
                            { name: "brand_id", value: true },
                            { name: "stock_no", value: true },
                            { name: "product_name", value: true },
                            { name: "site_liquidation", value: true },
                            { name: "barcode", value: true },
                            { name: "alternate_barcode", value: true },
                            { name: "unit_id", value: true },
                            { name: "quantity", value: true },
                            { name: "cost", value: true },
                            { name: "total_gross", value: true },
                            { name: "discount", value: true },
                            { name: "discount_text", value: true },
                            { name: "net_amount", value: true },
                            { name: "trade_commission_rate", value: true },
                            { name: "trade_discount", value: true },
                            { name: "net_receivable", value: true },
                            { name: "cs_quantity", value: true },
                            { name: "cs_amount", value: true },
                            { name: "cs_variance_quantity", value: true },
                            { name: "cs_variance_amount", value: true },
                            { name: "vendor_item_no", value: true }
                        ],
                        
                        this.tabulator.moveColumn("net_amount", "discount_text", true);
                        this.tabulator.getColumn('net_amount').updateDefinition({ title: "Net Sales" })
                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.header = PurchaseDocuments.headerOthLiq
                        this.header.showCompanyDetails = true
                        this.renderColumnFields()
                        this.showCancellationDate = false
                        this.showTargetDate = false
                        if(component_x.document_config){
                            component_x.showVatExclusiveCheckboxConfig = component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.showVatExclusiveAmount
                        }
                        component_x.showVatExclusiveCheckbox = true
                        component_x.isPurposeDisabled = true
                        component_x.showDocumentBodyHeader = true
                        component_x.HideDeleteAndAddProductButton = true
                        component_x.isSupportsDiscountDisabled = true
                        component_x.isSupplierDisabled =  true
                        component_x.isDocumentDateDisabled = true
                        component_x.isTargetDateDisabled = true
                        component_x.isCancellationDateDisabled = true
                        if ( component_x.documentNumber > 0 ) {
                            var document = await component_x.getCurrentDocument();
                            component_x.liqPeriod = document["reference_2"];
                        }
                        this.header.showCustomerType = true
                        this.header.showCustomer = true
                        //this.header.showSublocationHeader = true
                        this.selectedCustomerType = 'b2b'
                        break;
                    case 'OTHPWS':
                        //PWS Price and Cost rights
                        if(this.accessRights.includes('Z')){
                            this.accessPWSCost = true
                        }
                        if(this.accessRights.includes('Y')){
                            this.accessPWSPrice = true
                        }
                       this.defaultColumnFields = [
                         { name: "line_no", value: true },
                         { name: "product_icon", value: true },
                         { name: "product_name", value: true },
                         { name: "on_hand_quantity", value: true },
                         { name: "stock_no", value: true },
                         { name: "barcode", value: true },
                         { name: "old_landed_cost", value: true },
                         { name: "landed_cost", value: true },
                         { name: "old_retail_price", value: true },
                         { name: "retail_price", value: true },
                         { name: "markup_percent", value: true },
                         { name: "old_original_cost", value: true },
                         { name: "original_cost", value: true },
                         { name: "old_ordering_cost", value: true },
                         { name: "ordering_cost", value: true },
                         { name: "old_wholesale_price", value: true },
                         { name: "wholesale_price", value: true },
                         { name: "old_least_price", value: true },
                         { name: "least_price", value: true },
                         { name: "old_special_price", value: true },
                         { name: "special_price", value: true },
                        //  { name: "on_hand_quantity", value: true },
                        //  { name: "available_quantity", value: false },
                        //  { name: "actual_quantity", value: false },
                       ]

                       if(this.accountName.toLowerCase().includes('piml')){
                        this.defaultColumnFields = [
                          ...this.defaultColumnFields,
                         { name: "old_piml_price1", value: true },
                         { name: "piml_price1", value: true },
                         { name: "old_piml_price2", value: true },
                         { name: "piml_price2", value: true },
                         { name: "old_piml_price3", value: true },
                         { name: "piml_price3", value: true },
                        ]
                       }

                        // Reorder column header positions to follow primer's requirement
                        this.tabulator.moveColumn("ordering_cost", "old_ordering_cost", true);
                        this.tabulator.moveColumn("barcode", "vendor_item_no", false);

                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.header = PriceWorkSheet.header
                        this.renderColumnFields()

                        component_x.showSummaryCalculation = false
                        component_x.showTotalQuantity = false
                        component_x.showPwsCosts = true
                        component_x.showCancellationDate = false
                        component_x.showQuantity = false
                        component_x.showUnitCost = false
                        component_x.showDiscount = false
                        component_x.showUnitNetCost = false
                        component_x.showSubtotal = false
                        component_x.showFilteredBySupplier = false

                        // set site default to master if sitePricingEnabled
                        let sitePricingEnabled = secureStorage.getItem("sitePricingEnabled")

                        if ( component_x.documentNumber > 0 ) {
                            var document = await component_x.getCurrentDocument();
                            if( component_x.currentDocumentTypeCode ==='OTHPWS'){
                              component_x.forThisSite = sitePricingEnabled ? document['site_id'] :  {key:'-1', label: 'Master'}
                            }else{
                              component_x.forThisSite = document['site_id']
                            } 
                        } else {
                            component_x.forThisSite = {key:'-1', label: 'Master'}
                        } 

                        // component_x.forThisSite = document['site_id']
                        // component_x.forThisSite = sitePricingEnabled ? document['site_id'] :  {key:'-1', label: 'Master'}
                        // bryan

                        break;
                    case 'OTHBAR':
                        this.defaultColumnFields = [
                          { name: "line_no", value: true },
                          { name: "barcode", value: true },
                          { name: "product_name", value: true },
                          { name: "stock_no", value: true },
                          { name: "quantity", value: true },
                          { name: "color", value: true },
                          { name: "size", value: true },
                          { name: "price", value: true },
                          { name: "actual_quantity", value: true },
                          
                        ]
                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.header = BarcodePrinting.header
                        this.renderColumnFields()
                        this.showSummaryCalculation = false
                        this.showTotalQuantity = true
                        this.showDiscount = false
                        this.showUnitNetCost = false
                        this.showSubtotal = false
                        this.showAdvancedInfo = false

                        if (component_x.documentNumber < 1) {
                            var barcode_printing_id = this.$route.params.barcode_printing_id
                            var document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+barcode_printing_id, null);

                            component_x.reference = document['reference']
                            component_x.remark = document['remark']

                            //Load document lines
                            window.scrollTo(0,0);
                            let document_lines = []
                            document_lines = await HTTPRequest.getRequest(this.endPoint+'document_lines/'+barcode_printing_id+'?field_name=document_id&document_type_code='+this.currentDocumentTypeCode, null)
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                await this.tabulator.addData(document_lines, true);
                            }

                            this.tabulator.addFilter("line_no", ">", 0);
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                component_x.origData = JSON.stringify(document_lines.reverse()) //For isDirty Data on Document lines
                            } 
                            this.initializeFooterCalculation()
                            
                        }
                        break;
                    case 'RELRSR':

                        component_x.showHeaderDiscount = true
                        var isBarter = 0
                        if (component_x.documentNumber > 0) {
                            var document = await component_x.getCurrentDocument();
                            isBarter = document.reference_7
                        }

                        //1935 - Show Header / Supports Discount for RELRSR
                        component_x.showHeaderDiscount = true
                        component_x.showSupportDiscount = false

                        var subtotal = this.tabulator.getColumn("ref_code");
                        if(subtotal)
                            await subtotal.updateDefinition({ download: true });
                        
                        if(isBarter == 'Interco Tool'){
                            this.defaultColumnFields = [
                                { name: "line_no", value: true },
                                { name: "brand_id", value: true },
                                { name: "stock_no", value: true },
                                { name: "product_name", value: true },
                                { name: "ref_code", value: true },
                                { name: "barcode", value: true },
                                { name: "unit_id", value: true },
                                { name: "quantity", value: true },
                                { name: "actual_quantity", value: true },
                                { name: "remaining_qty", value: true },
                                { name: "on_hand_quantity", value: true },
                                { name: "avail_qty_to_transact", value: true },
                                { name: "price", value: true },
                                { name: "cost", value: true },
                                { name: "subtotal", value: true },
                                { name: "discount", value: true },
                                { name: "discount_text", value: true },
                                { name: "invoice_total", value: true },   
                                { name: "margin", value: true },
                                { name: "trade_commission_rate", value: true },
                                { name: "trade_discount", value: true },
                                { name: "interco_payable", value: true },
                                { name: "price_pi", value: false },
                                { name: "remarks", value: true },
                                { name: "vendor_item_no", value: true }
                            ]
                        } else {
                            this.defaultColumnFields = [
                            { name: "line_no", value: true },
                            { name: "brand_id", value: true },
                            { name: "stock_no", value: true },
                            { name: "product_name", value: true },
                            { name: "ref_code", value: true },
                            { name: "barcode", value: true },
                            { name: "unit_id", value: true },
                            { name: "quantity", value: true },
                            { name: "actual_quantity", value: true },
                            { name: "remaining_qty", value: true },
                            { name: "on_hand_quantity", value: true },
                            { name: "avail_qty_to_transact", value: true },
                            { name: "price", value: true },
                            { name: "cost", value: true },
                            { name: "subtotal", value: true },
                            { name: "discount", value: true },
                            { name: "discount_text", value: true },
                            { name: "remarks", value: true },
                            { name: "vendor_item_no", value: true }
                            ]
                      
                        }
                        
                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.header = PurchaseDocuments.header
                        this.renderColumnFields()

                        if (component_x.documentNumber < 1 && this.originDocumentNumber > 0) {
                            var document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+this.originDocumentNumber, null);
                            if (document != null) {
                                component_x.supplier = document["supplier_id"]
                                component_x.currency = document["ui_currency_id"]
                                component_x.currencyDetails = document["ui_currency_id"]
                                component_x.currencyRate = document["currency_rate"]
                                component_x.reference = document['reference']
                                component_x.remark = document['remark']
                                component_x.targetDate = moment(document["target_date"])
                                component_x.cancellationDate = moment(document["cancellation_date"])

                                //Populate Footer and Calculation Data
                                component_x.grossAmount =  document['amount_gross'].replace(',','')
                                component_x.grossAmountDisplay = document['amount_gross'].replace(',','')
                                component_x.overallDiscount = document['amount_header_discount']
                                component_x.overallDiscountPercentage = document['overall_discount_percentage']
                                component_x.netAmount = document['amount_net'].replace(',','')
                                component_x.netAmountDisplay = document['amount_net'].replace(',','')
                                component_x.vatAmount = document['tax_amount']
                                component_x.totalWithVat = document['tax_exempt_amount']
                                component_x.itemDiscount = document['amount_line_discount']
                                component_x.taxRate = document['tax_rate']
                                component_x.grossAmountwithoutTax = document['gross_amount_without_tax']
                                component_x.netAmountWithoutTax = document['net_amount_without_tax']
                                component_x.currencyId = document['currency_id']['key']
                                component_x.supplierCurrencyName = document['supplier_currency_name']
                                component_x.party_tax_type =  document['party_tax_type']
                                component_x.paymentTerm = document["payment_term_id"]
                                component_x.wTax = {key:document["wtax_code"],label:document["wtax_code"]}
                                component_x.brand = document["brand_filter"]
                            }

                            //Load document lines
                            window.scrollTo(0,0);
                            let document_lines = []
                            document_lines = await HTTPRequest.getRequest(this.endPoint+'document_lines/'+this.originDocumentNumber+'?field_name=document_id&origin_sublocation=0', null)
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                document_lines = document_lines.map((item) => {
                                  item.quantity = item.quantity - item.actual_quantity
                                  if (item.quantity <= 0) {
                                    item.quantity = 0
                                    item.discount_text = null
                                    item.discount = 0
                                  }
                                  item.actual_quantity = 0
                                  return item
                                })
                            }

                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                await this.tabulator.addData(document_lines, true);
                            } 

                            this.tabulator.addFilter("line_no", ">", 0);
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                component_x.origData = JSON.stringify(document_lines.reverse()) //For isDirty Data on Document lines
                            } 
                            
                            //Document Charges
                            var document_charges = []
                            document_charges = await HTTPRequest.getRequest(component_x.endPoint + "document_charges/"+component_x.originDocumentNumber+"?field_name=document_id", null);
                            if(document_charges) component_x.chargeData = document_charges

                            
                            //this.initializeFooterCalculation();

                            this.isSupplierDisabled = true
                            // this.showCreateChildDocButton = false;
                        }
                        
                        component_x.showCancellationDate = false
                        component_x.showTargetDate = false
                        component_x.isProductSearchDisabled = false
                        this.header.showBrand = true
                        if (secureStorage.getItem("currentSiteSiteType") == "ho"){
                            component_x.header.showRequestingSite = true
                        }
                        break;
                    case 'RECADJ':
                        this.moveColumnNextToFrozen(this.tabulator, "brand_id", "product_name", false);
                        this.moveColumnNextToFrozen(this.tabulator, "barcode", "product_icon", true);
                        this.tabulator.moveColumn("available_quantity", "unit_id", true);
                        this.renameLineNo()
                        // this.tabulator.getColumn("line_no").updateDefinition({title: 'Line No.'})
                        // this.tabulator.getColumn("brand_id").updateDefinition({width: 'auto'})
                        this.defaultColumnFields = [
                            { name: "line_no", value: true },
                            { name: "product_icon", value: true },
                            { name: "barcode", value: true },
                            { name: "product_name", value: true },
                            { name: "brand_id", value: true },
                            { name: "unit_id", value: true },
                            { name: "available_quantity", value: true },
                            { name: "quantity", value: true },
                            { name: "price", value: true },
                            { name: "subtotal", value: true },
                            { name: "vendor_item_no", value: false }
                        ]
                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.header = LocalDocuments.headerAdjustments
                        if (secureStorage.getItem("currentSiteSiteType") == "ho"){
                            this.RequestingLabel = "Target"
                            this.header.showRequestingSite = true
                            this.requestingSite = []
                        }else{
                            this.requestingSite = {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")}
                        }
                        this.header = {...this.header, showParty:false}
                        this.party =  this.requestingSite.label || ''
                        this.renderColumnFields()

                        component_x.showCancellationDate = false
                        component_x.showTargetDate = false
                        break;
                    case 'RELADJ':
                        this.moveColumnNextToFrozen(this.tabulator, "brand_id", "product_name", false);
                        this.moveColumnNextToFrozen(this.tabulator, "barcode", "product_icon", true);
                        this.tabulator.moveColumn("available_quantity", "unit_id", true);
                        this.renameLineNo()
                        // this.tabulator.getColumn("line_no").updateDefinition({title: 'Line No.'})
                        // this.tabulator.getColumn("brand_id").updateDefinition({width: 'auto'})

                        this.defaultColumnFields = [
                            { name: "line_no", value: true },
                            { name: "product_icon", value: true },
                            { name: "barcode", value: true },
                            { name: "product_name", value: true },
                            { name: "brand_id", value: true },
                            { name: "unit_id", value: true },
                            { name: "available_quantity", value: true },
                            { name: "quantity", value: true },
                            { name: "price", value: true },
                            { name: "subtotal", value: true },
                            { name: "vendor_item_no", value: false }
                        ]
                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.filteredColumnFields.filter(({name}) => name !== "vendor_item_no" )
                        this.header = LocalDocuments.headerAdjustments
                        if (secureStorage.getItem("currentSiteSiteType") == "ho"){
                            this.RequestingLabel = "Target"
                            this.header.showRequestingSite = true
                            this.requestingSite = []
                        }else{    
                            this.requestingSite = {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")}
                        }
                        this.header = {...this.header, showParty:false}
                        this.party =  this.requestingSite.label || ''
                        this.renderColumnFields()

                        component_x.showCancellationDate = false
                        component_x.showTargetDate = false
                        break;
                    case 'OTHUPC':
                    case 'OTHPCN':

                        //Default Sublocation Handling

                        this.sites = await HTTPRequest.getRequest(this.endPoint + 'sites/get_valid_document_sites', null)
                        this.sublocations = await HTTPRequest.getRequest(this.endPoint + 'sublocations/get_site_sublocations?site_id='+secureStorage.getItem("defaultSiteId"), null)
                        var default_sublocation_id = this.sites.find(element => element.id == secureStorage.getItem("defaultSiteId")).sublocation_id || 0
                        var default_sublocation_name = this.sublocations.find(element => element.id == default_sublocation_id).name || ""
                        this.siteSublocation = {key: default_sublocation_id, label: default_sublocation_name}
                        this.isSiteSublocationDisabled = true;
                        this.showSummaryCalculation = false
                        this.showUnitCost = false
                        this.showDiscount = false
                        this.showUnitNetCost = false
                        this.showSubtotal = false

                        this.moveColumnNextToFrozen(this.tabulator, "barcode", "product_icon", true);
                        this.tabulator.moveColumn("on_hand_quantity", "price", true);
                        this.renameLineNo()

                        this.defaultColumnFields = [
                            { name: "line_no", value: true },
                            { name: "product_icon", value: true },
                            { name: "barcode", value: true },
                            { name: "stock_no", value: false },
                            { name: "product_name", value: true },
                            { name: "unit_id", value: true },
                            { name: "quantity", value: true },
                            { name: "actual_quantity", value: true },
                            { name: "pos_sales_quantity", value: true },
                            { name: "pos_return_quantity", value: true },
                            { name: "variance_quantity", value: true },
                            { name: "price", value: true },
                            { name: "cost", value: false },
                            { name: "on_hand_quantity", value: true },
                            { name: "subtotal", value: true },  
                            { name: "available_quantity", value: false },
                            { name: "remarks", value: true },
                            { name: "brand_id", value: false },
                            { name: "vendor_item_no", value: false }
                        ]

                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.header = PCount.header
                        this.renderColumnFields()

                        this.showCreateChildDocButton = false
                        component_x.showCancellationDate = false
                        component_x.showTargetDate = false
                        break;
                    case 'OTHASM':
                        this.header.showDocumentHeader = false
                        this.showSummaryCalculation = false
                        this.showUnitCost = false
                        this.showDiscount = false
                        this.showUnitNetCost = false
                        this.showSubtotal = false

                        this.filteredColumnFields = [
                            ...this.defaultColumnFields, 
                            { name: "actual_quantity", value: true }
                        ]

                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.renderColumnFields()

                        component_x.showCancellationDate = false
                        component_x.showTargetDate = false
                        break;
                    case 'OTHDSM':
                        this.header.showDocumentHeader = false
                        this.showSummaryCalculation = false
                        this.showUnitCost = false
                        this.showDiscount = false
                        this.showUnitNetCost = false
                        this.showSubtotal = false

                        this.defaultColumnFields = [
                            ...this.defaultColumnFields, 
                            { name: "actual_quantity", value: true }
                        ]

                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.renderColumnFields()

                        component_x.showCancellationDate = false
                        component_x.showTargetDate = false
                        break;
                    case 'RELSLO':
                          this.defaultColumnFields = [
                          ...this.defaultColumnFields,
                          { name: "actual_quantity", value: true },
                        ]
                      
                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.header = DistributionDocuments.header
                        this.renderColumnFields()

                        component_x.distributionSite = {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")}
                        if (this.serverType == 'branch'){
                            component_x.isDistributionSiteDisabled = true
                        }
                        break;
                    case 'RECSLI':

                        this.defaultColumnFields = [
                          ...this.defaultColumnFields,
                          { name: "actual_quantity", value: true },
                        ]

                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.header = DistributionDocuments.header
                        this.renderColumnFields()

                        component_x.distributionSite = {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")}
                        if (this.serverType == 'branch'){
                            component_x.isDistributionSiteDisabled = true
                        }
                        break;
                    case 'OTHSRQ':
                        component_x.showCreateChildDocButton = true
                        component_x.createChildDocButtonLabel = 'Create Sales Order'
                    case 'ORISOX':
                        if (component_x.currentDocumentTypeCode == 'ORIPOX'){
                            component_x.createChildDocButtonLabel = 'Create Delivery Document'
                        }
                        var orisox_doc_config = await HTTPRequest.getRequest(component_x.endPoint+'/document_types/get_document_type_settings?type_code=SOX&trans_code=ORI', null)
                        //Set Order Source
                        if (orisox_doc_config && orisox_doc_config.document_type_settings.references){
                            this.referenceLabel = orisox_doc_config.document_type_settings.references[0].name || "Reference"
                        }
                        if (orisox_doc_config && orisox_doc_config.document_type_settings.orderSource){
                            this.isOrderSourceMode = orisox_doc_config.document_type_settings.orderSource.enableOrderSourceMode
                        }
                        if (orisox_doc_config && orisox_doc_config.document_type_settings.additionalEditorBehaviorCheckboxes.displayVatAmount){
                            this.displayVatAmount = orisox_doc_config.document_type_settings.additionalEditorBehaviorCheckboxes.displayVatAmount || false
                        }
                        if (orisox_doc_config && orisox_doc_config.document_type_settings.additionalEditorBehaviorCheckboxes.displayNetAmountWOVat){
                            this.displayNetAmountWOVat = orisox_doc_config.document_type_settings.additionalEditorBehaviorCheckboxes.displayNetAmountWOVat || false
                            this.displayNetAmountWOVatLabel = orisox_doc_config.document_type_settings.additionalEditorBehaviorCheckboxes.displayNetAmountWOVatLabel || "Net Amount w/o VAT"
                        }
                        this.showPayButton = true
                        this.showDeliverButton = true
                        this.showCreateChildDocButton = true

                        if (this.accountName.toLowerCase().includes('primerph')) {

                            this.defaultColumnFields = [
                            { name: "line_no", value: true },
                            { name: "product_icon", value: true },
                            { name: "brand_id", value: true },
                            { name: "stock_no", value: true },
                            { name: "product_name", value: true },
                            { name: "ref_code", value: true },
                            { name: "unit_id", value: true },
                            { name: "quantity", value: true },
                            { name: "actual_quantity", value: true },
                            { name: "price", value: true },
                            { name: "total_gross", value: true },
                            { name: "discount", value: true },
                            { name: "discount_text", value: true },
                            { name: "net_amount", value: true },
                            { name: "on_hand_quantity", value: true },
                            { name: "avail_qty_to_transact", value: true },
                            { name: "remarks", value: true },
                            { name: "barcode", value: true },
                            { name: "vendor_item_no", value: true },
                            ]
                        } else {
                            this.defaultColumnFields = [
                            { name: "line_no", value: true },
                            { name: "product_icon", value: true },
                            { name: "brand_id", value: true },
                            { name: "barcode", value: true },
                            { name: "vendor_item_no", value: true },
                            { name: "style_name", value: true }, 
                            { name: "size", value: true },
                            { name: "color", value: true }, 
                            { name: "unit_id", value: true },
                            { name: "quantity", value: true},
                            { name: "actual_quantity", value: true },
                            { name: "price", value: true },
                            { name: "currency", value: true },
                            { name: "total_gross", value: true },
                            { name: "discount", value: true },
                            { name: "discount_text", value: true },
                            { name: "net_amount", value: true },
                            { name: "ordering_cost", value: true },
                            { name: "pur_currency", value: true },
                            { name: "total_ordering_cost", value: true },
                            { name: "barcode_upc", value: true },
                            { name: "barcode_ean", value: true },
                            { name: "factory_name", value: this.currentDocumentTypeCode == 'ORISOX' ? true : false },
                            { name: "product_name", value: true },
                        ]
                        }

                        if (this.accountName.toLowerCase().includes('primerph')) {
                            this.tabulator.moveColumn("price", "actual_quantity", true);
                            this.tabulator.moveColumn("subtotal", "price", true);
                            this.tabulator.moveColumn("discount", "subtotal", true);
                            this.tabulator.moveColumn("barcode", "remarks", true);

                            let allColumns = this.tabulator.getColumnDefinitions();
                            allColumns[1].title = "No."
                            this.tabulator.setColumns(allColumns);

                            this.tabulator.moveColumn("discount_text", "discount", true);
                            this.tabulator.moveColumn("net_amount", "discount_text", true);
                            this.tabulator.moveColumn("total_gross", "price", true);
                            this.tabulator.getColumn('total_gross').updateDefinition({title:"Gross Amount"})
                        }
                       if (this.accountName.toLowerCase().includes('piml')) {
                            this.tabulator.getColumn('ordering_cost').updateDefinition({editable:this.currentDocumentTypeCode == 'OTHSRQ' ? true : false })

                            const index = this.defaultColumnFields.findIndex(field => field.name === 'actual_quantity');
                            if (index !== -1) {
                                this.defaultColumnFields.splice(index + 1, 0, { name: "remaining_qty", value: true });
                            }
                            this.tabulator.moveColumn("net_amount", "discount", true);
                            this.tabulator.moveColumn("product_name", "factory_name", true);
                            this.moveColumnNextToFrozen(this.tabulator, "barcode", "brand_id", true);
                            this.moveColumnNextToFrozen(this.tabulator, "vendor_item_no", "barcode", true);
                            this.tabulator.getColumn('product_name').updateDefinition({ frozen: false })
                            this.tabulator.moveColumn("ordering_cost", "net_amount", true);
                            this.tabulator.moveColumn("discount_text", "net_amount", false);
                            this.tabulator.moveColumn("total_gross", "currency", true);
                            this.tabulator.moveColumn("discount_text", "net_amount", false);
                        }
                      
                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.header = DistributionDocuments.headerOriSox
                        if (this.isOrderSourceMode){
                            this.header.showSublocationDestination = false
                            this.header.showOrderSource = true
                        } else {
                            this.header.showSublocationDestination = true
                            this.header.showOrderSource = false
                        }
                        // if (this.accountName.toLowerCase().includes('piml')) {
                        //     const namesToExclude = ["salesman_name", "ref_code", "line_extras"];
                        //     this.filteredColumnFields = this.filteredColumnFields.filter(field => 
                        //         !namesToExclude.includes(field.name)
                        //     );
                        // }

                        if (this.accountName.toLowerCase().includes('piml')) {
                            this.isPaymentTermDisabled = true;
                        }

                        this.header.showBrand = true
                        this.header.showCompanyDetails = true
                        this.renderColumnFields()

                        //Display Discount Header
                       if(component_x.documentNumber > 0){
                        var document = await component_x.getCurrentDocument();
                        if (document["discount_text"]!="" || document['discount_text'] != null) {
                           component_x.headerDiscount = document["discount_text"].split(',')
                        }
                       }
                       if (component_x.documentNumber < 1) {
                            var document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+this.originDocumentNumber, null);
                            if (document != null){
                                component_x.requestingSite = document['target_site_id']
                                component_x.supplyingSite = document['source_site_id']
                                component_x.reference = document['reference']
                                component_x.reference1 = document['reference_2']
                                component_x.remark = document['remark']
                                component_x.targetDate = moment(document["target_date"])
                                component_x.cancellationDate = moment(document["cancellation_date"])
                                component_x.party_tax_type = document['party_tax_type']
                                component_x.productPriceChoice = document['price_type']
                                component_x.productPriceChoice = document['price_type']

                                //Populate Footer and Calculation Data
                                component_x.grossAmount =  document['amount_gross'].replace(',','')
                                component_x.grossAmountDisplay = document['amount_gross'].replace(',','')
                                component_x.overallDiscount = document['amount_header_discount']
                                component_x.overallDiscountPercentage = document['overall_discount_percentage']
                                component_x.netAmount = document['amount_net'].replace(',','')
                                component_x.netAmountDisplay = document['amount_net'].replace(',','')
                                component_x.vatAmount = document['tax_amount']
                                component_x.totalWithVat = document['tax_exempt_amount']
                                component_x.itemDiscount = document['amount_line_discount']
                                component_x.taxRate = document['tax_rate']
                                component_x.grossAmountwithoutTax = document['gross_amount_without_tax']
                                component_x.netAmountWithoutTax = document['net_amount_without_tax']
                                component_x.isRequestingSiteDisabled = true
                            }

                            //Load document lines
                            window.scrollTo(0,0);
                            let document_lines = []
                            document_lines = await HTTPRequest.getRequest(this.endPoint+'document_lines/'+this.originDocumentNumber+'?field_name=document_id&origin_sublocation=0', null)
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                document_lines = document_lines.map((item) => {
                                  item.quantity = item.quantity - item.actual_quantity
                                  if (item.quantity <= 0) {
                                    item.quantity = 0
                                    item.discount_text = null
                                    item.discount = 0
                                  }
                                  item.actual_quantity = 0
                                  return item
                                })
                            }
                            
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                //Remove 0 quantity
                                let data = []
                                document_lines.forEach((object) => {
                                    if(object.quantity > 0){
                                        data.push(object)
                                    }
                                })
                                //await this.tabulator.addData(document_lines, true);
                                await this.tabulator.addData(data, true);
                            } 
                                
                            this.tabulator.addFilter("line_no", ">", 0);
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                component_x.origData = JSON.stringify(document_lines.reverse()) //For isDirty Data on Document lines
                            } 

                            
                            this.initializeFooterCalculation();
                        }

                        component_x.showHeaderDiscount = true
                      //  bryan
                        if (this.documentNumber > 0) {
                            this.isProductSearchDisabled = false
                        } else {
                            // this.isProductSearchDisabled = true
                        }
                        this.isDestinationSublocationDisabled = true
                        if (this.accountName.toLowerCase().includes('piml')) {
                            this.isPaymentTermDisabled = true;
                        }
                        this.searchFilter = "barcode"
                        this.showShippingMethod = true
                        this.selectedCustomerType = "b2b"
                        //component_x.distributionSite = {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")}
                        component_x.sublocationDestinationLabel = 'Serving Sublocation'
                        break;              
                    case 'ORIOSO':
                        var orioso_doc_config = await HTTPRequest.getRequest(component_x.endPoint+'/document_types/get_document_type_settings?type_code=OSO&trans_code=ORI', null)
                        //Set Order Source
                        if (orioso_doc_config && orioso_doc_config.document_type_settings.references){
                            this.referenceLabel = orioso_doc_config.document_type_settings.references[0].name || "Reference"
                        }
                        if (orioso_doc_config && orioso_doc_config.document_type_settings.additionalEditorBehaviorCheckboxes.displayVatAmount){
                            this.displayVatAmount = orioso_doc_config.document_type_settings.additionalEditorBehaviorCheckboxes.displayVatAmount || false
                        }
                        if (orioso_doc_config && orioso_doc_config.document_type_settings.additionalEditorBehaviorCheckboxes.displayNetAmountWOVat){
                            this.displayNetAmountWOVat = orioso_doc_config.document_type_settings.additionalEditorBehaviorCheckboxes.displayNetAmountWOVat || false
                            this.displayNetAmountWOVatLabel = orioso_doc_config.document_type_settings.additionalEditorBehaviorCheckboxes.displayNetAmountWOVatLabel || "Net Amount w/o VAT"
                        }
                        this.showPayButton = true
                        this.showDeliverButton = true

                        this.defaultColumnFields = [
                            { name: "line_no", value: true },
                            { name: "product_icon", value: true },
                            { name: "stock_no", value: true },
                            { name: "barcode", value: true },
                            { name: "product_name", value: true },
                            { name: "unit_id", value: true },
                            { name: "item_source", value: true },
                            { name: "quantity", value: true },
                            { name: "price", value: true },
                            { name: "subtotal", value: true },
                            { name: "discount_text", value: true },
                            { name: "discount", value: true },
                            { name: "on_hand_quantity", value: true },
                            { name: "ref_code", value: true },
                            { name: "remarks", value: true },
                            { name: "salesman_name", value: true },
                            { name: "line_extras", value: true },
                            { name: "available_quantity", value: false },
                            { name: "on_hand_quantity", value: true },
                            { name: "actual_quantity", value: true },
                            { name: "quantity", value: true },
                        ]

                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.header = DistributionDocuments.headerOriSox
                        if (this.isOrderSourceMode){
                            this.header.showSublocationDestination = false
                            this.header.showOrderSource = true
                        } else {
                            this.header.showSublocationDestination = true
                            this.header.showOrderSource = false
                        }
                        this.header.showCompanyDetails = true
                        this.renderColumnFields()

                        //Display Discount Header
                       if(component_x.documentNumber > 0){
                        var document = await component_x.getCurrentDocument();
                        if (document['discount_text'] != null) {
                           component_x.headerDiscount = document["discount_text"].split(',')
                        }
                       }

                        component_x.showHeaderDiscount = true
                      //  bryan
                        if (this.documentNumber > 0) {
                            this.isProductSearchDisabled = false
                        } else {
                            // this.isProductSearchDisabled = true
                        }
                        this.isDestinationSublocationDisabled = true
                        this.searchFilter = "barcode"
                        this.showShippingMethod = true

                        this.selectedCustomerType = "b2b"
                        //component_x.distributionSite = {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")}
                        component_x.sublocationDestinationLabel = 'Order Source'
                        this.selectedCustomerType = 'b2b'
                        break;
                    case 'RELDDE':
                        component_x.showHeaderDiscount = true
                        var orisox_doc_config = await HTTPRequest.getRequest(component_x.endPoint+'/document_types/get_document_type_settings?type_code=SOX&trans_code=ORI', null)
                        //Set Order Source
                        if (orisox_doc_config && orisox_doc_config.document_type_settings.orderSource){
                            this.isOrderSourceMode = orisox_doc_config.document_type_settings.orderSource.enableOrderSourceMode
                        }
                        var reldde_doc_config = await HTTPRequest.getRequest(component_x.endPoint+'/document_types/get_document_type_settings?type_code=DDE&trans_code=REL', null)
                        //Set Order Source
                        var allowWIthoutSO = false;
                        if (reldde_doc_config && reldde_doc_config.document_type_settings.references){
                            this.referenceLabel = reldde_doc_config.document_type_settings.references[0].name || "Reference"
                            allowWIthoutSO = reldde_doc_config.document_type_settings.additionalEditorBehaviorCheckboxes.allowCreationOfDDWithoutSO
                        }

                        this.tabulator.moveColumn("price", "actual_quantity", true);
                        this.tabulator.moveColumn("subtotal", "price", true);
                        this.tabulator.moveColumn("barcode", "remarks", true);
                        this.tabulator.moveColumn("discount_text", "discount", true);
                        this.tabulator.moveColumn("net_amount", "discount_text", true);
                        this.tabulator.moveColumn("on_hand_quantity", "net_amount", true);
                        this.tabulator.moveColumn("avail_qty_to_transact", "on_hand_quantity", true);
                        this.tabulator.getColumn('total_gross').updateDefinition({title:"Gross Amount"})

                        let allColumns = this.tabulator.getColumnDefinitions();
                        allColumns[1].title = "No."
                        this.tabulator.setColumns(allColumns);

                        this.defaultColumnFields = [
                            { name: "line_no", value: true },
                            { name: "product_icon", value: true },
                            { name: "brand_id", value: true },
                            { name: "stock_no", value: true },
                            { name: "product_name", value: true },
                            { name: "ref_code", value: true },
                            { name: "unit_id", value: true },
                            { name: "quantity", value: true },
                            { name: "actual_quantity", value: true },
                            { name: "price", value: true },
                            { name: "total_gross", value: true },
                            { name: "discount", value: true },
                            { name: "discount_text", value: true },
                            { name: "net_amount", value: true },
                            { name: "on_hand_quantity", value: true },
                            { name: "avail_qty_to_transact", value: true },
                            { name: "remarks", value: true },
                            { name: "barcode", value: true },
                            { name: "vendor_item_no", value: true },
                        ]
                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.header = DistributionDocuments.headerRelDde

                        if (this.isOrderSourceMode){
                            this.header.showSublocationDestination = false
                            this.header.showSublocationOrigin = false
                            this.header.showOrderSource = true
                        } else {
                            this.header.showSublocationDestination = true
                            this.header.showSublocationOrigin = true
                            this.header.showOrderSource = false
                            this.tabulator.toggleColumn("actual_quantity")
                        }
                        this.header.showBrand = true
                        if (!allowWIthoutSO && this.documentNumber==0){
                            this.showBookingButton = true
                            //this.showDocumentBodyHeader = false
                            this.productFormMode = "Search"
                            this.showShippingMethod = true
                        }
                        this.renderColumnFields()
                        //Disable fields

                        if (!allowWIthoutSO && this.documentNumber==0){
                            component_x.isOrderSourceDisabled = true
                            component_x.isCustomerDisabled = true
                            component_x.isCustomerCreateDisabled = true
                            component_x.isOrderTypeDisabled = true
                            component_x.isCountryOfOriginDisabled = true
                            component_x.isFiscalYearDisabled = true
                            component_x.isYearSeasonDisabled = true
                            component_x.isNoOfCartonsDisabled = true
                            component_x.isProvinceDisabled = true
                            component_x.isCityDisabled = true
                            component_x.isBarangayDisabled = true
                            component_x.isZipCodeDisabled = true
                            component_x.isDestinationSublocationDisabled = true
                            component_x.isDistributionSiteDisabled = true
                            component_x.isDocumentDateDisabled = true
                            component_x.isTargetDateDisabled = true
                            component_x.isCancellationDateDisabled = true
                            component_x.isShippingMethodDisabled = true
                            component_x.isPurposeDisabled = true
                            component_x.sublocationDestinationLabel = 'SO Sublocation'
                            component_x.sublocationOriginLabel = 'Serving Sublocation'
                            component_x.remarkLabel = "Remarks (Picker Details, Truck Details, & Other Info)"

                            component_x.showHeaderDiscount = true
                            component_x.isHeaderDiscountDisabled = true
                        }else if (allowWIthoutSO && this.documentNumber==0){
                            component_x.isOrderSourceDisabled = false
                        }

                        if (this.accountName.toLowerCase().includes('piml')) {
                            this.isPaymentTermDisabled = true;
                        }

                        if (component_x.documentNumber < 1) {
                            var sales_order_id = this.$route.params.sales_order_id
                            if (sales_order_id > -1){
                                var document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+sales_order_id, null);

                                var document_charges = []
                                document_charges = await HTTPRequest.getRequest(component_x.endPoint + "document_charges/"+sales_order_id+"?field_name=document_id", null);
                                if(document_charges) component_x.chargeData = document_charges
                                component_x.documentDetails = document
                            }
                            if (document["discount_text"]!="") {
                                if (document['discount_text'] != null) component_x.headerDiscount = document["discount_text"].split(',')
                            }

                            if (document["order_source"]!="") {
                                if (document['order_source'] != null) component_x.orderSource = document["order_source"]
                            }

                            if (document["payment_status"] == "Paid") {
                                this.forPaymentIsProcessed = true
                            }

                            //Populate Document Level Input
                            component_x.distributionSite = document['site_id']
                            component_x.companyOwnerId = document['company_id']
                            component_x.companyOwnerCode = document['company_code']
                            component_x.destinationSublocation = document['target_sublocation_id']
                            component_x.documentDate = moment(new Date())
                            component_x.targetDate = moment(document["target_date"])
                            component_x.cancellationDate = moment(document["cancellation_date"])
                            component_x.reference = document["reference"]
                            component_x.salesOrder = document["document_no"]
                            component_x.customer = document["customer_id"];
                            component_x.b2bCustomer = document["b2b_customer_id"];
                            if (document["shipping_method_id"]["key"] > 0) component_x.shippingMethod = document["shipping_method_id"];

                            component_x.remark = document["remark"];
                            component_x.imageReferenceLink = document["image_ref_link"];
                            component_x.orderType  = document["order_type"];
                            component_x.countryOfOrigin  = document["country_id"]
                            component_x.fiscalYear  = document["fiscal_year"];
                            component_x.yearSeason = document["year_season"];
                            component_x.noOfCartons  = document["no_of_cartons"];
                            component_x.ocReferenceNo  = document["oc_ref_no"];
                            component_x.shipmentReferenceNo  = document["shipment_ref_no"];

                            // trigger function to fetch and process customer details considering customer type
                            await this.fetchAndProcessCustomerDetails(); 

                            if(document["address"]){
                                component_x.customerAddress = document["address"]
                            }

                            //Populate Footer and Calculation Data
                            component_x.grossAmount =  document['amount_gross'].replace(',','')
                            component_x.grossAmountDisplay = document['amount_gross'].replace(',','')
                            component_x.overallDiscount = document['amount_header_discount']
                            component_x.overallDiscountPercentage = document['overall_discount_percentage']
                            component_x.netAmount = document['amount_net'].replace(',','')
                            component_x.netAmountDisplay = document['amount_net'].replace(',','')
                            component_x.vatAmount = document['tax_amount']
                            component_x.totalWithVat = document['tax_exempt_amount']
                            component_x.itemDiscount = document['amount_line_discount']
                            component_x.taxRate = document['tax_rate']
                            component_x.grossAmountwithoutTax = document['gross_amount_without_tax']
                            component_x.netAmountWithoutTax = document['net_amount_without_tax']
                            component_x.party_tax_type = document['party_tax_type']
                            component_x.selectedCustomerType = document["customer_type"]
                            component_x.paymentTerm = document["payment_term_id"]
                            component_x.wTax = {key:document["wtax_code"],label:document["wtax_code"]}

                            //Load document lines
                            window.scrollTo(0,0);
                            let document_lines = []
                            if (sales_order_id > -1){
                                document_lines = await HTTPRequest.getRequest(this.endPoint+'document_lines/'+sales_order_id+'?field_name=document_id&origin_sublocation=0', null)
                            }
                            document_lines.forEach( row => {
                                row.quantity = 0
                            });
                            if(document_lines) await this.tabulator.addData(document_lines, true);
                            this.tabulator.addFilter("line_no", ">", 0);
                            if(document_lines) component_x.origData = JSON.stringify(document_lines.reverse()) //For isDirty Data on Document lines
                            
                        } else {
                            component_x.isOriginSublocationDisabled = true
                            // this.tabulator.toggleColumn("goods_issue_quantity")
                        }

                        break;
                    case 'RELCSI':
                        component_x.showHeaderDiscount = true
                        var orisox_doc_config = await HTTPRequest.getRequest(component_x.endPoint+'/document_types/get_document_type_settings?type_code=SOX&trans_code=ORI', null)
                        //Set Order Source
                        if (orisox_doc_config && orisox_doc_config.document_type_settings.orderSource){
                            this.isOrderSourceMode = orisox_doc_config.document_type_settings.orderSource.enableOrderSourceMode
                        }
                        var reldde_doc_config = await HTTPRequest.getRequest(component_x.endPoint+'/document_types/get_document_type_settings?type_code=DDE&trans_code=REL', null)
                        //Set Order Source
                        var allowWIthoutSO = false;
                        if (reldde_doc_config && reldde_doc_config.document_type_settings.references){
                            this.referenceLabel = reldde_doc_config.document_type_settings.references[0].name || "Reference"
                            allowWIthoutSO = reldde_doc_config.document_type_settings.additionalEditorBehaviorCheckboxes.allowCreationOfDDWithoutSO
                        }
                        

                        this.defaultColumnFields = [
                            { name: "line_no", value: true },
                            { name: "product_icon", value: true },
                            { name: "brand_id", value: true },
                            { name: "barcode", value: true },
                            { name: "alternate_barcode", value: true },
                            { name: "product_name", value: true },
                            { name: "unit_id", value: true },
                            { name: "quantity", value: true },
                            { name: "actual_quantity", value: true },
                            { name: "on_hand_quantity", value: true },
                            { name: "price", value: true },
                            { name: "gross_amount", value: true },
                            { name: "subtotal", value: false },
                            { name: "discount", value: true },
                            { name: "discount_text", value: true },
                            { name: "net_amount", value: true },
                            { name: "remarks", value: true },
                            { name: "vendor_item_no", value: true },
                            { name: "barcode_upc", value: true },
                            { name: "barcode_ean", value: true },
                        ]
                        this.defaultColumnFields = this.defaultColumnFields.map(field => {
                            if ((field.name === 'stock_no' || field.name === 'ref_code' || field.name === 'goods_issue_quantity') && field.value === true) {
                                return { ...field, value: false };
                            }
                            return field;
                        });
                        this.moveColumnNextToFrozen(this.tabulator, "barcode", "brand_id", true);
                        this.moveColumnNextToFrozen(this.tabulator, "alternate_barcode", "barcode", true);
                        this.tabulator.moveColumn("vendor_item_no", "discount_text", true);
                        this.tabulator.moveColumn("remarks", "discount_text", true);
                        this.tabulator.moveColumn("net_amount", "discount_text", true);
                        this.filteredColumnFields = this.defaultColumnFields
                        this.header = DistributionDocuments.headerRelCsi

                        this.header.showCompanyDetails = true
                        this.renderColumnFields()
                        component_x.isOrderSourceDisabled = false
                        var sales_order_id = this.$route.params.sales_order_id
                        if (component_x.documentNumber < 1 && sales_order_id > -1) {
                                var document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+sales_order_id, null);
                                var document_charges = []
                                document_charges = await HTTPRequest.getRequest(component_x.endPoint + "document_charges/"+sales_order_id+"?field_name=document_id", null);
                                if(document_charges) component_x.chargeData = document_charges
                                component_x.documentDetails = document
                        
                            if (document["discount_text"]!="") {
                                if (document['discount_text'] != null) component_x.headerDiscount = document["discount_text"].split(',')
                            }

                            if (document["order_source"]!="") {
                                if (document['order_source'] != null) component_x.orderSource = document["order_source"]
                            }

                            if (document["payment_status"] == "Paid") {
                                this.forPaymentIsProcessed = true
                            }

                            //Populate Document Level Input
                            component_x.distributionSite = document['site_id']
                            component_x.destinationSublocation = document['target_sublocation_id']
                            component_x.documentDate = moment(document["document_date"])
                            component_x.targetDate = moment(document["target_date"])
                            component_x.cancellationDate = moment(document["cancellation_date"])
                            component_x.party_tax_type = document['party_tax_type']
                            component_x.reference = document["reference"]
                            component_x.salesOrder = document["document_no"]
                            component_x.customer = document["customer_id"];
                            component_x.b2bCustomer = document["b2b_customer_id"];
                            if (document["shipping_method_id"]["key"] > 0) component_x.shippingMethod = document["shipping_method_id"];

                            component_x.remark = document["remark"];
                            component_x.imageReferenceLink = document["image_ref_link"];
                            component_x.orderType  = document["order_type"];
                            component_x.countryOfOrigin  = document["country_id"]
                            component_x.fiscalYear  = document["fiscal_year"];
                            component_x.yearSeason = document["year_season"];
                            component_x.noOfCartons  = document["no_of_cartons"];
                            component_x.ocReferenceNo  = document["oc_ref_no"];
                            component_x.shipmentReferenceNo  = document["shipment_ref_no"];
                            component_x.companyOwnerName  = document["company_id"]["label"];

                            if (component_x.customer){
                                var customer = await HTTPRequest.getRequest(component_x.endPoint + "customers/"+component_x.customer.key, null);
                                this.customerAddress = (customer["address"]) ? customer["address"] : "No Customer Address";
                                this.customerContactMobile = (customer["mobile"]) ? decrypt(customer["mobile"]) : "No Customer Mobile";
                                this.customerContactTelephone = (customer["telephone"]) ? decrypt(customer["telephone"]) : "No Customer Telephone";
                                this.customerContactFax = (customer["fax"]) ? customer["fax"] : "No Customer Fax";
                                this.customerContactEmail = (customer["email"]) ? decrypt(customer["email"]) : "No Customer Email";
                                this.selectedCustomerContact = (customer["mobile"]) ? 'Mobile' : (customer["telephone"]) ? 'Telephone' : (customer["fax"]) ? 'Fax' : (customer["email"]) ? 'Email' : 'Telephone'
                                this.activeCustomerContact = (customer["mobile"]) ? decrypt(this.customerContactMobile) : (customer["telephone"]) ? decrypt(this.customerContactTelephone) : (customer["fax"]) ? this.customerContactFax : (customer["email"]) ? decrypt(this.customerContactEmail) : decrypt(this.customerContactTelephone)
                            }

                            if(document["address"]){
                                component_x.customerAddress = document["address"]
                            }

                            //Load document lines
                            window.scrollTo(0,0);
                            let document_lines = []
                            if (sales_order_id > -1){
                                document_lines = await HTTPRequest.getRequest(this.endPoint+'document_lines/'+sales_order_id+'?field_name=document_id&origin_sublocation=0', null)
                            }
                            document_lines.forEach( row => {
                                row.quantity = 0
                            });
                            if(document_lines) await this.tabulator.addData(document_lines, true);
                            this.tabulator.addFilter("line_no", ">", 0);
                            if(document_lines) component_x.origData = JSON.stringify(document_lines.reverse()) //For isDirty Data on Document lines
                            
                        } else {
                            component_x.isOriginSublocationDisabled = true
                        }
                        break;
                    case 'OTHSIN':
                        component_x.showHeaderDiscount = true
                        component_x.createChildDocButtonLabel = ""
                        component_x.showCreateChildDocButton = false
                        var orisox_doc_config = await HTTPRequest.getRequest(component_x.endPoint+'/document_types/get_document_type_settings?type_code=SOX&trans_code=ORI', null)
                        //Set Order Source
                        if (orisox_doc_config && orisox_doc_config.document_type_settings.orderSource){
                            this.isOrderSourceMode = orisox_doc_config.document_type_settings.orderSource.enableOrderSourceMode
                        }
                        var othsin_doc_config = await HTTPRequest.getRequest(component_x.endPoint+'/document_types/get_document_type_settings?type_code=SIN&trans_code=OTH', null)
                        if (othsin_doc_config && othsin_doc_config.document_type_settings.references){
                            this.referenceLabel = othsin_doc_config.document_type_settings.references[0].name || "Reference"
                        }
                        if (this.isOrderSourceMode){
                            this.header.showSublocationDestination = false
                            this.header.showSublocationOrigin = false
                            this.header.showOrderSource = true
                        } else {
                            this.header.showSublocationDestination = true
                            this.header.showSublocationOrigin = true
                            this.header.showOrderSource = false
                        }
                        
                        this.showDocumentBodyHeader = true
                        this.showShippingMethod = true
                        if (this.accountName.toLowerCase().includes('primerph')) {

                            this.defaultColumnFields = [
                            { name: "line_no", value: true },
                            { name: "product_icon", value: true },
                            { name: "stock_no", value: false },
                            { name: "barcode", value: true },
                            { name: "product_name", value: true },
                            { name: "brand_name", value: true },
                            { name: "unit_id", value: true },
                            { name: "quantity", value: true },
                            { name: "price", value: true },
                            { name: "total_gross", value: true },
                            { name: "ordered_quantity", value: false },
                            { name: "discount_text", value: true },
                            { name: "discount_total_amount", value: true },
                            { name: "discount", value: false },
                            { name: "goods_issue_quantity", value: false },
                            { name: "remarks", value: false },
                            { name: "vendor_item_no", value: false },
                            { name: "ref_code", value: false },
                            { name: "available_quantity", value: false },
                            { name: "on_hand_quantity", value: false },
                            { name: "actual_quantity", value: false },
                            { name: "net_amount", value: true },
                            { name: "invoice_total", value: false },
                            { name: "ordering_cost", value: false },
                            { name: "margin", value: false },
                            { name: "trade_commission_rate", value: true },
                            { name: "trade_discount", value: true },
                            { name: "net_receivable", value: true },
                            { name: "subtotal", value: false },
                        ]

                        this.moveColumnNextToFrozen(this.tabulator, "brand_id", "barcode", false);
                        this.tabulator.moveColumn("product_name", "barcode", true); 
                        this.tabulator.moveColumn("net_amount", "total_gross", true);
                        this.tabulator.moveColumn("net_amount", "discount_total_amount", true);
                        this.moveColumnNextToFrozen(this.tabulator, "product_name", "barcode", false);
                        this.tabulator.getColumn('total_gross').updateDefinition({ title: "Subtotal" })
                        this.moveColumnNextToFrozen(this.tabulator, "barcode", "product_icon", true);
                        } else {
                            this.defaultColumnFields = [
                                { name: "line_no", value: true },
                                { name: "product_icon", value: true },
                                { name: "brand_id", value: true },
                                { name: "barcode", value: true },
                                { name: "vendor_item_no", value: true },
                                { name: "style_name", value: true }, 
                                { name: "size", value: true },
                                { name: "color", value: true },
                                { name: "alternate_barcode", value: false },
                                { name: "unit_id", value: true },
                                { name: "quantity", value: true },
                                { name: "actual_quantity", value: true },
                                { name: "price", value: true },
                                { name: "currency", value: true },
                                { name: "total_gross", value: true },
                                { name: "discount", value: true },
                                { name: "discount_text", value: true },
                                { name: "net_amount", value: true },
                                { name: "ordering_cost", value: true },
                                { name: "pur_currency", value: true },
                                { name: "total_ordering_cost", value: true },
                                { name: "barcode_upc", value: true },
                                { name: "barcode_ean", value: true },
                                { name: "factory_name", value: true },
                                { name: "product_name", value: true },
                            ]
                        }

                        if (this.accountName.toLowerCase().includes('piml')) {
                            this.tabulator.moveColumn("net_amount", "discount", true);
                            this.tabulator.moveColumn("product_name", "factory_name", true);
                            this.moveColumnNextToFrozen(this.tabulator, "barcode", "brand_id", true);
                            this.moveColumnNextToFrozen(this.tabulator, "vendor_item_no", "barcode", true);
                            //this.tabulator.moveColumn("subtotal", "currency", true);
                            this.tabulator.moveColumn("total_gross", "currency", true);
                            this.tabulator.getColumn('product_name').updateDefinition({ frozen: false })
                            this.tabulator.moveColumn("ordering_cost", "net_amount", true);
                            this.tabulator.moveColumn("discount_text", "net_amount", false);
                        }
                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.header = DistributionDocuments.headerOthSin
                        this.header.showBrand = true
                        this.header.showCompanyDetails = true
                        this.renderColumnFields()

                        component_x.isCustomerDisabled = true
                        component_x.isCustomerCreateDisabled = true
                        component_x.isOrderSourceDisabled = true
                        component_x.isOrderTypeDisabled = true
                        component_x.isCountryOfOriginDisabled = true
                        component_x.isFiscalYearDisabled = true
                        component_x.isYearSeasonDisabled = true
                        component_x.isNoOfCartonsDisabled = true
                        component_x.isProvinceDisabled = true
                        component_x.isCityDisabled = true
                        component_x.isBarangayDisabled = true
                        component_x.isZipCodeDisabled = true
                        component_x.isDeliveryDocumentDisabled = true
                        component_x.isDocumentDateDisabled = true
                        component_x.isOriginSublocationDisabled = true
                        component_x.isDestinationSublocationDisabled = true
                        component_x.isDistributionSiteDisabled = true
                        component_x.isTargetDateDisabled = true
                        component_x.isCancellationDateDisabled = true
                        component_x.isShippingMethodDisabled = true
                        component_x.isPurposeDisabled = true
                        component_x.sublocationDestinationLabel = 'SO Sublocation'
                        component_x.sublocationOriginLabel = 'Serving Sublocation'

                        if (this.accountName.toLowerCase().includes('piml')) {
                            this.isPaymentTermDisabled = true;
                        }
                        
                        if (component_x.documentNumber < 1) {
                            var delivery_document_id = this.$route.params.delivery_document_id || component_x.originDocumentNumber
                            var document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+delivery_document_id, null);
                            //Populate Document Level Input
                            component_x.distributionSite = document['site_id']
                            component_x.destinationSublocation = document['target_sublocation_id']
                            component_x.originSublocation = document['origin_sublocation_id']
                            component_x.documentDate = moment(new Date())
                            component_x.targetDate = moment(document["target_date"])
                            component_x.party_tax_type = document['party_tax_type']
                            component_x.cancellationDate = moment(document["cancellation_date"])
                            component_x.salesOrder = document['origin_document_id']['label']
                            //component_x.deliveryDocument = delivery_document_id
                            component_x.deliveryDocument = document['code_and_document_no']
                            component_x.customer = document["customer_id"];
                            component_x.b2bCustomer = document["b2b_customer_id"];
                            component_x.reference = document["reference_1"]
                            component_x.reference1 = document["reference_2"]
                            component_x.brand = document["brand_filter"];
                            component_x.productPriceChoice = document['price_type'] || component_x.productPriceChoice
                            if (document["shipping_method_id"]["key"] > 0) component_x.shippingMethod = document["shipping_method_id"];
                            component_x.remark = document["remark"];
                            component_x.imageReferenceLink = document["image_ref_link"];
                            component_x.orderType  = document["order_type"];
                            component_x.countryOfOrigin  = document["country_id"]
                            component_x.fiscalYear  = document["fiscal_year"];
                            component_x.yearSeason = document["year_season"];
                            component_x.noOfCartons  = document["no_of_cartons"];
                            component_x.ocReferenceNo  = document["oc_ref_no"];
                            component_x.shipmentReferenceNo  = document["shipment_ref_no"];
                            component_x.isHeaderOnly = document['is_header_only']
                            component_x.companyOwnerName  = document["company_id"]["label"];
                            component_x.salesman = {key: document["salesman_id"], label: document["salesman_name"]};
                            var customerData = {};
                            if (document["customer_id"] || document["b2b_customer_id"]) {
                                if (document["customer_type"] === "customer") {
                                    customerData = await HTTPRequest.getRequest(component_x.endPoint + "customers/" + document["customer_id"]["key"], null);
                                } else if (document["customer_type"] === "b2b") {
                                    customerData = await HTTPRequest.getRequest(component_x.endPoint + "b2b_customers/" + document["b2b_customer_id"], null);
                                    if(component_x.b2bCustomerOptions.length <= 0){
                                        component_x.b2bCustomerOptions = [{id:customerData.id, name:decrypt(customerData.name)}]
                                    }
                                }
                            }
                            if (customerData) {
                                component_x.province = customerData.province_name;
                                component_x.address = customerData.address;
                                component_x.city = customerData.city_name;
                                component_x.barangay = customerData.barangay_name;
                                component_x.zipCode = customerData.zip_code;
                            }

                            // trigger function to fetch and process customer details considering customer type
                            await this.fetchAndProcessCustomerDetails();

                            if (document['support_discount_text']) component_x.supportDiscount = document['support_discount_text'].split(',')
                            if (document["discount_text"]!="") {
                                if (document['discount_text'] != null) component_x.headerDiscount = document["discount_text"].split(',')
                            }

                            if (document["order_source"]!="") {
                                if (document['order_source'] != null) component_x.orderSource = document["order_source"]
                            }
                            
                            if(document['origin_document_id']['key'] !== undefined){
                                var orisox_document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+document['origin_document_id']['key'], null);
                                if (orisox_document["error"] == undefined && orisox_document["payment_status"] == "Paid") {
                                    this.forPaymentIsProcessed = true
                                }
                            }

                            //Load document lines
                            window.scrollTo(0,0);
                            let document_lines = []
                            document_lines = await HTTPRequest.getRequest(this.endPoint+'document_lines/'+delivery_document_id+'?field_name=document_id', null)
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                document_lines.forEach( row => {
                                    if (component_x.accountName.toLowerCase().includes('piml')){
                                        row.quantity = row.quantity - row.actual_quantity
                                    }
                                    row.goods_issue_quantity = row.quantity
                                    if (row.quantity <= 0) {
                                        row.quantity = 0
                                        row.discount_text = null
                                        row.discount = 0
                                    }
                                    row.actual_quantity = 0
                                    //3058 Recalculate lines 
                                    if(this.party_tax_type == "V"){
                                        row.subtotal = ((row.quantity * Number(row.price).toFixed(this.decimalPlaces)) - Number(row.discount)).toFixed(this.decimalPlaces)
                                        row.subtotal_without_vat = (Number(row.subtotal)/ (1+Number(this.taxRate))).toFixed(this.decimalPlaces)
                                        row.price_without_vat = (Number(row.price)/ (1+Number(this.taxRate))).toFixed(this.decimalPlaces)
                                        row.tax_amount = row.subtotal - row.subtotal_without_vat
                                    }else{
                                        row.subtotal = ((row.quantity * Number(row.price).toFixed(this.decimalPlaces)) - Number(row.discount)).toFixed(this.decimalPlaces)
                                        row.subtotal_without_vat = (Number(row.subtotal)).toFixed(this.decimalPlaces)
                                        row.price_without_vat = (Number(row.price)).toFixed(this.decimalPlaces)
                                        row.tax_amount = 0
                                    }  
                                });
                            }

                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                //Remove 0 quantity
                                let data = []
                                document_lines.forEach((object) => {
                                    if(object.quantity > 0){
                                        data.push(object)
                                    }
                                })
                                //await this.tabulator.addData(document_lines, true);
                                await this.tabulator.addData(data, true);
                            }

                            this.tabulator.addFilter("line_no", ">", 0);
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                component_x.origData = JSON.stringify(document_lines.reverse()) //For isDirty Data on Document lines
                            } 
                            

                            //Populate Footer and Calculation Data
                            component_x.grossAmount =  document['amount_gross'].replace(',','')
                            component_x.grossAmountDisplay = document['amount_gross'].replace(',','')
                            component_x.overallDiscount = document['amount_header_discount']
                            component_x.overallDiscountPercentage = document['overall_discount_percentage']
                            component_x.netAmount = document['amount_net'].replace(',','')
                            component_x.netAmountDisplay = document['amount_net'].replace(',','')
                            component_x.vatAmount = document['tax_amount']
                            component_x.totalWithVat = document['tax_exempt_amount']
                            component_x.itemDiscount = document['amount_line_discount']
                            component_x.taxRate = document['tax_rate']
                            component_x.grossAmountwithoutTax = document['gross_amount_without_tax']
                            component_x.netAmountWithoutTax = document['net_amount_without_tax']
                            component_x.party_tax_type = document['party_tax_type']
                            component_x.selectedCustomerType = document["customer_type"]
                            component_x.paymentTerm = document["payment_term_id"]
                            component_x.wTax = {key:document["wtax_code"],label:document["wtax_code"]}
                            
                            this.initializeFooterCalculation()
                            if (component_x.totalQuantity == 0) {
                                component_x.totalQuantity = document['total_quantity']
                            }
                        }
                        break;
                    case 'RECCSR':
                      var orisox_doc_config = await HTTPRequest.getRequest(component_x.endPoint+'/document_types/get_document_type_settings?type_code=SOX&trans_code=ORI', null)

                        //Set Order Source
                        if (orisox_doc_config && orisox_doc_config.document_type_settings.orderSource){
                            this.isOrderSourceMode = orisox_doc_config.document_type_settings.orderSource.enableOrderSourceMode
                        }
                        if (this.isOrderSourceMode){
                            this.header.showSublocationDestination = false
                            this.header.showOrderSource = true
                        } else {
                            this.header.showSublocationDestination = true
                            this.header.showOrderSource = false
                        }

                        //this.showBookingButton = true
                        //this.showDocumentBodyHeader = false
                        //this.productFormMode = "Search"
                        //this.showShippingMethod = true
                        this.moveColumnNextToFrozen(this.tabulator, "brand_id", "product_name", false);
                        this.moveColumnNextToFrozen(this.tabulator,"barcode", "product_icon", true); 
                        this.tabulator.moveColumn("net_amount", "discount_total_amount", true);

                        this.defaultColumnFields = [
                            { name: "line_no", value: true },
                            { name: "product_icon", value: true },
                            { name: "stock_no", value: false },
                            { name: "barcode", value: true },
                            { name: "product_name", value: true },
                            { name: "brand_id", value: true },
                            { name: "unit_id", value: true },
                            { name: "quantity", value: true },
                            { name: "price", value: true },
                            { name: "total_gross", value: true },
                            { name: "discount_text", value: true },
                            { name: "discount_total_amount", value: true },
                            { name: "discount", value: false },
                            { name: "net_amount", value: true },
                            { name: "trade_commission_rate", value: true },
                            { name: "ref_code", value: false },
                            { name: "remarks", value: false },
                            { name: "available_quantity", value: false },
                            { name: "on_hand_quantity", value: false },
                            { name: "actual_quantity", value: false },
                            { name: "quantity", value: true },
                            { name: "trade_discount", value: true },
                            { name: "vendor_item_no", value: false },
                            { name: "net_receivable", value: true },
                        ]

                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.header = DistributionDocuments.headerRecCsr
                        this.header.showSalesOrder = true
                        this.header.showBrand = true
                        this.renderColumnFields()

                        //Disable fields
                        //component_x.isOrderSourceDisabled = true
                        //component_x.isCustomerDisabled = true
                        //component_x.isCustomerCreateDisabled = true
                        //component_x.isDestinationSublocationDisabled = true
                        //component_x.isDistributionSiteDisabled = true
                        //component_x.isDocumentDateDisabled = true
                        component_x.isTargetDateDisabled = true
                        component_x.isCancellationDateDisabled = true
                        component_x.isShippingMethodDisabled = true
                        //component_x.isPurposeDisabled = true
                        component_x.sublocationDestinationLabel = 'SO Sublocation'
                        component_x.remarkLabel = "Remarks (Picker Details, Truck Details, & Other Info)"

                        if (this.accountName.toLowerCase().includes('piml')) {
                            this.isPaymentTermDisabled = true;
                        }

                        component_x.showHeaderDiscount = true
                        component_x.isHeaderDiscountDisabled = true
                        var document_id = this.$route.params.sales_order_id
                        var documentExists = false
                        var openCSR = false
                        if( component_x.documentNumber > 0 ){
                            document_id = component_x.documentNumber
                            documentExists = true
                        } else if( this.$route.params.sales_order_id == undefined && component_x.documentNumber == 0){
                            openCSR = true
                        }

                        if(!openCSR && !documentExists){  
                            var document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+document_id, null);
                            var document_charges = []
                            document_charges = await HTTPRequest.getRequest(component_x.endPoint + "document_charges/"+document_id+"?field_name=document_id", null);
                            if(document_charges) component_x.chargeData = document_charges

                            component_x.documentDetails = document
                            if (document["discount_text"]!="") {
                                if (document['discount_text'] != null) component_x.headerDiscount = document["discount_text"].split(',')
                            }

                            if (document["order_source"]!="") {
                                if (document['order_source'] != null) component_x.orderSource = document["order_source"]
                            }

                            if (document["payment_status"] == "Paid") {
                                this.forPaymentIsProcessed = true
                            }

                            //Populate Document Level Input
                            component_x.distributionSite = document['site_id']
                            component_x.destinationSublocation = document['target_sublocation_id']
                            component_x.documentDate = moment(document["document_date"])
                            component_x.targetDate = moment(document["target_date"])
                            component_x.cancellationDate = moment(document["cancellation_date"])
                            component_x.reference = document["reference"]
                            component_x.salesOrder = document['origin_document_id']['label']
                            //document['origin_document_id']
                            if(documentExists){
                                component_x.deliveryDocument = document['origin_document_id']['label']
                            }else {
                                component_x.deliveryDocument = document["code_and_document_no"]
                                component_x.documentDate = moment()
                                //component_x.targetDate = moment()
                                component_x.targetDate = moment(new Date()).add('1', 'days');
                                component_x.cancellationDate = moment().add(1, 'months').calendar();
                                //component_x.isTargetDateDisabled = false
                            }
                            component_x.customer = document["customer_id"];
                            component_x.b2bCustomer = document["b2b_customer_id"];
                            component_x.brand = document["brand_filter"];
                            if (document["shipping_method_id"]["key"] > 0) component_x.shippingMethod = document["shipping_method_id"];

                            component_x.remark = document["remark"];
                            component_x.imageReferenceLink = document["image_ref_link"];
                            component_x.orderType  = document["order_type"];
                            component_x.countryOfOrigin  = document["country_id"]
                            component_x.fiscalYear  = document["fiscal_year"];
                            component_x.yearSeason = document["year_season"];
                            component_x.noOfCartons  = document["no_of_cartons"];
                            component_x.ocReferenceNo  = document["oc_ref_no"];
                            component_x.shipmentReferenceNo  = document["shipment_ref_no"];
                            component_x.party_tax_type =  document['party_tax_type']
                            component_x.selectedCustomerType = document["customer_type"]
                            component_x.paymentTerm = document["payment_term_id"]
                            component_x.wTax = {key:document["wtax_code"],label:document["wtax_code"]}

                            if (component_x.customer){
                                var customer = await HTTPRequest.getRequest(component_x.endPoint + "b2b_customers/"+component_x.customer.key, null);
                                if(this.b2bCustomerOptions.length <= 0){
                                    this.b2bCustomerOptions = [{id:customer.id, name:decrypt(customer.name)}]
                                }
                                this.customerAddress = (customer["address"]) ? customer["address"] : "No Customer Address";
                                this.customerContactMobile = (customer["mobile"]) ? decrypt(customer["mobile"]) : "No Customer Mobile";
                                this.customerContactTelephone = (customer["telephone"]) ? decrypt(customer["telephone"]) : "No Customer Telephone";
                                this.customerContactFax = (customer["fax"]) ? customer["fax"] : "No Customer Fax";
                                this.customerContactEmail = (customer["email"]) ? decrypt(customer["email"]) : "No Customer Email";
                                this.selectedCustomerContact = (customer["mobile"]) ? 'Mobile' : (customer["telephone"]) ? 'Telephone' : (customer["fax"]) ? 'Fax' : (customer["email"]) ? 'Email' : 'Telephone'
                                this.activeCustomerContact = (customer["mobile"]) ? decrypt(this.customerContactMobile) : (customer["telephone"]) ? decrypt(this.customerContactTelephone) : (customer["fax"]) ? this.customerContactFax : (customer["email"]) ? decrypt(this.customerContactEmail) : decrypt(this.customerContactTelephone)
                            }

                            if(document["address"]){
                                component_x.customerAddress = document["address"]
                            }


                            //Load document lines
                            window.scrollTo(0,0);
                            let document_lines = []
                            var origin_doc_id = documentExists ? document['origin_document_id']['key'] : document_id
                            // if(origin_doc_id == null || origin_doc_id == ''){
                            //     openCSR = true
                            // }
                            // if(!openCSR) 
                            var returnable_qtys = await HTTPRequest.getRequest(component_x.endPoint + '/documents/' + origin_doc_id + '/available_return_quantity', null)
                            document_lines = await HTTPRequest.getRequest(this.endPoint+'document_lines/'+document_id+'?field_name=document_id', null)
                            component_x.returnable_qtys = returnable_qtys
                            
                            if(document_lines != undefined && document_lines != null && document_lines != [] && !(['LIQUIDATION', 'BARTER TOOL'].includes(document['order_source']))){
                                document_lines.forEach( row => {
                                    // if creating CSR, then reset the quantities
                                    if(!documentExists){
                                        var returnable_line = returnable_qtys.data.find(line => line.product_id == row.product_id)
                                        row.goods_issue_quantity = returnable_line == undefined ? 0 : (returnable_line.returnable_qty)
                                        row.quantity = row.goods_issue_quantity
                                        row.delivery_quantity = row.goods_issue_quantity
                                    }
                                });
                            }
                            // if(documentExists) 
                            await this.tabulator.addData(document_lines, true);
                            this.tabulator.addFilter("line_no", ">", 0);
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                component_x.origData = JSON.stringify(document_lines.reverse())
                            } 
                            // !openCSR && 
                            if(((!documentExists) || ( documentExists && !(['Posted', 'Voided'].includes(document["status"])) ))) this.tabulator.toggleColumn("goods_issue_quantity")
                            this.header.showBrand = true
                            //Populate Footer and Calculation Data
                            component_x.grossAmount =  document['amount_gross'].replace(',','')
                            component_x.grossAmountDisplay = document['amount_gross'].replace(',','')
                            component_x.overallDiscount = document['amount_header_discount']
                            component_x.overallDiscountPercentage = document['overall_discount_percentage']
                            component_x.netAmount = document['amount_net'].replace(',','')
                            component_x.itemDiscount = document['amount_line_discount']
                            component_x.selectedCustomerType = document["customer_type"]
                            component_x.netAmountDisplay = document['amount_net'].replace(',','')
                            component_x.vatAmount = document['tax_amount']
                            component_x.totalWithVat = document['tax_exempt_amount']
                            component_x.taxRate = document['tax_rate']
                            component_x.grossAmountwithoutTax = document['gross_amount_without_tax']
                            component_x.netAmountWithoutTax = document['net_amount_without_tax']
                            this.initializeFooterCalculation()
                            await this.getB2bCustomerOptions(document["b2b_customer_id"]);
                        }
                        component_x.openCSR = openCSR
                        break;                 
                    case 'ORIOCR':
                      var orisox_doc_config = await HTTPRequest.getRequest(component_x.endPoint+'/document_types/get_document_type_settings?type_code=OSO&trans_code=ORI', null)
                        //Set Order Source
                        if (orisox_doc_config && orisox_doc_config.document_type_settings.orderSource){
                            this.isOrderSourceMode = orisox_doc_config.document_type_settings.orderSource.enableOrderSourceMode
                        }
                        if (this.isOrderSourceMode){
                            this.header.showSublocationDestination = false
                            this.header.showOrderSource = true
                        } else {
                            this.header.showSublocationDestination = true
                            this.header.showOrderSource = false
                        }
                        this.tabulator.getColumn('product_name').updateDefinition({ title: "Item Description" })
                        this.tabulator.getColumn('price').updateDefinition({ title: "Original Price" })
                        this.tabulator.getColumn('quantity').updateDefinition({ title: "Order Quantity" })
                        this.tabulator.getColumn('discount').updateDefinition({ title: "Discount" })
                    
                        this.renameLineNo()
                        this.moveColumnNextToFrozen(this.tabulator, "barcode", "product_icon", true);
                        this.tabulator.moveColumn("net_amount", "discount_text", true);
                        this.moveColumnNextToFrozen(this.tabulator, "brand_id", "net_amount", false);

                        this.defaultColumnFields = [
                            { name: "line_no", value: true },
                            { name: "product_icon", value: true },
                            { name: "stock_no", value: false },
                            { name: "barcode", value: true },
                            { name: "product_name", value: true },
                            { name: "unit_id", value: false },
                            { name: "quantity", value: true },
                            { name: "price", value: true },
                            { name: "discount", value: true },
                            { name: "discount_text", value: true },
                            { name: "net_amount", value: true },
                            { name: "brand_id", value: true },
                        ]

                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.header = DistributionDocuments.headerRecCsr
                        this.header.showCustomerType = true
                        this.header.showCustomer = false
                        this.renderColumnFields()

                        //Disable fields
                        component_x.selectedCustomerType = 'customer'
                        component_x.isTargetDateDisabled = true
                        component_x.isCancellationDateDisabled = true
                        component_x.isShippingMethodDisabled = true
                        component_x.sublocationDestinationLabel = 'SO Sublocation'
                        component_x.remarkLabel = "Remarks (Picker Details, Truck Details, & Other Info)"

                        component_x.isHeaderDiscountDisabled = true
                        var document_id = this.$route.params.sales_order_id
                        var documentExists = false
                        var openOCR = false
                        if( component_x.documentNumber > 0 ){
                            document_id = component_x.documentNumber
                            documentExists = true
                        } else if( this.$route.params.sales_order_id == undefined && component_x.documentNumber == 0){
                            openOCR = true
                        }
                        if(!openOCR){
                            var document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+document_id, null);

                            var document_charges = []
                            document_charges = await HTTPRequest.getRequest(component_x.endPoint + "document_charges/"+document_id+"?field_name=document_id", null);
                            if(document_charges) component_x.chargeData = document_charges

                            component_x.documentDetails = document
                            if (document["discount_text"]!="") {
                                if (document['discount_text'] != null) component_x.headerDiscount = document["discount_text"].split(',')
                            }

                            if (document["order_source"]!="") {
                                if (document['order_source'] != null) component_x.orderSource = document["order_source"]
                            }

                            if (document["payment_status"] == "Paid") {
                                this.forPaymentIsProcessed = true
                            }

                            //Populate Document Level Input
                            component_x.distributionSite = document['site_id']
                            component_x.destinationSublocation = document['target_sublocation_id']
                            component_x.documentDate = moment(document["document_date"])
                            component_x.targetDate = moment(document["target_date"])
                            component_x.cancellationDate = moment(document["cancellation_date"])
                            component_x.party_tax_type = document['party_tax_type']
                            component_x.reference = document["reference"]
                            component_x.brand = document["brand_filter"]
                            component_x.b2bCustomer = document["b2b_customer_id"];

                            if(documentExists){
                                component_x.deliveryDocument = document['origin_document_id']['label']
                            }else {
                                component_x.deliveryDocument = document["code_and_document_no"]
                                component_x.documentDate = moment()
                                component_x.targetDate = moment()
                                component_x.cancellationDate = moment().add(1, 'months').calendar();
                            }
                            // initialize selectedCustomerType based on the customer_type value from the document
                            // if (document["customer_type"]) {
                            //     this.selectedCustomerType = document["customer_type"];
                            // }

                            var customerData = {};
                            if (document["customer_id"] || document["b2b_customer_id"]) {
                                if (document["customer_type"] === "customer") {
                                    customerData = await HTTPRequest.getRequest(component_x.endPoint + "customers/" + document["customer_id"]["key"], null);
                                } else if (document["customer_type"] === "b2b") {
                                    const customerData = await HTTPRequest.getRequest(component_x.endPoint + "b2b_customers/id=" + document["b2b_customer_id"], null);
                                }
                            }
                            if (document["shipping_method_id"]["key"] > 0) component_x.shippingMethod = document["shipping_method_id"];

                            component_x.remark = document["remark"];
                            component_x.imageReferenceLink = document["image_ref_link"];
                            component_x.orderType  = document["order_type"];
                            component_x.countryOfOrigin  = document["country_id"]
                            component_x.fiscalYear  = document["fiscal_year"];
                            component_x.yearSeason = document["year_season"];
                            component_x.noOfCartons  = document["no_of_cartons"];
                            component_x.ocReferenceNo  = document["oc_ref_no"];
                            component_x.shipmentReferenceNo  = document["shipment_ref_no"];

                            if (component_x.customer){
                                var customer = await HTTPRequest.getRequest(component_x.endPoint + "customers/"+component_x.customer.key, null);
                                this.customerAddress = (customer["address"]) ? customer["address"] : "No Customer Address";
                                this.customerContactMobile = (customer["mobile"]) ? decrypt(customer["mobile"]) : "No Customer Mobile";
                                this.customerContactTelephone = (customer["telephone"]) ? decrypt(customer["telephone"]) : "No Customer Telephone";
                                this.customerContactFax = (customer["fax"]) ? customer["fax"] : "No Customer Fax";
                                this.customerContactEmail = (customer["email"]) ? decrypt(customer["email"]) : "No Customer Email";
                                this.selectedCustomerContact = (customer["mobile"]) ? 'Mobile' : (customer["telephone"]) ? 'Telephone' : (customer["fax"]) ? 'Fax' : (customer["email"]) ? 'Email' : 'Telephone'
                                this.activeCustomerContact = (customer["mobile"]) ? decrypt(this.customerContactMobile) : (customer["telephone"]) ? decrypt(this.customerContactTelephone) : (customer["fax"]) ? this.customerContactFax : (customer["email"]) ? decrypt(this.customerContactEmail) : decrypt(this.customerContactTelephone)
                            }

                            if(document["address"]){
                                component_x.customerAddress = document["address"]
                            }


                            //Load document lines
                            window.scrollTo(0,0);
                            let document_lines = []
                            var origin_doc_id = documentExists ? document['origin_document_id']['key'] : document_id
                            if(origin_doc_id == null || origin_doc_id == ''){
                                openOCR = true
                            }
                            if(!openOCR) var returnable_qtys = await HTTPRequest.getRequest(component_x.endPoint + '/documents/' + origin_doc_id + '/available_return_quantity', null)
                            document_lines = await HTTPRequest.getRequest(this.endPoint+'document_lines/'+document_id+'?field_name=document_id', null)
                            component_x.returnable_qtys = returnable_qtys
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                document_lines.forEach( row => {
                                    // if creating openOCR, then reset the quantities
                                    if(!documentExists){
                                        row.quantity = 0
                                    }
                                    // check max qty per product that can be returned, actual quantity is available quantity
                                    if(!openOCR){
                                        var returnable_line = returnable_qtys.data.find(line => line.product_id == row.product_id)
                                        row.goods_issue_quantity
                                        row.goods_issue_quantity = returnable_line == undefined ? 0 : (returnable_line.returnable_qty)
                                        row.delivery_quantity = row.goods_issue_quantity
                                    }
                                });
                            }
                            if(documentExists) await this.tabulator.addData(document_lines, true);
                            this.tabulator.addFilter("line_no", ">", 0);
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                component_x.origData = JSON.stringify(document_lines.reverse())
                            } 
                            if( !openOCR && ((!documentExists) || ( documentExists && !(['Posted', 'Voided'].includes(document["status"])) ))) this.tabulator.toggleColumn("goods_issue_quantity")
                        }
                        component_x.openOCR = openOCR
                        this.selectedCustomerType = "b2b"
                        
                        break;
                    case 'RECCSI':
                      var orisox_doc_config = await HTTPRequest.getRequest(component_x.endPoint+'/document_types/get_document_type_settings?type_code=OSO&trans_code=ORI', null)
                        //Set Order Source
                        if (orisox_doc_config && orisox_doc_config.document_type_settings.orderSource){
                            this.isOrderSourceMode = orisox_doc_config.document_type_settings.orderSource.enableOrderSourceMode
                        }
                        if (this.isOrderSourceMode){
                            this.header.showSublocationDestination = false
                            this.header.showOrderSource = true
                        } else {
                            this.header.showSublocationDestination = true
                            this.header.showOrderSource = false
                        }

                        this.defaultColumnFields = [
                            { name: "line_no", value: true },
                            { name: "product_icon", value: true },
                            { name: "stock_no", value: true },
                            { name: "barcode", value: true },
                            { name: "product_name", value: true },
                            { name: "unit_id", value: true },
                            { name: "quantity", value: true },
                            { name: "price", value: true },
                            { name: "subtotal", value: false },
                            { name: "gross_amount", value: true },
                            { name: "discount_text", value: true },
                            { name: "discount", value: true },
                            { name: "ref_code", value: true },
                            { name: "remarks", value: true },
                            { name: "available_quantity", value: false },
                            { name: "on_hand_quantity", value: true },
                            { name: "actual_quantity", value: true },
                            { name: "quantity", value: true },
                        ]

                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.header = DistributionDocuments.headerRecCsr
                        this.renderColumnFields()

                        //Disable fields
                        component_x.isTargetDateDisabled = true
                        component_x.isCancellationDateDisabled = true
                        component_x.isShippingMethodDisabled = true
                        component_x.sublocationDestinationLabel = 'SO Sublocation'
                        component_x.remarkLabel = "Remarks (Picker Details, Truck Details, & Other Info)"

                        component_x.isHeaderDiscountDisabled = true
                        var document_id = this.$route.params.concession_return_order_id
                        var documentExists = false
                        var openOCR = false
                        if( component_x.documentNumber > 0 ){
                            document_id = component_x.documentNumber
                            documentExists = true
                        } else if( this.$route.params.concession_return_order_id == undefined && component_x.documentNumber == 0){
                            openOCR = true
                        }
                        if(!openOCR && !documentExists){
                            var document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+document_id, null);

                            // var document_charges = []
                            // document_charges = await HTTPRequest.getRequest(component_x.endPoint + "document_charges/"+document_id+"?field_name=document_id", null);
                            // if(document_charges) component_x.chargeData = document_charges

                            component_x.documentDetails = document
                            if (document["discount_text"]!="") {
                                if (document['discount_text'] != null) component_x.headerDiscount = document["discount_text"].split(',')
                            }

                            if (document["order_source"]!="") {
                                if (document['order_source'] != null) component_x.orderSource = document["order_source"]
                            }

                            if (document["payment_status"] == "Paid") {
                                this.forPaymentIsProcessed = true
                            }

                            //Populate Document Level Input
                            component_x.distributionSite = document['site_id']
                            component_x.destinationSublocation = document['target_sublocation_id']
                            component_x.documentDate = moment(document["document_date"])
                            component_x.targetDate = moment(document["target_date"])
                            component_x.cancellationDate = moment(document["cancellation_date"])
                            component_x.party_tax_type = document['party_tax_type']
                            component_x.reference = document["reference"]

                            if(documentExists){
                                component_x.deliveryDocument = document['origin_document_id']['label']
                            }else {
                                component_x.deliveryDocument = document["code_and_document_no"]
                                component_x.documentDate = moment()
                                component_x.targetDate = moment()
                                component_x.cancellationDate = moment().add(1, 'months').calendar();
                            }
                            component_x.customer = document["customer_id"];
                            if (document["shipping_method_id"]["key"] > 0) component_x.shippingMethod = document["shipping_method_id"];

                            component_x.remark = document["remark"];
                            component_x.imageReferenceLink = document["image_ref_link"];
                            component_x.orderType  = document["order_type"];
                            component_x.countryOfOrigin  = document["country_id"]
                            component_x.fiscalYear  = document["fiscal_year"];
                            component_x.yearSeason = document["year_season"];
                            component_x.noOfCartons  = document["no_of_cartons"];
                            component_x.ocReferenceNo  = document["oc_ref_no"];
                            component_x.shipmentReferenceNo  = document["shipment_ref_no"];
                            component_x.party_tax_type =  document['party_tax_type']
                            component_x.selectedCustomerType = document["customer_type"]
                            component_x.paymentTerm = document["payment_term_id"]
                            component_x.wTax = {key:document["wtax_code"],label:document["wtax_code"]}

                            if (component_x.customer){
                                var customer = await HTTPRequest.getRequest(component_x.endPoint + "customers/"+component_x.customer.key, null);
                                this.customerAddress = (customer["address"]) ? customer["address"] : "No Customer Address";
                                this.customerContactMobile = (customer["mobile"]) ? decrypt(customer["mobile"]) : "No Customer Mobile";
                                this.customerContactTelephone = (customer["telephone"]) ? decrypt(customer["telephone"]) : "No Customer Telephone";
                                this.customerContactFax = (customer["fax"]) ? customer["fax"] : "No Customer Fax";
                                this.customerContactEmail = (customer["email"]) ? decrypt(customer["email"]) : "No Customer Email";
                                this.selectedCustomerContact = (customer["mobile"]) ? 'Mobile' : (customer["telephone"]) ? 'Telephone' : (customer["fax"]) ? 'Fax' : (customer["email"]) ? 'Email' : 'Telephone'
                                this.activeCustomerContact = (customer["mobile"]) ? decrypt(this.customerContactMobile) : (customer["telephone"]) ? decrypt(this.customerContactTelephone) : (customer["fax"]) ? this.customerContactFax : (customer["email"]) ? decrypt(this.customerContactEmail) : decrypt(this.customerContactTelephone)
                            }

                            if(document["address"]){
                                component_x.customerAddress = document["address"]
                            }


                            //Load document lines
                            window.scrollTo(0,0);
                            let document_lines = []
                            var origin_doc_id = documentExists ? document['origin_document_id']['key'] : document_id
                            // if(origin_doc_id == null || origin_doc_id == ''){
                            //     openOCR = true
                            // }
                            //if(!openOCR) 
                            var returnable_qtys = await HTTPRequest.getRequest(component_x.endPoint + '/documents/' + origin_doc_id + '/available_return_quantity', null)
                            document_lines = await HTTPRequest.getRequest(this.endPoint+'document_lines/'+document_id+'?field_name=document_id', null)
                            component_x.returnable_qtys = returnable_qtys
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                document_lines.forEach( row => {
                                    // if creating openOCR, then reset the quantities
                                    if(!documentExists){
                                        row.quantity = 0
                                    }
                                    // check max qty per product that can be returned, actual quantity is available quantity
                                    if(!openOCR){
                                        var returnable_line = returnable_qtys.data.find(line => line.product_id == row.product_id)
                                        row.goods_issue_quantity = returnable_line == undefined ? 0 : (returnable_line.returnable_qty)
                                        row.delivery_quantity = row.goods_issue_quantity
                                    }
                                });
                            }
                            
                            await this.tabulator.addData(document_lines, true);
                            this.tabulator.addFilter("line_no", ">", 0);
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                component_x.origData = JSON.stringify(document_lines.reverse())
                            } 
                            // if( !openOCR && ((!documentExists) || ( documentExists && !(['Posted', 'Voided'].includes(document["status"])) ))) this.tabulator.toggleColumn("goods_issue_quantity")
                            if(((!documentExists) || ( documentExists && !(['Posted', 'Voided'].includes(document["status"])) ))) this.tabulator.toggleColumn("goods_issue_quantity")
                        }
                        component_x.openOCR = openOCR
                        
                        break;
                    case 'ORORSO':
                      var ororso_doc_config = await HTTPRequest.getRequest(component_x.endPoint+'/document_types/get_document_type_settings?type_code=RSO&trans_code=ORO', null)
                        if (ororso_doc_config && ororso_doc_config.document_type_settings.editorBehavior){
                            this.revenueCreditingMode = ororso_doc_config.document_type_settings.editorBehavior.revenueCreditingMode
                        }
                        if (this.revenueCreditingMode == 'R'){
                            this.requestingSite = {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")}
                            this.revenue = 'R'
                            this.revenueSiteId = secureStorage.getItem("defaultSiteId").toString()
                            this.header.showRevenue = false
                        }else if(this.revenueCreditingMode == 'T'){
                            this.revenue = 'T'
                            this.header.showRevenue = false
                        }else if (this.revenueCreditingMode == 'M'){
                            this.header.showRevenue = true
                        }
                        this.showShippingMethod = true
                        this.RequestingLabel = "Target"

                        this.defaultColumnFields = [
                          { name: "line_no", value: true },
                          { name: "product_icon", value: true },
                          { name: "stock_no", value: true },
                          { name: "barcode", value: true },
                          { name: "product_name", value: true },
                          { name: "unit_id", value: true },
                          { name: "requested_quantity", value: true },
                          { name: "ordered_quantity", value: true},
                          { name: "price", value: true },
                          { name: "subtotal", value: true },
                          { name: "discount_text", value: true },
                          { name: "discount", value: true },
                          { name: "actual_quantity", value: false },
                          { name: "quantity", value: false },
                          { name: "remarks", value: true },
                          { name: "available_quantity", value: false },
                        ]
                      
                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.header = DistributionDocuments.headerOroRso
                        this.renderColumnFields()

                        //Disable fields
                        component_x.showDocumentBodyHeader = false
                        component_x.isTargetDateDisabled = true
                        component_x.isCancellationDateDisabled = true
                        component_x.isShippingMethodDisabled = true
                        //component_x.isPurposeDisabled = true
                        component_x.remarkLabel = "Remarks (Picker Details, Truck Details, & Other Info)"
                        component_x.showHeaderDiscount = true
                        component_x.isHeaderDiscountDisabled = true
                        if (component_x.documentNumber < 1) {
                            var sales_order_id = this.$route.params.sales_order_id
                            var document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+sales_order_id, null);

                            var document_charges = []
                            document_charges = await HTTPRequest.getRequest(component_x.endPoint + "document_charges/"+sales_order_id+"?field_name=document_id", null);
                            if(document_charges) component_x.chargeData = document_charges

                            component_x.documentDetails = document
                            if (document["discount_text"]!="") {
                                if (document['discount_text'] != null) component_x.headerDiscount = document["discount_text"].split(',')
                            }

                            if (document["payment_status"] == "Paid") {
                                this.forPaymentIsProcessed = true
                            }

                            //Populate Document Level Input
                            component_x.distributionSite = document['site_id']
                            component_x.destinationSublocation = document['target_sublocation_id']
                            component_x.documentDate = moment(document["document_date"])
                            component_x.targetDate = moment(document["target_date"])
                            component_x.cancellationDate = moment(document["cancellation_date"])
                            component_x.party_tax_type = document['party_tax_type']
                            component_x.reference = document["reference"]
                            component_x.siteSublocation = document["sublocation_id"]
                            component_x.salesOrder = sales_order_id
                            component_x.customer = document["customer_id"];
                            component_x.b2bCustomer = document["b2b_customer_id"];
                            if (document["shipping_method_id"]["key"] > 0) component_x.shippingMethod = document["shipping_method_id"];

                            component_x.remark = document["remark"];
                            component_x.imageReferenceLink = document["image_ref_link"];
                            component_x.orderType  = document["order_type"];
                            component_x.countryOfOrigin  = document["country_id"]
                            component_x.fiscalYear  = document["fiscal_year"];
                            component_x.yearSeason = document["year_season"];
                            component_x.noOfCartons  = document["no_of_cartons"];
                            component_x.ocReferenceNo  = document["oc_ref_no"];
                            component_x.shipmentReferenceNo  = document["shipment_ref_no"];

                            if (document["order_source"]!="") {
                                if (document['order_source'] != null) component_x.orderSource = document["order_source"]
                            }
                            
                            if (component_x.customer){
                                var customer = await HTTPRequest.getRequest(component_x.endPoint + "customers/"+component_x.customer.key, null);
                                this.customerAddress = (customer["address"]) ? customer["address"] : "No Customer Address";
                                this.customerContactMobile = (customer["mobile"]) ? decrypt(customer["mobile"]) : "No Customer Mobile";
                                this.customerContactTelephone = (customer["telephone"]) ? decrypt(customer["telephone"]) : "No Customer Telephone";
                                this.customerContactFax = (customer["fax"]) ? customer["fax"] : "No Customer Fax";
                                this.customerContactEmail = (customer["email"]) ? decrypt(customer["email"]) : "No Customer Email";
                                this.selectedCustomerContact = (customer["mobile"]) ? 'Mobile' : (customer["telephone"]) ? 'Telephone' : (customer["fax"]) ? 'Fax' : (customer["email"]) ? 'Email' : 'Telephone'
                                this.activeCustomerContact = (customer["mobile"]) ? decrypt(this.customerContactMobile) : (customer["telephone"]) ? decrypt(this.customerContactTelephone) : (customer["fax"]) ? this.customerContactFax : (customer["email"]) ? decrypt(this.customerContactEmail) : decrypt(this.customerContactTelephone)
                            }

                            //Load document lines
                            window.scrollTo(0,0);
                            let document_lines = []
                            document_lines = await HTTPRequest.getRequest(this.endPoint+'document_lines/'+sales_order_id+'?field_name=document_id&origin_sublocation=0', null)
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                await this.tabulator.addData(document_lines, true);
                            } 
                            this.tabulator.addFilter("line_no", ">", 0);
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                component_x.origData = JSON.stringify(document_lines.reverse()) //For isDirty Data on Document lines
                            } 
                            
                        }
                        break;
                    case 'OTHTRA':
                      
                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.header = TransferAllocationDocumentPicking.header
                        this.renderColumnFields()
                        
                        component_x.isSupplyingSiteDisabled = false
                        component_x.supplyingSite = {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")}
                        if (component_x.documentNumber < 1) {

                            var transfer_allocation_id = this.$route.params.transfer_allocation_id
                            var document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+transfer_allocation_id, null);

                            component_x.receivingReport = transfer_allocation_id
                            component_x.reference = document['reference']
                            component_x.remark = document['remark']
                            component_x.targetDate = moment(document["target_date"])
                            component_x.cancellationDate = moment(document["cancellation_date"])
                            component_x.party_tax_type = document['party_tax_type']

                            if (document['support_discount_text']) component_x.supportDiscount = document['support_discount_text'].split(',')
                            if (document["discount_text"]!="") {
                                if (document['discount_text'] != null) component_x.headerDiscount = document["discount_text"].split(',')
                            }

                            //Load document lines
                            window.scrollTo(0,0);
                            let document_lines = []
                            document_lines = await HTTPRequest.getRequest(this.endPoint+'document_lines/'+transfer_allocation_id+'?field_name=document_id&document_type_code='+this.currentDocumentTypeCode, null)
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                document_lines.forEach( row => {
                                    row.goods_issue_quantity = row.quantity
                                });
                                await this.tabulator.addData(document_lines, true);

                            }

                            this.tabulator.addFilter("line_no", ">", 0);
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                component_x.origData = JSON.stringify(document_lines.reverse()) //For isDirty Data on Document lines
                            } 
                            

                            //Populate Footer and Calculation Data
                            component_x.grossAmount =  document['amount_gross'].replace(',','')
                            component_x.grossAmountDisplay = document['amount_gross'].replace(',','')
                            component_x.overallDiscount = document['amount_header_discount']
                            component_x.overallDiscountPercentage = document['overall_discount_percentage']
                            component_x.netAmount = document['amount_net'].replace(',','')
                            component_x.netAmountDisplay = document['amount_net'].replace(',','')
                            component_x.vatAmount = document['tax_amount']
                            component_x.totalWithVat = document['tax_exempt_amount']
                            component_x.itemDiscount = document['amount_line_discount']
                            component_x.taxRate = document['tax_rate']
                            component_x.grossAmountwithoutTax = document['gross_amount_without_tax']
                            component_x.netAmountWithoutTax = document['net_amount_without_tax']
                            this.initializeFooterCalculation()
                            if (component_x.totalQuantity == 0) component_x.totalQuantity = document['total_quantity']
                        }

                        break;
                    case 'OTHPCK':
                    
                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.header = TransferAllocationDocumentPicking.header
                        this.renderColumnFields()

                        component_x.isSupplyingSiteDisabled = true
                        this.HideDeleteAndAddProductButton = true
                        if(component_x.originDocumentNumber < 1){
                            var document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+component_x.originDocumentNumber, null);
                            if(document!=null){
                                if(document["code_and_document_no"]=="TRA#"+document["document_no"]){
                                    this.tabulator.getColumn('quantity').updateDefinition({editable:false})
                                }
                            }
                        }
                        break;
                    case 'OTHCNS':
                        this.showDocumentBodyHeader = false
                        this.showSummaryCalculation = false
                        this.showUnitCost = false
                        this.showDiscount = false
                        this.showUnitNetCost = false
                        this.showSubtotal = false
                        this.showTotalQuantity = false
                        this.defaultColumnFields = [
                          { name: "code_and_document_no", value: true },
                          { name: "id", value: true },
                          { name: "reference_1", value: true },
                          { name: "document_date", value: true },
                          { name: "total_quantity", value: true },
                          { name: "status", value: true },
                          { name: "order_status", value: true },
                          { name: "remarks", value: true },
                          { name: "updated_by", value: true },
                          { name: "created_by", value: true },
                          { name: "available_quantity", value: false },
                          { name: "actual_quantity", value: true },
                        ]

                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.header = CountSet.header
                        this.renderColumnFields()

                        if (component_x.documentNumber < 1){
                            var data = this.$route.params.pcount_data != undefined ? this.$route.params.pcount_data : []
                            data = JSON.parse(JSON.stringify(data));
                            await this.tabulator.addData(data, true);
                        }
                        this.searchFilter = "document_no"
                        this.placeholder = "Search by document no"
                        this.showCancellationDate = false
                        this.showTargetDate = false
                        
                        break;
                    default:
                    break;
                }

                // Mount to Edit Record
                if (component_x.documentNumber > 0) {
                    component_x.isProductSearchDisabled = false
                    //Action History
                    var documentHistory = await HTTPRequest.getRequest(component_x.endPoint + "document_action_histories/"+component_x.documentNumber+"?field_name=document_id", null);
                    if (documentHistory) this.historyData = documentHistory

                    var document = await component_x.getCurrentDocument();
                    this.isUploaded = document.is_uploaded
                    //this.isPrinted = document.is_printed

                    // initialize selectedCustomerType based on the customer_type value from the document
                    if (document["customer_type"]) {
                        this.selectedCustomerType = document["customer_type"];
                    }

                    var customerData = {};
                    var customer = null
                    // Resolve valid ids first. customer_id is an object ({key}); an empty
                    // customer carries key == -1. b2b_customer_id is a plain id. Only fetch
                    // when there's a real id, otherwise we'd hit customers/-1 or b2b_customers/ .
                    var customerIdKey = (document["customer_id"] && document["customer_id"]["key"] != undefined)
                        ? parseInt(document["customer_id"]["key"])
                        : -1
                    var b2bCustomerId = parseInt(document["b2b_customer_id"])
                    if (customerIdKey > 0 || b2bCustomerId > 0) {
                        if (document["customer_type"] === "customer" && customerIdKey > 0) {
                            customerData = await HTTPRequest.getRequest(component_x.endPoint + "customers/" + customerIdKey, null);
                        } else if (document["customer_type"] === "b2b" && b2bCustomerId > 0) {
                            // const b2bCustomerResponse = await HTTPRequest.getRequest(component_x.endPoint + "b2b_customers/get_valid_b2b_customers?id=" + document["b2b_customer_id"], null);
                            // customerData = b2bCustomerResponse.find(b2b => b2b.id === document["b2b_customer_id"]);
                            customerData = await HTTPRequest.getRequest(component_x.endPoint + "b2b_customers/" + b2bCustomerId, null);
                            if(this.b2bCustomerOptions.length <= 0){
                                this.b2bCustomerOptions = [{id:customerData.id, name:decrypt(customerData.name)}]
                            }
                        }
                        customer = customerData
                    }
                    if (customer) {
                        this.customerAddress = customer.address || "No Customer Address";
                        this.customerContactMobile = decrypt(customer.mobile) || "No Customer Mobile";
                        this.customerContactTelephone = decrypt(customer.telephone) || "No Customer Telephone";
                        this.customerContactFax = customer.fax || "No Customer Fax";
                        this.customerContactEmail = decrypt(customer.email) || "No Customer Email";
                        this.selectedCustomerContact = customer.mobile ? 'Mobile' : customer.telephone ? 'Telephone' : customer.fax ? 'Fax' : customer.email ? 'Email' : 'Telephone';
                        this.activeCustomerContact = decrypt(customer.mobile) || decrypt(customer.telephone) || customer.fax || decrypt(customer.email) || decrypt(this.customerContactTelephone);
                    }
                    // console.log("this",document)
                    // this you will get the brand make in backend a brand with key and label
                    // Start
                    // https://tools.iripple.com/barter-11/bxi-backend/-/issues/1724
                    // Target Date & Cancellation Date for PO is not getting the assigned date from supplier template
                        // Only fetch the supplier template when the document actually has a
                        // supplier. Documents without one carry supplier_id.key == -1, which
                        // would otherwise fire a pointless GET suppliers/-1.
                        var supplierIdKey = (document["supplier_id"] && document["supplier_id"]["key"] != undefined)
                            ? parseInt(document["supplier_id"]["key"])
                            : -1
                        if (supplierIdKey > 0) {
                            this.suppDetails = await HTTPRequest.getRequest(this.endPoint + 'suppliers/' + supplierIdKey, null)
                        }
                    // https://tools.iripple.com/barter-11/bxi-backend/-/issues/1724
                    // Target Date & Cancellation Date for PO is not getting the assigned date from supplier template
                    // End

                    //2370
                    if (this.docTypesForIM.includes(this.currentDocumentTypeCode) || this.currentDocumentTypeCode=="OTHSBI"){
                        var vat_type = (this.suppDetails) ? this.suppDetails.vat_type : null
                        this.party_tax_type = this.party_tax_type || vat_type || null
                    }
                    if(this.docTypesForOM.includes(this.currentDocumentTypeCode)){
                        var vat_type = (customerData) ? customerData.vat_type : null
                        this.party_tax_type = this.party_tax_type || vat_type || null
                    }
                    this.wTax = {key:document['wtax_code'],label:document['wtax_code']}

                    component_x.documentDetails = document
                    component_x.friendlyCodeAndDocumentNo = document['code_and_document_no']
                    component_x.casNo = document['cas_no']
                    if(component_x.currentDocumentTypeCode=="RECDEL" && document['origin_document_id']["label"] != undefined) {
                        component_x.friendlyOriginDocumentNo = document['origin_document_id']["label"]
                    }
                    // Populate Document
                    component_x.documentId = document['id'];
                    component_x.documentNo = document['document_no']
                    component_x.postDate = document['posted_at']
                    component_x.existingDocumentTypeId = document['document_type_id']
                    component_x.documentStatus = document['status']
                    component_x.documentOrderStatus = document['order_status']
                    component_x.originDocumentNumber = document["origin_document_id"]["key"] || -1
                    if (this.docTypesForIM.includes(this.currentDocumentTypeCode) || this.docTypesForOM.includes(this.currentDocumentTypeCode) || this.currentDocumentTypeCode=="OTHSBI"){
                        if(this.originDocumentNumber>0){
                            this.isHeaderDiscountDisabled = true
                        }
                    }
                    component_x.isHeaderOnly = document['is_header_only']
                    component_x.isDocumentTrade = document['is_trade']

                    component_x.requestingSite = document['target_site_id']
                    component_x.supplyingSite = document['source_site_id']
                    component_x.distributionSite = document['site_id']
                    component_x.siteSublocation = document['sublocation_id']
                    component_x.forThisSite = document['site_id']
                    component_x.originSublocation = document['origin_sublocation_id']
                    component_x.destinationSublocation = document['target_sublocation_id']
                    component_x.reference = document['reference']
                    component_x.remark = document['remark']
                    component_x.imageReferenceLink = document['image_ref_link']
                    component_x.orderType  = document["order_type"];
                    component_x.countryOfOrigin  = document["country_id"]
                    component_x.fiscalYear  = document["fiscal_year"];
                    component_x.yearSeason = document["year_season"];
                    component_x.noOfCartons  = document["no_of_cartons"];
                    component_x.brand = document["brand_filter"];
                    component_x.isBrandDisabled = true;
                    // auto populate province, city, barangay, and zip_code fields based on the retrieved customer data arvs
                    if (customerData) {
                        var country_code = customerData.country_id
                        const selectedCountry = component_x.countryOfOriginOptions.find(country => country.code === country_code);
                        if (selectedCountry) {
                            component_x.country = selectedCountry.name;
                        }
                        component_x.province = customerData.province_name;
                        component_x.address = customerData.address;
                        component_x.city = customerData.city_name;
                        component_x.barangay = customerData.barangay_name;
                        component_x.zipCode = customerData.zip_code;
                    }
                    
                    component_x.ocReferenceNo  = document["oc_ref_no"];
                    component_x.shipmentReferenceNo  = document["shipment_ref_no"];
                    component_x.documentDate = moment(document["document_date"])
                    component_x.targetDate = moment(document["target_date"])
                    component_x.cancellationDate = moment(document["cancellation_date"])
                    component_x.paymentTerm = document["payment_term_id"]
                    component_x.supplier = document["supplier_id"]
                    component_x.supplierDetails = document["supplier_id"]
                    component_x.companyOwnerName = document["company_id"]["label"];
                    component_x.b2bCustomer = document["b2b_customer_id"];
                    component_x.isIntegrated = (document["integration_settings"] != null && document["integration_settings"] != '') ? 1:0;
                    if(this.currentDocumentTypeCode == 'OTHPCN' && document["order_status"] == 'Frozen'){
                        this.import_mode_label = 'Import Count Mode'
                        this.importMode = 1
                    }
                    // auto populate ship to address fields based on requesting branch
                    if (this.docTypesForP2P.includes(this.currentDocumentTypeCode)) {
                        this.populateAddress('requestingSite', document["site_id"]["key"], '', 'site');
                    }
                    component_x.currency = document['ui_currency_id']
                    component_x.imageFileUrl = document['image_url']
                    component_x.companyOwnerId = document['company_id']
                    component_x.companyOwnerCode = document['company_code']
                    var siteIdKey = (document['site_id'] && document['site_id']["key"] != undefined)
                        ? parseInt(document['site_id']["key"])
                        : -1
                    if (component_x.companyOwnerName == null && this.accountName.toLowerCase().includes('piml') && siteIdKey > 0){
                        const siteDetails = await this.getSiteById(siteIdKey);
                        var company_name = siteDetails.company_name

                        component_x.companyOwnerName = company_name
                        component_x.companyOwnerId = siteDetails.company_id
                        component_x.companyOwnerCode = siteDetails.code

                        component_x.reference1 = document['reference_2']

                    }

                    if(document["origin_document_id"]["label"] != undefined){
                        component_x.originDocumentCodeAndNumber = document["origin_document_id"]["label"].split("-").slice(-1)[0]
                    } else {
                        component_x.originDocumentCodeAndNumber = ''
                    }

                    if(document['discount_text'] != null){
                        component_x.headerDiscount = document['discount_text'].split(",")
                    }

                    if(document['origin_document_id'] > 0){
                        component_x.isSupplierDisabled = true;
                    }
                    
                    //Populate Footer and Calculation Data
                    component_x.grossAmount =  document['amount_gross'].replace(',','')
                    component_x.grossAmountDisplay = document['amount_gross'].replace(',','')
                    component_x.overallDiscount = document['amount_header_discount']
                    component_x.overallDiscountPercentage = document['overall_discount_percentage']
                    component_x.netAmount = document['amount_net'].replace(',','')
                    component_x.netAmountDisplay = document['amount_net'].replace(',','')
                    component_x.vatAmount = document['tax_amount']
                    component_x.totalWithVat = document['tax_exempt_amount']
                    component_x.itemDiscount = document['amount_line_discount']
                    component_x.taxRate = document['tax_rate']
                    component_x.grossAmountwithoutTax = document['gross_amount_without_tax']
                    component_x.netAmountWithoutTax = document['net_amount_without_tax']
                    component_x.drawerSublocationSiteId = document['site_id']["key"]
                    component_x.currencyRateLabel = document["currency_rate"] != "0.00" && document["currency_rate"]!=null ? document["currency_rate"] : 1
                    component_x.currencyRate = document["currency_rate"]
                    component_x.currencyDetails = document["ui_currency_id"]
                    component_x.currencyId = document['currency_id']['key']
                    component_x.supplierCurrencyName = document['supplier_currency_name']

                    component_x.createdBy = document['created_by']
                    component_x.postedBy = document['posted_by']
                    if (this.docTypesForOM.includes(this.currentDocumentTypeCode)){
                        if (is_reload){
                        component_x.productPriceChoice = component_x.productPriceChoice
                        }else {
                            component_x.productPriceChoice = document['price_type'] || component_x.productPriceChoice
                        }
                    }

                    // Document report/printing should show shipment_details - 3836
                    if(['ORIOSO'].includes(this.currentDocumentTypeCode) && document['shipment_details'] != null){
                        var v_array = document['shipment_details']
                        var v_keys = Object.keys(v_array)
                        component_x.shipmentDetailData = []
                        v_keys.forEach((element) => {
                            let result = element.replace(/([A-Z])/g, " $1");
                            let finalResult = result.charAt(0).toUpperCase() + result.slice(1);
                            //component_x.shipmentDetailData.push({"name": finalResult, "amount":v_array[element]})
                            if(typeof v_array[element] === 'string')
                                component_x.shipmentDetailData.push({"name": finalResult, "amount":v_array[element]})
                            else if(typeof v_array[element] === 'number')
                                component_x.shipmentDetailData.push({"name": finalResult, "amount":this.formatMyNumber(Number(v_array[element]), 2)})
                            else if(typeof v_array[element] === 'object'){
                                // component_x.shipmentDetailData.push({"name": finalResult, "amount":v_array[element].toString()})
                                if (v_array[element] === null) {
                                    component_x.shipmentDetailData.push({
                                        "name": finalResult, 
                                        "amount": "0.00" // or "N/A"
                                    }) 
                                } else {
                                    component_x.shipmentDetailData.push({
                                        "name": finalResult, 
                                        "amount": v_array[element].toString()
                                    });
                                }
                            }
                            else
                                component_x.shipmentDetailData.push({"name": finalResult, "amount":v_array[element]})
                        });
                    }

                    // Reuse the system module already fetched earlier in initializeDocument
                    // (stored as currentSystemModule) instead of re-fetching the same
                    // system_modules?code=<type>&status=A record.
                    var docTypeSystemModule = component_x.currentSystemModule
                    if (!docTypeSystemModule || !docTypeSystemModule["id"]) {
                        var docTypeSystemModules = await HTTPRequest.getRequest(component_x.endPoint+"system_modules?code="+component_x.currentDocumentTypeCode+"&status=A", null);
                        docTypeSystemModule = docTypeSystemModules[0]
                    }
                    var configgedExtras = await HTTPRequest.getRequest(component_x.endPoint+"account_system_modules/"+ docTypeSystemModule["id"] +"?field_name=system_module_id", null);
                    if(configgedExtras!=undefined && configgedExtras != [] && configgedExtras != {} && configgedExtras["meta"]!=undefined && configgedExtras["meta"].customized_fields != undefined ){
                        var metaHolder = JSON.parse(configgedExtras["meta"]).customized_fields
                        this.configuredExtras = metaHolder.map(a => a.code)
                    }
                    this.documentExtras = document['extras']
                    component_x.extras = this.documentExtras
                    //console.log("LOADING REFERENCES")
                    var documentReferences = component_x.document_config.document_type_settings.references
                    for(var i=0; i < documentReferences.length; i++){
                        var storedRef = document["reference_" + (i + 1).toString()]
                        if(_.isEmpty(storedRef)){
                            //console.log("skip")
                        } else {
                            documentReferences[i]["input"] = storedRef
                        }
                    }

                    if (document['support_discount_text']) component_x.supportDiscount = document['support_discount_text'].split(',')
                    if (component_x.document_config && !component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.termsAndDiscount && document["discount_text"]) component_x.headerDiscount = document["discount_text"].split(',')
                    
                    // Changed position of these initializers to render the right currency_rate in the tabulator
                    // Updated by Maron Justo
                    if(document["supplier_id"].currency_id!=document["ui_currency_id"].key){
                        await component_x.showConversionCurrencyRate();
                    }
                    if (component_x.currentDocumentTypeCode=="OTHPWS"){
                        window.scrollTo(0,0);
                        let document_lines = []
                        document_lines = await HTTPRequest.getRequest(component_x.endPoint + "pricecost_lines/"+component_x.documentNumber+"?field_name=document_id", null);
                        if(document_lines != undefined && document_lines != null && document_lines != []){
                            await this.tabulator.addData(document_lines, true);
                        } 
                        this.tabulator.addFilter("line_no", ">", 0);

                        if(document_lines != undefined && document_lines != null && document_lines != []){
                            component_x.origData = JSON.stringify(document_lines.reverse()) //For isDirty Data on Document lines
                        } 
                        this.initializeFooterCalculation();
                        
                    }else if(component_x.currentDocumentTypeCode=="OTHCNS"){
                        window.scrollTo(0,0);
                        var pcount_documents = [];
                        pcount_documents = await HTTPRequest.getRequest(component_x.endPoint + "documents/get_pcount_document_details?id="+component_x.documentNumber, null);
                        if(pcount_documents) await this.tabulator.addData(pcount_documents, true);
                        if(pcount_documents) component_x.origData = JSON.stringify(pcount_documents.reverse()) //For isDirty Data on Document lines
                        this.initializeFooterCalculation();
                        
                    } else if(component_x.currentDocumentTypeCode=="ORIOCR"){ // do nothing
                    } else {
                        window.scrollTo(0,0);
                        // console.log('30')
                        var other_params =""
                        if(is_reload){
                            other_params = "&priceorchoice="+this.productPriceChoice
                        }
                        let document_lines = []
                        document_lines = await HTTPRequest.getRequest(component_x.endPoint + "document_lines/" +component_x.documentNumber+ "?field_name=document_id"+other_params, null);
                       
                        if(document_lines != undefined && document_lines != null && document_lines != []) {
                            // console.log(document_lines)
                            if (((component_x.currentDocumentTypeCode == "OTHSRQ" || component_x.currentDocumentTypeCode == "ORISOX") && is_reload == true) || (this.currentDocumentTypeCode == 'RECDEL' && document['status'] == "Saved" && document['purpose_id']['code'] == "FOC") || (this.currentDocumentTypeCode == 'RELRSR_' && document['status'] == "Saved" && document['origin_document_id']['key'] > 0) || (this.currentDocumentTypeCode == 'OTHSIN' && document['status'] == "Saved" && ['STI-IR', 'PCN-IR'].includes(document['order_source']))){
                                
                                document_lines.forEach( row => {
                                    // if(this.currentDocumentTypeCode == 'RECDEL' || this.currentDocumentTypeCode == 'RELRSR'){
                                    //     var price = Number(eval('row.price_list.landed_cost'))
                                    // } else 
                                    if(this.currentDocumentTypeCode == 'OTHSIN' && !this.accountName.toLowerCase().includes('piml')){
                                        if(['STI-IR', 'PCN-IR'].includes(document['order_source']) && document["party_tax_type"] != 'V'){
                                            //Check customer vat type
                                            var price = Number(eval('row.price_list.retail_price') / 1.12)
                                        } else {
                                            var price = Number(eval('row.price_list.retail_price'))
                                        }
                                    } else {
                                        var price = Number(eval('row.price_list.'+component_x.productPriceChoice))
                                    }
                                    row.price = Number(price || row.price).toFixed(component_x.decimalPlaces)
                                    row.cost = Number(price || row.cost).toFixed(component_x.decimalPlaces)
                                    row.subtotal =((Number(row.price) * Number(row.quantity)) - Number(row.discount)).toFixed(component_x.decimalPlaces)
                                    row.subtotal_without_vat = (Number(row.subtotal)/ (1+Number(component_x.taxRate))).toFixed(component_x.decimalPlaces)
                                    row.price_without_vat = (Number(row.price)/ (1+Number(component_x.taxRate))).toFixed(component_x.decimalPlaces)
                                    row.tax_amount = row.subtotal - row.subtotal_without_vat
                                });
                                //this.isEditing = true
                            }
                            
                            await this.tabulator.addData(document_lines, true);
                        }

                        if(document_lines != undefined && document_lines != null && document_lines != []) {
                            await this.tabulator.addFilter("line_no", ">", 0);
                        }

                        if(document_lines != undefined && document_lines != null && document_lines != []){
                            component_x.origData = JSON.stringify(document_lines.reverse()) //For isDirty Data on Document lines
                        } 
                        
                    }

                    //Document Charges
                    // Only fetch document charges for OTHSBI documents (and only when there's a
                    // valid document id). Other document types don't need this call.
                    if(component_x.currentDocumentTypeCode === 'OTHSBI' && component_x.documentNumber > 0 && component_x.document_config){
                        var enableAddCharges = component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.enableAddCharges
                        if(enableAddCharges) {
                            var document_charges = []
                            document_charges = await HTTPRequest.getRequest(component_x.endPoint + "document_charges/"+component_x.documentNumber+"?field_name=document_id", null);
                            if(document_charges) component_x.chargeData = document_charges
                        }
                    }

                    if (document["shipping_method_id"]["key"] > 0) component_x.shippingMethod = document["shipping_method_id"];
                    if (document["purpose_id"]["key"] > 0) component_x.purpose = document["purpose_id"];

                    component_x.party = document["party_name"];
                    component_x.party_tax_type = document["party_tax_type"];
                    component_x.customer = document["customer_id"];
                    component_x.b2bCustomer = document["b2b_customer_id"];
                    component_x.salesman = {key: document["salesman_id"], label: document["salesman_name"]};

                    if(component_x.salesman)
                    // if (component_x.customer){
                    //     var customer = await HTTPRequest.getRequest(component_x.endPoint + "customers/"+component_x.customer.key, null);
                    //     this.customerAddress = (customer["address"]) ? customer["address"] : "No Customer Address";
                    //     this.customerContactMobile = (customer["mobile"]) ? customer["mobile"] : "No Customer Mobile";
                    //     this.customerContactTelephone = (customer["telephone"]) ? customer["telephone"] : "No Customer Telephone";
                    //     this.customerContactFax = (customer["fax"]) ? customer["fax"] : "No Customer Fax";
                    //     this.customerContactEmail = (customer["email"]) ? customer["email"] : "No Customer Email";
                    //     this.selectedCustomerContact = (customer["mobile"]) ? 'Mobile' : (customer["telephone"]) ? 'Telephone' : (customer["fax"]) ? 'Fax' : (customer["email"]) ? 'Email' : 'Telephone'
                    //     this.activeCustomerContact = (customer["mobile"]) ? this.customerContactMobile : (customer["telephone"]) ? this.customerContactTelephone : (customer["fax"]) ? this.customerContactFax : (customer["email"]) ? this.customerContactEmail : this.customerContactTelephone
                    // }
                    
                    //Optimization move to 19012
                    // consider customer type in populating customer details
                    // var customer = null;

                    // if (document["customer_type"] === "customer") {
                    //     customer = await HTTPRequest.getRequest(this.endPoint + "customers/" + this.customer.key, null);
                    // } else if ( document["customer_type"] === "b2b") {
                    //     customer = await HTTPRequest.getRequest(this.endPoint + '/b2b_customers/' + this.b2bCustomer, null);

                    //     if (customer) {
                    //         const address = `${customer.barangay_name || ''} ${customer.city_name || ''} ${customer.province_name || ''}`;
                    //         customer.address = address;
                    //     }
                    // }

                    // if (customer) {
                    //     this.customerAddress = customer.address || "No Customer Address";
                    //     this.customerContactMobile = decrypt(customer.mobile) || "No Customer Mobile";
                    //     this.customerContactTelephone = decrypt(customer.telephone) || "No Customer Telephone";
                    //     this.customerContactFax = customer.fax || "No Customer Fax";
                    //     this.customerContactEmail = decrypt(customer.email) || "No Customer Email";
                    //     this.selectedCustomerContact = customer.mobile ? 'Mobile' : customer.telephone ? 'Telephone' : customer.fax ? 'Fax' : customer.email ? 'Email' : 'Telephone';
                    //     this.activeCustomerContact = decrypt(customer.mobile) || decrypt(customer.telephone) || customer.fax || decrypt(customer.email) || decrypt(this.customerContactTelephone);
                    // }
                    //End Optimization move to 19012

                    if(document["address"]){
                        this.customerAddress = document["address"]
                    }

                    // if Transfer Request
                    if (this.currentDocumentTypeCode == 'ORITRQ' || this.currentDocumentTypeCode == 'ORICSQ') {
                        if (document['source_site_id']['key'].toString() == secureStorage.getItem("defaultSiteId").toString()) component_x.showCreateChildDocButton = true
                    }

                    if (this.currentDocumentTypeCode == 'RELTRX' || this.currentDocumentTypeCode == 'RELCSX') {
                        if (document['target_site_id']['key'].toString() == secureStorage.getItem("defaultSiteId").toString()) component_x.showCreateChildDocButton = true

                        if(this.currentDocumentTypeCode == 'RELTRX'){
                            //Get Default Site Sublocation [Requesting Site]
                            var targetSiteIdKey = (document['target_site_id'] && document['target_site_id']['key'] != undefined)
                                ? parseInt(document['target_site_id']['key'])
                                : -1
                            var default_sublocation = (targetSiteIdKey > 0)
                                ? await HTTPRequest.getRequest(this.endPoint + 'sites/'+targetSiteIdKey, null)
                                : null
                            this.notifMessage = []
                            if(default_sublocation && default_sublocation['sublocation_id'] != null){
                                //Get Sublocation Code
                                var sublocation = await HTTPRequest.getRequest(this.endPoint + 'sublocations/'+default_sublocation['sublocation_id'], null)
                                this.default_sublocation_code = sublocation['code']
                            } else {
                                this.requestingSite = ''
                                this.documentActionNotification('No default sublocation for the selected requesting site.', 'error')
                            }
                        }
                    }

                    // if Stock Request For Serving /Concession
                    if (this.currentDocumentTypeCode == 'OROTRQ' || this.currentDocumentTypeCode == 'OROCSQ' || this.currentDocumentTypeCode == 'OTHTOV') {
                        if (this.originDocumentNumber > 0) {
                            this.isRequestingSiteDisabled = true
                        }
                    }

                    // if Receiving Report
                    if (this.currentDocumentTypeCode == 'RECDEL') {
                        if (this.originDocumentNumber > 0) {
                            this.isSupplierDisabled = true
                        }
                    }

                    // if Sales order Document
                    if (this.currentDocumentTypeCode == 'ORISOX' || this.currentDocumentTypeCode == 'OTHSRQ' || this.currentDocumentTypeCode == 'ORIOSO') {
                        if (document["order_source"]!="") {
                            if (document['order_source'] != null) component_x.orderSource = document["order_source"]
                        }
                        this.showPrint = true
                    }

                    // if Delivery Document
                    if (this.currentDocumentTypeCode == 'RELDDE') {
                      if (document["discount_text"]) component_x.headerDiscount = document["discount_text"].split(',')
                      
                      if (document["order_source"]!="") {
                        if (document['order_source'] != null) component_x.orderSource = document["order_source"]
                      }
                      
                      var orisox_document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+document['origin_document_id']['key'], null);
                      component_x.salesOrder = orisox_document["document_no"];
                      if (orisox_document["error"] == undefined && orisox_document["payment_status"] == "Paid") {
                        this.forPaymentIsProcessed = true
                      }
                      this.showPrint = true
                      if (document['order_source'] == 'zalora'){
                        if (this.zaloraPrintWayBillStatus == null){
                            this.exportShippingLabel();
                        }else {
                            this.fetchStatus(this.zaloraPrintWayBillId)
                        }
                      }

                    }

                    // if re-routed SO
                    if (this.currentDocumentTypeCode == 'ORORSO') {
                        component_x.salesOrder = document['origin_document_id']['label'];
                        if (document["discount_text"]) component_x.headerDiscount = document["discount_text"].split(',')

                        if (document["order_source"]!="") {
                            if (document['order_source'] != null) component_x.orderSource = document["order_source"]
                        }

                        var orisox_document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+document['origin_document_id']['key'], null);
                        if (orisox_document["error"]== undefined && orisox_document["payment_status"] == "Paid") {
                            this.forPaymentIsProcessed = true
                        }
                        this.showPrint = true
                    }

                    // if Customer Return
                    if (this.currentDocumentTypeCode == 'RECCSR' || this.currentDocumentTypeCode == 'ORIOCR' || this.currentDocumentTypeCode == 'RECCSI') {
                        component_x.deliveryDocument = document['origin_document_id']['label'];
                        if (document["discount_text"]) component_x.headerDiscount = document["discount_text"].split(',')

                        if (document["order_source"]!="") {
                            if (document['order_source'] != null) component_x.orderSource = document["order_source"]
                        }

                        var orisox_document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+document['origin_document_id']['key'], null);
                        this.showPrint = true
                    }
                    // if Sales Invoice
                    if (this.currentDocumentTypeCode == 'OTHSIN') {
                        component_x.deliveryDocument = document['origin_document_id']['label'];
                        var delivery_document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+document['origin_document_id']['key'], null);
                        component_x.salesOrder = delivery_document['origin_document_id']['label'];

                        if (document["order_source"]!="") {
                            if (document['order_source'] != null) component_x.orderSource = document["order_source"]
                        }
                        var reldde_document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+document['origin_document_id']['key'], null);
                        if (reldde_document["error"] == undefined && reldde_document["origin_document_id"] !="" && reldde_document["origin_document_id"] !=null){
                            var orisox_document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+reldde_document['origin_document_id']['key'], null);
                            if (orisox_document["error"]== undefined && orisox_document["payment_status"] == "Paid") {
                                this.forPaymentIsProcessed = true
                            }
                        }
                        this.showPrint = true
                    }
                    // if Sales Invoice
                    if (this.originDocumentNumber > 0 && document['order_source'] != 'ADD ON') {
                        var originDocument = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+this.originDocumentNumber, null);
                        this.originDocumentTypeId = originDocument['document_type_id']
                    }

                    //Disabled Actions When Document is already Posted
                    var disable_status = ["Posted", "Voided", "Confirmed"]
                    var isPIML = this.accountName.toLowerCase().includes('piml');
                    if (isPIML) {
                        component_x.isPaymentTermDisabled = true;
                        } else {
                        // For non-PIML, disable only for specific statuses
                        component_x.isPaymentTermDisabled = disable_status.includes(component_x.documentStatus);
                    }
                        component_x.isBrandDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isSaveDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isUpdateDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isSupplyingSiteDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isRequestingSiteDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isHeaderDiscountDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isSupplierDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isTradeToggleDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.productFormMode = (disable_status.includes(component_x.documentStatus)) ? "Search" : "Add";
                        component_x.isReferenceDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        // component_x.isPaymentTermDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isWTaxDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isShippingMethodDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isSupportsDiscountDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isDocumentDateDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isTargetDateDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isCancellationDateDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isAddChargeDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isPurposeDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isPartyDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isDistributionSiteDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isOriginSublocationDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isDestinationSublocationDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isCustomerDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isOrderTypeDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isCountryOfOriginDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isFiscalYearDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isYearSeasonDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isNoOfCartonsDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isProvinceDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isCityDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isBarangayDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isZipCodeDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isSalesmanDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isCustomerCreateDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isOrderSourceDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.showSupplierOptions = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isForThisSiteDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isSiteSublocationDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isRevenueDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isPostDisabled = (disable_status.includes(component_x.documentStatus) && component_x.documentStatus != "Confirmed") ? true : false;
                        this.showAdvancedInfo = true

                        //Force disable for OTHTOV
                        if (this.currentDocumentTypeCode == 'OTHTOV') {
                            this.HideDeleteAndAddProductButton = true;
                            component_x.isSupplyingSiteDisabled = true;
                            component_x.isRequestingSiteDisabled = true;
                        }

                        //Disable sublocation for OTHPCN
                        if (this.currentDocumentTypeCode == 'OTHPCN') {
                            component_x.isSiteSublocationDisabled = true;
                        }

                        //SBI Editor
                        if (this.currentDocumentTypeCode == 'OTHSBI') {
                            component_x.receivingReport = document['origin_document_id']['label'];
                            if(document['origin_document_id']['key']) component_x.isRequestingSiteDisabled = true
                            component_x.isSupplierDisabled = true;
                            component_x.productFormMode = '';
                            component_x.HideDeleteAndAddProductButton = true;
                        }

                        //Force disable for OTHPCV
                        if (this.currentDocumentTypeCode == 'OTHPCV') {
                            this.HideDeleteAndAddProductButton = true;
                            component_x.isSiteSublocationDisabled = true;
                            component_x.isRequestingSiteDisabled = true;
                            this.requestingSite = document["site_id"]
                        }

                        //override customer using party name
                        if (this.currentDocumentTypeCode == 'ORIOSO' || this.currentDocumentTypeCode == 'ORIOCR') {
                            this.customer = {key: -1, label: document['party_name']}
                            component_x.orderSource = document['order_source']
                            this.cancellationDate = ''
                        }
                    
                        this.checkSiteTypeAndTargetBranch();


                        if(this.currentDocumentTypeCode == 'RECCSR') {
                        //Get ORIGIN
                        var document_origin = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+component_x.originDocumentNumber, null);
                        component_x.document_origin = document_origin
                        }

                        // if Transfer In /Concession
                        if (this.currentDocumentTypeCode == 'RECTRX' || this.currentDocumentTypeCode == 'RECCSX'  || this.currentDocumentTypeCode == 'OTHTOV') {
                            if (this.originDocumentNumber > 0) {
                                if (secureStorage.getItem("currentSiteSiteType") == "ho" && this.currentDocumentTypeCode != 'OTHTOV' && !document['origin_document_id']['key']){
                                    component_x.isSupplyingSiteDisabled = false
                                }else{
                                    component_x.isSupplyingSiteDisabled = true
                                }
                                this.isRequestingSiteDisabled = true
                                if((this.currentDocumentTypeCode == 'RECTRX' || this.isIntegrated == 1) && this.currentDocumentTypeCode != 'OTHTOV'){
                                    component_x.isPurposeDisabled = true
                                    component_x.isReferenceDisabled = true
                                    component_x.isOriginSublocationDisabled = true
                                }
                            }
                        }

                        if(this.currentDocumentTypeCode == 'RECDEL' && document['origin_document_id']['key']){
                            component_x.isPurposeDisabled = true
                        }

                        if(['RECADJ', 'RELADJ'].includes(this.currentDocumentTypeCode)){
                            if (document['origin_document_id']['key'] != undefined){
                                this.requestingSite = document["site_id"]
                            }
                        }

                        if(component_x.currentDocumentTypeCode=="ORORSO") {
                            if( this.documentExtras!='' && this.documentExtras!=undefined){
                                this.revenue = this.documentExtras["revenue"] || ''
                            }
                            if(this.requestingSite.key == secureStorage.getItem("defaultSiteId").toString()){
                                this.isPostDisabled = false
                                this.isConfirmDisabled = false
                                this.isUnconfirmDisabled = false
                                this.isRevenueDisabled = true
                                if(this.distributionSite.key != this.requestingSite.key){
                                    this.isRequestingSiteDisabled = true
                                }
                                this.tabulator.toggleColumn("quantity")
                                this.tabulator.toggleColumn("on_hand_quantity")
                            }else{
                                this.isPostDisabled = true
                                this.isConfirmDisabled = true
                                this.isUnconfirmDisabled = true
                            }
                        }
                    // await component_x.fetchCurrencies();
                    // await component_x.showConversionCurrencyRate();
                    if (component_x.totalQuantity == 0){
                        component_x.totalQuantity = document['total_quantity']
                    }
                    
                    component_x.defaultSite = document['site_id']["key"]
                } else {
                    if (this.header.showBrand){
                        component_x.isProductSearchDisabled = true
                    }
                    component_x.defaultSite = secureStorage.getItem("defaultSiteId")
                }

                //Check if with ongoing jobs
                // Only check import jobs when the document is still in a Saved state. Posted/
                // Voided/Confirmed documents can't have a pending CSV import, so skip the call.
                if(component_x.documentStatus === 'Saved' || component_x.documentStatus === 'S'){
                var ongoingJob = await HTTPRequest.getRequest(component_x.endPoint+'import_jobs?profile_name='+this.documentCurrentSiteSBU+'-'+this.documentCurrentSiteCode+'-'+this.currentDocumentTypeFriendlyCode+'-'+this.documentNumber, null)
                if(ongoingJob != undefined && ongoingJob.length > 0){
                    if(ongoingJob[0].formatted_status == 'Ongoing') {
                        this.documentStatus = 'Uploading'
                    }
                    else if(ongoingJob[0].formatted_status == 'With errors') {
                        this.documentStatus = 'Upload Error'
                        component_x.$notification['warning']({
                            message: 'Upload Error',
                            duration: 0,
                            description: "CSV file uploaded with errors ["+this.documentCurrentSiteSBU+'-'+this.documentCurrentSiteCode+'-'+this.currentDocumentTypeFriendlyCode+'-'+this.documentNumber+"] but you can ignore it and continue processing the document. Click 'View Jobs' button to review.",
                            style: getNotificationStyle('warning'),
                            btn: h => {
                                return h(
                                'base-button',
                                {
                                    props: {
                                    type: 'warning',
                                    class: 'btn-sm',
                                    },
                                    on: {
                                    click: () => component_x.$router.push("/jobs"),
                                    },
                                },
                                'View Jobs',
                                );
                            },
                        });
                    } else if(ongoingJob[0].formatted_status == 'Upload terminated') {
                        this.documentStatus = ongoingJob[0].formatted_status
                        component_x.$notification['warning']({
                            message: 'Upload terminated. Please reupload.',
                        });
                    }
                }
                } // end: only check import jobs when document status is Saved

                //Setting Document Status Icon on Header
                switch(this.documentStatus) {
                    case 'Saved':
                        this.headerStatusIcon = 'fas fa-check-circle'
                        break;
                    case 'Uploading':
                        this.headerStatusIcon = 'fas fa-cloud-upload-alt text-blue'
                        break;
                    case 'Upload Error':
                        this.headerStatusIcon = 'fas fa-times text-red'
                        break;
                    case 'Posted':
                        this.headerStatusIcon = 'fas fa-check-circle text-green'
                        this.isPostDisabled = true
                        if (this.currentDocumentTypeCode == 'OTHASM' || this.currentDocumentTypeCode == 'OTHDSM') {
                            this.postedASMDSM = true
                        }
                        break;
                    case 'Voided':
                        this.headerStatusIcon = 'fas fa-times-circle text-red'
                        this.isPostDisabled = true
                        break;
                    case 'Confirmed':
                        this.headerStatusIcon = 'fas fa-check-circle'
                        break;
                    default:
                        this.headerStatusIcon = ''
                        this.isPostDisabled = false
                }

                // console.log(this.documentOrderStatus)
                switch(this.documentOrderStatus){
                    case 'Unfulfilled':
                    this.headerOrderStatusIcon = 'fa-regular fa-circle mr-4 text-gray'
                    break;
                    case 'Fulfilled':
                    this.headerOrderStatusIcon = 'fas fa-check-circle mr-4 text-green'
                    break;
                    case 'Partial':
                    this.headerOrderStatusIcon = 'fa-solid fa-circle-half-stroke mr-4 text-green'
                    break;
                    case 'Done':
                    this.headerOrderStatusIcon = 'fa-solid fa-circle-dot mr-4 text-cyan'
                    break;
                    case 'Printed':
                    this.headerOrderStatusIcon = 'fas fa-print mr-4 text-black'
                    break;
                    default:
                    this.headerOrderStatusIcon = ''

                }
                //1935
                await this.calculateOverallDiscount()
                await this.initializeFooterCalculation();
                if(!component_x.isRunDefaultCurrency){
                    await component_x.fetchDefaultCurrency()
                }
                component_x.forceFetchCurrency = true
                await component_x.fetchCurrencies()
                
                const docSortDrawerData = localStorage.getItem("documentTypeSort" + this.currentDocumentTypeCode);
                if(docSortDrawerData != undefined && docSortDrawerData != null && docSortDrawerData != "[]"){
                    let val = JSON.parse(docSortDrawerData)
                    await this.sortDocument(val);
                }
                // A new child still carries its parent's documentId until it is saved
                // Clear inherited relationships and only fetch for the current saved document
                // Fix stuck loading spinner after creating a child ASN
                this.relatedDocument = []
                this.relatedDocumentOrigin = []
                this.relatedGrandChildrenDocument = []
                this.documentRelation = ''
                if(this.documentNumber > 0){
                    var related_document = await HTTPRequest.getRequest(this.endPoint + '/documents/get_related_document?document_id=' + this.documentNumber, null, null)
                    if(related_document && !related_document.error){
                        this.relatedDocument = Array.isArray(related_document.data) ? related_document.data : []
                        this.documentRelation = related_document.relation || ''
                        this.relatedGrandChildrenDocument = Array.isArray(related_document.grand_children) ? related_document.grand_children : []
                        this.relatedDocumentOrigin = Array.isArray(related_document.origin) ? related_document.origin : []
                    }
                }

                if(this.currentDocumentTypeCode == 'OTHSIN' && this.documentDetails && this.documentDetails.order_source == 'LIQUIDATION'){
                    this.tabulator.getColumn('subtotal').updateDefinition({ title: "Gross Amount" })
                }

                //Update SI document for TOV/PCV SI Resolution
                if (this.currentDocumentTypeCode == 'OTHSIN' && document['status'] == "Saved" && ['STI-IR', 'PCN-IR'].includes(document['order_source']) && this.is_updated == 0){
                    this.is_updated = 1
                    this.update()
                }
                this.totalCharge();

                //Optimization >> get_tabulator_site_sublocations
                // Only fetch the tabulator sublocation options when the item table actually
                // shows the "Sub Location" column for this document type. Other types don't
                // render it, so the call is unnecessary.
                // Only fetch when the item table actually shows the Sub Location column.
                var hasSublocationColumn = this.documentShowsSublocationColumn();
                var response = '';
                var sl_site = (this.currentDocumentTypeCode == 'RECTRX') ? this.distributionSite.key : this.requestingSite.key;
                if (hasSublocationColumn && sl_site>0){
                    var request = new XMLHttpRequest();
                    request.open('GET', this.endPoint + 'sublocations/get_tabulator_site_sublocations?site_id='+sl_site, false);
                    request.setRequestHeader('Authorization', 'Bearer ' + secureStorage.getItem("accessToken"));
                    request.setRequestHeader('Request-Source',"BXI-Web");
                    request.setRequestHeader('ip',secureStorage.getItem("ipAddress"));
                    request.send(null);
                    if (request.status === 200) {
                        response = request.responseText;
                    }
                    this.tabulator_site_sublocations = JSON.parse(response)
                }
                
                this.spinning = false;
            },
            renameLineNo(){
                let allColumns = this.tabulator.getColumnDefinitions();
                allColumns[1].title = "Line No."
                this.tabulator.setColumns(allColumns);
            },
            moveColumnNextToFrozen(tabulator, columnToMove, targetColumn, isFrozen) {
                let allColumns = tabulator.getColumnDefinitions();
                let targetIndex = -1
                // if (columnToMove == "line_no"){
                //     targetIndex = 0
                // }else {
                    targetIndex = allColumns.findIndex(col => col.field === targetColumn);
                // }
                let moveIndex = allColumns.findIndex(col => col.field === columnToMove);
                
                if (targetIndex === -1 || moveIndex === -1) {
                    console.error("Target or move column not found");
                    return;
                }
                
                let columnToMoveDefinition = allColumns.splice(moveIndex, 1)[0];
                allColumns.splice(targetIndex + 1, 0, columnToMoveDefinition);
                columnToMoveDefinition.frozen = isFrozen;
                tabulator.setColumns(allColumns);
                
                tabulator.redraw(true);
            },
            async copyDocument() {
                var duplicated_document = await HTTPRequest.postRequest(this.endPoint + '/documents/copy_document?document_id=' + this.documentNumber , null, null)
                this.openDocument(duplicated_document.id,this.existingDocumentTypeDetails)
            },
            voidEcomOrder(){
                if (this.orderSource == 'shopee' || this.orderSource == 'lazada' || this.orderSource == 'shopify' ||  this.orderSource == 'zalora'){
                    this.documentEcomDrawerVisible = true
                    this.ecomAction = 'Void'
                } else {
                    this.voided()
                }
            },
            deleteRow(id){
                this.documentNumber = id
                this.voided()
            },
            postEcomOrder(){
                window.scrollTo(0,0);
                this.notifMessage = [];
                //For RelDde Documents
                if(!this.isPostDisabled && !this.spinning){
                    this.spinning = true;
                    var data = this.tabulator.getData();
                    if(['RELDDE'].includes(this.currentDocumentTypeCode)){
                        if (this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.automaticPostingOnSave != true) {
                            //when goods issue
                            if (this.documentNumber > 0) {
                                var invalid = data.find(row => row.goods_issue_quantity == 0 && Number(row.ordered_quantity) > 0)
                                if (invalid != undefined){
                                    this.notifMessage.push("Zero goods issue quantity is not allowed in the document line");
                                    this.documentActionNotification('post', 'error');
                                    this.spinning = false;
                                    this.enableActions();
                                    return;
                                }
                            }
                        }
                    }
                    if (data.length > 0) {
                        this.isEditing = !(component_x.origData === JSON.stringify(data))
                    }

                    if(this.documentStatus == "Confirmed" && this.isEditing){
                        this.isChangeAction = true;
                    }

                    if (this.isEditing && !this.isChangeAction) {
                        this.notifMessage.push("You have unsaved changes, please save before posting")
                        this.documentActionNotification('post', 'error');
                        this.spinning = false;
                        this.enableActions();
                        return;
                    } else {
                        this.documentEcomDrawerVisible = true
                        this.ecomAction = 'Post'
                        this.spinning = false;
                        this.enableActions();
                    }
                }
            },
            ecomPost(id){
                this.documentNumber = id
                this.post()
            },
            shopeePrintWayBill:async function(){
                this.spinning = true;
                var post_request = await HTTPRequest.postRequest(this.endPoint + '/shopee_integrations/get_airway_bill', null, {document_id:this.documentNumber})
                if (post_request["result"]["errors"].length <=0){
                    this.spinning = false;
                    window.open(post_request["result"]["airway_bills"][0]["airway_bill"], '_blank')
                }else {
                    this.$notification['error']({
                        message: post_request["result"]["errors"][0]["error_code"],
                        description: post_request["result"]["errors"][0]["error_description"],
                        style: getNotificationStyle('error')
                    });
                    this.spinning = false;
                }
            },
            lazadaPrintWayBill:async function(){
                this.spinning = true;
                var post_request = await HTTPRequest.postRequest(this.endPoint + '/lazada_integrations/print_waybill', null, {document_id:this.documentNumber})
                if (post_request["errors"] == undefined){
                    this.spinning = false;
                    let pdfWindow = window.open("");
                    pdfWindow.document.write(
                        "<iframe width='100%' height='100%' src='data:"+post_request["document"]["mime_type"]+";base64, " +
                        post_request["document"]["file"] + "'></iframe>"
                    )
                }else {
                    this.$notification['error']({
                        message: "Error",
                        description: post_request["errors"],
                        style: getNotificationStyle('error')
                    });
                    this.spinning = false;
                }
            },
            exportShippingLabel:async function(){
                var post_request = await HTTPRequest.postRequest(this.endPoint + '/zalora_integrations/print_waybill', null, {document_id:this.documentNumber})
                if (post_request["errors"] == undefined){
                    this.zaloraPrintWayBillStatus == post_request.data.status;
                    this.zaloraPrintWayBillId == post_request.data.id;
                    if (this.zaloraPrintWayBillStatus !== 'Finished') {
                        this.fetchStatus(post_request["data"].id);
                    }else {
                    this.zaloraPrintWayBillDisabled = false;
                    this.zaloraPrintWayBillDLink = 'https://sellercenter-staging.zalora.com.ph/'+post_request["data"]["downloadLinks"][0]
                    }
                }
            },
            fetchStatus:async function(item_id) {
                var post_request = await HTTPRequest.postRequest(this.endPoint + '/zalora_integrations/get_export_item', null, {document_id:this.documentNumber, exportItemId: item_id});
                this.zaloraPrintWayBillStatus = post_request.status;
                if (this.zaloraPrintWayBillStatus !== 'Finished') {
                    setTimeout(() => {
                        this.fetchStatus(post_request.id);
                    }, 30000);
                }else {
                    this.zaloraPrintWayBillDisabled = false;
                    this.zaloraPrintWayBillDLink = 'https://sellercenter-staging.zalora.com.ph/'+post_request["downloadLinks"][0]
                }
            },
            zaloraPrintWayBill:async function(){
                window.open(this.zaloraPrintWayBillDLink, '_blank');
            },
           
            documentEndpoint (input) {
                var params = '/documents?type=OTHCNS&'
                return this.endPoint + params + this.searchFilter + '=' + input;
            },
            filterExistingDocuments(e){
                var data = this.tabulator.getData();
                var ids = data.map(({id}) => id)
                return e.data.filter(item => !ids.includes(item.id))
            },
            async getDocument (group) {
                this.notifMessage = []
                this.documentID = group.value
                this.selectedDocument = group.selectedObject
            },
            clearDocument (){
                this.selectedDocument = ''
                this.documentID = null
            },
            formattedDocumentDisplay (result) {
                if (this.searchFilter !='id'){
                    return eval('result.'+this.searchFilter) + ' ['+result.id+']';
                }else{
                    return eval('result.'+this.searchFilter)  + ' ['+result.document_no+']';
                }
            },
            handleAddDocumentVisibleChange(addPCountDocumentConfirmationVisible){
                if (!addPCountDocumentConfirmationVisible) {
                    this.addPCountDocumentConfirmationVisible = false;
                    return;
                }
                if (this.currentDocumentTypeCode == 'OTHCNS') {
                    this.addPCount();
                }
            },
            async addPCount() {
                this.notifMessage = []
                var data = this.tabulator.getData();
                if (this.documentID) {
                    if (!(data.length == this.maximumDocumentLineNumber)) {
                        await this.tabulator.addRow(this.selectedDocument);
                        this.clearDocument()
                    } else {
                        this.documentActionNotification('Add Document', 'error')
                    }
                }
                this.addPCountDocumentConfirmationVisible = false;
            },
            addPCountCancel() {
                this.addPCountDocumentConfirmationVisible = false;
            },
            checkSiteTypeAndTargetBranch(){
                if(this.requestingSite.label !=null && this.requestingSite.label !=undefined && this.requestingSite.label != "" && secureStorage.getItem("currentSiteSiteType") != "ho" && this.currentDocumentTypeCode != 'OTHPUR'){
                    this.isRequestingSiteDisabled = true
                }
            },
            mass_delete_document_line() {
                this.selectedDocumentLineRows.forEach(function(x){
                   x.delete();
                });
                this.selectedDocumentLines = []
            },
            async showConversionCurrencyRate(){
                if(!['BARTER TOOL', 'BARTER TOOL 3P', 'LIQUIDATION'].includes((this.documentDetails || {}).order_source)){
                    if (parseInt(this.supplierDetails.currency_id)>0){
                        if (Number(this.currencyRate) > 0 && parseInt(this.supplierDetails.currency_id)!=parseInt(this.currency.key)) {
                            this.isCurrencyToPhp = false
                            this.showConversionCurrencyRateColumns()
                        } else if (Number(this.currencyRate) <= 0 && parseInt(this.supplierDetails.currency_id)!=parseInt(this.currency.key)){
                            this.isCurrencyToPhp = true
                            this.showConversionCurrencyRateColumns()
                        }else{
                            this.hideConversionColumns()
                        }
                    }else if (this.hasDefaultCurrency){
                        if (parseInt(this.currency.key) == 0){
                            this.isCurrencyToPhp = true
                            this.showConversionCurrencyRateColumns()
                        }else{
                            this.hideConversionColumns()
                        }
                    } else if(Number(this.currencyRate) > 0 && parseInt(this.currency.key) != 0 && !this.hasDefaultCurrency){
                        this.isCurrencyToPhp = false
                        this.showConversionCurrencyRateColumns()
                    } else {
                        this.hideConversionColumns()
                    }
                }
            },
            async hideConversionColumns(){
                let subtotal,cost,price,gross;
                this.isCurrencyToPhp = false
                this.showConversionRate = false
                this.tabulator.hideColumn("subtotal_php")
                subtotal = this.tabulator.getColumn("subtotal_php")
                await subtotal.updateDefinition({download:false})
                this.tabulator.hideColumn("cost_php")
                cost = this.tabulator.getColumn("cost_php")
                await cost.updateDefinition({download:false})
                this.tabulator.hideColumn("price_php")
                price = this.tabulator.getColumn("price_php")
                await price.updateDefinition({download:false})
                this.tabulator.hideColumn("total_gross_php")
                gross = this.tabulator.getColumn("total_gross_php")
                await gross.updateDefinition({download:false})
            },
            async showConversionCurrencyRateColumns(){
                let subtotal,cost,price,gross,label;
                label=this.currencyDetails.code == undefined ? 'PHP' : this.currencyDetails.code
                this.showConversionRate = true
                if (this.accountName.toLowerCase().includes('primer')) {
                subtotal = this.tabulator.getColumn("subtotal_php")
                await subtotal.updateDefinition({title: "Subtotal ("+label+")", download:true})
                this.tabulator.showColumn("subtotal_php")
                cost = this.tabulator.getColumn("cost_php")
                await cost.updateDefinition({title: "Net Cost ("+label+")", download:true})
                this.tabulator.showColumn("cost_php")
                price = this.tabulator.getColumn("price_php")
                await price.updateDefinition({title: "Unit Cost ("+label+")", download:true})
                this.tabulator.showColumn("price_php")
                gross = this.tabulator.getColumn("total_gross_php")
                await gross.updateDefinition({title: "Total Gross ("+label+")", download:true})
                this.tabulator.showColumn("total_gross_php")
                }
            },
            iconFormatter(cell){
                var product_type = cell.getRow().getData().product_type
                if (product_type == undefined) {
                    product_type = cell.getRow().getData().product_icon
                }
                var icon_code = this.icon_code
                if (!icon_code) {
                    try {
                        icon_code = JSON.parse(localStorage.getItem("businessTypeCode"))
                    } catch (error) {}
                }
                icon_code = icon_code || 'OTH'
                var image_path = "";
                switch(product_type){
                    case '':
                    image_path =  'regular.png'
                    break;
                    case 'P':
                    image_path =  'packaged.png'
                    break;
                    case 'N':
                    image_path =  'non_inventory.png'
                    break;
                    case 'S':
                    image_path =  'serial.png'
                    break;
                    case 'K':
                    image_path =  'kit.png'
                    break;
                    case 'V':
                    image_path =  'virtual_kit.png'
                    break;
                    case 'M':
                    image_path =  'matrix.png'
                    break;
                    case 'I':
                    image_path =  'matrix.png'
                    break;
                    case 'B':
                    if(icon_code == 'FNB'){
                        image_path =  'combo.png'
                    }else{
                        image_path =  'regular.png'
                    }
                    break;
                    case 'R':
                    image_path =  'recipe.png'
                    break;
                    default:
                    image_path =  'regular.png'
                    break;
                }
                
                try {
                    image_path = require('../../assets/icons/'+ icon_code + '/'+ image_path)
                } catch (error) {
                    image_path = require('../../assets/icons/OTH/regular.png')
                }
                return "<img class='table-product-icons2' src='"+ image_path +"' alt='icon'>"
                
            },
            supplierStockNumber(cell){
                if(this.currentDocumentTypeCode=='ORIPOX'){
                    var show_status = this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.enableShowingSupplierStockNumber
                    var show_status1 = (this.document_config.document_type_settings.printSettings!=undefined) ? this.document_config.document_type_settings.printSettings.showStockNoInProductList : false
                    if(show_status==true || show_status1==true){
                        var label = ''
                        var supplier_stock_no = cell.getRow().getData().supplier_stock_no
                        if (supplier_stock_no!=undefined){
                            label = supplier_stock_no
                        }else{
                            var extras = cell.getRow().getData().extras
                            try{
                                if(extras["supplier_stock_no"] == undefined){
                                    label = ""
                                }else {
                                    label = extras["supplier_stock_no"]
                                }
                            }catch(e){
                                label = ""
                            }
                            cell.getRow().update({"supplier_stock_no":label})
                        }
                        return label
                    }
                }
            },
            sizeFormatter(cell){
                if(this.currentDocumentTypeCode=='ORIPOX'){
                    var show_status = (this.document_config.document_type_settings.printSettings!=undefined) ? this.document_config.document_type_settings.printSettings.showDesignAndSizeInProductList : false
                    if(show_status==true){
                        var label = ''
                        var size = cell.getRow().getData().size
                        if (size==null){
                            label = ''
                            cell.getRow().update({"size":label})
                        }else{
                            label = size
                        }
                        return label
                    }
                }else{
                    label = ''
                    size = cell.getRow().getData().size
                    if (size==null){
                        label = ''
                        cell.getRow().update({"size":label})
                    }else{
                        label = size
                    }
                    return label
                }
            },
            colorFormatter(cell){
                if(this.currentDocumentTypeCode=='ORIPOX'){
                    var show_status = (this.document_config.document_type_settings.printSettings!=undefined) ? this.document_config.document_type_settings.printSettings.showColorInProductList : false
                    if(show_status==true){
                        var label = ''
                        var color = cell.getRow().getData().color
                        if (color==null){
                            label = ''
                            cell.getRow().update({"color":label})
                        }else{
                            label = color
                        }
                        return label
                    }
                }else{
                    label = ''
                    color = cell.getRow().getData().color
                    if (color==null){
                        label = ''
                        cell.getRow().update({"color":label})
                    }else{
                        label = color
                    }
                    return label
                }
            },
            designFormatter(cell){
                if(this.currentDocumentTypeCode=='ORIPOX'){
                    var show_status = (this.document_config.document_type_settings.printSettings!=undefined) ? this.document_config.document_type_settings.printSettings.showDesignAndSizeInProductList : false
                    if(show_status==true){
                        var label = ''
                        var design = cell.getRow().getData().design
                        if (design==null){
                            label = ''
                            cell.getRow().update({"design":label})
                        }else{
                            label = design
                        }
                        return label
                    }
                }
            },
            payInitialDepositValidation(){
                this.initialDepositErrors = [];
                this.initialDepositErrors.push(ValidateField.required('Amount', this.initialDeposit.amount));
                this.initialDepositErrors.push(ValidateField.required('Reference', this.initialDeposit.reference));
                this.initialDepositErrors = this._.compact(this.initialDepositErrors);
                return this.initialDepositErrors.length;
            },
            async payInitialDeposit(documentNumber){
                if(!this.payInitialDepositValidation()){
                    var InitialDepositPayload = {
                        document_payment:{
                            amount:this.initialDeposit.amount,
                            reference:this.initialDeposit.reference,
                            payment_mode:"Initial Deposit",
                            status:"A",
                            payment_date: moment(new Date()),
                            document_id:documentNumber
                        }
                    }
                    var post_request = await HTTPRequest.postRequest(this.endPoint + 'document_payments', null, InitialDepositPayload)
                    if (post_request["error"] == undefined) {
                        this.forPaymentIsProcessed = true;
                        this.post();
                    } else {
                        this.notifMessage = post_request['error'].split(',');
                        this.documentActionNotification('Inital Deposit', 'error')
                    }
                }
            },
            async exportCSV(){
                if(this.currentDocumentTypeCode == 'ORIPOX'){
                    let tabulatorInstance = this.$refs.tabulator.getInstance();
                    var calculation = tabulatorInstance.getCalcResults();
                    var documentType = this.currentDocumentTypeName || ''
                    var currentSiteName = secureStorage.getItem("defaultSiteName") || '';
                    var userCode = secureStorage.getItem("userCode") || '';
                    var createdBy = this.createdBy || '';
                    var postedBy = this.postedBy || '';
                    var supplier = this.supplier.label || ''
                    var remark = this.remark || ''
                    var purpose = this.purpose.label || ''

                    var documentDate = this.documentDate.format('D-MMM-YYYY') || ''
                    var targetDate = this.targetDate.format('D-MMM-YYYY') || ''
                    var cancellationDate = this.cancellationDate.format('D-MMM-YYYY') || ''

                    var currentDocumentTypeFriendlyCode = this.currentDocumentTypeFriendlyCode || ''
                    var documentStatus = this.documentStatus || ''
                    var documentNumber = this.documentNo || ''

                    var reference = this.reference || ''
                    var currencyLabel = this.currency.label || '';
                    var currencyRate = this.documentDetails.currency_rate;

                    var printDate = moment().format('lll') || '';
                    var postDate = this.postDate || ''
                    var priceInclusion = this.documentDetails.reference_8 || ''
                    var comment1 = this.documentDetails.reference_9 || ''
                    var comment2 = this.documentDetails.reference_10 || ''
                    var initial_deposit = 0
                    var balance = 0
                    let currencyKey = component_x.currency.key;
                    var total_qty = 0
                    var total_cost = 0
                    var sub_total = 0
                    var vendor_item_no = this.tabulator.getColumn("vendor_item_no")
                    await vendor_item_no.updateDefinition({download: true})
                    if (currencyKey>0 && this.showConversionRate){
                        var subtotal = this.tabulator.getColumn("subtotal")
                        await subtotal.updateDefinition({download:false})
                        var subtotal_php = this.tabulator.getColumn("subtotal_php")
                        await subtotal_php.updateDefinition({downloadTitle: "Subtotal", download:true})
                        var price = this.tabulator.getColumn("price")
                        await price.updateDefinition({download:false})
                        var cost_php = this.tabulator.getColumn("price_php")
                        await cost_php.updateDefinition({downloadTitle: "Cost", download:true})
                        total_qty = (calculation.bottom.quantity).toString()
                        total_cost = (calculation.bottom.price_php).toString()
                        sub_total = (calculation.bottom.subtotal_php).toString()
                    }else {
                        total_qty = (calculation.bottom.quantity).toString()
                        total_cost = (calculation.bottom.price).toString()
                        sub_total = (calculation.bottom.subtotal).toString()
                    }
                    if(this.document_config.document_type_settings.printSettings != undefined){
                        if(this.currentDocumentTypeCode == 'ORIPOX' && this.document_config.document_type_settings.printSettings.showStockNoInProductList!=undefined && this.document_config.document_type_settings.printSettings.showStockNoInProductList==true){
                            var supplier_stock_no = this.tabulator.getColumn("supplier_stock_no")
                            await supplier_stock_no.updateDefinition({download:true})
                            if (this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.enableShowingSupplierStockNumber!=undefined && this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.enableShowingSupplierStockNumber==true) {
                                this.tabulator.showColumn("supplier_stock_no")
                            }
                        }
                        if(this.document_config.document_type_settings.printSettings.showSerialNoInProductList != undefined && this.document_config.document_type_settings.printSettings.showSerialNoInProductList == true){
                            var supplier_stock_no = this.tabulator.getColumn("document_line_serials_text")
                            await supplier_stock_no.updateDefinition({download:true})
                        }else{
                            var document_line_serials_text = this.tabulator.getColumn("document_line_serials_text")
                            await document_line_serials_text.updateDefinition({download:false})
                        }
                        if(this.document_config.document_type_settings.printSettings.showDesignAndSizeInProductList != undefined && this.document_config.document_type_settings.printSettings.showDesignAndSizeInProductList == true){
                            var design = this.tabulator.getColumn("design")
                            await design.updateDefinition({download:true})
                            var size = this.tabulator.getColumn("size")
                            await size.updateDefinition({download:true})
                        }
                        if(component_x.document_config.document_type_settings.printSettings.enableShowingInitialDepositField!=undefined && component_x.document_config.document_type_settings.printSettings.enableShowingInitialDepositField==true){
                            await this.showDocumentPayment("initialDeposit")
                            initial_deposit = Number(this.documentPaymentsList.reduce(function(prev, cur) { return Number(prev) + Number(cur.amount); }, 0)) || Number(this.documentDetails.reference_7) || 0
                        }
                        if(this.showRefCode!=undefined && this.showRefCode==true){
                            var ref_code = this.tabulator.getColumn("ref_code")
                            await ref_code.updateDefinition({download: true})
                        }

                    }
                }
                var fileFormatter = function(columns, data, options, setFileContents){
                    var self = this,titles = [],fields = [],delimiter = options && options.delimiter ? options.delimiter : ",",
                        fileContents=[],output,main_header = [],second_main_header = [],supplier_header = [],target_date_header = [],
                        cancellation_date_header = [],reference_header = [],currency_header=[],currency_rate_header=[],status_header = [],purpose_header = [],remark_header = [],price_inclusion_and_initial_deposit_header = [],
                        comment1_and_balance = [],comment2_and_total = [],total_count = [],total_qty_row = [],total_cost_row = [],subtotal_row = [],
                        space_line = [],noted_by_row = [],verified_by_row = [],approved_by_row = [],printed_by_row = [],print_date_row = [],
                        post_date_row = [],created_by_row = [],posted_by_row = [];
                    //build column headers
                    function parseTitles() {
                        columns.forEach(function (column) {
                            titles.push(String(column.title).split('"').join('""'));
                            fields.push(column.field);
                        });
                        if(options.nested) {
                            titles.push(String(nestedParentTitle));
                        }
                    }
                    parseTitles();
                    function parseMainAndRemarkHeader(i){
                        if(i==0){
                            main_header.push(currentSiteName)
                            purpose_header.push("Purpose:")
                            remark_header.push("Remark:")
                            noted_by_row.push("Noted By:")
                            verified_by_row.push("Verified By:")
                            approved_by_row.push("Approved By:")
                        }else if(i==1){
                            purpose_header.push(purpose)
                            remark_header.push(remark)
                        }else if(i == titles.length-1){
                            main_header.push(documentType)
                        }else{
                            main_header.push("")
                            remark_header.push("")
                        }
                    }
                    function parseSecondMainHeader(i) {
                        if(i == titles.length-1){
                            second_main_header.push("# "+String(documentNumber))
                        }else{
                            second_main_header.push("")
                        }
                    }
                    function parseSupplierAndCustomDetailsHeader(i) {
                        if(i==0){
                            supplier_header.push("Supplier:")
                            if(component_x.document_config.document_type_settings.printSettings.enableShowingPriceInclusionField!=undefined && component_x.document_config.document_type_settings.printSettings.enableShowingPriceInclusionField==true){
                                price_inclusion_and_initial_deposit_header.push("Price Inclusion:")
                            }else {
                                price_inclusion_and_initial_deposit_header.push("")
                            }
                            if(component_x.document_config.document_type_settings.printSettings.enableShowingComment1Field!=undefined && component_x.document_config.document_type_settings.printSettings.enableShowingComment1Field==true){
                                comment1_and_balance.push("Comment 1:")
                            }else{
                                comment1_and_balance.push("")
                            }
                            if(component_x.document_config.document_type_settings.printSettings.enableShowingComment2Field!=undefined && component_x.document_config.document_type_settings.printSettings.enableShowingComment2Field==true){
                                comment2_and_total.push("Comment 2:")
                            }else{
                                comment2_and_total.push("")
                            }
                        }else if(i == 1){
                            supplier_header.push(supplier)
                            if(component_x.document_config.document_type_settings.printSettings.enableShowingPriceInclusionField!=undefined && component_x.document_config.document_type_settings.printSettings.enableShowingPriceInclusionField==true){
                                price_inclusion_and_initial_deposit_header.push(priceInclusion)
                            }else {
                                price_inclusion_and_initial_deposit_header.push("")
                            }
                            if(component_x.document_config.document_type_settings.printSettings.enableShowingComment1Field!=undefined && component_x.document_config.document_type_settings.printSettings.enableShowingComment1Field==true){
                                comment1_and_balance.push(comment1)
                            }else{
                                comment1_and_balance.push("")
                            }
                            if(component_x.document_config.document_type_settings.printSettings.enableShowingComment2Field!=undefined && component_x.document_config.document_type_settings.printSettings.enableShowingComment2Field==true){
                                comment2_and_total.push(comment2)
                            }else{
                                comment2_and_total.push("")
                            }
                        }else if(i == titles.length-2){
                            supplier_header.push(currentDocumentTypeFriendlyCode+" Date:")
                            if(component_x.document_config.document_type_settings.printSettings.enableShowingInitialDepositField!=undefined && component_x.document_config.document_type_settings.printSettings.enableShowingInitialDepositField==true){
                                price_inclusion_and_initial_deposit_header.push("Initial Deposit:")
                            }else {
                                price_inclusion_and_initial_deposit_header.push("")
                            }
                            if(component_x.document_config.document_type_settings.printSettings.enableShowingBalanceField!=undefined && component_x.document_config.document_type_settings.printSettings.enableShowingBalanceField==true){
                                comment1_and_balance.push("Balance:")
                            }else {
                                comment1_and_balance.push("")
                            }
                            comment2_and_total.push("Total:")
                        }else if(i == titles.length-1){
                            supplier_header.push(documentDate)
                            if(component_x.document_config.document_type_settings.printSettings.enableShowingInitialDepositField!=undefined && component_x.document_config.document_type_settings.printSettings.enableShowingInitialDepositField==true){
                                price_inclusion_and_initial_deposit_header.push(initial_deposit.toFixed(2))
                            }else {
                                price_inclusion_and_initial_deposit_header.push("")
                            }
                            if(component_x.document_config.document_type_settings.printSettings.enableShowingBalanceField!=undefined && component_x.document_config.document_type_settings.printSettings.enableShowingBalanceField==true){
                                balance = Number(calculation.bottom.subtotal) - Number(initial_deposit)
                                comment1_and_balance.push(balance)
                            }else{
                                comment1_and_balance.push("")
                            }
                            comment2_and_total.push(calculation.bottom.subtotal.toFixed(2))
                        }else{
                            supplier_header.push("")
                            price_inclusion_and_initial_deposit_header.push("")
                            comment1_and_balance.push("")
                            comment2_and_total.push("")
                        }
                    }
                    function parseOtherDetailsInHeader(i) {
                        if(i == titles.length-1){
                            target_date_header.push(targetDate)
                            cancellation_date_header.push(cancellationDate)
                            reference_header.push(reference)
                            currency_header.push(currencyLabel)
                            currency_rate_header.push(currencyRate)
                            status_header.push(documentStatus)
                        }else if(i == titles.length-2){
                            target_date_header.push("Target Date:")
                            cancellation_date_header.push("Cancellation Date:")
                            reference_header.push("Reference:")
                            currency_header.push("Currency:")
                            currency_rate_header.push("Currency Rate:")
                            status_header.push("Status:")
                        }else{
                            target_date_header.push("")
                            cancellation_date_header.push("")
                            reference_header.push("")
                            currency_header.push("")
                            currency_rate_header.push("")
                            status_header.push("")
                        }
                    }
                    function parseTotalCountRow(i) {
                        if(i==0){
                            total_qty_row.push("Total Quantity:")
                            total_cost_row.push("Total Cost:")
                            subtotal_row.push("Subtotal:")
                            printed_by_row.push("Printed By:")
                            created_by_row.push("Created By:")
                            posted_by_row.push("Posted By:")
                            print_date_row.push("Print Date:")
                            post_date_row.push("Post Date:")
                        }else if(i == 1){
                            total_qty_row.push(total_qty)
                            total_cost_row.push(total_cost)
                            subtotal_row.push(sub_total)
                            printed_by_row.push(userCode)
                            print_date_row.push('"'+String(printDate)+'"')
                            post_date_row.push('"'+String(postDate)+'"')
                            created_by_row.push(createdBy)
                            posted_by_row.push(postedBy)
                        }else{
                            total_qty_row.push("")
                            total_cost_row.push("")
                            subtotal_row.push("")
                            printed_by_row.push("")
                            print_date_row.push("")
                            post_date_row.push("")
                            created_by_row.push("")
                            posted_by_row.push("")
                        }
                    }
                    function parseMainHeader(){
                        for (var i = 0; i < titles.length; i++) {
                            parseMainAndRemarkHeader(i)
                            parseSecondMainHeader(i)
                            parseSupplierAndCustomDetailsHeader(i)
                            parseOtherDetailsInHeader(i)
                            parseTotalCountRow(i)
                            if(titles[i] == "Cost"){
                                total_count.push(total_cost)
                            }else if(titles[i] == "Quantity"){
                                total_count.push(total_qty)
                            }else if(titles[i] == "Subtotal"){
                                total_count.push(sub_total)
                            } else {
                                total_count.push("")
                            }
                            space_line.push("")
                        }
                    }

                    parseMainHeader()
                    fileContents.push(main_header);
                    fileContents.push(second_main_header);
                    fileContents.push(supplier_header);
                    fileContents.push(target_date_header);
                    fileContents.push(cancellation_date_header);
                    fileContents.push(reference_header);
                    fileContents.push(currency_header);
                    fileContents.push(currency_rate_header);
                    fileContents.push(status_header);
                    fileContents.push(purpose_header);
                    fileContents.push(remark_header);
                    fileContents.push(price_inclusion_and_initial_deposit_header);
                    fileContents.push(comment1_and_balance);
                    fileContents.push(comment2_and_total);
                    fileContents.push(space_line);
                    fileContents.push(titles);
                    function parseRows(data,parentValue="") {
                        //generate each row of the table
                        data.forEach(function (row) {
                            var rowData = [];

                            fields.forEach(function (field) {
                                var value = self.getFieldValue(field, row);

                                switch (value === "undefined" ? "undefined" : value) {
                                    case "undefined":
                                    case "null":
                                        value = "";
                                        break;

                                    default:
                                        value = value;
                                }

                                //escape quotation marks
                                rowData.push('"' + String(value).split('"').join('""') + '"');
                            });

                            if(options.nested) {
                                rowData.push('"' + String(parentValue).split('"').join('""') + '"');
                            }

                            fileContents.push(rowData.join(delimiter));

                            if(options.nested) {
                                if(row._children) {
                                    parseRows(row._children, self.getFieldValue(nestedParentField, row));
                                }
                            }
                        });
                    }
                    parseRows(data);
                    fileContents.push(total_count);
                    fileContents.push(space_line);
                    fileContents.push(total_qty_row);
                    fileContents.push(total_cost_row);
                    fileContents.push(subtotal_row);
                    fileContents.push(space_line);
                    fileContents.push(noted_by_row);
                    fileContents.push(verified_by_row);
                    fileContents.push(approved_by_row);
                    fileContents.push(printed_by_row);
                    fileContents.push(print_date_row);
                    fileContents.push(post_date_row);
                    fileContents.push(created_by_row);
                    fileContents.push(posted_by_row);
                    output = fileContents.join("\n");

                    if (options.bom) {
                        output = "\uFEFF" + output;
                    }

                    setFileContents(output, "text/csv");
                }
                await HTTPRequest.postRequest(component_x.endPoint + 'users/create_user_act', null, {controller:"/document_form",category:this.currentDocumentTypeCode,system_module:this.currentDocumentTypeName,actions:"Export CSV"})
                let tabulatorInstance = this.$refs.tabulator.getInstance();
                tabulatorInstance.download(fileFormatter, this.friendlyCodeAndDocumentNo+".csv");
            },
            async onEnterScanner(){
                if(this.document_config != null && this.document_config != undefined){
                    if(this.document_config.document_type_settings.editorBehavior.radio == 'P'){
                        // Read the value actually typed/scanned into the autocomplete input
                        // instead of trusting filterExistingProductData[0]. The scanner's Enter
                        // can fire before the latest remote search resolves, so [0] may still be
                        // the PREVIOUS barcode's result - which is why every failed scan kept
                        // reporting the same product (e.g. QAQA1000237711).
                        var scannedValue = '';
                        try {
                            var inputEl = this.$refs.autocomplete && this.$refs.autocomplete.$el
                                ? this.$refs.autocomplete.$el.querySelector('input')
                                : null;
                            scannedValue = inputEl ? String(inputEl.value).trim() : '';
                        } catch (err) {
                            scannedValue = '';
                        }

                        // Match the scanned value against the current results using the active
                        // search field (barcode / stock_no / reference_code / name). Fall back to
                        // [0] only when we could not read the scanned value at all.
                        var matchedProduct = null;
                        if (scannedValue && Array.isArray(this.filterExistingProductData)) {
                            var needle = scannedValue.toLowerCase();
                            var field = this.searchFilter;
                            matchedProduct = this.filterExistingProductData.find(function (p) {
                                if (!p) return false;
                                var fieldVal = (field != null && p[field] != null) ? String(p[field]).toLowerCase() : null;
                                if (fieldVal === needle) return true;
                                // Also try common barcode-like fields so an exact scan still matches
                                // even if the active filter field differs.
                                return ['barcode', 'alternate_barcode', 'stock_no', 'reference_code']
                                    .some(function (f) {
                                        return p[f] != null && String(p[f]).toLowerCase() === needle;
                                    });
                            }) || null;
                        }

                        if (matchedProduct == null && !scannedValue && this.filterExistingProductData.length > 0) {
                            // Could not read the input value; preserve prior behavior.
                            matchedProduct = this.filterExistingProductData[0];
                        }

                        if (matchedProduct != null){
                            var group = {selectedObject: matchedProduct}
                            await this.getProduct(group)
                            setTimeout(async function() {
                                await this.addProduct(1)
                                this.filterExistingProductData = []
                            }.bind(this), 300)
                        }else {
                            // Clear stale results so the next scan can't reuse them.
                            this.filterExistingProductData = []
                            this.$notification['error']({
                                message: "barcode not found",
                                description: scannedValue ? ('No exact match for "' + scannedValue + '"') : "Error",
                                style: getNotificationStyle('error')
                            });
                        }
                    }
                }
            },
            saveAllocationValidation(index){
                this.siteAllocationErrors = [];
                this.siteAllocationErrors.push(ValidateField.greaterThanZero('Quantity', this.drawerCurrentSiteAllocation[index].temp_quantity));
                this.siteAllocationErrors.push(ValidateField.required('Quantity', this.drawerCurrentSiteAllocation[index].temp_quantity));
                this.siteAllocationErrors = this._.compact(this.siteAllocationErrors);
                return this.siteAllocationErrors.length;
            },
            async saveAllocation(index){
                if(!this.saveAllocationValidation(index)){
                    var total_site_quantity = this.drawerCurrentSiteAllocation.reduce((a, {quantity}) => a + parseInt(quantity), 0);
                    if (((Number(total_site_quantity)+Number(this.drawerCurrentSiteAllocation[index].temp_quantity))-Number(this.drawerCurrentSiteAllocation[index].quantity)) > this.selectedSiteAllocationProduct.quantity){
                        this.drawerCurrentSiteAllocation[index].quantity = this.selectedSiteAllocationProduct.quantity
                        this.isEditAllocation=false
                        this.siteAllocationErrors.push('You have exceeded the maximum allowed quantity: '+ this.selectedSiteAllocationProduct.quantity)
                    }else{
                        this.isEditAllocation=false
                        this.drawerCurrentSiteAllocation[index].quantity = this.drawerCurrentSiteAllocation[index].temp_quantity
                        total_site_quantity = this.drawerCurrentSiteAllocation.reduce((a, {quantity}) => a + parseInt(quantity), 0);
                    }
                    this.siteAllocationRemainingQuantity = Number(this.selectedSiteAllocationProduct.quantity) - Number(total_site_quantity)
                }
            },
            editAllocation(index){
                this.isEditAllocation=true
                this.drawerCurrentSiteAllocation[index].temp_quantity = this.drawerCurrentSiteAllocation[index].quantity
                this.isEditAllocationIndex = index
            },
            beforeUploadWithAllocation(file) {
                const reader = new FileReader()
                reader.onload = e => {
                    this.massAddWithAllocationProductErrors = []
                    var text = e.target.result;
                    var skulist = [];
                    var qtylist = [];
                    var workbook = XLSX.read(text, {type: 'array'})
                    let sheetName = workbook.SheetNames[0]
                    let worksheet = workbook.Sheets[sheetName]
                    var lines = XLSX.utils.sheet_to_json(worksheet,{defval: '', blankrows: true })

                    if(lines.length - 1 > this.maxLines)
                        this.massAddProductErrors.push('Total lines exceeded.  Please only upload up to ' + this.maxLines + ' lines.')

                    for(var i = 0; i < lines.length; i++) {
                        let filteredObj = this.objectWithoutProperties(lines[i],['Line No','Stock No','Description','Barcode','Unit','Quantity','Cost','Subtotal','Serial No'])
                        let totalqtyAllocation = Object.keys(filteredObj).reduce((sum,key)=>sum+parseFloat(filteredObj[key]||0),0)
                        if (lines[i]["Quantity"] < totalqtyAllocation)
                            this.massAddWithAllocationProductErrors.push('Total allocated quantity:'+`${totalqtyAllocation}`+' > Maximum Quantity:'+`${lines[i]["Quantity"]}`+' for barcode number: '+`${lines[i]["Barcode"]}.`)

                        if(typeof lines[i]["Quantity"] === 'string')
                            qtylist.push(parseInt(lines[i]["Quantity"]))
                        else
                            qtylist.push(parseInt(lines[i]["Quantity"]) || 0)

                        skulist.push(lines[i]["Barcode"])
                    }
                    // Get duplicate sku's/barcode
                    const findDuplicates = (skulist) => {
                        let sorted_arr = skulist.slice().sort();
                        let results = [];
                        for (let i = 0; i < sorted_arr.length - 1; i++) {
                            if (sorted_arr[i + 1] == sorted_arr[i]) {
                                results.push(sorted_arr[i]);
                            }
                        }
                        return results;
                    }
                    // Result duplicate sku's/barcode -> download list
                    if(findDuplicates(skulist).length > 0) {
                        this.massAddWithAllocationProductErrors.push('With duplicate Barcodes');
                    }
                    // Get 0 / - quantity
                    const zQty = qtylist.filter(qty => {
                        if(isNaN(qty))
                            return true
                        else
                            return qty < 1
                    });
                    if(zQty.length > 0){
                        this.massAddWithAllocationProductErrors.push('All quantities must be POSITIVE integers and no blanks/characters.');
                    }
                    // Get blank skus
                    const bSku = skulist.filter(sku => sku.length < 1);
                    // Result blank skus
                    if(bSku.length > 0)
                        this.massAddWithAllocationProductErrors.push('File has blank lines that generate rows with no data but with a comma.');

                    // Proceed validating if barcodes are valid
                    if(this.massAddWithAllocationProductErrors.length < 1){
                        this.spinning = true;
                        if(this.validationdocutypes.includes(this.currentDocumentTypeCode) && this.filterBySupp)
                            this.getSuppItems(skulist)
                        else
                            this.spinning = false;

                        this.fileWithAllocationList = [...this.fileWithAllocationList, file];
                    }
                    this.massAddWithAllocationProductErrors = this._.compact(this.massAddWithAllocationProductErrors);
                }
                reader.readAsArrayBuffer(file);
                this.spinning = false;
                return false;
            },
            async beforeUploadWithHeader(file) {
                this.fileList = [];
                const reader = new FileReader();
                reader.onload = async e => {
                    this.importDocumentHeaderWithLineErrors = []
                    var document_details = {};
                    var lines_details = [];
                    var skulist = [];
                    var pricelist = [];
                    var qtylist = [];
                    
                    var text = e.target.result;
                    var lines = text.split(/[\r\n]+/g); // tolerate both Windows and Unix linebreaks

                    if(lines.length - 1 > this.maxLines)
                        this.importDocumentHeaderWithLineErrors.push('Total lines exceeded.  Please only upload up to ' + this.maxLines + ' lines.')

                    for(var i = 0; i < lines.length; i++) {
                        if (i == 0){
                            var importWithHeader = []
                            if(this.currentDocumentTypeCode === "OTHSRQ"){
                                importWithHeader = ["customer_code","cas_no","code_and_document_no","brand_code","order_type","country_of_origin","fiscal_year","year_season","target_date","oc_reference"]
                            }else if(this.currentDocumentTypeCode === "ORISOX"){
                                importWithHeader = ["Site Code","Customer Code","Document Date","Target Date","Country Code","Reference","Total Amount"]
                            }else if(this.currentDocumentTypeCode === "ORIPOX"){
                                importWithHeader = ["Site Code","Vendor Code","Document Date","Target Date","Country Code","Reference","Total Amount"]
                            }

                            for(var ii = 0; ii < importWithHeader.length; ii++) {
                                if(lines[i].split(',')[ii] != importWithHeader[ii]){
                                    this.importDocumentHeaderWithLineErrors.push('Column names are incorrect and invalid.');
                                }
                            }

                            if(this.hasDefaultCurrency){
                                this.currencyId = this.defaultCurrencyDetails.key
                                this.currencyRate = this.defaultCurrencyRate
                            }

                            //get country id using code
                            var country_code = (this.currentDocumentTypeCode === "OTHSRQ") ? lines[1].split(',')[5] : lines[1].split(',')[4]
                            var country_details = await HTTPRequest.getRequest(this.endPoint + '/countries?code='+country_code, null);
                            if(country_details['data'].length > 0){
                                this.countryOfOrigin.key = country_details['data'][0]['id']

                            } else {
                                this.importDocumentHeaderWithLineErrors.push('Country with code ' + country_code + ' not found.');
                            }

                            if (["OTHSRQ","ORISOX"].includes(this.currentDocumentTypeCode)){
                                //Get b2b id using code
                                var b2b_code = (this.currentDocumentTypeCode === "OTHSRQ") ? lines[1].split(',')[0] : lines[1].split(',')[1]
                                let b2b_details
                                if (b2b_code && (this.b2bCustomer == undefined || this.b2bCustomer == null || this.b2bCustomer <= 0 || this.b2bCustomer == "")) {
                                    //when customer input from file
                                    b2b_details = await HTTPRequest.getRequest(this.endPoint + '/b2b_customers?code='+b2b_code, null);
                                } else if (this.b2bCustomer) {
                                    //when customer input from ui
                                    b2b_details = await HTTPRequest.getRequest(this.endPoint + '/b2b_customers/' + this.b2bCustomer, null);
                                }
                                //var b2b_details = await HTTPRequest.getRequest(this.endPoint + '/b2b_customers?code='+b2b_code, null);
                                if(b2b_code && (this.b2bCustomer == undefined || this.b2bCustomer == null || this.b2bCustomer <= 0 || this.b2bCustomer == "") && b2b_details['data'].length > 0){
                                    this.b2bCustomer = b2b_details['data'][0]['id']
                                    this.party_tax_type = b2b_details['data'][0]['vat_type']
                                    this.paymentTerm.key = b2b_details['data'][0]['payment_term']
                                    this.paymentTerm.label = b2b_details['data'][0]['payment_term_name']
                                    this.wTax.key = b2b_details['data'][0]['wtax_code']
                                    this.wTax.label = b2b_details['data'][0]['wtax_code']
                                    var arr = {
                                        key:b2b_details['data'][0]['payment_term'],
                                        label:b2b_details['data'][0]['payment_term_name']
                                    }
                                    var paymentTerm = arr
                                    Object.assign(this, {
                                        paymentTerm,
                                        paymentTerms: [],
                                        fetching: false,
                                    })
                                } else if (this.b2bCustomer && b2b_details) {
                                    this.party_tax_type = b2b_details['vat_type']
                                    this.paymentTerm.key = b2b_details['payment_term']
                                    this.paymentTerm.label = b2b_details['payment_term_name']
                                    this.wTax.key = b2b_details['wtax_code']
                                    this.wTax.label = b2b_details['wtax_code']
                                    var arr = {
                                        key:b2b_details['payment_term'],
                                        label:b2b_details['payment_term_name']
                                    }
                                    var paymentTerm = arr
                                    Object.assign(this, {
                                        paymentTerm,
                                        paymentTerms: [],
                                        fetching: false,
                                    })
                                }else{
                                    this.importDocumentHeaderWithLineErrors.push('B2B customer with code '+b2b_code+' not found.');
                                }
                            }
                            if (["OTHSRQ"].includes(this.currentDocumentTypeCode)){
                                //get brand id using code
                                var brand_details = await HTTPRequest.getRequest(this.endPoint + '/brands?code='+lines[1].split(',')[3], null);
                                if(brand_details['data'].length > 0){
                                    this.brand.key = brand_details['data'][0]['id']
                                }else{
                                    this.importDocumentHeaderWithLineErrors.push('Brand with code '+lines[1].split(',')[3]+' not found.');
                                }
                            }

                            var target_date = (this.currentDocumentTypeCode === "OTHSRQ") ? lines[1].split(',')[8] : lines[1].split(',')[3]
                            //target date
                            this.targetDate = moment(new Date(target_date))

                            if (["OTHSRQ"].includes(this.currentDocumentTypeCode)){
                                //order type
                                this.orderType = lines[1].split(',')[4]

                                //fiscal year
                                this.fiscalYear = lines[1].split(',')[6]
                                if ((!this.fiscalYear || this.fiscalYear.trim() === '') && this.accountName.toLowerCase().includes('piml')) {
                                    this.importDocumentHeaderWithLineErrors.push('Fiscal Year cannot be blank.');
                                }
                                //year season
                                this.yearSeason = lines[1].split(',')[7]

                                //OC Reference
                                this.ocReferenceNo = lines[1].split(',')[9]
                            }

                            //document date
                            if (["ORIPOX","ORISOX"].includes(this.currentDocumentTypeCode)){
                                this.documentDate = lines[1].split(',')[2]
                            }

                            //Reference
                            if (["ORIPOX","ORISOX"].includes(this.currentDocumentTypeCode)){
                                this.reference = lines[1].split(',')[5]
                            }

                            //total amount
                            if (["ORIPOX","ORISOX"].includes(this.currentDocumentTypeCode)){
                                this.netAmount = lines[1].split(',')[6]
                            }

                            if (["ORIPOX"].includes(this.currentDocumentTypeCode)){
                                var supplier_details = await HTTPRequest.getRequest(this.endPoint + '/suppliers?code='+lines[1].split(',')[1], null);
                                if(supplier_details['data'].length > 0){
                                    this.supplier = {key: supplier_details['data'][0]['id'], label: supplier_details['data'][0]['name']}
                                }else{
                                    this.importDocumentHeaderWithLineErrors.push('Supplier with code '+lines[1].split(',')[1]+' not found.');
                                }
                            }

                            if (["ORIPOX","ORISOX"].includes(this.currentDocumentTypeCode)){
                                var site_details = await HTTPRequest.getRequest(this.endPoint + '/sites?code='+lines[1].split(',')[0], null);
                                if(site_details['data'].length > 0){
                                    if (["ORIPOX"].includes(this.currentDocumentTypeCode)){
                                        this.requestingSite = {key: site_details['data'][0]['id'], label: site_details['data'][0]['name']}
                                    }else {
                                        this.distributionSite = {key: site_details['data'][0]['id'], label: site_details['data'][0]['name']} 
                                    }
                                }else{
                                    this.importDocumentHeaderWithLineErrors.push('Site with code '+lines[1].split(',')[0]+' not found.');
                                }
                            }
                        }

                        if( i == 2 && (lines[i].split(',')[0] != 'barcode' || lines[i].split(',')[1] != 'quantity' || lines[i].split(',')[2] != 'price') && this.currentDocumentTypeCode === "ORIPOX" )  
                              this.importDocumentHeaderWithLineErrors.push('Column names are incorrect and invalid.');
                        if (i==1){
                            document_details = {customer_code:lines[i].split(',')[0],cas_no:lines[i].split(',')[1],code_and_document_no:lines[i].split(',')[2]}
                        }
                        if( i > 2){
                            let splitLine = lines[i].split(',');

                            if (splitLine[0].trim() !== '' ) {
                                if (splitLine[0] != 'barcode')
                                skulist.push(splitLine[0]);  // Add valid barcode
                                if (splitLine[1] != 'quantity')
                                qtylist.push(splitLine[1]);   // Add valid quantity
                                if (splitLine[2] != 'price')
                                pricelist.push(splitLine[2]); // Add valid price

                                this.csvData += splitLine[0] + ',' + parseInt(splitLine[1]) + ',' + splitLine[2] || 0;
                                if (i < lines.length) this.csvData += '\n';
                            }

                            // skulist.push(lines[i].split(',')[0])
                            // qtylist.push(lines[i].split(',')[1])
                            // pricelist.push(lines[i].split(',')[2])
                            // this.csvData += lines[i].split(',')[0] +','+ parseInt(lines[i].split(',')[1])+ ',' + lines[i].split(',')[2] || 0;
                            // if(i < lines.length)
                            //     this.csvData += '\n'

                        }
                    }
                    // Get duplicate sku's/barcode
                    const findDuplicates = (skulist) => {
                        let sorted_arr = skulist.slice().sort();
                        let results = [];
                        for (let i = 0; i < sorted_arr.length - 1; i++) {
                            if (sorted_arr[i + 1] == sorted_arr[i]) {
                                results.push(sorted_arr[i]);
                            }
                        }
                        return results;
                    }

                    // Result duplicate sku's/barcode -> download list
                    if(findDuplicates(skulist).length > 0) {
                        this.importDocumentHeaderWithLineErrors.push('With duplicate Barcodes');
                    }
                    // Get 0 / - quantity
                    const zQty = qtylist.filter(qty => {
                        if(isNaN(qty))
                            return true
                        else
                            return qty < 1
                    });
                    if(zQty.length > 0){
                        this.importDocumentHeaderWithLineErrors.push('All quantities must be POSITIVE integers and no blanks/characters.');
                    }
                    // Get blank skus
                    const bSku = skulist.filter(sku => sku.length < 1);
                    // Result blank skus
                    if(bSku.length > 0)
                        this.importDocumentHeaderWithLineErrors.push('File has blank lines that generate rows with no data but with a comma.');

                    // Proceed validating if barcodes are valid
                    if(this.importDocumentHeaderWithLineErrors.length < 1){
                        this.spinning = true;
                        if(this.validationdocutypes.includes(this.currentDocumentTypeCode) && this.filterBySupp)
                            this.getSuppItems(skulist)
                        else
                            this.spinning = false;

                        this.fileWithAllocationList = [...this.fileWithAllocationList, file];
                    }
                    this.importDocumentHeaderWithLineErrors = this._.compact(this.importDocumentHeaderWithLineErrors);

                    this.reference = document_details.code_and_document_no
                    this.reference1 = document_details.cas_no
                    if (this.importDocumentHeaderWithLineErrors.length == 0 && this.importDocumentHeaderWithLineErrors.length == 0) {
                        this.fileList = [...this.fileList, file];
                    }
                }
                reader.readAsText(file);
                this.spinning = false;
                return false;
            },
            objectWithoutProperties(obj, keys){
                var target = {};
                for (var i in obj) {
                    if (keys.indexOf(i) >= 0) continue;
                    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
                    target[i] = obj[i];
                }
                return target;
            },
            toFixedNotRounded(number,fixed){
                fixed = fixed || 0;
                fixed = Math.pow(10, fixed);
                if(Math.abs(number % 1) > .90){
                    return Math.floor(number * fixed) / fixed;
                } else {
                    return (number * fixed) / fixed;
                }
            },
            importWithAllocationFile(){
                this.spinning = true;
                var bodyFormData = new FormData();
                bodyFormData.append('file', this.fileWithAllocationList[0])
                this.xlsxUploadFormData = bodyFormData
                this.documentStatus = 'Uploading';
                this.processingXlsxUpload = true
                if (this.documentNumber > 1) {
                    this.update();
                } else {
                    this.save();
                }
                this.closeDrawer('massAddWithAllocation');
                this.spinning = false;
                return false;
            },
            async viewSiteAllocation(){
                this.viewAllocation = true
                this.documentLines = this.tabulator.getData();
            },
            async getMinMaxProducts(){
                this.spinning = true
                var site_id = this.requestingSite.key;
                var supplier_id = 0;
                if(this.currentDocumentTypeCode == 'ORIPOX'){
                    if (this.supplier.key == undefined || this.supplier.key == '' || this.supplier.key < 1) {
                        component_x.$notification['error']({
                            message: 'Auto-Rep (Min/Max)',
                            description: "Supplier is required.",
                            style: getNotificationStyle('error')
                        });
                        this.spinning = false
                        return
                    } else {
                        supplier_id = this.supplier.key
                    }
                }

                var minmax_products = await HTTPRequest.getRequest(this.endPoint + '/products/get_minmax_products?site_id=' + site_id + '&document_type=' + this.currentDocumentTypeCode + '&supplier_id=' + supplier_id + '&include_it=' + this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.includeInTransitForMinMaxAutoRep);
                this.spinning = false

                if(minmax_products.length > 0){
                    this.minMaxProducts = minmax_products;
                    this.modalMinMaxProducts = true;
                    if(this.tabulator.getRows().length > 0)
                        this.overrideMinMaxProducts = 'And this will override the items added in this document.'
                } else {
                    component_x.$notification['error']({
                        message: 'Auto-Rep (Min/Max)',
                        description: "No products for min/max replenishment for the selected supplier.",
                        style: getNotificationStyle('error')
                    });
                    return
                }

            },
            async getOffTakeProducts(){
                this.spinning = true
                var site_id = this.requestingSite.key;
                var supplier_id = 0;
                if(this.currentDocumentTypeCode == 'ORIPOX'){
                    if (this.supplier.key == undefined || this.supplier.key == '' || this.supplier.key < 1) {
                        component_x.$notification['error']({
                            message: 'Auto-Rep (By Offtake)',
                            description: "Supplier is required.",
                            style: getNotificationStyle('error')
                        });
                        this.spinning = false
                        return
                    } else {
                        supplier_id = this.supplier.key
                    }
                }

                var offtake_products = await HTTPRequest.getRequest(this.endPoint + '/products/get_offtake_products?site_id=' + site_id + '&document_type=' + this.currentDocumentTypeCode + '&supplier_id=' + supplier_id + '&include_it=' + this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.includeInTransitForMinMaxAutoRep + '&offtake_days=' + this.offtakeDays);
                this.spinning = false

                if(offtake_products.length > 0){
                    this.offtakeProducts = offtake_products;
                    this.modalOffTakeProducts = true;
                    if(this.tabulator.getRows().length > 0)
                        this.overrideOfftakeProducts = 'And this will override the items added in this document.'
                } else {
                    component_x.$notification['error']({
                        message: 'Auto-Rep (By Offtake)',
                        description: "No products for "+ this.offtakeDays +" days offtake-based replenishment for the selected supplier.",
                        style: getNotificationStyle('error')
                    });
                    return
                }
            },
            async exportWithAllocationDocument(){
                let formattedLines = []
                let lines = this.tabulator.getData()
                for(var i = 0; i < lines.length; i++) {
                    let formatLine = {
                        'Line No': lines[i].line_no,
                        'Stock No': lines[i].stock_no,
                        'Description': lines[i].product_name,
                        'Barcode': lines[i].barcode,
                        'Unit': lines[i].unit_label,
                        'Quantity': lines[i].quantity,
                        'Cost': lines[i].cost,
                        'Subtotal': lines[i].subtotal,
                        'Serial No': lines[i].document_line_serials_text
                    }
                    if (lines[i].site_allocation!=undefined && lines[i].site_allocation!=null){
                        lines[i].site_allocation.forEach(function(obj) {
                            if (component_x.currentDocumentTypeCode=='OTHPCK'){
                                var qty = (obj.available_quantity == 0) ? '' : obj.available_quantity
                                // formatLine[' '+`${obj.code}`] = qty
                            }else{
                                var qty = (obj.quantity == 0) ? '' : obj.quantity
                                // formatLine[' '+`${obj.code}`] = qty
                            }

                            if(component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.AllocationDefaultValue == 'SC'){
                                formatLine[' '+`${obj.code}`] = qty
                            } else {
                                formatLine[' '+`${obj.refcode}`] = qty
                            }
                        });
                    }
                    formattedLines.push(formatLine)
                }
                var dataWS = XLSX.utils.json_to_sheet(formattedLines)
                var wb = XLSX.utils.book_new()
                await HTTPRequest.postRequest(component_x.endPoint + 'users/create_user_act', null, {controller:"/document_form",category:this.currentDocumentTypeCode,system_module:this.currentDocumentTypeName,actions:"Export With Allocation"})
                XLSX.utils.book_append_sheet(wb, dataWS, this.currentDocumentTypeFriendlyCodeWithId)
                XLSX.writeFile(wb, this.friendlyCodeAndDocumentNo+".xlsx")
            },
            async downLoadExcelIfMoreThan5Site(){
                var wb = XLSX.utils.book_new()
                var documentType = this.currentDocumentTypeName || ''
                var currentSiteName = secureStorage.getItem("defaultSiteName") || '';
                var userCode = secureStorage.getItem("userCode") || '';
                var documentDate = this.documentDate.format('D-MMM-YYYY') || ''
                var targetDate = this.targetDate.format('D-MMM-YYYY') || ''
                var cancellationDate = this.cancellationDate.format('D-MMM-YYYY') || ''
                var currentDocumentTypeFriendlyCode = this.currentDocumentTypeFriendlyCode || ''
                var documentStatus = this.documentStatus || ''
                var documentNumber = this.documentNo || ''
                var reference = this.reference || ''
                var remark = this.remark || ''
                var purpose = this.purpose.label || ''
                var printDate = moment().format('lll') || '';
                var postDate = this.postDate || ''
                let currencyKey = component_x.currency.key;
                let tabulatorInstance = this.$refs.tabulator.getInstance();
                var calculation = tabulatorInstance.getCalcResults();
                let formattedLines = []
                var lines = this.tabulator.getData();
                for(var i = 0; i < lines.length; i++) {
                    let formatLine = {
                        'Line No': lines[i].line_no,
                        'Stock No': lines[i].stock_no,
                        'Description': lines[i].product_name,
                        'Barcode': lines[i].barcode,
                        'Unit': lines[i].unit_label,
                        'Quantity': lines[i].quantity,
                        'Cost': lines[i].cost,
                        'Subtotal': lines[i].subtotal,
                        'Serial No': lines[i].document_line_serials_text
                    }
                    if (lines[i].site_allocation!=undefined && lines[i].site_allocation!=null){
                        lines[i].site_allocation.forEach(function(obj) {
                            if (component_x.currentDocumentTypeCode=='OTHPCK'){
                                var qty = (obj.available_quantity == 0) ? '' : obj.available_quantity
                                // formatLine[' '+`${obj.code}`] = qty
                            }else{
                                var qty = (obj.quantity == 0) ? '' : obj.quantity
                                // formatLine[' '+`${obj.code}`] = qty
                            }

                            if(component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.AllocationDefaultValue == 'SC'){
                                formatLine[' '+`${obj.code}`] = qty
                            } else {
                                formatLine[' '+`${obj.refcode}`] = qty
                            }
                        });
                    }
                    formattedLines.push(formatLine)
                }
                var lineCount = parseInt(formattedLines.length)
                var dataWS = XLSX.utils.sheet_add_json(wb.Sheets.sheet1,formattedLines,{origin: "A12"})
                XLSX.utils.sheet_add_aoa(dataWS,[[currentSiteName,"","","","","","","",documentType]],{origin: "A1"});
                XLSX.utils.sheet_add_aoa(dataWS,[["","","","","","","","","# "+String(documentNumber)]],{origin: "A2"});
                XLSX.utils.sheet_add_aoa(dataWS,[["","","","","","","","",currentDocumentTypeFriendlyCode+" Date:",documentDate]],{origin: "A3"});
                XLSX.utils.sheet_add_aoa(dataWS,[["","","","","","","","","Target Date:",targetDate]],{origin: "A4"});
                XLSX.utils.sheet_add_aoa(dataWS,[["","","","","","","","","Cancellation Date:",cancellationDate]],{origin: "A5"});
                XLSX.utils.sheet_add_aoa(dataWS,[["","","","","","","","","Reference:",reference]],{origin: "A6"});
                XLSX.utils.sheet_add_aoa(dataWS,[["","","","","","","",""]],{origin: "A7"});
                XLSX.utils.sheet_add_aoa(dataWS,[["Purpose",purpose,"","","","","","","Status:",documentStatus]],{origin: "A8"});
                XLSX.utils.sheet_add_aoa(dataWS,[["Remark:",remark,"","","","","",""]],{origin: "A9"});
                XLSX.utils.sheet_add_aoa(dataWS,[["","","","","","","","","Total:",calculation.bottom.subtotal.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")]],{origin: "A10"});
                XLSX.utils.sheet_add_aoa(dataWS,[["","","","","","","",""]],{origin: "A11"});
                XLSX.utils.sheet_add_aoa(dataWS,[["Total Quantity:",(calculation.bottom.quantity).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),"","",""]],{origin: "A"+`${lineCount+17}`});
                if(currencyKey>0 && component_x.showConversionRate){
                    XLSX.utils.sheet_add_aoa(dataWS,[["Total Cost:",(calculation.bottom.price_php).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","),"","",""]],{origin: "A"+`${lineCount+18}`});
                    XLSX.utils.sheet_add_aoa(dataWS,[["Subtotal:",(calculation.bottom.subtotal_php).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","),"","",""]],{origin: "A"+`${lineCount+19}`});
                }else{
                    XLSX.utils.sheet_add_aoa(dataWS,[["Total Cost:",(calculation.bottom.price).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","),"","",""]],{origin: "A"+`${lineCount+18}`});
                    XLSX.utils.sheet_add_aoa(dataWS,[["Subtotal:",(calculation.bottom.subtotal).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","),"","",""]],{origin: "A"+`${lineCount+19}`});
                }
                XLSX.utils.sheet_add_aoa(dataWS,[["Noted By:","____________________________________","","",""]],{origin: "A"+`${lineCount+21}`});
                XLSX.utils.sheet_add_aoa(dataWS,[["Verified By:","____________________________________","","",""]],{origin: "A"+`${lineCount+22}`});
                XLSX.utils.sheet_add_aoa(dataWS,[["Approved By:","____________________________________","","",""]],{origin: "A"+`${lineCount+23}`});
                XLSX.utils.sheet_add_aoa(dataWS,[["","","","","",""]],{origin: "A"+`${lineCount+24}`});
                XLSX.utils.sheet_add_aoa(dataWS,[["Printed By:",userCode,"","","",""]],{origin: "A"+`${lineCount+25}`});
                XLSX.utils.sheet_add_aoa(dataWS,[["Print Date:",printDate,"","","",""]],{origin: "A"+`${lineCount+26}`});
                XLSX.utils.sheet_add_aoa(dataWS,[["Post Date:",postDate,"","","",""]],{origin: "A"+`${lineCount+27}`});
                XLSX.utils.book_append_sheet(wb, dataWS, this.currentDocumentTypeFriendlyCodeWithId)
                XLSX.writeFile(wb, this.friendlyCodeAndDocumentNo+".xlsx")
            },
            async changeCostBySupplier(){
                this.spinning = true
                this.confirmLoadingonSuppModal = true
                let items = this.tabulator.getData();
                let newItems = []
                for(let i = 0; i < items.length; i++){
                    let item = items[i]
                    let product_id = item.product_id
                    let  supp_id = this.supplier.key
                    if(item.product_type == "I"){
                        product_id = item.matrix_parent_id
                    }

                    // should it change if wala sya na kita sa dating ordering cost from api or not?
                    var product = await HTTPRequest.getRequest(this.endPoint + 'products/' + product_id + '?supplier_id=' + supp_id)
                    if(product != null){
                        if(product.supplier_product_ordering_cost > 0 && this.productPriceChoice == 'ordering_cost'){
                            // this.unitCost = alternate_supplier.ordering_cost
                            // this.unitNetCost = alternate_supplier.ordering_cost
                            item.cost = Number(product.supplier_product_ordering_cost).toFixed(this.decimalPlaces)
                            item.price = Number(product.supplier_product_ordering_cost).toFixed(this.decimalPlaces)
                            item.subtotal = (Number(product.supplier_product_ordering_cost).toFixed(this.decimalPlaces) * item.quantity) - Number(item.discount)
                            //2370
                            item.subtotal_without_vat = (Number(item.subtotal)/ (1+Number(this.taxRate))).toFixed(this.decimalPlaces)
                            item.price_without_vat = (Number(item.cost)/ (1+Number(this.taxRate))).toFixed(this.decimalPlaces)
                            item.tax_amount = item.subtotal - item.subtotal_without_vat
                        }else{
                            var site_id = secureStorage.getItem("defaultSiteId");
                            let product_id
                            if(item.matrix_parent_id == null){
                                product_id = item.product_id
                            }else{
                                product_id = item.matrix_parent_id
                            }

                            let order_cost
                            var site_product = await HTTPRequest.getRequest(this.endPoint + '/site_products/get_site_product?product_id=' + product_id + '&site_id=' + site_id);
                            if(site_product != null){
                                var siteUnitCost = eval('site_product.'+this.productPriceChoice)
                                if(siteUnitCost != null && siteUnitCost > 0){
                                    order_cost = Number(siteUnitCost).toFixed(this.decimalPlaces)
                                }else{
                                    var cost = eval('product.'+this.productPriceChoice)
                                    // if (['BLENDED'].includes(this.documentCostingMethod) && ['RELTRX','RECTRX'].includes(this.currentDocumentTypeCode)){
                                    //     cost = eval('product.blended_cost')
                                    // }
                                    if(cost<=0) cost = eval('product.landed_cost')
                                    order_cost = Number(cost).toFixed(this.decimalPlaces)
                                }
                            }
                            // this.unitCost = alternate_supplier.ordering_cost
                            // this.unitNetCost = alternate_supplier.ordering_cost
                            item.cost = Number(order_cost).toFixed(this.decimalPlaces)
                            item.price = Number(order_cost).toFixed(this.decimalPlaces)
                            item.subtotal = ((Number(order_cost).toFixed(this.decimalPlaces) * item.quantity) - Number(item.discount)).toFixed(component_x.decimalPlaces)
                            //2370
                            item.subtotal_without_vat = (Number(item.subtotal)/ (1+Number(this.taxRate))).toFixed(this.decimalPlaces)
                            item.price_without_vat = (Number(item.cost)/ (1+Number(this.taxRate))).toFixed(this.decimalPlaces)
                            item.tax_amount = item.subtotal - item.subtotal_without_vat
                        }
                        newItems.push(item)
                    }
                }
                // console.log(newItems)
                await this.tabulator.updateData(newItems)
                this.confirmLoadingonSuppModal = false
                this.spinning = false
                this.showChangeSupplierModal = false
            },

            async handleSearchDrawerSites(value) {
                if (value == undefined) value = ''
                this.drawerSites = await HTTPRequest.getRequest(this.endPoint + 'sites/get_valid_document_sites?name='+value, null)
            },

            async getSettings(){
                let AccountSettings = await HTTPRequest.getRequest(this.endPoint + 'settings?code=accountSettings&status=A', null)
                if(AccountSettings.length > 0){
                    let as = JSON.parse(AccountSettings[0].value)
                    let printFontSize = as.printSettingsFontSizePTPM
                    if(printFontSize != null){
                        this.printFontSizeIncrease = printFontSize
                    }
                    let valueHeaderPos = as.printSettingsValueHeaderPos
                    if(valueHeaderPos != null){
                        this.printValueHeaderPos = valueHeaderPos
                    }
                    let valueFooterPos = as.printSettingsValueFooterPos
                    if(valueFooterPos != null){
                        this.printValueFooterPos = valueFooterPos
                    }
                    let printPaperSize = as.printSettingsPaperSizePTPM
                    if(printPaperSize != null){
                        this.printPaperSize = printPaperSize
                    }
                    // console.log(AccountSettings[0].value.userPasswordFormatStrict,AccountSettings[0].value[:userPasswordFormatStrict])
                    // if(AccountSettings[0].value.userPasswordFormatStrict!=null){
                    // }
                }
            },
            async updateValueOfSupplierCurrency(){
                if (this.currencyRate!=this.supplierDetails.currency_rate){
                    this.currencyRate = this.supplierDetails.currency_rate
                }
                if (this.currencyId!=this.supplierDetails.currency_id){
                    this.currencyId = this.supplierDetails.currency_id
                }
                var currency_histories = await this.getSupplierCurrencyByDocDate(this.currencyId)
                if (currency_histories.length > 0) {
                    this.currencyRate = currency_histories[0].conversion_rate || this.currencyRate || 1
                }
            },
            costFormatter(cell){return "***"},
            accessRightsMaskValidation(value){
                if((!this.accessCostPriceRights.includes('Z') && (this.productPriceChoice =='landed_cost' || this.productPriceChoice == 'ordering_cost' || this.productPriceChoice == 'original_cost')) || (!this.accessCostPriceRights.includes('Y') && (this.productPriceChoice =='retail_price' || this.productPriceChoice =='wholesale_price'))){
                    try {
                        return value.replace(/\d/g,"*")
                    } catch (error) {
                        return "***" 
                    }
                }else{
                    return value
                }
            },
            accessRightsDisableValidation(){
                if((!this.accessCostPriceRights.includes('Z') && (this.productPriceChoice =='landed_cost' || this.productPriceChoice == 'ordering_cost' || this.productPriceChoice == 'original_cost')) || (!this.accessCostPriceRights.includes('Y')&& (this.productPriceChoice =='retail_price' || this.productPriceChoice =='wholesale_price'))){
                    return true
                }else{
                    return false
                }
            },
            priceInputTypeAccessRights(){
                if(this.currentDocumentTypeCode === 'OTHPWS'){
                    if(!this.accessCostPriceRights.includes('Y') && !this.accessCostPriceRights.includes('YY')){
                        return 'password'
                    }else{
                        return ''
                    } 
                } else {
                    if(!this.accessCostPriceRights.includes('Y')){
                        return 'password'
                    }else{
                        return ''
                    } 
                } 
            },
            costInputTypeAccessRights(){
                if(this.currentDocumentTypeCode === 'OTHPWS'){
                    if(!this.accessCostPriceRights.includes('Z') && !this.accessCostPriceRights.includes('ZZ')){
                        return 'password'
                    }else{
                        return ''
                    }
                } else {
                    if(!this.accessCostPriceRights.includes('Z')){
                        return 'password'
                    }else{
                        return ''
                    }
                }
            },
            disablePriceAccessRightsValidation(){
                if(!this.accessCostPriceRights.includes('Y')){
                    return true
                }else{
                    return false
                }
            },
            disableCostAccessRightsValidation(){
                if(!this.accessCostPriceRights.includes('Z')){
                    return true
                }else{
                    return false
                }
            },
            accessRightsInputTypeValidation(){
                if((!this.accessCostPriceRights.includes('Z') && (this.productPriceChoice =='landed_cost' || this.productPriceChoice == 'ordering_cost' || this.productPriceChoice == 'original_cost')) || (!this.accessCostPriceRights.includes('Y')&& (this.productPriceChoice =='retail_price' || this.productPriceChoice =='wholesale_price'))){
                    return 'password'
                }else{
                    return ''
                }
            },
            renderColumnFields() {
                // For customizing column headers in document line table view
                this.filteredColumnFields.map(({ name, value }) => {
                var get_column = this.tabulator.getColumn(name)
                if (value && get_column) {
                    if (this.currentDocumentTypeCode === 'ORIPOX') {
                        //if (name === "actual_quantity") get_column.updateDefinition({ title: "Available Quantity" })
                        if (name === "content_quantity") get_column.updateDefinition({ title: "Balance Quantity" })
                    }
                    if((this.currentDocumentTypeCode === 'RELRSR') && name === "price") get_column.updateDefinition({ title: "Price" })
                    if((this.currentDocumentTypeCode === 'OTHLIQ') && name === "cost") get_column.updateDefinition({ title: "Price" })
                    if(this.currentDocumentTypeCode === 'OTHSBI' && name === "price") get_column.updateDefinition({ title: "Price" })
                    if(this.currentDocumentTypeCode === 'OTHSBI' && name === "cost") get_column.updateDefinition({ title: "Cost" })
                    if(this.currentDocumentTypeCode === 'OTHSBI' && name === "standby_landed_cost") get_column.updateDefinition({ title: "Standby Cost" })
                    if(this.currentDocumentTypeCode === 'OTHSBI' && name === "on_hand_quantity") get_column.updateDefinition({ title: "Qty Onhand [Add On]" })
                    if(this.currentDocumentTypeCode === 'OTHSBI' && name === "prod_ordering_cost") get_column.updateDefinition({ title: "Original Standard Cost" })
                    if(this.currentDocumentTypeCode === 'OTHSBI' && name === "price_pi") get_column.updateDefinition({ title: "Standard Cost Before Add On" })
                    if(this.currentDocumentTypeCode === 'RECDEL' && name === "on_hand_quantity") get_column.updateDefinition({ title: "Qty Onhand [Add On]" })
                    if(this.currentDocumentTypeCode === 'RECDEL' && name === "prod_ordering_cost") get_column.updateDefinition({ title: "Original Standard Cost" })
                    if(this.currentDocumentTypeCode === 'RECDEL' && name === "price_pi") get_column.updateDefinition({ title: "Standard Cost Before Add On" })
                    if(this.currentDocumentTypeCode === 'RECDEL' && name === "original_cost") get_column.updateDefinition({ title: "Blended Before Add On" })
                    if(this.currentDocumentTypeCode === 'OTHSBI' && name === "cost") get_column.updateDefinition({ title: "Cost" })
                    if((this.currentDocumentTypeCode === 'RELCSI') && name === "gross_amount") get_column.updateDefinition({ title: "Subtotal" })
                    if((this.currentDocumentTypeCode === 'OTHSIN') && name === "total_gross") get_column.updateDefinition({ title: "Total Gross" })
                    if((this.currentDocumentTypeCode === 'OTHSIN') && name === "total_gross") get_column.updateDefinition({ title: "Total Gross" })
                    if(['OTHTOV', 'OTHPCV'].includes(this.currentDocumentTypeCode) && name === "reason_id") get_column.updateDefinition({ title: "Resolution" })
                    if(this.currentDocumentTypeCode === 'OTHTOV' && name === "quantity") get_column.updateDefinition({ title: "Variance Quantity" })
                    if (this.currentDocumentTypeCode === 'OTHUPC') {
                    if (name === "actual_quantity") get_column.updateDefinition({ title: "Available Quantity" })
                    }
                    if (this.currentDocumentTypeCode === 'RECADJ' || this.currentDocumentTypeCode === 'RELADJ') {
                        if (name === "price") get_column.updateDefinition({ title: "SRP" })
                    }
                    if (this.currentDocumentTypeCode === 'OTHSIN') {
                        if (name === "actual_quantity") get_column.updateDefinition({ title: "Doc Qty" })
                        if (name === "Total Gross") get_column.updateDefinition({ title: "Subtotal" })
                    }
                    if (['ORIPOX','OTHPUR','RECDEL','ORIASN', 'OTHSBI','RELTRX'].includes(this.currentDocumentTypeCode)){
                        if (name === "quantity") get_column.updateDefinition({ title: "Doc Qty" })
                        if (name === "retail_price" && this.currentDocumentTypeCode == 'RELTRX') get_column.updateDefinition({ title: "Price" })
                    }
                    if (['OTHPCN', 'OTHPCV'].includes(this.currentDocumentTypeCode)){
                        if (name === "actual_quantity") get_column.updateDefinition({ title: "Freeze Quantity" })
                        if (name === "quantity") get_column.updateDefinition({ title: "Count Quantity" })
                    }
                    // if (['RECTRX'].includes(this.currentDocumentTypeCode)){
                    //     if (name === "quantity") get_column.updateDefinition({ title: "Received Qty" })
                    // }
                    if (['ORIPOX','OTHPUR','ORIASN', 'RECDEL'].includes(this.currentDocumentTypeCode)){
                        if (name === "price") get_column.updateDefinition({ title: "Ordering Cost" })
                    }
                    if (['OTHPUR'].includes(this.currentDocumentTypeCode)){
                        if (name === "cost") get_column.updateDefinition({ visible: false, download:false })
                    }
                    if (['ORIASN', 'RECDEL'].includes(this.currentDocumentTypeCode)){
                        if (name === "cost") get_column.updateDefinition({ title: "Unit Net Ordering Cost" })
                    }
                    if (['ORIPOX'].includes(this.currentDocumentTypeCode)){
                        if (name === "net_cost") get_column.updateDefinition({ title: "Unit Net Ordering Cost" })
                    }
                
                    if (['OTHSRQ', 'ORISOX', 'OTHSIN'].includes(this.currentDocumentTypeCode) && this.accountName.toLowerCase().includes('piml')){
                        if (name === "quantity") get_column.updateDefinition({ title: this.currentDocumentTypeCode == 'OTHSRQ' ? "SR Qty" : this.currentDocumentTypeCode == 'OTHSIN' ? "SI Qty" : "SO Qty" })
                        if (name === "actual_quantity") get_column.updateDefinition({ title: "Actual Qty" })
                        if (name === "currency") get_column.updateDefinition({ title: "Sales Amount Currency" })
                        if (name === "pur_currency") get_column.updateDefinition({ title: "Purchase Amount Currency" })
                        if (name === "price") get_column.updateDefinition({ title: "Sales Price" })
                        if (name === "total_gross") get_column.updateDefinition({ title: "Total Gross Sales Amount" })
                        if (name === "discount") get_column.updateDefinition({ title: "Sales Discount Amount" })
                        if (name === "net_amount") get_column.updateDefinition({ title: "Total Net Sales Amount" })
                        if (name === "ordering_cost") get_column.updateDefinition({ title: "Purchasing Cost" })
                        if (name === "total_ordering_cost") get_column.updateDefinition({ title: "Total Purchasing Amount" })
                        if (name === "total_gross") get_column.updateDefinition({ title: "Total Gross Sales Amount" })
                        if (name === "remaining_qty") get_column.updateDefinition({ title: "Balance Qty" })
                        }

                    if (['RELRSR'].includes(this.currentDocumentTypeCode)){
                        if (name === "quantity") get_column.updateDefinition({ title: "Doc Qty" })
                    }

                    if (['ORISOX', 'RELDDE'].includes(this.currentDocumentTypeCode) && this.accountName.toLowerCase().includes('primerph')) {
                        if (name === "quantity") {
                            get_column.updateDefinition({ title: "Doc Qty" });
                        }
                        if (name === "subtotal") {
                            get_column.updateDefinition({ title: "Gross Amount" });
                        }
                        if (name === "actual_quantity") {
                            get_column.updateDefinition({ title: "Actual Qty" });
                        }
                        if (name === "on_hand_quantity") {
                            get_column.updateDefinition({ title: "On-Hand Qty" });
                        }
                    }

                    if (this.currentDocumentTypeCode === 'OTHPCV') {
                        if (name === "price") get_column.updateDefinition({ title: "Price" })
                    }

                    if (this.currentDocumentTypeCode === 'OTHPWS'){
                        if (name === "ordering_cost") get_column.updateDefinition({ title: "New Ordering Cost" })
                        if (name === "old_ordering_cost") get_column.updateDefinition({ title: "Old Ordering Cost" })
                    }
                    if (this.currentDocumentTypeCode === 'RELTRX'){
                        if (name === "remaining_qty") get_column.updateDefinition({ title: "Rem Qty" })
                        if (name === "product_name") get_column.updateDefinition({ frozen: false })
                    }

                    if(name === "cost") if((!this.accessCostPriceRights.includes('Z') && (this.productPriceChoice =='landed_cost' || this.productPriceChoice == 'ordering_cost' || this.productPriceChoice == 'original_cost')) || (!this.accessCostPriceRights.includes('Y')&& (this.productPriceChoice =='retail_price' || this.productPriceChoice =='wholesale_price'))) get_column.updateDefinition({formatter:this.costFormatter}) 
                    if(this.currentDocumentTypeCode === 'OTHLIQ' && name === "cost") get_column.updateDefinition({ title: "Price" })
                    if(name === "price") if((!this.accessCostPriceRights.includes('Z') && (this.productPriceChoice =='landed_cost' || this.productPriceChoice == 'ordering_cost' || this.productPriceChoice == 'original_cost')) || (!this.accessCostPriceRights.includes('Y')&& (this.productPriceChoice =='retail_price' || this.productPriceChoice =='wholesale_price'))) get_column.updateDefinition({formatter:this.costFormatter}) 
                    if(name === "subtotal") if((!this.accessCostPriceRights.includes('Z') && (this.productPriceChoice =='landed_cost' || this.productPriceChoice == 'ordering_cost' || this.productPriceChoice == 'original_cost')) || (!this.accessCostPriceRights.includes('Y')&& (this.productPriceChoice =='retail_price' || this.productPriceChoice =='wholesale_price'))) get_column.updateDefinition({formatter:this.costFormatter}) 
                    if(this.currentDocumentTypeCode == "OTHPWS"){
                        if(name === "old_landed_cost") if(!this.accessCostPriceRights.includes('Z') && !this.accessCostPriceRights.includes('ZZ')) get_column.updateDefinition({formatter:this.costFormatter}) 
                        if(name === "landed_cost") if(!this.accessCostPriceRights.includes('Z')) get_column.updateDefinition({formatter:this.costFormatter}) 
                        if(name === "old_original_cost") if(!this.accessCostPriceRights.includes('Z') && !this.accessCostPriceRights.includes('ZZ')) get_column.updateDefinition({formatter:this.costFormatter}) 
                        if(name === "original_cost") if(!this.accessCostPriceRights.includes('Z')) get_column.updateDefinition({formatter:this.costFormatter}) 
                        if(name === "old_ordering_cost") if(!this.accessCostPriceRights.includes('Z') && !this.accessCostPriceRights.includes('ZZ')) get_column.updateDefinition({formatter:this.costFormatter}) 
                        //if(name === "ordering_cost") if(!this.accessCostPriceRights.includes('Z')) get_column.updateDefinition({formatter:this.costFormatter}) 
                        if(name === "old_wholesale_price") if(!this.accessCostPriceRights.includes('Y') && !this.accessCostPriceRights.includes('YY')) get_column.updateDefinition({formatter:this.costFormatter}) 
                        if(name === "wholesale_price") if(!this.accessCostPriceRights.includes('Y')) get_column.updateDefinition({formatter:this.costFormatter}) 
                        if(name === "old_least_price") if(!this.accessCostPriceRights.includes('Y') && !this.accessCostPriceRights.includes('YY')) get_column.updateDefinition({formatter:this.costFormatter}) 
                        if(name === "least_price") if(!this.accessCostPriceRights.includes('Y')) get_column.updateDefinition({formatter:this.costFormatter}) 
                        if(name === "old_special_price") if(!this.accessCostPriceRights.includes('Y') && !this.accessCostPriceRights.includes('YY')) get_column.updateDefinition({formatter:this.costFormatter}) 
                        if(name === "special_price") if(!this.accessCostPriceRights.includes('Y')) get_column.updateDefinition({formatter:this.costFormatter}) 
                    }else{
                        if(name === "landed_cost") if((!this.accessCostPriceRights.includes('Z') && (this.productPriceChoice =='landed_cost' || this.productPriceChoice == 'ordering_cost' || this.productPriceChoice == 'original_cost')) || (!this.accessCostPriceRights.includes('Y')&& (this.productPriceChoice =='retail_price' || this.productPriceChoice =='wholesale_price'))) get_column.updateDefinition({formatter:this.costFormatter})
                    }
                    this.tabulator.showColumn(name)
                } else {
                    this.tabulator.hideColumn(name)
                }
                })
            },
            async duplicateDocumentLines(){
                let documentLines = this.selectedDocumentLines
                let data = this.tabulator.getData()
                documentLines.forEach((object) => {
                        data.splice(object.line_no, 0, object)
                    }
                )
                await this.tabulator.replaceData(data)
                await this.recountLineNo()
                await this.calculateSummary();
            },
            async checkIfDocumentTypeIsCorrect(){
                if (this.existingDocumentTypeId != this.currentDocumentTypeId){
                    this.$warning({
                        title: "Your selected document has been changed.",
                        content: h => <div>This will return to the documents table. Please click 'OK' to continue.</div>,
                        button: {
                            yes: 'OK',
                        },
                        onOk: () => {
                            this.notEqualDocumentTypeIdStatus = false
                            this.$router.replace(this.backLink)
                        },
                    })
                }
            },
            async checkSiteIfCorrect(){
                if (parseInt(this.defaultSite)!=0 && parseInt(this.defaultSite)!=-1){
                    if (this.defaultSite != secureStorage.getItem("defaultSiteId") && this.defaultSite != this.documentCurrentSite && secureStorage.getItem("currentSiteSiteType") != 'ho'){
                        this.$warning({
                            title: "Your default site has been changed.",
                            content: h => <div>This will return to the documents table. Please click 'OK' to continue.</div>,
                            button: {
                                yes: 'OK',
                            },
                            onOk: () => {
                                this.updateCheckCurrentSite(true)
                                this.$router.replace(this.backLink)
                            },
                        })
                    }
                }
            },
            changeReference: function(){
                this.isEditing = true
            },
            showBarcodePrintingModal(){
                this.showPrintingModal = true;
                if (!qz.websocket.isActive()) {
                    this.loadingBarcodePrintingModal = true;
                    qz.websocket.connect().then(function() {
                        console.log("connected!")
                        component_x.loadingBarcodePrintingModal = false;
                        component_x.getlistOfPrinters();
                    }).catch(function(error) {
                        console.log(error);
                        this.loadingBarcodePrintingModal = true;
                    });
                }else {
                    this.loadingBarcodePrintingModal = false;
                    this.getlistOfPrinters();
                }
                this.getListOfPrinterFormat();
                this.documentLines = this.tabulator.getData();
            },
            hidePrintingModal: function(){
                this.showPrintingModal = false;
            },
            getlistOfPrinters(){
                this.fetchingPrinterList = true;
                qz.printers.find().then(function(data) {
                   console.log(data);
                   component_x.printerList = data;
                   component_x.fetchingPrinterList = false;
                }).catch(function(error) {
                    console.log(error);
                });
            },
            disabledDateForOtherDate(current) {
                if(this.currentDocumentTypeCode == 'RECCSR'){
                    return current <= moment().startOf('day');
                } else {
                    return current && current < moment().startOf('day');
                }
            },
            async getListOfPrinterFormat(){
                var response = await HTTPRequest.getRequest(this.endPoint + 'barcode_printing_templates/get_all_barcode_printing_template', null)
                console.log(response)
                this.printerFormatList = response
            },
            changePimlPriceChoice(value){
                this.productPriceChoice = value
            },
            async printBarcode(){
                this.printBarcodeLoading = true;
                if (!this.printBarcodeValidation()){
                    var config = qz.configs.create(component_x.selectedPrinter);
                    var data = []
                    var format = "";
                    await fetch(component_x.selectedBarcodeFormat[0].file_url).then(response => response.text())
                            .then(data => {console.log(data); format = data;});
                    await qz.printers.find(component_x.selectedPrinter).then(function(printer) {
                        component_x.documentLines.forEach(async function (val) {
                            var text = format;
                            text = text.replace(/{barcode}/g,val.barcode)
                            text = text.replace(/{name}/g,val.product_name)
                            text = text.replace(/{price}/g,component_x.formatMyNumber(Number(val.price),2))
                            text = text.replace(/{quantity}/g,parseInt(val.quantity))
                            data.push(text)
                        })
                        qz.print(config, data).then(function() {
                            if (component_x.documentOrderStatus == "Printed"){
                                component_x.updateOrderStatus("RP");
                            }else{
                                component_x.updateOrderStatus("P");
                            }
                            component_x.hidePrintingModal();
                        });
                    }).catch(function(error) {
                        this.barcodeTemplateErrors = error.split(',');
                    });
                }
                this.printBarcodeLoading = false;
            },
            changePrinterFormat(value){
                this.selectedBarcodeFormat = this.printerFormatList.filter(d => d.id == value);
                this.selectedBarcodeFormat.descriptionList = this.selectedBarcodeFormat[0].description.split(", ")
                this.selectedPrinterFormat = value;
            },
            printBarcodeValidation(){
                this.barcodeTemplateErrors = []
                this.barcodeTemplateErrors.push(ValidateField.required('Printer Device', this.selectedPrinter));
                this.barcodeTemplateErrors.push(ValidateField.required('Format', this.selectedPrinterFormat));
                this.barcodeTemplateErrors = this._.compact(this.barcodeTemplateErrors);
                return this.barcodeTemplateErrors.length;
            },
            onChangeOverallDiscount(){
                if (Number(this.overallDiscount) > 0){
                    this.reCalculateHeaderDiscount = true
                    var subtotal = Number(this.grossAmount) - Number(this.itemDiscount)
                    var overall_percentage = (this.overallDiscount/subtotal) || 0
                    this.overallDiscountPercentage = overall_percentage
                } else {
                    this.overallDiscountPercentage = 0
                }
            }
        },
        watch: {
            currentDocumentTypeCode: 'checkHeaderDiscountState',
            documentStatus: 'checkHeaderDiscountState',
            // Enforce the 255 character limit on the advanced-info fields
            // Trimming the value and informing the user right after they paste
            reference(newVal){ this.trimToMaxLength('reference', this.referenceLabel, newVal, this.fieldMaxLength); },
            remark(newVal){ this.trimToMaxLength('remark', this.remarkLabel, newVal, this.fieldMaxLength); },
            ocReferenceNo(newVal){ this.trimToMaxLength('ocReferenceNo', 'OC Reference No.', newVal, this.fieldMaxLength); },
            shipmentReferenceNo(newVal){ this.trimToMaxLength('shipmentReferenceNo', 'Shipment Reference No.', newVal, this.fieldMaxLength); },
            headerDiscount: {
                handler(newVal, oldVal) {
                    if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
                        // fix pre-selected empty value in headerDiscount field
                        this.headerDiscount = newVal.filter(value => value !== "");
                    }
                },
                deep: true
            },
            netAmountWithoutTax: function(){
                if (this.docTypesForIM.includes(this.currentDocumentTypeCode) || this.docTypesForOM.includes(this.currentDocumentTypeCode) || this.currentDocumentTypeCode == 'OTHSBI'){
                        var vat_type = (this.docTypesForIM.includes(this.currentDocumentTypeCode) || this.docTypesForOM.includes(this.currentDocumentTypeCode) || this.currentDocumentTypeCode == 'OTHSBI') ? this.party_tax_type : null
                        switch (vat_type) {
                        case "V":
                            this.vatableSalesAmount = this.netAmountWithoutTax || 0.00
                            this.vatExemptSalesAmount = 0.00
                            this.zeroRatedSalesAmount = 0.00
                        break;
                        case "X":
                            this.vatableSalesAmount = 0.00
                            this.vatExemptSalesAmount = this.netAmountWithoutTax || 0.00
                            this.zeroRatedSalesAmount = 0.00
                        break;
                        case "Z":
                            this.vatableSalesAmount = 0.00
                            this.vatExemptSalesAmount = 0.00
                            this.zeroRatedSalesAmount = this.netAmountWithoutTax || 0.00
                        break;
                        default:
                        break;
                    }
                }
            },
            overallDiscount: function(){
                this.reCalculateHeaderDiscount = true
                if (Number(this.overallDiscount) > 0 && (this.reCalculateHeaderDiscount)){
                    var subtotal = Number(this.grossAmount) - Number(this.itemDiscount)
                    var overall_percentage = (this.overallDiscount/subtotal) || 0
                    this.overallDiscountPercentage = overall_percentage
                } else {
                    this.overallDiscountPercentage = 0
                }
            },
            party_tax_type: function() {
                if (this.docTypesForIM.includes(this.currentDocumentTypeCode) || this.docTypesForOM.includes(this.currentDocumentTypeCode) || this.currentDocumentTypeCode == 'OTHSBI'){
                    var is_supplier = (this.docTypesForOM.includes(this.currentDocumentTypeCode)) ? false : true
                    switch (this.party_tax_type) {
                        case "V":
                            (is_supplier) ? this.supplierVatType = "Vatable" : this.customerVatType = "Vatable"
                            this.vatableSalesAmount = this.netAmountWithoutTax || 0.00
                            this.vatExemptSalesAmount = 0.00
                            this.zeroRatedSalesAmount = 0.00
                        break;
                        case "X":
                            (is_supplier) ? this.supplierVatType = "Vat-Exempt" : this.customerVatType = "Vat-Exempt"
                            this.vatableSalesAmount = 0.00
                            this.vatExemptSalesAmount = this.netAmountWithoutTax || 0.00
                            this.zeroRatedSalesAmount = 0.00
                        break;
                        case "Z":
                            (is_supplier) ? this.supplierVatType = "Zero-Rated" : this.customerVatType = "Zero-Rated"
                            this.vatableSalesAmount = 0.00
                            this.vatExemptSalesAmount = 0.00
                            this.zeroRatedSalesAmount = this.netAmountWithoutTax || 0.00
                        break;
                        default:
                        break;
                    }
                }
            },
            supplier: {
                handler(newVal, oldVal) {
                    if (newVal.key == undefined || newVal.key == null || newVal.key == ""){
                        this.supplierVatType = ""
                        this.party_tax_type = ""
                        this.supplierCurrencyName = "PHP"
                    }
                },
                deep: true
            },
            brand: {
                handler(newVal, oldVal) {
                    if ((newVal.key == undefined || newVal.key == null || newVal.key == "") && !(["ORISOX","RECADJ","RELADJ","OTHPCN"].includes(component_x.currentDocumentTypeCode))){
                        this.isProductSearchDisabled = true
                    }
                },
                deep: true
            },
            requestingSite: {
                handler(newVal, oldVal) {
                    if (newVal && newVal.key !== oldVal.key && component_x.documentDetails.id !== undefined && oldVal.key !== undefined) {
                        console.log("Requesting site changed");
                        var reqSiteKey = String(newVal.key != undefined ? newVal.key : '').replace('selectRequestingSite', '');
                        // Trap invalid id: don't populate (and hit sites/<id>) when key is -1 / not positive.
                        if (parseInt(reqSiteKey) > 0) {
                            this.populateAddress('requestingSite', reqSiteKey);
                        }
                    }
                },
                deep: true
            },
            supplyingSite: {
                handler: 'fetchCompanyBasedOnSupplyingSite',
                deep: true
            },
            paymentMode: async function() {
                if(this.paymentMode == "dragonpay" && this.paymentMethods.length == 0){
                    var response = await HTTPRequest.getRequest(this.endPoint + 'integrations/get_dragonpay_processors', null)
                    component_x.paymentMethods = response
                }
            },
            documentStatus: function(){
                if (this.documentStatus == 'Posted' || this.documentStatus == 'Voided' || this.documentStatus == 'Confirmed'){
                    var elList = this.$el.querySelectorAll(".tabulator-cell");
                    elList.forEach(el => el.style.cssText = "pointer-events: none;");
                }
            },
            viewAllocation: async function(){
                if (this.viewAllocation){
                    this.totalAllocatedQty = 0
                    var column_names = []
                    var check_error = false
                    try{
                        component_x.tabulator1 = this.$refs.tabulator1.getInstance();
                        check_error = false
                    }catch(e){
                        check_error = true
                    }
                    var lines = this.documentLines;
                    for(var i = 0; i < lines.length; i++) {
                        if (lines[i].site_allocation!=undefined && lines[i].site_allocation!=null){
                            var ttl_quantity = 0
                            lines[i].site_allocation.forEach(function(obj) {
                                if (component_x.currentDocumentTypeCode=='OTHPCK'){
                                    var qty = (obj.available_quantity == 0) ? '' : obj.available_quantity
                                    if(component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.AllocationDefaultValue == 'SC'){
                                        lines[i][`${obj.code}`] = qty
                                    } else {
                                        lines[i][`${obj.refcode}`] = qty
                                    }
                                    ttl_quantity+= isNaN(parseInt(qty)) ? 0 : parseInt(qty)
                                }else{
                                    var qty = (obj.quantity == 0) ? '' : obj.quantity
                                    if(component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.AllocationDefaultValue == 'SC'){
                                        lines[i][`${obj.code}`] = qty
                                    } else {
                                        lines[i][`${obj.refcode}`] = qty
                                    }
                                    ttl_quantity+= isNaN(parseInt(qty)) ? 0 : parseInt(qty)
                                }
                                if (!column_names.includes(obj.code) && component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.AllocationDefaultValue == 'SC') {
                                    column_names.push(obj.code);
                                }

                                if (!column_names.includes(obj.refcode) && component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.AllocationDefaultValue == 'RC') {
                                    column_names.push(obj.refcode);
                                }
                            });
                            lines[i]["total_allocated_quantity"] =  parseInt(ttl_quantity)
                            this.totalAllocatedQty += parseInt(ttl_quantity)
                        }
                    }
                    for (var index = 0; index < column_names.length; index++) {
                        try {
                            var customField = component_x.tabulator1.getColumn(column_names[index])
                            if (customField==undefined || customField==null || customField=='') {
                                if (check_error){
                                    component_x.optionsViewAllocation.columns.push({title:column_names[index], field:column_names[index]})
                                }else{
                                    component_x.tabulator1.addColumn({title:column_names[index], field:column_names[index]})
                                }
                            }
                        } catch (error) {
                            if (check_error){
                                component_x.optionsViewAllocation.columns.push({title:column_names[index], field:column_names[index]})
                            }else{
                                component_x.tabulator1.addColumn({title:column_names[index], field:column_names[index]})
                            }
                        }
                    }
                    if (column_names.length > 0){
                        try {
                            var total_allocated_quantity = component_x.tabulator1.getColumn("total_allocated_quantity")
                            if (total_allocated_quantity==undefined || total_allocated_quantity==null || total_allocated_quantity=='') {
                                if (check_error){
                                    component_x.optionsViewAllocation.columns.push({title:"Total Allocated Quantity", field:"total_allocated_quantity"})
                                }else{
                                    component_x.tabulator1.addColumn({title:"Total Allocated Quantity", field:"total_allocated_quantity"})
                                }
                            }
                        } catch (error) {
                            if (check_error){
                                component_x.optionsViewAllocation.columns.push({title:"Total Allocated Quantity", field:"total_allocated_quantity"})
                            }else{
                                component_x.tabulator1.addColumn({title:"Total Allocated Quantity", field:"total_allocated_quantity"})
                            }
                        }
                    }
                }

            },
            'requestingSite.label': function(){
                this.checkSiteTypeAndTargetBranch()
                this.populateAddress('requestingSite', this.requestingSite.key, '', 'site');
            },
            revenue: function(){
                if (this.revenue == 'R'){
                    this.revenueSiteId = secureStorage.getItem("defaultSiteId").toString()
                }else if(this.revenue =='T'){
                    this.revenueSiteId = this.requestingSite.key || 0
                }
            },
            'distributionSite.key': async function(){
                if (this.currentDocumentTypeCode == 'ORIOSO' || this.currentDocumentTypeCode=='ORISOX' || this.currentDocumentTypeCode=='OTHSRQ' || this.currentDocumentTypeCode=='RELCSI'){
                    try{
                        if (this.distributionSite.key > 0){
                            var company_id = -1
                            if(component_x.companyOwnerId.key == undefined){
                                var siteDetails = await this.getSiteById(this.distributionSite.key);
                                company_id = siteDetails.company_id
                            } else {
                                company_id = component_x.companyOwnerId.key
                            }
                            var data = await HTTPRequest.getRequest(
                                component_x.endPoint + "companies/" + company_id,
                                null
                            );
                            this.companyOwnerName = data.name
                        }
                    }catch(e){}
                }
            },
            supplierDetails: function(){
                if (this.currentDocumentTypeCode == 'ORIPOX' || this.currentDocumentTypeCode=='RECDEL'){
                    if (this.documentStatus != 'Posted' && this.documentStatus != 'Voided' && this.documentStatus != 'Saved'){
                       this.updateValueOfSupplierCurrency()
                    }
                }
            },
            currentSerialCount: function(){
              if(!this.currentDocumentTypeCode.includes("REL")){
                this.currentSerialCount === this.previousSerialCount && this.saveDrawerSerialization();
              }
            },
            documentDate: async function(){
                if(this.currencyId>0){
                    var currency_histories = await this.getSupplierCurrencyByDocDate(this.currencyId)
                    if (currency_histories.length > 0) {
                        this.currencyRate = currency_histories[0].conversion_rate || this.currencyDetails.conversion || 1
                    } else {
                        this.currencyRate = this.currencyDetails.conversion || 1
                    }
                }
            },
        }
    };

</script>

<style lang='scss'>
@import "~vue-tabulator/dist/scss/bootstrap/tabulator_bootstrap";

/* #135: "X" button for search product vertical align */
.autocomplete__icon.autocomplete--clear {
    height: 100%;
}

.tabulator-calcs-holder{
    display: none;
}

.sticky-header {
    z-index: 100;
}

.ant-steps-dot .ant-steps-item-content, .ant-steps-dot.ant-steps-small .ant-steps-item-content {
    width: 250px;
}

.pill {
  display: inline-block;
  padding: 3px 8px;
  font-size: 12px;
  border: 1px solid #ccc;
  border-radius: 10px;
  cursor: pointer;
  margin-right: 10px;
}

.pill.selected {
  background-color: #007bff;
  color: #fff;
}

.currency-select {
    min-width: 150px;
    width: auto;
}

// .tabulator-menu {
//     position: absolute;
//     z-index: 999999;
//     background-color: white;
//     border: groove;
//     padding: 10px;
//     cursor: pointer;
// }

// .tabulator-menu-item:hover {
//     background-color: whitesmoke;
// }
.table-product-icons2{
    height: 15px;
    width: 15px;
}

</style>

<style scoped>
@media (min-width: 1200px) {
    .container {
        max-width: 100%;
    }
}
.table-scroll {
	position:relative;
	max-width:600px;
	margin:auto;
	overflow:hidden;
	border:1px solid #000;
}
.table-wrap {
	width:100%;
	overflow:auto;
}
.table-scroll table {
	width:100%;
	margin:auto;
	border-collapse:separate;
	border-spacing:0;
}
.table-scroll th, .table-scroll td {
	padding:5px 10px;
	border:1px solid #000;
	background:#fff;
	white-space:nowrap;
	vertical-align:top;
}
.fixed-side {
	border:1px solid #000;
	background:#eee;
	visibility:visible;
}
.refresh-document {
    margin: 0 10px;
    font-size: 20px;
    display: flex;
    align-items: center;
    height: 26px;
    color: inherit !important;
}
.si_customer_name{
  display:flex;
  justify-content: space-between;
}
.si_customer_name_input{
  flex: 10;
  border-radius: 5px 0px 0px 5px !important;
}
.si_customer_name_btn{
  flex: 1;
  border-radius: 0px 5px 5px 0px;
}
.table-product-icons2{
    height: 15px;
    width: 15px;
}
</style>
